// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23636f83%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.87%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27rgba%28255, 255, 255, 0.87%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.87%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 21, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%2387bbb7%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.87%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%232eb85c%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23e55353%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23e55353%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2844, 56, 74, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27var%28--cui-body-color%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%230e6a63%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%2844, 56, 74, 0.95%29%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.87%29%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.87%29%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27currentColor%27 stroke-width=%272.25%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cpath fill=%27rgba%28255, 255, 255, 0.38%29%27 d=%27M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cpath fill=%27rgba%28255, 255, 255, 0.87%29%27 d=%27M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.6%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.87%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../assets/fonts/Inter-VariableFont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../assets/fonts/Inter-Italic-VariableFont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAACCAYAAACuTHuKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1OThBRDY4OUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1OThBRDY4QUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU5OEFENjg3Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU5OEFENjg4Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VU513gAAADVJREFUeNrs0DENACAQBDBIWLGBJQby/mUcJn5sJXQmOQMAAAAAAJqt+2prAAAAAACg2xdgANk6BEVuJgyMAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/png;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAAA4CAYAAAB5YT9uAAAAAXNSR0IArs4c6QAAASVJREFUeAHt3DuOwjAUBVAHscWZjaSkAIqU2QjskV80QwpsF3ArdGiw3hW3OGnQM2Iof6/dfr7+n71/LjAdx+HRsvm8SkNPAHBPJ5ABDiD2KgD3dAIZ4ABirwJwTyeQAQ4g9ioA93QC2fbZsSm/z7MDAQIECBAgQIAAAQIECBAgQIAAAQKvAsvV8mO8O8yn19jkXYHpMC7byXVdeS0/75b5XFvAwr1tE0kARxjbJYDbNpEEcISxXQK4bRNJAEcY2yWA2zaRZP0ePJRzpFEJAQIECBAgQIAAAQIECBAgQIAAgW8VWK/tj7Nb5eBTnvbjsp1c15WX4ncRQeB7lb8zyHrW29xo1F1iU8AxynoR4LpLbAo4RlkvAlx3iU0BxyjrRYDrLrHpDVSAEEPXScHTAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/png;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("data:image/png;base64,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", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * CoreUI  v4.3.0 (https://coreui.io)
 * Copyright (c) 2023 creativeLabs Łukasz Holeczek
 * Licensed under MIT (https://github.com/coreui/coreui/blob/main/LICENSE)
 */
:root {
  --cui-blue: #0d6efd;
  --cui-indigo: #6610f2;
  --cui-purple: #6f42c1;
  --cui-pink: #d63384;
  --cui-red: #dc3545;
  --cui-orange: #fd7e14;
  --cui-yellow: #ffc107;
  --cui-green: #198754;
  --cui-teal: #20c997;
  --cui-cyan: #0dcaf0;
  --cui-black: #000015;
  --cui-white: #fff;
  --cui-gray: #8a93a2;
  --cui-gray-dark: #636f83;
  --cui-gray-100: #ebedef;
  --cui-gray-200: #d8dbe0;
  --cui-gray-300: #c4c9d0;
  --cui-gray-400: #b1b7c1;
  --cui-gray-500: #9da5b1;
  --cui-gray-600: #8a93a2;
  --cui-gray-700: #768192;
  --cui-gray-800: #636f83;
  --cui-gray-900: #4f5d73;
  --cui-primary: #0f766e;
  --cui-secondary: #9da5b1;
  --cui-success: #2eb85c;
  --cui-info: #39f;
  --cui-warning: #f9b115;
  --cui-danger: #e55353;
  --cui-light: #ebedef;
  --cui-dark: #4f5d73;
  --cui-primary-rgb: 15, 118, 110;
  --cui-secondary-rgb: 157, 165, 177;
  --cui-success-rgb: 46, 184, 92;
  --cui-info-rgb: 51, 153, 255;
  --cui-warning-rgb: 249, 177, 21;
  --cui-danger-rgb: 229, 83, 83;
  --cui-light-rgb: 235, 237, 239;
  --cui-dark-rgb: 79, 93, 115;
  --cui-white-rgb: 255, 255, 255;
  --cui-black-rgb: 0, 0, 21;
  --cui-font-sans-serif: "Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  --cui-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --cui-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --cui-body-font-family: var(--cui-font-sans-serif);
  --cui-body-font-size: 1rem;
  --cui-body-font-weight: 400;
  --cui-body-line-height: 1.5;
  --cui-body-color: rgba(44, 56, 74, 0.95);
  --cui-body-color-rgb: 44, 56, 74;
  --cui-body-bg: #fff;
  --cui-body-bg-rgb: 255, 255, 255;
  --cui-emphasis-color: #000015;
  --cui-emphasis-color-rgb: 0, 0, 21;
  --cui-secondary-color: rgba(44, 56, 74, 0.681);
  --cui-secondary-color-rgb: 44, 56, 74;
  --cui-secondary-bg: #d8dbe0;
  --cui-secondary-bg-rgb: 216, 219, 224;
  --cui-tertiary-color: rgba(44, 56, 74, 0.38);
  --cui-tertiary-color-rgb: 44, 56, 74;
  --cui-tertiary-bg: #ebedef;
  --cui-tertiary-bg-rgb: 235, 237, 239;
  --cui-high-emphasis: rgba(44, 56, 74, 0.95);
  --cui-medium-emphasis: rgba(44, 56, 74, 0.681);
  --cui-disabled: rgba(44, 56, 74, 0.38);
  --cui-high-emphasis-inverse: rgba(255, 255, 255, 0.87);
  --cui-medium-emphasis-inverse: rgba(255, 255, 255, 0.6);
  --cui-disabled-inverse: rgba(255, 255, 255, 0.38);
  --cui-heading-color: inherit;
  --cui-link-color: #0f766e;
  --cui-link-color-rgb: 15, 118, 110;
  --cui-link-decoration: underline;
  --cui-link-hover-color: #0c5e58;
  --cui-link-hover-color-rgb: 12, 94, 88;
  --cui-code-color: #d63384;
  --cui-highlight-bg: #fff3cd;
  --cui-border-width: 1px;
  --cui-border-style: solid;
  --cui-border-color: #d8dbe0;
  --cui-border-color-translucent: rgba(0, 0, 21, 0.175);
  --cui-border-radius: 0.375rem;
  --cui-border-radius-sm: 0.25rem;
  --cui-border-radius-lg: 0.5rem;
  --cui-border-radius-xl: 1rem;
  --cui-border-radius-xxl: 2rem;
  --cui-border-radius-2xl: var(--cui-border-radius-xxl);
  --cui-border-radius-pill: 50rem;
  --cui-box-shadow: 0 0.5rem 1rem rgba(0, 0, 21, 0.15);
  --cui-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 21, 0.075);
  --cui-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 21, 0.175);
  --cui-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 21, 0.075);
  --cui-focus-ring-width: 0.25rem;
  --cui-focus-ring-opacity: 0.25;
  --cui-focus-ring-color: rgba(15, 118, 110, 0.25);
  --cui-form-valid-color: #2eb85c;
  --cui-form-valid-border-color: #2eb85c;
  --cui-form-invalid-color: #e55353;
  --cui-form-invalid-border-color: #e55353;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--cui-body-font-family);
  font-size: var(--cui-body-font-size);
  font-weight: var(--cui-body-font-weight);
  line-height: var(--cui-body-line-height);
  color: var(--cui-body-color);
  text-align: var(--cui-body-text-align);
  background-color: var(--cui-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 21, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--cui-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--cui-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  background-color: var(--cui-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--cui-link-color-rgb), var(--cui-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --cui-link-color-rgb: var(--cui-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--cui-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
  color: var(--cui-pre-color, );
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--cui-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--cui-kbd-color, var(--cui-body-bg));
  background-color: var(--cui-kbd-bg, var(--cui-body-color));
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--cui-table-caption-color, var(--cui-secondary-color));
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

*[dir=rtl] [type=tel],
*[dir=rtl] [type=url],
*[dir=rtl] [type=email],
*[dir=rtl] [type=number] {
  direction: ltr;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #8a93a2;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--cui-thumbnail-bg, var(--cui-body-bg));
  border: var(--cui-border-width) solid var(--cui-thumbnail-border-color, var(--cui-border-color));
  border-radius: var(--cui-border-radius);
  box-shadow: var(--cui-box-shadow-sm);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--cui-figure-caption-color, var(--cui-secondary-color));
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --cui-gutter-x: 1.5rem;
  --cui-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--cui-gutter-x) * 0.5);
  padding-left: calc(var(--cui-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --cui-breakpoint-xs: 0;
  --cui-breakpoint-sm: 576px;
  --cui-breakpoint-md: 768px;
  --cui-breakpoint-lg: 992px;
  --cui-breakpoint-xl: 1200px;
  --cui-breakpoint-xxl: 1400px;
  --cui-mobile-breakpoint: md;
}

.row {
  --cui-gutter-x: 1.5rem;
  --cui-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--cui-gutter-y));
  margin-right: calc(-0.5 * var(--cui-gutter-x));
  margin-left: calc(-0.5 * var(--cui-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--cui-gutter-x) * 0.5);
  padding-left: calc(var(--cui-gutter-x) * 0.5);
  margin-top: var(--cui-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --cui-gutter-x: 0;
}

.g-0,
.gy-0 {
  --cui-gutter-y: 0;
}

.g-1,
.gx-1 {
  --cui-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --cui-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --cui-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --cui-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --cui-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --cui-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --cui-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --cui-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --cui-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --cui-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --cui-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --cui-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --cui-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --cui-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --cui-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --cui-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --cui-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --cui-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --cui-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --cui-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --cui-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --cui-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --cui-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --cui-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --cui-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --cui-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --cui-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --cui-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --cui-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --cui-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --cui-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --cui-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --cui-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --cui-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --cui-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --cui-gutter-y: 3rem;
  }
}
.table {
  --cui-table-color-type: initial;
  --cui-table-bg-type: initial;
  --cui-table-color-state: initial;
  --cui-table-bg-state: initial;
  --cui-table-color: var(--cui-body-color);
  --cui-table-bg: var(--cui-body-bg);
  --cui-table-border-color: var(--cui-border-color);
  --cui-table-accent-bg: transparent;
  --cui-table-striped-color: var(--cui-body-color);
  --cui-table-striped-bg: rgba(0, 0, 21, 0.05);
  --cui-table-active-color: var(--cui-body-color);
  --cui-table-active-bg: rgba(0, 0, 21, 0.1);
  --cui-table-hover-color: var(--cui-body-color);
  --cui-table-hover-bg: rgba(0, 0, 21, 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--cui-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--cui-table-color-state, var(--cui-table-color-type, var(--cui-table-color)));
  background-color: var(--cui-table-bg);
  border-bottom-width: var(--cui-border-width);
  box-shadow: inset 0 0 0 9999px var(--cui-table-bg-state, var(--cui-table-bg-type, var(--cui-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--cui-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--cui-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--cui-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --cui-table-color-type: var(--cui-table-striped-color);
  --cui-table-bg-type: var(--cui-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --cui-table-color-type: var(--cui-table-striped-color);
  --cui-table-bg-type: var(--cui-table-striped-bg);
}

.table-active {
  --cui-table-color-state: var(--cui-table-active-color);
  --cui-table-bg-state: var(--cui-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --cui-table-color-state: var(--cui-table-hover-color);
  --cui-table-bg-state: var(--cui-table-hover-bg);
}

.table-primary {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #cfe4e2;
  --cui-table-border-color: rgba(192, 212, 212, 0.995);
  --cui-table-striped-bg: rgba(200, 220, 219, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(192, 212, 212, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(196, 216, 216, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-secondary {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #ebedef;
  --cui-table-border-color: rgba(218, 220, 224, 0.995);
  --cui-table-striped-bg: rgba(226, 229, 232, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(218, 220, 224, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(222, 225, 228, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-success {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #d5f1de;
  --cui-table-border-color: rgba(198, 224, 208, 0.995);
  --cui-table-striped-bg: rgba(205, 233, 215, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(198, 224, 208, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(201, 228, 212, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-info {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #d6ebff;
  --cui-table-border-color: rgba(198, 219, 238, 0.995);
  --cui-table-striped-bg: rgba(206, 227, 247, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(198, 219, 238, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(202, 223, 243, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-warning {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #feefd0;
  --cui-table-border-color: rgba(235, 222, 196, 0.995);
  --cui-table-striped-bg: rgba(244, 231, 202, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(235, 222, 196, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(240, 226, 199, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-danger {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #fadddd;
  --cui-table-border-color: rgba(231, 206, 208, 0.995);
  --cui-table-striped-bg: rgba(241, 214, 214, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(231, 206, 208, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(236, 210, 211, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-light {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #ebedef;
  --cui-table-border-color: rgba(218, 220, 224, 0.995);
  --cui-table-striped-bg: rgba(226, 229, 232, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(218, 220, 224, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(222, 225, 228, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-dark {
  --cui-table-color: rgba(255, 255, 255, 0.87);
  --cui-table-bg: #4f5d73;
  --cui-table-border-color: rgba(93, 106, 126, 0.987);
  --cui-table-striped-bg: rgba(86, 99, 120, 0.9935);
  --cui-table-striped-color: rgba(255, 255, 255, 0.87);
  --cui-table-active-bg: rgba(93, 106, 126, 0.987);
  --cui-table-active-color: rgba(255, 255, 255, 0.87);
  --cui-table-hover-bg: rgba(89, 103, 123, 0.99025);
  --cui-table-hover-color: rgba(255, 255, 255, 0.87);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
  color: var(--cui-form-label-color, );
}

.col-form-label {
  padding-top: calc(0.375rem + var(--cui-border-width));
  padding-bottom: calc(0.375rem + var(--cui-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
  color: var(--cui-form-label-color, );
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--cui-border-width));
  padding-bottom: calc(0.5rem + var(--cui-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--cui-border-width));
  padding-bottom: calc(0.25rem + var(--cui-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--cui-form-text-color, var(--cui-secondary-color));
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cui-input-color, var(--cui-body-color));
  appearance: none;
  background-color: var(--cui-input-bg, var(--cui-body-bg));
  background-clip: padding-box;
  border: var(--cui-border-width) solid var(--cui-input-border-color, var(--cui-border-color));
  border-radius: var(--cui-border-radius);
  box-shadow: inset 0 1px 2px rgba(0, 0, 21, 0.075);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--cui-input-focus-color, var(--cui-body-color));
  background-color: var(--cui-input-focus-bg, var(--cui-body-bg));
  border-color: var(--cui-input-focus-border-color, #87bbb7);
  outline: 0;
  box-shadow: inset 0 1px 2px rgba(0, 0, 21, 0.075), 0 0 0 0.25rem rgba(15, 118, 110, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--cui-input-placeholder-color, var(--cui-secondary-color));
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--cui-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--cui-form-file-button-color, var(--cui-body-color));
  background-color: var(--cui-form-file-button-bg, var(--cui-tertiary-bg));
  background-image: var(--cui-gradient);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--cui-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--cui-form-file-button-hover-bg, var(--cui-secondary-bg));
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--cui-input-plaintext-color, var(--cui-body-color));
  background-color: transparent;
  border: solid transparent;
  border-width: var(--cui-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--cui-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--cui-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--cui-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--cui-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--cui-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--cui-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
}

.form-select {
  --cui-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cui-form-select-color, var(--cui-body-color));
  appearance: none;
  background-color: var(--cui-form-select-bg, var(--cui-body-bg));
  background-image: var(--cui-form-select-bg-img), var(--cui-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--cui-border-width) solid var(--cui-form-select-border-color, var(--cui-border-color));
  border-radius: var(--cui-border-radius);
  box-shadow: inset 0 1px 2px rgba(0, 0, 21, 0.075);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: var(--cui-form-select-focus-border-color, #87bbb7);
  outline: 0;
  box-shadow: inset 0 1px 2px rgba(0, 0, 21, 0.075), 0 0 0 0.25rem rgba(15, 118, 110, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  color: var(--cui-form-select-disabled-color, );
  background-color: var(--cui-form-select-disabled-bg, var(--cui-secondary-bg));
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--cui-form-select-color, var(--cui-body-color));
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--cui-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--cui-border-radius-lg);
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --cui-form-check-bg: var(--cui-body-bg);
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--cui-form-check-bg);
  background-image: var(--cui-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--cui-border-width) solid var(--cui-border-color);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: #87bbb7;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(15, 118, 110, 0.25);
}
.form-check-input:checked {
  background-color: var(--cui-form-check-input-checked-bg-color, #0f766e);
  border-color: var(--cui-form-check-input-checked-border-color, #0f766e);
}
.form-check-input:checked[type=checkbox] {
  --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}), var(--cui-gradient);
}
.form-check-input:checked[type=radio] {
  --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}), var(--cui-gradient);
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #0f766e;
  border-color: #0f766e;
  --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}), var(--cui-gradient);
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-check-label {
  color: var(--cui-form-check-label-color, );
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--cui-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___}), var(--cui-gradient);
}
.form-switch.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -1.5em;
  margin-left: 0;
}

.form-switch-lg {
  min-height: 1.25em;
  padding-left: 2.25em;
}
.form-switch-lg .form-check-input {
  width: 1.75em;
  height: 1.25em;
  margin-left: -2.25em;
}
.form-switch-lg .form-check-label {
  padding-top: calc((1.25em - 1rem) / 2);
}

.form-switch-xl {
  min-height: 1.5em;
  padding-left: 2.5em;
}
.form-switch-xl .form-check-input {
  width: 2em;
  height: 1.5em;
  margin-left: -2.5em;
}
.form-switch-xl .form-check-label {
  padding-top: calc((1.5em - 1rem) / 2);
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(15, 118, 110, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(15, 118, 110, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: var(--cui-form-range-thumb-bg, #0f766e);
  background-image: var(--cui-gradient);
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 21, 0.1);
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: var(--cui-form-range-thumb-active-bg, #b7d6d4);
  background-image: var(--cui-gradient);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--cui-form-range-track-bg, var(--cui-tertiary-bg));
  border-color: transparent;
  border-radius: 1rem;
  box-shadow: inset 0 1px 2px rgba(0, 0, 21, 0.075);
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: var(--cui-form-range-thumb-bg, #0f766e);
  background-image: var(--cui-gradient);
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 21, 0.1);
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: var(--cui-form-range-thumb-active-bg, #b7d6d4);
  background-image: var(--cui-gradient);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--cui-form-range-track-bg, var(--cui-tertiary-bg));
  border-color: transparent;
  border-radius: 1rem;
  box-shadow: inset 0 1px 2px rgba(0, 0, 21, 0.075);
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--cui-form-range-thumb-disabled-bg, var(--cui-secondary-color));
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--cui-form-range-thumb-disabled-bg, var(--cui-secondary-color));
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--cui-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--cui-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--cui-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--cui-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--cui-body-bg);
  border-radius: var(--cui-border-radius);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--cui-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--cui-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #8a93a2;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: var(--cui-secondary-bg);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cui-input-group-addon-color, var(--cui-body-color));
  text-align: center;
  white-space: nowrap;
  background-color: var(--cui-input-group-addon-bg, var(--cui-tertiary-bg));
  border: var(--cui-border-width) solid var(--cui-input-group-addon-border-color, var(--cui-border-color));
  border-radius: var(--cui-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--cui-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--cui-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--cui-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--cui-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--cui-success);
  border-radius: var(--cui-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--cui-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--cui-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--cui-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --cui-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--cui-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--cui-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--cui-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--cui-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--cui-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--cui-danger);
  border-radius: var(--cui-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--cui-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--cui-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--cui-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --cui-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--cui-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--cui-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--cui-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--cui-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --cui-btn-padding-x: 0.75rem;
  --cui-btn-padding-y: 0.375rem;
  --cui-btn-font-family: ;
  --cui-btn-font-size: 1rem;
  --cui-btn-font-weight: 400;
  --cui-btn-line-height: 1.5;
  --cui-btn-color: var(--cui-body-color);
  --cui-btn-bg: transparent;
  --cui-btn-border-width: var(--cui-border-width);
  --cui-btn-border-color: transparent;
  --cui-btn-border-radius: var(--cui-border-radius);
  --cui-btn-hover-border-color: transparent;
  --cui-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 21, 0.075);
  --cui-btn-disabled-opacity: 0.65;
  --cui-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--cui-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--cui-btn-padding-y) var(--cui-btn-padding-x);
  font-family: var(--cui-btn-font-family);
  font-size: var(--cui-btn-font-size);
  font-weight: var(--cui-btn-font-weight);
  line-height: var(--cui-btn-line-height);
  color: var(--cui-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--cui-btn-border-width) solid var(--cui-btn-border-color);
  border-radius: var(--cui-btn-border-radius);
  background-color: var(--cui-btn-bg);
  background-image: var(--cui-gradient);
  box-shadow: var(--cui-btn-box-shadow);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--cui-btn-hover-color);
  background-color: var(--cui-btn-hover-bg);
  border-color: var(--cui-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--cui-btn-color);
  background-color: var(--cui-btn-bg);
  border-color: var(--cui-btn-border-color);
}
.btn:focus-visible {
  color: var(--cui-btn-hover-color);
  background-color: var(--cui-btn-hover-bg);
  background-image: var(--cui-gradient);
  border-color: var(--cui-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--cui-btn-box-shadow), var(--cui-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--cui-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--cui-btn-box-shadow), var(--cui-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--cui-btn-active-color);
  background-color: var(--cui-btn-active-bg);
  background-image: none;
  border-color: var(--cui-btn-active-border-color);
  box-shadow: var(--cui-btn-active-shadow);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--cui-btn-active-shadow), var(--cui-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--cui-btn-disabled-color);
  pointer-events: none;
  background-color: var(--cui-btn-disabled-bg);
  background-image: none;
  border-color: var(--cui-btn-disabled-border-color);
  opacity: var(--cui-btn-disabled-opacity);
  box-shadow: none;
}

.btn-transparent {
  --cui-btn-active-border-color: transparent;
  --cui-btn-disabled-border-color: transparent;
  --cui-btn-hover-border-color: transparent;
}

.btn-primary {
  --cui-btn-color: rgba(255, 255, 255, 0.87);
  --cui-btn-bg: #0f766e;
  --cui-btn-border-color: #0f766e;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #338b84;
  --cui-btn-hover-border-color: #27847d;
  --cui-btn-focus-shadow-rgb: 44, 134, 127;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #3f918b;
  --cui-btn-active-border-color: #27847d;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: rgba(255, 255, 255, 0.87);
  --cui-btn-disabled-bg: #0f766e;
  --cui-btn-disabled-border-color: #0f766e;
}

.btn-secondary {
  --cui-btn-color: #000015;
  --cui-btn-bg: #9da5b1;
  --cui-btn-border-color: #9da5b1;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #acb3bd;
  --cui-btn-hover-border-color: #a7aeb9;
  --cui-btn-focus-shadow-rgb: 133, 140, 154;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #b1b7c1;
  --cui-btn-active-border-color: #a7aeb9;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #9da5b1;
  --cui-btn-disabled-border-color: #9da5b1;
}

.btn-success {
  --cui-btn-color: #000015;
  --cui-btn-bg: #2eb85c;
  --cui-btn-border-color: #2eb85c;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #4dc374;
  --cui-btn-hover-border-color: #43bf6c;
  --cui-btn-focus-shadow-rgb: 39, 156, 81;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #58c67d;
  --cui-btn-active-border-color: #43bf6c;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #2eb85c;
  --cui-btn-disabled-border-color: #2eb85c;
}

.btn-danger {
  --cui-btn-color: #000015;
  --cui-btn-bg: #e55353;
  --cui-btn-border-color: #e55353;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #e96d6d;
  --cui-btn-hover-border-color: #e86464;
  --cui-btn-focus-shadow-rgb: 195, 71, 74;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #ea7575;
  --cui-btn-active-border-color: #e86464;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #e55353;
  --cui-btn-disabled-border-color: #e55353;
}

.btn-warning {
  --cui-btn-color: rgba(44, 56, 74, 0.95);
  --cui-btn-bg: #f9b115;
  --cui-btn-border-color: #f9b115;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #d49612;
  --cui-btn-hover-border-color: #c78e11;
  --cui-btn-focus-shadow-rgb: 221, 160, 28;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #c78e11;
  --cui-btn-active-border-color: #bb8510;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-bg: #f9b115;
  --cui-btn-disabled-border-color: #f9b115;
}

.btn-info {
  --cui-btn-color: #000015;
  --cui-btn-bg: #39f;
  --cui-btn-border-color: #39f;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #52a8ff;
  --cui-btn-hover-border-color: #47a3ff;
  --cui-btn-focus-shadow-rgb: 43, 130, 220;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #5cadff;
  --cui-btn-active-border-color: #47a3ff;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #39f;
  --cui-btn-disabled-border-color: #39f;
}

.btn-light {
  --cui-btn-color: rgba(44, 56, 74, 0.95);
  --cui-btn-bg: #ebedef;
  --cui-btn-border-color: #ebedef;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #c8c9cb;
  --cui-btn-hover-border-color: #bcbebf;
  --cui-btn-focus-shadow-rgb: 209, 212, 216;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #bcbebf;
  --cui-btn-active-border-color: #b0b2b3;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-bg: #ebedef;
  --cui-btn-disabled-border-color: #ebedef;
}

.btn-dark {
  --cui-btn-color: rgba(255, 255, 255, 0.87);
  --cui-btn-bg: #4f5d73;
  --cui-btn-border-color: #4f5d73;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: #697588;
  --cui-btn-hover-border-color: #616d81;
  --cui-btn-focus-shadow-rgb: 100, 112, 132;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: #727d8f;
  --cui-btn-active-border-color: #616d81;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: rgba(255, 255, 255, 0.87);
  --cui-btn-disabled-bg: #4f5d73;
  --cui-btn-disabled-border-color: #4f5d73;
}

.btn-outline-primary {
  --cui-btn-color: #0f766e;
  --cui-btn-border-color: #0f766e;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #3f918b;
  --cui-btn-hover-border-color: #27847d;
  --cui-btn-focus-shadow-rgb: 15, 118, 110;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #3f918b;
  --cui-btn-active-border-color: #27847d;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #0f766e;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-secondary {
  --cui-btn-color: #9da5b1;
  --cui-btn-border-color: #9da5b1;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #b1b7c1;
  --cui-btn-hover-border-color: #a7aeb9;
  --cui-btn-focus-shadow-rgb: 157, 165, 177;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #b1b7c1;
  --cui-btn-active-border-color: #a7aeb9;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #9da5b1;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-success {
  --cui-btn-color: #2eb85c;
  --cui-btn-border-color: #2eb85c;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #58c67d;
  --cui-btn-hover-border-color: #43bf6c;
  --cui-btn-focus-shadow-rgb: 46, 184, 92;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #58c67d;
  --cui-btn-active-border-color: #43bf6c;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #2eb85c;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-danger {
  --cui-btn-color: #e55353;
  --cui-btn-border-color: #e55353;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #ea7575;
  --cui-btn-hover-border-color: #e86464;
  --cui-btn-focus-shadow-rgb: 229, 83, 83;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #ea7575;
  --cui-btn-active-border-color: #e86464;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #e55353;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-warning {
  --cui-btn-color: #f9b115;
  --cui-btn-border-color: #f9b115;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #c78e11;
  --cui-btn-hover-border-color: #bb8510;
  --cui-btn-focus-shadow-rgb: 249, 177, 21;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #c78e11;
  --cui-btn-active-border-color: #bb8510;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #f9b115;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-info {
  --cui-btn-color: #39f;
  --cui-btn-border-color: #39f;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #5cadff;
  --cui-btn-hover-border-color: #47a3ff;
  --cui-btn-focus-shadow-rgb: 51, 153, 255;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #5cadff;
  --cui-btn-active-border-color: #47a3ff;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #39f;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-light {
  --cui-btn-color: #ebedef;
  --cui-btn-border-color: #ebedef;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #bcbebf;
  --cui-btn-hover-border-color: #b0b2b3;
  --cui-btn-focus-shadow-rgb: 235, 237, 239;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #bcbebf;
  --cui-btn-active-border-color: #b0b2b3;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #ebedef;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-dark {
  --cui-btn-color: #4f5d73;
  --cui-btn-border-color: #4f5d73;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: #727d8f;
  --cui-btn-hover-border-color: #616d81;
  --cui-btn-focus-shadow-rgb: 79, 93, 115;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: #727d8f;
  --cui-btn-active-border-color: #616d81;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #4f5d73;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-ghost-primary {
  --cui-btn-color: #0f766e;
  --cui-btn-hover-bg: #338b84;
  --cui-btn-hover-border-color: #27847d;
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: #3f918b;
  --cui-btn-active-border-color: #27847d;
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #0f766e;
  --cui-btn-shadow: rgba(15, 118, 110, 0.5);
}

.btn-ghost-secondary {
  --cui-btn-color: #9da5b1;
  --cui-btn-hover-bg: #acb3bd;
  --cui-btn-hover-border-color: #a7aeb9;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #b1b7c1;
  --cui-btn-active-border-color: #a7aeb9;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-color: #9da5b1;
  --cui-btn-shadow: rgba(157, 165, 177, 0.5);
}

.btn-ghost-success {
  --cui-btn-color: #2eb85c;
  --cui-btn-hover-bg: #4dc374;
  --cui-btn-hover-border-color: #43bf6c;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #58c67d;
  --cui-btn-active-border-color: #43bf6c;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-color: #2eb85c;
  --cui-btn-shadow: rgba(46, 184, 92, 0.5);
}

.btn-ghost-danger {
  --cui-btn-color: #e55353;
  --cui-btn-hover-bg: #e96d6d;
  --cui-btn-hover-border-color: #e86464;
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: #ea7575;
  --cui-btn-active-border-color: #e86464;
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #e55353;
  --cui-btn-shadow: rgba(229, 83, 83, 0.5);
}

.btn-ghost-warning {
  --cui-btn-color: #f9b115;
  --cui-btn-hover-bg: #d49612;
  --cui-btn-hover-border-color: #c78e11;
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: #c78e11;
  --cui-btn-active-border-color: #bb8510;
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #f9b115;
  --cui-btn-shadow: rgba(249, 177, 21, 0.5);
}

.btn-ghost-info {
  --cui-btn-color: #39f;
  --cui-btn-hover-bg: #52a8ff;
  --cui-btn-hover-border-color: #47a3ff;
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: #5cadff;
  --cui-btn-active-border-color: #47a3ff;
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #39f;
  --cui-btn-shadow: rgba(51, 153, 255, 0.5);
}

.btn-ghost-light {
  --cui-btn-color: #ebedef;
  --cui-btn-hover-bg: #c8c9cb;
  --cui-btn-hover-border-color: #bcbebf;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #bcbebf;
  --cui-btn-active-border-color: #b0b2b3;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-color: #ebedef;
  --cui-btn-shadow: rgba(235, 237, 239, 0.5);
}

.btn-ghost-dark {
  --cui-btn-color: #4f5d73;
  --cui-btn-hover-bg: #697588;
  --cui-btn-hover-border-color: #616d81;
  --cui-btn-hover-color: #fff;
  --cui-btn-active-bg: #727d8f;
  --cui-btn-active-border-color: #616d81;
  --cui-btn-active-color: #fff;
  --cui-btn-disabled-color: #4f5d73;
  --cui-btn-shadow: rgba(79, 93, 115, 0.5);
}

.btn-link {
  --cui-btn-font-weight: 400;
  --cui-btn-color: var(--cui-link-color);
  --cui-btn-bg: transparent;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-color: var(--cui-link-hover-color);
  --cui-btn-hover-border-color: transparent;
  --cui-btn-active-border-color: transparent;
  --cui-btn-disabled-color: #8a93a2;
  --cui-btn-disabled-border-color: transparent;
  --cui-btn-box-shadow: none;
  --cui-btn-focus-shadow-rgb: 44, 134, 127;
  text-decoration: underline;
  background-image: none;
}
.btn-link:focus-visible {
  color: var(--cui-btn-color);
}

.btn-lg, .btn-group-lg > .btn {
  --cui-btn-padding-y: 0.5rem;
  --cui-btn-padding-x: 1rem;
  --cui-btn-font-size: 1.25rem;
  --cui-btn-border-radius: var(--cui-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --cui-btn-padding-y: 0.25rem;
  --cui-btn-padding-x: 0.5rem;
  --cui-btn-font-size: 0.875rem;
  --cui-btn-border-radius: var(--cui-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --cui-dropdown-zindex: 1000;
  --cui-dropdown-min-width: 10rem;
  --cui-dropdown-padding-x: 0;
  --cui-dropdown-padding-y: 0.5rem;
  --cui-dropdown-spacer: 0.125rem;
  --cui-dropdown-font-size: 1rem;
  --cui-dropdown-color: var(--cui-body-color);
  --cui-dropdown-bg: var(--cui-body-bg);
  --cui-dropdown-border-color: var(--cui-border-color-translucent);
  --cui-dropdown-border-radius: var(--cui-border-radius);
  --cui-dropdown-border-width: var(--cui-border-width);
  --cui-dropdown-inner-border-radius: calc(var(--cui-border-radius) - var(--cui-border-width));
  --cui-dropdown-divider-bg: var(--cui-border-color-translucent);
  --cui-dropdown-divider-margin-y: 0.5rem;
  --cui-dropdown-box-shadow: 0 0.5rem 1rem rgba(0, 0, 21, 0.15);
  --cui-dropdown-link-color: var(--cui-body-color);
  --cui-dropdown-link-hover-color: var(--cui-body-color);
  --cui-dropdown-link-hover-bg: var(--cui-tertiary-bg);
  --cui-dropdown-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-link-active-bg: #0f766e;
  --cui-dropdown-link-disabled-color: var(--cui-tertiary-color);
  --cui-dropdown-item-padding-x: 1rem;
  --cui-dropdown-item-padding-y: 0.25rem;
  --cui-dropdown-header-color: #8a93a2;
  --cui-dropdown-header-padding-x: 1rem;
  --cui-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--cui-dropdown-zindex);
  display: none;
  min-width: var(--cui-dropdown-min-width);
  padding: var(--cui-dropdown-padding-y) var(--cui-dropdown-padding-x);
  margin: 0;
  font-size: var(--cui-dropdown-font-size);
  color: var(--cui-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--cui-dropdown-bg);
  background-clip: padding-box;
  border: var(--cui-dropdown-border-width) solid var(--cui-dropdown-border-color);
  border-radius: var(--cui-dropdown-border-radius);
  box-shadow: var(--cui-dropdown-box-shadow);
}
.dropdown-menu[data-coreui-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--cui-dropdown-spacer);
}

.dropdown-menu-start {
  --cui-position: start;
}
.dropdown-menu-start[data-coreui-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --cui-position: end;
}
.dropdown-menu-end[data-coreui-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --cui-position: start;
  }
  .dropdown-menu-sm-start[data-coreui-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --cui-position: end;
  }
  .dropdown-menu-sm-end[data-coreui-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --cui-position: start;
  }
  .dropdown-menu-md-start[data-coreui-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --cui-position: end;
  }
  .dropdown-menu-md-end[data-coreui-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --cui-position: start;
  }
  .dropdown-menu-lg-start[data-coreui-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --cui-position: end;
  }
  .dropdown-menu-lg-end[data-coreui-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --cui-position: start;
  }
  .dropdown-menu-xl-start[data-coreui-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --cui-position: end;
  }
  .dropdown-menu-xl-end[data-coreui-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --cui-position: start;
  }
  .dropdown-menu-xxl-start[data-coreui-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --cui-position: end;
  }
  .dropdown-menu-xxl-end[data-coreui-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-coreui-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--cui-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-coreui-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--cui-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-coreui-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--cui-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--cui-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--cui-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--cui-dropdown-item-padding-y) var(--cui-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--cui-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--cui-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--cui-dropdown-link-hover-color);
  background-color: var(--cui-dropdown-link-hover-bg);
  background-image: var(--cui-gradient);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--cui-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--cui-dropdown-link-active-bg);
  background-image: var(--cui-gradient);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--cui-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
  background-image: none;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--cui-dropdown-header-padding-y) var(--cui-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--cui-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--cui-dropdown-item-padding-y) var(--cui-dropdown-item-padding-x);
  color: var(--cui-dropdown-link-color);
}

.dropdown-menu-dark {
  --cui-dropdown-color: #c4c9d0;
  --cui-dropdown-bg: #636f83;
  --cui-dropdown-border-color: var(--cui-border-color-translucent);
  --cui-dropdown-box-shadow: ;
  --cui-dropdown-link-color: #c4c9d0;
  --cui-dropdown-link-hover-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-divider-bg: var(--cui-border-color-translucent);
  --cui-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --cui-dropdown-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-link-active-bg: #0f766e;
  --cui-dropdown-link-disabled-color: #9da5b1;
  --cui-dropdown-header-color: #9da5b1;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--cui-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--cui-border-width) * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group.show .dropdown-toggle {
  box-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
}
.btn-group.show .dropdown-toggle.btn-link {
  box-shadow: none;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--cui-border-width) * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --cui-nav-link-padding-x: 1rem;
  --cui-nav-link-padding-y: 0.5rem;
  --cui-nav-link-font-weight: ;
  --cui-nav-link-color: var(--cui-link-color);
  --cui-nav-link-hover-color: var(--cui-link-hover-color);
  --cui-nav-link-disabled-color: var(--cui-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--cui-nav-link-padding-y) var(--cui-nav-link-padding-x);
  font-size: var(--cui-nav-link-font-size);
  font-weight: var(--cui-nav-link-font-weight);
  color: var(--cui-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--cui-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(15, 118, 110, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--cui-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --cui-nav-tabs-border-width: var(--cui-border-width);
  --cui-nav-tabs-border-color: var(--cui-border-color);
  --cui-nav-tabs-border-radius: var(--cui-border-radius);
  --cui-nav-tabs-link-hover-border-color: var(--cui-secondary-bg) var(--cui-secondary-bg) var(--cui-border-color);
  --cui-nav-tabs-link-active-color: var(--cui-emphasis-color);
  --cui-nav-tabs-link-active-bg: var(--cui-body-bg);
  --cui-nav-tabs-link-active-border-color: var(--cui-border-color) var(--cui-border-color) var(--cui-body-bg);
  border-bottom: var(--cui-nav-tabs-border-width) solid var(--cui-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--cui-nav-tabs-border-width));
  border: var(--cui-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--cui-nav-tabs-border-radius);
  border-top-right-radius: var(--cui-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--cui-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--cui-nav-tabs-link-active-color);
  background-color: var(--cui-nav-tabs-link-active-bg);
  border-color: var(--cui-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--cui-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --cui-nav-pills-border-radius: var(--cui-border-radius);
  --cui-nav-pills-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-nav-pills-link-active-bg: #0f766e;
}
.nav-pills .nav-link {
  border-radius: var(--cui-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--cui-nav-pills-link-active-color);
  background-color: var(--cui-nav-pills-link-active-bg);
  background-image: var(--cui-gradient);
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --cui-navbar-padding-x: 0;
  --cui-navbar-padding-y: 0.5rem;
  --cui-navbar-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-navbar-hover-color: rgba(var(--cui-emphasis-color-rgb), 0.8);
  --cui-navbar-disabled-color: rgba(var(--cui-emphasis-color-rgb), 0.3);
  --cui-navbar-active-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-brand-padding-y: 0.3125rem;
  --cui-navbar-brand-margin-end: 1rem;
  --cui-navbar-brand-font-size: 1.25rem;
  --cui-navbar-brand-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-brand-hover-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-nav-link-padding-x: 0.5rem;
  --cui-navbar-toggler-padding-y: 0.25rem;
  --cui-navbar-toggler-padding-x: 0.75rem;
  --cui-navbar-toggler-font-size: 1.25rem;
  --cui-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  --cui-navbar-toggler-border-color: rgba(var(--cui-emphasis-color-rgb), 0.15);
  --cui-navbar-toggler-border-radius: var(--cui-border-radius);
  --cui-navbar-toggler-focus-width: 0.25rem;
  --cui-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-navbar-padding-y) var(--cui-navbar-padding-x);
  background-image: var(--cui-gradient);
}
.navbar .header > .container,
.navbar .header > .container-fluid,
.navbar .header > .container-sm,
.navbar .header > .container-md,
.navbar .header > .container-lg,
.navbar .header > .container-xl,
.navbar .header > .container-xxl, .navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--cui-navbar-brand-padding-y);
  padding-bottom: var(--cui-navbar-brand-padding-y);
  margin-right: var(--cui-navbar-brand-margin-end);
  font-size: var(--cui-navbar-brand-font-size);
  color: var(--cui-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--cui-navbar-brand-hover-color);
}

.navbar-nav {
  --cui-nav-link-padding-x: 0;
  --cui-nav-link-padding-y: 0.5rem;
  --cui-nav-link-font-weight: ;
  --cui-nav-link-color: var(--cui-navbar-color);
  --cui-nav-link-hover-color: var(--cui-navbar-hover-color);
  --cui-nav-link-disabled-color: var(--cui-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--cui-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--cui-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--cui-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--cui-navbar-toggler-padding-y) var(--cui-navbar-toggler-padding-x);
  font-size: var(--cui-navbar-toggler-font-size);
  line-height: 1;
  color: var(--cui-navbar-color);
  background-color: transparent;
  border: var(--cui-border-width) solid var(--cui-navbar-toggler-border-color);
  border-radius: var(--cui-navbar-toggler-border-radius);
  transition: var(--cui-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--cui-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--cui-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--cui-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--cui-navbar-nav-link-padding-x);
  padding-left: var(--cui-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  box-shadow: none;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark {
  --cui-navbar-color: rgba(255, 255, 255, 0.55);
  --cui-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --cui-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --cui-navbar-active-color: #fff;
  --cui-navbar-brand-color: #fff;
  --cui-navbar-brand-hover-color: #fff;
  --cui-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --cui-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.card {
  --cui-card-spacer-y: 1rem;
  --cui-card-spacer-x: 1rem;
  --cui-card-title-spacer-y: 0.5rem;
  --cui-card-title-color: ;
  --cui-card-subtitle-color: ;
  --cui-card-border-width: var(--cui-border-width);
  --cui-card-border-color: var(--cui-border-color-translucent);
  --cui-card-border-radius: var(--cui-border-radius);
  --cui-card-box-shadow: ;
  --cui-card-inner-border-radius: calc(var(--cui-border-radius) - (var(--cui-border-width)));
  --cui-card-cap-padding-y: 0.5rem;
  --cui-card-cap-padding-x: 1rem;
  --cui-card-cap-bg: rgba(var(--cui-body-color-rgb), 0.03);
  --cui-card-cap-color: ;
  --cui-card-height: ;
  --cui-card-color: ;
  --cui-card-bg: var(--cui-body-bg);
  --cui-card-img-overlay-padding: 1rem;
  --cui-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--cui-card-height);
  color: var(--cui-body-color);
  word-wrap: break-word;
  background-color: var(--cui-card-bg);
  background-clip: border-box;
  border: var(--cui-card-border-width) solid var(--cui-card-border-color);
  border-radius: var(--cui-card-border-radius);
  box-shadow: var(--cui-card-box-shadow);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--cui-card-inner-border-radius);
  border-top-right-radius: var(--cui-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--cui-card-inner-border-radius);
  border-bottom-left-radius: var(--cui-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--cui-card-spacer-y) var(--cui-card-spacer-x);
  color: var(--cui-card-color);
}

.card-title {
  margin-bottom: var(--cui-card-title-spacer-y);
  color: var(--cui-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--cui-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--cui-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--cui-card-spacer-x);
}

.card-header {
  padding: var(--cui-card-cap-padding-y) var(--cui-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--cui-card-cap-color);
  background-color: var(--cui-card-cap-bg);
  border-bottom: var(--cui-card-border-width) solid var(--cui-card-border-color);
}
.card-header:first-child {
  border-radius: var(--cui-card-inner-border-radius) var(--cui-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--cui-card-cap-padding-y) var(--cui-card-cap-padding-x);
  color: var(--cui-card-cap-color);
  background-color: var(--cui-card-cap-bg);
  border-top: var(--cui-card-border-width) solid var(--cui-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--cui-card-inner-border-radius) var(--cui-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--cui-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--cui-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--cui-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--cui-card-bg);
  border-bottom-color: var(--cui-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--cui-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--cui-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--cui-card-img-overlay-padding);
  border-radius: var(--cui-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--cui-card-inner-border-radius);
  border-top-right-radius: var(--cui-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--cui-card-inner-border-radius);
  border-bottom-left-radius: var(--cui-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--cui-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --cui-accordion-color: var(--cui-body-color);
  --cui-accordion-bg: var(--cui-body-bg);
  --cui-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --cui-accordion-border-color: var(--cui-border-color);
  --cui-accordion-border-width: var(--cui-border-width);
  --cui-accordion-border-radius: var(--cui-border-radius);
  --cui-accordion-inner-border-radius: calc(var(--cui-border-radius) - (var(--cui-border-width)));
  --cui-accordion-btn-padding-x: 1.25rem;
  --cui-accordion-btn-padding-y: 1rem;
  --cui-accordion-btn-color: var(--cui-body-color);
  --cui-accordion-btn-bg: var(--cui-accordion-bg);
  --cui-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --cui-accordion-btn-icon-width: 1.25rem;
  --cui-accordion-btn-icon-transform: rotate(-180deg);
  --cui-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --cui-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  --cui-accordion-btn-focus-border-color: #87bbb7;
  --cui-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(15, 118, 110, 0.25);
  --cui-accordion-body-padding-x: 1.25rem;
  --cui-accordion-body-padding-y: 1rem;
  --cui-accordion-active-color: #0e6a63;
  --cui-accordion-active-bg: #e7f1f1;
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--cui-accordion-btn-padding-y) var(--cui-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--cui-accordion-btn-color);
  text-align: left;
  background-color: var(--cui-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--cui-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--cui-accordion-active-color);
  background-color: var(--cui-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--cui-accordion-border-width)) 0 var(--cui-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--cui-accordion-btn-active-icon);
  transform: var(--cui-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--cui-accordion-btn-icon-width);
  height: var(--cui-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--cui-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--cui-accordion-btn-icon-width);
  transition: var(--cui-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: var(--cui-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--cui-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--cui-accordion-color);
  background-color: var(--cui-accordion-bg);
  border: var(--cui-accordion-border-width) solid var(--cui-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--cui-accordion-border-radius);
  border-top-right-radius: var(--cui-accordion-border-radius);
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--cui-accordion-inner-border-radius);
  border-top-right-radius: var(--cui-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--cui-accordion-border-radius);
  border-bottom-left-radius: var(--cui-accordion-border-radius);
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--cui-accordion-inner-border-radius);
  border-bottom-left-radius: var(--cui-accordion-inner-border-radius);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--cui-accordion-border-radius);
  border-bottom-left-radius: var(--cui-accordion-border-radius);
}

.accordion-body {
  padding: var(--cui-accordion-body-padding-y) var(--cui-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}

.breadcrumb {
  --cui-breadcrumb-padding-x: 0;
  --cui-breadcrumb-padding-y: 0;
  --cui-breadcrumb-margin-bottom: 1rem;
  --cui-breadcrumb-bg: ;
  --cui-breadcrumb-border-radius: ;
  --cui-breadcrumb-divider-color: var(--cui-secondary-color);
  --cui-breadcrumb-item-padding-x: 0.5rem;
  --cui-breadcrumb-item-active-color: #5d697e;
  display: flex;
  flex-wrap: wrap;
  padding: var(--cui-breadcrumb-padding-y) var(--cui-breadcrumb-padding-x);
  margin-bottom: var(--cui-breadcrumb-margin-bottom);
  font-size: var(--cui-breadcrumb-font-size);
  list-style: none;
  background-color: var(--cui-breadcrumb-bg);
  border-radius: var(--cui-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--cui-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--cui-breadcrumb-item-padding-x);
  color: var(--cui-breadcrumb-divider-color);
  content: var(--cui-breadcrumb-divider, "/");
}
.breadcrumb-item.active {
  color: var(--cui-breadcrumb-item-active-color);
}

.pagination {
  --cui-pagination-padding-x: 0.75rem;
  --cui-pagination-padding-y: 0.375rem;
  --cui-pagination-font-size: 1rem;
  --cui-pagination-color: var(--cui-link-color);
  --cui-pagination-bg: var(--cui-body-bg);
  --cui-pagination-border-width: var(--cui-border-width);
  --cui-pagination-border-color: var(--cui-border-color);
  --cui-pagination-border-radius: var(--cui-border-radius);
  --cui-pagination-hover-color: var(--cui-link-hover-color);
  --cui-pagination-hover-bg: var(--cui-tertiary-bg);
  --cui-pagination-hover-border-color: var(--cui-border-color);
  --cui-pagination-focus-color: var(--cui-link-hover-color);
  --cui-pagination-focus-bg: var(--cui-secondary-bg);
  --cui-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(15, 118, 110, 0.25);
  --cui-pagination-active-color: rgba(255, 255, 255, 0.87);
  --cui-pagination-active-bg: #0f766e;
  --cui-pagination-active-border-color: #0f766e;
  --cui-pagination-disabled-color: var(--cui-secondary-color);
  --cui-pagination-disabled-bg: var(--cui-secondary-bg);
  --cui-pagination-disabled-border-color: var(--cui-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--cui-pagination-padding-y) var(--cui-pagination-padding-x);
  font-size: var(--cui-pagination-font-size);
  color: var(--cui-pagination-color);
  text-decoration: none;
  background-color: var(--cui-pagination-bg);
  border: var(--cui-pagination-border-width) solid var(--cui-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--cui-pagination-hover-color);
  background-color: var(--cui-pagination-hover-bg);
  border-color: var(--cui-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--cui-pagination-focus-color);
  background-color: var(--cui-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--cui-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--cui-pagination-active-color);
  background-color: var(--cui-pagination-active-bg);
  background-image: var(--cui-gradient);
  border-color: var(--cui-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--cui-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--cui-pagination-disabled-bg);
  border-color: var(--cui-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(var(--cui-border-width) * -1);
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--cui-pagination-border-radius);
  border-bottom-left-radius: var(--cui-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--cui-pagination-border-radius);
  border-bottom-right-radius: var(--cui-pagination-border-radius);
}

.pagination-lg {
  --cui-pagination-padding-x: 1.5rem;
  --cui-pagination-padding-y: 0.75rem;
  --cui-pagination-font-size: 1.25rem;
  --cui-pagination-border-radius: var(--cui-border-radius-lg);
}

.pagination-sm {
  --cui-pagination-padding-x: 0.5rem;
  --cui-pagination-padding-y: 0.25rem;
  --cui-pagination-font-size: 0.875rem;
  --cui-pagination-border-radius: var(--cui-border-radius-sm);
}

.badge {
  --cui-badge-padding-x: 0.65em;
  --cui-badge-padding-y: 0.35em;
  --cui-badge-font-size: 0.75em;
  --cui-badge-font-weight: 700;
  --cui-badge-color: rgba(255, 255, 255, 0.87);
  --cui-badge-border-radius: var(--cui-border-radius);
  display: inline-block;
  padding: var(--cui-badge-padding-y) var(--cui-badge-padding-x);
  font-size: var(--cui-badge-font-size);
  font-weight: var(--cui-badge-font-weight);
  line-height: 1;
  color: var(--cui-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--cui-badge-border-radius, 0);
  background-image: var(--cui-gradient);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-sm {
  --cui-badge-padding-x: 0.5em;
  --cui-badge-padding-y: 0.3em;
  font-size: 0.65em;
}

.alert {
  --cui-alert-bg: transparent;
  --cui-alert-padding-x: 1rem;
  --cui-alert-padding-y: 1rem;
  --cui-alert-margin-bottom: 1rem;
  --cui-alert-color: inherit;
  --cui-alert-border-color: transparent;
  --cui-alert-border: var(--cui-border-width) solid var(--cui-alert-border-color);
  --cui-alert-border-radius: var(--cui-border-radius);
  --cui-alert-link-color: inherit;
  position: relative;
  padding: var(--cui-alert-padding-y) var(--cui-alert-padding-x);
  margin-bottom: var(--cui-alert-margin-bottom);
  color: var(--cui-alert-color);
  background-color: var(--cui-alert-bg);
  border: var(--cui-alert-border);
  border-radius: var(--cui-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--cui-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --cui-alert-color: #094742;
  --cui-alert-bg: #cfe4e2;
  --cui-alert-border-color: #b7d6d4;
  --cui-alert-link-color: #073935;
}

.alert-secondary {
  --cui-alert-color: #5e636a;
  --cui-alert-bg: #ebedef;
  --cui-alert-border-color: #e2e4e8;
  --cui-alert-link-color: #4b4f55;
}

.alert-success {
  --cui-alert-color: #1c6e37;
  --cui-alert-bg: #d5f1de;
  --cui-alert-border-color: #c0eace;
  --cui-alert-link-color: #16582c;
}

.alert-info {
  --cui-alert-color: #1f5c99;
  --cui-alert-bg: #d6ebff;
  --cui-alert-border-color: #c2e0ff;
  --cui-alert-link-color: #194a7a;
}

.alert-warning {
  --cui-alert-color: #956a0d;
  --cui-alert-bg: #feefd0;
  --cui-alert-border-color: #fde8b9;
  --cui-alert-link-color: #77550a;
}

.alert-danger {
  --cui-alert-color: #893232;
  --cui-alert-bg: #fadddd;
  --cui-alert-border-color: #f7cbcb;
  --cui-alert-link-color: #6e2828;
}

.alert-light {
  --cui-alert-color: #8d8e8f;
  --cui-alert-bg: #fbfbfc;
  --cui-alert-border-color: #f9fafa;
  --cui-alert-link-color: #717272;
}

.alert-dark {
  --cui-alert-color: #2f3845;
  --cui-alert-bg: #dcdfe3;
  --cui-alert-border-color: #caced5;
  --cui-alert-link-color: #262d37;
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --cui-progress-height: 1rem;
  --cui-progress-font-size: 0.75rem;
  --cui-progress-bg: var(--cui-secondary-bg);
  --cui-progress-border-radius: var(--cui-border-radius);
  --cui-progress-box-shadow: var(--cui-box-shadow-inset);
  --cui-progress-bar-color: rgba(255, 255, 255, 0.87);
  --cui-progress-bar-bg: var(--cui-primary);
  --cui-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--cui-progress-height);
  overflow: hidden;
  font-size: var(--cui-progress-font-size);
  background-color: var(--cui-progress-bg);
  border-radius: var(--cui-progress-border-radius);
  box-shadow: var(--cui-progress-box-shadow);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--cui-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--cui-progress-bar-bg);
  transition: var(--cui-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--cui-progress-height) var(--cui-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.progress-thin {
  height: 4px;
}

.progress.progress-white {
  background-color: rgba(255, 255, 255, 0.2);
}
.progress.progress-white .progress-bar {
  background-color: #fff;
}

.progress-group {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 1rem;
}

.progress-group-prepend {
  flex: 0 0 100px;
  align-self: center;
}

.progress-group-header {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  margin-bottom: 0.25rem;
}

.progress-group-bars {
  flex-grow: 1;
  align-self: center;
}
.progress-group-bars .progress:not(:last-child) {
  margin-bottom: 2px;
}

.progress-group-header + .progress-group-bars {
  flex-basis: 100%;
}

.list-group {
  --cui-list-group-color: var(--cui-body-color);
  --cui-list-group-bg: var(--cui-body-bg);
  --cui-list-group-border-color: var(--cui-border-color);
  --cui-list-group-border-width: var(--cui-border-width);
  --cui-list-group-border-radius: var(--cui-border-radius);
  --cui-list-group-item-padding-x: 1rem;
  --cui-list-group-item-padding-y: 0.5rem;
  --cui-list-group-action-color: var(--cui-secondary-color);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-tertiary-bg);
  --cui-list-group-action-active-color: var(--cui-body-color);
  --cui-list-group-action-active-bg: var(--cui-secondary-bg);
  --cui-list-group-disabled-color: var(--cui-secondary-color);
  --cui-list-group-disabled-bg: var(--cui-body-bg);
  --cui-list-group-active-color: rgba(255, 255, 255, 0.87);
  --cui-list-group-active-bg: #0f766e;
  --cui-list-group-active-border-color: #0f766e;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--cui-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--cui-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--cui-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--cui-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--cui-list-group-action-active-color);
  background-color: var(--cui-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--cui-list-group-item-padding-y) var(--cui-list-group-item-padding-x);
  color: var(--cui-list-group-color);
  text-decoration: none;
  background-color: var(--cui-list-group-bg);
  border: var(--cui-list-group-border-width) solid var(--cui-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--cui-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--cui-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--cui-list-group-active-color);
  background-color: var(--cui-list-group-active-bg);
  border-color: var(--cui-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--cui-list-group-border-width));
  border-top-width: var(--cui-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--cui-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--cui-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--cui-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--cui-list-group-border-width));
  border-left-width: var(--cui-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
    border-left-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
    border-left-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
    border-left-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
    border-left-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
    border-left-width: var(--cui-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--cui-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --cui-list-group-color: contrast-ratio-correction(#094742, #cfe4e2, 40%, "primary");
  --cui-list-group-bg: #cfe4e2;
  --cui-list-group-hover-bg: #0e6a63;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#094742, #cfe4e2, 40%, "primary");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#094742, #cfe4e2, 40%, "primary");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#094742, #cfe4e2, 40%, "primary");
}

.list-group-item-secondary {
  --cui-list-group-color: contrast-ratio-correction(#5e636a, #ebedef, 40%, "secondary");
  --cui-list-group-bg: #ebedef;
  --cui-list-group-hover-bg: #8d959f;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#5e636a, #ebedef, 40%, "secondary");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#5e636a, #ebedef, 40%, "secondary");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#5e636a, #ebedef, 40%, "secondary");
}

.list-group-item-success {
  --cui-list-group-color: contrast-ratio-correction(#1c6e37, #d5f1de, 40%, "success");
  --cui-list-group-bg: #d5f1de;
  --cui-list-group-hover-bg: #29a653;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#1c6e37, #d5f1de, 40%, "success");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#1c6e37, #d5f1de, 40%, "success");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#1c6e37, #d5f1de, 40%, "success");
}

.list-group-item-danger {
  --cui-list-group-color: contrast-ratio-correction(#893232, #fadddd, 40%, "danger");
  --cui-list-group-bg: #fadddd;
  --cui-list-group-hover-bg: #ce4b4b;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#893232, #fadddd, 40%, "danger");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#893232, #fadddd, 40%, "danger");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#893232, #fadddd, 40%, "danger");
}

.list-group-item-warning {
  --cui-list-group-color: contrast-ratio-correction(#956a0d, #feefd0, 40%, "warning");
  --cui-list-group-bg: #feefd0;
  --cui-list-group-hover-bg: #e09f13;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#956a0d, #feefd0, 40%, "warning");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#956a0d, #feefd0, 40%, "warning");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#956a0d, #feefd0, 40%, "warning");
}

.list-group-item-info {
  --cui-list-group-color: contrast-ratio-correction(#1f5c99, #d6ebff, 40%, "info");
  --cui-list-group-bg: #d6ebff;
  --cui-list-group-hover-bg: #2e8ae6;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#1f5c99, #d6ebff, 40%, "info");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#1f5c99, #d6ebff, 40%, "info");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#1f5c99, #d6ebff, 40%, "info");
}

.list-group-item-light {
  --cui-list-group-color: contrast-ratio-correction(#8d8e8f, #fbfbfc, 40%, "light");
  --cui-list-group-bg: #fbfbfc;
  --cui-list-group-hover-bg: #d4d5d7;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#8d8e8f, #fbfbfc, 40%, "light");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#8d8e8f, #fbfbfc, 40%, "light");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#8d8e8f, #fbfbfc, 40%, "light");
}

.list-group-item-dark {
  --cui-list-group-color: contrast-ratio-correction(#2f3845, #dcdfe3, 40%, "dark");
  --cui-list-group-bg: #dcdfe3;
  --cui-list-group-hover-bg: #475468;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#2f3845, #dcdfe3, 40%, "dark");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#2f3845, #dcdfe3, 40%, "dark");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#2f3845, #dcdfe3, 40%, "dark");
}

.btn-close {
  --cui-btn-close-color: rgba(44, 56, 74, 0.95);
  --cui-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --cui-btn-close-opacity: 0.5;
  --cui-btn-close-hover-opacity: 0.75;
  --cui-btn-close-focus-shadow: 0 0 0 0.25rem rgba(15, 118, 110, 0.25);
  --cui-btn-close-focus-opacity: 1;
  --cui-btn-close-disabled-opacity: 0.25;
  --cui-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--cui-btn-close-color);
  background: transparent var(--cui-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--cui-btn-close-opacity);
}
.btn-close:hover {
  color: var(--cui-btn-close-color);
  text-decoration: none;
  opacity: var(--cui-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--cui-btn-close-focus-shadow);
  opacity: var(--cui-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--cui-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--cui-btn-close-white-filter);
}

.toast {
  --cui-toast-zindex: 1090;
  --cui-toast-padding-x: 0.75rem;
  --cui-toast-padding-y: 0.5rem;
  --cui-toast-spacing: 1.5rem;
  --cui-toast-max-width: 350px;
  --cui-toast-font-size: 0.875rem;
  --cui-toast-color: ;
  --cui-toast-bg: rgba(var(--cui-body-bg-rgb), 0.85);
  --cui-toast-border-width: var(--cui-border-width);
  --cui-toast-border-color: var(--cui-border-color-translucent);
  --cui-toast-border-radius: var(--cui-border-radius);
  --cui-toast-box-shadow: var(--cui-box-shadow);
  --cui-toast-header-color: var(--cui-secondary-color);
  --cui-toast-header-bg: rgba(var(--cui-body-bg-rgb), 0.85);
  --cui-toast-header-border-color: var(--cui-border-color-translucent);
  width: var(--cui-toast-max-width);
  max-width: 100%;
  font-size: var(--cui-toast-font-size);
  color: var(--cui-toast-color);
  pointer-events: auto;
  background-color: var(--cui-toast-bg);
  background-clip: padding-box;
  border: var(--cui-toast-border-width) solid var(--cui-toast-border-color);
  box-shadow: var(--cui-toast-box-shadow);
  border-radius: var(--cui-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --cui-toast-zindex: 1090;
  position: absolute;
  z-index: var(--cui-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--cui-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--cui-toast-padding-y) var(--cui-toast-padding-x);
  color: var(--cui-toast-header-color);
  background-color: var(--cui-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--cui-toast-border-width) solid var(--cui-toast-header-border-color);
  border-top-left-radius: calc(var(--cui-toast-border-radius) - var(--cui-toast-border-width));
  border-top-right-radius: calc(var(--cui-toast-border-radius) - var(--cui-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--cui-toast-padding-x));
  margin-left: var(--cui-toast-padding-x);
}

.toast-body {
  padding: var(--cui-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --cui-modal-zindex: 1055;
  --cui-modal-width: 500px;
  --cui-modal-padding: 1rem;
  --cui-modal-margin: 0.5rem;
  --cui-modal-color: ;
  --cui-modal-bg: var(--cui-body-bg);
  --cui-modal-border-color: var(--cui-border-color-translucent);
  --cui-modal-border-width: var(--cui-border-width);
  --cui-modal-border-radius: var(--cui-border-radius-lg);
  --cui-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 21, 0.075);
  --cui-modal-inner-border-radius: calc(var(--cui-border-radius-lg) - (var(--cui-border-width)));
  --cui-modal-header-padding-x: 1rem;
  --cui-modal-header-padding-y: 1rem;
  --cui-modal-header-padding: 1rem 1rem;
  --cui-modal-header-border-color: var(--cui-border-color);
  --cui-modal-header-border-width: var(--cui-border-width);
  --cui-modal-title-line-height: 1.5;
  --cui-modal-footer-gap: 0.5rem;
  --cui-modal-footer-bg: ;
  --cui-modal-footer-border-color: var(--cui-border-color);
  --cui-modal-footer-border-width: var(--cui-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--cui-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--cui-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--cui-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--cui-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--cui-modal-color);
  pointer-events: auto;
  background-color: var(--cui-modal-bg);
  background-clip: padding-box;
  border: var(--cui-modal-border-width) solid var(--cui-modal-border-color);
  border-radius: var(--cui-modal-border-radius);
  box-shadow: var(--cui-modal-box-shadow);
  outline: 0;
}

.modal-backdrop {
  --cui-backdrop-zindex: 1050;
  --cui-backdrop-bg: #000015;
  --cui-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--cui-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--cui-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--cui-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-modal-header-padding);
  border-bottom: var(--cui-modal-header-border-width) solid var(--cui-modal-header-border-color);
  border-top-left-radius: var(--cui-modal-inner-border-radius);
  border-top-right-radius: var(--cui-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--cui-modal-header-padding-y) * 0.5) calc(var(--cui-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--cui-modal-header-padding-y)) calc(-0.5 * var(--cui-modal-header-padding-x)) calc(-0.5 * var(--cui-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--cui-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--cui-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--cui-modal-padding) - var(--cui-modal-footer-gap) * 0.5);
  background-color: var(--cui-modal-footer-bg);
  border-top: var(--cui-modal-footer-border-width) solid var(--cui-modal-footer-border-color);
  border-bottom-right-radius: var(--cui-modal-inner-border-radius);
  border-bottom-left-radius: var(--cui-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--cui-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --cui-modal-margin: 1.75rem;
    --cui-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 21, 0.15);
  }
  .modal-dialog {
    max-width: var(--cui-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --cui-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --cui-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --cui-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --cui-tooltip-zindex: 1080;
  --cui-tooltip-max-width: 200px;
  --cui-tooltip-padding-x: 0.5rem;
  --cui-tooltip-padding-y: 0.25rem;
  --cui-tooltip-margin: ;
  --cui-tooltip-font-size: 0.875rem;
  --cui-tooltip-color: var(--cui-body-bg);
  --cui-tooltip-bg: var(--cui-emphasis-color);
  --cui-tooltip-border-radius: var(--cui-border-radius);
  --cui-tooltip-opacity: 0.9;
  --cui-tooltip-arrow-width: 0.8rem;
  --cui-tooltip-arrow-height: 0.4rem;
  z-index: var(--cui-tooltip-zindex);
  display: block;
  margin: var(--cui-tooltip-margin);
  font-family: var(--cui-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--cui-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--cui-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--cui-tooltip-arrow-width);
  height: var(--cui-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--cui-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--cui-tooltip-arrow-height) calc(var(--cui-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--cui-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--cui-tooltip-arrow-height));
  width: var(--cui-tooltip-arrow-height);
  height: var(--cui-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--cui-tooltip-arrow-width) * 0.5) var(--cui-tooltip-arrow-height) calc(var(--cui-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--cui-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--cui-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--cui-tooltip-arrow-width) * 0.5) var(--cui-tooltip-arrow-height);
  border-bottom-color: var(--cui-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--cui-tooltip-arrow-height));
  width: var(--cui-tooltip-arrow-height);
  height: var(--cui-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--cui-tooltip-arrow-width) * 0.5) 0 calc(var(--cui-tooltip-arrow-width) * 0.5) var(--cui-tooltip-arrow-height);
  border-left-color: var(--cui-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--cui-tooltip-max-width);
  padding: var(--cui-tooltip-padding-y) var(--cui-tooltip-padding-x);
  color: var(--cui-tooltip-color);
  text-align: center;
  background-color: var(--cui-tooltip-bg);
  border-radius: var(--cui-tooltip-border-radius);
}

.popover {
  --cui-popover-zindex: 1070;
  --cui-popover-max-width: 276px;
  --cui-popover-font-size: 0.875rem;
  --cui-popover-bg: var(--cui-body-bg);
  --cui-popover-border-width: var(--cui-border-width);
  --cui-popover-border-color: var(--cui-border-color-translucent);
  --cui-popover-border-radius: var(--cui-border-radius-lg);
  --cui-popover-inner-border-radius: calc(var(--cui-border-radius-lg) - var(--cui-border-width));
  --cui-popover-box-shadow: 0 0.5rem 1rem rgba(0, 0, 21, 0.15);
  --cui-popover-header-padding-x: 1rem;
  --cui-popover-header-padding-y: 0.5rem;
  --cui-popover-header-font-size: 1rem;
  --cui-popover-header-color: inherit;
  --cui-popover-header-bg: var(--cui-secondary-bg);
  --cui-popover-body-padding-x: 1rem;
  --cui-popover-body-padding-y: 1rem;
  --cui-popover-body-color: var(--cui-body-color);
  --cui-popover-arrow-width: 1rem;
  --cui-popover-arrow-height: 0.5rem;
  --cui-popover-arrow-border: var(--cui-popover-border-color);
  z-index: var(--cui-popover-zindex);
  display: block;
  max-width: var(--cui-popover-max-width);
  font-family: var(--cui-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--cui-popover-font-size);
  word-wrap: break-word;
  background-color: var(--cui-popover-bg);
  background-clip: padding-box;
  border: var(--cui-popover-border-width) solid var(--cui-popover-border-color);
  border-radius: var(--cui-popover-border-radius);
  box-shadow: var(--cui-popover-box-shadow);
}
.popover .popover-arrow {
  display: block;
  width: var(--cui-popover-arrow-width);
  height: var(--cui-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--cui-popover-arrow-height) calc(var(--cui-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--cui-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--cui-popover-border-width);
  border-top-color: var(--cui-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
  width: var(--cui-popover-arrow-height);
  height: var(--cui-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--cui-popover-arrow-width) * 0.5) var(--cui-popover-arrow-height) calc(var(--cui-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--cui-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--cui-popover-border-width);
  border-right-color: var(--cui-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--cui-popover-arrow-width) * 0.5) var(--cui-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--cui-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--cui-popover-border-width);
  border-bottom-color: var(--cui-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--cui-popover-arrow-width);
  margin-left: calc(-0.5 * var(--cui-popover-arrow-width));
  content: "";
  border-bottom: var(--cui-popover-border-width) solid var(--cui-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
  width: var(--cui-popover-arrow-height);
  height: var(--cui-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--cui-popover-arrow-width) * 0.5) 0 calc(var(--cui-popover-arrow-width) * 0.5) var(--cui-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--cui-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--cui-popover-border-width);
  border-left-color: var(--cui-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--cui-popover-header-padding-y) var(--cui-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--cui-popover-header-font-size);
  color: var(--cui-popover-header-color);
  background-color: var(--cui-popover-header-bg);
  border-bottom: var(--cui-popover-border-width) solid var(--cui-popover-border-color);
  border-top-left-radius: var(--cui-popover-inner-border-radius);
  border-top-right-radius: var(--cui-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--cui-popover-body-padding-y) var(--cui-popover-body-padding-x);
  color: var(--cui-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: var(--cui-carousel-control-color, rgba(255, 255, 255, 0.87));
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: var(--cui-carousel-control-color, rgba(255, 255, 255, 0.87));
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
  background-image: linear-gradient(90deg, rgba(0, 0, 21, 0.25), rgba(0, 0, 21, 0.001));
}

.carousel-control-next {
  right: 0;
  background-image: linear-gradient(270deg, rgba(0, 0, 21, 0.25), rgba(0, 0, 21, 0.001));
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators [data-coreui-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: var(--cui-carousel-indicator-active-bg, #fff);
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-coreui-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--cui-carousel-caption-color, rgba(255, 255, 255, 0.87));
  text-align: center;
}

.carousel-dark {
  --cui-carousel-indicator-active-bg: #000015;
  --cui-carousel-caption-color: rgba(44, 56, 74, 0.95);
}
.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-coreui-target] {
  background-color: #000015;
}
.carousel-dark .carousel-caption {
  color: rgba(44, 56, 74, 0.95);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--cui-spinner-width);
  height: var(--cui-spinner-height);
  vertical-align: var(--cui-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--cui-spinner-animation-speed) linear infinite var(--cui-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --cui-spinner-width: 2rem;
  --cui-spinner-height: 2rem;
  --cui-spinner-vertical-align: -0.125em;
  --cui-spinner-border-width: 0.25em;
  --cui-spinner-animation-speed: 0.75s;
  --cui-spinner-animation-name: spinner-border;
  border: var(--cui-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --cui-spinner-width: 1rem;
  --cui-spinner-height: 1rem;
  --cui-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --cui-spinner-width: 2rem;
  --cui-spinner-height: 2rem;
  --cui-spinner-vertical-align: -0.125em;
  --cui-spinner-animation-speed: 0.75s;
  --cui-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --cui-spinner-width: 1rem;
  --cui-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --cui-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --cui-offcanvas-zindex: 1045;
  --cui-offcanvas-width: 400px;
  --cui-offcanvas-height: 30vh;
  --cui-offcanvas-padding-x: 1rem;
  --cui-offcanvas-padding-y: 1rem;
  --cui-offcanvas-color: var(--cui-body-color);
  --cui-offcanvas-bg: var(--cui-body-bg);
  --cui-offcanvas-border-width: var(--cui-border-width);
  --cui-offcanvas-border-color: var(--cui-border-color-translucent);
  --cui-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 21, 0.075);
  --cui-offcanvas-transition: transform 0.3s ease-in-out;
  --cui-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--cui-offcanvas-box-shadow);
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--cui-offcanvas-width);
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--cui-offcanvas-width);
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--cui-offcanvas-box-shadow);
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--cui-offcanvas-width);
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--cui-offcanvas-width);
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--cui-offcanvas-box-shadow);
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--cui-offcanvas-width);
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--cui-offcanvas-width);
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--cui-offcanvas-box-shadow);
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--cui-offcanvas-width);
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--cui-offcanvas-width);
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--cui-offcanvas-box-shadow);
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--cui-offcanvas-width);
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--cui-offcanvas-width);
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--cui-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--cui-offcanvas-color);
  visibility: hidden;
  background-color: var(--cui-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  box-shadow: var(--cui-offcanvas-box-shadow);
  transition: var(--cui-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--cui-offcanvas-width);
  border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--cui-offcanvas-width);
  border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--cui-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--cui-offcanvas-height);
  max-height: 100%;
  border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none !important;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: var(--cui-offcanvas-backdrop-bg, #000015);
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-offcanvas-padding-y) var(--cui-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--cui-offcanvas-padding-y) * 0.5) calc(var(--cui-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--cui-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--cui-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--cui-offcanvas-padding-y));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--cui-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--cui-offcanvas-padding-y) var(--cui-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000015 55%, rgba(0, 0, 0, 0.8) 75%, #000015 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.avatar {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  border-radius: 50em;
  transition: margin 0.15s;
  width: 2rem;
  height: 2rem;
  font-size: 0.8rem;
}
@media (prefers-reduced-motion: reduce) {
  .avatar {
    transition: none;
  }
}
.avatar .avatar-status {
  width: 0.5333333333rem;
  height: 0.5333333333rem;
}

.avatar-img {
  width: 100%;
  height: auto;
  border-radius: 50em;
}

.avatar-status {
  position: absolute;
  right: 0;
  bottom: 0;
  display: block;
  border: 1px solid #fff;
  border-radius: 50em;
}

.avatar-sm {
  width: 1.5rem;
  height: 1.5rem;
  font-size: 0.6rem;
}
.avatar-sm .avatar-status {
  width: 0.4rem;
  height: 0.4rem;
}

.avatar-md {
  width: 2.5rem;
  height: 2.5rem;
  font-size: 1rem;
}
.avatar-md .avatar-status {
  width: 0.6666666667rem;
  height: 0.6666666667rem;
}

.avatar-lg {
  width: 3rem;
  height: 3rem;
  font-size: 1.2rem;
}
.avatar-lg .avatar-status {
  width: 0.8rem;
  height: 0.8rem;
}

.avatar-xl {
  width: 4rem;
  height: 4rem;
  font-size: 1.6rem;
}
.avatar-xl .avatar-status {
  width: 1.0666666667rem;
  height: 1.0666666667rem;
}

.avatars-stack {
  display: flex;
}
.avatars-stack .avatar {
  margin-right: -0.8rem;
}
.avatars-stack .avatar:hover {
  margin-right: 0;
}
.avatars-stack .avatar-sm {
  margin-right: -0.6rem;
}
.avatars-stack .avatar-md {
  margin-right: -1rem;
}
.avatars-stack .avatar-lg {
  margin-right: -1.2rem;
}
.avatars-stack .avatar-xl {
  margin-right: -1.6rem;
}

.callout {
  --cui-callout-padding-x: 1rem;
  --cui-callout-padding-y: 1rem;
  --cui-callout-margin-x: 0;
  --cui-callout-margin-y: 1rem;
  --cui-callout-border-width: var(--cui-border-width);
  --cui-callout-border-color: var(--cui-border-color);
  --cui-callout-border-left-width: calc(var(--cui-border-width) * 4);
  --cui-callout-border-radius: var(--cui-border-radius);
  padding: var(--cui-callout-padding-y) var(--cui-callout-padding-x);
  margin: var(--cui-callout-margin-y) var(--cui-callout-margin-x);
  border: var(--cui-callout-border-width) solid var(--cui-callout-border-color);
  border-left-width: var(--cui-callout-border-left-width);
  border-left-color: var(--cui-callout-border-left-color);
  border-radius: var(--cui-callout-border-radius);
}

.callout-primary {
  --cui-callout-border-left-color: #0f766e;
}

.callout-secondary {
  --cui-callout-border-left-color: #9da5b1;
}

.callout-success {
  --cui-callout-border-left-color: #2eb85c;
}

.callout-danger {
  --cui-callout-border-left-color: #e55353;
}

.callout-warning {
  --cui-callout-border-left-color: #f9b115;
}

.callout-info {
  --cui-callout-border-left-color: #39f;
}

.callout-light {
  --cui-callout-border-left-color: #ebedef;
}

.callout-dark {
  --cui-callout-border-left-color: #4f5d73;
}

.footer {
  --cui-footer-min-height: 3rem;
  --cui-footer-padding-x: 1rem;
  --cui-footer-padding-y: 0.5rem;
  --cui-footer-color: var(--cui-body-color);
  --cui-footer-bg: var(--cui-tertiary-bg);
  --cui-footer-border-color: var(--cui-border-color);
  --cui-footer-border: var(--cui-border-width) solid var(--cui-footer-border-color);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  min-height: var(--cui-footer-min-height);
  padding: var(--cui-footer-padding-y) var(--cui-footer-padding-x);
  color: var(--cui-footer-color);
  background: var(--cui-footer-bg);
  border-top: var(--cui-footer-border);
}

.footer-fixed {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
}

.footer-sticky {
  position: sticky;
  bottom: 0;
  z-index: 1000;
}

.header {
  --cui-header-min-height: 4rem;
  --cui-header-padding-x: 0.5rem;
  --cui-header-padding-y: 0.5rem;
  --cui-header-bg: var(--cui-body-bg);
  --cui-header-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-header-border-color: var(--cui-border-color);
  --cui-header-border: var(--cui-border-width) solid var(--cui-header-border-color);
  --cui-header-hover-color: rgba(var(--cui-emphasis-color-rgb), 0.8);
  --cui-header-disabled-color: rgba(var(--cui-emphasis-color-rgb), 0.3);
  --cui-header-active-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-header-brand-padding-y: 0.3125rem;
  --cui-header-brand-color: #4f5d73;
  --cui-header-brand-hover-color: #475468;
  --cui-header-toggler-padding-x: 0.75rem;
  --cui-header-toggler-padding-y: 0.25rem;
  --cui-header-toggler-bg: transparent;
  --cui-header-toggler-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-header-toggler-border-radius: var(--cui-border-radius);
  --cui-header-toggler-hover-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-header-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --cui-header-toggler-hover-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --cui-header-nav-link-padding-x: 0.5rem;
  --cui-header-nav-link-padding-y: 0.5rem;
  --cui-header-divider-border-color: var(--cui-border-color);
  --cui-header-divider-border: var(--cui-border-width) solid var(--cui-header-divider-border-color);
  --cui-subheader-min-height: 3rem;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  min-height: var(--cui-header-min-height);
  padding: var(--cui-header-padding-y) var(--cui-header-padding-x);
  background: var(--cui-header-bg);
  border-bottom: var(--cui-header-border);
}
.header > .container,
.header > .container-fluid,
.header > .container-sm,
.header > .container-md,
.header > .container-lg,
.header > .container-xl,
.header > .container-xxl, .header .navbar > .container,
.header .navbar > .container-fluid,
.header .navbar > .container-sm,
.header .navbar > .container-md,
.header .navbar > .container-lg,
.header .navbar > .container-xl,
.header .navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.header .container:first-child,
.header .container-fluid:first-child,
.header .container-sm:first-child,
.header .container-md:first-child,
.header .container-lg:first-child,
.header .container-xl:first-child,
.header .container-xxl:first-child {
  min-height: calc(var(--cui-header-min-height) - 2 * var(--cui-header-padding-y));
}
.header .container:nth-child(n+2),
.header .container-fluid:nth-child(n+2),
.header .container-sm:nth-child(n+2),
.header .container-md:nth-child(n+2),
.header .container-lg:nth-child(n+2),
.header .container-xl:nth-child(n+2),
.header .container-xxl:nth-child(n+2) {
  min-height: calc(var(--cui-subheader-min-height) - 2 * var(--cui-header-padding-y));
}
.header.header-sticky {
  position: sticky;
  top: 0;
  z-index: 999;
}

.header-divider {
  flex-basis: calc(100% + 2 * var(--cui-header-padding-x));
  height: 0;
  margin: var(--cui-header-padding-y) calc(var(--cui-header-padding-x) * -1);
  border-top: var(--cui-header-divider-border);
}

.header-brand {
  padding-top: var(--cui-header-brand-padding-y);
  padding-bottom: var(--cui-header-brand-padding-y);
  margin-right: 1rem;
  font-size: 1.25rem;
  color: var(--cui-header-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.header-brand:hover, .header-brand:focus {
  color: var(--cui-header-brand-hover-color);
}

.header-nav {
  display: flex;
  flex-direction: row;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.header-nav .nav-link {
  padding: var(--cui-header-nav-link-padding-y) var(--cui-header-nav-link-padding-x);
  color: var(--cui-header-color);
}
.header-nav .nav-link:hover, .header-nav .nav-link:focus {
  color: var(--cui-header-hover-color);
}
.header-nav .nav-link.disabled {
  color: var(--cui-header-disabled-color);
}
.header-nav .show > .nav-link,
.header-nav .nav-link.active {
  color: var(--cui-header-active-color);
}
.header-nav .dropdown-menu {
  position: absolute;
}

.header-text {
  padding-top: var(--cui-header-nav-link-padding-y);
  padding-bottom: var(--cui-header-nav-link-padding-y);
  color: var(--cui-header-color);
}
.header-text a {
  color: var(--cui-header-active-color);
}
.header-text a:hover, .header-text a:focus {
  color: var(--cui-header-active-color);
}

.header-toggler {
  padding: var(--cui-header-toggler-padding-y) var(--cui-header-toggler-padding-x);
  font-size: 1.25rem;
  color: var(--cui-header-toggler-color);
  background-color: var(--cui-header-toggler-bg);
  border: 0;
  border-radius: var(--cui-header-toggler-border-radius);
}
.header-toggler:hover {
  color: var(--cui-header-toggler-hover-color);
  text-decoration: none;
}
.header-toggler:focus {
  outline: 0;
}
.header-toggler:not(:disabled) {
  cursor: pointer;
}

.header-toggler-icon {
  display: block;
  height: 1.5625rem;
  background-image: var(--cui-header-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
}
.header-toggler-icon:hover {
  background-image: var(--cui-header-toggler-hover-icon-bg);
}

.icon {
  display: inline-block;
  color: inherit;
  text-align: center;
  vertical-align: -0.125rem;
  fill: currentcolor;
}
.icon:not(.icon-c-s):not(.icon-custom-size) {
  width: 1rem;
  height: 1rem;
  font-size: 1rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-xxl {
  width: 2rem;
  height: 2rem;
  font-size: 2rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-xl {
  width: 1.5rem;
  height: 1.5rem;
  font-size: 1.5rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-lg {
  width: 1.25rem;
  height: 1.25rem;
  font-size: 1.25rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-sm {
  width: 0.875rem;
  height: 0.875rem;
  font-size: 0.875rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-3xl {
  width: 3rem;
  height: 3rem;
  font-size: 3rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-4xl {
  width: 4rem;
  height: 4rem;
  font-size: 4rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-5xl {
  width: 5rem;
  height: 5rem;
  font-size: 5rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-6xl {
  width: 6rem;
  height: 6rem;
  font-size: 6rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-7xl {
  width: 7rem;
  height: 7rem;
  font-size: 7rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-8xl {
  width: 8rem;
  height: 8rem;
  font-size: 8rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-9xl {
  width: 9rem;
  height: 9rem;
  font-size: 9rem;
}

.sidebar {
  --cui-sidebar-width: 16rem;
  --cui-sidebar-bg: #3c4b64;
  --cui-sidebar-padding-x: 0;
  --cui-sidebar-padding-y: 0;
  --cui-sidebar-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-border-width: 0;
  --cui-sidebar-border-color: transparent;
  --cui-sidebar-brand-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-brand-height: 4rem;
  --cui-sidebar-brand-bg: rgba(0, 0, 21, 0.2);
  --cui-sidebar-header-height: 4rem;
  --cui-sidebar-header-bg: rgba(0, 0, 21, 0.2);
  --cui-sidebar-header-padding-x: 1rem;
  --cui-sidebar-header-padding-y: 0.75rem;
  --cui-sidebar-footer-bg: rgba(0, 0, 21, 0.2);
  --cui-sidebar-footer-height: auto;
  --cui-sidebar-footer-padding-x: 1rem;
  --cui-sidebar-footer-padding-y: 0.75rem;
  --cui-sidebar-toggler-bg: rgba(0, 0, 21, 0.2);
  --cui-sidebar-toggler-height: 3rem;
  --cui-sidebar-toggler-indicator: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  --cui-sidebar-toggler-indicator-width: 4rem;
  --cui-sidebar-toggler-indicator-height: 3rem;
  --cui-sidebar-toggler-hover-bg: rgba(0, 0, 0, 0.3);
  --cui-sidebar-toggler-indicator-hover: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  --cui-sidebar-narrow-width: 4rem;
  --cui-sidebar-nav-title-padding-x: 1rem;
  --cui-sidebar-nav-title-padding-y: 0.75rem;
  --cui-sidebar-nav-title-margin-top: 1rem;
  --cui-sidebar-nav-title-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-link-padding-x: 1rem;
  --cui-sidebar-nav-link-padding-y: 0.8445rem;
  --cui-sidebar-nav-link-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-link-bg: transparent;
  --cui-sidebar-nav-link-border-color: transparent;
  --cui-sidebar-nav-link-border: 0 solid var(--cui-sidebar-nav-link-border-color);
  --cui-sidebar-nav-link-border-radius: 0;
  --cui-sidebar-nav-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-link-active-bg: rgba(255, 255, 255, 0.05);
  --cui-sidebar-nav-link-active-icon-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-link-disabled-color: rgba(255, 255, 255, 0.38);
  --cui-sidebar-nav-link-disabled-icon-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-link-hover-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-link-hover-bg: rgba(255, 255, 255, 0.05);
  --cui-sidebar-nav-link-hover-icon-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-icon-width: 4rem;
  --cui-sidebar-nav-icon-height: 1.25rem;
  --cui-sidebar-nav-icon-font-size: 1.25rem;
  --cui-sidebar-nav-link-icon-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-group-bg: rgba(0, 0, 0, 0.2);
  --cui-sidebar-nav-group-items-padding-y: 0;
  --cui-sidebar-nav-group-items-padding-x: 0;
  --cui-sidebar-nav-group-indicator: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  --cui-sidebar-nav-group-indicator-hover: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  --cui-sidebar-nav-group-toggle-show-color: rgba(255, 255, 255, 0.6);
  position: relative;
  display: flex;
  flex: 0 0 var(--cui-sidebar-width);
  flex-direction: column;
  order: -1;
  width: var(--cui-sidebar-width);
  padding: var(--cui-sidebar-padding-y) var(--cui-sidebar-padding-x);
  color: var(--cui-sidebar-color);
  background: var(--cui-sidebar-bg);
  border-right: var(--cui-sidebar-border-width) solid var(--cui-sidebar-border-color);
  box-shadow: none;
  transition: margin-left 0.15s, margin-right 0.15s, box-shadow 0.075s, transform 0.15s, width 0.15s, z-index 0s ease 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar {
    transition: none;
  }
}
.sidebar:not(.sidebar-end) {
  margin-left: 0;
}
.sidebar:not(.sidebar-end) ~ * {
  --cui-sidebar-occupy-start: 16rem;
}
.sidebar.sidebar-end {
  order: 99;
  margin-right: 0;
}
.sidebar.sidebar-end ~ * {
  --cui-sidebar-occupy-end: 16rem;
}
.sidebar[class*=bg-] {
  border-color: rgba(0, 0, 21, 0.1);
}
.sidebar.sidebar-sm {
  --cui-sidebar-width: 12rem;
}
@media (min-width: 768px) {
  .sidebar.sidebar-sm:not(.sidebar-end):not(.hide) ~ * {
    --cui-sidebar-occupy-start: 12rem;
  }
  .sidebar.sidebar-sm.sidebar-end:not(.hide) ~ * {
    --cui-sidebar-occupy-end: 12rem;
  }
}
.sidebar.sidebar-lg {
  --cui-sidebar-width: 20rem;
}
@media (min-width: 768px) {
  .sidebar.sidebar-lg:not(.sidebar-end):not(.hide) ~ * {
    --cui-sidebar-occupy-start: 20rem;
  }
  .sidebar.sidebar-lg.sidebar-end:not(.hide) ~ * {
    --cui-sidebar-occupy-end: 20rem;
  }
}
.sidebar.sidebar-xl {
  --cui-sidebar-width: 24rem;
}
@media (min-width: 768px) {
  .sidebar.sidebar-xl:not(.sidebar-end):not(.hide) ~ * {
    --cui-sidebar-occupy-start: 24rem;
  }
  .sidebar.sidebar-xl.sidebar-end:not(.hide) ~ * {
    --cui-sidebar-occupy-end: 24rem;
  }
  .sidebar.hide:not(.sidebar-end) {
    margin-left: calc(-1 * var(--cui-sidebar-width));
  }
  .sidebar.hide:not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 0;
  }
  .sidebar.hide.sidebar-end {
    margin-right: calc(-1 * var(--cui-sidebar-width));
  }
  .sidebar.hide.sidebar-end ~ * {
    --cui-sidebar-occupy-end: 0;
  }
  .sidebar.sidebar-fixed {
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 1000;
  }
  .sidebar.sidebar-fixed:not(.sidebar-end) {
    left: 0;
  }
  .sidebar.sidebar-fixed.sidebar-end {
    right: 0;
  }
  .sidebar.sidebar-sticky {
    position: sticky;
    top: 0;
    height: 100vh;
  }
}
.sidebar.sidebar-overlaid {
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 1002;
}
.sidebar.sidebar-overlaid:not(.sidebar-end) {
  left: 0;
}
.sidebar.sidebar-overlaid:not(.sidebar-end) ~ * {
  --cui-sidebar-occupy-start: 0;
}
.sidebar.sidebar-overlaid.sidebar-end {
  right: 0;
}
.sidebar.sidebar-overlaid.sidebar-end ~ * {
  --cui-sidebar-occupy-end: 0;
}
@media (max-width: 767.98px) {
  .sidebar {
    --cui-is-mobile: true;
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 1001;
  }
  .sidebar:not(.sidebar-end) {
    left: 0;
  }
  .sidebar:not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 0 !important;
  }
  .sidebar:not(.sidebar-end):not(.show) {
    margin-left: calc(-1 * var(--cui-sidebar-width));
  }
  .sidebar.sidebar-end {
    right: 0;
  }
  .sidebar.sidebar-end ~ * {
    --cui-sidebar-occupy-end: 0 !important;
  }
  .sidebar.sidebar-end:not(.show) {
    margin-right: calc(-1 * var(--cui-sidebar-width));
  }
}

.sidebar-close {
  position: absolute;
  top: 0;
  right: 0;
  width: var(--cui-sidebar-width);
  height: var(--cui-sidebar-header-height);
  color: var(--cui-sidebar-color);
  background: transparent;
  border: 0;
}
.sidebar-close:hover {
  text-decoration: none;
}
.sidebar-close:focus {
  outline: 0;
}

.sidebar-brand {
  display: flex;
  flex: 0 0 var(--cui-sidebar-brand-height);
  align-items: center;
  justify-content: center;
  color: var(--cui-sidebar-brand-color);
  background: var(--cui-sidebar-brand-bg);
}
.sidebar-brand .sidebar-brand-narrow {
  display: none;
}

.sidebar-header {
  flex: 0 0 var(--cui-sidebar-header-height);
  padding: var(--cui-sidebar-header-padding-y) var(--cui-sidebar-header-padding-x);
  text-align: center;
  background: var(--cui-sidebar-header-bg);
  transition: height 0.15s, padding 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-header {
    transition: none;
  }
}
.sidebar-header .nav-link {
  display: flex;
  align-items: center;
  min-height: var(--cui-sidebar-header-height);
}

.sidebar-footer {
  flex: 0 0 var(--cui-sidebar-footer-height);
  padding: var(--cui-sidebar-footer-padding-y) var(--cui-sidebar-footer-padding-x);
  background: var(--cui-sidebar-footer-bg);
  transition: height 0.15s, padding 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-footer {
    transition: none;
  }
}

.sidebar-toggler {
  display: flex;
  flex: 0 0 var(--cui-sidebar-toggler-height);
  justify-content: flex-end;
  width: inherit;
  padding: 0;
  cursor: pointer;
  background-color: var(--cui-sidebar-toggler-bg);
  border: 0;
}
@media (max-width: 767.98px) {
  .sidebar-toggler {
    display: none;
  }
}
.sidebar-toggler::before {
  display: block;
  width: var(--cui-sidebar-toggler-indicator-width);
  height: var(--cui-sidebar-toggler-indicator-height);
  content: "";
  background-image: var(--cui-sidebar-toggler-indicator);
  background-repeat: no-repeat;
  background-position: center;
  background-size: calc(var(--cui-sidebar-toggler-indicator-height) * 0.25);
  transition: transform 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-toggler::before {
    transition: none;
  }
}
.sidebar-toggler:focus {
  outline: 0;
}
.sidebar-toggler:hover {
  background-color: var(--cui-sidebar-toggler-hover-bg);
}
.sidebar-toggler:hover::before {
  background-image: var(--cui-sidebar-toggler-indicator-hover);
}
.sidebar-end .sidebar-toggler {
  justify-content: flex-start;
}
.sidebar-end .sidebar-toggler::before {
  transform: rotate(-180deg);
}

.sidebar-backdrop {
  --cui-backdrop-zindex: 799;
  --cui-backdrop-bg: #000015;
  --cui-backdrop-opacity: 0.5;
}
@media (max-width: 767.98px) {
  .sidebar-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--cui-backdrop-zindex);
    width: 100vw;
    height: 100vh;
    background-color: var(--cui-backdrop-bg);
  }
  .sidebar-backdrop.fade {
    opacity: 0;
  }
  .sidebar-backdrop.show {
    opacity: var(--cui-backdrop-opacity);
  }
}

.sidebar-nav {
  position: relative;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  padding: 0;
  margin-bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none;
}
.sidebar-nav .nav-title {
  padding: var(--cui-sidebar-nav-title-padding-y) var(--cui-sidebar-nav-title-padding-x);
  margin-top: var(--cui-sidebar-nav-title-margin-top);
  font-size: 80%;
  font-weight: 700;
  color: var(--cui-sidebar-nav-title-color);
  text-transform: uppercase;
  transition: height 0.15s, margin 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-title {
    transition: none;
  }
}
.sidebar-nav .nav-link {
  display: flex;
  flex: 1 1;
  align-items: center;
  padding: var(--cui-sidebar-nav-link-padding-y) var(--cui-sidebar-nav-link-padding-x);
  color: var(--cui-sidebar-nav-link-color);
  text-decoration: none;
  white-space: nowrap;
  background: var(--cui-sidebar-nav-link-bg);
  border: var(--cui-sidebar-nav-link-border);
  border-radius: var(--cui-sidebar-nav-link-border-radius);
  transition: background 0.15s ease, color 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-link {
    transition: none;
  }
}
.sidebar-nav .nav-link.active {
  color: var(--cui-sidebar-nav-link-active-color);
  background: var(--cui-sidebar-nav-link-active-bg);
}
.sidebar-nav .nav-link.active .nav-icon {
  color: var(--cui-sidebar-nav-link-active-icon-color);
}
.sidebar-nav .nav-link.disabled {
  color: var(--cui-sidebar-nav-link-disabled-color);
  pointer-events: none;
  cursor: not-allowed;
  background: transparent;
}
.sidebar-nav .nav-link.disabled .nav-icon {
  color: var(--cui-sidebar-nav-link-disabled-icon-color);
}
.sidebar-nav .nav-link.disabled:hover {
  color: var(--cui-sidebar-nav-link-disabled-color);
}
.sidebar-nav .nav-link.disabled:hover .nav-icon {
  color: var(--cui-sidebar-nav-link-disabled-icon-color);
}
.sidebar-nav .nav-link.disabled:hover.nav-dropdown-toggle::after {
  background-image: var(--cui-sidebar-nav-group-indicator-hover);
}
@media (hover: hover), (-ms-high-contrast: none) {
  .sidebar-nav .nav-link:hover {
    color: var(--cui-sidebar-nav-link-hover-color);
    text-decoration: none;
    background: var(--cui-sidebar-nav-link-hover-bg);
  }
  .sidebar-nav .nav-link:hover .nav-icon {
    color: var(--cui-sidebar-nav-link-hover-icon-color);
  }
  .sidebar-nav .nav-link:hover.nav-group-toggle::after {
    background-image: var(--cui-sidebar-nav-group-indicator-hover);
  }
}
.sidebar-nav .nav-icon {
  flex: 0 0 var(--cui-sidebar-nav-icon-width);
  height: var(--cui-sidebar-nav-icon-height);
  font-size: var(--cui-sidebar-nav-icon-font-size);
  color: var(--cui-sidebar-nav-link-icon-color);
  text-align: center;
  pointer-events: none;
  fill: currentcolor;
  transition: inherit;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-icon {
    transition: none;
  }
}
.sidebar-nav .nav-icon:first-child {
  margin-left: calc(var(--cui-sidebar-nav-link-padding-x) * -1);
}
.sidebar-nav svg.nav-icon {
  overflow: hidden;
}
.sidebar-nav .nav-group {
  position: relative;
  transition: background 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-group {
    transition: none;
  }
}
.sidebar-nav .nav-group .nav-group-items {
  padding: var(--cui-sidebar-nav-group-items-padding-y) var(--cui-sidebar-nav-group-items-padding-x);
  overflow: hidden;
  transition: height 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-group .nav-group-items {
    transition: none;
  }
}
.sidebar-nav .nav-group:not(.show) .nav-group-items {
  display: none;
}
.sidebar-nav .nav-group.show {
  background: var(--cui-sidebar-nav-group-bg);
}
.sidebar-nav .nav-group.show .nav-group-toggle {
  color: var(--cui-sidebar-nav-group-toggle-show-color);
}
.sidebar-nav .nav-group.show > .nav-group-toggle::after {
  transform: rotate(180deg);
}
.sidebar-nav .nav-group.show + .show {
  margin-top: 1px;
}
.sidebar-nav .nav-group-toggle {
  cursor: pointer;
}
.sidebar-nav .nav-group-toggle::after {
  display: block;
  flex: 0 1 12px;
  height: 12px;
  margin-left: auto;
  content: "";
  background-image: var(--cui-sidebar-nav-group-indicator);
  background-repeat: no-repeat;
  background-position: center;
  transition: transform 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-group-toggle::after {
    transition: none;
  }
}
.sidebar-nav .nav-group-items {
  padding: 0;
  list-style: none;
}
.sidebar-nav .nav-group-items .nav-link {
  padding-left: var(--cui-sidebar-nav-icon-width);
}
.sidebar-nav .nav-group-items .nav-link .nav-icon {
  margin-left: calc(var(--cui-sidebar-nav-icon-width) * -1);
}
.sidebar-nav.compact .nav-link,
.sidebar-nav .compact .nav-link {
  padding-top: calc(var(--cui-sidebar-nav-link-padding-y) * 0.5);
  padding-bottom: calc(var(--cui-sidebar-nav-link-padding-y) * 0.5);
}

@media (min-width: 768px) {
  .sidebar-narrow-unfoldable:not(:hover), .sidebar-narrow {
    z-index: 1001;
    flex: 0 0 var(--cui-sidebar-narrow-width);
    width: var(--cui-sidebar-narrow-width);
    padding-bottom: var(--cui-sidebar-toggler-height);
    overflow: visible;
  }
  .sidebar-fixed.sidebar-narrow-unfoldable:not(:hover), .sidebar-fixed.sidebar-narrow {
    z-index: 1001;
    width: var(--cui-sidebar-narrow-width);
  }
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-brand-full, .sidebar-narrow .sidebar-brand-full {
    display: none;
  }
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-brand-narrow, .sidebar-narrow .sidebar-brand-narrow {
    display: block;
  }
  .sidebar-narrow-unfoldable:not(:hover) .d-narrow-none, .sidebar-narrow .d-narrow-none,
  .sidebar-narrow-unfoldable:not(:hover) .nav-label,
  .sidebar-narrow .nav-label,
  .sidebar-narrow-unfoldable:not(:hover) .nav-title,
  .sidebar-narrow .nav-title,
  .sidebar-narrow-unfoldable:not(:hover) .nav-group-items,
  .sidebar-narrow .nav-group-items,
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-footer,
  .sidebar-narrow .sidebar-footer,
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-form,
  .sidebar-narrow .sidebar-form,
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-header,
  .sidebar-narrow .sidebar-header {
    height: 0 !important;
    padding: 0;
    margin: 0;
    visibility: hidden;
    opacity: 0;
  }
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler, .sidebar-narrow .sidebar-toggler {
    position: fixed;
    bottom: 0;
  }
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler::before, .sidebar-narrow .sidebar-toggler::before {
    transform: rotate(-180deg);
  }
  .sidebar-end.sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler::before, .sidebar-end.sidebar-narrow .sidebar-toggler::before {
    transform: rotate(0deg);
  }
}

.sidebar-narrow:not(.sidebar-end) ~ * {
  --cui-sidebar-occupy-start: 4rem;
}
.sidebar-narrow.sidebar-end ~ * {
  --cui-sidebar-occupy-end: 4rem;
}

.sidebar-narrow-unfoldable {
  position: fixed;
  z-index: 1001;
}
.sidebar-narrow-unfoldable:not(.sidebar-end) ~ * {
  --cui-sidebar-occupy-start: 4rem;
}
.sidebar-narrow-unfoldable.sidebar-end ~ * {
  --cui-sidebar-occupy-end: 4rem;
}
.sidebar-narrow-unfoldable:hover .sidebar-toggler::before {
  transform: rotate(-180deg);
}
.sidebar-narrow-unfoldable:hover.sidebar-end .sidebar-toggler::before {
  transform: rotate(0deg);
}

.sidebar:not(.show).sidebar-self-hiding.sidebar-narrow:not(.sidebar-end), .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow-unfoldable:not(.sidebar-end) {
  margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
}
.sidebar:not(.show).sidebar-self-hiding.sidebar-narrow.sidebar-end, .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow-unfoldable.sidebar-end {
  margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
}

@media (max-width: 575.98px) {
  .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow:not(.sidebar-end), .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow.sidebar-end, .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
@media (max-width: 767.98px) {
  .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow:not(.sidebar-end), .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow.sidebar-end, .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
@media (max-width: 991.98px) {
  .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow:not(.sidebar-end), .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow.sidebar-end, .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
@media (max-width: 1199.98px) {
  .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow:not(.sidebar-end), .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow.sidebar-end, .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
@media (max-width: 1399.98px) {
  .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow:not(.sidebar-end), .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow.sidebar-end, .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
.subheader {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  min-height: 3rem;
  padding: 0.5rem 1rem;
  background: var(--cui-subheader-bg, #fff);
  border-bottom: var(--cui-subheader-border-width, var(--cui-border-width)) solid var(--cui-subheader-border-color, var(--cui-border-color));
}

.subheader-sticky {
  position: sticky;
  top: 0;
  z-index: 999;
}

.subheader-nav {
  display: flex;
  flex-direction: row;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.subheader-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  color: var(--cui-subheader-color, var(--cui-secondary-color));
}
.subheader-nav .nav-link:hover, .subheader-nav .nav-link:focus {
  color: var(--cui-subheader-hover-color, var(--cui-body-color));
}
.subheader-nav .nav-link.disabled {
  color: var(--cui-subheader-disabled-color, rgba(44, 56, 74, 0.38));
}
.subheader-nav .show > .nav-link,
.subheader-nav .nav-link.active {
  color: var(--cui-subheader-active-color, var(--cui-body-color));
}
.subheader-nav .dropdown-menu {
  position: absolute;
}

.subheader-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--cui-subheader-color, var(--cui-secondary-color));
}
.subheader-text a {
  color: var(--cui-subheader-active-color, var(--cui-body-color));
}
.subheader-text a:hover, .subheader-text a:focus {
  color: var(--cui-subheader-active-color, var(--cui-body-color));
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: rgba(255, 255, 255, 0.87) !important;
  background-color: RGBA(var(--cui-primary-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #000015 !important;
  background-color: RGBA(var(--cui-secondary-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #000015 !important;
  background-color: RGBA(var(--cui-success-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000015 !important;
  background-color: RGBA(var(--cui-info-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: rgba(44, 56, 74, 0.95) !important;
  background-color: RGBA(var(--cui-warning-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #000015 !important;
  background-color: RGBA(var(--cui-danger-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: rgba(44, 56, 74, 0.95) !important;
  background-color: RGBA(var(--cui-light-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: rgba(255, 255, 255, 0.87) !important;
  background-color: RGBA(var(--cui-dark-rgb), var(--cui-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--cui-primary-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-primary-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(63, 145, 139, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(63, 145, 139, var(--cui-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--cui-secondary-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-secondary-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(177, 183, 193, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(177, 183, 193, var(--cui-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--cui-success-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-success-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(88, 198, 125, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(88, 198, 125, var(--cui-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--cui-info-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-info-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(92, 173, 255, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(92, 173, 255, var(--cui-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--cui-warning-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-warning-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(199, 142, 17, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(199, 142, 17, var(--cui-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--cui-danger-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-danger-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(234, 117, 117, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(234, 117, 117, var(--cui-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--cui-light-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-light-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(188, 190, 191, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(188, 190, 191, var(--cui-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--cui-dark-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-dark-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(114, 125, 143, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(114, 125, 143, var(--cui-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--cui-focus-ring-x, 0) var(--cui-focus-ring-y, 0) var(--cui-focus-ring-blur, 0) var(--cui-focus-ring-width) var(--cui-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--cui-link-color-rgb), var(--cui-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--cui-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--cui-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --cui-aspect-ratio: 100%;
}

.ratio-4x3 {
  --cui-aspect-ratio: 75%;
}

.ratio-16x9 {
  --cui-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --cui-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1000;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--cui-border-width);
  min-height: 1em;
  padding: 0;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 21, 0.15) !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 21, 0.075) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 21, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --cui-focus-ring-color: rgba(var(--cui-primary-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-secondary {
  --cui-focus-ring-color: rgba(var(--cui-secondary-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-success {
  --cui-focus-ring-color: rgba(var(--cui-success-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-info {
  --cui-focus-ring-color: rgba(var(--cui-info-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-warning {
  --cui-focus-ring-color: rgba(var(--cui-warning-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-danger {
  --cui-focus-ring-color: rgba(var(--cui-danger-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-light {
  --cui-focus-ring-color: rgba(var(--cui-light-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-dark {
  --cui-focus-ring-color: rgba(var(--cui-dark-rgb), var(--cui-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-primary-rgb), var(--cui-border-opacity)) !important;
}

.border-secondary {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-secondary-rgb), var(--cui-border-opacity)) !important;
}

.border-success {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-success-rgb), var(--cui-border-opacity)) !important;
}

.border-info {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-info-rgb), var(--cui-border-opacity)) !important;
}

.border-warning {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-warning-rgb), var(--cui-border-opacity)) !important;
}

.border-danger {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-danger-rgb), var(--cui-border-opacity)) !important;
}

.border-light {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-light-rgb), var(--cui-border-opacity)) !important;
}

.border-dark {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-dark-rgb), var(--cui-border-opacity)) !important;
}

.border-white {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-white-rgb), var(--cui-border-opacity)) !important;
}

.border-top-primary {
  border-top-color: #0f766e !important;
}

.border-top-secondary {
  border-top-color: #9da5b1 !important;
}

.border-top-success {
  border-top-color: #2eb85c !important;
}

.border-top-info {
  border-top-color: #39f !important;
}

.border-top-warning {
  border-top-color: #f9b115 !important;
}

.border-top-danger {
  border-top-color: #e55353 !important;
}

.border-top-light {
  border-top-color: #ebedef !important;
}

.border-top-dark {
  border-top-color: #4f5d73 !important;
}

.border-top-white {
  border-top-color: #fff !important;
}

.border-end-primary {
  border-right-color: #0f766e !important;
}

.border-end-secondary {
  border-right-color: #9da5b1 !important;
}

.border-end-success {
  border-right-color: #2eb85c !important;
}

.border-end-info {
  border-right-color: #39f !important;
}

.border-end-warning {
  border-right-color: #f9b115 !important;
}

.border-end-danger {
  border-right-color: #e55353 !important;
}

.border-end-light {
  border-right-color: #ebedef !important;
}

.border-end-dark {
  border-right-color: #4f5d73 !important;
}

.border-end-white {
  border-right-color: #fff !important;
}

.border-bottom-primary {
  border-bottom-color: #0f766e !important;
}

.border-bottom-secondary {
  border-bottom-color: #9da5b1 !important;
}

.border-bottom-success {
  border-bottom-color: #2eb85c !important;
}

.border-bottom-info {
  border-bottom-color: #39f !important;
}

.border-bottom-warning {
  border-bottom-color: #f9b115 !important;
}

.border-bottom-danger {
  border-bottom-color: #e55353 !important;
}

.border-bottom-light {
  border-bottom-color: #ebedef !important;
}

.border-bottom-dark {
  border-bottom-color: #4f5d73 !important;
}

.border-bottom-white {
  border-bottom-color: #fff !important;
}

.border-start-primary {
  border-left-color: #0f766e !important;
}

.border-start-secondary {
  border-left-color: #9da5b1 !important;
}

.border-start-success {
  border-left-color: #2eb85c !important;
}

.border-start-info {
  border-left-color: #39f !important;
}

.border-start-warning {
  border-left-color: #f9b115 !important;
}

.border-start-danger {
  border-left-color: #e55353 !important;
}

.border-start-light {
  border-left-color: #ebedef !important;
}

.border-start-dark {
  border-left-color: #4f5d73 !important;
}

.border-start-white {
  border-left-color: #fff !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-top-1 {
  border-top-width: 1px !important;
}

.border-top-2 {
  border-top-width: 2px !important;
}

.border-top-3 {
  border-top-width: 3px !important;
}

.border-top-4 {
  border-top-width: 4px !important;
}

.border-top-5 {
  border-top-width: 5px !important;
}

.border-end-1 {
  border-right-width: 1px !important;
}

.border-end-2 {
  border-right-width: 2px !important;
}

.border-end-3 {
  border-right-width: 3px !important;
}

.border-end-4 {
  border-right-width: 4px !important;
}

.border-end-5 {
  border-right-width: 5px !important;
}

.border-bottom-1 {
  border-bottom-width: 1px !important;
}

.border-bottom-2 {
  border-bottom-width: 2px !important;
}

.border-bottom-3 {
  border-bottom-width: 3px !important;
}

.border-bottom-4 {
  border-bottom-width: 4px !important;
}

.border-bottom-5 {
  border-bottom-width: 5px !important;
}

.border-start-1 {
  border-left-width: 1px !important;
}

.border-start-2 {
  border-left-width: 2px !important;
}

.border-start-3 {
  border-left-width: 3px !important;
}

.border-start-4 {
  border-left-width: 4px !important;
}

.border-start-5 {
  border-left-width: 5px !important;
}

.border-opacity-10 {
  --cui-border-opacity: 0.1;
}

.border-opacity-25 {
  --cui-border-opacity: 0.25;
}

.border-opacity-50 {
  --cui-border-opacity: 0.5;
}

.border-opacity-75 {
  --cui-border-opacity: 0.75;
}

.border-opacity-100 {
  --cui-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--cui-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-primary-rgb), var(--cui-text-opacity)) !important;
}

.text-secondary {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-secondary-rgb), var(--cui-text-opacity)) !important;
}

.text-success {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-success-rgb), var(--cui-text-opacity)) !important;
}

.text-info {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-info-rgb), var(--cui-text-opacity)) !important;
}

.text-warning {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-warning-rgb), var(--cui-text-opacity)) !important;
}

.text-danger {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-danger-rgb), var(--cui-text-opacity)) !important;
}

.text-light {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-light-rgb), var(--cui-text-opacity)) !important;
}

.text-dark {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-dark-rgb), var(--cui-text-opacity)) !important;
}

.text-black {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-black-rgb), var(--cui-text-opacity)) !important;
}

.text-white {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-white-rgb), var(--cui-text-opacity)) !important;
}

.text-body {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-body-color-rgb), var(--cui-text-opacity)) !important;
}

.text-muted {
  --cui-text-opacity: 1;
  color: var(--cui-secondary-color) !important;
}

.text-black-50 {
  --cui-text-opacity: 1;
  color: rgba(0, 0, 21, 0.5) !important;
}

.text-white-50 {
  --cui-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --cui-text-opacity: 1;
  color: var(--cui-secondary-color) !important;
}

.text-body-tertiary {
  --cui-text-opacity: 1;
  color: var(--cui-tertiary-color) !important;
}

.text-body-emphasis {
  --cui-text-opacity: 1;
  color: var(--cui-emphasis-color) !important;
}

.text-reset {
  --cui-text-opacity: 1;
  color: inherit !important;
}

.text-high-emphasis-inverse {
  --cui-text-opacity: 1;
  color: var(--cui-high-emphasis-inverse) !important;
}

.text-medium-emphasis-inverse {
  --cui-text-opacity: 1;
  color: var(--cui-medium-emphasis-inverse) !important;
}

.text-disabled-inverse {
  --cui-text-opacity: 1;
  color: var(--cui-disabled-inverse) !important;
}

.text-high-emphasis {
  --cui-text-opacity: 1;
  color: var(--cui-high-emphasis) !important;
}

.text-medium-emphasis {
  --cui-text-opacity: 1;
  color: var(--cui-medium-emphasis) !important;
}

.text-disabled {
  --cui-text-opacity: 1;
  color: var(--cui-disabled) !important;
}

.text-opacity-25 {
  --cui-text-opacity: 0.25;
}

.text-opacity-50 {
  --cui-text-opacity: 0.5;
}

.text-opacity-75 {
  --cui-text-opacity: 0.75;
}

.text-opacity-100 {
  --cui-text-opacity: 1;
}

.link-opacity-10 {
  --cui-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --cui-link-opacity: 0.1;
}

.link-opacity-25 {
  --cui-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --cui-link-opacity: 0.25;
}

.link-opacity-50 {
  --cui-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --cui-link-opacity: 0.5;
}

.link-opacity-75 {
  --cui-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --cui-link-opacity: 0.75;
}

.link-opacity-100 {
  --cui-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --cui-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-primary-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-secondary-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-success {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-success-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-info {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-info-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-warning {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-warning-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-danger {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-danger-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-light {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-light-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-dark {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-dark-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-link-color-rgb), var(--cui-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --cui-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --cui-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --cui-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --cui-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --cui-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --cui-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --cui-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --cui-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --cui-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --cui-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --cui-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --cui-link-underline-opacity: 1;
}

.bg-primary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-primary-rgb), var(--cui-bg-opacity)) !important;
}

.bg-secondary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-secondary-rgb), var(--cui-bg-opacity)) !important;
}

.bg-success {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-success-rgb), var(--cui-bg-opacity)) !important;
}

.bg-info {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-info-rgb), var(--cui-bg-opacity)) !important;
}

.bg-warning {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-warning-rgb), var(--cui-bg-opacity)) !important;
}

.bg-danger {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-danger-rgb), var(--cui-bg-opacity)) !important;
}

.bg-light {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-light-rgb), var(--cui-bg-opacity)) !important;
}

.bg-dark {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-dark-rgb), var(--cui-bg-opacity)) !important;
}

.bg-black {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-black-rgb), var(--cui-bg-opacity)) !important;
}

.bg-white {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-white-rgb), var(--cui-bg-opacity)) !important;
}

.bg-body {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-body-bg-rgb), var(--cui-bg-opacity)) !important;
}

.bg-transparent {
  --cui-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-secondary-bg-rgb), var(--cui-bg-opacity)) !important;
}

.bg-body-tertiary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-tertiary-bg-rgb), var(--cui-bg-opacity)) !important;
}

.bg-opacity-10 {
  --cui-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --cui-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --cui-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --cui-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --cui-bg-opacity: 1;
}

.bg-gradient {
  background-image: var(--cui-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--cui-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--cui-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--cui-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--cui-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--cui-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--cui-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--cui-border-radius) !important;
  border-top-right-radius: var(--cui-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--cui-border-radius-sm) !important;
  border-top-right-radius: var(--cui-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--cui-border-radius) !important;
  border-top-right-radius: var(--cui-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--cui-border-radius-lg) !important;
  border-top-right-radius: var(--cui-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--cui-border-radius-xl) !important;
  border-top-right-radius: var(--cui-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--cui-border-radius-xxl) !important;
  border-top-right-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--cui-border-radius-pill) !important;
  border-top-right-radius: var(--cui-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--cui-border-radius) !important;
  border-bottom-right-radius: var(--cui-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--cui-border-radius-sm) !important;
  border-bottom-right-radius: var(--cui-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--cui-border-radius) !important;
  border-bottom-right-radius: var(--cui-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--cui-border-radius-lg) !important;
  border-bottom-right-radius: var(--cui-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--cui-border-radius-xl) !important;
  border-bottom-right-radius: var(--cui-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--cui-border-radius-xxl) !important;
  border-bottom-right-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--cui-border-radius-pill) !important;
  border-bottom-right-radius: var(--cui-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--cui-border-radius) !important;
  border-bottom-left-radius: var(--cui-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--cui-border-radius-sm) !important;
  border-bottom-left-radius: var(--cui-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--cui-border-radius) !important;
  border-bottom-left-radius: var(--cui-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--cui-border-radius-lg) !important;
  border-bottom-left-radius: var(--cui-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--cui-border-radius-xl) !important;
  border-bottom-left-radius: var(--cui-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--cui-border-radius-xxl) !important;
  border-bottom-left-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--cui-border-radius-pill) !important;
  border-bottom-left-radius: var(--cui-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--cui-border-radius) !important;
  border-top-left-radius: var(--cui-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--cui-border-radius-sm) !important;
  border-top-left-radius: var(--cui-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--cui-border-radius) !important;
  border-top-left-radius: var(--cui-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--cui-border-radius-lg) !important;
  border-top-left-radius: var(--cui-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--cui-border-radius-xl) !important;
  border-top-left-radius: var(--cui-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--cui-border-radius-xxl) !important;
  border-top-left-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--cui-border-radius-pill) !important;
  border-top-left-radius: var(--cui-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/*!
 * CoreUI Plugins - Chart.js for CoreUI 3
 * @version v3.1.2
 * @link https://coreui.io
 * Copyright (c) 2021 creativeLabs Łukasz Holeczek
 * Licensed under MIT (https://github.com/coreui/coreui-chartjs/blob/main/LICENSE)
 */
.chartjs-tooltip {
  position: absolute;
  z-index: 1021;
  padding: 0.25rem 0.5rem;
  color: #fff;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.7);
  opacity: 0;
  transition: all 0.15s ease;
  transform: translate(-50%, 0);
  border-radius: 0.375rem;
}
@media (prefers-reduced-motion: reduce) {
  .chartjs-tooltip {
    transition: none;
  }
}

.chartjs-tooltip-header {
  margin-bottom: 0.5rem;
}

.chartjs-tooltip-header-item {
  font-size: 0.875rem;
  font-weight: 700;
}

.chartjs-tooltip-body-item {
  align-items: center;
  font-size: 0.875rem;
  white-space: nowrap;
}

.text-bg-primary {
  color: rgba(255, 255, 255, 0.87) !important;
  background-color: RGBA(15, 118, 110, var(--cui-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #000015 !important;
  background-color: RGBA(157, 165, 177, var(--cui-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #000015 !important;
  background-color: RGBA(46, 184, 92, var(--cui-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000015 !important;
  background-color: RGBA(51, 153, 255, var(--cui-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: rgba(44, 56, 74, 0.95) !important;
  background-color: RGBA(249, 177, 21, var(--cui-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #000015 !important;
  background-color: RGBA(229, 83, 83, var(--cui-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: rgba(44, 56, 74, 0.95) !important;
  background-color: RGBA(235, 237, 239, var(--cui-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: rgba(255, 255, 255, 0.87) !important;
  background-color: RGBA(79, 93, 115, var(--cui-bg-opacity, 1)) !important;
}

.wrapper {
  width: 100%;
  padding-left: var(--cui-sidebar-occupy-start, 0);
  will-change: auto;
  transition: padding 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .wrapper {
    transition: none;
  }
}

/*Color Codes*/
/*Shadow Codes*/
/*Fonts*/
/*Screen Size*/
/*Animation*/
/* Media query Manager */
/*
0 - 600px       :   Phone
601 - 900px     :   Tablet Potrait
901 - 1200px    :   Tablet Landscape
1201 - 1800px   :   Desktop
1801 +          :   BigDesktop
*/
/*Break-point argument choices:
- mob
- tab-p
- tab-l
- b-desktop
*/
@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("truetype");
  font-weight: 100 900;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("truetype");
  font-style: italic;
  font-weight: 100 900;
  font-display: swap;
}
body {
  background: #838389;
  font-size: 11pt;
}

:root iframe#webpack-dev-server-client-overlay {
  display: none !important;
}

:root {
  --cui-font-sans-serif:
      "Inter",
      system-ui,
      -apple-system,
      BlinkMacSystemFont,
      "Segoe UI",
      Roboto,
      Helvetica,
      Arial,
      sans-serif;
  --cui-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --cui-card-cap-padding-y: 0.5rem;
  --cui-card-cap-padding-x: 1rem;
  --cui-card-border-color: rgba(0,0,21,.125);
  --cui-card-cap-bg: rgba(0,0,21,.03);
  --cui-sidebar-nav-link-color: white;
  --cui-card-border-width:1px;
  --cui-card-border-color:#E5E7EB;
  --cui-card-cap-bg:#FFFFFF;
  --cui-primary: #0f766e;
  --cui-btn-bg: #0f766e;
  --cui-primary-rgb: 15, 118, 110;
}

.form-control:disabled, .form-control[readonly] {
  background-color: #d8dbe0;
  background-color: var(--cui-input-disabled-bg, #d8dbe0);
  border-color: #b1b7c1;
  border-color: var(--cui-input-disabled-border-color, #b1b7c1);
  opacity: 1;
}

.reg_pelanggan {
  position: absolute;
  top: 40mm;
  left: 30mm;
  right: 10mm;
}

.card.disabled {
  background-color: #e9ecef;
  opacity: 0.7;
  z-index: 20;
}

.toggle,
[id^=drop] {
  display: none;
}

/* Giving a background-color to the nav container. */
.foto_tambah_pelanggan {
  padding-top: 38%;
  background-position: 50%;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.65);
}

.foto_tambah_mitra {
  padding-top: 38%;
  background-position: 50%;
}

.pie-chart {
  margin: 20px;
  text-align: center;
}
.pie-chart > svg > path {
  stroke: var(--color1);
  stroke-width: 1px;
}
.pie-chart > svg > a {
  transition: opacity var(--fade);
  opacity: 0;
}
.pie-chart > svg > a > text {
  font-weight: bold;
  opacity: 0.4;
}
.pie-chart > svg > a > path {
  stroke: var(--color4);
}
.pie-chart > svg > a:hover {
  opacity: 1;
}
.pie-chart > .legend {
  text-align: left;
  margin: 15px;
}
.pie-chart > .legend > .legend-line > .color {
  height: 12px;
  width: 12px;
  margin-right: 5px;
  border: 1px solid var(--color1);
  display: inline-block;
}

.dropdown-menu {
  background-clip: padding-box;
  background-color: #fff;
  background-color: var(--cui-dropdown-bg, #fff);
  border: 1px solid rgba(0, 0, 21, 0.15);
  border: 1px solid var(--cui-dropdown-border-color, rgba(0, 0, 21, 0.15));
  border-radius: 0.25rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 21, 0.15);
  color: rgba(44, 56, 74, 0.95);
  color: var(--cui-dropdown-color, rgba(44, 56, 74, 0.95));
  display: none;
  font-size: 1rem;
  list-style: none;
  margin: 0;
  min-width: 10rem;
  padding: 0.5rem 0;
  position: absolute;
  text-align: start;
  z-index: 1000;
}

/* Media Queries
--------------------------------------------- */
@media all and (max-width: 768px) {
  .logo {
    display: block;
    padding: 0;
    width: 100%;
    text-align: center;
    float: none;
  }
  nav {
    margin: 0;
  }
  /* Hide the navigation menu by default */
  /* Also hide the  */
  .toggle + a,
  .menu {
    display: none;
  }
  /* Stylinf the toggle lable */
  .toggle {
    display: block;
    background-color: #ffffff;
    padding: 14px 20px;
    color: #1A1919;
    font-size: 17px;
    text-decoration: none;
    border: none;
  }
  .toggle:hover {
    background-color: #badefc;
  }
  /* Display Dropdown when clicked on Parent Lable */
  [id^=drop]:checked + ul {
    display: block;
    width: -webkit-fill-available;
  }
  /* Change menu item's width to 100% */
  nav ul li {
    display: block;
    width: 100%;
  }
  nav ul ul .toggle,
  nav ul ul a {
    padding: 0 40px;
  }
  nav ul ul ul a {
    padding: 0 80px;
  }
  nav a:hover,
  nav ul ul ul a {
    background-color: #badefc;
  }
  nav ul li ul li .toggle,
  nav ul ul a,
  nav ul ul ul a {
    padding: 14px 20px;
    color: #1A1919;
    font-size: 17px;
  }
  /* Hide Dropdowns by Default */
  nav ul ul {
    float: none;
    position: static;
    color: #1A1919;
    /* has to be the same number as the "line-height" of "nav a" */
  }
  /* Hide menus on hover */
  nav ul ul li:hover > ul,
  nav ul li:hover > ul {
    display: none;
  }
  /* Fisrt Tier Dropdown */
  nav ul ul li {
    display: block;
    width: 100%;
  }
  nav ul ul ul li {
    position: static;
    /* has to be the same number as the "width" of "nav ul ul li" */
  }
}
@media all and (max-width: 330px) {
  nav ul li {
    display: block;
    width: 94%;
  }
}
.dropdown a {
  color: #1A1919;
}

.dropdown a:hover {
  color: #1A1919;
}

/* Dropdown */
.dropdown {
  display: inline-block;
  position: relative;
}

.dd-button {
  display: inline-block;
  background-color: #badefc;
  outline: 1px solid #a5c3e4;
  outline-offset: -1px;
  color: #1A1919;
  cursor: pointer;
  white-space: nowrap;
  padding: 14px 20px;
}

.dd-button span {
  padding: 0 16px 0 0;
  vertical-align: middle;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.dd-button:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 0.7rem;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #1A1919;
}

.dd-input {
  display: none;
}

.dd-menu {
  position: absolute;
  top: 100%;
  border-radius: 4px;
  padding: 0;
  margin: 4px 0 0 0;
  box-shadow: 2px 5px 12px 0px rgba(14, 97, 185, 0.1);
  background-color: #ffffff;
  list-style-type: none;
  z-index: 99;
  right: 0;
}

.dd-input + .dd-menu {
  display: none;
}

.dd-input:checked + .dd-menu {
  display: block;
}

.dd-menu li {
  padding: 0.8rem 1.5rem;
  cursor: pointer;
  white-space: nowrap;
  font-weight: 400;
}

.dd-menu li a {
  display: block;
  margin: -10px -20px;
  padding: 10px 20px;
}

.dd-menu li.divider {
  padding: 0;
  border-bottom: 1px solid #a5c3e4;
}

/* apply a natural box layout model to all elements, but allowing components to change */
*,
::after,
::before {
  box-sizing: border-box;
}

a {
  color: #0e61b9;
  text-decoration: none;
  transition: color 0.1s linear;
}

.preloader-container {
  position: relative;
}

tbody.ct-centered {
  display: flex;
  align-items: center;
  justify-content: center;
}

.preloader-ct {
  border: 8px solid #3498db;
  border-top: 8px solid #f0f0f0;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@keyframes spin {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
.projectname-container {
  font-size: 15px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 1400px) {
  .projectname-container {
    max-width: 1360px;
  }
}
@media (max-width: 1399px) and (min-width: 1200px) {
  .projectname-container {
    max-width: 1140px;
  }
}
@media (max-width: 1199px) and (min-width: 992px) {
  .projectname-container {
    max-width: 960px;
  }
}
@media (max-width: 991px) and (min-width: 768px) {
  .projectname-container {
    max-width: 720px;
  }
}
@media (max-width: 767px) and (min-width: 576px) {
  .projectname-container {
    max-width: 540px;
  }
}
.projectname-breadcrumb--section {
  background-color: #f9f9f9;
}

.projectname-page-header .breadcrumbs ol {
  display: inline-flex;
}

.projectname-page-header .breadcrumbs ol .breadcrumb {
  margin: 1rem 0.5rem;
}

.projectname-page-header .breadcrumbs ol .breadcrumb::after {
  margin-left: 0.5rem;
  content: "/";
}

.projectname-page-header .breadcrumbs ol .breadcrumb:last-child {
  pointer-events: none;
  cursor: default;
}

.projectname-page-header .breadcrumbs ol .breadcrumb:last-child a {
  color: #1A1919;
}

.projectname-page-header .breadcrumbs ol .breadcrumb:last-child a:hover {
  pointer-events: none;
  cursor: default;
}

.projectname-page-header .breadcrumbs ol .breadcrumb:last-child::after {
  content: "";
}

.projectname-form-container {
  padding: 2rem 0rem;
}

.projectname-right--section,
.projectname-model {
  background: #ffffff;
  border-radius: 6px;
  border: 0px solid #a5c3e4;
  box-shadow: 2px 5px 12px 0px rgba(14, 97, 185, 0.1);
}

.projectname-right--section .form--header,
.projectname-model .form--header {
  padding: 1.5rem 3rem;
}

.projectname-right--section .form--header_heading,
.projectname-model .form--header_heading {
  align-items: center;
}

.projectname-right--section .form--header_heading h2, .projectname-right--section .form--header_heading .h2,
.projectname-model .form--header_heading h2,
.projectname-model .form--header_heading .h2 {
  font-family: "Mulish", sans-serif;
  font-size: 22px;
  font-weight: 600;
  line-height: 40px;
}

.projectname-right--section .form--header_heading-description,
.projectname-model .form--header_heading-description {
  color: #767676;
}

.projectname-right--section .form--header_sub-heading,
.projectname-model .form--header_sub-heading {
  font-size: 1.2rem;
  margin: 1rem 0;
  margin-top: 1.5rem;
}

.projectname-right--section .form--body,
.projectname-model .form--body {
  padding: 0 3rem;
}

.projectname-right--section .form--footer,
.projectname-model .form--footer {
  margin-top: 1.5rem;
  border-top: 1px solid #DFE0E2;
  display: flex;
  justify-content: flex-end;
  padding: 1.5rem 3rem;
}

.projectname-right--section .form--footer .slds-button_outline-brand,
.projectname-model .form--footer .slds-button_outline-brand {
  padding: 0.3rem 1.5rem;
  background: transparent;
  color: #0e61b9;
  border: 0px;
  box-shadow: none;
}

.projectname-right--section .form--footer .slds-button_outline-brand,
.projectname-right--section .form--footer .slds-button_outline-brand:link,
.projectname-right--section .form--footer .slds-button_outline-brand:visited,
.projectname-model .form--footer .slds-button_outline-brand,
.projectname-model .form--footer .slds-button_outline-brand:link,
.projectname-model .form--footer .slds-button_outline-brand:visited {
  align-items: center;
  border-radius: 2px;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 18px;
  font-weight: 500;
  justify-content: center;
  min-width: 88px;
  outline: 0;
  text-decoration: none;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
  position: relative;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  will-change: box-shadow;
}

.projectname-right--section .form--footer .slds-button_outline-brand:hover,
.projectname-model .form--footer .slds-button_outline-brand:hover {
  background: #215FAB;
  border: 1px solid #0e61b9;
  color: #ffffff;
  background: rgba(14, 97, 185, 0.1);
  color: #0e61b9;
  border: 0px;
  box-shadow: none;
}

.projectname-right--section .form--footer .slds-button_neutral,
.projectname-model .form--footer .slds-button_neutral {
  padding: 0.3rem 1.5rem;
  background: transparent;
  color: #6C6E75;
  border: 0px;
  box-shadow: none;
}

.projectname-right--section .form--footer .slds-button_neutral,
.projectname-right--section .form--footer .slds-button_neutral:link,
.projectname-right--section .form--footer .slds-button_neutral:visited,
.projectname-model .form--footer .slds-button_neutral,
.projectname-model .form--footer .slds-button_neutral:link,
.projectname-model .form--footer .slds-button_neutral:visited {
  align-items: center;
  border-radius: 2px;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 18px;
  font-weight: 500;
  justify-content: center;
  min-width: 88px;
  outline: 0;
  text-decoration: none;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
  position: relative;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  will-change: box-shadow;
}

.projectname-right--section .form--footer .slds-button_neutral:hover,
.projectname-model .form--footer .slds-button_neutral:hover {
  background: #215FAB;
  border: 1px solid #0e61b9;
  color: #ffffff;
  background: rgba(108, 110, 117, 0.1);
  color: #6C6E75;
  border: 0px;
  box-shadow: none;
}

.projectname-right--section .form--footer .slds-button.slds-button_brand,
.projectname-model .form--footer .slds-button.slds-button_brand {
  padding: 0.3rem 1.5rem;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  background: #0e61b9;
  border: 1px solid #0e61b9;
  color: #ffffff;
}

.projectname-right--section .form--footer .slds-button.slds-button_brand,
.projectname-right--section .form--footer .slds-button.slds-button_brand:link,
.projectname-right--section .form--footer .slds-button.slds-button_brand:visited,
.projectname-model .form--footer .slds-button.slds-button_brand,
.projectname-model .form--footer .slds-button.slds-button_brand:link,
.projectname-model .form--footer .slds-button.slds-button_brand:visited {
  align-items: center;
  border-radius: 2px;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 18px;
  font-weight: 500;
  justify-content: center;
  min-width: 88px;
  outline: 0;
  text-decoration: none;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
  position: relative;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  will-change: box-shadow;
}

.projectname-right--section .form--footer .slds-button.slds-button_brand:hover,
.projectname-model .form--footer .slds-button.slds-button_brand:hover {
  background: #215FAB;
  border: 1px solid #0e61b9;
  color: #ffffff;
}

.projectname-right--section .form--footer .slds-button.slds-button_brand:active,
.projectname-right--section .form--footer .slds-button.slds-button_brand:focus,
.projectname-model .form--footer .slds-button.slds-button_brand:active,
.projectname-model .form--footer .slds-button.slds-button_brand:focus {
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.projectname-right--section .form--footer .slds-button_destructive,
.projectname-model .form--footer .slds-button_destructive {
  padding: 0.3rem 1.5rem;
  background: transparent;
  color: #E71D36;
  border: 0px;
  box-shadow: none;
}

.projectname-right--section .form--footer .slds-button_destructive,
.projectname-right--section .form--footer .slds-button_destructive:link,
.projectname-right--section .form--footer .slds-button_destructive:visited,
.projectname-model .form--footer .slds-button_destructive,
.projectname-model .form--footer .slds-button_destructive:link,
.projectname-model .form--footer .slds-button_destructive:visited {
  align-items: center;
  border-radius: 2px;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 18px;
  font-weight: 500;
  justify-content: center;
  min-width: 88px;
  outline: 0;
  text-decoration: none;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
  position: relative;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  will-change: box-shadow;
}

.projectname-right--section .form--footer .slds-button_destructive:hover,
.projectname-model .form--footer .slds-button_destructive:hover {
  background: #215FAB;
  border: 1px solid #0e61b9;
  color: #ffffff;
  background: rgba(231, 29, 54, 0.1);
  color: #E71D36;
  border: 0px;
  box-shadow: none;
}

.projectname-right--section .form--footer .slds-button_success,
.projectname-model .form--footer .slds-button_success {
  padding: 0.3rem 1.5rem;
  background: transparent;
  color: #90be6d;
  border: 0px;
  box-shadow: none;
}

.projectname-right--section .form--footer .slds-button_success,
.projectname-right--section .form--footer .slds-button_success:link,
.projectname-right--section .form--footer .slds-button_success:visited,
.projectname-model .form--footer .slds-button_success,
.projectname-model .form--footer .slds-button_success:link,
.projectname-model .form--footer .slds-button_success:visited {
  align-items: center;
  border-radius: 2px;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 18px;
  font-weight: 500;
  justify-content: center;
  min-width: 88px;
  outline: 0;
  text-decoration: none;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
  position: relative;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  will-change: box-shadow;
}

.projectname-right--section .form--footer .slds-button_success:hover,
.projectname-model .form--footer .slds-button_success:hover {
  background: #215FAB;
  border: 1px solid #0e61b9;
  color: #ffffff;
  background: rgba(144, 190, 109, 0.1);
  color: #90be6d;
  border: 0px;
  box-shadow: none;
}

.projectname-right--section .yn_question,
.projectname-model .yn_question {
  display: grid;
  grid-template-columns: 3fr 1fr;
  align-items: center;
}

.projectname-right--section .yn_question .question,
.projectname-model .yn_question .question {
  color: #333333;
  font-family: HelveticaNeue-Medium;
  font-size: 18px;
  font-weight: 500;
  line-height: 30px;
}

.projectname-right--section .yn_question .question .sub_section,
.projectname-model .yn_question .question .sub_section {
  color: #333333;
  font-family: HelveticaNeue;
  font-size: 12px;
}

.projectname-right--section .yn_question .anwser .projectname-radio-buttons,
.projectname-model .yn_question .anwser .projectname-radio-buttons {
  margin-top: 0rem;
}

.projectname-right--section .yn_question .anwser .projectname-radio-buttons .slds-radio label,
.projectname-model .yn_question .anwser .projectname-radio-buttons .slds-radio label {
  padding: 1.25rem 2.25rem 1.25rem 2.25rem;
}

.projectname-right--section:not(:first-child) {
  margin-top: 2rem;
}

.projectname-model {
  margin: auto;
}

.projectname-model--lg {
  width: 90%;
}

.projectname-model--md {
  width: 60%;
}

.projectname-model--sm {
  width: 35%;
}

.projectname-button--section {
  display: flex;
  justify-content: flex-end;
  padding: 2rem 0;
}

.projectname-button--section .slds-button_outline-brand {
  padding: 0.3rem 1.5rem;
  background: transparent;
  color: #0e61b9;
  border: 0px;
  box-shadow: none;
}

.projectname-button--section .slds-button_outline-brand,
.projectname-button--section .slds-button_outline-brand:link,
.projectname-button--section .slds-button_outline-brand:visited {
  align-items: center;
  border-radius: 2px;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 18px;
  font-weight: 500;
  justify-content: center;
  min-width: 88px;
  outline: 0;
  text-decoration: none;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
  position: relative;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  will-change: box-shadow;
}

.projectname-button--section .slds-button_outline-brand:hover {
  background: #215FAB;
  border: 1px solid #0e61b9;
  color: #ffffff;
  background: rgba(14, 97, 185, 0.1);
  color: #0e61b9;
  border: 0px;
  box-shadow: none;
}

.projectname-button--section .slds-button_neutral {
  padding: 0.3rem 1.5rem;
  background: transparent;
  color: #6C6E75;
  border: 0px;
  box-shadow: none;
}

.projectname-button--section .slds-button_neutral,
.projectname-button--section .slds-button_neutral:link,
.projectname-button--section .slds-button_neutral:visited {
  align-items: center;
  border-radius: 2px;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 18px;
  font-weight: 500;
  justify-content: center;
  min-width: 88px;
  outline: 0;
  text-decoration: none;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
  position: relative;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  will-change: box-shadow;
}

.projectname-button--section .slds-button_neutral:hover {
  background: #215FAB;
  border: 1px solid #0e61b9;
  color: #ffffff;
  background: rgba(108, 110, 117, 0.1);
  color: #6C6E75;
  border: 0px;
  box-shadow: none;
}

.projectname-button--section .slds-button.slds-button_brand {
  padding: 0.3rem 1.5rem;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  background: #0e61b9;
  border: 1px solid #0e61b9;
  color: #ffffff;
}

.projectname-button--section .slds-button.slds-button_brand,
.projectname-button--section .slds-button.slds-button_brand:link,
.projectname-button--section .slds-button.slds-button_brand:visited {
  align-items: center;
  border-radius: 2px;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 18px;
  font-weight: 500;
  justify-content: center;
  min-width: 88px;
  outline: 0;
  text-decoration: none;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
  position: relative;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  will-change: box-shadow;
}

.projectname-button--section .slds-button.slds-button_brand:hover {
  background: #215FAB;
  border: 1px solid #0e61b9;
  color: #ffffff;
}

.projectname-button--section .slds-button.slds-button_brand:active,
.projectname-button--section .slds-button.slds-button_brand:focus {
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.projectname-button--section .slds-button_destructive {
  padding: 0.3rem 1.5rem;
  background: transparent;
  color: #E71D36;
  border: 0px;
  box-shadow: none;
}

.projectname-button--section .slds-button_destructive,
.projectname-button--section .slds-button_destructive:link,
.projectname-button--section .slds-button_destructive:visited {
  align-items: center;
  border-radius: 2px;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 18px;
  font-weight: 500;
  justify-content: center;
  min-width: 88px;
  outline: 0;
  text-decoration: none;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
  position: relative;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  will-change: box-shadow;
}

.projectname-button--section .slds-button_destructive:hover {
  background: #215FAB;
  border: 1px solid #0e61b9;
  color: #ffffff;
  background: rgba(231, 29, 54, 0.1);
  color: #E71D36;
  border: 0px;
  box-shadow: none;
}

.projectname-button--section .slds-button_success {
  padding: 0.3rem 1.5rem;
  background: transparent;
  color: #90be6d;
  border: 0px;
  box-shadow: none;
}

.projectname-button--section .slds-button_success,
.projectname-button--section .slds-button_success:link,
.projectname-button--section .slds-button_success:visited {
  align-items: center;
  border-radius: 2px;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 18px;
  font-weight: 500;
  justify-content: center;
  min-width: 88px;
  outline: 0;
  text-decoration: none;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
  position: relative;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  will-change: box-shadow;
}

.projectname-button--section .slds-button_success:hover {
  background: #215FAB;
  border: 1px solid #0e61b9;
  color: #ffffff;
  background: rgba(144, 190, 109, 0.1);
  color: #90be6d;
  border: 0px;
  box-shadow: none;
}

.projectname-radio-buttons {
  margin-top: 1rem;
}

.projectname-radio-buttons .slds-radio {
  padding: 0;
}

.projectname-radio-buttons .slds-radio label {
  display: flex;
  align-items: center;
  padding: 0.25rem 1.25rem 0.25rem 1.25rem;
  border: 1px solid #ddd;
  border-radius: 3px;
  min-height: 2.5rem;
}

.projectname-radio-buttons .slds-radio label .slds-form-element__label {
  padding-right: 0;
}

@media (min-width: 768px) {
  .projectname-radio-buttons .slds-radio + .slds-radio {
    margin-left: 1rem;
  }
  .projectname-radio-buttons.btns-x {
    display: flex;
  }
}
.projectname-vertical-wizard {
  border-right: 1px solid #DFE0E2;
}

.projectname-vertical-wizard ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.projectname-vertical-wizard li {
  display: block;
  position: relative;
}

.projectname-vertical-wizard li.complete .ico {
  left: 8px;
}

.projectname-vertical-wizard li.complete a::before {
  background-color: #90be6d;
  opacity: 1;
  height: calc(100% - 25px);
  bottom: -9px;
}

.projectname-vertical-wizard li.complete a::after {
  display: none;
}

.projectname-vertical-wizard li.locked > a:after {
  display: none;
}

.projectname-vertical-wizard li.current {
  background-color: #f4f4f4;
}

.projectname-vertical-wizard li.current a:before {
  background-color: #0e61b9;
  opacity: 1;
}

.projectname-vertical-wizard li.current a:after {
  border-color: #0e61b9;
  background-color: #0e61b9;
  opacity: 1;
}

.projectname-vertical-wizard li.current:before,
.projectname-vertical-wizard li.current:after {
  left: 100%;
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.projectname-vertical-wizard li:last-child > a:before {
  display: none;
}

.projectname-vertical-wizard a {
  display: block;
  padding: 10px 10px 20px 40px;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.35px;
  color: #1A1919;
}

.projectname-vertical-wizard a::before {
  content: "";
  position: absolute;
  width: 1px;
  height: calc(100% - 25px);
  background-color: #aaacb1;
  left: 13px;
  bottom: -9px;
  z-index: 3;
}

.projectname-vertical-wizard a::after {
  content: "";
  position: absolute;
  border: 2px solid #aaacb1;
  border-radius: 50%;
  top: 14px;
  left: 6px;
  width: 16px;
  height: 16px;
  z-index: 3;
}

.projectname-vertical-wizard a:hover,
.projectname-vertical-wizard a:focus {
  text-decoration: none;
}

.projectname-vertical-wizard .ico {
  pointer-events: none;
  font-size: 14px;
  position: absolute;
  left: 10px;
  top: 15px;
  z-index: 2;
}

.projectname-vertical-wizard .ico.ico-green {
  color: #90be6d;
}

.projectname-vertical-wizard .ico.ico-muted {
  color: #aaacb1;
}

.projectname-vertical-wizard .desc {
  display: block;
  line-height: 1.8;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  color: #aaacb1;
}

.projectname-vertical-wizard ul > li.current:after {
  border-color: rgba(0, 0, 0, 0);
  border-left-color: #f4f4f4;
  border-width: 10px;
  margin-top: -10px;
}

.projectname-vertical-wizard ul > li.current:before {
  border-color: rgba(14, 97, 185, 0);
  border-left-color: #DFE0E2;
  border-width: 11px;
  margin-top: -11px;
}

label.slds-form-element__label {
  font-family: Muli;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.projectname-container .slds-tabs_scoped__content {
  padding: 0rem;
}

.projectname-container .slds-tabs_scoped__nav {
  border: 0px;
  border-radius: 0px 6px 0px 0px;
  background-color: #e8e8e8;
}

.projectname-container .slds-tabs_scoped__content {
  border: 0px;
  border-radius: 0px 0px 6px 6px;
}

.projectname-container .slds-is-active {
  border-top: 3px solid #1A1919;
}

.projectname-container .slds-is-active .slds-tabs_scoped__link {
  border: 0px;
}

.projectname-container .slds-tabs_scoped__link {
  padding: 0 2rem;
}

.form-label.sm {
  font-size: 0.875rem;
  margin-bottom: 0.3rem;
}

.block-panel {
  display: flex;
  justify-items: center;
  flex-direction: column;
  text-align: center;
  position: absolute;
  width: 100%;
  height: 100%;
  background: black;
  z-index: 1600;
  opacity: 0.5;
}

.z-10 {
  z-index: 10;
}

.block-panel p {
  justify-content: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  color: white;
}

.block-panel-p {
  justify-content: center;
  flex-direction: column;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  text-align: center;
  /* opacity: 1; */
  z-index: 1700;
  position: absolute;
  color: white;
}

/*****************************************
  upload button styles
******************************************/
.file-upload {
  position: relative;
  display: inline-block;
}

.file-upload__label {
  color: #fff;
  border-radius: 0.4em;
  transition: background 0.3s;
}
.file-upload__label:hover {
  cursor: pointer;
}

.file-upload__input {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  font-size: 1;
  width: 0;
  height: 100%;
  opacity: 0;
}

.bg-image {
  padding-top: 50%;
  width: 100%;
  cursor: pointer;
  background-position: 50%;
}

.bg-image-cover {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.87);
  display: block;
  background-position: 50%;
  background-size: contain;
  background-repeat: no-repeat;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.bg-image:hover {
  transform: scale(1.2);
}

.foto_avatar {
  padding-top: 140% !important;
}

.react-datepicker__input-container input {
  width: 100%;
}

.footer {
  overflow: hidden;
  margin-top: 5mm;
  width: 100%;
  background: #303c54;
  color: white;
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
  border-left: 1px solid;
}

.header-search-wrapper {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
}

.example-content-main {
  width: 100%;
  z-index: 200;
}

/* Desktop */
@media (min-width: 992px) {
  .example-content-main {
    width: 500px;
  }
}
.main-filter-table {
  flex-wrap: nowrap;
}
@media (min-width: 576px) {
  .main-filter-table {
    width: 200px;
  }
}
@media (min-width: 992px) {
  .main-filter-table {
    width: 500px;
  }
}

.main-search-button {
  display: flex;
}
@media (min-width: 576px) {
  .main-search-button {
    display: none;
  }
}
@media (min-width: 992px) {
  .main-search-button {
    display: none;
  }
}

.ant-form-item {
  margin-bottom: 8px !important;
}

.smooth-image {
  transition: opacity 1s;
}

.image-visible {
  opacity: 1;
}

.image-hidden {
  opacity: 0;
}

.smooth-no-image {
  background-image: linear-gradient(90deg, #ccc, #999, #ccc);
  color: #fff;
}

img[alt=img-logo] {
  border-radius: 10px;
}

.label-primary {
  background-color: #0f766e;
  color: #fff;
}

.label-danger {
  background-color: #e55353;
  color: #fff;
}

.label-warning {
  background-color: #f9b115;
  color: #fff;
}

.label-info {
  background-color: #39f;
  color: #fff;
}

.label-light {
  background-color: #ebedef;
  color: #fff;
}

.label-success {
  background-color: #2eb85c;
  color: #fff;
}

.label {
  display: inline;
  padding: 0.2em 0.6em 0.3em;
  font-weight: bold;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
}

.form-check-input:checked {
  border-color: #c3ddd1;
}

.sidebar {
  background-color: #04889F;
  background: linear-gradient(180deg, #134E4A 0%, #115E59 50%, #0F766E 100%);
}

.ui.horizontal.divider {
  display: table;
  white-space: nowrap;
  height: auto;
  margin: "";
  line-height: 1;
  text-align: center;
}

h4.ui.headers, .ui.headers.h4 {
  font-size: 1.07142857rem;
}

.ui.headers {
  border: none;
  margin: calc(2rem - 0.14285714em) 0 1rem;
  padding: 0 0;
  font-family: Lato, "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-weight: 700;
  line-height: 1.28571429em;
  text-transform: none;
  color: rgba(0, 0, 0, 0.87);
}

.ui.horizontal.divider:after,
.ui.horizontal.divider:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}

.ui.horizontal.divider:before {
  background-position: right 1em top 50%;
}

.ui.horizontal.divider:after,
.ui.horizontal.divider:before {
  content: "";
  display: table-cell;
  position: relative;
  top: 50%;
  width: 50%;
  background-repeat: no-repeat;
}

.ui.header .icon:only-child {
  display: inline-block;
  padding: 0;
  margin-right: 0.75rem;
}

.ui.header > .icon {
  display: table-cell;
  opacity: 1;
  font-size: 1.5em;
  padding-top: 0;
  vertical-align: middle;
}

.ui.divider > .icon {
  margin: 0;
  font-size: 1rem;
  height: 1em;
  vertical-align: middle;
}

i.icon,
i.icons {
  font-size: 1em;
}

i.icon {
  display: inline-block;
  opacity: 1;
  margin: 0 0.25rem 0 0;
  width: 1.18em;
  height: 1em;
  font-family: Icons;
  font-style: normal;
  font-weight: 400;
  text-decoration: inherit;
  text-align: center;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  backface-visibility: hidden;
}

.rdt_Table {
  padding: 10px;
}

/*****************************************
 design styles
******************************************/
.page-multiple.A4 {
  width: 270mm;
}

#print_target .page-multiple.A58.portrait {
  width: 80mm;
  font-size: 8pt !important;
  line-height: 10pt;
}

.simplebar-init {
  max-height: 36rem;
}

@media (min-width: 576px) {
  .simplebar-init {
    max-height: 30rem;
  }
}
.accordion-body {
  padding: 10px;
}

.receipt {
  padding: 10px;
  /* font-family: 'Merchant Copy Doublesize', sans-serif; */
  /* border: 1px solid; */
  /* font-size: 8pt; */
  font-size: 16px;
}

.receipt img {
  width: 27.9px;
}

.garis {
  color: black;
  border: 1px dashed black;
  height: 1px;
  margin-top: 5px;
}

.garis-solid {
  color: black;
  border: 1px solid black;
  height: 2px;
  margin-top: 5px;
}

.fs-8pt {
  font-size: 12pt;
}

.receipt hr {
  opacity: unset !important;
}

.mt-3px {
  margin-top: 3px;
}

.fs-5pt {
  font-size: 5pt;
}

.fs-10pt {
  font-size: 12pt;
}

.fs-12pt {
  font-size: 14pt;
}

.fs-11pt {
  font-size: 11pt;
}

.w-14rem {
  width: 7rem;
  vertical-align: top;
}

.nama {
  overflow: hidden;
  /* max-width: 100px; */
  /* max-height: 15px; */
}

/* .nama::before {
   content: '..'
  } */
.float-right {
  float: right;
}

.text-small {
  font-size: 10px;
  line-height: inherit;
}

.receipt table tr td {
  vertical-align: top;
}

table.invoice-table {
  page-break-after: always;
}

table.invoice-table tr td {
  vertical-align: top;
}

.border-invoice {
  border: 1px solid;
}

@media print {
  .border {
    border: unset !important;
  }
  .border-invoice {
    border: unset !important;
  }
  .cm-1 {
    padding: unset !important;
  }
}
.modal-open {
  overflow: hidden;
}

.tags {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 5px;
}

.tags .tag {
  margin-bottom: 0.1rem;
}

.tags .tag:not(:last-child) {
  margin-right: 0.5rem;
}

.tags:last-child {
  /* margin-bottom: -.5rem */
}

.tags:not(:last-child) {
  margin-bottom: 1rem;
}

.tags.are-medium .tag:not(.is-normal):not(.is-large) {
  font-size: 1rem;
}

.tags.are-large .tag:not(.is-normal):not(.is-medium) {
  font-size: 1.25rem;
}

.tags.is-centered {
  justify-content: center;
}

.tags.is-centered .tag {
  margin-right: 0.25rem;
  margin-left: 0.25rem;
}

.tags.is-right {
  justify-content: flex-end;
}

.tags.is-right .tag:not(:first-child) {
  margin-left: 0.5rem;
}

.tags.is-right .tag:not(:last-child) {
  margin-right: 0;
}

.tags.has-addons .tag {
  margin-right: 0;
}

.tags.has-addons .tag:not(:first-child) {
  margin-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.tags.has-addons .tag:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.tag:not(body) {
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 0.375em;
  color: #4a4a4a;
  display: inline-flex;
  font-size: 0.75rem;
  height: 2em;
  justify-content: center;
  line-height: 1.5;
  padding-left: 0.75em;
  padding-right: 0.75em;
  white-space: nowrap;
}

.tag:not(body) .delete {
  margin-left: 0.25rem;
  margin-right: -0.375rem;
}

.tag:not(body).is-white {
  background-color: #fff;
  color: #0a0a0a;
}

.tag:not(body).is-black {
  background-color: #0a0a0a;
  color: #fff;
}

.tag:not(body).is-light {
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.7);
}

.tag:not(body).is-dark {
  background-color: #363636;
  color: #fff;
}

.tag:not(body).is-primary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-primary-rgb), var(--cui-bg-opacity)) !important;
  color: #fff;
}

.tag:not(body).is-success {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-success-rgb), var(--cui-bg-opacity)) !important;
  color: #fff;
}

.tag:not(body).is-warning {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-warning-rgb), var(--cui-bg-opacity)) !important;
  color: #fff;
}

.tag:not(body).is-danger {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-danger-rgb), var(--cui-bg-opacity)) !important;
  color: #fff;
}

.nav-link.active {
  background-color: var(--cui-btn-bg, transparent);
}

@media (max-width: 767.98px) {
  .is-sm {
    display: grid;
  }
}
.sticky {
  position: sticky !important;
  position: -webkit-sticky !important;
  z-index: 2;
  top: -1px;
  background-color: whitesmoke;
}

.stick {
  display: flex;
  align-items: center;
  background-color: white;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
}

@media only screen and (max-width: 576px) {
  .rc-pagination-options {
    display: block !important;
  }
}
.border-left-primary {
  border-left: 0.25rem solid rgba(var(--cui-primary-rgb), 1) !important;
}

.border-left-success {
  border-left: 0.25rem solid rgba(var(--cui-success-rgb), 1) !important;
}

.border-left-info {
  border-left: 0.25rem solid rgba(var(--cui-info-rgb), 1) !important;
}

.border-left-warning {
  border-left: 0.25rem solid rgba(var(--cui-warning-rgb), 1) !important;
}

.field.is-grouped.is-grouped-multiline:last-child {
  margin-bottom: -0.75rem;
}

.field.is-grouped.is-grouped-multiline {
  flex-wrap: wrap;
}

.field.is-grouped {
  display: flex;
  justify-content: flex-start;
}

/*!
 * animate.css - https://animate.style/
 * Version - 4.1.1
 * Licensed under the Hippocratic License 2.1 - http://firstdonoharm.dev
 *
 * Copyright (c) 2022 Animate.css
 */
:root {
  --animate-duration: 1s;
  --animate-delay: 1s;
  --animate-repeat: 1;
}

.animate__animated {
  animation-duration: 1s;
  animation-duration: var(--animate-duration);
  animation-fill-mode: both;
}

.animate__animated.animate__infinite {
  animation-iteration-count: infinite;
}

.animate__animated.animate__repeat-1 {
  animation-iteration-count: 1;
  animation-iteration-count: var(--animate-repeat);
}

.animate__animated.animate__repeat-2 {
  animation-iteration-count: 2;
  animation-iteration-count: calc(var(--animate-repeat) * 2);
}

.animate__animated.animate__repeat-3 {
  animation-iteration-count: 3;
  animation-iteration-count: calc(var(--animate-repeat) * 3);
}

.animate__animated.animate__delay-1s {
  animation-delay: 1s;
  animation-delay: var(--animate-delay);
}

.animate__animated.animate__delay-2s {
  animation-delay: 2s;
  animation-delay: calc(var(--animate-delay) * 2);
}

.animate__animated.animate__delay-3s {
  animation-delay: 3s;
  animation-delay: calc(var(--animate-delay) * 3);
}

.animate__animated.animate__delay-4s {
  animation-delay: 4s;
  animation-delay: calc(var(--animate-delay) * 4);
}

.animate__animated.animate__delay-5s {
  animation-delay: 5s;
  animation-delay: calc(var(--animate-delay) * 5);
}

.animate__animated.animate__faster {
  animation-duration: 0.5s;
  animation-duration: calc(var(--animate-duration) / 2);
}

.animate__animated.animate__fast {
  animation-duration: 0.8s;
  animation-duration: calc(var(--animate-duration) * 0.8);
}

.animate__animated.animate__slow {
  animation-duration: 2s;
  animation-duration: calc(var(--animate-duration) * 2);
}

.animate__animated.animate__slower {
  animation-duration: 3s;
  animation-duration: calc(var(--animate-duration) * 3);
}

@media print, (prefers-reduced-motion: reduce) {
  .animate__animated {
    animation-duration: 1ms !important;
    transition-duration: 1ms !important;
    animation-iteration-count: 1 !important;
  }
  .animate__animated[class*=Out] {
    opacity: 0;
  }
}
/* Attention seekers  */
@keyframes bounce {
  from, 20%, 53%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }
  40%, 43% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -30px, 0) scaleY(1.1);
  }
  70% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -15px, 0) scaleY(1.05);
  }
  80% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0) scaleY(0.95);
  }
  90% {
    transform: translate3d(0, -4px, 0) scaleY(1.02);
  }
}
.animate__bounce {
  animation-name: bounce;
  transform-origin: center bottom;
}
@keyframes flash {
  from, 50%, to {
    opacity: 1;
  }
  25%, 75% {
    opacity: 0;
  }
}
.animate__flash {
  animation-name: flash;
}

/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */
@keyframes pulse {
  from {
    transform: scale3d(1, 1, 1);
  }
  50% {
    transform: scale3d(1.05, 1.05, 1.05);
  }
  to {
    transform: scale3d(1, 1, 1);
  }
}
.animate__pulse {
  animation-name: pulse;
  animation-timing-function: ease-in-out;
}
@keyframes rubberBand {
  from {
    transform: scale3d(1, 1, 1);
  }
  30% {
    transform: scale3d(1.25, 0.75, 1);
  }
  40% {
    transform: scale3d(0.75, 1.25, 1);
  }
  50% {
    transform: scale3d(1.15, 0.85, 1);
  }
  65% {
    transform: scale3d(0.95, 1.05, 1);
  }
  75% {
    transform: scale3d(1.05, 0.95, 1);
  }
  to {
    transform: scale3d(1, 1, 1);
  }
}
.animate__rubberBand {
  animation-name: rubberBand;
}
@keyframes shakeX {
  from, to {
    transform: translate3d(0, 0, 0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translate3d(-10px, 0, 0);
  }
  20%, 40%, 60%, 80% {
    transform: translate3d(10px, 0, 0);
  }
}
.animate__shakeX {
  animation-name: shakeX;
}
@keyframes shakeY {
  from, to {
    transform: translate3d(0, 0, 0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translate3d(0, -10px, 0);
  }
  20%, 40%, 60%, 80% {
    transform: translate3d(0, 10px, 0);
  }
}
.animate__shakeY {
  animation-name: shakeY;
}
@keyframes headShake {
  0% {
    transform: translateX(0);
  }
  6.5% {
    transform: translateX(-6px) rotateY(-9deg);
  }
  18.5% {
    transform: translateX(5px) rotateY(7deg);
  }
  31.5% {
    transform: translateX(-3px) rotateY(-5deg);
  }
  43.5% {
    transform: translateX(2px) rotateY(3deg);
  }
  50% {
    transform: translateX(0);
  }
}
.animate__headShake {
  animation-timing-function: ease-in-out;
  animation-name: headShake;
}
@keyframes swing {
  20% {
    transform: rotate3d(0, 0, 1, 15deg);
  }
  40% {
    transform: rotate3d(0, 0, 1, -10deg);
  }
  60% {
    transform: rotate3d(0, 0, 1, 5deg);
  }
  80% {
    transform: rotate3d(0, 0, 1, -5deg);
  }
  to {
    transform: rotate3d(0, 0, 1, 0deg);
  }
}
.animate__swing {
  transform-origin: top center;
  animation-name: swing;
}
@keyframes tada {
  from {
    transform: scale3d(1, 1, 1);
  }
  10%, 20% {
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
  }
  30%, 50%, 70%, 90% {
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
  }
  40%, 60%, 80% {
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
  }
  to {
    transform: scale3d(1, 1, 1);
  }
}
.animate__tada {
  animation-name: tada;
}

/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */
@keyframes wobble {
  from {
    transform: translate3d(0, 0, 0);
  }
  15% {
    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);
  }
  30% {
    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);
  }
  45% {
    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);
  }
  60% {
    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);
  }
  75% {
    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animate__wobble {
  animation-name: wobble;
}
@keyframes jello {
  from, 11.1%, to {
    transform: translate3d(0, 0, 0);
  }
  22.2% {
    transform: skewX(-12.5deg) skewY(-12.5deg);
  }
  33.3% {
    transform: skewX(6.25deg) skewY(6.25deg);
  }
  44.4% {
    transform: skewX(-3.125deg) skewY(-3.125deg);
  }
  55.5% {
    transform: skewX(1.5625deg) skewY(1.5625deg);
  }
  66.6% {
    transform: skewX(-0.78125deg) skewY(-0.78125deg);
  }
  77.7% {
    transform: skewX(0.390625deg) skewY(0.390625deg);
  }
  88.8% {
    transform: skewX(-0.1953125deg) skewY(-0.1953125deg);
  }
}
.animate__jello {
  animation-name: jello;
  transform-origin: center;
}
@keyframes heartBeat {
  0% {
    transform: scale(1);
  }
  14% {
    transform: scale(1.3);
  }
  28% {
    transform: scale(1);
  }
  42% {
    transform: scale(1.3);
  }
  70% {
    transform: scale(1);
  }
}
.animate__heartBeat {
  animation-name: heartBeat;
  animation-duration: 1.3s;
  animation-duration: calc(var(--animate-duration) * 1.3);
  animation-timing-function: ease-in-out;
}

/* Back entrances */
@keyframes backInDown {
  0% {
    transform: translateY(-1200px) scale(0.7);
    opacity: 0.7;
  }
  80% {
    transform: translateY(0px) scale(0.7);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.animate__backInDown {
  animation-name: backInDown;
}
@keyframes backInLeft {
  0% {
    transform: translateX(-2000px) scale(0.7);
    opacity: 0.7;
  }
  80% {
    transform: translateX(0px) scale(0.7);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.animate__backInLeft {
  animation-name: backInLeft;
}
@keyframes backInRight {
  0% {
    transform: translateX(2000px) scale(0.7);
    opacity: 0.7;
  }
  80% {
    transform: translateX(0px) scale(0.7);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.animate__backInRight {
  animation-name: backInRight;
}
@keyframes backInUp {
  0% {
    transform: translateY(1200px) scale(0.7);
    opacity: 0.7;
  }
  80% {
    transform: translateY(0px) scale(0.7);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.animate__backInUp {
  animation-name: backInUp;
}

/* Back exits */
@keyframes backOutDown {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  20% {
    transform: translateY(0px) scale(0.7);
    opacity: 0.7;
  }
  100% {
    transform: translateY(700px) scale(0.7);
    opacity: 0.7;
  }
}
.animate__backOutDown {
  animation-name: backOutDown;
}
@keyframes backOutLeft {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  20% {
    transform: translateX(0px) scale(0.7);
    opacity: 0.7;
  }
  100% {
    transform: translateX(-2000px) scale(0.7);
    opacity: 0.7;
  }
}
.animate__backOutLeft {
  animation-name: backOutLeft;
}
@keyframes backOutRight {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  20% {
    transform: translateX(0px) scale(0.7);
    opacity: 0.7;
  }
  100% {
    transform: translateX(2000px) scale(0.7);
    opacity: 0.7;
  }
}
.animate__backOutRight {
  animation-name: backOutRight;
}
@keyframes backOutUp {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  20% {
    transform: translateY(0px) scale(0.7);
    opacity: 0.7;
  }
  100% {
    transform: translateY(-700px) scale(0.7);
    opacity: 0.7;
  }
}
.animate__backOutUp {
  animation-name: backOutUp;
}

/* Bouncing entrances  */
@keyframes bounceIn {
  from, 20%, 40%, 60%, 80%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  20% {
    transform: scale3d(1.1, 1.1, 1.1);
  }
  40% {
    transform: scale3d(0.9, 0.9, 0.9);
  }
  60% {
    opacity: 1;
    transform: scale3d(1.03, 1.03, 1.03);
  }
  80% {
    transform: scale3d(0.97, 0.97, 0.97);
  }
  to {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}
.animate__bounceIn {
  animation-duration: 0.75s;
  animation-duration: calc(var(--animate-duration) * 0.75);
  animation-name: bounceIn;
}
@keyframes bounceInDown {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0) scaleY(3);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0) scaleY(0.9);
  }
  75% {
    transform: translate3d(0, -10px, 0) scaleY(0.95);
  }
  90% {
    transform: translate3d(0, 5px, 0) scaleY(0.985);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animate__bounceInDown {
  animation-name: bounceInDown;
}
@keyframes bounceInLeft {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0) scaleX(3);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0) scaleX(1);
  }
  75% {
    transform: translate3d(-10px, 0, 0) scaleX(0.98);
  }
  90% {
    transform: translate3d(5px, 0, 0) scaleX(0.995);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animate__bounceInLeft {
  animation-name: bounceInLeft;
}
@keyframes bounceInRight {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0) scaleX(3);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0) scaleX(1);
  }
  75% {
    transform: translate3d(10px, 0, 0) scaleX(0.98);
  }
  90% {
    transform: translate3d(-5px, 0, 0) scaleX(0.995);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animate__bounceInRight {
  animation-name: bounceInRight;
}
@keyframes bounceInUp {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0) scaleY(5);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0) scaleY(0.9);
  }
  75% {
    transform: translate3d(0, 10px, 0) scaleY(0.95);
  }
  90% {
    transform: translate3d(0, -5px, 0) scaleY(0.985);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animate__bounceInUp {
  animation-name: bounceInUp;
}

/* Bouncing exits  */
@keyframes bounceOut {
  20% {
    transform: scale3d(0.9, 0.9, 0.9);
  }
  50%, 55% {
    opacity: 1;
    transform: scale3d(1.1, 1.1, 1.1);
  }
  to {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
}
.animate__bounceOut {
  animation-duration: 0.75s;
  animation-duration: calc(var(--animate-duration) * 0.75);
  animation-name: bounceOut;
}
@keyframes bounceOutDown {
  20% {
    transform: translate3d(0, 10px, 0) scaleY(0.985);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, -20px, 0) scaleY(0.9);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0) scaleY(3);
  }
}
.animate__bounceOutDown {
  animation-name: bounceOutDown;
}
@keyframes bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, 0, 0) scaleX(0.9);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0) scaleX(2);
  }
}
.animate__bounceOutLeft {
  animation-name: bounceOutLeft;
}
@keyframes bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0) scaleX(0.9);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0) scaleX(2);
  }
}
.animate__bounceOutRight {
  animation-name: bounceOutRight;
}
@keyframes bounceOutUp {
  20% {
    transform: translate3d(0, -10px, 0) scaleY(0.985);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, 20px, 0) scaleY(0.9);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0) scaleY(3);
  }
}
.animate__bounceOutUp {
  animation-name: bounceOutUp;
}

/* Fading entrances  */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.animate__fadeIn {
  animation-name: fadeIn;
}
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.animate__fadeInDown {
  animation-name: fadeInDown;
}
@keyframes fadeInDownBig {
  from {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.animate__fadeInDownBig {
  animation-name: fadeInDownBig;
}
@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.animate__fadeInLeft {
  animation-name: fadeInLeft;
}
@keyframes fadeInLeftBig {
  from {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.animate__fadeInLeftBig {
  animation-name: fadeInLeftBig;
}
@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.animate__fadeInRight {
  animation-name: fadeInRight;
}
@keyframes fadeInRightBig {
  from {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.animate__fadeInRightBig {
  animation-name: fadeInRightBig;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.animate__fadeInUp {
  animation-name: fadeInUp;
}
@keyframes fadeInUpBig {
  from {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.animate__fadeInUpBig {
  animation-name: fadeInUpBig;
}
@keyframes fadeInTopLeft {
  from {
    opacity: 0;
    transform: translate3d(-100%, -100%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.animate__fadeInTopLeft {
  animation-name: fadeInTopLeft;
}
@keyframes fadeInTopRight {
  from {
    opacity: 0;
    transform: translate3d(100%, -100%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.animate__fadeInTopRight {
  animation-name: fadeInTopRight;
}
@keyframes fadeInBottomLeft {
  from {
    opacity: 0;
    transform: translate3d(-100%, 100%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.animate__fadeInBottomLeft {
  animation-name: fadeInBottomLeft;
}
@keyframes fadeInBottomRight {
  from {
    opacity: 0;
    transform: translate3d(100%, 100%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.animate__fadeInBottomRight {
  animation-name: fadeInBottomRight;
}

/* Fading exits */
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.animate__fadeOut {
  animation-name: fadeOut;
}
@keyframes fadeOutDown {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
}
.animate__fadeOutDown {
  animation-name: fadeOutDown;
}
@keyframes fadeOutDownBig {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}
.animate__fadeOutDownBig {
  animation-name: fadeOutDownBig;
}
@keyframes fadeOutLeft {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
}
.animate__fadeOutLeft {
  animation-name: fadeOutLeft;
}
@keyframes fadeOutLeftBig {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
}
.animate__fadeOutLeftBig {
  animation-name: fadeOutLeftBig;
}
@keyframes fadeOutRight {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
}
.animate__fadeOutRight {
  animation-name: fadeOutRight;
}
@keyframes fadeOutRightBig {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
}
.animate__fadeOutRightBig {
  animation-name: fadeOutRightBig;
}
@keyframes fadeOutUp {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
}
.animate__fadeOutUp {
  animation-name: fadeOutUp;
}
@keyframes fadeOutUpBig {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}
.animate__fadeOutUpBig {
  animation-name: fadeOutUpBig;
}
@keyframes fadeOutTopLeft {
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-100%, -100%, 0);
  }
}
.animate__fadeOutTopLeft {
  animation-name: fadeOutTopLeft;
}
@keyframes fadeOutTopRight {
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(100%, -100%, 0);
  }
}
.animate__fadeOutTopRight {
  animation-name: fadeOutTopRight;
}
@keyframes fadeOutBottomRight {
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(100%, 100%, 0);
  }
}
.animate__fadeOutBottomRight {
  animation-name: fadeOutBottomRight;
}
@keyframes fadeOutBottomLeft {
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-100%, 100%, 0);
  }
}
.animate__fadeOutBottomLeft {
  animation-name: fadeOutBottomLeft;
}

/* Flippers */
@keyframes flip {
  from {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, -360deg);
    animation-timing-function: ease-out;
  }
  40% {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);
    animation-timing-function: ease-out;
  }
  50% {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);
    animation-timing-function: ease-in;
  }
  80% {
    transform: perspective(400px) scale3d(0.95, 0.95, 0.95) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);
    animation-timing-function: ease-in;
  }
  to {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);
    animation-timing-function: ease-in;
  }
}
.animate__animated.animate__flip {
  backface-visibility: visible;
  animation-name: flip;
}
@keyframes flipInX {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}
.animate__flipInX {
  backface-visibility: visible !important;
  animation-name: flipInX;
}
@keyframes flipInY {
  from {
    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}
.animate__flipInY {
  backface-visibility: visible !important;
  animation-name: flipInY;
}
@keyframes flipOutX {
  from {
    transform: perspective(400px);
  }
  30% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }
  to {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
}
.animate__flipOutX {
  animation-duration: 0.75s;
  animation-duration: calc(var(--animate-duration) * 0.75);
  animation-name: flipOutX;
  backface-visibility: visible !important;
}
@keyframes flipOutY {
  from {
    transform: perspective(400px);
  }
  30% {
    transform: perspective(400px) rotate3d(0, 1, 0, -15deg);
    opacity: 1;
  }
  to {
    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    opacity: 0;
  }
}
.animate__flipOutY {
  animation-duration: 0.75s;
  animation-duration: calc(var(--animate-duration) * 0.75);
  backface-visibility: visible !important;
  animation-name: flipOutY;
}

/* Lightspeed */
@keyframes lightSpeedInRight {
  from {
    transform: translate3d(100%, 0, 0) skewX(-30deg);
    opacity: 0;
  }
  60% {
    transform: skewX(20deg);
    opacity: 1;
  }
  80% {
    transform: skewX(-5deg);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animate__lightSpeedInRight {
  animation-name: lightSpeedInRight;
  animation-timing-function: ease-out;
}
@keyframes lightSpeedInLeft {
  from {
    transform: translate3d(-100%, 0, 0) skewX(30deg);
    opacity: 0;
  }
  60% {
    transform: skewX(-20deg);
    opacity: 1;
  }
  80% {
    transform: skewX(5deg);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animate__lightSpeedInLeft {
  animation-name: lightSpeedInLeft;
  animation-timing-function: ease-out;
}
@keyframes lightSpeedOutRight {
  from {
    opacity: 1;
  }
  to {
    transform: translate3d(100%, 0, 0) skewX(30deg);
    opacity: 0;
  }
}
.animate__lightSpeedOutRight {
  animation-name: lightSpeedOutRight;
  animation-timing-function: ease-in;
}
@keyframes lightSpeedOutLeft {
  from {
    opacity: 1;
  }
  to {
    transform: translate3d(-100%, 0, 0) skewX(-30deg);
    opacity: 0;
  }
}
.animate__lightSpeedOutLeft {
  animation-name: lightSpeedOutLeft;
  animation-timing-function: ease-in;
}

/* Rotating entrances */
@keyframes rotateIn {
  from {
    transform: rotate3d(0, 0, 1, -200deg);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
.animate__rotateIn {
  animation-name: rotateIn;
  transform-origin: center;
}
@keyframes rotateInDownLeft {
  from {
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
.animate__rotateInDownLeft {
  animation-name: rotateInDownLeft;
  transform-origin: left bottom;
}
@keyframes rotateInDownRight {
  from {
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
.animate__rotateInDownRight {
  animation-name: rotateInDownRight;
  transform-origin: right bottom;
}
@keyframes rotateInUpLeft {
  from {
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
.animate__rotateInUpLeft {
  animation-name: rotateInUpLeft;
  transform-origin: left bottom;
}
@keyframes rotateInUpRight {
  from {
    transform: rotate3d(0, 0, 1, -90deg);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
.animate__rotateInUpRight {
  animation-name: rotateInUpRight;
  transform-origin: right bottom;
}

/* Rotating exits */
@keyframes rotateOut {
  from {
    opacity: 1;
  }
  to {
    transform: rotate3d(0, 0, 1, 200deg);
    opacity: 0;
  }
}
.animate__rotateOut {
  animation-name: rotateOut;
  transform-origin: center;
}
@keyframes rotateOutDownLeft {
  from {
    opacity: 1;
  }
  to {
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0;
  }
}
.animate__rotateOutDownLeft {
  animation-name: rotateOutDownLeft;
  transform-origin: left bottom;
}
@keyframes rotateOutDownRight {
  from {
    opacity: 1;
  }
  to {
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0;
  }
}
.animate__rotateOutDownRight {
  animation-name: rotateOutDownRight;
  transform-origin: right bottom;
}
@keyframes rotateOutUpLeft {
  from {
    opacity: 1;
  }
  to {
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0;
  }
}
.animate__rotateOutUpLeft {
  animation-name: rotateOutUpLeft;
  transform-origin: left bottom;
}
@keyframes rotateOutUpRight {
  from {
    opacity: 1;
  }
  to {
    transform: rotate3d(0, 0, 1, 90deg);
    opacity: 0;
  }
}
.animate__rotateOutUpRight {
  animation-name: rotateOutUpRight;
  transform-origin: right bottom;
}

/* Specials */
@keyframes hinge {
  0% {
    animation-timing-function: ease-in-out;
  }
  20%, 60% {
    transform: rotate3d(0, 0, 1, 80deg);
    animation-timing-function: ease-in-out;
  }
  40%, 80% {
    transform: rotate3d(0, 0, 1, 60deg);
    animation-timing-function: ease-in-out;
    opacity: 1;
  }
  to {
    transform: translate3d(0, 700px, 0);
    opacity: 0;
  }
}
.animate__hinge {
  animation-duration: 2s;
  animation-duration: calc(var(--animate-duration) * 2);
  animation-name: hinge;
  transform-origin: top left;
}
@keyframes jackInTheBox {
  from {
    opacity: 0;
    transform: scale(0.1) rotate(30deg);
    transform-origin: center bottom;
  }
  50% {
    transform: rotate(-10deg);
  }
  70% {
    transform: rotate(3deg);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.animate__jackInTheBox {
  animation-name: jackInTheBox;
}

/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */
@keyframes rollIn {
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.animate__rollIn {
  animation-name: rollIn;
}

/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */
@keyframes rollOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);
  }
}
.animate__rollOut {
  animation-name: rollOut;
}

/* Zooming entrances */
@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
.animate__zoomIn {
  animation-name: zoomIn;
}
@keyframes zoomInDown {
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}
.animate__zoomInDown {
  animation-name: zoomInDown;
}
@keyframes zoomInLeft {
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}
.animate__zoomInLeft {
  animation-name: zoomInLeft;
}
@keyframes zoomInRight {
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}
.animate__zoomInRight {
  animation-name: zoomInRight;
}
@keyframes zoomInUp {
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}
.animate__zoomInUp {
  animation-name: zoomInUp;
}

/* Zooming exits */
@keyframes zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}
.animate__zoomOut {
  animation-name: zoomOut;
}
@keyframes zoomOutDown {
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  to {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}
.animate__zoomOutDown {
  animation-name: zoomOutDown;
  transform-origin: center bottom;
}
@keyframes zoomOutLeft {
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);
  }
  to {
    opacity: 0;
    transform: scale(0.1) translate3d(-2000px, 0, 0);
  }
}
.animate__zoomOutLeft {
  animation-name: zoomOutLeft;
  transform-origin: left center;
}
@keyframes zoomOutRight {
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);
  }
  to {
    opacity: 0;
    transform: scale(0.1) translate3d(2000px, 0, 0);
  }
}
.animate__zoomOutRight {
  animation-name: zoomOutRight;
  transform-origin: right center;
}
@keyframes zoomOutUp {
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  to {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}
.animate__zoomOutUp {
  animation-name: zoomOutUp;
  transform-origin: center bottom;
}

/* Sliding entrances */
@keyframes slideInDown {
  from {
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animate__slideInDown {
  animation-name: slideInDown;
}
@keyframes slideInLeft {
  from {
    transform: translate3d(-100%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animate__slideInLeft {
  animation-name: slideInLeft;
}
@keyframes slideInRight {
  from {
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animate__slideInRight {
  animation-name: slideInRight;
}
@keyframes slideInUp {
  from {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animate__slideInUp {
  animation-name: slideInUp;
}

/* Sliding exits */
@keyframes slideOutDown {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 100%, 0);
  }
}
.animate__slideOutDown {
  animation-name: slideOutDown;
}
@keyframes slideOutLeft {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-100%, 0, 0);
  }
}
.animate__slideOutLeft {
  animation-name: slideOutLeft;
}
@keyframes slideOutRight {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(100%, 0, 0);
  }
}
.animate__slideOutRight {
  animation-name: slideOutRight;
}
@keyframes slideOutUp {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -100%, 0);
  }
}
.animate__slideOutUp {
  animation-name: slideOutUp;
}

.rc-pagination {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.rc-pagination ol,
.rc-pagination ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.rc-pagination:after {
  display: block;
  clear: both;
  height: 0;
  overflow: hidden;
  visibility: hidden;
  content: " ";
}

.rc-pagination-total-text {
  display: inline-block;
  height: 28px;
  margin-right: 8px;
  line-height: 26px;
  vertical-align: middle;
}

.rc-pagination-item {
  display: inline-block;
  min-width: 28px;
  height: 28px;
  margin-right: 8px;
  line-height: 26px;
  text-align: center;
  vertical-align: middle;
  list-style: none;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  outline: 0;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}

.rc-pagination-item a {
  display: block;
  padding: 0 6px;
  color: rgba(0, 0, 0, 0.85);
  transition: none;
}

.rc-pagination-item a:hover {
  text-decoration: none;
}

.rc-pagination-item:focus,
.rc-pagination-item:hover {
  border-color: #1890ff;
  transition: all 0.3s;
}

.rc-pagination-item:focus a,
.rc-pagination-item:hover a {
  color: #1890ff;
}

.rc-pagination-item-active {
  font-weight: 500;
  background: #fff;
  border-color: #1890ff;
}

.rc-pagination-item-active a {
  color: #1890ff;
}

.rc-pagination-item-active:focus,
.rc-pagination-item-active:hover {
  border-color: #40a9ff;
}

.rc-pagination-item-active:focus a,
.rc-pagination-item-active:hover a {
  color: #40a9ff;
}

.rc-pagination-jump-next,
.rc-pagination-jump-prev {
  outline: 0;
}

.rc-pagination-jump-next button,
.rc-pagination-jump-prev button {
  background: transparent;
  border: none;
  cursor: pointer;
  color: #666;
}

.rc-pagination-jump-next button:after,
.rc-pagination-jump-prev button:after {
  display: block;
  content: "•••";
}

.rc-pagination-jump-next,
.rc-pagination-jump-prev,
.rc-pagination-prev {
  margin-right: 8px;
}

.rc-pagination-jump-next,
.rc-pagination-jump-prev,
.rc-pagination-next,
.rc-pagination-prev {
  display: inline-block;
  min-width: 28px;
  height: 28px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 28px;
  text-align: center;
  vertical-align: middle;
  list-style: none;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s;
}

.rc-pagination-next,
.rc-pagination-prev {
  outline: 0;
}

.rc-pagination-next button,
.rc-pagination-prev button {
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}

.rc-pagination-next:hover button,
.rc-pagination-prev:hover button {
  border-color: #40a9ff;
}

.rc-pagination-next .rc-pagination-item-link,
.rc-pagination-prev .rc-pagination-item-link {
  display: block;
  width: 100%;
  height: 100%;
  font-size: 12px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  outline: none;
  transition: all 0.3s;
}

.rc-pagination-next:focus .rc-pagination-item-link,
.rc-pagination-next:hover .rc-pagination-item-link,
.rc-pagination-prev:focus .rc-pagination-item-link,
.rc-pagination-prev:hover .rc-pagination-item-link {
  color: #1890ff;
  border-color: #1890ff;
}

.rc-pagination-prev button:after {
  content: "‹";
  display: block;
}

.rc-pagination-next button:after {
  content: "›";
  display: block;
}

.rc-pagination-disabled,
.rc-pagination-disabled:focus,
.rc-pagination-disabled:hover {
  cursor: not-allowed;
}

.rc-pagination-disabled .rc-pagination-item-link,
.rc-pagination-disabled:focus .rc-pagination-item-link,
.rc-pagination-disabled:hover .rc-pagination-item-link {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.rc-pagination-slash {
  margin: 0 10px 0 5px;
}

.rc-pagination-options {
  display: inline-block;
  margin-left: 16px;
  vertical-align: middle;
}

@media (-ms-high-contrast: none) {
  .rc-pagination-options,
  .rc-pagination-options ::-ms-backdrop {
    vertical-align: top;
  }
}
.rc-pagination-options-size-changer.rc-select {
  display: inline-block;
  width: auto;
  margin-right: 8px;
}

.rc-pagination-options-quick-jumper {
  display: inline-block;
  height: 28px;
  line-height: 28px;
  vertical-align: top;
}

.rc-pagination-options-quick-jumper input {
  width: 50px;
  margin: 0 8px;
}

.rc-pagination-simple .rc-pagination-next,
.rc-pagination-simple .rc-pagination-prev {
  height: 24px;
  line-height: 24px;
  vertical-align: top;
}

.rc-pagination-simple .rc-pagination-next .rc-pagination-item-link,
.rc-pagination-simple .rc-pagination-prev .rc-pagination-item-link {
  height: 24px;
  background-color: transparent;
  border: 0;
}

.rc-pagination-simple .rc-pagination-next .rc-pagination-item-link:after,
.rc-pagination-simple .rc-pagination-prev .rc-pagination-item-link:after {
  height: 24px;
  line-height: 24px;
}

.rc-pagination-simple .rc-pagination-simple-pager {
  display: inline-block;
  height: 24px;
  margin-right: 8px;
}

.rc-pagination-simple .rc-pagination-simple-pager input {
  box-sizing: border-box;
  height: 100%;
  margin-right: 8px;
  padding: 0 6px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  outline: none;
  transition: border-color 0.3s;
}

.rc-pagination-simple .rc-pagination-simple-pager input:hover {
  border-color: #1890ff;
}

.rc-pagination.rc-pagination-disabled {
  cursor: not-allowed;
}

.rc-pagination.rc-pagination-disabled .rc-pagination-item {
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.rc-pagination.rc-pagination-disabled .rc-pagination-item a {
  color: rgba(0, 0, 0, 0.25);
  background: transparent;
  border: none;
  cursor: not-allowed;
}

.rc-pagination.rc-pagination-disabled .rc-pagination-item-active {
  background: #dbdbdb;
  border-color: transparent;
}

.rc-pagination.rc-pagination-disabled .rc-pagination-item-active a {
  color: #fff;
}

.rc-pagination.rc-pagination-disabled .rc-pagination-item-link {
  color: rgba(0, 0, 0, 0.25);
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.rc-pagination.rc-pagination-disabled .rc-pagination-item-link-icon {
  opacity: 0;
}

.rc-pagination.rc-pagination-disabled .rc-pagination-item-ellipsis {
  opacity: 1;
}

@media only screen and (max-width: 992px) {
  .rc-pagination-item-after-jump-prev,
  .rc-pagination-item-before-jump-next {
    display: none;
  }
}
@media only screen and (max-width: 576px) {
  .rc-pagination-options {
    display: none;
  }
}
* {
  box-sizing: border-box;
}

.rc-select {
  display: inline-block;
  font-size: 12px;
  width: 100px;
  position: relative;
}

.rc-select-disabled,
.rc-select-disabled input {
  cursor: not-allowed;
}

.rc-select-disabled .rc-select-selector {
  opacity: 0.3;
}

.rc-select-show-arrow.rc-select-loading .rc-select-arrow-icon:after {
  box-sizing: border-box;
  width: 12px;
  height: 12px;
  border-radius: 100%;
  border-color: transparent #999;
  border-style: solid;
  border-width: 2px;
  transform: none;
  margin-top: 4px;
  animation: rcSelectLoadingIcon 0.5s infinite;
}

.rc-select .rc-select-selection-placeholder {
  opacity: 0.4;
  pointer-events: none;
}

.rc-select .rc-select-selection-search-input {
  appearance: none;
}

.rc-select .rc-select-selection-search-input::-webkit-search-cancel-button {
  display: none;
  appearance: none;
}

.rc-select-single .rc-select-selector {
  display: flex;
  position: relative;
}

.rc-select-single .rc-select-selector .rc-select-selection-search {
  width: 100%;
}

.rc-select-single .rc-select-selector .rc-select-selection-search-input {
  width: 100%;
}

.rc-select-single .rc-select-selector .rc-select-selection-item,
.rc-select-single .rc-select-selector .rc-select-selection-placeholder {
  position: absolute;
  top: 1px;
  left: 3px;
  pointer-events: none;
}

.rc-select-single:not(.rc-select-customize-input) .rc-select-selector {
  padding: 1px;
  border: 1px solid #000;
}

.rc-select-single:not(.rc-select-customize-input) .rc-select-selector .rc-select-selection-search-input {
  border: none;
  outline: none;
  background: rgba(255, 0, 0, 0.2);
  width: 100%;
}

.rc-select-multiple .rc-select-selector {
  display: flex;
  flex-wrap: wrap;
  padding: 1px;
  border: 1px solid #000;
}

.rc-select-multiple .rc-select-selector .rc-select-selection-item {
  flex: none;
  background: #bbb;
  border-radius: 4px;
  margin-right: 2px;
  padding: 0 8px;
}

.rc-select-multiple .rc-select-selector .rc-select-selection-item-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.rc-select-multiple .rc-select-selector .rc-select-selection-overflow {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.rc-select-multiple .rc-select-selector .rc-select-selection-overflow-item {
  flex: none;
  max-width: 100%;
}

.rc-select-multiple .rc-select-selector .rc-select-selection-search {
  position: relative;
  max-width: 100%;
}

.rc-select-multiple .rc-select-selector .rc-select-selection-search-input,
.rc-select-multiple .rc-select-selector .rc-select-selection-search-mirror {
  padding: 1px;
  font-family: system-ui;
}

.rc-select-multiple .rc-select-selector .rc-select-selection-search-mirror {
  position: absolute;
  z-index: 999;
  white-space: nowrap;
  position: none;
  left: 0;
  top: 0;
  visibility: hidden;
}

.rc-select-multiple .rc-select-selector .rc-select-selection-search-input {
  border: none;
  outline: none;
  background: rgba(255, 0, 0, 0.2);
  width: 100%;
}

.rc-select-allow-clear.rc-select-multiple .rc-select-selector {
  padding-right: 20px;
}

.rc-select-allow-clear .rc-select-clear {
  position: absolute;
  right: 20px;
  top: 0;
}

.rc-select-show-arrow.rc-select-multiple .rc-select-selector {
  padding-right: 20px;
}

.rc-select-show-arrow .rc-select-arrow {
  pointer-events: none;
  position: absolute;
  right: 5px;
  top: 0;
}

.rc-select-show-arrow .rc-select-arrow-icon:after {
  content: "";
  width: 0;
  height: 0;
  display: inline-block;
  border: 5px solid transparent;
  border-top-color: #999;
  transform: translateY(5px);
}

.rc-select-focused .rc-select-selector {
  border-color: #00f !important;
}

.rc-select-dropdown {
  border: 1px solid green;
  min-height: 100px;
  position: absolute;
  background: #fff;
}

.rc-select-dropdown-hidden {
  display: none;
}

.rc-select-item {
  font-size: 16px;
  line-height: 1.5;
  padding: 4px 16px;
}

.rc-select-item-group {
  color: #999;
  font-weight: 700;
  font-size: 80%;
}

.rc-select-item-option {
  position: relative;
}

.rc-select-item-option-grouped {
  padding-left: 24px;
}

.rc-select-item-option .rc-select-item-option-state {
  position: absolute;
  right: 0;
  top: 4px;
  pointer-events: none;
}

.rc-select-item-option-active {
  background: #ddd;
}

.rc-select-item-option-disabled {
  color: #999;
}

.rc-select-item-empty {
  text-align: center;
  color: #999;
}

.rc-select-selection__choice-zoom {
  transition: all 0.3s;
}

.rc-select-selection__choice-zoom-appear {
  opacity: 0;
  transform: scale(0.5);
}

.rc-select-selection__choice-zoom-appear.rc-select-selection__choice-zoom-appear-active {
  opacity: 1;
  transform: scale(1);
}

.rc-select-selection__choice-zoom-leave {
  opacity: 1;
  transform: scale(1);
}

.rc-select-selection__choice-zoom-leave.rc-select-selection__choice-zoom-leave-active {
  opacity: 0;
  transform: scale(0.5);
}

.rc-select-dropdown-slide-up-appear,
.rc-select-dropdown-slide-up-enter {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  transform-origin: 0 0;
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
  animation-play-state: paused;
}

.rc-select-dropdown-slide-up-leave {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  transform-origin: 0 0;
  opacity: 1;
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
  animation-play-state: paused;
}

.rc-select-dropdown-slide-up-appear.rc-select-dropdown-slide-up-appear-active.rc-select-dropdown-placement-bottomLeft,
.rc-select-dropdown-slide-up-appear.rc-select-dropdown-slide-up-appear-active.rc-select-dropdown-placement-bottomRight,
.rc-select-dropdown-slide-up-enter.rc-select-dropdown-slide-up-enter-active.rc-select-dropdown-placement-bottomLeft,
.rc-select-dropdown-slide-up-enter.rc-select-dropdown-slide-up-enter-active.rc-select-dropdown-placement-bottomRight {
  animation-name: rcSelectDropdownSlideUpIn;
  animation-play-state: running;
}

.rc-select-dropdown-slide-up-leave.rc-select-dropdown-slide-up-leave-active.rc-select-dropdown-placement-bottomLeft,
.rc-select-dropdown-slide-up-leave.rc-select-dropdown-slide-up-leave-active.rc-select-dropdown-placement-bottomRight {
  animation-name: rcSelectDropdownSlideUpOut;
  animation-play-state: running;
}

.rc-select-dropdown-slide-up-appear.rc-select-dropdown-slide-up-appear-active.rc-select-dropdown-placement-topLeft,
.rc-select-dropdown-slide-up-enter.rc-select-dropdown-slide-up-enter-active.rc-select-dropdown-placement-topLeft {
  animation-name: rcSelectDropdownSlideDownIn;
  animation-play-state: running;
}

.rc-select-dropdown-slide-up-leave.rc-select-dropdown-slide-up-leave-active.rc-select-dropdown-placement-topLeft {
  animation-name: rcSelectDropdownSlideDownOut;
  animation-play-state: running;
}

@keyframes rcSelectDropdownSlideUpIn {
  0% {
    opacity: 0;
    transform-origin: 0 0;
    transform: scaleY(0);
  }
  to {
    opacity: 1;
    transform-origin: 0 0;
    transform: scaleY(1);
  }
}
@keyframes rcSelectDropdownSlideUpOut {
  0% {
    opacity: 1;
    transform-origin: 0 0;
    transform: scaleY(1);
  }
  to {
    opacity: 0;
    transform-origin: 0 0;
    transform: scaleY(0);
  }
}
@keyframes rcSelectLoadingIcon {
  0% {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
.__dumi-default-previewer {
  background-color: #fff;
  border: 1px solid #ebedf1;
  border-radius: 1px;
}

[data-prefers-color=dark] .__dumi-default-previewer {
  background-color: #141414;
  border-color: #6b6c6d;
}

.__dumi-default-previewer[data-debug] {
  margin-top: 32px;
  border-color: #ffcb00;
}

.__dumi-default-previewer[data-debug]:before {
  content: "DEV ONLY";
  float: left;
  margin-left: -1px;
  margin-top: -18px;
  padding: 3px 6px;
  font-size: 12px;
  line-height: 1;
  background-color: #ffcb00;
  color: #735600;
  text-shadow: 0.5px 0.5px 0 hsla(0, 0%, 100%, 0.5);
  border-top-left-radius: 1px;
  border-top-right-radius: 1px;
}

.__dumi-default-previewer[data-iframe] .__dumi-default-previewer-browser-nav {
  padding: 2px 6px;
  background-color: #ebedf1;
}

.__dumi-default-previewer[data-iframe] .__dumi-default-previewer-browser-nav:before {
  content: "";
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #fd6458;
  box-shadow: 20px 0 0 #ffbf2b, 40px 0 0 #24cc3d;
}

.__dumi-default-previewer[data-iframe] .__dumi-default-previewer-demo > iframe {
  border: 0;
  width: 100%;
  height: 300px;
}

.__dumi-default-previewer + .__dumi-default-previewer {
  margin-top: 32px;
}

.__dumi-default-previewer-demo {
  padding: 40px 24px;
}

.__dumi-default-previewer-target {
  border-color: rgba(69, 105, 212, 0.5);
  box-shadow: 0 0 0 5px rgba(69, 105, 212, 0.05);
}

[data-prefers-color=dark] .__dumi-default-previewer-target {
  box-shadow: 0 0 0 5px rgba(69, 105, 212, 0.3);
}

.__dumi-default-previewer-desc > div:last-child {
  padding: 1.2em 1em 1em;
  color: #454d64;
  border-top: 1px solid #ebedf1;
}

[data-prefers-color=dark] .__dumi-default-previewer-desc > div:last-child {
  border-color: #6b6c6d;
}

.__dumi-default-previewer-desc .markdown > p:first-child {
  margin-top: 0;
}

.__dumi-default-previewer-desc .markdown > p:last-child {
  margin-bottom: 0;
}

.__dumi-default-previewer-desc[data-title] {
  position: relative;
}

.__dumi-default-previewer-desc[data-title] > a:first-child {
  position: absolute;
  top: 0;
  left: 1em;
  margin-left: -4px;
  padding: 0 4px;
  color: #454d64;
  font-size: inherit;
  font-weight: 500;
  background: linear-gradient(0deg, #fff, #fff 50%, hsla(0, 0%, 100%, 0)) 100%;
  transform: translateY(-50%);
  pointer-events: auto;
  cursor: pointer;
}

[data-prefers-color=dark] .__dumi-default-previewer-desc[data-title] > a:first-child {
  color: hsla(0, 0%, 100%, 0.85);
  background: linear-gradient(0deg, #141414, #141414 50%, hsla(0, 0%, 100%, 0)) 100%;
}

.__dumi-default-previewer-desc[data-title]:empty {
  padding-top: 0;
}

.__dumi-default-previewer-desc[data-title]:empty + .__dumi-default-previewer-actions {
  height: 46px;
  border-top-style: solid;
}

.__dumi-default-previewer-actions {
  display: flex;
  height: 40px;
  padding: 0 1em;
  align-items: center;
  border-top: 1px dashed #ebedf1;
}

[data-prefers-color=dark] .__dumi-default-previewer-actions {
  border-color: #6b6c6d;
}

.__dumi-default-previewer-actions > a:not(:last-child),
.__dumi-default-previewer-actions > button:not(:last-child) {
  margin-right: 8px;
}

.__dumi-default-previewer-actions > a {
  display: flex;
}

.__dumi-default-previewer-actions button {
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  padding: 0;
  border: 0;
  box-sizing: border-box;
  cursor: pointer;
  opacity: 0.6;
  outline: none;
  transition: opacity 0.2s, background 0.2s;
}

[data-prefers-color=dark] .__dumi-default-previewer-actions button {
  opacity: 1;
}

.__dumi-default-previewer-actions button:after {
  content: "";
  position: absolute;
  top: -8px;
  left: -8px;
  right: -8px;
  bottom: -8px;
}

.__dumi-default-previewer-actions button:hover {
  opacity: 0.8;
}

.__dumi-default-previewer-actions button:active {
  opacity: 0.9;
}

.__dumi-default-previewer-actions button:disabled {
  opacity: 0.2;
  cursor: not-allowed;
}

.__dumi-default-previewer-actions button[role=codesandbox] {
  background-position: -18px 0;
}

.__dumi-default-previewer-actions button[role=codepen] {
  background-position: -36px 0;
}

.__dumi-default-previewer-actions button[role=source] {
  background-position: -72px 0;
}

.__dumi-default-previewer-actions button[role=change-jsx] {
  background-position: -90px 0;
}

.__dumi-default-previewer-actions button[role=change-tsx] {
  background-position: -108px 0;
}

.__dumi-default-previewer-actions button[role=open-demo] {
  background-position: -126px 0;
}

.__dumi-default-previewer-actions button[role=motions] {
  background-position: -162px 0;
}

.__dumi-default-previewer-actions button[role=sketch-component] {
  background-position: -182px 0;
}

.__dumi-default-previewer-actions button[role=sketch-group] {
  background-position: -200px 0;
}

.__dumi-default-previewer-actions button[role=copy][data-status=ready] {
  background-position: -54px 0;
}

.__dumi-default-previewer-actions button[role=copy][data-status=copied] {
  pointer-events: none;
  background-position: -54px -16px;
}

.__dumi-default-previewer-actions button[role=refresh] {
  background-position-x: -144px;
}

.__dumi-default-previewer-actions > span {
  flex: 1 1;
  display: inline-block;
}

.__dumi-default-previewer-source {
  border-top: 1px dashed #ebedf1;
}

[data-prefers-color=dark] .__dumi-default-previewer-source {
  border-color: #6b6c6d;
}

.__dumi-default-previewer-source-tab {
  border-top: 1px dashed #ebedf1;
}

[data-prefers-color=dark] .__dumi-default-previewer-source-tab {
  border-color: #6b6c6d;
}

.__dumi-default-previewer-source-tab .__dumi-default-tabs-tab-btn {
  position: relative;
  padding-left: 32px;
}

.__dumi-default-previewer-source-tab .__dumi-default-tabs-tab-btn:after,
.__dumi-default-previewer-source-tab .__dumi-default-tabs-tab-btn:before {
  content: "";
  position: absolute;
  margin-right: 4px;
  display: inline-block;
  box-sizing: border-box;
}

.__dumi-default-previewer-source-tab .__dumi-default-tabs-tab-btn:before {
  left: 16px;
  top: 50%;
  margin-top: -6px;
  width: 10px;
  height: 12px;
  border: 1px solid #717484;
}

.__dumi-default-previewer-source-tab .__dumi-default-tabs-tab-btn:after {
  top: 50%;
  left: 23px;
  margin-top: -7px;
  width: 4px;
  height: 4px;
  background: #fff;
  border-bottom: 1px solid #717484;
  transform: rotate(45deg);
}

[data-prefers-color=dark] .__dumi-default-previewer-source-tab .__dumi-default-tabs-tab-btn:after {
  background: #141414;
}

.__dumi-default-tabs {
  overflow: hidden;
}

.__dumi-default-tabs.__dumi-default-tabs-top {
  flex-direction: column;
}

.__dumi-default-tabs.__dumi-default-tabs-top .__dumi-default-tabs-ink-bar {
  bottom: 0;
}

.__dumi-default-tabs-nav {
  display: flex;
}

.__dumi-default-tabs-nav-wrap {
  display: flex;
  white-space: nowrap;
  overflow: hidden;
}

.__dumi-default-tabs-nav-wrap.__dumi-default-tabs-nav-wrap-ping-left {
  box-shadow: inset 5px 0 5px -5px rgba(0, 0, 0, 0.1);
}

.__dumi-default-tabs-nav-wrap.__dumi-default-tabs-nav-wrap-ping-right ~ * > .__dumi-default-tabs-nav-more {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.__dumi-default-tabs-nav-list {
  position: relative;
  display: flex;
  transition: transform 0.2s;
}

.__dumi-default-tabs-nav-more {
  height: 100%;
  cursor: pointer;
  background: none;
  border: 0;
  transition: box-shadow 0.2s;
}

.__dumi-default-tabs-tab {
  display: flex;
}

.__dumi-default-tabs-tab-btn {
  padding: 0 16px;
  font-size: 14px;
  line-height: 36px;
  border: 0;
  outline: none;
  background: transparent;
  box-sizing: border-box;
  cursor: pointer;
}

.__dumi-default-tabs-tab-btn:hover {
  color: #4569d4;
}

.__dumi-default-tabs-ink-bar {
  position: absolute;
  height: 2px;
  background: #4569d4;
  transition: left 0.2s, width 0.2s;
  pointer-events: none;
}

[data-prefers-color=dark] .__dumi-default-tabs-ink-bar {
  background: #7395f7;
}

.__dumi-default-tabs-dropdown {
  position: absolute;
  background: #fff;
  border: 1px solid #ebedf1;
  max-height: 200px;
  overflow: auto;
}

.__dumi-default-tabs-dropdown > ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.__dumi-default-tabs-dropdown > ul > li {
  padding: 4px 12px;
  font-size: 14px;
  cursor: pointer;
}

.__dumi-default-tabs-dropdown > ul > li:hover {
  color: #4569d4;
}

.__dumi-default-tabs-dropdown > ul > li:not(:last-child) {
  border-bottom: 1px dashed #ebedf1;
}

.__dumi-default-tabs-dropdown-hidden {
  display: none;
}

code[class*=language-],
pre[class*=language-] {
  color: #000;
  background: none;
  text-shadow: 0 1px #fff;
  font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
  font-size: 1em;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  tab-size: 4;
  hyphens: none;
}

code[class*=language-]::selection,
code[class*=language-] ::selection,
pre[class*=language-]::selection,
pre[class*=language-] ::selection {
  text-shadow: none;
  background: #b3d4fc;
}

@media print {
  code[class*=language-],
  pre[class*=language-] {
    text-shadow: none;
  }
}
pre[class*=language-] {
  padding: 1em;
  margin: 0.5em 0;
  overflow: auto;
}

:not(pre) > code[class*=language-],
pre[class*=language-] {
  background: #f5f2f0;
}

:not(pre) > code[class*=language-] {
  padding: 0.1em;
  border-radius: 0.3em;
  white-space: normal;
}

.token.cdata,
.token.comment,
.token.doctype,
.token.prolog {
  color: #708090;
}

.token.punctuation {
  color: #999;
}

.token.namespace {
  opacity: 0.7;
}

.token.boolean,
.token.constant,
.token.deleted,
.token.number,
.token.property,
.token.symbol,
.token.tag {
  color: #905;
}

.token.attr-name,
.token.builtin,
.token.char,
.token.inserted,
.token.selector,
.token.string {
  color: #690;
}

.language-css .token.string,
.style .token.string,
.token.entity,
.token.operator,
.token.url {
  color: #9a6e3a;
  background: hsla(0, 0%, 100%, 0.5);
}

.token.atrule,
.token.attr-value,
.token.keyword {
  color: #07a;
}

.token.class-name,
.token.function {
  color: #dd4a68;
}

.token.important,
.token.regex,
.token.variable {
  color: #e90;
}

.token.bold,
.token.important {
  font-weight: 700;
}

.token.italic {
  font-style: italic;
}

.token.entity {
  cursor: help;
}

.__dumi-default-code-block {
  position: relative;
  font-size: 14px;
  background-color: #f9fafb;
}

[data-prefers-color=dark] .__dumi-default-code-block {
  color: hsla(0, 0%, 100%, 0.85);
  background: #262626;
}

.__dumi-default-code-block + .__dumi-default-code-block,
.__dumi-default-code-block + table {
  margin-top: 16px;
}

.__dumi-default-code-block > pre[class*=language-] {
  margin: 0;
  background: transparent;
}

.__dumi-default-code-block > pre[class*=language-] .token-line:not(:last-child) .plain:empty {
  display: inline-block;
  min-height: 1em;
}

.__dumi-default-code-block-copy-btn {
  position: absolute;
  top: 1.1em;
  right: 1em;
  display: inline-block;
  width: 16px;
  height: 16px;
  padding: 0;
  border: 0;
  outline: none;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.2s, background 0.2s;
}

.__dumi-default-code-block-copy-btn:hover {
  opacity: 0.8;
}

.__dumi-default-code-block-copy-btn:active {
  opacity: 0.9;
}

.__dumi-default-code-block-copy-btn[data-status=ready] {
  background-position: -54px 0;
}

.__dumi-default-code-block-copy-btn[data-status=copied] {
  opacity: 1;
  pointer-events: none;
  background-position: -54px -16px;
}

.__dumi-default-code-block:not(:hover) .__dumi-default-code-block-copy-btn {
  visibility: hidden;
  opacity: 0;
}

code[class*=language-]::selection,
code[class*=language-] ::selection,
pre[class*=language-]::selection,
pre[class*=language-] ::selection {
  color: inherit;
}

[data-prefers-color=dark] code[class*=language-],
[data-prefers-color=dark] pre[class*=language-] {
  color: hsla(0, 0%, 100%, 0.85);
  text-shadow: 0 1px #000;
}

[data-prefers-color=dark] code[class*=language-]::selection,
[data-prefers-color=dark] code[class*=language-] ::selection,
[data-prefers-color=dark] pre[class*=language-]::selection,
[data-prefers-color=dark] pre[class*=language-] ::selection {
  background-color: #364a63;
}

[data-prefers-color=dark] .language-css .token.string,
[data-prefers-color=dark] .style .token.string,
[data-prefers-color=dark] .token.entity,
[data-prefers-color=dark] .token.operator,
[data-prefers-color=dark] .token.url {
  background: transparent;
}

[data-prefers-color=dark] .token.constant,
[data-prefers-color=dark] .token.deleted,
[data-prefers-color=dark] .token.property,
[data-prefers-color=dark] .token.symbol,
[data-prefers-color=dark] .token.tag {
  color: #f92672;
}

[data-prefers-color=dark] .token.attr-name,
[data-prefers-color=dark] .token.builtin,
[data-prefers-color=dark] .token.char,
[data-prefers-color=dark] .token.inserted,
[data-prefers-color=dark] .token.selector,
[data-prefers-color=dark] .token.string {
  color: #a6e22e;
}

[data-prefers-color=dark] .token.atrule,
[data-prefers-color=dark] .token.attr-value,
[data-prefers-color=dark] .token.keyword {
  color: #e6db74;
}

[data-prefers-color=dark] .token.punctuation {
  color: hsla(0, 0%, 100%, 0.85);
}

[data-prefers-color=dark] .token.keyword {
  color: #66d9ef;
}

[data-prefers-color=dark] .token.boolean,
[data-prefers-color=dark] .token.number {
  color: #ae81ff;
}

.markdown {
  color: #454d64;
  font-size: 15px;
  line-height: 1.60625;
}

[data-prefers-color=dark] .markdown {
  color: hsla(0, 0%, 100%, 0.65);
}

.markdown:not(:first-child):empty {
  min-height: 32px;
}

.markdown h1, .markdown .h1,
.markdown h2,
.markdown .h2,
.markdown h3,
.markdown .h3,
.markdown h4,
.markdown .h4,
.markdown h5,
.markdown .h5,
.markdown h6,
.markdown .h6 {
  margin: 42px 0 18px;
  color: #454d64;
  font-weight: 500;
  line-height: 1.40625;
}

[data-prefers-color=dark] .markdown h1, [data-prefers-color=dark] .markdown .h1,
[data-prefers-color=dark] .markdown h2,
[data-prefers-color=dark] .markdown .h2,
[data-prefers-color=dark] .markdown h3,
[data-prefers-color=dark] .markdown .h3,
[data-prefers-color=dark] .markdown h4,
[data-prefers-color=dark] .markdown .h4,
[data-prefers-color=dark] .markdown h5,
[data-prefers-color=dark] .markdown .h5,
[data-prefers-color=dark] .markdown h6,
[data-prefers-color=dark] .markdown .h6 {
  color: hsla(0, 0%, 100%, 0.85);
}

.markdown h1:hover > a[aria-hidden], .markdown .h1:hover > a[aria-hidden],
.markdown h2:hover > a[aria-hidden],
.markdown .h2:hover > a[aria-hidden],
.markdown h3:hover > a[aria-hidden],
.markdown .h3:hover > a[aria-hidden],
.markdown h4:hover > a[aria-hidden],
.markdown .h4:hover > a[aria-hidden],
.markdown h5:hover > a[aria-hidden],
.markdown .h5:hover > a[aria-hidden],
.markdown h6:hover > a[aria-hidden],
.markdown .h6:hover > a[aria-hidden] {
  float: left;
  margin-top: 0.06em;
  margin-left: -20px;
  width: 20px;
  padding-right: 4px;
  line-height: 1;
  box-sizing: border-box;
}

@media only screen and (max-width: 767px) {
  .markdown h1:hover > a[aria-hidden], .markdown .h1:hover > a[aria-hidden],
  .markdown h2:hover > a[aria-hidden],
  .markdown .h2:hover > a[aria-hidden],
  .markdown h3:hover > a[aria-hidden],
  .markdown .h3:hover > a[aria-hidden],
  .markdown h4:hover > a[aria-hidden],
  .markdown .h4:hover > a[aria-hidden],
  .markdown h5:hover > a[aria-hidden],
  .markdown .h5:hover > a[aria-hidden],
  .markdown h6:hover > a[aria-hidden],
  .markdown .h6:hover > a[aria-hidden] {
    width: 14px;
    margin-left: -14px;
  }
}
.markdown h1:hover > a[aria-hidden]:after, .markdown .h1:hover > a[aria-hidden]:after,
.markdown h2:hover > a[aria-hidden]:after,
.markdown .h2:hover > a[aria-hidden]:after,
.markdown h3:hover > a[aria-hidden]:after,
.markdown .h3:hover > a[aria-hidden]:after,
.markdown h4:hover > a[aria-hidden]:after,
.markdown .h4:hover > a[aria-hidden]:after,
.markdown h5:hover > a[aria-hidden]:after,
.markdown .h5:hover > a[aria-hidden]:after,
.markdown h6:hover > a[aria-hidden]:after,
.markdown .h6:hover > a[aria-hidden]:after {
  content: "#";
  display: inline-block;
  vertical-align: middle;
  font-size: 20px;
}

.markdown h1:hover > a[aria-hidden] span, .markdown .h1:hover > a[aria-hidden] span,
.markdown h2:hover > a[aria-hidden] span,
.markdown .h2:hover > a[aria-hidden] span,
.markdown h3:hover > a[aria-hidden] span,
.markdown .h3:hover > a[aria-hidden] span,
.markdown h4:hover > a[aria-hidden] span,
.markdown .h4:hover > a[aria-hidden] span,
.markdown h5:hover > a[aria-hidden] span,
.markdown .h5:hover > a[aria-hidden] span,
.markdown h6:hover > a[aria-hidden] span,
.markdown .h6:hover > a[aria-hidden] span {
  display: none;
}

.markdown h1 + h1, .markdown .h1 + h1, .markdown h1 + .h1, .markdown .h1 + .h1,
.markdown h1 + h2,
.markdown .h1 + h2,
.markdown h1 + .h2,
.markdown .h1 + .h2,
.markdown h1 + h3,
.markdown .h1 + h3,
.markdown h1 + .h3,
.markdown .h1 + .h3,
.markdown h1 + h4,
.markdown .h1 + h4,
.markdown h1 + .h4,
.markdown .h1 + .h4,
.markdown h1 + h5,
.markdown .h1 + h5,
.markdown h1 + .h5,
.markdown .h1 + .h5,
.markdown h1 + h6,
.markdown .h1 + h6,
.markdown h1 + .h6,
.markdown .h1 + .h6,
.markdown h2 + h1,
.markdown .h2 + h1,
.markdown h2 + .h1,
.markdown .h2 + .h1,
.markdown h2 + h2,
.markdown .h2 + h2,
.markdown h2 + .h2,
.markdown .h2 + .h2,
.markdown h2 + h3,
.markdown .h2 + h3,
.markdown h2 + .h3,
.markdown .h2 + .h3,
.markdown h2 + h4,
.markdown .h2 + h4,
.markdown h2 + .h4,
.markdown .h2 + .h4,
.markdown h2 + h5,
.markdown .h2 + h5,
.markdown h2 + .h5,
.markdown .h2 + .h5,
.markdown h2 + h6,
.markdown .h2 + h6,
.markdown h2 + .h6,
.markdown .h2 + .h6,
.markdown h3 + h1,
.markdown .h3 + h1,
.markdown h3 + .h1,
.markdown .h3 + .h1,
.markdown h3 + h2,
.markdown .h3 + h2,
.markdown h3 + .h2,
.markdown .h3 + .h2,
.markdown h3 + h3,
.markdown .h3 + h3,
.markdown h3 + .h3,
.markdown .h3 + .h3,
.markdown h3 + h4,
.markdown .h3 + h4,
.markdown h3 + .h4,
.markdown .h3 + .h4,
.markdown h3 + h5,
.markdown .h3 + h5,
.markdown h3 + .h5,
.markdown .h3 + .h5,
.markdown h3 + h6,
.markdown .h3 + h6,
.markdown h3 + .h6,
.markdown .h3 + .h6,
.markdown h4 + h1,
.markdown .h4 + h1,
.markdown h4 + .h1,
.markdown .h4 + .h1,
.markdown h4 + h2,
.markdown .h4 + h2,
.markdown h4 + .h2,
.markdown .h4 + .h2,
.markdown h4 + h3,
.markdown .h4 + h3,
.markdown h4 + .h3,
.markdown .h4 + .h3,
.markdown h4 + h4,
.markdown .h4 + h4,
.markdown h4 + .h4,
.markdown .h4 + .h4,
.markdown h4 + h5,
.markdown .h4 + h5,
.markdown h4 + .h5,
.markdown .h4 + .h5,
.markdown h4 + h6,
.markdown .h4 + h6,
.markdown h4 + .h6,
.markdown .h4 + .h6,
.markdown h5 + h1,
.markdown .h5 + h1,
.markdown h5 + .h1,
.markdown .h5 + .h1,
.markdown h5 + h2,
.markdown .h5 + h2,
.markdown h5 + .h2,
.markdown .h5 + .h2,
.markdown h5 + h3,
.markdown .h5 + h3,
.markdown h5 + .h3,
.markdown .h5 + .h3,
.markdown h5 + h4,
.markdown .h5 + h4,
.markdown h5 + .h4,
.markdown .h5 + .h4,
.markdown h5 + h5,
.markdown .h5 + h5,
.markdown h5 + .h5,
.markdown .h5 + .h5,
.markdown h5 + h6,
.markdown .h5 + h6,
.markdown h5 + .h6,
.markdown .h5 + .h6,
.markdown h6 + h1,
.markdown .h6 + h1,
.markdown h6 + .h1,
.markdown .h6 + .h1,
.markdown h6 + h2,
.markdown .h6 + h2,
.markdown h6 + .h2,
.markdown .h6 + .h2,
.markdown h6 + h3,
.markdown .h6 + h3,
.markdown h6 + .h3,
.markdown .h6 + .h3,
.markdown h6 + h4,
.markdown .h6 + h4,
.markdown h6 + .h4,
.markdown .h6 + .h4,
.markdown h6 + h5,
.markdown .h6 + h5,
.markdown h6 + .h5,
.markdown .h6 + .h5,
.markdown h6 + h6,
.markdown .h6 + h6,
.markdown h6 + .h6,
.markdown .h6 + .h6 {
  margin-top: 16px;
}

.markdown h1, .markdown .h1 {
  margin-top: 48px;
  margin-bottom: 32px;
  font-size: 32px;
}

.markdown h2, .markdown .h2 {
  font-size: 24px;
}

.markdown h3, .markdown .h3 {
  font-size: 20px;
}

.markdown h4, .markdown .h4 {
  font-size: 18px;
}

.markdown h5, .markdown .h5 {
  font-size: 16px;
}

.markdown h6, .markdown .h6 {
  font-size: 14px;
}

.markdown p {
  margin: 16px 0;
}

.markdown :not(pre) code {
  padding: 2px 5px;
  color: #d56161;
  background: #f6f7f9;
}

[data-prefers-color=dark] .markdown :not(pre) code {
  color: #ff7875;
  background: hsla(0, 0%, 100%, 0.08);
}

.markdown code {
  font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
}

.markdown pre {
  font-size: 14px;
  background: #f6f7f9;
}

.markdown pre:not([class^=language-]) {
  padding: 1em;
}

.markdown hr {
  margin: 16px 0;
  border: 0;
  border-top: 1px solid #ebedf1;
}

.markdown blockquote {
  margin: 16px 0;
  padding: 0 24px;
  color: rgba(69, 77, 100, 0.7);
  border-left: 4px solid #ebedf1;
  overflow: hidden;
}

[data-prefers-color=dark] .markdown blockquote {
  color: hsla(0, 0%, 100%, 0.55);
  border-color: #6b6c6d;
}

.markdown ol,
.markdown ul {
  margin: 8px 0 8px 32px;
  padding: 0;
}

.markdown ol li,
.markdown ul li {
  margin-bottom: 4px;
}

.markdown table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ebedf1;
}

[data-prefers-color=dark] .markdown table {
  border: 1px solid #3b434b;
}

.markdown table td,
.markdown table th {
  padding: 10px 24px;
  border: 1px solid #ebedf1;
}

[data-prefers-color=dark] .markdown table td,
[data-prefers-color=dark] .markdown table th {
  border: 1px solid #3b434b;
}

.markdown table th {
  font-weight: 600;
  background: #f9fafb;
}

[data-prefers-color=dark] .markdown table th {
  background: hsla(0, 0%, 100%, 0.08);
}

.markdown table td:first-child {
  font-weight: 500;
}

.markdown table a svg {
  display: none;
}

.markdown a {
  color: #4569d4;
  text-decoration: none;
  transition: opacity 0.2s;
  outline: none;
}

[data-prefers-color=dark] .markdown a {
  color: #7395f7;
}

.markdown a:hover {
  opacity: 0.7;
  text-decoration: underline;
}

.markdown a:active {
  opacity: 0.9;
}

.markdown img {
  max-width: 100%;
}

.__dumi-default-external-link-icon {
  vertical-align: -0.155em;
  margin-left: 2px;
}

[data-prefers-color=dark] h1, [data-prefers-color=dark] .h1,
[data-prefers-color=dark] h2,
[data-prefers-color=dark] .h2,
[data-prefers-color=dark] h3,
[data-prefers-color=dark] .h3,
[data-prefers-color=dark] h4,
[data-prefers-color=dark] .h4 {
  color: hsla(0, 0%, 100%, 0.85);
}

.__dumi-default-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) no-repeat 0 0/230px auto;
}

[data-prefers-color=dark] body {
  color: hsla(0, 0%, 100%, 0.85);
  background-color: #141414;
}

.__dumi-default-layout {
  box-sizing: border-box;
  min-height: 100vh;
  padding: 16px 194px 50px 318px;
}

@media only screen and (max-width: 767px) {
  .__dumi-default-layout {
    padding-top: 66px !important;
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
}
.__dumi-default-layout[data-gapless=true] {
  padding-top: 64px !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  padding-bottom: 0;
}

@media only screen and (max-width: 767px) {
  .__dumi-default-layout[data-gapless=true] {
    padding-top: 50px !important;
  }
}
.__dumi-default-layout[data-show-sidemenu=false] {
  padding-left: 58px;
}

.__dumi-default-layout[data-show-slugs=false] {
  padding-right: 58px;
}

.__dumi-default-layout[data-site-mode=true] {
  padding-top: 114px;
}

.__dumi-default-layout[data-site-mode=true][data-show-sidemenu=true] {
  padding-left: 350px;
}

.__dumi-default-layout[data-site-mode=true][data-show-slugs=true] {
  padding-right: 208px;
}

.__dumi-default-layout[data-site-mode=true] .__dumi-default-layout-content > .markdown:first-child > :first-child {
  margin-top: 0;
}

.__dumi-default-layout[data-site-mode=true] .__dumi-default-layout-toc {
  top: 114px;
  max-height: calc(90vh - 144px);
}

.__dumi-default-layout-hero {
  margin: -50px -58px 0;
  padding: 100px 0;
  text-align: center;
  background-color: #f5f6f8;
}

[data-prefers-color=dark] .__dumi-default-layout-hero {
  background-color: hsla(0, 0%, 100%, 0.08);
}

@media only screen and (max-width: 767px) {
  .__dumi-default-layout-hero {
    margin: -16px -16px 0;
    padding: 48px 0;
  }
}
.__dumi-default-layout-hero img {
  max-width: 100%;
  max-height: 200px;
  margin-bottom: 1rem;
}

.__dumi-default-layout-hero h1, .__dumi-default-layout-hero .h1 {
  margin: 0 0 16px;
  font-size: 48px;
  font-weight: 600;
  line-height: 56px;
  color: #080e29;
}

[data-prefers-color=dark] .__dumi-default-layout-hero h1, [data-prefers-color=dark] .__dumi-default-layout-hero .h1 {
  color: hsla(0, 0%, 100%, 0.85);
}

.__dumi-default-layout-hero h1 + div, .__dumi-default-layout-hero .h1 + div {
  margin: 16px 0 32px;
  opacity: 0.78;
}

.__dumi-default-layout-hero h1 + div .markdown, .__dumi-default-layout-hero .h1 + div .markdown {
  font-size: 16px;
}

.__dumi-default-layout-hero button {
  margin-right: 16px;
  padding: 0 32px;
  height: 44px;
  color: #4569d4;
  font-size: 16px;
  background: transparent;
  border: 1px solid #4569d4;
  border-radius: 22px;
  box-sizing: border-box;
  cursor: pointer;
  outline: none;
  transition: all 0.3s;
}

.__dumi-default-layout-hero button:hover {
  opacity: 0.8;
}

.__dumi-default-layout-hero button:active {
  opacity: 0.9;
}

.__dumi-default-layout-hero a:last-child button {
  margin-right: 0;
  color: #fff;
  background: #4569d4;
}

.__dumi-default-layout-features {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 96px;
  grid-row-gap: 56px;
  padding: 72px 0;
}

.__dumi-default-layout-features > dl {
  flex: 1 1;
  margin: 0;
  text-align: center;
  background: no-repeat top/auto 48px;
}

.__dumi-default-layout-features > dl[style*=background-image] {
  padding-top: 64px;
}

.__dumi-default-layout-features > dl dt {
  margin-bottom: 12px;
  font-size: 20px;
  line-height: 1;
  color: #454d64;
}

[data-prefers-color=dark] .__dumi-default-layout-features > dl dt {
  color: hsla(0, 0%, 100%, 0.85);
}

.__dumi-default-layout-features > dl a {
  transition-duration: none;
}

.__dumi-default-layout-features > dl a dt {
  color: #4569d4;
  transition: opacity 0.2s;
}

.__dumi-default-layout-features > dl a dt:hover {
  opacity: 0.7;
  text-decoration: underline;
}

.__dumi-default-layout-features > dl a dt:active {
  opacity: 0.9;
}

.__dumi-default-layout-features > dl dd {
  margin: 0;
}

.__dumi-default-layout-features > dl dd .markdown {
  color: #717484;
  font-size: 14px;
  line-height: 22px;
}

[data-prefers-color=dark] .__dumi-default-layout-features > dl dd .markdown {
  color: hsla(0, 0%, 100%, 0.65);
}

.__dumi-default-layout-features > dl dd .markdown > p:first-child {
  margin-top: 0;
}

.__dumi-default-layout-features > dl dd .markdown > p:last-child {
  margin-bottom: 0;
}

@media only screen and (max-width: 767px) {
  .__dumi-default-layout-features {
    display: block;
    padding: 40px 0;
  }
  .__dumi-default-layout-features > dl {
    text-align: left;
    background-position: 0 0;
  }
  .__dumi-default-layout-features > dl[style*=background-image] {
    padding: 0 0 0 60px;
  }
  .__dumi-default-layout-features > dl + dl {
    margin-top: 32px;
  }
}
.__dumi-default-layout-features,
.__dumi-default-layout-features + .__dumi-default-layout-content,
.__dumi-default-layout-hero + .__dumi-default-layout-content {
  margin-left: auto;
  margin-right: auto;
  max-width: 960px;
}

.__dumi-default-layout-hero + .__dumi-default-layout-content {
  margin-top: 60px;
}

.__dumi-default-layout-toc {
  list-style: none;
  position: fixed;
  z-index: 10;
  top: 50px;
  right: 0;
  width: 136px;
  max-height: calc(90vh - 80px);
  margin: 0;
  padding: 0 24px 0 0;
  background-color: #fff;
  box-sizing: content-box;
  overflow: auto;
}

[data-prefers-color=dark] .__dumi-default-layout-toc {
  background-color: #141414;
}

@media only screen and (max-width: 767px) {
  .__dumi-default-layout-toc {
    display: none;
  }
}
.__dumi-default-layout-toc li {
  position: relative;
  margin: 0;
  padding: 4px 0 4px 6px;
  text-indent: 12px;
  font-size: 13px;
  line-height: 1.40625;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.__dumi-default-layout-toc li a {
  color: #454d64;
  text-decoration: none;
}

[data-prefers-color=dark] .__dumi-default-layout-toc li a {
  color: hsla(0, 0%, 100%, 0.85);
}

.__dumi-default-layout-toc li a:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  display: inline-block;
  width: 2px;
  background: #ebedf1;
}

.__dumi-default-layout-toc li a:hover {
  color: #5a7ad9;
}

[data-prefers-color=dark] .__dumi-default-layout-toc li a:hover {
  color: #8ba7f8;
}

.__dumi-default-layout-toc li a:active {
  color: #5173d7;
}

[data-prefers-color=dark] .__dumi-default-layout-toc li a:active {
  color: #81a0f8;
}

.__dumi-default-layout-toc li a.active {
  color: #4569d4;
}

[data-prefers-color=dark] .__dumi-default-layout-toc li a.active {
  color: #7395f7;
}

.__dumi-default-layout-toc li a.active:before {
  background: #4569d4;
}

[data-prefers-color=dark] .__dumi-default-layout-toc li a.active:before {
  background: #7395f7;
}

.__dumi-default-layout-footer-meta {
  margin-top: 40px;
  padding-top: 24px;
  display: flex;
  color: #717484;
  font-size: 14px;
  justify-content: space-between;
  border-top: 1px solid #ebedf1;
}

[data-prefers-color=dark] .__dumi-default-layout-footer-meta {
  color: hsla(0, 0%, 100%, 0.65);
  border-color: #6b6c6d;
}

@media only screen and (max-width: 960px) {
  .__dumi-default-layout-footer-meta {
    display: block;
  }
}
.__dumi-default-layout-footer-meta > a {
  margin-bottom: 4px;
  display: block;
  color: #4569d4;
  transition: opacity 0.2s;
  text-decoration: none;
}

[data-prefers-color=dark] .__dumi-default-layout-footer-meta > a {
  color: #7395f7;
}

.__dumi-default-layout-footer-meta > a:hover {
  opacity: 0.7;
  text-decoration: underline;
}

.__dumi-default-layout-footer-meta > a:active {
  opacity: 0.9;
}

.__dumi-default-layout-footer-meta > span:last-child:before {
  content: attr(data-updated-text);
  color: #4569d4;
}

[data-prefers-color=dark] .__dumi-default-layout-footer-meta > span:last-child:before {
  color: #7395f7;
}

.__dumi-default-layout-footer {
  margin: 72px 0 -32px;
  padding-top: 24px;
  border-top: 1px solid #ebedf1;
  text-align: center;
}

[data-prefers-color=dark] .__dumi-default-layout-footer {
  border-color: #6b6c6d;
}

.__dumi-default-layout-footer .markdown {
  color: #b0b1ba;
}

[data-prefers-color=dark] .__dumi-default-layout-footer .markdown {
  color: hsla(0, 0%, 100%, 0.45);
}

.__dumi-default-navbar {
  position: fixed;
  z-index: 101;
  top: 0;
  left: 0;
  right: 0;
  display: none;
  align-items: center;
  justify-content: space-between;
  padding: 0 58px;
  height: 64px;
  white-space: nowrap;
  background: #fff;
  box-shadow: 0 8px 24px -2px rgba(0, 0, 0, 0.05);
}

[data-prefers-color=dark] .__dumi-default-navbar {
  background: #141414;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.65);
}

@media only screen and (max-width: 767px) {
  .__dumi-default-navbar {
    display: flex;
    justify-content: center;
    height: 50px;
  }
}
.__dumi-default-navbar-toggle {
  position: absolute;
  top: 14px;
  left: 16px;
  display: none;
  width: 22px;
  height: 22px;
  border: 0;
  outline: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) no-repeat 50%/contain;
}

@media only screen and (max-width: 767px) {
  .__dumi-default-navbar-toggle {
    display: block;
  }
}
.__dumi-default-navbar-logo {
  display: inline-block;
  height: 40px;
  color: #080e29;
  font-weight: 500;
  text-decoration: none;
  font-size: 24px;
  line-height: 40px;
}

[data-prefers-color=dark] .__dumi-default-navbar-logo {
  color: hsla(0, 0%, 100%, 0.85);
}

.__dumi-default-navbar-logo:not([data-plaintext]) {
  padding-left: 56px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) no-repeat 0/contain;
}

@media only screen and (max-width: 767px) {
  .__dumi-default-navbar-logo {
    height: 28px;
    line-height: 28px;
  }
  .__dumi-default-navbar-logo:not([data-plaintext]) {
    padding-left: 36px;
  }
}
.__dumi-default-navbar-tool {
  display: inline-block;
}

.__dumi-default-navbar nav > span {
  position: relative;
  margin-left: 40px;
  display: inline-block;
  color: #454d64;
  height: 64px;
  cursor: pointer;
  font-size: 14px;
  line-height: 64px;
  text-decoration: none;
  letter-spacing: 0;
}

[data-prefers-color=dark] .__dumi-default-navbar nav > span {
  color: hsla(0, 0%, 100%, 0.85);
}

.__dumi-default-navbar nav > span > a {
  color: #4d5164;
  text-decoration: none;
}

[data-prefers-color=dark] .__dumi-default-navbar nav > span > a {
  color: hsla(0, 0%, 100%, 0.85);
}

.__dumi-default-navbar nav > span > a.active,
.__dumi-default-navbar nav > span > a:hover {
  color: #4569d4;
}

[data-prefers-color=dark] .__dumi-default-navbar nav > span > a.active,
[data-prefers-color=dark] .__dumi-default-navbar nav > span > a:hover {
  color: #7395f7;
}

.__dumi-default-navbar nav > span > a:before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  right: -18px;
  left: -18px;
}

.__dumi-default-navbar nav > span > a.active:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: -2px;
  right: -2px;
  height: 2px;
  background-color: #4569d4;
  border-radius: 1px;
}

.__dumi-default-navbar nav > span + :not(a) {
  margin-left: 40px;
}

.__dumi-default-navbar nav > span > ul {
  list-style: none;
  position: absolute;
  top: 100%;
  left: 50%;
  margin: 0;
  min-width: 100px;
  padding: 8px 18px;
  line-height: 2;
  background-color: #fff;
  box-shadow: 0 8px 24px -2px rgba(0, 0, 0, 0.08);
  transform: translate(-50%);
  transform-origin: top;
  border-radius: 1px;
  transition: all 0.2s;
}

[data-prefers-color=dark] .__dumi-default-navbar nav > span > ul {
  background-color: #141414;
}

.__dumi-default-navbar nav > span > ul a {
  position: relative;
  display: block;
  color: #454d64;
  text-decoration: none;
}

[data-prefers-color=dark] .__dumi-default-navbar nav > span > ul a {
  color: hsla(0, 0%, 100%, 0.85);
}

.__dumi-default-navbar nav > span > ul a.active,
.__dumi-default-navbar nav > span > ul a:hover {
  color: #4569d4;
}

[data-prefers-color=dark] .__dumi-default-navbar nav > span > ul a.active,
[data-prefers-color=dark] .__dumi-default-navbar nav > span > ul a:hover {
  color: #7395f7;
}

.__dumi-default-navbar nav > span:not(:hover) > ul {
  visibility: hidden;
  pointer-events: none;
  transform: translate(-50%) scaleY(0.9);
  opacity: 0;
}

.__dumi-default-navbar nav .__dumi-default-search + .__dumi-default-locale-select {
  margin-left: 40px;
}

@media only screen and (max-width: 767px) {
  .__dumi-default-navbar nav > a,
  .__dumi-default-navbar nav > div,
  .__dumi-default-navbar nav > span {
    display: none;
  }
}
.__dumi-default-navbar[data-mode=site] {
  display: flex;
}

.__dumi-default-locale-select {
  position: relative;
  display: inline-block;
  border: 1px solid #dadadf;
  border-radius: 14px;
  transition: background 0.2s;
}

[data-prefers-color=dark] .__dumi-default-locale-select {
  border: 1px solid #464646;
}

@media only screen and (max-width: 767px) {
  .__dumi-default-locale-select {
    margin-top: 6px;
  }
}
.__dumi-default-locale-select:hover {
  background-color: #fafafa;
}

[data-prefers-color=dark] .__dumi-default-locale-select:hover {
  background-color: hsla(0, 0%, 100%, 0.1);
}

.__dumi-default-locale-select:not([data-locale-count="1"]):not([data-locale-count="2"]):after {
  content: "";
  position: absolute;
  top: 50%;
  right: 10px;
  margin-top: -3px;
  width: 0;
  height: 0;
  border: 4px solid transparent;
  border-top: 6px solid #7b7f8d;
  pointer-events: none;
}

.__dumi-default-locale-select a,
.__dumi-default-locale-select select,
.__dumi-default-locale-select span {
  padding: 0 24px 0 16px;
  height: 28px;
  text-align: center;
  text-decoration: none;
  line-height: 28px;
  appearance: none;
  border: 0;
  font-size: 16px;
  color: #7b7f8d;
  background: transparent;
  outline: none;
  cursor: pointer;
}

.__dumi-default-locale-select a,
.__dumi-default-locale-select span {
  padding-right: 16px;
}

.__dumi-default-search {
  margin-left: 20px;
  position: relative;
  display: inline-block;
}

.__dumi-default-search-input {
  width: 200px;
  height: 32px;
  padding: 0 38px 0 14px;
  color: #454d64;
  font-size: 14px;
  border: 0;
  outline: none;
  transition: all 0.2s;
  border-radius: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) #f5f6f7 no-repeat right 14px center/16px;
  appearance: none;
}

[data-prefers-color=dark] .__dumi-default-search-input {
  color: hsla(0, 0%, 100%, 0.65);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) hsla(0, 0%, 100%, 0.1215686275) no-repeat right 14px center/16px;
}

.__dumi-default-search-input:focus {
  box-shadow: inset 0 0 0 1px rgba(69, 105, 212, 0.2);
}

.__dumi-default-search-input:not(:focus) + ul:not(:hover) {
  visibility: hidden;
}

.__dumi-default-search > ul {
  list-style: none;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  margin: 8px 0 0;
  min-width: 280px;
  max-width: 400px;
  max-height: 230px;
  padding: 6px 0;
  background-color: #fff;
  border: 1px solid #ebedf1;
  border-radius: 1px;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  overflow-y: auto;
}

[data-prefers-color=dark] .__dumi-default-search > ul {
  border: none;
  background-color: #141414;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.48), 0 6px 16px 0 rgba(0, 0, 0, 0.32), 0 9px 28px 8px rgba(0, 0, 0, 0.2);
}

.__dumi-default-search > ul:empty {
  display: none;
}

.__dumi-default-search > ul li {
  font-size: 15px;
}

.__dumi-default-search > ul li a {
  display: block;
  padding: 6px 20px;
  color: #717484;
  text-decoration: none;
  line-height: 1.5715;
  transition: background-color 0.3s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

[data-prefers-color=dark] .__dumi-default-search > ul li a {
  color: hsla(0, 0%, 100%, 0.65);
}

.__dumi-default-search > ul li a:hover {
  color: #4569d4;
  background-color: #f9fafb;
}

[data-prefers-color=dark] .__dumi-default-search > ul li a:hover {
  color: #7395f7;
  background-color: hsla(0, 0%, 100%, 0.08);
}

.__dumi-default-search > ul li span:first-child:not(.__dumi-default-search-highlight) {
  position: relative;
  display: inline-block;
  max-width: 50%;
  padding-right: 26px;
  vertical-align: bottom;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 0.8;
}

.__dumi-default-search > ul li span:first-child:not(.__dumi-default-search-highlight):after {
  content: ">";
  position: absolute;
  top: 50%;
  right: 6px;
  opacity: 0.6;
  transform: translateY(-54%);
}

.__dumi-default-search-empty {
  margin: 6px 0;
  opacity: 0.6;
  fill: #454d64;
}

[data-prefers-color=dark] .__dumi-default-search-empty {
  fill: hsla(0, 0%, 100%, 0.85);
}

.__dumi-default-search-highlight {
  padding: 2px 0;
  color: #736b2d;
  vertical-align: bottom;
  background: #fff9cb;
}

[data-prefers-color=dark] .__dumi-default-search-highlight {
  color: #454d64;
}

@media only screen and (max-width: 1024px) {
  .__dumi-default-search {
    margin-right: -14px;
  }
  .__dumi-default-search > input:not(:focus) {
    color: transparent;
    width: 32px;
    padding-right: 0;
    box-shadow: none;
    cursor: pointer;
    background-position: right 8px center;
  }
  .__dumi-default-search > input:not(:focus) + ul {
    transition: visibility 0.1s;
    visibility: hidden;
  }
}
@media only screen and (max-width: 767px) {
  .__dumi-default-search {
    position: absolute;
    top: 9px;
    right: 24px;
    display: block !important;
  }
  .__dumi-default-search > ul {
    right: 0;
    left: auto;
  }
}
.__dumi-default-dark {
  position: fixed;
  right: 20px;
  top: 16px;
}

[data-mode=doc] .__dumi-default-dark {
  position: relative;
  top: 0;
  right: 0;
  display: inline-block;
}

@media only screen and (max-width: 767px) {
  .__dumi-default-dark {
    position: relative;
    top: 6px;
    right: auto;
    display: flex;
    justify-content: center;
  }
  .__dumi-default-navbar .__dumi-default-dark {
    display: none;
  }
}
.__dumi-default-dark-auto,
.__dumi-default-dark-moon,
.__dumi-default-dark-sun {
  position: relative;
  border-radius: 50%;
  outline: none;
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.__dumi-default-dark-auto svg,
.__dumi-default-dark-moon svg,
.__dumi-default-dark-sun svg {
  transition: all 0.3s linear;
}

.__dumi-default-dark-auto svg:hover,
.__dumi-default-dark-moon svg:hover,
.__dumi-default-dark-sun svg:hover {
  transform: scale(1.2);
}

.__dumi-default-dark-auto,
.__dumi-default-dark-moon,
.__dumi-default-dark-sun {
  border: 1px solid #dadadf;
  background-color: #f9fafb;
}

.__dumi-default-dark-auto svg,
.__dumi-default-dark-moon svg,
.__dumi-default-dark-sun svg {
  fill: #454d64;
}

[data-prefers-color=dark] .__dumi-default-dark-auto svg,
[data-prefers-color=dark] .__dumi-default-dark-moon svg,
[data-prefers-color=dark] .__dumi-default-dark-sun svg {
  fill: hsla(0, 0%, 100%, 0.85);
}

[data-prefers-color=dark] .__dumi-default-dark-auto,
[data-prefers-color=dark] .__dumi-default-dark-moon,
[data-prefers-color=dark] .__dumi-default-dark-sun {
  border-color: #464646;
  background-color: #141414;
}

[data-mode=doc] .__dumi-default-dark-switch {
  display: flex;
}

[data-mode=doc] .__dumi-default-dark-switch button + button {
  margin-left: 4px;
}

@media only screen and (max-width: 767px) {
  .__dumi-default-dark-switch {
    display: flex;
  }
  .__dumi-default-dark-switch button + button {
    margin-left: 10px;
  }
}
.__dumi-default-menu .__dumi-default-dark-switch-active {
  border-color: #4569d4;
}

[data-prefers-color=dark] .__dumi-default-menu .__dumi-default-dark-switch-active {
  border-color: #7395f7;
}

[data-mode=doc][data-mobile-show=true] .__dumi-default-dark-switch {
  margin-bottom: 10px;
}

.__dumi-default-dark-switch button {
  z-index: 102;
}

.__dumi-default-dark-switch-list {
  animation: dropDown 0.2s linear 0s 1;
}

.__dumi-default-dark-switch-list button {
  z-index: 101;
  margin-top: 4px;
}

[data-mode=doc] .__dumi-default-dark-switch-list {
  position: absolute;
}

@keyframes dropDown {
  0% {
    margin-top: -100%;
  }
  to {
    margin-top: 0;
  }
}
.__dumi-default-menu {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  bottom: 0;
  width: 260px;
  background-color: #f2f5fa;
  box-sizing: border-box;
  transition: left 0.3s;
}

.__dumi-default-menu[data-hidden] {
  display: none;
}

@media only screen and (max-width: 767px) {
  .__dumi-default-menu {
    left: -240px;
    top: 50px;
    display: block !important;
    width: 240px;
    background-color: #fff;
  }
  .__dumi-default-menu[data-mobile-show] {
    left: 0;
  }
  [data-prefers-color=dark] .__dumi-default-menu {
    background-color: #141414;
  }
}
.__dumi-default-menu:after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: block;
  width: 20px;
  background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.03));
  pointer-events: none;
}

@media only screen and (max-width: 767px) {
  .__dumi-default-menu:after {
    width: 1px;
    background: #ebedf1;
  }
}
.__dumi-default-menu-header {
  position: relative;
  padding-top: 40px;
  text-align: center;
  border-bottom: 1px solid #ebedf1;
}

[data-prefers-color=dark] .__dumi-default-menu-header {
  border-color: #6b6c6d;
}

@media only screen and (max-width: 767px) {
  .__dumi-default-menu-header {
    display: none;
  }
}
.__dumi-default-menu-header .__dumi-default-menu-logo {
  display: inline-block;
  width: 66px;
  height: 65px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) no-repeat 0/contain;
}

.__dumi-default-menu-header h1, .__dumi-default-menu-header .h1 {
  margin: 10px 0 0;
  color: #454d64;
  font-weight: 500;
  line-height: 1.40625;
}

.__dumi-default-menu-header p {
  margin: 0 0 5px;
  color: #8c8e9c;
}

.__dumi-default-menu-header p > object[data^="https://img.shields.io"] {
  max-height: 20px;
}

.__dumi-default-menu-header p + p {
  margin-bottom: 10px;
}

.__dumi-default-menu-doc-locale {
  padding: 16px 0;
  text-align: center;
  border-bottom: 1px solid #ebedf1;
  display: flex;
  justify-content: space-evenly;
}

[data-prefers-color=dark] .__dumi-default-menu-doc-locale {
  border-color: #6b6c6d;
}

[data-mode=doc][data-mobile-show=true] .__dumi-default-menu-doc-locale {
  display: grid;
}

.__dumi-default-menu-doc-locale:empty {
  display: none;
}

.__dumi-default-menu-inner {
  width: 100%;
  height: 100%;
  overflow: auto;
  overscroll-behavior: contain;
}

[data-prefers-color=dark] .__dumi-default-menu-inner {
  background-color: #262626;
}

.__dumi-default-menu-inner ul {
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 16px;
}

.__dumi-default-menu-inner ul li {
  color: #454d64;
}

.__dumi-default-menu-inner ul li > span,
.__dumi-default-menu-inner ul li a {
  position: relative;
  display: block;
  padding-right: 24px;
  color: #454d64;
  line-height: 2.4;
  text-decoration: none;
  outline: none;
  transition: color 0.3s, background 0.3s;
}

[data-prefers-color=dark] .__dumi-default-menu-inner ul li > span,
[data-prefers-color=dark] .__dumi-default-menu-inner ul li a {
  color: hsla(0, 0%, 100%, 0.85);
}

.__dumi-default-menu-inner ul li > span span,
.__dumi-default-menu-inner ul li a span {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.__dumi-default-menu-inner ul li > span.active,
.__dumi-default-menu-inner ul li > span:hover,
.__dumi-default-menu-inner ul li a.active,
.__dumi-default-menu-inner ul li a:hover {
  color: #4569d4;
}

[data-prefers-color=dark] .__dumi-default-menu-inner ul li > span.active,
[data-prefers-color=dark] .__dumi-default-menu-inner ul li > span:hover,
[data-prefers-color=dark] .__dumi-default-menu-inner ul li a.active,
[data-prefers-color=dark] .__dumi-default-menu-inner ul li a:hover {
  color: #7395f7;
}

.__dumi-default-menu-inner ul li > span:before,
.__dumi-default-menu-inner ul li a:before {
  content: "";
  position: absolute;
  top: 50%;
  left: -10px;
  margin-top: -2.5px;
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: #4569d4;
  border-radius: 50%;
  opacity: 0;
  transition: transform 0.2s, opacity 0.2s;
  transform: scale(0) translateX(-10px);
}

.__dumi-default-menu-inner ul li.active a:before,
.__dumi-default-menu-inner ul li a.active:before {
  opacity: 1;
  transform: scale(1) translateX(0);
}

.__dumi-default-menu-inner ul li ul {
  font-size: 0.9em;
  padding-left: 1em;
}

.__dumi-default-menu-inner > ul > li > a {
  line-height: 2.875;
}

.__dumi-default-menu-inner > ul > li > a:not([href]) {
  padding-top: 24px;
  line-height: 1;
  font-weight: 500;
  color: #454d64 !important;
  background: transparent !important;
  cursor: default;
}

[data-prefers-color=dark] .__dumi-default-menu-inner > ul > li > a:not([href]) {
  color: hsla(0, 0%, 100%, 0.85) !important;
}

.__dumi-default-menu-inner > ul > li:first-child > a:not([href]) {
  padding-top: 0;
}

.__dumi-default-menu-inner > ul ul a {
  color: #717484;
}

[data-prefers-color=dark] .__dumi-default-menu-inner > ul ul a {
  color: hsla(0, 0%, 100%, 0.65);
}

.__dumi-default-menu-inner > ul ul a.active {
  color: #4569d4;
}

[data-prefers-color=dark] .__dumi-default-menu-inner > ul ul a.active {
  color: #7395f7;
}

.__dumi-default-menu-inner .__dumi-default-menu-mobile-area {
  display: none;
  padding-bottom: 16px;
  margin-bottom: 16px;
  text-align: center;
  border-bottom: 1px solid #ebedf1;
}

[data-prefers-color=dark] .__dumi-default-menu-inner .__dumi-default-menu-mobile-area {
  border-color: #6b6c6d;
}

@media only screen and (max-width: 767px) {
  .__dumi-default-menu-inner .__dumi-default-menu-mobile-area {
    display: block;
  }
}
.__dumi-default-menu-inner .__dumi-default-menu-nav-list {
  padding: 16px 0 0;
}

.__dumi-default-menu-inner .__dumi-default-menu-nav-list > li,
.__dumi-default-menu-inner .__dumi-default-menu-nav-list > li > a {
  padding-right: 0;
  line-height: 2.4;
}

.__dumi-default-menu-inner .__dumi-default-menu-nav-list > li > a ul,
.__dumi-default-menu-inner .__dumi-default-menu-nav-list > li ul {
  padding-left: 0;
}

.__dumi-default-menu-inner .__dumi-default-menu-nav-list > li > a ul a,
.__dumi-default-menu-inner .__dumi-default-menu-nav-list > li ul a {
  padding-right: 0;
  font-size: 90%;
}

.__dumi-default-menu-inner .__dumi-default-menu-list {
  padding: 8px 0;
  margin-bottom: 40px;
}

.__dumi-default-menu-inner .__dumi-default-menu-list > li > a {
  padding-left: 28px;
}

.__dumi-default-menu-inner .__dumi-default-menu-list > li > a.active {
  background: linear-gradient(270deg, #e8ecf4, rgba(232, 236, 244, 0));
}

[data-prefers-color=dark] .__dumi-default-menu-inner .__dumi-default-menu-list > li > a.active {
  background: linear-gradient(270deg, #3d3d3e, hsla(0, 0%, 100%, 0.06));
}

.__dumi-default-menu-inner .__dumi-default-menu-list > li > a ~ ul {
  margin-top: 8px;
  margin-left: 28px;
}

@media only screen and (max-width: 767px) {
  .__dumi-default-menu-inner .__dumi-default-menu-list > li > a {
    padding-left: 16px;
  }
  .__dumi-default-menu-inner .__dumi-default-menu-list > li > a ~ ul {
    margin-left: 16px;
  }
}
.__dumi-default-menu[data-mode=site]:after {
  width: 1px;
  background: #ebedf1;
}

[data-prefers-color=dark] .__dumi-default-menu[data-mode=site]:after {
  background: #6b6c6d;
}

.__dumi-default-menu[data-mode=site] .__dumi-default-menu-list {
  padding: 0;
}

.__dumi-default-menu[data-mode=site] .__dumi-default-menu-list > li > a {
  position: relative;
}

.__dumi-default-menu[data-mode=site] .__dumi-default-menu-list > li > a:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  display: block;
  width: 3px;
  background-color: #4569d4;
  visibility: hidden;
  opacity: 0;
  transition: all 0.3s;
  border-radius: 1px;
}

.__dumi-default-menu[data-mode=site] .__dumi-default-menu-list > li > a.active {
  z-index: 1;
  background: linear-gradient(270deg, #f8faff, rgba(248, 250, 255, 0));
}

[data-prefers-color=dark] .__dumi-default-menu[data-mode=site] .__dumi-default-menu-list > li > a.active {
  background: linear-gradient(270deg, #3d3d3e, hsla(0, 0%, 100%, 0.06));
}

.__dumi-default-menu[data-mode=site] .__dumi-default-menu-list > li > a.active:after {
  opacity: 1;
  visibility: visible;
}

@media only screen and (min-width: 768px) {
  .__dumi-default-menu[data-mode=site] {
    top: 64px;
    width: 300px;
    padding-top: 50px;
    background: transparent;
  }
  [data-prefers-color=dark] .__dumi-default-menu[data-mode=site] {
    background: hsla(0, 0%, 100%, 0.08);
  }
  .__dumi-default-menu[data-mode=site] .__dumi-default-menu-header,
  .__dumi-default-menu[data-mode=site] .__dumi-default-menu-nav {
    display: none;
  }
  .__dumi-default-menu[data-mode=site] .__dumi-default-menu-list > li > a {
    padding-left: 58px;
  }
  .__dumi-default-menu[data-mode=site] .__dumi-default-menu-list > li > a ~ ul {
    margin-left: 58px;
  }
}
ul[role=slug-list]:empty {
  margin: 0 !important;
  padding: 0 !important;
}

ul[role=slug-list] li > a.active {
  color: #3d62d2;
}

ul[role=slug-list] li[data-depth="3"] {
  padding-left: 12px;
}

.__dumi-default-table {
  margin: 16px 0 32px;
  transform: translate(0);
}

.__dumi-default-table-content {
  overflow: auto;
}

.__dumi-default-table-content:after,
.__dumi-default-table-content:before {
  content: "";
  display: block;
  position: fixed;
  z-index: 1;
  top: 0;
  bottom: 0;
  width: 6px;
  pointer-events: none;
}

.__dumi-default-table-content[data-left-folded]:before {
  left: 0;
  background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.1), transparent);
}

[data-prefers-color=dark] .__dumi-default-table-content[data-left-folded]:before {
  background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.5), transparent);
}

.__dumi-default-table-content[data-right-folded]:after {
  right: 0;
  background-image: linear-gradient(270deg, rgba(0, 0, 0, 0.1), transparent);
}

[data-prefers-color=dark] .__dumi-default-table-content[data-right-folded]:after {
  background-image: linear-gradient(270deg, rgba(0, 0, 0, 0.5), transparent);
}

.__dumi-default-table-content > table > thead > tr > th,
.__dumi-default-table-content > table > tr > th {
  white-space: nowrap;
}

.node-wrapper {
  white-space: pre;
}
.node-wrapper.default-color:hover {
  background-color: rgba(215, 38, 56, 0.3) !important;
}
.node-wrapper.white-color:hover {
  background-color: rgba(255, 255, 255, 0.5) !important;
}
.node-wrapper.gray-color:hover {
  background-color: rgba(65, 70, 90, 0.5) !important;
}

.selected-node.default-color-selected {
  background-color: rgba(215, 38, 56, 0.5);
}
.selected-node.white-color-selected {
  background-color: rgba(255, 255, 255, 0.5);
}
.selected-node.gray-color-selected {
  background-color: rgba(65, 70, 90, 0.5);
}

.tree-node {
  display: flex;
  align-items: center;
  min-height: 40px;
  max-height: 40px;
}
.tree-node .tree-icon {
  margin-right: 8px;
  border-radius: 50%;
  cursor: pointer;
  background-repeat: no-repeat;
}
.tree-node .tree-icon.open-icon {
  width: 12px;
  height: 12px;
  background-size: contain;
}
.tree-node .tree-icon.close-icon {
  width: 12px;
  height: 12px;
  background-size: contain;
}
.tree-node .tree-icon.empty-icon {
  width: 12px;
  height: 12px;
  background-size: contain;
}
.tree-node .node-content-wrapper {
  cursor: pointer;
  min-height: 40px;
  max-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  width: 100%;
  padding: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.2s ease;
}
.tree-node .node-content-wrapper:hover {
  background-color: rgba(215, 38, 56, 0.1);
}
.tree-node .node-content-wrapper.node-selected {
  border-left: 4px solid #d72638;
}
.tree-node .node-content-wrapper .titles {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.tree-node .node-content-wrapper .titles .node-title {
  font-weight: 600;
}
.tree-node .node-content-wrapper .titles .node-subtitle {
  margin-top: 4px;
  font-size: 10px;
}
.tree-node .node-content-wrapper .children-length {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 24px;
  height: 16px;
  background-color: #d72638;
  color: #ffffff;
  padding: 4px;
  font-size: 12px;
  border-radius: 16px;
  margin-left: 12px;
  font-weight: 600;
}

.tree-wrapper {
  width: 50%;
  padding: 0 0 0 16px;
}
.tree-wrapper.simple {
  overflow: auto;
}
@media (max-width: 767px) {
  .tree-wrapper {
    width: 100%;
    padding: 0 0 0 0;
    margin-top: 16px;
  }
}

.lib-icon {
  margin-top: 100px;
}
.lib-icon .tree-icon {
  background-repeat: no-repeat;
  width: 100px;
  height: 100px;
}

.code-wrapper {
  display: flex;
  width: 50%;
  background-color: #fff;
  min-height: 480px;
}
@media (max-width: 767px) {
  .code-wrapper {
    width: 100%;
  }
}
.code-wrapper .line-numbers {
  font-size: 10px;
  line-height: 12px;
  padding-top: 18px;
  color: rgba(96, 125, 139, 0.5);
  text-align: right;
  margin-left: 8px;
}
.code-wrapper .rendered {
  width: 100%;
  line-height: 12px;
}
.code-wrapper .rendered .code-view {
  white-space: pre-wrap;
  font-size: 10px;
  width: 100%;
}

.hljs {
  display: block;
  overflow-x: auto;
  padding: 0.5em;
  color: #607D8B;
}

.hljs-comment,
.hljs-quote {
  color: #5c6370;
  font-style: italic;
}

.hljs-doctag,
.hljs-keyword,
.hljs-formula {
  color: rgb(209, 98, 98);
}

.hljs-section,
.hljs-name,
.hljs-selector-tag,
.hljs-deletion,
.hljs-subst {
  color: #e03f4d;
}

.hljs-literal {
  color: #56b6c2;
}

.hljs-string,
.hljs-regexp,
.hljs-addition,
.hljs-attribute,
.hljs-meta-string {
  color: #5c9e2d;
}

.hljs-built_in,
.hljs-class .hljs-title {
  color: #e6c07b;
}

.hljs-attr,
.hljs-variable,
.hljs-template-variable,
.hljs-type,
.hljs-selector-class,
.hljs-selector-attr,
.hljs-selector-pseudo,
.hljs-number {
  color: #d19a66;
}

.hljs-symbol,
.hljs-bullet,
.hljs-link,
.hljs-meta,
.hljs-selector-id,
.hljs-title {
  color: #4c86b6;
}

.hljs-emphasis {
  font-style: italic;
}

.hljs-strong {
  font-weight: bold;
}

.hljs-link {
  text-decoration: underline;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker__navigation-icon::before {
  border-color: #ccc;
  border-style: solid;
  border-width: 3px 3px 0 0;
  content: "";
  display: block;
  height: 9px;
  position: absolute;
  top: 6px;
  width: 9px;
}
.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  margin-left: -4px;
  position: absolute;
  width: 0;
}
.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  box-sizing: content-box;
  position: absolute;
  border: 8px solid transparent;
  height: 0;
  width: 1px;
  content: "";
  z-index: -1;
  border-width: 8px;
  left: -8px;
}
.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  border-bottom-color: #aeaeae;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  top: 0;
  margin-top: -8px;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  border-top: none;
  border-bottom-color: #f0f0f0;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  top: 0;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  top: -1px;
  border-bottom-color: #aeaeae;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {
  bottom: 0;
  margin-bottom: -8px;
}
.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after {
  border-bottom: none;
  border-top-color: #fff;
}
.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after {
  bottom: 0;
}
.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {
  bottom: -1px;
  border-top-color: #aeaeae;
}

.react-datepicker-wrapper {
  display: inline-block;
  padding: 0;
  border: 0;
  width: 100%;
}

.react-datepicker {
  font-family: "Helvetica Neue", helvetica, arial, sans-serif;
  font-size: 0.8rem;
  background-color: #fff;
  color: #000;
  border: 1px solid #aeaeae;
  border-radius: 0.3rem;
  display: inline-block;
  position: relative;
}

.react-datepicker--time-only .react-datepicker__triangle {
  left: 35px;
}
.react-datepicker--time-only .react-datepicker__time-container {
  border-left: 0;
}
.react-datepicker--time-only .react-datepicker__time,
.react-datepicker--time-only .react-datepicker__time-box {
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.react-datepicker__triangle {
  position: absolute;
  left: 50px;
}

.react-datepicker-popper {
  z-index: 1;
}
.react-datepicker-popper[data-placement^=bottom] {
  padding-top: 10px;
}
.react-datepicker-popper[data-placement=bottom-end] .react-datepicker__triangle, .react-datepicker-popper[data-placement=top-end] .react-datepicker__triangle {
  left: auto;
  right: 50px;
}
.react-datepicker-popper[data-placement^=top] {
  padding-bottom: 10px;
}
.react-datepicker-popper[data-placement^=right] {
  padding-left: 8px;
}
.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle {
  left: auto;
  right: 42px;
}
.react-datepicker-popper[data-placement^=left] {
  padding-right: 8px;
}
.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle {
  left: 42px;
  right: auto;
}

.react-datepicker__header {
  text-align: center;
  background-color: #f0f0f0;
  border-bottom: 1px solid #aeaeae;
  border-top-left-radius: 0.3rem;
  padding: 8px 0;
  position: relative;
}
.react-datepicker__header--time {
  padding-bottom: 8px;
  padding-left: 5px;
  padding-right: 5px;
}
.react-datepicker__header--time:not(.react-datepicker__header--time--only) {
  border-top-left-radius: 0;
}
.react-datepicker__header:not(.react-datepicker__header--has-time-select) {
  border-top-right-radius: 0.3rem;
}

.react-datepicker__year-dropdown-container--select,
.react-datepicker__month-dropdown-container--select,
.react-datepicker__month-year-dropdown-container--select,
.react-datepicker__year-dropdown-container--scroll,
.react-datepicker__month-dropdown-container--scroll,
.react-datepicker__month-year-dropdown-container--scroll {
  display: inline-block;
  margin: 0 2px;
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
  margin-top: 0;
  color: #000;
  font-weight: bold;
  font-size: 0.944rem;
}

.react-datepicker-time__header {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.react-datepicker__navigation {
  align-items: center;
  background: none;
  display: flex;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: 2px;
  padding: 0;
  border: none;
  z-index: 1;
  height: 32px;
  width: 32px;
  text-indent: -999em;
  overflow: hidden;
}
.react-datepicker__navigation--previous {
  left: 2px;
}
.react-datepicker__navigation--next {
  right: 2px;
}
.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
  right: 85px;
}
.react-datepicker__navigation--years {
  position: relative;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.react-datepicker__navigation--years-previous {
  top: 4px;
}
.react-datepicker__navigation--years-upcoming {
  top: -4px;
}
.react-datepicker__navigation:hover *::before {
  border-color: #a6a6a6;
}

.react-datepicker__navigation-icon {
  position: relative;
  top: -1px;
  font-size: 20px;
  width: 0;
}
.react-datepicker__navigation-icon--next {
  left: -2px;
}
.react-datepicker__navigation-icon--next::before {
  transform: rotate(45deg);
  left: -7px;
}
.react-datepicker__navigation-icon--previous {
  right: -2px;
}
.react-datepicker__navigation-icon--previous::before {
  transform: rotate(225deg);
  right: -7px;
}

.react-datepicker__month-container {
  float: left;
}

.react-datepicker__year {
  margin: 0.4rem;
  text-align: center;
}
.react-datepicker__year-wrapper {
  display: flex;
  flex-wrap: wrap;
  max-width: 180px;
}
.react-datepicker__year .react-datepicker__year-text {
  display: inline-block;
  width: 4rem;
  margin: 2px;
}

.react-datepicker__month {
  margin: 0.4rem;
  text-align: center;
}
.react-datepicker__month .react-datepicker__month-text,
.react-datepicker__month .react-datepicker__quarter-text {
  display: inline-block;
  width: 4rem;
  margin: 2px;
}

.react-datepicker__input-time-container {
  clear: both;
  width: 100%;
  float: left;
  margin: 5px 0 10px 15px;
  text-align: left;
}
.react-datepicker__input-time-container .react-datepicker-time__caption {
  display: inline-block;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container {
  display: inline-block;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {
  display: inline-block;
  margin-left: 10px;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {
  width: auto;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time] {
  -moz-appearance: textfield;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {
  margin-left: 5px;
  display: inline-block;
}

.react-datepicker__time-container {
  float: right;
  border-left: 1px solid #aeaeae;
  width: 85px;
}
.react-datepicker__time-container--with-today-button {
  display: inline;
  border: 1px solid #aeaeae;
  border-radius: 0.3rem;
  position: absolute;
  right: -72px;
  top: 0;
}
.react-datepicker__time-container .react-datepicker__time {
  position: relative;
  background: white;
  border-bottom-right-radius: 0.3rem;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  width: 85px;
  overflow-x: hidden;
  margin: 0 auto;
  text-align: center;
  border-bottom-right-radius: 0.3rem;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
  list-style: none;
  margin: 0;
  height: calc(195px + 1.7rem / 2);
  overflow-y: scroll;
  padding-right: 0;
  padding-left: 0;
  width: 100%;
  box-sizing: content-box;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  height: 30px;
  padding: 5px 10px;
  white-space: nowrap;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  cursor: pointer;
  background-color: #f0f0f0;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: #216ba5;
  color: white;
  font-weight: bold;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
  background-color: #216ba5;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {
  color: #ccc;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {
  cursor: default;
  background-color: transparent;
}

.react-datepicker__week-number {
  color: #ccc;
  display: inline-block;
  width: 1.7rem;
  line-height: 1.7rem;
  text-align: center;
  margin: 0.166rem;
}
.react-datepicker__week-number.react-datepicker__week-number--clickable {
  cursor: pointer;
}
.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
  border-radius: 0.3rem;
  background-color: #f0f0f0;
}

.react-datepicker__day-names,
.react-datepicker__week {
  white-space: nowrap;
}

.react-datepicker__day-names {
  margin-bottom: -8px;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  color: #000;
  display: inline-block;
  width: 1.7rem;
  line-height: 1.7rem;
  text-align: center;
  margin: 0.166rem;
}

.react-datepicker__month--selected, .react-datepicker__month--in-selecting-range, .react-datepicker__month--in-range,
.react-datepicker__quarter--selected,
.react-datepicker__quarter--in-selecting-range,
.react-datepicker__quarter--in-range {
  border-radius: 0.3rem;
  background-color: #216ba5;
  color: #fff;
}
.react-datepicker__month--selected:hover, .react-datepicker__month--in-selecting-range:hover, .react-datepicker__month--in-range:hover,
.react-datepicker__quarter--selected:hover,
.react-datepicker__quarter--in-selecting-range:hover,
.react-datepicker__quarter--in-range:hover {
  background-color: #1d5d90;
}
.react-datepicker__month--disabled,
.react-datepicker__quarter--disabled {
  color: #ccc;
  pointer-events: none;
}
.react-datepicker__month--disabled:hover,
.react-datepicker__quarter--disabled:hover {
  cursor: default;
  background-color: transparent;
}

.react-datepicker__day,
.react-datepicker__month-text,
.react-datepicker__quarter-text,
.react-datepicker__year-text {
  cursor: pointer;
}
.react-datepicker__day:hover,
.react-datepicker__month-text:hover,
.react-datepicker__quarter-text:hover,
.react-datepicker__year-text:hover {
  border-radius: 0.3rem;
  background-color: #f0f0f0;
}
.react-datepicker__day--today,
.react-datepicker__month-text--today,
.react-datepicker__quarter-text--today,
.react-datepicker__year-text--today {
  font-weight: bold;
}
.react-datepicker__day--highlighted,
.react-datepicker__month-text--highlighted,
.react-datepicker__quarter-text--highlighted,
.react-datepicker__year-text--highlighted {
  border-radius: 0.3rem;
  background-color: #3dcc4a;
  color: #fff;
}
.react-datepicker__day--highlighted:hover,
.react-datepicker__month-text--highlighted:hover,
.react-datepicker__quarter-text--highlighted:hover,
.react-datepicker__year-text--highlighted:hover {
  background-color: #32be3f;
}
.react-datepicker__day--highlighted-custom-1,
.react-datepicker__month-text--highlighted-custom-1,
.react-datepicker__quarter-text--highlighted-custom-1,
.react-datepicker__year-text--highlighted-custom-1 {
  color: magenta;
}
.react-datepicker__day--highlighted-custom-2,
.react-datepicker__month-text--highlighted-custom-2,
.react-datepicker__quarter-text--highlighted-custom-2,
.react-datepicker__year-text--highlighted-custom-2 {
  color: green;
}
.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--selected,
.react-datepicker__year-text--in-selecting-range,
.react-datepicker__year-text--in-range {
  border-radius: 0.3rem;
  background-color: #216ba5;
  color: #fff;
}
.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,
.react-datepicker__month-text--selected:hover,
.react-datepicker__month-text--in-selecting-range:hover,
.react-datepicker__month-text--in-range:hover,
.react-datepicker__quarter-text--selected:hover,
.react-datepicker__quarter-text--in-selecting-range:hover,
.react-datepicker__quarter-text--in-range:hover,
.react-datepicker__year-text--selected:hover,
.react-datepicker__year-text--in-selecting-range:hover,
.react-datepicker__year-text--in-range:hover {
  background-color: #1d5d90;
}
.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
  border-radius: 0.3rem;
  background-color: #2a87d0;
  color: #fff;
}
.react-datepicker__day--keyboard-selected:hover,
.react-datepicker__month-text--keyboard-selected:hover,
.react-datepicker__quarter-text--keyboard-selected:hover,
.react-datepicker__year-text--keyboard-selected:hover {
  background-color: #1d5d90;
}
.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range) {
  background-color: rgba(33, 107, 165, 0.5);
}
.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range) {
  background-color: #f0f0f0;
  color: #000;
}
.react-datepicker__day--disabled,
.react-datepicker__month-text--disabled,
.react-datepicker__quarter-text--disabled,
.react-datepicker__year-text--disabled {
  cursor: default;
  color: #ccc;
}
.react-datepicker__day--disabled:hover,
.react-datepicker__month-text--disabled:hover,
.react-datepicker__quarter-text--disabled:hover,
.react-datepicker__year-text--disabled:hover {
  background-color: transparent;
}

.react-datepicker__month-text.react-datepicker__month--selected:hover, .react-datepicker__month-text.react-datepicker__month--in-range:hover, .react-datepicker__month-text.react-datepicker__quarter--selected:hover, .react-datepicker__month-text.react-datepicker__quarter--in-range:hover,
.react-datepicker__quarter-text.react-datepicker__month--selected:hover,
.react-datepicker__quarter-text.react-datepicker__month--in-range:hover,
.react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,
.react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {
  background-color: #216ba5;
}
.react-datepicker__month-text:hover,
.react-datepicker__quarter-text:hover {
  background-color: #f0f0f0;
}

.react-datepicker__input-container {
  position: relative;
  display: inline-block;
  width: 100%;
}

.react-datepicker__year-read-view,
.react-datepicker__month-read-view,
.react-datepicker__month-year-read-view {
  border: 1px solid transparent;
  border-radius: 0.3rem;
  position: relative;
}
.react-datepicker__year-read-view:hover,
.react-datepicker__month-read-view:hover,
.react-datepicker__month-year-read-view:hover {
  cursor: pointer;
}
.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {
  border-top-color: #b3b3b3;
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
  transform: rotate(135deg);
  right: -16px;
  top: 0;
}

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown,
.react-datepicker__month-year-dropdown {
  background-color: #f0f0f0;
  position: absolute;
  width: 50%;
  left: 25%;
  top: 30px;
  z-index: 1;
  text-align: center;
  border-radius: 0.3rem;
  border: 1px solid #aeaeae;
}
.react-datepicker__year-dropdown:hover,
.react-datepicker__month-dropdown:hover,
.react-datepicker__month-year-dropdown:hover {
  cursor: pointer;
}
.react-datepicker__year-dropdown--scrollable,
.react-datepicker__month-dropdown--scrollable,
.react-datepicker__month-year-dropdown--scrollable {
  height: 150px;
  overflow-y: scroll;
}

.react-datepicker__year-option,
.react-datepicker__month-option,
.react-datepicker__month-year-option {
  line-height: 20px;
  width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.react-datepicker__year-option:first-of-type,
.react-datepicker__month-option:first-of-type,
.react-datepicker__month-year-option:first-of-type {
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}
.react-datepicker__year-option:last-of-type,
.react-datepicker__month-option:last-of-type,
.react-datepicker__month-year-option:last-of-type {
  -webkit-user-select: none;
  user-select: none;
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}
.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-year-option:hover {
  background-color: #ccc;
}
.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {
  border-bottom-color: #b3b3b3;
}
.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {
  border-top-color: #b3b3b3;
}
.react-datepicker__year-option--selected,
.react-datepicker__month-option--selected,
.react-datepicker__month-year-option--selected {
  position: absolute;
  left: 15px;
}

.react-datepicker__close-icon {
  cursor: pointer;
  background-color: transparent;
  border: 0;
  outline: 0;
  padding: 0 6px 0 0;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  display: table-cell;
  vertical-align: middle;
}
.react-datepicker__close-icon::after {
  cursor: pointer;
  background-color: #216ba5;
  color: #fff;
  border-radius: 50%;
  height: 16px;
  width: 16px;
  padding: 2px;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  content: "×";
}

.react-datepicker__today-button {
  background: #f0f0f0;
  border-top: 1px solid #aeaeae;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  padding: 5px 0;
  clear: left;
}

.react-datepicker__portal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  z-index: 2147483647;
}
.react-datepicker__portal .react-datepicker__day-name,
.react-datepicker__portal .react-datepicker__day,
.react-datepicker__portal .react-datepicker__time-name {
  width: 3rem;
  line-height: 3rem;
}
@media (max-width: 400px), (max-height: 550px) {
  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
    width: 2rem;
    line-height: 2rem;
  }
}
.react-datepicker__portal .react-datepicker__current-month,
.react-datepicker__portal .react-datepicker-time__header {
  font-size: 1.44rem;
}

.centered {
  position: absolute;
  left: 50%;
  top: 50%;
}

@media screen, print {
  .is-text-multiple {
    height: 130mm;
    overflow: hidden;
    line-height: 1;
    display: inline-table;
    margin-left: 20px;
    margin-right: 20px;
  }
}
@keyframes color_change {
  0% {
    background-color: white;
  }
  50% {
    background-color: #11f542;
  }
  70% {
    background-color: rgba(7, 182, 45, 0.637);
  }
  100% {
    background-color: white;
  }
}
.has-anim {
  animation-name: color_change;
  animation-duration: 5s;
}

.rows-changed {
  animation-name: color_change;
  animation-duration: 5s;
}

.ribbon {
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
}

.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
  border: 5px solid #2980b9;
}

.ribbon span {
  position: absolute;
  display: block;
  width: 225px;
  padding: 15px 0;
  background-color: #3498db;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  color: #fff;
  font: 700 18px/1 "Lato", sans-serif;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
  text-align: center;
}

/* top right*/
.ribbon-top-right {
  top: -10px;
  right: -10px;
}

.ribbon-top-right::before,
.ribbon-top-right::after {
  border-top-color: transparent;
  border-right-color: transparent;
}

.ribbon-top-right::before {
  top: 0;
  left: 0;
}

.ribbon-top-right::after {
  bottom: 0;
  right: 0;
}

.ribbon-top-right span {
  left: -25px;
  top: 30px;
  transform: rotate(45deg);
}

.sidebar-nav .nav-link.active {
  font-weight: 700;
}

.bg-dashboard {
  background: linear-gradient(180deg, #F6FBF8 0%, #EDF5F2 100%);
}`, "",{"version":3,"sources":["webpack://./src/scss/style.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_banner.scss","webpack://./node_modules/@coreui/coreui/scss/_root.scss","webpack://./node_modules/@coreui/coreui/scss/vendor/_rfs.scss","webpack://./node_modules/@coreui/coreui/scss/_reboot.scss","webpack://./node_modules/@coreui/coreui/scss/_variables.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_ltr-rtl.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_border-radius.scss","webpack://./node_modules/@coreui/coreui/scss/_type.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_lists.scss","webpack://./node_modules/@coreui/coreui/scss/_images.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_image.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_box-shadow.scss","webpack://./node_modules/@coreui/coreui/scss/_containers.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_container.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_breakpoints.scss","webpack://./node_modules/@coreui/coreui/scss/_grid.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_grid.scss","webpack://./node_modules/@coreui/coreui/scss/_tables.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_table-variants.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_labels.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-text.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-control.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_transition.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_gradients.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-select.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-check.scss","webpack://./src/scss/_variables.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-range.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_floating-labels.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_input-group.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_forms.scss","webpack://./node_modules/@coreui/coreui/scss/_buttons.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_buttons.scss","webpack://./node_modules/@coreui/coreui/scss/_transitions.scss","webpack://./node_modules/@coreui/coreui/scss/_dropdown.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_caret.scss","webpack://./node_modules/@coreui/coreui/scss/_button-group.scss","webpack://./node_modules/@coreui/coreui/scss/_nav.scss","webpack://./node_modules/@coreui/coreui/scss/_navbar.scss","webpack://./node_modules/@coreui/coreui/scss/_card.scss","webpack://./node_modules/@coreui/coreui/scss/_accordion.scss","webpack://./node_modules/@coreui/coreui/scss/_breadcrumb.scss","webpack://./node_modules/@coreui/coreui/scss/_pagination.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_pagination.scss","webpack://./node_modules/@coreui/coreui/scss/_badge.scss","webpack://./node_modules/@coreui/coreui/scss/_alert.scss","webpack://./node_modules/@coreui/coreui/scss/_progress.scss","webpack://./node_modules/@coreui/coreui/scss/_list-group.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_list-group.scss","webpack://./node_modules/@coreui/coreui/scss/_close.scss","webpack://./node_modules/@coreui/coreui/scss/_toasts.scss","webpack://./node_modules/@coreui/coreui/scss/_modal.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_backdrop.scss","webpack://./node_modules/@coreui/coreui/scss/_tooltip.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_reset-text.scss","webpack://./node_modules/@coreui/coreui/scss/_popover.scss","webpack://./node_modules/@coreui/coreui/scss/_carousel.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_clearfix.scss","webpack://./node_modules/@coreui/coreui/scss/_spinners.scss","webpack://./node_modules/@coreui/coreui/scss/_offcanvas.scss","webpack://./node_modules/@coreui/coreui/scss/_placeholders.scss","webpack://./node_modules/@coreui/coreui/scss/_avatar.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_avatar.scss","webpack://./node_modules/@coreui/coreui/scss/_callout.scss","webpack://./node_modules/@coreui/coreui/scss/_footer.scss","webpack://./node_modules/@coreui/coreui/scss/_header.scss","webpack://./node_modules/@coreui/coreui/scss/_icon.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_icon.scss","webpack://./node_modules/@coreui/coreui/scss/sidebar/_sidebar.scss","webpack://./node_modules/@coreui/coreui/scss/sidebar/_sidebar-nav.scss","webpack://./node_modules/@coreui/coreui/scss/sidebar/_sidebar-narrow.scss","webpack://./node_modules/@coreui/coreui/scss/_subheader.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_color-bg.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_colored-links.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_focus-ring.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_icon-link.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_ratio.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_position.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_stacks.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_visually-hidden.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_visually-hidden.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_stretched-link.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_text-truncation.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_text-truncate.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_vr.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_utilities.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_api.scss","webpack://./node_modules/@coreui/chartjs/scss/coreui-chartjs.scss","webpack://./node_modules/@coreui/chartjs/scss/_tooltips.scss","webpack://./src/scss/_color-bg.scss","webpack://./src/scss/_layout.scss","webpack://./src/scss/_custom.scss","webpack://./src/scss/_animate.scss","webpack://./src/scss/_pagination.scss","webpack://./src/scss/_styletree.scss","webpack://./src/scss/_mixins.scss","webpack://./src/scss/_datepicker.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACCd;;;;EAAA;ACDF;EAQI,mBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,wBAAA;EAIA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,gBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAIA,+BAAA;EAAA,kCAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,2BAAA;EAGF,8BAAA;EACA,yBAAA;EAQA,8HAAA;EACA,0GAAA;EACA,0FAAA;EAOA,kDAAA;ECsPI,0BALI;ED/OR,2BAAA;EACA,2BAAA;EAKA,wCAAA;EACA,gCAAA;EACA,mBAAA;EACA,gCAAA;EAEA,6BAAA;EACA,kCAAA;EAEA,8CAAA;EACA,qCAAA;EACA,2BAAA;EACA,qCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAGA,2CAAA;EACA,8CAAA;EACA,sCAAA;EAEA,sDAAA;EACA,uDAAA;EACA,iDAAA;EAEA,4BAAA;EAEA,yBAAA;EACA,kCAAA;EACA,gCAAA;EAEA,+BAAA;EACA,sCAAA;EAMA,yBAAA;EACA,2BAAA;EAGA,uBAAA;EACA,yBAAA;EACA,2BAAA;EACA,qDAAA;EAEA,6BAAA;EACA,+BAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,qDAAA;EACA,+BAAA;EAGA,oDAAA;EACA,6DAAA;EACA,sDAAA;EACA,6DAAA;EAIA,+BAAA;EACA,8BAAA;EACA,gDAAA;EAIA,+BAAA;EACA,sCAAA;EACA,iCAAA;EACA,wCAAA;AFhBF;;AI5FA;;;EAGE,sBAAA;AJ+FF;;AIhFI;EANJ;IAOM,uBAAA;EJoFJ;AACF;;AIvEA;EACE,SAAA;EACA,wCAAA;ED6OI,oCALI;ECtOR,wCAAA;EACA,wCAAA;EACA,4BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8BAAA;EACA,8CAAA;AJ0EF;;AIjEA;EACE,cAAA;EACA,cC6qB4B;ED5qB5B,SAAA;EACA,yCAAA;EACA,aCmrB4B;AL/mB9B;;AI1DA;EACE,aAAA;EACA,qBC0mB4B;EDvmB5B,gBC0mB4B;EDzmB5B,gBC0mB4B;EDzmB5B,+BAAA;AJ2DF;;AIxDA;EDuMQ,iCAAA;AH3IR;AGjBI;EC3CJ;ID8MQ,iBAAA;EH9IN;AACF;;AI5DA;EDkMQ,iCAAA;AHlIR;AG1BI;ECtCJ;IDyMQ,eAAA;EHrIN;AACF;;AIhEA;ED6LQ,+BAAA;AHzHR;AGnCI;ECjCJ;IDoMQ,kBAAA;EH5HN;AACF;;AIpEA;EDwLQ,iCAAA;AHhHR;AG5CI;EC5BJ;ID+LQ,iBAAA;EHnHN;AACF;;AIxEA;ED+KM,kBALI;AH9FV;;AIvEA;ED0KM,eALI;AH1FV;;AIhEA;EACE,aAAA;EACA,mBCyY0B;ALtU5B;;AIzDA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;AJ4DF;;AItDA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AJyDF;;AI9CA;;;EAGE,aAAA;EACA,mBAAA;AJiDF;;AI9CA;;;;EAIE,gBAAA;AJiDF;;AI9CA;EACE,gBC+e4B;AL9b9B;;AI5CA;EACE,qBAAA;EEjII,cAAA;ANiLN;;AIzCA;EACE,gBAAA;AJ4CF;;AIpCA;;EAEE,mBCwd4B;ALjb9B;;AI/BA;ED6EM,kBALI;AHrCV;;AI5BA;EACE,iBC+iB4B;ED9iB5B,yCAAA;AJ+BF;;AItBA;;EAEE,kBAAA;EDyDI,iBALI;EClDR,cAAA;EACA,wBAAA;AJyBF;;AItBA;EAAM,eAAA;AJ0BN;;AIzBA;EAAM,WAAA;AJ6BN;;AIxBA;EACE,kEAAA;EACA,0BCkQwC;ALvO1C;AIzBE;EACE,qDAAA;AJ2BJ;;AIjBE;EAEE,cAAA;EACA,qBAAA;AJmBJ;;AIZA;;;;EAIE,sCCoY4B;EFpXxB,cALI;AHKV;;AIRA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EDII,kBALI;ECGR,6BAAA;AJWF;AIRE;EDDI,kBALI;ECQN,cAAA;EACA,kBAAA;AJUJ;;AINA;EDRM,kBALI;ECeR,4BAAA;EACA,qBAAA;AJSF;AINE;EACE,cAAA;AJQJ;;AIJA;EACE,2BAAA;EDpBI,kBALI;EC2BR,+CAAA;EACA,0DAAA;EGnSE,sBAAA;AP2SJ;AILE;EACE,UAAA;ED3BE,cALI;AHwCV;;AIGA;EACE,gBAAA;AJAF;;AIMA;;EAEE,sBAAA;AJHF;;AIWA;EACE,oBAAA;EACA,yBAAA;AJRF;;AIWA;EACE,mBC8b4B;ED7b5B,sBC6b4B;ED5b5B,iEAAA;EACA,gBAAA;AJRF;;AIeA;EAEE,mBAAA;EACA,gCAAA;AJbF;;AIgBA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AJbF;;AIqBA;EACE,qBAAA;AJlBF;;AIwBA;EAEE,gBAAA;AJtBF;;AI8BA;EACE,UAAA;AJ3BF;;AIgCA;;;;;EAKE,SAAA;EACA,oBAAA;ED1HI,kBALI;ECiIR,oBAAA;AJ7BF;;AIiCA;;EAEE,oBAAA;AJ9BF;;AImCA;EACE,eAAA;AJhCF;;AImCA;EAGE,iBAAA;AJlCF;AIqCE;EACE,UAAA;AJnCJ;;AI0CA;EACE,wBAAA;AJvCF;;AI+CA;;;;EAIE,0BAAA;AJ5CF;AI+CI;;;;EACE,eAAA;AJ1CN;;AIiDA;EACE,UAAA;EACA,kBAAA;AJ9CF;;AImDA;EACE,gBAAA;AJhDF;;AI0DA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AJvDF;;AI+DA;EEvbM,WAAA;EFybJ,WAAA;EACA,UAAA;EACA,qBC+Q4B;EF9dtB,iCAAA;ECkNN,oBAAA;AJ7DF;AGjTI;ECuWJ;IDpMQ,iBAAA;EHkJN;AACF;AI0DE;EACE,WAAA;AJxDJ;;AI+DA;;;;;;;EAOE,UAAA;AJ5DF;;AI+DA;EACE,YAAA;AJ5DF;;AIqEA;EACE,6BAAA;EACA,oBAAA;AJlEF;;AIyEE;;;;EAIE,cAAA;AJtEJ;;AI6EA;EACE,wBAAA;AJ1EF;;AI+EA;EACE,UAAA;AJ5EF;;AImFA;EACE,aAAA;EACA,0BAAA;AJhFF;;AIqFA;EACE,qBAAA;AJlFF;;AIuFA;EACE,SAAA;AJpFF;;AI2FA;EACE,kBAAA;EACA,eAAA;AJxFF;;AIgGA;EACE,wBAAA;AJ7FF;;AIqGA;EACE,wBAAA;AJlGF;;AQheA;ELmQM,kBALI;EK5PR,gBH0rB8B;ALvNhC;;AQ9dE;ELgQM,iCAAA;EK5PJ,gBH2qBkB;EG1qBlB,gBH0pB0B;AL3L9B;AGhYI;EKpGF;ILuQM,eAAA;EHiON;AACF;;AQzeE;ELgQM,iCAAA;EK5PJ,gBH2qBkB;EG1qBlB,gBH0pB0B;ALhL9B;AG3YI;EKpGF;ILuQM,iBAAA;EH4ON;AACF;;AQpfE;ELgQM,iCAAA;EK5PJ,gBH2qBkB;EG1qBlB,gBH0pB0B;ALrK9B;AGtZI;EKpGF;ILuQM,eAAA;EHuPN;AACF;;AQ/fE;ELgQM,iCAAA;EK5PJ,gBH2qBkB;EG1qBlB,gBH0pB0B;AL1J9B;AGjaI;EKpGF;ILuQM,iBAAA;EHkQN;AACF;;AQ1gBE;ELgQM,iCAAA;EK5PJ,gBH2qBkB;EG1qBlB,gBH0pB0B;AL/I9B;AG5aI;EKpGF;ILuQM,eAAA;EH6QN;AACF;;AQrhBE;ELgQM,iCAAA;EK5PJ,gBH2qBkB;EG1qBlB,gBH0pB0B;ALpI9B;AGvbI;EKpGF;ILuQM,iBAAA;EHwRN;AACF;;AQxgBA;EFJM,eAAA;EGlDJ,gBAAA;ATmkBF;;AQxgBA;EFTM,eAAA;EGlDJ,gBAAA;ATwkBF;;AQ1gBA;EACE,qBAAA;AR6gBF;AQ3gBE;EFfI,oBAAA;AN6hBN;;AQngBA;EL8MM,kBALI;EKvMR,yBAAA;ARsgBF;;AQlgBA;EACE,mBHkXO;EF3KH,kBALI;AHoUV;AQngBE;EACE,gBAAA;ARqgBJ;;AQjgBA;EACE,iBAAA;EACA,mBHwWO;EF3KH,kBALI;EKtLR,cHrFU;ALylBZ;AQlgBE;EACE,aAAA;ARogBJ;;AUpmBA;ECIE,eAAA;EAGA,YAAA;AXkmBF;;AUnmBA;EACE,gBLqxDkC;EKpxDlC,6DAAA;EACA,gGAAA;EHGE,uCAAA;EKLE,oCARW;EDKf,eAAA;EAGA,YAAA;AX4mBF;;AU9lBA;EAEE,qBAAA;AVgmBF;;AU7lBA;EACE,qBAAA;EACA,cAAA;AVgmBF;;AU7lBA;EPyPM,kBALI;EOlPR,kEAAA;AVgmBF;;AaloBE;;;;;;;ECHA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,6CAAA;EACA,kBAAA;EACA,iBAAA;Ad+oBF;;AezlBI;EF5CE;IACE,gBRmhBe;ELsHrB;AACF;Ae/lBI;EF5CE;IACE,gBRmhBe;EL2HrB;AACF;AepmBI;EF5CE;IACE,gBRmhBe;ELgIrB;AACF;AezmBI;EF5CE;IACE,iBRmhBe;ELqIrB;AACF;Ae9mBI;EF5CE;IACE,iBRmhBe;EL0IrB;AACF;AgB9qBA;EAEI,sBAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,4BAAA;EAGF,2BAAA;AhBkrBF;;AgB9qBE;ECRA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EAEA,0CAAA;EACA,8CAAA;EACA,6CAAA;AjByrBF;AgBrrBI;ECKF,cAAA;EACA,WAAA;EACA,eAAA;EACA,8CAAA;EACA,6CAAA;EACA,+BAAA;AjBmrBF;;AiBpoBM;EACE,SAAA;AjBuoBR;;AiBpoBM;EApCJ,cAAA;EACA,WAAA;AjB4qBF;;AiB9pBE;EACE,cAAA;EACA,WAAA;AjBiqBJ;;AiBnqBE;EACE,cAAA;EACA,UAAA;AjBsqBJ;;AiBxqBE;EACE,cAAA;EACA,qBAAA;AjB2qBJ;;AiB7qBE;EACE,cAAA;EACA,UAAA;AjBgrBJ;;AiBlrBE;EACE,cAAA;EACA,UAAA;AjBqrBJ;;AiBvrBE;EACE,cAAA;EACA,qBAAA;AjB0rBJ;;AiB3pBM;EAhDJ,cAAA;EACA,WAAA;AjB+sBF;;AiB1pBU;EAhEN,cAAA;EACA,kBAAA;AjB8tBJ;;AiB/pBU;EAhEN,cAAA;EACA,mBAAA;AjBmuBJ;;AiBpqBU;EAhEN,cAAA;EACA,UAAA;AjBwuBJ;;AiBzqBU;EAhEN,cAAA;EACA,mBAAA;AjB6uBJ;;AiB9qBU;EAhEN,cAAA;EACA,mBAAA;AjBkvBJ;;AiBnrBU;EAhEN,cAAA;EACA,UAAA;AjBuvBJ;;AiBxrBU;EAhEN,cAAA;EACA,mBAAA;AjB4vBJ;;AiB7rBU;EAhEN,cAAA;EACA,mBAAA;AjBiwBJ;;AiBlsBU;EAhEN,cAAA;EACA,UAAA;AjBswBJ;;AiBvsBU;EAhEN,cAAA;EACA,mBAAA;AjB2wBJ;;AiB5sBU;EAhEN,cAAA;EACA,mBAAA;AjBgxBJ;;AiBjtBU;EAhEN,cAAA;EACA,WAAA;AjBqxBJ;;AiB9sBY;EXhDN,wBAAA;ANkwBN;;AiBltBY;EXhDN,yBAAA;ANswBN;;AiBttBY;EXhDN,gBAAA;AN0wBN;;AiB1tBY;EXhDN,yBAAA;AN8wBN;;AiB9tBY;EXhDN,yBAAA;ANkxBN;;AiBluBY;EXhDN,gBAAA;ANsxBN;;AiBtuBY;EXhDN,yBAAA;AN0xBN;;AiB1uBY;EXhDN,yBAAA;AN8xBN;;AiB9uBY;EXhDN,gBAAA;ANkyBN;;AiBlvBY;EXhDN,yBAAA;ANsyBN;;AiBtvBY;EXhDN,yBAAA;AN0yBN;;AiB/uBQ;;EAEE,iBAAA;AjBkvBV;;AiB/uBQ;;EAEE,iBAAA;AjBkvBV;;AiBzvBQ;;EAEE,uBAAA;AjB4vBV;;AiBzvBQ;;EAEE,uBAAA;AjB4vBV;;AiBnwBQ;;EAEE,sBAAA;AjBswBV;;AiBnwBQ;;EAEE,sBAAA;AjBswBV;;AiB7wBQ;;EAEE,oBAAA;AjBgxBV;;AiB7wBQ;;EAEE,oBAAA;AjBgxBV;;AiBvxBQ;;EAEE,sBAAA;AjB0xBV;;AiBvxBQ;;EAEE,sBAAA;AjB0xBV;;AiBjyBQ;;EAEE,oBAAA;AjBoyBV;;AiBjyBQ;;EAEE,oBAAA;AjBoyBV;;Ae91BI;EEUE;IACE,SAAA;EjBw1BN;EiBr1BI;IApCJ,cAAA;IACA,WAAA;EjB43BA;EiB92BA;IACE,cAAA;IACA,WAAA;EjBg3BF;EiBl3BA;IACE,cAAA;IACA,UAAA;EjBo3BF;EiBt3BA;IACE,cAAA;IACA,qBAAA;EjBw3BF;EiB13BA;IACE,cAAA;IACA,UAAA;EjB43BF;EiB93BA;IACE,cAAA;IACA,UAAA;EjBg4BF;EiBl4BA;IACE,cAAA;IACA,qBAAA;EjBo4BF;EiBr2BI;IAhDJ,cAAA;IACA,WAAA;EjBw5BA;EiBn2BQ;IAhEN,cAAA;IACA,kBAAA;EjBs6BF;EiBv2BQ;IAhEN,cAAA;IACA,mBAAA;EjB06BF;EiB32BQ;IAhEN,cAAA;IACA,UAAA;EjB86BF;EiB/2BQ;IAhEN,cAAA;IACA,mBAAA;EjBk7BF;EiBn3BQ;IAhEN,cAAA;IACA,mBAAA;EjBs7BF;EiBv3BQ;IAhEN,cAAA;IACA,UAAA;EjB07BF;EiB33BQ;IAhEN,cAAA;IACA,mBAAA;EjB87BF;EiB/3BQ;IAhEN,cAAA;IACA,mBAAA;EjBk8BF;EiBn4BQ;IAhEN,cAAA;IACA,UAAA;EjBs8BF;EiBv4BQ;IAhEN,cAAA;IACA,mBAAA;EjB08BF;EiB34BQ;IAhEN,cAAA;IACA,mBAAA;EjB88BF;EiB/4BQ;IAhEN,cAAA;IACA,WAAA;EjBk9BF;EiB34BU;IXhDN,cAAA;EN87BJ;EiB94BU;IXhDN,wBAAA;ENi8BJ;EiBj5BU;IXhDN,yBAAA;ENo8BJ;EiBp5BU;IXhDN,gBAAA;ENu8BJ;EiBv5BU;IXhDN,yBAAA;EN08BJ;EiB15BU;IXhDN,yBAAA;EN68BJ;EiB75BU;IXhDN,gBAAA;ENg9BJ;EiBh6BU;IXhDN,yBAAA;ENm9BJ;EiBn6BU;IXhDN,yBAAA;ENs9BJ;EiBt6BU;IXhDN,gBAAA;ENy9BJ;EiBz6BU;IXhDN,yBAAA;EN49BJ;EiB56BU;IXhDN,yBAAA;EN+9BJ;EiBp6BM;;IAEE,iBAAA;EjBs6BR;EiBn6BM;;IAEE,iBAAA;EjBq6BR;EiB56BM;;IAEE,uBAAA;EjB86BR;EiB36BM;;IAEE,uBAAA;EjB66BR;EiBp7BM;;IAEE,sBAAA;EjBs7BR;EiBn7BM;;IAEE,sBAAA;EjBq7BR;EiB57BM;;IAEE,oBAAA;EjB87BR;EiB37BM;;IAEE,oBAAA;EjB67BR;EiBp8BM;;IAEE,sBAAA;EjBs8BR;EiBn8BM;;IAEE,sBAAA;EjBq8BR;EiB58BM;;IAEE,oBAAA;EjB88BR;EiB38BM;;IAEE,oBAAA;EjB68BR;AACF;AexgCI;EEUE;IACE,SAAA;EjBigCN;EiB9/BI;IApCJ,cAAA;IACA,WAAA;EjBqiCA;EiBvhCA;IACE,cAAA;IACA,WAAA;EjByhCF;EiB3hCA;IACE,cAAA;IACA,UAAA;EjB6hCF;EiB/hCA;IACE,cAAA;IACA,qBAAA;EjBiiCF;EiBniCA;IACE,cAAA;IACA,UAAA;EjBqiCF;EiBviCA;IACE,cAAA;IACA,UAAA;EjByiCF;EiB3iCA;IACE,cAAA;IACA,qBAAA;EjB6iCF;EiB9gCI;IAhDJ,cAAA;IACA,WAAA;EjBikCA;EiB5gCQ;IAhEN,cAAA;IACA,kBAAA;EjB+kCF;EiBhhCQ;IAhEN,cAAA;IACA,mBAAA;EjBmlCF;EiBphCQ;IAhEN,cAAA;IACA,UAAA;EjBulCF;EiBxhCQ;IAhEN,cAAA;IACA,mBAAA;EjB2lCF;EiB5hCQ;IAhEN,cAAA;IACA,mBAAA;EjB+lCF;EiBhiCQ;IAhEN,cAAA;IACA,UAAA;EjBmmCF;EiBpiCQ;IAhEN,cAAA;IACA,mBAAA;EjBumCF;EiBxiCQ;IAhEN,cAAA;IACA,mBAAA;EjB2mCF;EiB5iCQ;IAhEN,cAAA;IACA,UAAA;EjB+mCF;EiBhjCQ;IAhEN,cAAA;IACA,mBAAA;EjBmnCF;EiBpjCQ;IAhEN,cAAA;IACA,mBAAA;EjBunCF;EiBxjCQ;IAhEN,cAAA;IACA,WAAA;EjB2nCF;EiBpjCU;IXhDN,cAAA;ENumCJ;EiBvjCU;IXhDN,wBAAA;EN0mCJ;EiB1jCU;IXhDN,yBAAA;EN6mCJ;EiB7jCU;IXhDN,gBAAA;ENgnCJ;EiBhkCU;IXhDN,yBAAA;ENmnCJ;EiBnkCU;IXhDN,yBAAA;ENsnCJ;EiBtkCU;IXhDN,gBAAA;ENynCJ;EiBzkCU;IXhDN,yBAAA;EN4nCJ;EiB5kCU;IXhDN,yBAAA;EN+nCJ;EiB/kCU;IXhDN,gBAAA;ENkoCJ;EiBllCU;IXhDN,yBAAA;ENqoCJ;EiBrlCU;IXhDN,yBAAA;ENwoCJ;EiB7kCM;;IAEE,iBAAA;EjB+kCR;EiB5kCM;;IAEE,iBAAA;EjB8kCR;EiBrlCM;;IAEE,uBAAA;EjBulCR;EiBplCM;;IAEE,uBAAA;EjBslCR;EiB7lCM;;IAEE,sBAAA;EjB+lCR;EiB5lCM;;IAEE,sBAAA;EjB8lCR;EiBrmCM;;IAEE,oBAAA;EjBumCR;EiBpmCM;;IAEE,oBAAA;EjBsmCR;EiB7mCM;;IAEE,sBAAA;EjB+mCR;EiB5mCM;;IAEE,sBAAA;EjB8mCR;EiBrnCM;;IAEE,oBAAA;EjBunCR;EiBpnCM;;IAEE,oBAAA;EjBsnCR;AACF;AejrCI;EEUE;IACE,SAAA;EjB0qCN;EiBvqCI;IApCJ,cAAA;IACA,WAAA;EjB8sCA;EiBhsCA;IACE,cAAA;IACA,WAAA;EjBksCF;EiBpsCA;IACE,cAAA;IACA,UAAA;EjBssCF;EiBxsCA;IACE,cAAA;IACA,qBAAA;EjB0sCF;EiB5sCA;IACE,cAAA;IACA,UAAA;EjB8sCF;EiBhtCA;IACE,cAAA;IACA,UAAA;EjBktCF;EiBptCA;IACE,cAAA;IACA,qBAAA;EjBstCF;EiBvrCI;IAhDJ,cAAA;IACA,WAAA;EjB0uCA;EiBrrCQ;IAhEN,cAAA;IACA,kBAAA;EjBwvCF;EiBzrCQ;IAhEN,cAAA;IACA,mBAAA;EjB4vCF;EiB7rCQ;IAhEN,cAAA;IACA,UAAA;EjBgwCF;EiBjsCQ;IAhEN,cAAA;IACA,mBAAA;EjBowCF;EiBrsCQ;IAhEN,cAAA;IACA,mBAAA;EjBwwCF;EiBzsCQ;IAhEN,cAAA;IACA,UAAA;EjB4wCF;EiB7sCQ;IAhEN,cAAA;IACA,mBAAA;EjBgxCF;EiBjtCQ;IAhEN,cAAA;IACA,mBAAA;EjBoxCF;EiBrtCQ;IAhEN,cAAA;IACA,UAAA;EjBwxCF;EiBztCQ;IAhEN,cAAA;IACA,mBAAA;EjB4xCF;EiB7tCQ;IAhEN,cAAA;IACA,mBAAA;EjBgyCF;EiBjuCQ;IAhEN,cAAA;IACA,WAAA;EjBoyCF;EiB7tCU;IXhDN,cAAA;ENgxCJ;EiBhuCU;IXhDN,wBAAA;ENmxCJ;EiBnuCU;IXhDN,yBAAA;ENsxCJ;EiBtuCU;IXhDN,gBAAA;ENyxCJ;EiBzuCU;IXhDN,yBAAA;EN4xCJ;EiB5uCU;IXhDN,yBAAA;EN+xCJ;EiB/uCU;IXhDN,gBAAA;ENkyCJ;EiBlvCU;IXhDN,yBAAA;ENqyCJ;EiBrvCU;IXhDN,yBAAA;ENwyCJ;EiBxvCU;IXhDN,gBAAA;EN2yCJ;EiB3vCU;IXhDN,yBAAA;EN8yCJ;EiB9vCU;IXhDN,yBAAA;ENizCJ;EiBtvCM;;IAEE,iBAAA;EjBwvCR;EiBrvCM;;IAEE,iBAAA;EjBuvCR;EiB9vCM;;IAEE,uBAAA;EjBgwCR;EiB7vCM;;IAEE,uBAAA;EjB+vCR;EiBtwCM;;IAEE,sBAAA;EjBwwCR;EiBrwCM;;IAEE,sBAAA;EjBuwCR;EiB9wCM;;IAEE,oBAAA;EjBgxCR;EiB7wCM;;IAEE,oBAAA;EjB+wCR;EiBtxCM;;IAEE,sBAAA;EjBwxCR;EiBrxCM;;IAEE,sBAAA;EjBuxCR;EiB9xCM;;IAEE,oBAAA;EjBgyCR;EiB7xCM;;IAEE,oBAAA;EjB+xCR;AACF;Ae11CI;EEUE;IACE,SAAA;EjBm1CN;EiBh1CI;IApCJ,cAAA;IACA,WAAA;EjBu3CA;EiBz2CA;IACE,cAAA;IACA,WAAA;EjB22CF;EiB72CA;IACE,cAAA;IACA,UAAA;EjB+2CF;EiBj3CA;IACE,cAAA;IACA,qBAAA;EjBm3CF;EiBr3CA;IACE,cAAA;IACA,UAAA;EjBu3CF;EiBz3CA;IACE,cAAA;IACA,UAAA;EjB23CF;EiB73CA;IACE,cAAA;IACA,qBAAA;EjB+3CF;EiBh2CI;IAhDJ,cAAA;IACA,WAAA;EjBm5CA;EiB91CQ;IAhEN,cAAA;IACA,kBAAA;EjBi6CF;EiBl2CQ;IAhEN,cAAA;IACA,mBAAA;EjBq6CF;EiBt2CQ;IAhEN,cAAA;IACA,UAAA;EjBy6CF;EiB12CQ;IAhEN,cAAA;IACA,mBAAA;EjB66CF;EiB92CQ;IAhEN,cAAA;IACA,mBAAA;EjBi7CF;EiBl3CQ;IAhEN,cAAA;IACA,UAAA;EjBq7CF;EiBt3CQ;IAhEN,cAAA;IACA,mBAAA;EjBy7CF;EiB13CQ;IAhEN,cAAA;IACA,mBAAA;EjB67CF;EiB93CQ;IAhEN,cAAA;IACA,UAAA;EjBi8CF;EiBl4CQ;IAhEN,cAAA;IACA,mBAAA;EjBq8CF;EiBt4CQ;IAhEN,cAAA;IACA,mBAAA;EjBy8CF;EiB14CQ;IAhEN,cAAA;IACA,WAAA;EjB68CF;EiBt4CU;IXhDN,cAAA;ENy7CJ;EiBz4CU;IXhDN,wBAAA;EN47CJ;EiB54CU;IXhDN,yBAAA;EN+7CJ;EiB/4CU;IXhDN,gBAAA;ENk8CJ;EiBl5CU;IXhDN,yBAAA;ENq8CJ;EiBr5CU;IXhDN,yBAAA;ENw8CJ;EiBx5CU;IXhDN,gBAAA;EN28CJ;EiB35CU;IXhDN,yBAAA;EN88CJ;EiB95CU;IXhDN,yBAAA;ENi9CJ;EiBj6CU;IXhDN,gBAAA;ENo9CJ;EiBp6CU;IXhDN,yBAAA;ENu9CJ;EiBv6CU;IXhDN,yBAAA;EN09CJ;EiB/5CM;;IAEE,iBAAA;EjBi6CR;EiB95CM;;IAEE,iBAAA;EjBg6CR;EiBv6CM;;IAEE,uBAAA;EjBy6CR;EiBt6CM;;IAEE,uBAAA;EjBw6CR;EiB/6CM;;IAEE,sBAAA;EjBi7CR;EiB96CM;;IAEE,sBAAA;EjBg7CR;EiBv7CM;;IAEE,oBAAA;EjBy7CR;EiBt7CM;;IAEE,oBAAA;EjBw7CR;EiB/7CM;;IAEE,sBAAA;EjBi8CR;EiB97CM;;IAEE,sBAAA;EjBg8CR;EiBv8CM;;IAEE,oBAAA;EjBy8CR;EiBt8CM;;IAEE,oBAAA;EjBw8CR;AACF;AengDI;EEUE;IACE,SAAA;EjB4/CN;EiBz/CI;IApCJ,cAAA;IACA,WAAA;EjBgiDA;EiBlhDA;IACE,cAAA;IACA,WAAA;EjBohDF;EiBthDA;IACE,cAAA;IACA,UAAA;EjBwhDF;EiB1hDA;IACE,cAAA;IACA,qBAAA;EjB4hDF;EiB9hDA;IACE,cAAA;IACA,UAAA;EjBgiDF;EiBliDA;IACE,cAAA;IACA,UAAA;EjBoiDF;EiBtiDA;IACE,cAAA;IACA,qBAAA;EjBwiDF;EiBzgDI;IAhDJ,cAAA;IACA,WAAA;EjB4jDA;EiBvgDQ;IAhEN,cAAA;IACA,kBAAA;EjB0kDF;EiB3gDQ;IAhEN,cAAA;IACA,mBAAA;EjB8kDF;EiB/gDQ;IAhEN,cAAA;IACA,UAAA;EjBklDF;EiBnhDQ;IAhEN,cAAA;IACA,mBAAA;EjBslDF;EiBvhDQ;IAhEN,cAAA;IACA,mBAAA;EjB0lDF;EiB3hDQ;IAhEN,cAAA;IACA,UAAA;EjB8lDF;EiB/hDQ;IAhEN,cAAA;IACA,mBAAA;EjBkmDF;EiBniDQ;IAhEN,cAAA;IACA,mBAAA;EjBsmDF;EiBviDQ;IAhEN,cAAA;IACA,UAAA;EjB0mDF;EiB3iDQ;IAhEN,cAAA;IACA,mBAAA;EjB8mDF;EiB/iDQ;IAhEN,cAAA;IACA,mBAAA;EjBknDF;EiBnjDQ;IAhEN,cAAA;IACA,WAAA;EjBsnDF;EiB/iDU;IXhDN,cAAA;ENkmDJ;EiBljDU;IXhDN,wBAAA;ENqmDJ;EiBrjDU;IXhDN,yBAAA;ENwmDJ;EiBxjDU;IXhDN,gBAAA;EN2mDJ;EiB3jDU;IXhDN,yBAAA;EN8mDJ;EiB9jDU;IXhDN,yBAAA;ENinDJ;EiBjkDU;IXhDN,gBAAA;ENonDJ;EiBpkDU;IXhDN,yBAAA;ENunDJ;EiBvkDU;IXhDN,yBAAA;EN0nDJ;EiB1kDU;IXhDN,gBAAA;EN6nDJ;EiB7kDU;IXhDN,yBAAA;ENgoDJ;EiBhlDU;IXhDN,yBAAA;ENmoDJ;EiBxkDM;;IAEE,iBAAA;EjB0kDR;EiBvkDM;;IAEE,iBAAA;EjBykDR;EiBhlDM;;IAEE,uBAAA;EjBklDR;EiB/kDM;;IAEE,uBAAA;EjBilDR;EiBxlDM;;IAEE,sBAAA;EjB0lDR;EiBvlDM;;IAEE,sBAAA;EjBylDR;EiBhmDM;;IAEE,oBAAA;EjBkmDR;EiB/lDM;;IAEE,oBAAA;EjBimDR;EiBxmDM;;IAEE,sBAAA;EjB0mDR;EiBvmDM;;IAEE,sBAAA;EjBymDR;EiBhnDM;;IAEE,oBAAA;EjBknDR;EiB/mDM;;IAEE,oBAAA;EjBinDR;AACF;AkBvuDA;EAEE,+BAAA;EACA,4BAAA;EACA,gCAAA;EACA,6BAAA;EAEA,wCAAA;EACA,kCAAA;EACA,iDAAA;EACA,kCAAA;EACA,gDAAA;EACA,4CAAA;EACA,+CAAA;EACA,0CAAA;EACA,8CAAA;EACA,2CAAA;EAEA,WAAA;EACA,mBbmbO;EalbP,mBbuwB4B;EatwB5B,2CAAA;AlBsuDF;AkB/tDE;EACE,sBAAA;EAEA,wFAAA;EACA,qCAAA;EACA,4Cb+wB0B;Ea9wB1B,8GAAA;AlBguDJ;AkB7tDE;EACE,uBAAA;AlB+tDJ;AkB5tDE;EACE,sBAAA;AlB8tDJ;;AkB1tDA;EACE,gEAAA;AlB6tDF;;AkBttDA;EACE,iBAAA;AlBytDF;;AkB/sDE;EACE,wBAAA;AlBktDJ;;AkBnsDE;EACE,uCAAA;AlBssDJ;AkBnsDI;EACE,uCAAA;AlBqsDN;;AkB9rDE;EACE,sBAAA;AlBisDJ;AkB9rDE;EACE,mBAAA;AlBgsDJ;;AkBtrDE;EACE,sDAAA;EACA,gDAAA;AlByrDJ;;AkBnrDE;EACE,sDAAA;EACA,gDAAA;AlBsrDJ;;AkB9qDA;EACE,sDAAA;EACA,gDAAA;AlBirDF;;AkBzqDE;EACE,qDAAA;EACA,+CAAA;AlB4qDJ;;AmBxzDE;EAOE,yCAAA;EACA,uBAAA;EACA,oDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AnBozDJ;;AmBt0DE;EAOE,yCAAA;EACA,uBAAA;EACA,oDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AnBk0DJ;;AmBp1DE;EAOE,yCAAA;EACA,uBAAA;EACA,oDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AnBg1DJ;;AmBl2DE;EAOE,yCAAA;EACA,uBAAA;EACA,oDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AnB81DJ;;AmBh3DE;EAOE,yCAAA;EACA,uBAAA;EACA,oDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AnB42DJ;;AmB93DE;EAOE,yCAAA;EACA,uBAAA;EACA,oDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AnB03DJ;;AmB54DE;EAOE,yCAAA;EACA,uBAAA;EACA,oDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AnBw4DJ;;AmB15DE;EAOE,4CAAA;EACA,uBAAA;EACA,mDAAA;EACA,iDAAA;EACA,oDAAA;EACA,gDAAA;EACA,mDAAA;EACA,iDAAA;EACA,kDAAA;EAEA,6BAAA;EACA,2CAAA;AnBs5DJ;;AkBrwDI;EACE,gBAAA;EACA,iCAAA;AlBwwDN;;Aen2DI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElB8wDJ;AACF;Ae12DI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElBoxDJ;AACF;Aeh3DI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElB0xDJ;AACF;Aet3DI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElBgyDJ;AACF;Ae53DI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElBsyDJ;AACF;AoB18DA;EACE,qBf87BsC;Ee17BtC,oCAAA;ApBy8DF;;AoBp8DA;EACE,qDAAA;EACA,wDAAA;EACA,gBAAA;EjB8QI,kBALI;EiBrQR,gBfipB4B;EehpB5B,oCAAA;ApBq8DF;;AoBl8DA;EACE,mDAAA;EACA,sDAAA;EjBoQI,kBALI;AHusDV;;AoBl8DA;EACE,oDAAA;EACA,uDAAA;EjB8PI,mBALI;AH6sDV;;AqBn+DA;EACE,mBhBs7BsC;EF5pBlC,kBALI;EkBjRR,6DAAA;ArBo+DF;;AsBz+DA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;EnBwRI,eALI;EmBhRR,gBjBopB4B;EiBnpB5B,gBjB2pB4B;EiB1pB5B,oDAAA;EACA,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,4FAAA;EfGE,uCAAA;EKLE,iDARW;EWUX,wEDMJ;AtBw+DF;AuB1+DM;EDhBN;ICiBQ,gBAAA;EvB6+DN;AACF;AsB3+DE;EACE,gBAAA;AtB6+DJ;AsB3+DI;EACE,eAAA;AtB6+DN;AsBx+DE;EACE,0DAAA;EACA,+DAAA;EACA,0DAAA;EACA,UAAA;EVvBE,yFARW;AZ0gEjB;AsB/9DE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;AtBm9DJ;AsB98DE;EACE,cAAA;EACA,UAAA;AtBg9DJ;AsB58DE;EACE,qEAAA;EAEA,UAAA;AtB68DJ;AsBr8DE;EAEE,yCjBk4BoC;EiB/3BpC,UAAA;AtBo8DJ;AsBh8DE;EACE,yBAAA;EACA,0BAAA;EACA,0BjBivB0B;EiBhvB1B,+DAAA;EEjGF,wEFkGuB;EE/FrB,qCAAA;EFgGA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gDjB6vB0B;EiB5vB1B,gBAAA;EC5FE,qID6FF;AtBm8DJ;AuB5hEM;ED6EJ;IC5EM,gBAAA;EvB+hEN;AACF;AsBr8DE;EACE,+EAAA;AtBu8DJ;;AsB97DA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBjBuiB4B;EiBtiB5B,8DAAA;EACA,6BAAA;EACA,yBAAA;EACA,uCAAA;AtBi8DF;AsB/7DE;EACE,UAAA;AtBi8DJ;AsB97DE;EAEE,gBAAA;EACA,eAAA;AtB+7DJ;;AsBp7DA;EACE,oEjBg2BsC;EiB/1BtC,uBAAA;EnBsII,mBALI;EIvQN,0CAAA;AP+jEJ;AsBr7DE;EACE,uBAAA;EACA,wBAAA;EACA,yBjBisB0B;ALsvC9B;;AsBn7DA;EACE,kEjBo1BsC;EiBn1BtC,oBAAA;EnByHI,kBALI;EIvQN,0CAAA;AP2kEJ;AsBp7DE;EACE,oBAAA;EACA,qBAAA;EACA,uBjBwrB0B;AL8vC9B;;AsB96DE;EACE,qEjBi0BoC;ALgnCxC;AsB96DE;EACE,oEjB8zBoC;ALknCxC;AsB76DE;EACE,kEjB2zBoC;ALonCxC;;AsB16DA;EACE,WjByzBsC;EiBxzBtC,iEjBkzBsC;EiBjzBtC,iBjB8oB4B;AL+xC9B;AsB36DE;EACE,eAAA;AtB66DJ;AsB16DE;EACE,oBAAA;Ef1LA,uCAAA;APumEJ;AsBz6DE;EACE,oBAAA;Ef/LA,uCAAA;AP2mEJ;AsBx6DE;EAAoB,gEjBkyBkB;ALyoCxC;AsB16DE;EAAoB,8DjBkyBkB;AL2oCxC;;AyB/nEA;EACE,iEAAA;EAEA,cAAA;EACA,WAAA;EnB0EI,0CAAA;EmBxEJ,uCAAA;EtBoRI,eALI;EsB5QR,gBpBgpB4B;EoB/oB5B,gBpBupB4B;EoBtpB5B,0DAAA;EACA,gBAAA;EACA,+DAAA;EACA,qFAAA;EACA,4BAAA;EnB+DI,yCAAA;EmB7DJ,0BpBkkCkC;EoBjkClC,kGAAA;ElBJE,uCAAA;EKLE,iDARW;EWUX,wEEUJ;AzBgoEF;AuBtoEM;EEfN;IFgBQ,gBAAA;EvByoEN;AACF;AyBnoEE;EACE,gEAAA;EACA,UAAA;EbhBE,yFARW;AZ8pEjB;AyB7nEE;EnBgBI,sBAAA;EmBbF,sBAAA;AzB8nEJ;AyB3nEE;EACE,8CAAA;EACA,6EAAA;AzB6nEJ;AyBxnEE;EACE,kBAAA;EACA,sEAAA;AzB0nEJ;;AyBtnEA;EACE,oBpBqyB4B;EoBpyB5B,uBpBoyB4B;ECzyBxB,oBAAA;EHwOA,mBALI;EIvQN,0CAAA;APqqEJ;;AyBtnEA;EACE,mBpBiyB4B;EoBhyB5B,sBpBgyB4B;EC7yBxB,kBAAA;EHwOA,kBALI;EIvQN,0CAAA;AP6qEJ;;A0B5rEA;EACE,cAAA;EACA,kBrB4/BwC;EC38BpC,mBAAA;EoB/CJ,uBrB4/BwC;ALmsC1C;A0B7rEE;EpB6CI,WAAA;EAAA,mBAAA;ANopEN;;A0B3rEA;EpBuCM,oBAAA;EAAA,eAAA;EAAA,iBAAA;AN0pEN;A0B5rEE;EpBkCI,YAAA;EAAA,oBAAA;EAAA,cAAA;AN+pEN;;A0B1rEA;EACE,uCAAA;EAEA,UrBk+BwC;EqBj+BxC,WrBi+BwC;EqBh+BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,gDAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,6DrBm+BwC;EqBl+BxC,iCAAA;UAAA,yBAAA;A1B4rEF;A0BzrEE;EnB1BE,qBAAA;APstEJ;A0BxrEE;EAEE,kBrB29BsC;AL8tC1C;A0BtrEE;EACE,uBrBk9BsC;ALsuC1C;A0BrrEE;EACE,qBrB86BoC;EqB76BpC,UAAA;EACA,kDrBijBoB;ALsoDxB;A0BprEE;EACE,uEAAA;EACA,uEAAA;A1BsrEJ;A0BprEI;EAEI,uFAAA;A1BqrER;A0B/qEI;EAEI,uFAAA;A1BgrER;A0BzqEE;EACE,yBClFM;EDmFN,qBCnFM;EDsFJ,uFAAA;A1ByqEN;A0BnqEE;EACE,oBAAA;EACA,YAAA;EACA,YrB07BuC;AL2uC3C;A0B9pEI;EACE,eAAA;EACA,YrBi7BqC;AL+uC3C;;A0B3pEA;EACE,0CAAA;A1B8pEF;;A0BtpEA;EpBnEM,mBAAA;AN6tEN;A0BvpEE;EACE,6DAAA;EAEA,UrBs6B8B;EC/+B5B,mBAAA;EoB2EF,2CAAA;EACA,gCAAA;EnBhHA,kBAAA;EgBHE,iDGqHF;A1BwpEJ;AuBzwEM;EGyGJ;IHxGM,gBAAA;EvB4wEN;AACF;A0B3pEI;EACE,6DAAA;A1B6pEN;A0B1pEI;EACE,iCrBq6B4B;EqBl6B1B,kFAAA;A1B0pER;A0BnpEE;EpB/FI,oBAAA;EAAA,eAAA;ANsvEN;A0BnpEI;EpBnGE,oBAAA;EAAA,cAAA;AN0vEN;;A0B5oEE;EACE,kBAHO;EpB5GL,oBAAA;AN+vEN;A0B7oEI;EACE,aARI;EASJ,cARK;EpB5GL,oBAAA;ANowEN;A0B5oEI;EAEE,sCAAA;A1B6oEN;;A0BzpEE;EACE,iBAHO;EpB5GL,mBAAA;AN4wEN;A0B1pEI;EACE,UARI;EASJ,aARK;EpB5GL,mBAAA;ANixEN;A0BzpEI;EAEE,qCAAA;A1B0pEN;;A0BrpEA;EACE,qBAAA;EpBhII,kBAAA;ANyxEN;;A0BrpEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A1BwpEF;A0BppEI;EACE,oBAAA;EACA,YAAA;EACA,arBksBwB;ALo9C9B;;A4Br1EA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A5Bw1EF;A4Bt1EE;EACE,UAAA;A5Bw1EJ;A4Bp1EI;EAA0B,kEvBknCa;ALquC3C;A4Bt1EI;EAA0B,kEvBinCa;ALwuC3C;A4Bt1EE;EACE,SAAA;A5Bw1EJ;A4Br1EE;EACE,WvBmmCuC;EuBlmCvC,YvBkmCuC;EuBjmCvC,oBAAA;EACA,gBAAA;EJ1BF,yDI2BuB;EJxBrB,qCAAA;EIyBA,SvBimCuC;EE9mCvC,mBAAA;EKLE,gDARW;EWUX,oHKmBF;ELnBE,4GKmBF;A5Bw1EJ;AuBv2EM;EKMJ;ILLM,wBAAA;IAAA,gBAAA;EvB02EN;AACF;A4B31EI;EJjCF,gEIkCyB;EJ/BvB,qCAAA;AxB63EJ;A4B11EE;EACE,WvB4kC8B;EuB3kC9B,cvB4kC8B;EuB3kC9B,kBAAA;EACA,evB2kC8B;EuB1kC9B,wEAAA;EACA,yBAAA;ErB7BA,mBAAA;EKLE,iDARW;AZw4EjB;A4Bz1EE;EACE,WvBwkCuC;EuBvkCvC,YvBukCuC;EuBtkCvC,gBAAA;EJpDF,yDIqDuB;EJlDrB,qCAAA;EImDA,SvBukCuC;EE9mCvC,mBAAA;EKLE,gDARW;EWUX,iHK6CF;EL7CE,4GK6CF;A5B41EJ;AuBr4EM;EKiCJ;ILhCM,qBAAA;IAAA,gBAAA;EvBw4EN;AACF;A4B/1EI;EJ3DF,gEI4DyB;EJzDvB,qCAAA;AxB25EJ;A4B91EE;EACE,WvBkjC8B;EuBjjC9B,cvBkjC8B;EuBjjC9B,kBAAA;EACA,evBijC8B;EuBhjC9B,wEAAA;EACA,yBAAA;ErBvDA,mBAAA;EKLE,iDARW;AZs6EjB;A4B71EE;EACE,oBAAA;A5B+1EJ;A4B71EI;EACE,qFAAA;A5B+1EN;A4B51EI;EACE,qFAAA;A5B81EN;;A6Br7EA;EACE,kBAAA;A7Bw7EF;A6Bt7EE;;;EAGE,wDxB4oCoC;EwB3oCpC,4DxB2oCoC;EwB1oCpC,iBxB2oCoC;AL6yCxC;A6Br7EE;EACE,kBAAA;EACA,MAAA;EvB0CE,OAAA;EuBxCF,UAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;EACA,qBAAA;ENRE,gEMSF;A7Bu7EJ;AuB57EM;EMTJ;INUM,gBAAA;EvB+7EN;AACF;A6Bz7EE;;EAEE,qBAAA;A7B27EJ;A6Bz7EI;;EACE,kBAAA;A7B47EN;A6Bz7EI;;;EAEE,qBxBgnCkC;EwB/mClC,wBxBgnCkC;AL40CxC;A6Bz7EI;;EACE,qBxB2mCkC;EwB1mClC,wBxB2mCkC;ALi1CxC;A6Bx7EE;EACE,qBxBqmCoC;EwBpmCpC,wBxBqmCoC;ALq1CxC;A6Bn7EI;;;;EACE,4CAAA;EACA,8DxB+lCkC;ALy1CxC;A6Bt7EM;;;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,axBulCgC;EwBtlChC,WAAA;EACA,oCxBu5BgC;EEv8BpC,uCAAA;AP4+EJ;A6Br7EI;EACE,4CAAA;EACA,8DxB8kCkC;ALy2CxC;A6Bl7EI;EACE,uCAAA;A7Bo7EN;A6Bh7EE;;EAEE,cxBzEQ;AL2/EZ;A6Bh7EI;;EACE,yCxBi4BkC;ALkjDxC;;A8B1gFA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A9B6gFF;A8B3gFE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A9B6gFJ;A8BzgFE;;;EAGE,UAAA;A9B2gFJ;A8BrgFE;EACE,kBAAA;EACA,UAAA;A9BugFJ;A8BrgFI;EACE,UAAA;A9BugFN;;A8B5/EA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;E3B8OI,eALI;E2BvOR,gBzB2mB4B;EyB1mB5B,gBzBknB4B;EyBjnB5B,gEAAA;EACA,kBAAA;EACA,mBAAA;EACA,yEAAA;EACA,wGAAA;EvBtCE,uCAAA;APsiFJ;;A8Bt/EA;;;;EAIE,oBAAA;E3BwNI,kBALI;EIvQN,0CAAA;AP+iFJ;;A8Bt/EA;;;;EAIE,uBAAA;E3B+MI,mBALI;EIvQN,0CAAA;APwjFJ;;A8Bt/EA;;ExB9BM,mBAAA;ANyhFN;;A8B5+EI;;;;ExB7CE,0BAAA;EAAA,6BAAA;ANiiFN;A8B3+EI;;;;ExBtDE,0BAAA;EAAA,6BAAA;ANwiFN;A8Br+EE;ExBnEI,+CAAA;EAAA,yBAAA;EAAA,4BAAA;AN6iFN;A8Br+EE;;ExBxEI,yBAAA;EAAA,4BAAA;ANkjFN;;A+B/kFE;EACE,aAAA;EACA,WAAA;EACA,mB1B85BoC;EF5pBlC,kBALI;E4B1PN,kC1BspCqB;AL27CzB;;A+B9kFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E5BqPE,mBALI;E4B7ON,W1ByoCqB;E0BxoCrB,oC1BwoCqB;EEnqCrB,uCAAA;AP4mFJ;;A+B5kFI;;;;EAEE,cAAA;A/BilFN;;A+BhoFI;EAqDE,gD1B2nCmB;EC/nCnB,oCAAA;EyBQE,yDAAA;EACA,4BAAA;EzBmBF,2DAAA;EyBjBE,gEAAA;A/B6kFR;A+B1kFM;EACE,gD1BgnCiB;E0B/mCjB,4D1B+mCiB;AL69CzB;;A+B7oFI;EzBiDE,oCAAA;EA4BA,kFAAA;ANqkFN;;A+BlpFI;EAkFE,gD1B8lCmB;ALs+CzB;A+BjkFQ;EAEE,kEAAA;EzBtCJ,uBAAA;EA4BA,+DAAA;EyBaI,2EAAA;A/BkkFV;A+B9jFM;EACE,gD1BilCiB;E0BhlCjB,4D1BglCiB;ALg/CzB;;A+BhqFI;EAwGI,yCAAA;A/B4jFR;;A+BpqFI;EA+GE,gD1BikCmB;ALw/CzB;A+BvjFM;EACE,6C1B8jCiB;AL2/CzB;A+BtjFM;EACE,4D1B0jCiB;AL8/CzB;A+BrjFM;EACE,kC1BsjCiB;ALigDzB;;A+BljFI;EzB9EE,kBAAA;ANooFN;;A+BrrFI;;;;;EA0IM,UAAA;A/BmjFV;;A+BzqFE;EACE,aAAA;EACA,WAAA;EACA,mB1B85BoC;EF5pBlC,kBALI;E4B1PN,oC1BspCqB;ALqhDzB;;A+BxqFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E5BqPE,mBALI;E4B7ON,W1ByoCqB;E0BxoCrB,mC1BwoCqB;EEnqCrB,uCAAA;APssFJ;;A+BtqFI;;;;EAEE,cAAA;A/B2qFN;;A+B1tFI;EAqDE,kD1B2nCmB;EC/nCnB,oCAAA;EyBQE,yDAAA;EACA,4BAAA;EzBmBF,2DAAA;EyBjBE,gEAAA;A/BuqFR;A+BpqFM;EACE,kD1BgnCiB;E0B/mCjB,2D1B+mCiB;ALujDzB;;A+BvuFI;EzBiDE,oCAAA;EA4BA,kFAAA;AN+pFN;;A+B5uFI;EAkFE,kD1B8lCmB;ALgkDzB;A+B3pFQ;EAEE,kEAAA;EzBtCJ,uBAAA;EA4BA,+DAAA;EyBaI,2EAAA;A/B4pFV;A+BxpFM;EACE,kD1BilCiB;E0BhlCjB,2D1BglCiB;AL0kDzB;;A+B1vFI;EAwGI,yCAAA;A/BspFR;;A+B9vFI;EA+GE,kD1BikCmB;ALklDzB;A+BjpFM;EACE,+C1B8jCiB;ALqlDzB;A+BhpFM;EACE,2D1B0jCiB;ALwlDzB;A+B/oFM;EACE,oC1BsjCiB;AL2lDzB;;A+B5oFI;EzB9EE,kBAAA;AN8tFN;;A+B/wFI;;;;;EA4IM,UAAA;A/B2oFV;;AgCzxFA;EAEE,4BAAA;EACA,6BAAA;EACA,uBAAA;E7BuRI,yBALI;E6BhRR,0BAAA;EACA,0BAAA;EACA,sCAAA;EACA,yBAAA;EACA,+CAAA;EACA,mCAAA;EACA,iDAAA;EACA,yCAAA;EACA,8FAAA;EACA,gCAAA;EACA,mFAAA;EAGA,qBAAA;EACA,0DAAA;EACA,uCAAA;E7BsQI,mCALI;E6B/PR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,qEAAA;EzBjBE,2CAAA;EiBfF,mCQkCqB;ER/BnB,qCAAA;EZOE,qCARW;EWUX,qISwBJ;AhCyxFF;AuB7yFM;EShBN;ITiBQ,gBAAA;EvBgzFN;AACF;AgC5xFE;EACE,iCAAA;EAEA,yCAAA;EACA,+CAAA;AhC6xFJ;AgC1xFE;EAEE,2BAAA;EACA,mCAAA;EACA,yCAAA;AhC2xFJ;AgCxxFE;EACE,iCAAA;ERrDF,yCQsDuB;ERnDrB,qCAAA;EQoDA,+CAAA;EACA,UAAA;EAGE,sEAAA;AhCyxFN;AgCnxFE;EACE,+CAAA;EACA,UAAA;EAGE,sEAAA;AhCmxFN;AgC7wFE;EAKE,kCAAA;EACA,0CAAA;EAEA,sBAAA;EACA,gDAAA;EpB3EE,wCARW;AZ81FjB;AgCxwFI;EAGI,yEAAA;AhCwwFR;AgCjwFE;EAGE,oCAAA;EACA,oBAAA;EACA,4CAAA;EACA,sBAAA;EACA,kDAAA;EACA,wCAAA;EpBhGE,gBARW;AZ02FjB;;AgCxvFA;EACE,0CAAA;EACA,4CAAA;EACA,yCAAA;AhC2vFF;;AgCtvFE;EC3GA,0CAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,mDAAA;EACA,8BAAA;EACA,wCAAA;AjCq2FF;;AgCvwFE;EC3GA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,6CAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AjCs3FF;;AgCxxFE;EC3GA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,6CAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AjCu4FF;;AgCzyFE;EC3GA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AjCw5FF;;AgC1zFE;EC3GA,uCAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,gDAAA;EACA,8BAAA;EACA,wCAAA;AjCy6FF;;AgC30FE;EC3GA,wBAAA;EACA,kBAAA;EACA,4BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,2BAAA;EACA,qCAAA;AjC07FF;;AgC51FE;EC3GA,uCAAA;EACA,qBAAA;EACA,+BAAA;EACA,6CAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,gDAAA;EACA,8BAAA;EACA,wCAAA;AjC28FF;;AgC72FE;EC3GA,0CAAA;EACA,qBAAA;EACA,+BAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,4BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,mDAAA;EACA,8BAAA;EACA,wCAAA;AjC49FF;;AgCx3FE;ECpFA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjCg9FF;;AgCx4FE;ECpFA,wBAAA;EACA,+BAAA;EACA,6CAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjCg+FF;;AgCx5FE;ECpFA,wBAAA;EACA,+BAAA;EACA,6CAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjCg/FF;;AgCx6FE;ECpFA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjCggGF;;AgCx7FE;ECpFA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjCghGF;;AgCx8FE;ECpFA,qBAAA;EACA,4BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,8BAAA;EACA,kCAAA;EACA,oBAAA;AjCgiGF;;AgCx9FE;ECpFA,wBAAA;EACA,+BAAA;EACA,6CAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjCgjGF;;AgCx+FE;ECpFA,wBAAA;EACA,+BAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,4BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjCgkGF;;AgCl/FE;EC9DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,yCAAA;AjCojGF;;AgC9/FE;EC9DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,6CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8CAAA;EACA,iCAAA;EACA,0CAAA;AjCgkGF;;AgC1gGE;EC9DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,6CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8CAAA;EACA,iCAAA;EACA,wCAAA;AjC4kGF;;AgCthGE;EC9DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,wCAAA;AjCwlGF;;AgCliGE;EC9DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,yCAAA;AjComGF;;AgC9iGE;EC9DA,qBAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,8BAAA;EACA,yCAAA;AjCgnGF;;AgC1jGE;EC9DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,6CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8CAAA;EACA,iCAAA;EACA,0CAAA;AjC4nGF;;AgCtkGE;EC9DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,2BAAA;EACA,4BAAA;EACA,sCAAA;EACA,4BAAA;EACA,iCAAA;EACA,wCAAA;AjCwoGF;;AgCtkGA;EACE,0BAAA;EACA,sCAAA;EACA,yBAAA;EACA,mCAAA;EACA,kDAAA;EACA,yCAAA;EACA,0CAAA;EACA,iCAAA;EACA,4CAAA;EACA,0BAAA;EACA,wCAAA;EAEA,0B3BiVwC;E2B/UtC,sBAAA;AhCukGJ;AgC/jGE;EACE,2BAAA;AhCikGJ;;AgCtjGA;EC9FE,2BAAA;EACA,yBAAA;E9BiMI,4BALI;E8B1LR,oDAAA;AjCwpGF;;AgCzjGA;EClGE,4BAAA;EACA,2BAAA;E9BiMI,6BALI;E8B1LR,oDAAA;AjC+pGF;;AkC/vGA;EXgBM,gCWfJ;AlCkwGF;AuB/uGM;EWpBN;IXqBQ,gBAAA;EvBkvGN;AACF;AkCrwGE;EACE,UAAA;AlCuwGJ;;AkCjwGE;EACE,aAAA;AlCowGJ;;AkChwGA;EACE,SAAA;EACA,gBAAA;EXDI,6BWEJ;AlCmwGF;AuBjwGM;EWLN;IXMQ,gBAAA;EvBowGN;AACF;AkCtwGE;EACE,QAAA;EACA,YAAA;EXNE,4BWOF;AlCwwGJ;AuB3wGM;EWAJ;IXCM,gBAAA;EvB8wGN;AACF;;AmCnyGA;;;;;;EAME,kBAAA;AnCsyGF;;AmCnyGA;EACE,mBAAA;AnCsyGF;AoC9wGI;EACE,qBAAA;E9BmBA,oBAAA;E8BjBA,uB/B6kBwB;E+B5kBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;ApCszGF;AoC5vGI;E9BRE,cAAA;ANuwGN;;AmC5yGA;EAEE,2BAAA;EACA,+BAAA;EACA,2BAAA;EACA,gCAAA;EACA,+BAAA;EhCuQI,8BALI;EgChQR,2CAAA;EACA,qCAAA;EACA,gEAAA;EACA,sDAAA;EACA,oDAAA;EACA,4FAAA;EACA,8DAAA;EACA,uCAAA;EACA,6DAAA;EACA,gDAAA;EACA,sDAAA;EACA,oDAAA;EACA,2DAAA;EACA,sCAAA;EACA,6DAAA;EACA,mCAAA;EACA,sCAAA;EACA,oCAAA;EACA,qCAAA;EACA,uCAAA;EAGA,kBAAA;EACA,mCAAA;EACA,aAAA;EACA,wCAAA;EACA,oEAAA;EACA,SAAA;EhC0OI,wCALI;EgCnOR,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;EACA,4BAAA;EACA,+EAAA;E5BzCE,gDAAA;EKLE,0CARW;AZo2GjB;AmC1yGE;EACE,SAAA;E7BVE,OAAA;E6BYF,sCAAA;AnC4yGJ;;AmCpxGI;EACE,qBAAA;AnCuxGN;AmCrxGM;E7BvCA,WAAA;EAAA,OAAA;ANg0GN;;AmCnxGI;EACE,mBAAA;AnCsxGN;AmCpxGM;E7BhDA,QAAA;EAAA,UAAA;ANw0GN;;Aeh0GI;EoB4BA;IACE,qBAAA;EnCwyGJ;EmCtyGI;I7BvCA,WAAA;IAAA,OAAA;ENi1GJ;EmCpyGE;IACE,mBAAA;EnCsyGJ;EmCpyGI;I7BhDA,QAAA;IAAA,UAAA;ENw1GJ;AACF;Aej1GI;EoB4BA;IACE,qBAAA;EnCwzGJ;EmCtzGI;I7BvCA,WAAA;IAAA,OAAA;ENi2GJ;EmCpzGE;IACE,mBAAA;EnCszGJ;EmCpzGI;I7BhDA,QAAA;IAAA,UAAA;ENw2GJ;AACF;Aej2GI;EoB4BA;IACE,qBAAA;EnCw0GJ;EmCt0GI;I7BvCA,WAAA;IAAA,OAAA;ENi3GJ;EmCp0GE;IACE,mBAAA;EnCs0GJ;EmCp0GI;I7BhDA,QAAA;IAAA,UAAA;ENw3GJ;AACF;Aej3GI;EoB4BA;IACE,qBAAA;EnCw1GJ;EmCt1GI;I7BvCA,WAAA;IAAA,OAAA;ENi4GJ;EmCp1GE;IACE,mBAAA;EnCs1GJ;EmCp1GI;I7BhDA,QAAA;IAAA,UAAA;ENw4GJ;AACF;Aej4GI;EoB4BA;IACE,qBAAA;EnCw2GJ;EmCt2GI;I7BvCA,WAAA;IAAA,OAAA;ENi5GJ;EmCp2GE;IACE,mBAAA;EnCs2GJ;EmCp2GI;I7BhDA,QAAA;IAAA,UAAA;ENw5GJ;AACF;AmC71GE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,yCAAA;AnC+1GJ;AoCn7GI;EACE,qBAAA;E9BmBA,oBAAA;E8BjBA,uB/B6kBwB;E+B5kBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;ApCo9GF;AoCj6GI;E9BRE,cAAA;AN46GN;;AmCn2GE;EACE,MAAA;E7B1EE,WAAA;EAAA,UAAA;E6B6EF,aAAA;E7B7EE,uCAAA;ANo7GN;AoCx8GI;EACE,qBAAA;E9BmBA,oBAAA;E8BjBA,uB/B6kBwB;E+B5kBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;ApCk+GF;AoCt7GI;E9BRE,cAAA;ANi8GN;AmC92GI;EACE,iBAAA;AnCg3GN;;AmC12GE;EACE,MAAA;E7B3FE,WAAA;EAAA,UAAA;E6B8FF,aAAA;E7B9FE,wCAAA;AN48GN;AoCh+GI;EACE,qBAAA;E9BmBA,oBAAA;E8BjBA,uB/B6kBwB;E+B5kBxB,WAAA;EAYE,aAAA;ApCs9GR;AoCn9GM;EACE,qBAAA;E9BAF,qBAAA;E8BEE,uB/B0jBsB;E+BzjBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;ApC4/GF;AoCt9GI;E9BRE,cAAA;ANi+GN;AmC73GI;EACE,iBAAA;AnC+3GN;;AmCx3GA;EACE,SAAA;EACA,8CAAA;EACA,gBAAA;EACA,oDAAA;EACA,UAAA;AnC23GF;;AmCr3GA;EACE,cAAA;EACA,WAAA;EACA,8EAAA;EACA,WAAA;EACA,gB9B2e4B;E8B1e5B,qCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E5BtKE,wDAAA;AP+hHJ;AmCt3GE;EAEE,2CAAA;EX1LF,mDW4LuB;EXzLrB,qCAAA;AxBgjHJ;AmCp3GE;EAEE,4CAAA;EACA,qBAAA;EXlMF,oDWmMuB;EXhMrB,qCAAA;AxBsjHJ;AmCn3GE;EAEE,8CAAA;EACA,oBAAA;EACA,6BAAA;EAEA,sBAAA;AnCm3GJ;;AmC/2GA;EACE,cAAA;AnCk3GF;;AmC92GA;EACE,cAAA;EACA,kFAAA;EACA,gBAAA;EhCmEI,mBALI;EgC5DR,uCAAA;EACA,mBAAA;AnCi3GF;;AmC72GA;EACE,cAAA;EACA,8EAAA;EACA,qCAAA;AnCg3GF;;AmC52GA;EAEE,6BAAA;EACA,0BAAA;EACA,gEAAA;EACA,2BAAA;EACA,kCAAA;EACA,0DAAA;EACA,8DAAA;EACA,uDAAA;EACA,2DAAA;EACA,sCAAA;EACA,2CAAA;EACA,oCAAA;AnC82GF;;AqCpmHA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;ArCumHF;AqCrmHE;;EACE,kBAAA;EACA,cAAA;ArCwmHJ;AqCnmHE;;;;;;;;;;;;EAME,UAAA;ArC2mHJ;;AqCtmHA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;ArCymHF;AqCvmHE;EACE,WAAA;ArCymHJ;;AqCrmHA;E9BhBI,uCAAA;APynHJ;AqCrmHE;;E/BgBI,+CAAA;ANylHN;AqCnmHE;;;E/BUI,0BAAA;EAAA,6BAAA;AN+lHN;AqC/lHE;;;E/BAI,yBAAA;EAAA,4BAAA;ANqmHN;;AqCllHA;EACE,wBAAA;EACA,uBAAA;ArCqlHF;AqCnlHE;E/BvBI,cAAA;AN6mHN;AqChlHE;E/B7BI,eAAA;ANgnHN;;AqC9kHA;EACE,uBAAA;EACA,sBAAA;ArCilHF;;AqC9kHA;EACE,sBAAA;EACA,qBAAA;ArCilHF;;AqC3kHA;EzBxFM,iDARW;AZ+qHjB;AqC3kHE;EzB5FI,gBARW;AZkrHjB;;AqCpkHA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;ArCukHF;AqCrkHE;;EAEE,WAAA;ArCukHJ;AqCpkHE;;EAEE,8CAAA;ArCskHJ;AqClkHE;;E9B1FE,6BAAA;EACA,4BAAA;APgqHJ;AqClkHE;;E9B7GE,yBAAA;EACA,0BAAA;APmrHJ;;AsC3sHA;EAEE,8BAAA;EACA,gCAAA;EAEA,4BAAA;EACA,2CAAA;EACA,uDAAA;EACA,yDAAA;EAGA,aAAA;EACA,eAAA;EhCsCI,eAAA;EgCpCJ,gBAAA;EACA,gBAAA;AtC0sHF;;AsCvsHA;EACE,cAAA;EACA,oEAAA;EnCsQI,wCALI;EmC/PR,4CAAA;EACA,gCAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EffI,uGegBJ;AtC0sHF;AuBttHM;EeGN;IfFQ,gBAAA;EvBytHN;AACF;AsC7sHE;EAEE,sCAAA;AtC8sHJ;AsC1sHE;EACE,UAAA;EACA,kDjCokBoB;ALwoGxB;AsCxsHE;EAEE,yCAAA;EACA,oBAAA;EACA,eAAA;AtCysHJ;;AsCjsHA;EAEE,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,+GAAA;EACA,2DAAA;EACA,iDAAA;EACA,2GAAA;EAGA,sFAAA;AtCisHF;AsC/rHE;EACE,0DAAA;EACA,0DAAA;E/B7CA,yDAAA;EACA,0DAAA;AP+uHJ;AsChsHI;EAGE,kBAAA;EACA,yDAAA;AtCgsHN;AsC5rHE;;EAEE,4CAAA;EACA,oDAAA;EACA,0DAAA;AtC8rHJ;AsC3rHE;EAEE,uDAAA;E/BjEA,yBAAA;EACA,0BAAA;AP8vHJ;;AsCnrHA;EAEE,uDAAA;EACA,4DAAA;EACA,uCAAA;AtCqrHF;AsClrHE;E/B5FE,iDAAA;APixHJ;AsCjrHE;;EAEE,6CAAA;EdjHF,qDckHuB;Ed/GrB,qCAAA;AxBmyHJ;;AsC1qHE;;EAEE,cAAA;EACA,kBAAA;AtC6qHJ;;AsCxqHE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AtC2qHJ;;AsCrqHE;;EACE,WAAA;AtCyqHJ;;AsC/pHE;EACE,aAAA;AtCkqHJ;AsChqHE;EACE,cAAA;AtCkqHJ;;AuC9zHA;EAEE,yBAAA;EACA,8BAAA;EACA,6DAAA;EACA,kEAAA;EACA,qEAAA;EACA,iEAAA;EACA,uCAAA;EACA,mCAAA;EACA,qCAAA;EACA,gEAAA;EACA,sEAAA;EACA,uCAAA;EACA,uCAAA;EACA,uCAAA;EACA,uCAAA;EACA,qEAAA;EACA,4EAAA;EACA,4DAAA;EACA,yCAAA;EACA,6DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,gEAAA;Ef3BE,qCAAA;AxB01HJ;AuCzzHE;;;;;;;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AvCu0HJ;AuCnzHA;EACE,8CAAA;EACA,iDAAA;EjCXI,gDAAA;EHwOA,4CALI;EoCrNR,oCAAA;EACA,qBAAA;EACA,mBAAA;AvCqzHF;AuCnzHE;EAEE,0CAAA;AvCozHJ;;AuC1yHA;EAEE,2BAAA;EACA,gCAAA;EAEA,4BAAA;EACA,6CAAA;EACA,yDAAA;EACA,+DAAA;EAGA,aAAA;EACA,sBAAA;EjC1CI,eAAA;EiC4CJ,gBAAA;EACA,gBAAA;AvCyyHF;AuCtyHI;EAEE,qCAAA;AvCuyHN;AuCnyHE;EACE,gBAAA;AvCqyHJ;;AuC7xHA;EACE,mBlCqnCkC;EkCpnClC,sBlConCkC;EkCnnClC,8BAAA;AvCgyHF;AuC9xHE;;;EAGE,qCAAA;AvCgyHJ;;AuCnxHA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AvCoxHF;;AuChxHA;EACE,gFAAA;EpC0II,8CALI;EoCnIR,cAAA;EACA,8BAAA;EACA,6BAAA;EACA,4EAAA;EhCvIE,sDAAA;EgBHE,gDgB4IJ;AvCmxHF;AuB35HM;EgBgIN;IhB/HQ,gBAAA;EvB85HN;AACF;AuCtxHE;EACE,qBAAA;AvCwxHJ;AuCrxHE;EACE,qBAAA;EACA,UAAA;EACA,uDAAA;AvCuxHJ;;AuCjxHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AvCoxHF;;AuCjxHA;EACE,0CAAA;EACA,gBAAA;AvCoxHF;;Ae74HI;EwBqIA;IAEI,iBAAA;IACA,2BAAA;EvC2wHN;EuCzwHM;IACE,mBAAA;EvC2wHR;EuCzwHQ;IACE,kBAAA;EvC2wHV;EuCxwHQ;IACE,mDAAA;IACA,kDAAA;EvC0wHV;EuCtwHM;IACE,iBAAA;EvCwwHR;EuCrwHM;IACE,wBAAA;IACA,gBAAA;EvCuwHR;EuCpwHM;IACE,aAAA;EvCswHR;EuCnwHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I3B/NJ,gBARW;IWUX,gBgB+NI;EvCowHR;EuCjwHQ;IACE,aAAA;EvCmwHV;EuChwHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCkwHV;AACF;Ae97HI;EwBqIA;IAEI,iBAAA;IACA,2BAAA;EvC2zHN;EuCzzHM;IACE,mBAAA;EvC2zHR;EuCzzHQ;IACE,kBAAA;EvC2zHV;EuCxzHQ;IACE,mDAAA;IACA,kDAAA;EvC0zHV;EuCtzHM;IACE,iBAAA;EvCwzHR;EuCrzHM;IACE,wBAAA;IACA,gBAAA;EvCuzHR;EuCpzHM;IACE,aAAA;EvCszHR;EuCnzHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I3B/NJ,gBARW;IWUX,gBgB+NI;EvCozHR;EuCjzHQ;IACE,aAAA;EvCmzHV;EuChzHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCkzHV;AACF;Ae9+HI;EwBqIA;IAEI,iBAAA;IACA,2BAAA;EvC22HN;EuCz2HM;IACE,mBAAA;EvC22HR;EuCz2HQ;IACE,kBAAA;EvC22HV;EuCx2HQ;IACE,mDAAA;IACA,kDAAA;EvC02HV;EuCt2HM;IACE,iBAAA;EvCw2HR;EuCr2HM;IACE,wBAAA;IACA,gBAAA;EvCu2HR;EuCp2HM;IACE,aAAA;EvCs2HR;EuCn2HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I3B/NJ,gBARW;IWUX,gBgB+NI;EvCo2HR;EuCj2HQ;IACE,aAAA;EvCm2HV;EuCh2HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCk2HV;AACF;Ae9hII;EwBqIA;IAEI,iBAAA;IACA,2BAAA;EvC25HN;EuCz5HM;IACE,mBAAA;EvC25HR;EuCz5HQ;IACE,kBAAA;EvC25HV;EuCx5HQ;IACE,mDAAA;IACA,kDAAA;EvC05HV;EuCt5HM;IACE,iBAAA;EvCw5HR;EuCr5HM;IACE,wBAAA;IACA,gBAAA;EvCu5HR;EuCp5HM;IACE,aAAA;EvCs5HR;EuCn5HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I3B/NJ,gBARW;IWUX,gBgB+NI;EvCo5HR;EuCj5HQ;IACE,aAAA;EvCm5HV;EuCh5HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCk5HV;AACF;Ae9kII;EwBqIA;IAEI,iBAAA;IACA,2BAAA;EvC28HN;EuCz8HM;IACE,mBAAA;EvC28HR;EuCz8HQ;IACE,kBAAA;EvC28HV;EuCx8HQ;IACE,mDAAA;IACA,kDAAA;EvC08HV;EuCt8HM;IACE,iBAAA;EvCw8HR;EuCr8HM;IACE,wBAAA;IACA,gBAAA;EvCu8HR;EuCp8HM;IACE,aAAA;EvCs8HR;EuCn8HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I3B/NJ,gBARW;IWUX,gBgB+NI;EvCo8HR;EuCj8HQ;IACE,aAAA;EvCm8HV;EuCh8HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCk8HV;AACF;AuCz/HI;EAEI,iBAAA;EACA,2BAAA;AvC0/HR;AuCx/HQ;EACE,mBAAA;AvC0/HV;AuCx/HU;EACE,kBAAA;AvC0/HZ;AuCv/HU;EACE,mDAAA;EACA,kDAAA;AvCy/HZ;AuCr/HQ;EACE,iBAAA;AvCu/HV;AuCp/HQ;EACE,wBAAA;EACA,gBAAA;AvCs/HV;AuCn/HQ;EACE,aAAA;AvCq/HV;AuCl/HQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;E3B/NJ,gBARW;EWUX,gBgB+NI;AvCm/HV;AuCh/HU;EACE,aAAA;AvCk/HZ;AuC/+HU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AvCi/HZ;;AuCh+HA;EAEE,6CAAA;EACA,mDAAA;EACA,sDAAA;EACA,+BAAA;EACA,8BAAA;EACA,oCAAA;EACA,2DAAA;EACA,sEAAA;AvCk+HF;;AwClvIA;EAEE,yBAAA;EACA,yBAAA;EACA,iCAAA;EACA,wBAAA;EACA,2BAAA;EACA,gDAAA;EACA,4DAAA;EACA,kDAAA;EACA,uBAAA;EACA,0FAAA;EACA,gCAAA;EACA,8BAAA;EACA,wDAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,oCAAA;EACA,gCAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,4BAAA;EACA,qBAAA;EACA,oCAAA;EACA,2BAAA;EACA,uEAAA;EjCjBE,4CAAA;EKLE,sCARW;AZkxIjB;AwChvIE;EACE,eAAA;EACA,cAAA;AxCkvIJ;AwC/uIE;EACE,mBAAA;EACA,sBAAA;AxCivIJ;AwC/uII;EACE,mBAAA;EjCtBF,2DAAA;EACA,4DAAA;APwwIJ;AwC/uII;EACE,sBAAA;EjCbF,+DAAA;EACA,8DAAA;AP+vIJ;AwC5uIE;;EAEE,aAAA;AxC8uIJ;;AwC1uIA;EAGE,cAAA;EACA,0DAAA;EACA,4BAAA;AxC2uIF;;AwCxuIA;EACE,6CAAA;EACA,kCAAA;AxC2uIF;;AwCxuIA;EACE,uDAAA;EACA,gBAAA;EACA,qCAAA;AxC2uIF;;AwCxuIA;EACE,gBAAA;AxC2uIF;;AwCnuIE;ElCzCI,qCAAA;ANgxIN;;AwC9tIA;EACE,oEAAA;EACA,gBAAA;EACA,gCAAA;EACA,wCAAA;EACA,8EAAA;AxCiuIF;AwC/tIE;EjC7FE,0FAAA;AP+zIJ;;AwC7tIA;EACE,oEAAA;EACA,gCAAA;EACA,wCAAA;EACA,2EAAA;AxCguIF;AwC9tIE;EjCxGE,0FAAA;APy0IJ;;AwCvtIA;EACE,wDAAA;EACA,uDAAA;EACA,uDAAA;EACA,gBAAA;AxC0tIF;AwCxtIE;EACE,oCAAA;EACA,uCAAA;AxC0tIJ;;AwCttIA;EACE,wDAAA;EACA,uDAAA;AxCytIF;;AwCrtIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,4CAAA;EjC1IE,kDAAA;APm2IJ;;AwCrtIA;;;EAGE,WAAA;AxCwtIF;;AwCrtIA;;EjC3II,2DAAA;EACA,4DAAA;APq2IJ;;AwCttIA;;EjClII,+DAAA;EACA,8DAAA;AP61IJ;;AwC/sIE;EACE,2CAAA;AxCktIJ;Ae70II;EyBuHJ;IAQI,aAAA;IACA,mBAAA;ExCktIF;EwC/sIE;IAEE,SAAA;IACA,gBAAA;ExCgtIJ;EwC9sII;IlChJA,cAAA;IAAA,cAAA;ENk2IJ;EwC3sIM;IlCvJF,0BAAA;IAAA,6BAAA;ENs2IJ;EwC5sIQ;;IAGE,0BAAA;ExC6sIV;EwC3sIQ;;IAGE,6BAAA;ExC4sIV;EwCxsIM;IlCtKF,yBAAA;IAAA,4BAAA;ENk3IJ;EwCzsIQ;;IAGE,yBAAA;ExC0sIV;EwCxsIQ;;IAGE,4BAAA;ExCysIV;AACF;;AyC96IA;EAEE,4CAAA;EACA,sCAAA;EACA,+KAAA;EACA,qDAAA;EACA,qDAAA;EACA,uDAAA;EACA,+FAAA;EACA,sCAAA;EACA,mCAAA;EACA,gDAAA;EACA,+CAAA;EACA,kEAAA;EACA,uCAAA;EACA,mDAAA;EACA,+DAAA;EACA,yEAAA;EACA,+CAAA;EACA,4EAAA;EACA,uCAAA;EACA,oCAAA;EACA,qCAAA;EACA,kCAAA;AzCg7IF;;AyC56IA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8EAAA;EtC2PI,eALI;EsCpPR,qCAAA;EACA,gBAAA;EACA,6CAAA;EACA,SAAA;ElCtBE,gBAAA;EkCwBF,qBAAA;ElB3BI,2CkB4BJ;AzC+6IF;AuBv8IM;EkBWN;IlBVQ,gBAAA;EvB08IN;AACF;AyCl7IE;EACE,wCAAA;EACA,gDAAA;EACA,oGAAA;AzCo7IJ;AyCl7II;EACE,sDAAA;EACA,kDAAA;AzCo7IN;AyC/6IE;EACE,cAAA;EACA,0CAAA;EACA,2CAAA;EACA,iBAAA;EACA,WAAA;EACA,+CAAA;EACA,4BAAA;EACA,oDAAA;ElBlDE,oDkBmDF;AzCi7IJ;AuBh+IM;EkBsCJ;IlBrCM,gBAAA;EvBm+IN;AACF;AyCn7IE;EACE,UAAA;AzCq7IJ;AyCl7IE;EACE,UAAA;EACA,yDAAA;EACA,UAAA;EACA,qDAAA;AzCo7IJ;;AyCh7IA;EACE,gBAAA;AzCm7IF;;AyCh7IA;EACE,iCAAA;EACA,yCAAA;EACA,iFAAA;AzCm7IF;AyCj7IE;ElC/DE,0DAAA;EACA,2DAAA;APm/IJ;AyCl7II;ElClEA,gEAAA;EACA,iEAAA;APu/IJ;AyCj7IE;EACE,aAAA;AzCm7IJ;AyC/6IE;ElC9DE,8DAAA;EACA,6DAAA;APg/IJ;AyC/6IM;ElClEF,oEAAA;EACA,mEAAA;APo/IJ;AyC96II;ElCvEA,8DAAA;EACA,6DAAA;APw/IJ;;AyC56IA;EACE,gFAAA;AzC+6IF;;AyCt6IE;EACE,eAAA;AzCy6IJ;AyCt6IE;EACE,eAAA;EACA,cAAA;ElCpHA,gBAAA;AP6hJJ;AyCt6II;EAAgB,aAAA;AzCy6IpB;AyCx6II;EAAe,gBAAA;AzC26InB;AyCx6IM;ElC3HF,gBAAA;APsiJJ;;A0CzjJA;EAEE,6BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,qBAAA;EACA,gCAAA;EACA,0DAAA;EACA,uCAAA;EACA,2CAAA;EAGA,aAAA;EACA,eAAA;EACA,wEAAA;EACA,kDAAA;EvC+QI,0CALI;EuCxQR,gBAAA;EACA,0CAAA;EnCAE,kDAAA;APyjJJ;;A0CnjJE;EpC8BI,kDAAA;ANyhJN;A0CpjJI;EpC2BE,WAAA;EAAA,mDAAA;EoCxBA,0CAAA;EpCwBA,2CAAA;AN+hJN;A0C7iJE;EACE,8CAAA;A1C+iJJ;;A2CzlJA;EAEE,mCAAA;EACA,oCAAA;ExC4RI,gCALI;EwCrRR,6CAAA;EACA,uCAAA;EACA,sDAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;EACA,iDAAA;EACA,4DAAA;EACA,yDAAA;EACA,kDAAA;EACA,yEAAA;EACA,wDAAA;EACA,mCAAA;EACA,6CAAA;EACA,2DAAA;EACA,qDAAA;EACA,+DAAA;EAGA,aAAA;ErC+BI,eAAA;EGlDJ,gBAAA;AT8mJF;;A2CvlJA;EACE,kBAAA;EACA,cAAA;EACA,wEAAA;ExCgQI,0CALI;EwCzPR,kCAAA;EACA,qBAAA;EACA,0CAAA;EACA,mFAAA;EpBpBI,qIoBqBJ;A3C0lJF;AuB3mJM;EoBQN;IpBPQ,gBAAA;EvB8mJN;AACF;A2C7lJE;EACE,UAAA;EACA,wCAAA;EAEA,gDAAA;EACA,sDAAA;A3C8lJJ;A2C3lJE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,UtC40CgC;EsC30ChC,kDAAA;A3C6lJJ;A2C1lJE;EAEE,UAAA;EACA,yCAAA;EnBtDF,iDmBuDuB;EnBpDrB,qCAAA;EmBqDA,uDAAA;A3C4lJJ;A2CzlJE;EAEE,2CAAA;EACA,oBAAA;EACA,mDAAA;EACA,yDAAA;A3C0lJJ;;A2CrlJE;ErClBI,+CAAA;AN2mJN;A2CnlJM;ErCxBA,2DAAA;EAAA,8DAAA;AN+mJN;A2CjlJM;ErC9BA,4DAAA;EAAA,+DAAA;ANmnJN;;A2CpkJA;EClGE,kCAAA;EACA,mCAAA;EzC0RI,mCALI;EyCnRR,2DAAA;A5C0qJF;;A2CvkJA;ECtGE,kCAAA;EACA,mCAAA;EzC0RI,oCALI;EyCnRR,2DAAA;A5CirJF;;A6CnrJA;EAEE,6BAAA;EACA,6BAAA;E1CuRI,6BALI;E0ChRR,4BAAA;EACA,4CAAA;EACA,mDAAA;EAGA,qBAAA;EACA,8DAAA;E1C+QI,qCALI;E0CxQR,yCAAA;EACA,cAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gDAAA;ErBjBE,qCAAA;AxBqsJJ;A6ChrJE;EACE,aAAA;A7CkrJJ;;A6C7qJA;EACE,kBAAA;EACA,SAAA;A7CgrJF;;A6CzqJA;EACE,4BAAA;EACA,4BAAA;E1CkPI,iBALI;AHg8IV;;A8CttJA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,+BAAA;EACA,0BAAA;EACA,qCAAA;EACA,+EAAA;EACA,mDAAA;EACA,+BAAA;EAGA,kBAAA;EACA,8DAAA;EACA,6CAAA;EACA,6BAAA;EACA,qCAAA;EACA,+BAAA;EvCHE,6CAAA;AP0tJJ;;A8CltJA;EAEE,cAAA;A9CotJF;;A8ChtJA;EACE,gBzC+nB4B;EyC9nB5B,kCAAA;A9CmtJF;;A8C3sJA;ExCYM,mBAAA;ANmsJN;A8C3sJE;EACE,kBAAA;EACA,MAAA;ExCME,QAAA;EwCJF,UAAA;EACA,qBAAA;A9C6sJJ;;A8CrsJE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A9CwsJJ;;A8C5sJE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A9C+sJJ;;A8CntJE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A9CstJJ;;A8C1tJE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A9C6tJJ;;A8CjuJE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A9CouJJ;;A8CxuJE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A9C2uJJ;;A8C/uJE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A9CkvJJ;;A8CtvJE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A9CyvJJ;;A+CrzJE;EACE;IAAK,2B1CoqD2B;ELqpGlC;AACF;A+CrzJA;;EAGE,2BAAA;E5CkRI,iCALI;E4C3QR,0CAAA;EACA,sDAAA;EACA,sDAAA;EACA,mDAAA;EACA,yCAAA;EACA,8CAAA;EAGA,aAAA;EACA,kCAAA;EACA,gBAAA;E5CsQI,wCALI;E4C/PR,wCAAA;ExCRE,gDAAA;EKLE,0CARW;AZ20JjB;;A+CjzJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;ExBxBI,8CwByBJ;A/CozJF;AuBz0JM;EwBYN;IxBXQ,gBAAA;EvB40JN;AACF;;A+CtzJA;EvBAE,qMAAA;EuBEA,sEAAA;A/CyzJF;;A+CtzJA;EACE,iBAAA;A/CyzJF;;A+CtzJA;EACE,WAAA;A/CyzJF;;A+CrzJE;EACE,kDAAA;A/CwzJJ;A+CrzJM;EAJJ;IAKM,eAAA;E/CwzJN;AACF;;A+CnzJA;EACE,WAAA;A/CszJF;;A+ClzJA;EACE,0CAAA;A/CqzJF;A+CpzJE;EACE,sB1CrEQ;AL23JZ;;A+ClzJA;EACE,aAAA;EACA,mBAAA;EACA,mB1CsXO;AL+7IT;;A+ClzJA;EACE,eAAA;EACA,kBAAA;A/CqzJF;;A+ClzJA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,sB1ColDqC;ALiuGvC;;A+ClzJA;EACE,YAAA;EACA,kBAAA;A/CqzJF;A+CnzJE;EACE,kBAAA;A/CqzJJ;;A+CjzJA;EACE,gBAAA;A/CozJF;;AgD75JA;EAEE,6CAAA;EACA,uCAAA;EACA,sDAAA;EACA,sDAAA;EACA,wDAAA;EACA,qCAAA;EACA,uCAAA;EACA,yDAAA;EACA,8DAAA;EACA,wDAAA;EACA,2DAAA;EACA,0DAAA;EACA,2DAAA;EACA,gDAAA;EACA,wDAAA;EACA,mCAAA;EACA,6CAAA;EAGA,aAAA;EACA,sBAAA;E1C6BI,eAAA;E0CzBJ,gBAAA;EzCXE,kDAAA;APu6JJ;;AgDx5JA;EACE,qBAAA;EACA,sBAAA;AhD25JF;AgDz5JE;EAEE,oCAAA;EACA,0BAAA;AhD05JJ;;AgDj5JA;EACE,WAAA;EACA,yCAAA;EACA,mBAAA;AhDo5JF;AgDj5JE;EAEE,UAAA;EACA,+CAAA;EACA,qBAAA;EACA,uDAAA;AhDk5JJ;AgD/4JE;EACE,gDAAA;EACA,wDAAA;AhDi5JJ;;AgDz4JA;EACE,kBAAA;EACA,cAAA;EACA,kFAAA;EACA,kCAAA;EACA,qBAAA;EACA,0CAAA;EACA,mFAAA;AhD44JF;AgD14JE;EzCvDE,+BAAA;EACA,gCAAA;APo8JJ;AgD14JE;EzC7CE,mCAAA;EACA,kCAAA;AP07JJ;AgD14JE;EAEE,2CAAA;EACA,oBAAA;EACA,mDAAA;AhD24JJ;AgDv4JE;EACE,UAAA;EACA,yCAAA;EACA,iDAAA;EACA,uDAAA;AhDy4JJ;AgDr4JE;EACE,mBAAA;AhDu4JJ;AgDr4JI;EACE,yDAAA;EACA,oDAAA;AhDu4JN;;AgD13JI;EACE,mBAAA;AhD63JN;AgD13JQ;E1C1EF,8DAAA;EAAA,0BAAA;ANw8JN;AgDz3JQ;E1C/EF,4DAAA;EAAA,4BAAA;AN48JN;AgDx3JQ;EACE,aAAA;AhD03JV;AgDv3JQ;EACE,oDAAA;E1CzFJ,oBAAA;ANm9JN;AgDv3JU;E1C5FJ,0DAAA;EAAA,qDAAA;ANu9JN;;Ae/8JI;EiC8DA;IACE,mBAAA;EhDq5JJ;EgDl5JM;I1C1EF,8DAAA;IAAA,0BAAA;ENg+JJ;EgDj5JM;I1C/EF,4DAAA;IAAA,4BAAA;ENo+JJ;EgDh5JM;IACE,aAAA;EhDk5JR;EgD/4JM;IACE,oDAAA;I1CzFJ,oBAAA;EN2+JJ;EgD/4JQ;I1C5FJ,0DAAA;IAAA,qDAAA;EN++JJ;AACF;Aex+JI;EiC8DA;IACE,mBAAA;EhD66JJ;EgD16JM;I1C1EF,8DAAA;IAAA,0BAAA;ENw/JJ;EgDz6JM;I1C/EF,4DAAA;IAAA,4BAAA;EN4/JJ;EgDx6JM;IACE,aAAA;EhD06JR;EgDv6JM;IACE,oDAAA;I1CzFJ,oBAAA;ENmgKJ;EgDv6JQ;I1C5FJ,0DAAA;IAAA,qDAAA;ENugKJ;AACF;AehgKI;EiC8DA;IACE,mBAAA;EhDq8JJ;EgDl8JM;I1C1EF,8DAAA;IAAA,0BAAA;ENghKJ;EgDj8JM;I1C/EF,4DAAA;IAAA,4BAAA;ENohKJ;EgDh8JM;IACE,aAAA;EhDk8JR;EgD/7JM;IACE,oDAAA;I1CzFJ,oBAAA;EN2hKJ;EgD/7JQ;I1C5FJ,0DAAA;IAAA,qDAAA;EN+hKJ;AACF;AexhKI;EiC8DA;IACE,mBAAA;EhD69JJ;EgD19JM;I1C1EF,8DAAA;IAAA,0BAAA;ENwiKJ;EgDz9JM;I1C/EF,4DAAA;IAAA,4BAAA;EN4iKJ;EgDx9JM;IACE,aAAA;EhD09JR;EgDv9JM;IACE,oDAAA;I1CzFJ,oBAAA;ENmjKJ;EgDv9JQ;I1C5FJ,0DAAA;IAAA,qDAAA;ENujKJ;AACF;AehjKI;EiC8DA;IACE,mBAAA;EhDq/JJ;EgDl/JM;I1C1EF,8DAAA;IAAA,0BAAA;ENgkKJ;EgDj/JM;I1C/EF,4DAAA;IAAA,4BAAA;ENokKJ;EgDh/JM;IACE,aAAA;EhDk/JR;EgD/+JM;IACE,oDAAA;I1CzFJ,oBAAA;EN2kKJ;EgD/+JQ;I1C5FJ,0DAAA;IAAA,qDAAA;EN+kKJ;AACF;AgDp+JA;EzChJI,gBAAA;APunKJ;AgDp+JE;EACE,oDAAA;AhDs+JJ;AgDp+JI;EACE,sBAAA;AhDs+JN;;AgDz9JE;EC9KA,mFAAA;EACA,4BAAA;EACA,kCAAA;EACA,gGAAA;EACA,0CAAA;EACA,8FAAA;EACA,wGAAA;AjD2oKF;;AgDn+JE;EC9KA,qFAAA;EACA,4BAAA;EACA,kCAAA;EACA,kGAAA;EACA,0CAAA;EACA,gGAAA;EACA,0GAAA;AjDqpKF;;AgD7+JE;EC9KA,mFAAA;EACA,4BAAA;EACA,kCAAA;EACA,gGAAA;EACA,0CAAA;EACA,8FAAA;EACA,wGAAA;AjD+pKF;;AgDv/JE;EC9KA,kFAAA;EACA,4BAAA;EACA,kCAAA;EACA,+FAAA;EACA,0CAAA;EACA,6FAAA;EACA,uGAAA;AjDyqKF;;AgDjgKE;EC9KA,mFAAA;EACA,4BAAA;EACA,kCAAA;EACA,gGAAA;EACA,0CAAA;EACA,8FAAA;EACA,wGAAA;AjDmrKF;;AgD3gKE;EC9KA,gFAAA;EACA,4BAAA;EACA,kCAAA;EACA,6FAAA;EACA,0CAAA;EACA,2FAAA;EACA,qGAAA;AjD6rKF;;AgDrhKE;EC9KA,iFAAA;EACA,4BAAA;EACA,kCAAA;EACA,8FAAA;EACA,0CAAA;EACA,4FAAA;EACA,sGAAA;AjDusKF;;AgD/hKE;EC9KA,gFAAA;EACA,4BAAA;EACA,kCAAA;EACA,6FAAA;EACA,0CAAA;EACA,2FAAA;EACA,qGAAA;AjDitKF;;AkD3tKA;EAEE,6CAAA;EACA,4DAAA;EACA,4BAAA;EACA,mCAAA;EACA,oEAAA;EACA,gCAAA;EACA,sCAAA;EACA,wEAAA;EAGA,uBAAA;EACA,U7C+8D2B;E6C98D3B,W7C88D2B;E6C78D3B,sBAAA;EACA,iCAAA;EACA,yEAAA;EACA,SAAA;E3CJE,uBAAA;E2CMF,qCAAA;AlD2tKF;AkDxtKE;EACE,iCAAA;EACA,qBAAA;EACA,2CAAA;AlD0tKJ;AkDvtKE;EACE,UAAA;EACA,6CAAA;EACA,2CAAA;AlDytKJ;AkDttKE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,8CAAA;AlDutKJ;;AkDntKA;EACE,yCAAA;AlDstKF;;AmDvwKA;EAEE,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EhDyRI,+BALI;EgDlRR,mBAAA;EACA,kDAAA;EACA,iDAAA;EACA,6DAAA;EACA,mDAAA;EACA,6CAAA;EACA,oDAAA;EACA,yDAAA;EACA,oEAAA;EAGA,iCAAA;EACA,eAAA;EhD2QI,qCALI;EgDpQR,6BAAA;EACA,oBAAA;EACA,qCAAA;EACA,4BAAA;EACA,yEAAA;EACA,uCAAA;E5CRE,6CAAA;APgxKJ;AmDrwKE;EACE,UAAA;AnDuwKJ;AmDpwKE;EACE,aAAA;AnDswKJ;;AmDlwKA;EACE,wBAAA;EAEA,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AnDowKF;AmDlwKE;EACE,uCAAA;AnDowKJ;;AmDhwKA;EACE,aAAA;EACA,mBAAA;EACA,8DAAA;EACA,oCAAA;EACA,4CAAA;EACA,4BAAA;EACA,uFAAA;E5ChCE,4FAAA;EACA,6FAAA;APoyKJ;AmDlwKE;E7CRI,qDAAA;EAAA,uCAAA;AN8wKN;;AmDhwKA;EACE,mCAAA;EACA,qBAAA;AnDmwKF;;AoDj0KA;EAEE,wBAAA;EACA,wBAAA;EACA,yBAAA;EACA,0BAAA;EACA,mBAAA;EACA,kCAAA;EACA,6DAAA;EACA,iDAAA;EACA,sDAAA;EACA,gEAAA;EACA,8FAAA;EACA,kCAAA;EACA,kCAAA;EACA,qCAAA;EACA,wDAAA;EACA,wDAAA;EACA,kCAAA;EACA,8BAAA;EACA,uBAAA;EACA,wDAAA;EACA,wDAAA;EAGA,eAAA;EACA,MAAA;E9CoBI,OAAA;E8ClBJ,gCAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;ApD+zKF;;AoDxzKA;EACE,kBAAA;EACA,WAAA;EACA,+BAAA;EAEA,oBAAA;ApD0zKF;AoDvzKE;E7B5CI,mC6B6CF;EACA,8B/CmiDgC;ALsxHpC;AuBn2KM;E6BwCJ;I7BvCM,gBAAA;EvBs2KN;AACF;AoD5zKE;EACE,e/CiiDgC;AL6xHpC;AoD1zKE;EACE,sB/C8hDgC;AL8xHpC;;AoDxzKA;EACE,gDAAA;ApD2zKF;AoDzzKE;EACE,gBAAA;EACA,gBAAA;ApD2zKJ;AoDxzKE;EACE,gBAAA;ApD0zKJ;;AoDtzKA;EACE,aAAA;EACA,mBAAA;EACA,oDAAA;ApDyzKF;;AoDrzKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,6BAAA;EACA,oBAAA;EACA,qCAAA;EACA,4BAAA;EACA,yEAAA;E7CrFE,6CAAA;EKLE,uCARW;EwCsGf,UAAA;ApDszKF;;AoDlzKA;EAEE,2BAAA;EACA,0BAAA;EACA,2BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,mCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,wCD+G4D;ApDwzK9D;AqDp6KE;EAAS,UAAA;ArDu6KX;AqDt6KE;EAAS,oCD2GiF;ApD8zK5F;;AoDzzKA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;EACA,8FAAA;E7CtGE,4DAAA;EACA,6DAAA;APm6KJ;AoD3zKE;EACE,oGAAA;E9CnDE,yJAAA;ANi3KN;;AoDxzKA;EACE,gBAAA;EACA,+CAAA;ApD2zKF;;AoDtzKA;EACE,kBAAA;EAGA,cAAA;EACA,iCAAA;ApDuzKF;;AoDnzKA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,2EAAA;EACA,4CAAA;EACA,2FAAA;E7C1HE,gEAAA;EACA,+DAAA;APi7KJ;AoDlzKE;EACE,+CAAA;ApDozKJ;;Aeh6KI;EqCkHF;IACE,2BAAA;IACA,0DAAA;EpDkzKF;EoD9yKA;IACE,iCAAA;IACA,kBAAA;IACA,iBAAA;EpDgzKF;EoD7yKA;IACE,wBAAA;EpD+yKF;AACF;Ae/6KI;EqCoIF;;IAEE,wBAAA;EpD8yKF;AACF;Aer7KI;EqC2IF;IACE,yBAAA;EpD6yKF;AACF;AoDpyKI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;ApDsyKN;AoDpyKM;EACE,YAAA;EACA,SAAA;E7C1MJ,gBAAA;APi/KJ;AoDnyKM;;E7C9MF,gBAAA;APq/KJ;AoDlyKM;EACE,gBAAA;ApDoyKR;;Ae/7KI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpD0zKJ;EoDxzKI;IACE,YAAA;IACA,SAAA;I7C1MJ,gBAAA;EPqgLF;EoDvzKI;;I7C9MF,gBAAA;EPygLF;EoDtzKI;IACE,gBAAA;EpDwzKN;AACF;Aep9KI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpD80KJ;EoD50KI;IACE,YAAA;IACA,SAAA;I7C1MJ,gBAAA;EPyhLF;EoD30KI;;I7C9MF,gBAAA;EP6hLF;EoD10KI;IACE,gBAAA;EpD40KN;AACF;Aex+KI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpDk2KJ;EoDh2KI;IACE,YAAA;IACA,SAAA;I7C1MJ,gBAAA;EP6iLF;EoD/1KI;;I7C9MF,gBAAA;EPijLF;EoD91KI;IACE,gBAAA;EpDg2KN;AACF;Ae5/KI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpDs3KJ;EoDp3KI;IACE,YAAA;IACA,SAAA;I7C1MJ,gBAAA;EPikLF;EoDn3KI;;I7C9MF,gBAAA;EPqkLF;EoDl3KI;IACE,gBAAA;EpDo3KN;AACF;AehhLI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpD04KJ;EoDx4KI;IACE,YAAA;IACA,SAAA;I7C1MJ,gBAAA;EPqlLF;EoDv4KI;;I7C9MF,gBAAA;EPylLF;EoDt4KI;IACE,gBAAA;EpDw4KN;AACF;AsD/mLA;EAEE,0BAAA;EACA,8BAAA;EACA,+BAAA;EACA,gCAAA;EACA,sBAAA;EnDwRI,iCALI;EmDjRR,uCAAA;EACA,2CAAA;EACA,qDAAA;EACA,0BAAA;EACA,iCAAA;EACA,kCAAA;EAGA,kCAAA;EACA,cAAA;EACA,iCAAA;EClBA,uClDipB4B;EkD/oB5B,kBAAA;EACA,gBlD0pB4B;EkDzpB5B,gBlDiqB4B;EkDhqB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EpDgRI,uCALI;EmDhQR,qBAAA;EACA,UAAA;AtDunLF;AsDrnLE;EAAS,mCAAA;AtDwnLX;AsDtnLE;EACE,cAAA;EACA,qCAAA;EACA,uCAAA;AtDwnLJ;AsDtnLI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AtDwnLN;;AsDnnLA;EACE,kDAAA;AtDsnLF;AsDpnLE;EACE,SAAA;EACA,0FAAA;EACA,uCAAA;AtDsnLJ;;AsDlnLA,qBAAA;AACA;EACE,gDAAA;EACA,sCAAA;EACA,sCAAA;AtDqnLF;AsDnnLE;EACE,WAAA;EACA,qIAAA;EACA,yCAAA;AtDqnLJ;;AsDjnLA,mBAAA;AAEA;EACE,+CAAA;AtDmnLF;AsDjnLE;EACE,YAAA;EACA,0FAAA;EACA,0CAAA;AtDmnLJ;;AsD/mLA,qBAAA;AACA;EACE,iDAAA;EACA,sCAAA;EACA,sCAAA;AtDknLF;AsDhnLE;EACE,UAAA;EACA,qIAAA;EACA,wCAAA;AtDknLJ;;AsD9mLA,mBAAA;AAkBA;EACE,uCAAA;EACA,kEAAA;EACA,+BAAA;EACA,kBAAA;EACA,uCAAA;E/CjGE,+CAAA;APksLJ;;AwDrtLA;EAEE,0BAAA;EACA,8BAAA;ErD4RI,iCALI;EqDrRR,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,wDAAA;EACA,8FAAA;EACA,4DAAA;EACA,oCAAA;EACA,sCAAA;ErDmRI,oCALI;EqD5QR,mCAAA;EACA,gDAAA;EACA,kCAAA;EACA,kCAAA;EACA,+CAAA;EACA,+BAAA;EACA,kCAAA;EACA,2DAAA;EAGA,kCAAA;EACA,cAAA;EACA,uCAAA;EDzBA,uClDipB4B;EkD/oB5B,kBAAA;EACA,gBlD0pB4B;EkDzpB5B,gBlDiqB4B;EkDhqB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EpDgRI,uCALI;EqD1PR,qBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;EjDhBE,+CAAA;EKLE,yCARW;AZ8vLjB;AwD7tLE;EACE,cAAA;EACA,qCAAA;EACA,uCAAA;AxD+tLJ;AwD7tLI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AxD8tLN;;AwDxtLE;EACE,sFAAA;AxD2tLJ;AwDztLI;EAEE,0FAAA;AxD0tLN;AwDvtLI;EACE,SAAA;EACA,iDAAA;AxDytLN;AwDttLI;EACE,uCAAA;EACA,uCAAA;AxDwtLN;;AwDntLA,qBAAA;AAEE;EACE,oFAAA;EACA,sCAAA;EACA,sCAAA;AxDqtLJ;AwDntLI;EAEE,qIAAA;AxDotLN;AwDjtLI;EACE,OAAA;EACA,mDAAA;AxDmtLN;AwDhtLI;EACE,qCAAA;EACA,yCAAA;AxDktLN;;AwD7sLA,mBAAA;AAGE;EACE,mFAAA;AxD8sLJ;AwD5sLI;EAEE,0FAAA;AxD6sLN;AwD1sLI;EACE,MAAA;EACA,oDAAA;AxD4sLN;AwDzsLI;EACE,oCAAA;EACA,0CAAA;AxD2sLN;AwDtsLE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,qCAAA;EACA,wDAAA;EACA,WAAA;EACA,iFAAA;AxDwsLJ;;AwDpsLA,qBAAA;AAEE;EACE,qFAAA;EACA,sCAAA;EACA,sCAAA;AxDssLJ;AwDpsLI;EAEE,qIAAA;AxDqsLN;AwDlsLI;EACE,QAAA;EACA,kDAAA;AxDosLN;AwDjsLI;EACE,sCAAA;EACA,wCAAA;AxDmsLN;;AwD9rLA,mBAAA;AAkBA;EACE,gFAAA;EACA,gBAAA;ErD2GI,8CALI;EqDpGR,sCAAA;EACA,8CAAA;EACA,oFAAA;EjD5JE,8DAAA;EACA,+DAAA;AP60LJ;AwD/qLE;EACE,aAAA;AxDirLJ;;AwD7qLA;EACE,4EAAA;EACA,oCAAA;AxDgrLF;;AyDr2LA;EACE,kBAAA;AzDw2LF;;AyDr2LA;EACE,mBAAA;AzDw2LF;;AyDr2LA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AzDw2LF;A0D93LE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A1Dg4LJ;;AyDz2LA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;ElClBI,sCkCmBJ;AzD42LF;AuB33LM;EkCQN;IlCPQ,gBAAA;EvB83LN;AACF;;AyD92LA;;;EAGE,cAAA;AzDi3LF;;AyD92LA;;EAEE,2BAAA;AzDi3LF;;AyD92LA;;EAEE,4BAAA;AzDi3LF;;AyDx2LE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AzD22LJ;AyDx2LE;;;EAGE,UAAA;EACA,UAAA;AzD02LJ;AyDv2LE;;EAEE,UAAA;EACA,UAAA;ElC5DE,2BkC6DF;AzDy2LJ;AuBl6LM;EkCqDJ;;IlCpDM,gBAAA;EvBs6LN;AACF;;AyDt2LA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UpDsuDmC;EoDruDnC,UAAA;EACA,mEAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YpDiuDmC;EkBvzD/B,8BkCuFJ;AzDw2LF;AuB37LM;EkCkEN;;IlCjEQ,gBAAA;EvB+7LN;AACF;AyD32LE;;;EAEE,mEAAA;EACA,qBAAA;EACA,UAAA;EACA,YpDytDiC;ALqpIrC;;AyD32LA;EACE,OAAA;EACA,qFAAA;AzD82LF;;AyD52LA;EACE,QAAA;EACA,sFAAA;AzD+2LF;;AyD32LA;;EAEE,qBAAA;EACA,WpD0tDmC;EoDztDnC,YpDytDmC;EoDxtDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AzD82LF;;AyD32LA;;;;;;;GAAA;AAQA;EACE,0DAAA;AzD82LF;;AyD52LA;EACE,0DAAA;AzD+2LF;;AyDv2LA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBpDkqDmC;EoDjqDnC,mBAAA;EACA,gBpDgqDmC;EoD/pDnC,gBAAA;AzDy2LF;AyDv2LE;EACE,uBAAA;EACA,cAAA;EACA,WpD+pDiC;EoD9pDjC,WpD+pDiC;EoD9pDjC,UAAA;EACA,iBpD+pDiC;EoD9pDjC,gBpD8pDiC;EoD7pDjC,mBAAA;EACA,eAAA;EACA,+DAAA;EACA,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YpDspDiC;EkB/zD/B,6BkC0KF;AzDw2LJ;AuB9gMM;EkCqJJ;IlCpJM,gBAAA;EvBihMN;AACF;AyD12LE;EACE,UpDmpDiC;ALytIrC;;AyDn2LA;EACE,kBAAA;EACA,UAAA;EACA,epD6oDmC;EoD5oDnC,SAAA;EACA,oBpD0oDmC;EoDzoDnC,uBpDyoDmC;EoDxoDnC,mEAAA;EACA,kBAAA;AzDs2LF;;AyDj2LA;EACE,2CAAA;EACA,oDAAA;AzDo2LF;AyDn2LE;;EAEE,gCpD4oDiC;ALytIrC;AyDl2LE;EACE,yBpD1MQ;AL8iMZ;AyDj2LE;EACE,6BpD3LuB;AL8hM3B;;A2DhkMA;;EAEE,qBAAA;EACA,+BAAA;EACA,iCAAA;EACA,iDAAA;EAEA,kBAAA;EACA,+FAAA;A3DkkMF;;A2D9jMA;EACE;IAAK,0CAAA;E3DkkML;AACF;A2D/jMA;EAEE,yBAAA;EACA,0BAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,4CAAA;EAGA,0DAAA;EACA,+BAAA;A3D8jMF;;A2D3jMA;EAEE,yBAAA;EACA,0BAAA;EACA,iCAAA;A3D6jMF;;A2DpjMA;EACE;IACE,mBAAA;E3DujMF;E2DrjMA;IACE,UAAA;IACA,eAAA;E3DujMF;AACF;A2DnjMA;EAEE,yBAAA;EACA,0BAAA;EACA,sCAAA;EACA,oCAAA;EACA,0CAAA;EAGA,8BAAA;EACA,UAAA;A3DkjMF;;A2D/iMA;EACE,yBAAA;EACA,0BAAA;A3DkjMF;;A2D9iME;EACE;;IAEE,mCAAA;E3DijMJ;AACF;A4DjoMA;EAEE,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,+BAAA;EACA,+BAAA;EACA,4CAAA;EACA,sCAAA;EACA,qDAAA;EACA,iEAAA;EACA,oEAAA;EACA,sDAAA;EACA,sCAAA;A5DkoMF;;AerkMI;E6C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IhD9BA,2CARW;IWUX,2CqC8BA;E5DonMJ;AACF;AuB/oMM;EqCYJ;IrCXM,gBAAA;EvBkpMN;AACF;Ae5lMI;E6C5BE;IACE,MAAA;ItDMF,OAAA;IsDJE,iCAAA;ItDIF,uFAAA;IA4BA,4BAAA;EN6lMJ;E4DxnMI;IACE,MAAA;ItDFF,QAAA;IsDIE,iCAAA;ItDJF,sFAAA;IsDME,2BAAA;E5D0nMN;E4DvnMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E5DynMN;E4DtnMI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E5DwnMN;E4DrnMI;IAEE,0BAAA;E5DsnMN;E4DnnMI;IAGE,mBAAA;E5DmnMN;AACF;AehpMI;E6C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E5DknMN;E4DhnMM;IACE,aAAA;E5DknMR;E4D/mMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5DgnMR;AACF;;AeppMI;E6C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IhD9BA,2CARW;IWUX,2CqC8BA;E5DmsMJ;AACF;AuB9tMM;EqCYJ;IrCXM,gBAAA;EvBiuMN;AACF;Ae3qMI;E6C5BE;IACE,MAAA;ItDMF,OAAA;IsDJE,iCAAA;ItDIF,uFAAA;IA4BA,4BAAA;EN4qMJ;E4DvsMI;IACE,MAAA;ItDFF,QAAA;IsDIE,iCAAA;ItDJF,sFAAA;IsDME,2BAAA;E5DysMN;E4DtsMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E5DwsMN;E4DrsMI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E5DusMN;E4DpsMI;IAEE,0BAAA;E5DqsMN;E4DlsMI;IAGE,mBAAA;E5DksMN;AACF;Ae/tMI;E6C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E5DisMN;E4D/rMM;IACE,aAAA;E5DisMR;E4D9rMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5D+rMR;AACF;;AenuMI;E6C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IhD9BA,2CARW;IWUX,2CqC8BA;E5DkxMJ;AACF;AuB7yMM;EqCYJ;IrCXM,gBAAA;EvBgzMN;AACF;Ae1vMI;E6C5BE;IACE,MAAA;ItDMF,OAAA;IsDJE,iCAAA;ItDIF,uFAAA;IA4BA,4BAAA;EN2vMJ;E4DtxMI;IACE,MAAA;ItDFF,QAAA;IsDIE,iCAAA;ItDJF,sFAAA;IsDME,2BAAA;E5DwxMN;E4DrxMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E5DuxMN;E4DpxMI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E5DsxMN;E4DnxMI;IAEE,0BAAA;E5DoxMN;E4DjxMI;IAGE,mBAAA;E5DixMN;AACF;Ae9yMI;E6C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E5DgxMN;E4D9wMM;IACE,aAAA;E5DgxMR;E4D7wMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5D8wMR;AACF;;AelzMI;E6C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IhD9BA,2CARW;IWUX,2CqC8BA;E5Di2MJ;AACF;AuB53MM;EqCYJ;IrCXM,gBAAA;EvB+3MN;AACF;Aez0MI;E6C5BE;IACE,MAAA;ItDMF,OAAA;IsDJE,iCAAA;ItDIF,uFAAA;IA4BA,4BAAA;EN00MJ;E4Dr2MI;IACE,MAAA;ItDFF,QAAA;IsDIE,iCAAA;ItDJF,sFAAA;IsDME,2BAAA;E5Du2MN;E4Dp2MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E5Ds2MN;E4Dn2MI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E5Dq2MN;E4Dl2MI;IAEE,0BAAA;E5Dm2MN;E4Dh2MI;IAGE,mBAAA;E5Dg2MN;AACF;Ae73MI;E6C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E5D+1MN;E4D71MM;IACE,aAAA;E5D+1MR;E4D51MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5D61MR;AACF;;Aej4MI;E6C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IhD9BA,2CARW;IWUX,2CqC8BA;E5Dg7MJ;AACF;AuB38MM;EqCYJ;IrCXM,gBAAA;EvB88MN;AACF;Aex5MI;E6C5BE;IACE,MAAA;ItDMF,OAAA;IsDJE,iCAAA;ItDIF,uFAAA;IA4BA,4BAAA;ENy5MJ;E4Dp7MI;IACE,MAAA;ItDFF,QAAA;IsDIE,iCAAA;ItDJF,sFAAA;IsDME,2BAAA;E5Ds7MN;E4Dn7MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E5Dq7MN;E4Dl7MI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E5Do7MN;E4Dj7MI;IAEE,0BAAA;E5Dk7MN;E4D/6MI;IAGE,mBAAA;E5D+6MN;AACF;Ae58MI;E6C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E5D86MN;E4D56MM;IACE,aAAA;E5D86MR;E4D36MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5D46MR;AACF;;A4D5/ME;EAEI,eAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;EACA,yCAAA;EACA,4BAAA;EACA,UAAA;EhD9BA,2CARW;EWUX,2CqC8BA;A5D8/MN;AuBxhNM;EqCYJ;IrCXM,gBAAA;EvB2hNN;AACF;A4DjgNM;EACE,MAAA;EtDMF,OAAA;EsDJE,iCAAA;EtDIF,uFAAA;EA4BA,4BAAA;ANq+MN;A4DhgNM;EACE,MAAA;EtDFF,QAAA;EsDIE,iCAAA;EtDJF,sFAAA;EsDME,2BAAA;A5DkgNR;A4D//MM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,mCAAA;EACA,gBAAA;EACA,wFAAA;EACA,4BAAA;A5DigNR;A4D9/MM;EACE,QAAA;EACA,OAAA;EACA,mCAAA;EACA,gBAAA;EACA,qFAAA;EACA,2BAAA;A5DggNR;A4D7/MM;EAEE,0BAAA;A5D8/MR;A4D3/MM;EAGE,mBAAA;A5D2/MR;;A4Dh+MA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,ahDgtCkC;EgD/sClC,YAAA;EACA,aAAA;EACA,2DO+GsD;A5Dy+MxD;AqDrlNE;EAAS,UAAA;ArDwlNX;AqDvlNE;EAAS,YhDokDyB;ALshKpC;;A4D5+MA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sEAAA;A5D++MF;A4D7+ME;EACE,8FAAA;EACA,uDAAA;EtD3EE,yDAAA;EsD6EF,0DAAA;A5D++MJ;;A4D3+MA;EACE,gBAAA;EACA,mDAAA;A5D8+MF;;A4D3+MA;EACE,YAAA;EACA,sEAAA;EACA,gBAAA;A5D8+MF;;A6D9nNA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YxDi5CkC;ALgvKpC;A6D/nNE;EACE,qBAAA;EACA,WAAA;A7DioNJ;;A6D5nNA;EACE,iBAAA;A7D+nNF;;A6D5nNA;EACE,iBAAA;A7D+nNF;;A6D5nNA;EACE,iBAAA;A7D+nNF;;A6D1nNE;EACE,mDAAA;A7D6nNJ;;A6DznNA;EACE;IACE,YxDo3CgC;ELwwKlC;AACF;A6DznNA;EACE,qFAAA;EACA,oBAAA;EACA,8CAAA;A7D2nNF;;A6DxnNA;EACE;IACE,uBAAA;E7D2nNF;AACF;A8D5qNA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EvDcE,mBAAA;EgBHE,wBuCTJ;ECNA,W1DymDc;E0DxmDd,Y1DwmDc;E0DvmDd,iBAAA;A/DqrNF;AuBpqNM;EuCpBN;IvCqBQ,gBAAA;EvBuqNN;AACF;A+DxrNE;EACE,sBAAA;EACA,uBAAA;A/D0rNJ;;A8DtrNA;EACE,WAAA;EACA,YAAA;EvDME,mBAAA;APorNJ;;A8DtrNA;EACE,kBAAA;ExDqCI,QAAA;EwDnCJ,SAAA;EACA,cAAA;EACA,sBAAA;EvDHE,mBAAA;AP6rNJ;;A8DrrNE;EC1BA,a1D2mDc;E0D1mDd,c1D0mDc;E0DzmDd,iBAAA;A/DmtNF;A+DjtNE;EACE,aAAA;EACA,cAAA;A/DmtNJ;;A8D/rNE;EC1BA,a1D2mDc;E0D1mDd,c1D0mDc;E0DzmDd,eAAA;A/D6tNF;A+D3tNE;EACE,sBAAA;EACA,uBAAA;A/D6tNJ;;A8DzsNE;EC1BA,W1D2mDc;E0D1mDd,Y1D0mDc;E0DzmDd,iBAAA;A/DuuNF;A+DruNE;EACE,aAAA;EACA,cAAA;A/DuuNJ;;A8DntNE;EC1BA,W1D2mDc;E0D1mDd,Y1D0mDc;E0DzmDd,iBAAA;A/DivNF;A+D/uNE;EACE,sBAAA;EACA,uBAAA;A/DivNJ;;A8DxtNA;EACE,aAAA;A9D2tNF;A8DztNE;ExDoBI,qBAAA;ANwsNN;A8DztNI;ExDiBE,eAAA;AN2sNN;A8DttNI;ExDWE,qBAAA;AN8sNN;A8DztNI;ExDWE,mBAAA;ANitNN;A8D5tNI;ExDWE,qBAAA;ANotNN;A8D/tNI;ExDWE,qBAAA;ANutNN;;AgE9wNA;EAEE,6BAAA;EACA,6BAAA;EACA,yBAAA;EACA,4BAAA;EACA,mDAAA;EACA,mDAAA;EACA,kEAAA;EACA,qDAAA;EAGA,kEAAA;EACA,+DAAA;EACA,6EAAA;E1DyCI,uDAAA;EAAA,uDAAA;ECpCF,+CAAA;AP4wNJ;;AgExwNE;EACE,wCAAA;AhE2wNJ;;AgE5wNE;EACE,wCAAA;AhE+wNJ;;AgEhxNE;EACE,wCAAA;AhEmxNJ;;AgEpxNE;EACE,wCAAA;AhEuxNJ;;AgExxNE;EACE,wCAAA;AhE2xNJ;;AgE5xNE;EACE,qCAAA;AhE+xNJ;;AgEhyNE;EACE,wCAAA;AhEmyNJ;;AgEpyNE;EACE,wCAAA;AhEuyNJ;;AiE/zNA;EAEE,6BAAA;EACA,4BAAA;EACA,8BAAA;EACA,yCAAA;EACA,uCAAA;EACA,kDAAA;EACA,iFAAA;EAGA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;EACA,gEAAA;EACA,8BAAA;EACA,gCAAA;EACA,oCAAA;AjE+zNF;;AiE5zNA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,atC2Ca;A3BoxNf;;AiE5zNA;EACE,gBAAA;EACA,SAAA;EACA,atCqCa;A3B0xNf;;AkEh2NA;EAEE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,mCAAA;EACA,6DAAA;EACA,kDAAA;EACA,iFAAA;EACA,kEAAA;EACA,qEAAA;EACA,iEAAA;EACA,uCAAA;EACA,iCAAA;EACA,uCAAA;EACA,uCAAA;EACA,uCAAA;EACA,oCAAA;EACA,qEAAA;EACA,4DAAA;EACA,wEAAA;EACA,sEAAA;EACA,4EAAA;EACA,uCAAA;EACA,uCAAA;EACA,0DAAA;EACA,iGAAA;EACA,gCAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;EACA,gEAAA;EACA,gCAAA;EACA,uCAAA;AlEg2NF;AkE31NE;;;;;;;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AlEy2NJ;AkE31NE;;;;;;;EAEE,gFAAA;AlEk2NJ;AkE/1NE;;;;;;;EAEE,mFAAA;AlEs2NJ;AkEn2NE;EACE,gBAAA;EACA,MAAA;EACA,YAAA;AlEq2NJ;;AkEj2NA;EACE,wDAAA;EACA,SAAA;EACA,0EAAA;EACA,4CAAA;AlEo2NF;;AkE71NA;EACE,8CAAA;EACA,iDAAA;E5DpCI,kBAAA;EHwOA,kBALI;E+D5LR,oCAAA;EACA,qBAAA;EACA,mBAAA;AlEg2NF;AkE91NE;EAEE,0CAAA;AlE+1NJ;;AkEt1NA;EACE,aAAA;EACA,mBAAA;E5DxDI,eAAA;E4D0DJ,gBAAA;EACA,gBAAA;AlEy1NF;AkEv1NE;EACE,kFAAA;EACA,8BAAA;AlEy1NJ;AkEv1NI;EAEE,oCAAA;AlEw1NN;AkEr1NI;EACE,uCAAA;AlEu1NN;AkEn1NE;;EAEE,qCAAA;AlEq1NJ;AkEl1NE;EACE,kBAAA;AlEo1NJ;;AkE30NA;EACE,iDAAA;EACA,oDAAA;EACA,8BAAA;AlE80NF;AkE50NE;EACE,qCAAA;AlE80NJ;AkE50NI;EAEE,qCAAA;AlE60NN;;AkEx0NA;EACE,gFAAA;E/D8HI,kBALI;E+DvHR,sCAAA;EACA,8CAAA;EACA,SAAA;E3DlJE,sDAAA;AP89NJ;AkEz0NE;EACE,4CAAA;EACA,qBAAA;AlE20NJ;AkEx0NE;EACE,UAAA;AlE00NJ;AkEt0NE;EACE,eAAA;AlEw0NJ;;AkEp0NA;EACE,cAAA;EACA,iBAAA;EACA,mDAAA;EACA,4BAAA;EACA,kCAAA;EACA,0BAAA;AlEu0NF;AkEr0NE;EACE,yDAAA;AlEu0NJ;;AmEvgOA;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AnE0gOF;AmEzgOE;ECJA,W/D4wBgB;E+D3wBhB,Y/D2wBgB;E+D1wBhB,e/D0wBgB;ALswMlB;AmE3gOI;ECPF,W/DgxBgB;E+D/wBhB,Y/D+wBgB;E+D9wBhB,e/D8wBgB;ALuwMlB;AmE5gOI;ECXF,a/D+wBgB;E+D9wBhB,c/D8wBgB;E+D7wBhB,iB/D6wBgB;AL6wMlB;AmE7gOI;ECfF,c/D8wBgB;E+D7wBhB,e/D6wBgB;E+D5wBhB,kB/D4wBgB;ALmxMlB;AmE9gOI;ECnBF,e/D6wBgB;E+D5wBhB,gB/D4wBgB;E+D3wBhB,mB/D2wBgB;ALyxMlB;AmE9gOM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AnEkhO3B;AmEnhOM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AnEuhO3B;AmExhOM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AnE4hO3B;AmE7hOM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AnEiiO3B;AmEliOM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AnEsiO3B;AmEviOM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AnE2iO3B;AmE5iOM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AnEgjO3B;;AqE3kOA;EAEE,0BAAA;EACA,yBAAA;EACA,0BAAA;EACA,0BAAA;EACA,8CAAA;EACA,6BAAA;EACA,uCAAA;EACA,oDAAA;EACA,gCAAA;EACA,2CAAA;EACA,iCAAA;EACA,4CAAA;EACA,oCAAA;EACA,uCAAA;EACA,4CAAA;EACA,iCAAA;EACA,oCAAA;EACA,uCAAA;EACA,6CAAA;EACA,kCAAA;EACA,yEAAA;EACA,2CAAA;EACA,4CAAA;EACA,kDAAA;EACA,+EAAA;EAEA,gCAAA;EAEA,uCAAA;EACA,0CAAA;EACA,wCAAA;EACA,uDAAA;EACA,sCAAA;EACA,2CAAA;EACA,sDAAA;EACA,sCAAA;EACA,gDAAA;EACA,+EAAA;EACA,uCAAA;EACA,8DAAA;EACA,2DAAA;EACA,mEAAA;EACA,gEAAA;EACA,oEAAA;EACA,6DAAA;EACA,0DAAA;EACA,kEAAA;EACA,kCAAA;EACA,sCAAA;EACA,yCAAA;EACA,2DAAA;EACA,8CAAA;EACA,0CAAA;EACA,0CAAA;EACA,2EAAA;EACA,iFAAA;EACA,mEAAA;EAGA,kBAAA;EACA,aAAA;EAEA,kCAAA;EACA,sBAAA;EAEA,SAAA;EACA,+BAAA;EACA,kEAAA;EACA,+BAAA;EACA,iCAAA;E/DhBI,mFAAA;E+DkBJ,gBAAA;E9CzDI,yH8C0DJ;ArEukOF;AuB7nOM;E8CpBN;I9CqBQ,gBAAA;EvBgoON;AACF;AqE1kOE;E/DrBI,cAAA;ANkmON;AqE3kOI;EACE,iCAAA;ArE6kON;AqEzkOE;EACE,SAAA;E/D7BE,eAAA;ANymON;AqE1kOI;EACE,+BAAA;ArE4kON;AqExkOE;EACE,iCAAA;ArE0kOJ;AqEtkOI;EACE,0BAAA;ArEwkON;Ae1mOI;EsDqCM;IACE,iCAAA;ErEwkOV;EqEpkOQ;IACE,+BAAA;ErEskOV;AACF;AqEjlOI;EACE,0BAAA;ArEmlON;AernOI;EsDqCM;IACE,iCAAA;ErEmlOV;EqE/kOQ;IACE,+BAAA;ErEilOV;AACF;AqE5lOI;EACE,0BAAA;ArE8lON;AehoOI;EsDqCM;IACE,iCAAA;ErE8lOV;EqE1lOQ;IACE,+BAAA;ErE4lOV;EqEnlOI;I/D5DA,gDAAA;ENopOJ;EqEtlOM;IACE,6BAAA;ErEwlOR;EqErlOI;I/DlEA,iDAAA;EN0pOJ;EqEtlOM;IACE,2BAAA;ErEwlOR;EqEllOA;IAEI,eAAA;IACA,MAAA;IACA,SAAA;IACA,a1CjES;E3BspOb;EqEnlOI;I/DlFA,OAAA;ENwqOJ;EqEllOI;I/DtFA,QAAA;EN2qOJ;EqE/kOA;IAEI,gBAAA;IACA,MAAA;IACA,aAAA;ErEklOJ;AAlCF;AqE5iOE;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;ArEilOJ;AqE/kOI;E/D1GE,OAAA;AN4rON;AqEhlOM;EACE,6BAAA;ArEklOR;AqE9kOI;E/DjHE,QAAA;ANksON;AqE/kOM;EACE,2BAAA;ArEilOR;AehrOI;EsD5EJ;IAkLI,qBAAA;IACA,eAAA;IACA,MAAA;IACA,SAAA;IACA,aAAA;ErE8kOF;EqE5kOE;I/DjIE,OAAA;ENgtOJ;EqE7kOI;IACE,wCAAA;ErE+kON;EqE5kOI;I/DvIA,gDAAA;ENstOJ;EqE3kOE;I/D3IE,QAAA;ENytOJ;EqE5kOI;IACE,sCAAA;ErE8kON;EqE3kOI;I/DjJA,iDAAA;EN+tOJ;AACF;;AqExkOA;EACE,kBAAA;EACA,MAAA;E/D1JI,QAAA;E+D4JJ,+BAAA;EACA,wCAAA;EACA,+BAAA;EACA,uBAAA;EACA,SAAA;ArE2kOF;AqEzkOE;EACE,qBAAA;ArE2kOJ;AqExkOE;EACE,UAAA;ArE0kOJ;;AqEtkOA;EACE,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;EACA,uCAAA;ArEykOF;AqEvkOE;EACE,aAAA;ArEykOJ;;AqErkOA;EACE,0CAAA;EACA,gFAAA;EACA,kBAAA;EACA,wCAAA;E9CnOI,uC8CoOJ;ArEwkOF;AuBxyOM;E8C2NN;I9C1NQ,gBAAA;EvB2yON;AACF;AqE3kOE;EACE,aAAA;EACA,mBAAA;EACA,4CAAA;ArE6kOJ;;AqEzkOA;EACE,0CAAA;EACA,gFAAA;EACA,wCAAA;E9ChPI,uC8CiPJ;ArE4kOF;AuBzzOM;E8CyON;I9CxOQ,gBAAA;EvB4zON;AACF;;AqE9kOA;EACE,aAAA;EACA,2CAAA;EACA,yBAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;EACA,+CAAA;EACA,SAAA;ArEilOF;AejxOI;EsDwLJ;IAWI,aAAA;ErEklOF;AACF;AqEhlOE;EACE,cAAA;EACA,iDAAA;EACA,mDAAA;EACA,WAAA;EACA,sDAAA;EACA,4BAAA;EACA,2BAAA;EACA,yEAAA;E9C1QE,2B8C2QF;ArEklOJ;AuBz1OM;E8C8PJ;I9C7PM,gBAAA;EvB41ON;AACF;AqEjlOE;EACE,UAAA;ArEmlOJ;AqEhlOE;EACE,qDAAA;ArEklOJ;AqEjlOI;EACE,4DAAA;ArEmlON;AqE/kOE;EACE,2BAAA;ArEilOJ;AqEhlOI;EACE,0BAAA;ArEklON;;AqE3kOA;EAEE,0BAAA;EACA,0BAAA;EACA,2BAAA;ArE6kOF;Ae3zOI;EsD0OJ;IhBpTE,eAAA;IACA,MAAA;IACA,OAAA;IACA,mCgByT4B;IhBxT5B,YAAA;IACA,aAAA;IACA,wCgBsT8D;ErEmlO9D;EqDt4OA;IAAS,UAAA;ErDy4OT;EqDx4OA;IAAS,oCgBkTmF;ErEylO5F;AACF;;AsEt5OA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AtEy5OF;AsEv5OE;EACE,sFAAA;EACA,mDAAA;EACA,cAAA;EACA,gBAAA;EACA,yCAAA;EACA,yBAAA;E/CHE,sC+CIF;AtEy5OJ;AuBz5OM;E+CPJ;I/CQM,gBAAA;EvB45ON;AACF;AsE35OE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,oFAAA;EACA,wCAAA;EACA,qBAAA;EACA,mBAAA;EACA,0CAAA;EACA,0CAAA;E/DbA,wDAAA;EgBHE,mD+CkBF;AtE65OJ;AuB36OM;E+CGJ;I/CFM,gBAAA;EvB86ON;AACF;AsEh6OI;EACE,+CAAA;EACA,iDAAA;AtEk6ON;AsEh6OM;EACE,oDAAA;AtEk6OR;AsE95OI;EACE,iDAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AtEg6ON;AsE95OM;EACE,sDAAA;AtEg6OR;AsE75OM;EACE,iDAAA;AtE+5OR;AsE75OQ;EACE,sDAAA;AtE+5OV;AsE55OQ;EACE,8DAAA;AtE85OV;AsEz5OI;EACE;IACE,8CAAA;IACA,qBAAA;IACA,gDAAA;EtE25ON;EsEz5OM;IACE,mDAAA;EtE25OR;EsEx5OM;IACE,8DAAA;EtE05OR;AACF;AsEr5OE;EACE,2CAAA;EACA,0CAAA;EACA,gDAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;E/C5EE,mB+C6EF;AtEu5OJ;AuBh+OM;E+CiEJ;I/ChEM,gBAAA;EvBm+ON;AACF;AsE15OI;EhExCE,6DAAA;ANq8ON;AsEx5OE;EACE,gBAAA;AtE05OJ;AsEv5OE;EACE,kBAAA;E/CzFE,wC+C0FF;AtEy5OJ;AuB/+OM;E+CoFJ;I/CnFM,gBAAA;EvBk/ON;AACF;AsE55OI;EACE,kGAAA;EACA,gBAAA;E/C9FA,6B+C+FA;AtE85ON;AuBz/OM;E+CwFF;I/CvFI,gBAAA;EvB4/ON;AACF;AsEh6OI;EACE,aAAA;AtEk6ON;AsE/5OI;EACE,2CAAA;AtEi6ON;AsE/5OM;EACE,qDAAA;AtEi6OR;AsE95OM;EACE,yBAAA;AtEg6OR;AsE75OM;EACE,eAAA;AtE+5OR;AsE15OE;EACE,eAAA;AtE45OJ;AsE15OI;EACE,cAAA;EACA,cAAA;EACA,YAAA;EhEtFA,iBAAA;EgEwFA,WAAA;EACA,wDAAA;EACA,4BAAA;EACA,2BAAA;E/ClIA,2B+CmIA;AtE45ON;AuB3hPM;E+CsHF;I/CrHI,gBAAA;EvB8hPN;AACF;AsE75OE;EACE,UAAA;EACA,gBAAA;AtE+5OJ;AsE75OI;EhEpGE,+CAAA;ANogPN;AsE75OM;EhEvGA,yDAAA;ANugPN;AsEx5OI;;EACE,8DAAA;EACA,iEAAA;AtE25ON;;AepgPI;EwD/DJ;IAEI,aAAA;IACA,yCAAA;IACA,sCAAA;IACA,iDAAA;IACA,iBAAA;EvEskPF;EuEpkPE;IACE,aAAA;IACA,sCAAA;EvEskPJ;EuEnkPE;IACE,aAAA;EvEqkPJ;EuElkPE;IACE,cAAA;EvEokPJ;EuEjkPE;;;;;;;;;;;;;IAQE,oBAAA;IACA,UAAA;IACA,SAAA;IACA,kBAAA;IACA,UAAA;EvEwkPJ;EuErkPE;IACE,eAAA;IACA,SAAA;EvEukPJ;EuErkPI;IjEeA,0BAAA;ENyjPJ;EuEnkPE;IACE,uBAAA;EvEqkPJ;AACF;;AuE/jPE;EACE,gCAAA;AvEkkPJ;AuEhkPE;EACE,8BAAA;AvEkkPJ;;AuE9jPA;EACE,eAAA;EACA,aAAA;AvEikPF;AuE/jPE;EACE,gCAAA;AvEikPJ;AuE/jPE;EACE,8BAAA;AvEikPJ;AuExjPM;EjEvBA,0BAAA;ANklPN;AuEtjPI;EACE,uBAAA;AvEwjPN;;AuE5iPQ;EjEzCF,uDAAA;ANylPN;AuE7iPQ;EjE5CF,wDAAA;AN4lPN;;AevkPI;EwDoBI;IjEzCF,uDAAA;ENimPJ;EuErjPM;IjE5CF,wDAAA;ENomPJ;AACF;AehlPI;EwDoBI;IjEzCF,uDAAA;ENymPJ;EuE7jPM;IjE5CF,wDAAA;EN4mPJ;AACF;AexlPI;EwDoBI;IjEzCF,uDAAA;ENinPJ;EuErkPM;IjE5CF,wDAAA;ENonPJ;AACF;AehmPI;EwDoBI;IjEzCF,uDAAA;ENynPJ;EuE7kPM;IjE5CF,wDAAA;EN4nPJ;AACF;AexmPI;EwDoBI;IjEzCF,uDAAA;ENioPJ;EuErlPM;IjE5CF,wDAAA;ENooPJ;AACF;AwE5rPA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBnEuwD+B;EmEtwD/B,oBAAA;EACA,yCAAA;EACA,0IAAA;AxE8rPF;;AwE3rPA;EACE,gBAAA;EACA,MAAA;EACA,YAAA;AxE8rPF;;AwEvrPA;EACE,aAAA;EACA,mBAAA;ElE+BI,eAAA;EkE7BJ,gBAAA;EACA,gBAAA;AxE0rPF;AwExrPE;EACE,qBnEqvD4B;EmEpvD5B,oBnEovD4B;EmEnvD5B,6DAAA;AxE0rPJ;AwExrPI;EAEE,8DAAA;AxEyrPN;AwEtrPI;EACE,kEAAA;AxEwrPN;AwEprPE;;EAEE,+DAAA;AxEsrPJ;AwEnrPE;EACE,kBAAA;AxEqrPJ;;AwE7qPA;EACE,mBnEirCkC;EmEhrClC,sBnEgrCkC;EmE/qClC,6DAAA;AxEgrPF;AwE9qPE;EACE,+DAAA;AxEgrPJ;AwE9qPI;EAEE,+DAAA;AxE+qPN;;A0DjvPE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A1DovPJ;;AyEvvPE;EACE,2CAAA;EACA,mFAAA;AzE0vPJ;;AyE5vPE;EACE,yBAAA;EACA,qFAAA;AzE+vPJ;;AyEjwPE;EACE,yBAAA;EACA,mFAAA;AzEowPJ;;AyEtwPE;EACE,yBAAA;EACA,gFAAA;AzEywPJ;;AyE3wPE;EACE,wCAAA;EACA,mFAAA;AzE8wPJ;;AyEhxPE;EACE,yBAAA;EACA,kFAAA;AzEmxPJ;;AyErxPE;EACE,wCAAA;EACA,iFAAA;AzEwxPJ;;AyE1xPE;EACE,2CAAA;EACA,gFAAA;AzE6xPJ;;A0E/xPE;EACE,0EAAA;EACA,oGAAA;A1EkyPJ;A0E/xPM;EAGE,gEAAA;EACA,0FAAA;A1E+xPR;;A0ExyPE;EACE,4EAAA;EACA,sGAAA;A1E2yPJ;A0ExyPM;EAGE,iEAAA;EACA,2FAAA;A1EwyPR;;A0EjzPE;EACE,0EAAA;EACA,oGAAA;A1EozPJ;A0EjzPM;EAGE,gEAAA;EACA,0FAAA;A1EizPR;;A0E1zPE;EACE,uEAAA;EACA,iGAAA;A1E6zPJ;A0E1zPM;EAGE,gEAAA;EACA,0FAAA;A1E0zPR;;A0En0PE;EACE,0EAAA;EACA,oGAAA;A1Es0PJ;A0En0PM;EAGE,gEAAA;EACA,0FAAA;A1Em0PR;;A0E50PE;EACE,yEAAA;EACA,mGAAA;A1E+0PJ;A0E50PM;EAGE,iEAAA;EACA,2FAAA;A1E40PR;;A0Er1PE;EACE,wEAAA;EACA,kGAAA;A1Ew1PJ;A0Er1PM;EAGE,iEAAA;EACA,2FAAA;A1Eq1PR;;A0E91PE;EACE,uEAAA;EACA,iGAAA;A1Ei2PJ;A0E91PM;EAGE,iEAAA;EACA,2FAAA;A1E81PR;;A0Ev1PA;EACE,iFAAA;EACA,2GAAA;A1E01PF;A0Ev1PI;EAEE,oFAAA;EACA,8GAAA;A1Ew1PN;;A2El3PA;EACE,UAAA;EAEA,uJAAA;A3Eo3PF;;A4Ev3PA;EACE,oBAAA;EACA,avE8f4B;EuE7f5B,mBAAA;EACA,oFAAA;EACA,6BvE4f4B;EuE3f5B,2BAAA;A5E03PF;A4Ex3PE;EACE,cAAA;EACA,UvEwf0B;EuEvf1B,WvEuf0B;EuEtf1B,kBAAA;ErDIE,sCqDHF;A5E03PJ;AuBn3PM;EqDZJ;IrDaM,gBAAA;EvBs3PN;AACF;;A4Ex3PI;EACE,oEAAA;A5E23PN;;A6E94PA;EACE,kBAAA;EACA,WAAA;A7Ei5PF;A6E/4PE;EACE,cAAA;EACA,oCAAA;EACA,WAAA;A7Ei5PJ;A6E94PE;EACE,kBAAA;EACA,MAAA;EvEyCE,OAAA;EuEvCF,WAAA;EACA,YAAA;A7Eg5PJ;;A6E34PE;EACE,wBAAA;A7E84PJ;;A6E/4PE;EACE,uBAAA;A7Ek5PJ;;A6En5PE;EACE,0BAAA;A7Es5PJ;;A6Ev5PE;EACE,kCAAA;A7E05PJ;;A8E/6PA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,anD+Da;A3Bm3Pf;;A8E/6PA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,anDuDa;A3B23Pf;;A8E16PI;EACE,gBAAA;EACA,MAAA;EACA,azEwrC8B;ALqvNpC;;A8E16PI;EACE,gBAAA;EACA,SAAA;EACA,azEkrC8B;AL2vNpC;;Ae94PI;E+DxCA;IACE,gBAAA;IACA,MAAA;IACA,azEwrC8B;ELkwNlC;E8Ev7PE;IACE,gBAAA;IACA,SAAA;IACA,azEkrC8B;ELuwNlC;AACF;Ae35PI;E+DxCA;IACE,gBAAA;IACA,MAAA;IACA,azEwrC8B;EL8wNlC;E8En8PE;IACE,gBAAA;IACA,SAAA;IACA,azEkrC8B;ELmxNlC;AACF;Aev6PI;E+DxCA;IACE,gBAAA;IACA,MAAA;IACA,azEwrC8B;EL0xNlC;E8E/8PE;IACE,gBAAA;IACA,SAAA;IACA,azEkrC8B;EL+xNlC;AACF;Aen7PI;E+DxCA;IACE,gBAAA;IACA,MAAA;IACA,azEwrC8B;ELsyNlC;E8E39PE;IACE,gBAAA;IACA,SAAA;IACA,azEkrC8B;EL2yNlC;AACF;Ae/7PI;E+DxCA;IACE,gBAAA;IACA,MAAA;IACA,azEwrC8B;ELkzNlC;E8Ev+PE;IACE,gBAAA;IACA,SAAA;IACA,azEkrC8B;ELuzNlC;AACF;A+EzgQA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;A/E2gQF;;A+ExgQA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;A/E2gQF;;AgFnhQA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AjFohQF;AiFjhQE;;EACE,6BAAA;AjFohQJ;;AkFliQE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U7EifsC;E6EhftC,WAAA;AlFqiQJ;;AmF7iQA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;ApFijQF;;AqFvjQA;EACE,qBAAA;EACA,mBAAA;EACA,8BhF2vB4B;EgF1vB5B,eAAA;EACA,UAAA;EACA,8BAAA;EACA,ahFovB4B;ALs0O9B;;AsF5/PQ;EAUM,mCAAA;AtFs/Pd;;AsFhgQQ;EAUM,8BAAA;AtF0/Pd;;AsFpgQQ;EAUM,iCAAA;AtF8/Pd;;AsFxgQQ;EAUM,iCAAA;AtFkgQd;;AsF5gQQ;EAUM,sCAAA;AtFsgQd;;AsFhhQQ;EAUM,mCAAA;AtF0gQd;;AsFphQQ;EhFdF,sBAAA;ANsiQN;;AsFxhQQ;EhFdF,uBAAA;AN0iQN;;AsF5hQQ;EhFdF,sBAAA;AN8iQN;;AsFhiQQ;EAUM,8BAAA;AtF0hQd;;AsFpiQQ;EAUM,4BAAA;AtF8hQd;;AsFxiQQ;EAUM,2BAAA;AtFkiQd;;AsF5iQQ;EAUM,iCAAA;AtFsiQd;;AsFhjQQ;EAUM,2BAAA;AtF0iQd;;AsFpjQQ;EAUM,qBAAA;AtF8iQd;;AsFxjQQ;EAUM,wBAAA;AtFkjQd;;AsF5jQQ;EAUM,uBAAA;AtFsjQd;;AsFhkQQ;EAUM,wBAAA;AtF0jQd;;AsFpkQQ;EAUM,qBAAA;AtF8jQd;;AsFxkQQ;EAUM,yBAAA;AtFkkQd;;AsF5kQQ;EAUM,2BAAA;AtFskQd;;AsFhlQQ;EAUM,4BAAA;AtF0kQd;;AsFplQQ;EAUM,2BAAA;AtF8kQd;;AsFxlQQ;EAUM,2BAAA;AtFklQd;;AsF5lQQ;EAUM,6BAAA;AtFslQd;;AsFhmQQ;EAUM,8BAAA;AtF0lQd;;AsFpmQQ;EAUM,6BAAA;AtF8lQd;;AsFxmQQ;EAUM,2BAAA;AtFkmQd;;AsF5mQQ;EAUM,6BAAA;AtFsmQd;;AsFhnQQ;EAUM,8BAAA;AtF0mQd;;AsFpnQQ;EAUM,6BAAA;AtF8mQd;;AsFxnQQ;EAUM,0BAAA;AtFknQd;;AsF5nQQ;EAUM,gCAAA;AtFsnQd;;AsFhoQQ;EAUM,yBAAA;AtF0nQd;;AsFpoQQ;EAUM,wBAAA;AtF8nQd;;AsFxoQQ;EAUM,+BAAA;AtFkoQd;;AsF5oQQ;EAUM,yBAAA;AtFsoQd;;AsFhpQQ;EAUM,6BAAA;AtF0oQd;;AsFppQQ;EAUM,8BAAA;AtF8oQd;;AsFxpQQ;EAUM,wBAAA;AtFkpQd;;AsF5pQQ;EAUM,+BAAA;AtFspQd;;AsFhqQQ;EAUM,wBAAA;AtF0pQd;;AsFpqQQ;EAUM,yDAAA;AtF8pQd;;AsFxqQQ;EAUM,+DAAA;AtFkqQd;;AsF5qQQ;EAUM,wDAAA;AtFsqQd;;AsFhrQQ;EAUM,2BAAA;AtF0qQd;;AsF9rQQ;EACE,mFAAA;AtFisQV;;AsFlsQQ;EACE,qFAAA;AtFqsQV;;AsFtsQQ;EACE,mFAAA;AtFysQV;;AsF1sQQ;EACE,gFAAA;AtF6sQV;;AsF9sQQ;EACE,mFAAA;AtFitQV;;AsFltQQ;EACE,kFAAA;AtFqtQV;;AsFttQQ;EACE,iFAAA;AtFytQV;;AsF1tQQ;EACE,gFAAA;AtF6tQV;;AsFptQQ;EAUM,2BAAA;AtF8sQd;;AsFxtQQ;EAUM,6BAAA;AtFktQd;;AsF5tQQ;EAUM,6BAAA;AtFstQd;;AsFhuQQ;EAUM,0BAAA;AtF0tQd;;AsFpuQQ;EAUM,2BAAA;AtF8tQd;;AsFxuQQ;EAUM,iBAAA;AtFkuQd;;AsF5uQQ;EAUM,mBAAA;AtFsuQd;;AsFhvQQ;EAUM,oBAAA;AtF0uQd;;AsFpvQQ;EAUM,oBAAA;AtF8uQd;;AsFxvQQ;EAUM,sBAAA;AtFkvQd;;AsF5vQQ;EAUM,uBAAA;AtFsvQd;;AsFhwQQ;EAUM,kBAAA;AtF0vQd;;AsFpwQQ;EAUM,oBAAA;AtF8vQd;;AsFxwQQ;EAUM,qBAAA;AtFkwQd;;AsF5wQQ;EAUM,mBAAA;AtFswQd;;AsFhxQQ;EAUM,qBAAA;AtF0wQd;;AsFpxQQ;EAUM,sBAAA;AtF8wQd;;AsFxxQQ;EAUM,2CAAA;AtFkxQd;;AsF5xQQ;EAUM,sCAAA;AtFsxQd;;AsFhyQQ;EAUM,sCAAA;AtF0xQd;;AsFpyQQ;EAUM,0FAAA;AtF8xQd;;AsFxyQQ;EAUM,oBAAA;AtFkyQd;;AsF5yQQ;EAUM,8FAAA;AtFsyQd;;AsFhzQQ;EAUM,wBAAA;AtF0yQd;;AsFpzQQ;EhFdF,gGAAA;ANs0QN;;AsFxzQQ;EhFdF,0BAAA;AN00QN;;AsF5zQQ;EAUM,iGAAA;AtFszQd;;AsFh0QQ;EAUM,2BAAA;AtF0zQd;;AsFp0QQ;EhFdF,+FAAA;ANs1QN;;AsFx0QQ;EhFdF,yBAAA;AN01QN;;AsF50QQ;EAIQ,uBAAA;EAMF,gFAAA;AtFu0Qd;;AsFj1QQ;EAIQ,uBAAA;EAMF,kFAAA;AtF40Qd;;AsFt1QQ;EAIQ,uBAAA;EAMF,gFAAA;AtFi1Qd;;AsF31QQ;EAIQ,uBAAA;EAMF,6EAAA;AtFs1Qd;;AsFh2QQ;EAIQ,uBAAA;EAMF,gFAAA;AtF21Qd;;AsFr2QQ;EAIQ,uBAAA;EAMF,+EAAA;AtFg2Qd;;AsF12QQ;EAIQ,uBAAA;EAMF,8EAAA;AtFq2Qd;;AsF/2QQ;EAIQ,uBAAA;EAMF,6EAAA;AtF02Qd;;AsFp3QQ;EAIQ,uBAAA;EAMF,8EAAA;AtF+2Qd;;AsFz3QQ;EAUM,oCAAA;AtFm3Qd;;AsF73QQ;EAUM,oCAAA;AtFu3Qd;;AsFj4QQ;EAUM,oCAAA;AtF23Qd;;AsFr4QQ;EAUM,iCAAA;AtF+3Qd;;AsFz4QQ;EAUM,oCAAA;AtFm4Qd;;AsF74QQ;EAUM,oCAAA;AtFu4Qd;;AsFj5QQ;EAUM,oCAAA;AtF24Qd;;AsFr5QQ;EAUM,oCAAA;AtF+4Qd;;AsFz5QQ;EAUM,iCAAA;AtFm5Qd;;AsF75QQ;EhFdF,sCAAA;AN+6QN;;AsFj6QQ;EhFdF,sCAAA;ANm7QN;;AsFr6QQ;EhFdF,sCAAA;ANu7QN;;AsFz6QQ;EhFdF,mCAAA;AN27QN;;AsF76QQ;EhFdF,sCAAA;AN+7QN;;AsFj7QQ;EhFdF,sCAAA;ANm8QN;;AsFr7QQ;EhFdF,sCAAA;ANu8QN;;AsFz7QQ;EhFdF,sCAAA;AN28QN;;AsF77QQ;EhFdF,mCAAA;AN+8QN;;AsFj8QQ;EAUM,uCAAA;AtF27Qd;;AsFr8QQ;EAUM,uCAAA;AtF+7Qd;;AsFz8QQ;EAUM,uCAAA;AtFm8Qd;;AsF78QQ;EAUM,oCAAA;AtFu8Qd;;AsFj9QQ;EAUM,uCAAA;AtF28Qd;;AsFr9QQ;EAUM,uCAAA;AtF+8Qd;;AsFz9QQ;EAUM,uCAAA;AtFm9Qd;;AsF79QQ;EAUM,uCAAA;AtFu9Qd;;AsFj+QQ;EAUM,oCAAA;AtF29Qd;;AsFr+QQ;EhFdF,qCAAA;ANu/QN;;AsFz+QQ;EhFdF,qCAAA;AN2/QN;;AsF7+QQ;EhFdF,qCAAA;AN+/QN;;AsFj/QQ;EhFdF,kCAAA;ANmgRN;;AsFr/QQ;EhFdF,qCAAA;ANugRN;;AsFz/QQ;EhFdF,qCAAA;AN2gRN;;AsF7/QQ;EhFdF,qCAAA;AN+gRN;;AsFjgRQ;EhFdF,qCAAA;ANmhRN;;AsFrgRQ;EhFdF,kCAAA;ANuhRN;;AsFzgRQ;EAUM,4BAAA;AtFmgRd;;AsF7gRQ;EAUM,4BAAA;AtFugRd;;AsFjhRQ;EAUM,4BAAA;AtF2gRd;;AsFrhRQ;EAUM,4BAAA;AtF+gRd;;AsFzhRQ;EAUM,4BAAA;AtFmhRd;;AsF7hRQ;EAUM,gCAAA;AtFuhRd;;AsFjiRQ;EAUM,gCAAA;AtF2hRd;;AsFriRQ;EAUM,gCAAA;AtF+hRd;;AsFziRQ;EAUM,gCAAA;AtFmiRd;;AsF7iRQ;EAUM,gCAAA;AtFuiRd;;AsFjjRQ;EhFdF,kCAAA;ANmkRN;;AsFrjRQ;EhFdF,kCAAA;ANukRN;;AsFzjRQ;EhFdF,kCAAA;AN2kRN;;AsF7jRQ;EhFdF,kCAAA;AN+kRN;;AsFjkRQ;EhFdF,kCAAA;ANmlRN;;AsFrkRQ;EAUM,mCAAA;AtF+jRd;;AsFzkRQ;EAUM,mCAAA;AtFmkRd;;AsF7kRQ;EAUM,mCAAA;AtFukRd;;AsFjlRQ;EAUM,mCAAA;AtF2kRd;;AsFrlRQ;EAUM,mCAAA;AtF+kRd;;AsFzlRQ;EhFdF,iCAAA;AN2mRN;;AsF7lRQ;EhFdF,iCAAA;AN+mRN;;AsFjmRQ;EhFdF,iCAAA;ANmnRN;;AsFrmRQ;EhFdF,iCAAA;ANunRN;;AsFzmRQ;EhFdF,iCAAA;AN2nRN;;AsFvnRQ;EACE,yBAAA;AtF0nRV;;AsF3nRQ;EACE,0BAAA;AtF8nRV;;AsF/nRQ;EACE,yBAAA;AtFkoRV;;AsFnoRQ;EACE,0BAAA;AtFsoRV;;AsFvoRQ;EACE,uBAAA;AtF0oRV;;AsFjoRQ;EAUM,qBAAA;AtF2nRd;;AsFroRQ;EAUM,qBAAA;AtF+nRd;;AsFzoRQ;EAUM,qBAAA;AtFmoRd;;AsF7oRQ;EAUM,sBAAA;AtFuoRd;;AsFjpRQ;EAUM,sBAAA;AtF2oRd;;AsFrpRQ;EAUM,0BAAA;AtF+oRd;;AsFzpRQ;EAUM,uBAAA;AtFmpRd;;AsF7pRQ;EAUM,2BAAA;AtFupRd;;AsFjqRQ;EAUM,sBAAA;AtF2pRd;;AsFrqRQ;EAUM,sBAAA;AtF+pRd;;AsFzqRQ;EAUM,sBAAA;AtFmqRd;;AsF7qRQ;EAUM,uBAAA;AtFuqRd;;AsFjrRQ;EAUM,uBAAA;AtF2qRd;;AsFrrRQ;EAUM,2BAAA;AtF+qRd;;AsFzrRQ;EAUM,wBAAA;AtFmrRd;;AsF7rRQ;EAUM,4BAAA;AtFurRd;;AsFjsRQ;EAUM,yBAAA;AtF2rRd;;AsFrsRQ;EAUM,8BAAA;AtF+rRd;;AsFzsRQ;EAUM,iCAAA;AtFmsRd;;AsF7sRQ;EAUM,sCAAA;AtFusRd;;AsFjtRQ;EAUM,yCAAA;AtF2sRd;;AsFrtRQ;EAUM,uBAAA;AtF+sRd;;AsFztRQ;EAUM,uBAAA;AtFmtRd;;AsF7tRQ;EAUM,yBAAA;AtFutRd;;AsFjuRQ;EAUM,yBAAA;AtF2tRd;;AsFruRQ;EAUM,0BAAA;AtF+tRd;;AsFzuRQ;EAUM,4BAAA;AtFmuRd;;AsF7uRQ;EAUM,kCAAA;AtFuuRd;;AsFjvRQ;EAUM,sCAAA;AtF2uRd;;AsFrvRQ;EAUM,oCAAA;AtF+uRd;;AsFzvRQ;EAUM,kCAAA;AtFmvRd;;AsF7vRQ;EAUM,yCAAA;AtFuvRd;;AsFjwRQ;EAUM,wCAAA;AtF2vRd;;AsFrwRQ;EAUM,wCAAA;AtF+vRd;;AsFzwRQ;EAUM,kCAAA;AtFmwRd;;AsF7wRQ;EAUM,gCAAA;AtFuwRd;;AsFjxRQ;EAUM,8BAAA;AtF2wRd;;AsFrxRQ;EAUM,gCAAA;AtF+wRd;;AsFzxRQ;EAUM,+BAAA;AtFmxRd;;AsF7xRQ;EAUM,oCAAA;AtFuxRd;;AsFjyRQ;EAUM,kCAAA;AtF2xRd;;AsFryRQ;EAUM,gCAAA;AtF+xRd;;AsFzyRQ;EAUM,uCAAA;AtFmyRd;;AsF7yRQ;EAUM,sCAAA;AtFuyRd;;AsFjzRQ;EAUM,iCAAA;AtF2yRd;;AsFrzRQ;EAUM,2BAAA;AtF+yRd;;AsFzzRQ;EAUM,iCAAA;AtFmzRd;;AsF7zRQ;EAUM,+BAAA;AtFuzRd;;AsFj0RQ;EAUM,6BAAA;AtF2zRd;;AsFr0RQ;EAUM,+BAAA;AtF+zRd;;AsFz0RQ;EAUM,8BAAA;AtFm0Rd;;AsF70RQ;EAUM,oBAAA;AtFu0Rd;;AsFj1RQ;EAUM,mBAAA;AtF20Rd;;AsFr1RQ;EAUM,mBAAA;AtF+0Rd;;AsFz1RQ;EAUM,mBAAA;AtFm1Rd;;AsF71RQ;EAUM,mBAAA;AtFu1Rd;;AsFj2RQ;EAUM,mBAAA;AtF21Rd;;AsFr2RQ;EAUM,mBAAA;AtF+1Rd;;AsFz2RQ;EAUM,mBAAA;AtFm2Rd;;AsF72RQ;EAUM,oBAAA;AtFu2Rd;;AsFj3RQ;EAUM,0BAAA;AtF22Rd;;AsFr3RQ;EAUM,yBAAA;AtF+2Rd;;AsFz3RQ;EAUM,uBAAA;AtFm3Rd;;AsF73RQ;EAUM,yBAAA;AtFu3Rd;;AsFj4RQ;EAUM,uBAAA;AtF23Rd;;AsFr4RQ;EAUM,uBAAA;AtF+3Rd;;AsFz4RQ;EAUM,0BAAA;EAAA,yBAAA;AtFo4Rd;;AsF94RQ;EAUM,gCAAA;EAAA,+BAAA;AtFy4Rd;;AsFn5RQ;EAUM,+BAAA;EAAA,8BAAA;AtF84Rd;;AsFx5RQ;EAUM,6BAAA;EAAA,4BAAA;AtFm5Rd;;AsF75RQ;EAUM,+BAAA;EAAA,8BAAA;AtFw5Rd;;AsFl6RQ;EAUM,6BAAA;EAAA,4BAAA;AtF65Rd;;AsFv6RQ;EAUM,6BAAA;EAAA,4BAAA;AtFk6Rd;;AsF56RQ;EAUM,wBAAA;EAAA,2BAAA;AtFu6Rd;;AsFj7RQ;EAUM,8BAAA;EAAA,iCAAA;AtF46Rd;;AsFt7RQ;EAUM,6BAAA;EAAA,gCAAA;AtFi7Rd;;AsF37RQ;EAUM,2BAAA;EAAA,8BAAA;AtFs7Rd;;AsFh8RQ;EAUM,6BAAA;EAAA,gCAAA;AtF27Rd;;AsFr8RQ;EAUM,2BAAA;EAAA,8BAAA;AtFg8Rd;;AsF18RQ;EAUM,2BAAA;EAAA,8BAAA;AtFq8Rd;;AsF/8RQ;EAUM,wBAAA;AtFy8Rd;;AsFn9RQ;EAUM,8BAAA;AtF68Rd;;AsFv9RQ;EAUM,6BAAA;AtFi9Rd;;AsF39RQ;EAUM,2BAAA;AtFq9Rd;;AsF/9RQ;EAUM,6BAAA;AtFy9Rd;;AsFn+RQ;EAUM,2BAAA;AtF69Rd;;AsFv+RQ;EAUM,2BAAA;AtFi+Rd;;AsF3+RQ;EhFdF,0BAAA;AN6/RN;;AsF/+RQ;EhFdF,gCAAA;ANigSN;;AsFn/RQ;EhFdF,+BAAA;ANqgSN;;AsFv/RQ;EhFdF,6BAAA;ANygSN;;AsF3/RQ;EhFdF,+BAAA;AN6gSN;;AsF//RQ;EhFdF,6BAAA;ANihSN;;AsFngSQ;EhFdF,6BAAA;ANqhSN;;AsFvgSQ;EAUM,2BAAA;AtFigSd;;AsF3gSQ;EAUM,iCAAA;AtFqgSd;;AsF/gSQ;EAUM,gCAAA;AtFygSd;;AsFnhSQ;EAUM,8BAAA;AtF6gSd;;AsFvhSQ;EAUM,gCAAA;AtFihSd;;AsF3hSQ;EAUM,8BAAA;AtFqhSd;;AsF/hSQ;EAUM,8BAAA;AtFyhSd;;AsFniSQ;EhFdF,yBAAA;ANqjSN;;AsFviSQ;EhFdF,+BAAA;ANyjSN;;AsF3iSQ;EhFdF,8BAAA;AN6jSN;;AsF/iSQ;EhFdF,4BAAA;ANikSN;;AsFnjSQ;EhFdF,8BAAA;ANqkSN;;AsFvjSQ;EhFdF,4BAAA;ANykSN;;AsF3jSQ;EhFdF,4BAAA;AN6kSN;;AsF/jSQ;EAUM,qBAAA;AtFyjSd;;AsFnkSQ;EAUM,2BAAA;AtF6jSd;;AsFvkSQ;EAUM,0BAAA;AtFikSd;;AsF3kSQ;EAUM,wBAAA;AtFqkSd;;AsF/kSQ;EAUM,0BAAA;AtFykSd;;AsFnlSQ;EAUM,wBAAA;AtF6kSd;;AsFvlSQ;EAUM,2BAAA;EAAA,0BAAA;AtFklSd;;AsF5lSQ;EAUM,iCAAA;EAAA,gCAAA;AtFulSd;;AsFjmSQ;EAUM,gCAAA;EAAA,+BAAA;AtF4lSd;;AsFtmSQ;EAUM,8BAAA;EAAA,6BAAA;AtFimSd;;AsF3mSQ;EAUM,gCAAA;EAAA,+BAAA;AtFsmSd;;AsFhnSQ;EAUM,8BAAA;EAAA,6BAAA;AtF2mSd;;AsFrnSQ;EAUM,yBAAA;EAAA,4BAAA;AtFgnSd;;AsF1nSQ;EAUM,+BAAA;EAAA,kCAAA;AtFqnSd;;AsF/nSQ;EAUM,8BAAA;EAAA,iCAAA;AtF0nSd;;AsFpoSQ;EAUM,4BAAA;EAAA,+BAAA;AtF+nSd;;AsFzoSQ;EAUM,8BAAA;EAAA,iCAAA;AtFooSd;;AsF9oSQ;EAUM,4BAAA;EAAA,+BAAA;AtFyoSd;;AsFnpSQ;EAUM,yBAAA;AtF6oSd;;AsFvpSQ;EAUM,+BAAA;AtFipSd;;AsF3pSQ;EAUM,8BAAA;AtFqpSd;;AsF/pSQ;EAUM,4BAAA;AtFypSd;;AsFnqSQ;EAUM,8BAAA;AtF6pSd;;AsFvqSQ;EAUM,4BAAA;AtFiqSd;;AsF3qSQ;EhFdF,2BAAA;AN6rSN;;AsF/qSQ;EhFdF,iCAAA;ANisSN;;AsFnrSQ;EhFdF,gCAAA;ANqsSN;;AsFvrSQ;EhFdF,8BAAA;ANysSN;;AsF3rSQ;EhFdF,gCAAA;AN6sSN;;AsF/rSQ;EhFdF,8BAAA;ANitSN;;AsFnsSQ;EAUM,4BAAA;AtF6rSd;;AsFvsSQ;EAUM,kCAAA;AtFisSd;;AsF3sSQ;EAUM,iCAAA;AtFqsSd;;AsF/sSQ;EAUM,+BAAA;AtFysSd;;AsFntSQ;EAUM,iCAAA;AtF6sSd;;AsFvtSQ;EAUM,+BAAA;AtFitSd;;AsF3tSQ;EhFdF,0BAAA;AN6uSN;;AsF/tSQ;EhFdF,gCAAA;ANivSN;;AsFnuSQ;EhFdF,+BAAA;ANqvSN;;AsFvuSQ;EhFdF,6BAAA;ANyvSN;;AsF3uSQ;EhFdF,+BAAA;AN6vSN;;AsF/uSQ;EhFdF,6BAAA;ANiwSN;;AsFnvSQ;EAUM,iBAAA;AtF6uSd;;AsFvvSQ;EAUM,uBAAA;AtFivSd;;AsF3vSQ;EAUM,sBAAA;AtFqvSd;;AsF/vSQ;EAUM,oBAAA;AtFyvSd;;AsFnwSQ;EAUM,sBAAA;AtF6vSd;;AsFvwSQ;EAUM,oBAAA;AtFiwSd;;AsF3wSQ;EAUM,qBAAA;AtFqwSd;;AsF/wSQ;EAUM,2BAAA;AtFywSd;;AsFnxSQ;EAUM,0BAAA;AtF6wSd;;AsFvxSQ;EAUM,wBAAA;AtFixSd;;AsF3xSQ;EAUM,0BAAA;AtFqxSd;;AsF/xSQ;EAUM,wBAAA;AtFyxSd;;AsFnySQ;EAUM,wBAAA;AtF6xSd;;AsFvySQ;EAUM,8BAAA;AtFiySd;;AsF3ySQ;EAUM,6BAAA;AtFqySd;;AsF/ySQ;EAUM,2BAAA;AtFyySd;;AsFnzSQ;EAUM,6BAAA;AtF6ySd;;AsFvzSQ;EAUM,2BAAA;AtFizSd;;AsF3zSQ;EAUM,iDAAA;AtFqzSd;;AsF/zSQ;EAUM,4CAAA;AtFyzSd;;AsFn0SQ;EAUM,4CAAA;AtF6zSd;;AsFv0SQ;EAUM,0CAAA;AtFi0Sd;;AsF30SQ;EAUM,4CAAA;AtFq0Sd;;AsF/0SQ;EAUM,6BAAA;AtFy0Sd;;AsFn1SQ;EAUM,0BAAA;AtF60Sd;;AsFv1SQ;EAUM,6BAAA;AtFi1Sd;;AsF31SQ;EAUM,6BAAA;AtFq1Sd;;AsF/1SQ;EAUM,+BAAA;AtFy1Sd;;AsFn2SQ;EAUM,2BAAA;AtF61Sd;;AsFv2SQ;EAUM,2BAAA;AtFi2Sd;;AsF32SQ;EAUM,2BAAA;AtFq2Sd;;AsF/2SQ;EAUM,2BAAA;AtFy2Sd;;AsFn3SQ;EAUM,2BAAA;AtF62Sd;;AsFv3SQ;EAUM,8BAAA;AtFi3Sd;;AsF33SQ;EAUM,yBAAA;AtFq3Sd;;AsF/3SQ;EAUM,4BAAA;AtFy3Sd;;AsFn4SQ;EAUM,2BAAA;AtF63Sd;;AsFv4SQ;EAUM,yBAAA;AtFi4Sd;;AsF34SQ;EhFdF,2BAAA;AN65SN;;AsF/4SQ;EhFdF,4BAAA;ANi6SN;;AsFn5SQ;EhFdF,6BAAA;ANq6SN;;AsFv5SQ;EAUM,gCAAA;AtFi5Sd;;AsF35SQ;EAUM,qCAAA;AtFq5Sd;;AsF/5SQ;EAUM,wCAAA;AtFy5Sd;;AsFn6SQ;EAUM,oCAAA;AtF65Sd;;AsFv6SQ;EAUM,oCAAA;AtFi6Sd;;AsF36SQ;EAUM,qCAAA;AtFq6Sd;;AsF/6SQ;EAUM,8BAAA;AtFy6Sd;;AsFn7SQ;EAUM,8BAAA;AtF66Sd;;AsFr8SQ,qBAAA;AAcA;EAUM,gCAAA;EAAA,iCAAA;AtFm7Sd;;AsF/5SQ,mBAAA;AA9BA;EAIQ,qBAAA;EAMF,uEAAA;AtFy7Sd;;AsFn8SQ;EAIQ,qBAAA;EAMF,yEAAA;AtF87Sd;;AsFx8SQ;EAIQ,qBAAA;EAMF,uEAAA;AtFm8Sd;;AsF78SQ;EAIQ,qBAAA;EAMF,oEAAA;AtFw8Sd;;AsFl9SQ;EAIQ,qBAAA;EAMF,uEAAA;AtF68Sd;;AsFv9SQ;EAIQ,qBAAA;EAMF,sEAAA;AtFk9Sd;;AsF59SQ;EAIQ,qBAAA;EAMF,qEAAA;AtFu9Sd;;AsFj+SQ;EAIQ,qBAAA;EAMF,oEAAA;AtF49Sd;;AsFt+SQ;EAIQ,qBAAA;EAMF,qEAAA;AtFi+Sd;;AsF3+SQ;EAIQ,qBAAA;EAMF,qEAAA;AtFs+Sd;;AsFh/SQ;EAIQ,qBAAA;EAMF,0EAAA;AtF2+Sd;;AsFr/SQ;EAIQ,qBAAA;EAMF,4CAAA;AtFg/Sd;;AsF1/SQ;EAIQ,qBAAA;EAMF,qCAAA;AtFq/Sd;;AsF//SQ;EAIQ,qBAAA;EAMF,0CAAA;AtF0/Sd;;AsFpgTQ;EAIQ,qBAAA;EAMF,4CAAA;AtF+/Sd;;AsFzgTQ;EAIQ,qBAAA;EAMF,2CAAA;AtFogTd;;AsF9gTQ;EAIQ,qBAAA;EAMF,2CAAA;AtFygTd;;AsFnhTQ;EAIQ,qBAAA;EAMF,yBAAA;AtF8gTd;;AsFxhTQ;EAIQ,qBAAA;EAMF,kDAAA;AtFmhTd;;AsF7hTQ;EAIQ,qBAAA;EAMF,oDAAA;AtFwhTd;;AsFliTQ;EAIQ,qBAAA;EAMF,6CAAA;AtF6hTd;;AsFviTQ;EAIQ,qBAAA;EAMF,0CAAA;AtFkiTd;;AsF5iTQ;EAIQ,qBAAA;EAMF,4CAAA;AtFuiTd;;AsFjjTQ;EAIQ,qBAAA;EAMF,qCAAA;AtF4iTd;;AsFhkTQ;EACE,wBAAA;AtFmkTV;;AsFpkTQ;EACE,uBAAA;AtFukTV;;AsFxkTQ;EACE,wBAAA;AtF2kTV;;AsF5kTQ;EACE,qBAAA;AtF+kTV;;AsFhlTQ;EACE,uBAAA;AtFmlTV;;AsF/kTU;EACE,uBAAA;AtFklTZ;;AsFxlTQ;EACE,wBAAA;AtF2lTV;;AsFvlTU;EACE,wBAAA;AtF0lTZ;;AsFhmTQ;EACE,uBAAA;AtFmmTV;;AsF/lTU;EACE,uBAAA;AtFkmTZ;;AsFxmTQ;EACE,wBAAA;AtF2mTV;;AsFvmTU;EACE,wBAAA;AtF0mTZ;;AsFhnTQ;EACE,qBAAA;AtFmnTV;;AsF/mTU;EACE,qBAAA;AtFknTZ;;AsF9mTQ;EAUM,yCAAA;AtFwmTd;;AsFlmTU;EAOI,yCAAA;AtF+lTd;;AsFtnTQ;EAUM,wCAAA;AtFgnTd;;AsF1mTU;EAOI,wCAAA;AtFumTd;;AsF9nTQ;EAUM,yCAAA;AtFwnTd;;AsFlnTU;EAOI,yCAAA;AtF+mTd;;AsFtoTQ;EAIQ,+BAAA;EAMF,iGAAA;AtFioTd;;AsF3oTQ;EAIQ,+BAAA;EAMF,mGAAA;AtFsoTd;;AsFhpTQ;EAIQ,+BAAA;EAMF,iGAAA;AtF2oTd;;AsFrpTQ;EAIQ,+BAAA;EAMF,8FAAA;AtFgpTd;;AsF1pTQ;EAIQ,+BAAA;EAMF,iGAAA;AtFqpTd;;AsF/pTQ;EAIQ,+BAAA;EAMF,gGAAA;AtF0pTd;;AsFpqTQ;EAIQ,+BAAA;EAMF,+FAAA;AtF+pTd;;AsFzqTQ;EAIQ,+BAAA;EAMF,8FAAA;AtFoqTd;;AsF9qTQ;EAIQ,+BAAA;EAMF,uGAAA;AtFyqTd;;AsF7rTQ;EACE,+BAAA;AtFgsTV;;AsF5rTU;EACE,+BAAA;AtF+rTZ;;AsFrsTQ;EACE,iCAAA;AtFwsTV;;AsFpsTU;EACE,iCAAA;AtFusTZ;;AsF7sTQ;EACE,kCAAA;AtFgtTV;;AsF5sTU;EACE,kCAAA;AtF+sTZ;;AsFrtTQ;EACE,iCAAA;AtFwtTV;;AsFptTU;EACE,iCAAA;AtFutTZ;;AsF7tTQ;EACE,kCAAA;AtFguTV;;AsF5tTU;EACE,kCAAA;AtF+tTZ;;AsFruTQ;EACE,+BAAA;AtFwuTV;;AsFpuTU;EACE,+BAAA;AtFuuTZ;;AsFnuTQ;EAIQ,mBAAA;EAMF,gFAAA;AtF8tTd;;AsFxuTQ;EAIQ,mBAAA;EAMF,kFAAA;AtFmuTd;;AsF7uTQ;EAIQ,mBAAA;EAMF,gFAAA;AtFwuTd;;AsFlvTQ;EAIQ,mBAAA;EAMF,6EAAA;AtF6uTd;;AsFvvTQ;EAIQ,mBAAA;EAMF,gFAAA;AtFkvTd;;AsF5vTQ;EAIQ,mBAAA;EAMF,+EAAA;AtFuvTd;;AsFjwTQ;EAIQ,mBAAA;EAMF,8EAAA;AtF4vTd;;AsFtwTQ;EAIQ,mBAAA;EAMF,6EAAA;AtFiwTd;;AsF3wTQ;EAIQ,mBAAA;EAMF,8EAAA;AtFswTd;;AsFhxTQ;EAIQ,mBAAA;EAMF,8EAAA;AtF2wTd;;AsFrxTQ;EAIQ,mBAAA;EAMF,gFAAA;AtFgxTd;;AsF1xTQ;EAIQ,mBAAA;EAMF,wCAAA;AtFqxTd;;AsF/xTQ;EAIQ,mBAAA;EAMF,qFAAA;AtF0xTd;;AsFpyTQ;EAIQ,mBAAA;EAMF,oFAAA;AtF+xTd;;AsFnzTQ;EACE,qBAAA;AtFszTV;;AsFvzTQ;EACE,sBAAA;AtF0zTV;;AsF3zTQ;EACE,qBAAA;AtF8zTV;;AsF/zTQ;EACE,sBAAA;AtFk0TV;;AsFn0TQ;EACE,mBAAA;AtFs0TV;;AsF7zTQ;EAUM,gDAAA;AtFuzTd;;AsFj0TQ;EAUM,mCAAA;UAAA,2BAAA;AtF2zTd;;AsFr0TQ;EAUM,oCAAA;UAAA,4BAAA;AtF+zTd;;AsFz0TQ;EAUM,oCAAA;UAAA,4BAAA;AtFm0Td;;AsF70TQ;EAUM,+BAAA;AtFu0Td;;AsFj1TQ;EAUM,+BAAA;AtF20Td;;AsFr1TQ;EAUM,kDAAA;AtF+0Td;;AsFz1TQ;EAUM,2BAAA;AtFm1Td;;AsF71TQ;EAUM,qDAAA;AtFu1Td;;AsFj2TQ;EAUM,kDAAA;AtF21Td;;AsFr2TQ;EAUM,qDAAA;AtF+1Td;;AsFz2TQ;EAUM,qDAAA;AtFm2Td;;AsF72TQ;EAUM,sDAAA;AtFu2Td;;AsFj3TQ;EAUM,6BAAA;AtF22Td;;AsFr3TQ;EAUM,uDAAA;AtF+2Td;;AsFz3TQ;EAUM,2DAAA;EAAA,4DAAA;AtFo3Td;;AsF93TQ;EAUM,oCAAA;EAAA,qCAAA;AtFy3Td;;AsFn4TQ;EAUM,8DAAA;EAAA,+DAAA;AtF83Td;;AsFx4TQ;EAUM,2DAAA;EAAA,4DAAA;AtFm4Td;;AsF74TQ;EAUM,8DAAA;EAAA,+DAAA;AtFw4Td;;AsFl5TQ;EAUM,8DAAA;EAAA,+DAAA;AtF64Td;;AsFv5TQ;EAUM,+DAAA;EAAA,gEAAA;AtFk5Td;;AsF55TQ;EAUM,sCAAA;EAAA,uCAAA;AtFu5Td;;AsFj6TQ;EAUM,gEAAA;EAAA,iEAAA;AtF45Td;;AsFt6TQ;EhFdF,4DAAA;EAAA,+DAAA;ANy7TN;;AsF36TQ;EhFdF,qCAAA;EAAA,wCAAA;AN87TN;;AsFh7TQ;EhFdF,+DAAA;EAAA,kEAAA;ANm8TN;;AsFr7TQ;EhFdF,4DAAA;EAAA,+DAAA;ANw8TN;;AsF17TQ;EhFdF,+DAAA;EAAA,kEAAA;AN68TN;;AsF/7TQ;EhFdF,+DAAA;EAAA,kEAAA;ANk9TN;;AsFp8TQ;EhFdF,gEAAA;EAAA,mEAAA;ANu9TN;;AsFz8TQ;EhFdF,uCAAA;EAAA,0CAAA;AN49TN;;AsF98TQ;EhFdF,iEAAA;EAAA,oEAAA;ANi+TN;;AsFn9TQ;EAUM,+DAAA;EAAA,8DAAA;AtF88Td;;AsFx9TQ;EAUM,wCAAA;EAAA,uCAAA;AtFm9Td;;AsF79TQ;EAUM,kEAAA;EAAA,iEAAA;AtFw9Td;;AsFl+TQ;EAUM,+DAAA;EAAA,8DAAA;AtF69Td;;AsFv+TQ;EAUM,kEAAA;EAAA,iEAAA;AtFk+Td;;AsF5+TQ;EAUM,kEAAA;EAAA,iEAAA;AtFu+Td;;AsFj/TQ;EAUM,mEAAA;EAAA,kEAAA;AtF4+Td;;AsFt/TQ;EAUM,0CAAA;EAAA,yCAAA;AtFi/Td;;AsF3/TQ;EAUM,oEAAA;EAAA,mEAAA;AtFs/Td;;AsFhgUQ;EhFdF,8DAAA;EAAA,2DAAA;ANmhUN;;AsFrgUQ;EhFdF,uCAAA;EAAA,oCAAA;ANwhUN;;AsF1gUQ;EhFdF,iEAAA;EAAA,8DAAA;AN6hUN;;AsF/gUQ;EhFdF,8DAAA;EAAA,2DAAA;ANkiUN;;AsFphUQ;EhFdF,iEAAA;EAAA,8DAAA;ANuiUN;;AsFzhUQ;EhFdF,iEAAA;EAAA,8DAAA;AN4iUN;;AsF9hUQ;EhFdF,kEAAA;EAAA,+DAAA;ANijUN;;AsFniUQ;EhFdF,yCAAA;EAAA,sCAAA;ANsjUN;;AsFxiUQ;EhFdF,mEAAA;EAAA,gEAAA;AN2jUN;;AsF7iUQ;EAUM,8BAAA;AtFuiUd;;AsFjjUQ;EAUM,6BAAA;AtF2iUd;;AsFrjUQ;EAUM,sBAAA;AtF+iUd;;AsFzjUQ;EAUM,qBAAA;AtFmjUd;;AsF7jUQ;EAUM,qBAAA;AtFujUd;;AsFjkUQ;EAUM,qBAAA;AtF2jUd;;AsFrkUQ;EAUM,qBAAA;AtF+jUd;;Ae/kUI;EuEMI;IhFdF,sBAAA;EN4lUJ;EsF9kUM;IhFdF,uBAAA;EN+lUJ;EsFjlUM;IhFdF,sBAAA;ENkmUJ;EsFplUM;IAUM,8BAAA;EtF6kUZ;EsFvlUM;IAUM,4BAAA;EtFglUZ;EsF1lUM;IAUM,2BAAA;EtFmlUZ;EsF7lUM;IAUM,iCAAA;EtFslUZ;EsFhmUM;IAUM,2BAAA;EtFylUZ;EsFnmUM;IAUM,0BAAA;EtF4lUZ;EsFtmUM;IAUM,gCAAA;EtF+lUZ;EsFzmUM;IAUM,yBAAA;EtFkmUZ;EsF5mUM;IAUM,wBAAA;EtFqmUZ;EsF/mUM;IAUM,+BAAA;EtFwmUZ;EsFlnUM;IAUM,yBAAA;EtF2mUZ;EsFrnUM;IAUM,6BAAA;EtF8mUZ;EsFxnUM;IAUM,8BAAA;EtFinUZ;EsF3nUM;IAUM,wBAAA;EtFonUZ;EsF9nUM;IAUM,+BAAA;EtFunUZ;EsFjoUM;IAUM,wBAAA;EtF0nUZ;EsFpoUM;IAUM,yBAAA;EtF6nUZ;EsFvoUM;IAUM,8BAAA;EtFgoUZ;EsF1oUM;IAUM,iCAAA;EtFmoUZ;EsF7oUM;IAUM,sCAAA;EtFsoUZ;EsFhpUM;IAUM,yCAAA;EtFyoUZ;EsFnpUM;IAUM,uBAAA;EtF4oUZ;EsFtpUM;IAUM,uBAAA;EtF+oUZ;EsFzpUM;IAUM,yBAAA;EtFkpUZ;EsF5pUM;IAUM,yBAAA;EtFqpUZ;EsF/pUM;IAUM,0BAAA;EtFwpUZ;EsFlqUM;IAUM,4BAAA;EtF2pUZ;EsFrqUM;IAUM,kCAAA;EtF8pUZ;EsFxqUM;IAUM,sCAAA;EtFiqUZ;EsF3qUM;IAUM,oCAAA;EtFoqUZ;EsF9qUM;IAUM,kCAAA;EtFuqUZ;EsFjrUM;IAUM,yCAAA;EtF0qUZ;EsFprUM;IAUM,wCAAA;EtF6qUZ;EsFvrUM;IAUM,wCAAA;EtFgrUZ;EsF1rUM;IAUM,kCAAA;EtFmrUZ;EsF7rUM;IAUM,gCAAA;EtFsrUZ;EsFhsUM;IAUM,8BAAA;EtFyrUZ;EsFnsUM;IAUM,gCAAA;EtF4rUZ;EsFtsUM;IAUM,+BAAA;EtF+rUZ;EsFzsUM;IAUM,oCAAA;EtFksUZ;EsF5sUM;IAUM,kCAAA;EtFqsUZ;EsF/sUM;IAUM,gCAAA;EtFwsUZ;EsFltUM;IAUM,uCAAA;EtF2sUZ;EsFrtUM;IAUM,sCAAA;EtF8sUZ;EsFxtUM;IAUM,iCAAA;EtFitUZ;EsF3tUM;IAUM,2BAAA;EtFotUZ;EsF9tUM;IAUM,iCAAA;EtFutUZ;EsFjuUM;IAUM,+BAAA;EtF0tUZ;EsFpuUM;IAUM,6BAAA;EtF6tUZ;EsFvuUM;IAUM,+BAAA;EtFguUZ;EsF1uUM;IAUM,8BAAA;EtFmuUZ;EsF7uUM;IAUM,oBAAA;EtFsuUZ;EsFhvUM;IAUM,mBAAA;EtFyuUZ;EsFnvUM;IAUM,mBAAA;EtF4uUZ;EsFtvUM;IAUM,mBAAA;EtF+uUZ;EsFzvUM;IAUM,mBAAA;EtFkvUZ;EsF5vUM;IAUM,mBAAA;EtFqvUZ;EsF/vUM;IAUM,mBAAA;EtFwvUZ;EsFlwUM;IAUM,mBAAA;EtF2vUZ;EsFrwUM;IAUM,oBAAA;EtF8vUZ;EsFxwUM;IAUM,0BAAA;EtFiwUZ;EsF3wUM;IAUM,yBAAA;EtFowUZ;EsF9wUM;IAUM,uBAAA;EtFuwUZ;EsFjxUM;IAUM,yBAAA;EtF0wUZ;EsFpxUM;IAUM,uBAAA;EtF6wUZ;EsFvxUM;IAUM,uBAAA;EtFgxUZ;EsF1xUM;IAUM,0BAAA;IAAA,yBAAA;EtFoxUZ;EsF9xUM;IAUM,gCAAA;IAAA,+BAAA;EtFwxUZ;EsFlyUM;IAUM,+BAAA;IAAA,8BAAA;EtF4xUZ;EsFtyUM;IAUM,6BAAA;IAAA,4BAAA;EtFgyUZ;EsF1yUM;IAUM,+BAAA;IAAA,8BAAA;EtFoyUZ;EsF9yUM;IAUM,6BAAA;IAAA,4BAAA;EtFwyUZ;EsFlzUM;IAUM,6BAAA;IAAA,4BAAA;EtF4yUZ;EsFtzUM;IAUM,wBAAA;IAAA,2BAAA;EtFgzUZ;EsF1zUM;IAUM,8BAAA;IAAA,iCAAA;EtFozUZ;EsF9zUM;IAUM,6BAAA;IAAA,gCAAA;EtFwzUZ;EsFl0UM;IAUM,2BAAA;IAAA,8BAAA;EtF4zUZ;EsFt0UM;IAUM,6BAAA;IAAA,gCAAA;EtFg0UZ;EsF10UM;IAUM,2BAAA;IAAA,8BAAA;EtFo0UZ;EsF90UM;IAUM,2BAAA;IAAA,8BAAA;EtFw0UZ;EsFl1UM;IAUM,wBAAA;EtF20UZ;EsFr1UM;IAUM,8BAAA;EtF80UZ;EsFx1UM;IAUM,6BAAA;EtFi1UZ;EsF31UM;IAUM,2BAAA;EtFo1UZ;EsF91UM;IAUM,6BAAA;EtFu1UZ;EsFj2UM;IAUM,2BAAA;EtF01UZ;EsFp2UM;IAUM,2BAAA;EtF61UZ;EsFv2UM;IhFdF,0BAAA;ENw3UJ;EsF12UM;IhFdF,gCAAA;EN23UJ;EsF72UM;IhFdF,+BAAA;EN83UJ;EsFh3UM;IhFdF,6BAAA;ENi4UJ;EsFn3UM;IhFdF,+BAAA;ENo4UJ;EsFt3UM;IhFdF,6BAAA;ENu4UJ;EsFz3UM;IhFdF,6BAAA;EN04UJ;EsF53UM;IAUM,2BAAA;EtFq3UZ;EsF/3UM;IAUM,iCAAA;EtFw3UZ;EsFl4UM;IAUM,gCAAA;EtF23UZ;EsFr4UM;IAUM,8BAAA;EtF83UZ;EsFx4UM;IAUM,gCAAA;EtFi4UZ;EsF34UM;IAUM,8BAAA;EtFo4UZ;EsF94UM;IAUM,8BAAA;EtFu4UZ;EsFj5UM;IhFdF,yBAAA;ENk6UJ;EsFp5UM;IhFdF,+BAAA;ENq6UJ;EsFv5UM;IhFdF,8BAAA;ENw6UJ;EsF15UM;IhFdF,4BAAA;EN26UJ;EsF75UM;IhFdF,8BAAA;EN86UJ;EsFh6UM;IhFdF,4BAAA;ENi7UJ;EsFn6UM;IhFdF,4BAAA;ENo7UJ;EsFt6UM;IAUM,qBAAA;EtF+5UZ;EsFz6UM;IAUM,2BAAA;EtFk6UZ;EsF56UM;IAUM,0BAAA;EtFq6UZ;EsF/6UM;IAUM,wBAAA;EtFw6UZ;EsFl7UM;IAUM,0BAAA;EtF26UZ;EsFr7UM;IAUM,wBAAA;EtF86UZ;EsFx7UM;IAUM,2BAAA;IAAA,0BAAA;EtFk7UZ;EsF57UM;IAUM,iCAAA;IAAA,gCAAA;EtFs7UZ;EsFh8UM;IAUM,gCAAA;IAAA,+BAAA;EtF07UZ;EsFp8UM;IAUM,8BAAA;IAAA,6BAAA;EtF87UZ;EsFx8UM;IAUM,gCAAA;IAAA,+BAAA;EtFk8UZ;EsF58UM;IAUM,8BAAA;IAAA,6BAAA;EtFs8UZ;EsFh9UM;IAUM,yBAAA;IAAA,4BAAA;EtF08UZ;EsFp9UM;IAUM,+BAAA;IAAA,kCAAA;EtF88UZ;EsFx9UM;IAUM,8BAAA;IAAA,iCAAA;EtFk9UZ;EsF59UM;IAUM,4BAAA;IAAA,+BAAA;EtFs9UZ;EsFh+UM;IAUM,8BAAA;IAAA,iCAAA;EtF09UZ;EsFp+UM;IAUM,4BAAA;IAAA,+BAAA;EtF89UZ;EsFx+UM;IAUM,yBAAA;EtFi+UZ;EsF3+UM;IAUM,+BAAA;EtFo+UZ;EsF9+UM;IAUM,8BAAA;EtFu+UZ;EsFj/UM;IAUM,4BAAA;EtF0+UZ;EsFp/UM;IAUM,8BAAA;EtF6+UZ;EsFv/UM;IAUM,4BAAA;EtFg/UZ;EsF1/UM;IhFdF,2BAAA;EN2gVJ;EsF7/UM;IhFdF,iCAAA;EN8gVJ;EsFhgVM;IhFdF,gCAAA;ENihVJ;EsFngVM;IhFdF,8BAAA;ENohVJ;EsFtgVM;IhFdF,gCAAA;ENuhVJ;EsFzgVM;IhFdF,8BAAA;EN0hVJ;EsF5gVM;IAUM,4BAAA;EtFqgVZ;EsF/gVM;IAUM,kCAAA;EtFwgVZ;EsFlhVM;IAUM,iCAAA;EtF2gVZ;EsFrhVM;IAUM,+BAAA;EtF8gVZ;EsFxhVM;IAUM,iCAAA;EtFihVZ;EsF3hVM;IAUM,+BAAA;EtFohVZ;EsF9hVM;IhFdF,0BAAA;EN+iVJ;EsFjiVM;IhFdF,gCAAA;ENkjVJ;EsFpiVM;IhFdF,+BAAA;ENqjVJ;EsFviVM;IhFdF,6BAAA;ENwjVJ;EsF1iVM;IhFdF,+BAAA;EN2jVJ;EsF7iVM;IhFdF,6BAAA;EN8jVJ;EsFhjVM;IAUM,iBAAA;EtFyiVZ;EsFnjVM;IAUM,uBAAA;EtF4iVZ;EsFtjVM;IAUM,sBAAA;EtF+iVZ;EsFzjVM;IAUM,oBAAA;EtFkjVZ;EsF5jVM;IAUM,sBAAA;EtFqjVZ;EsF/jVM;IAUM,oBAAA;EtFwjVZ;EsFlkVM;IAUM,qBAAA;EtF2jVZ;EsFrkVM;IAUM,2BAAA;EtF8jVZ;EsFxkVM;IAUM,0BAAA;EtFikVZ;EsF3kVM;IAUM,wBAAA;EtFokVZ;EsF9kVM;IAUM,0BAAA;EtFukVZ;EsFjlVM;IAUM,wBAAA;EtF0kVZ;EsFplVM;IAUM,wBAAA;EtF6kVZ;EsFvlVM;IAUM,8BAAA;EtFglVZ;EsF1lVM;IAUM,6BAAA;EtFmlVZ;EsF7lVM;IAUM,2BAAA;EtFslVZ;EsFhmVM;IAUM,6BAAA;EtFylVZ;EsFnmVM;IAUM,2BAAA;EtF4lVZ;EsFtmVM;IhFdF,2BAAA;ENunVJ;EsFzmVM;IhFdF,4BAAA;EN0nVJ;EsF5mVM;IhFdF,6BAAA;EN6nVJ;AACF;AetnVI;EuEMI;IhFdF,sBAAA;ENkoVJ;EsFpnVM;IhFdF,uBAAA;ENqoVJ;EsFvnVM;IhFdF,sBAAA;ENwoVJ;EsF1nVM;IAUM,8BAAA;EtFmnVZ;EsF7nVM;IAUM,4BAAA;EtFsnVZ;EsFhoVM;IAUM,2BAAA;EtFynVZ;EsFnoVM;IAUM,iCAAA;EtF4nVZ;EsFtoVM;IAUM,2BAAA;EtF+nVZ;EsFzoVM;IAUM,0BAAA;EtFkoVZ;EsF5oVM;IAUM,gCAAA;EtFqoVZ;EsF/oVM;IAUM,yBAAA;EtFwoVZ;EsFlpVM;IAUM,wBAAA;EtF2oVZ;EsFrpVM;IAUM,+BAAA;EtF8oVZ;EsFxpVM;IAUM,yBAAA;EtFipVZ;EsF3pVM;IAUM,6BAAA;EtFopVZ;EsF9pVM;IAUM,8BAAA;EtFupVZ;EsFjqVM;IAUM,wBAAA;EtF0pVZ;EsFpqVM;IAUM,+BAAA;EtF6pVZ;EsFvqVM;IAUM,wBAAA;EtFgqVZ;EsF1qVM;IAUM,yBAAA;EtFmqVZ;EsF7qVM;IAUM,8BAAA;EtFsqVZ;EsFhrVM;IAUM,iCAAA;EtFyqVZ;EsFnrVM;IAUM,sCAAA;EtF4qVZ;EsFtrVM;IAUM,yCAAA;EtF+qVZ;EsFzrVM;IAUM,uBAAA;EtFkrVZ;EsF5rVM;IAUM,uBAAA;EtFqrVZ;EsF/rVM;IAUM,yBAAA;EtFwrVZ;EsFlsVM;IAUM,yBAAA;EtF2rVZ;EsFrsVM;IAUM,0BAAA;EtF8rVZ;EsFxsVM;IAUM,4BAAA;EtFisVZ;EsF3sVM;IAUM,kCAAA;EtFosVZ;EsF9sVM;IAUM,sCAAA;EtFusVZ;EsFjtVM;IAUM,oCAAA;EtF0sVZ;EsFptVM;IAUM,kCAAA;EtF6sVZ;EsFvtVM;IAUM,yCAAA;EtFgtVZ;EsF1tVM;IAUM,wCAAA;EtFmtVZ;EsF7tVM;IAUM,wCAAA;EtFstVZ;EsFhuVM;IAUM,kCAAA;EtFytVZ;EsFnuVM;IAUM,gCAAA;EtF4tVZ;EsFtuVM;IAUM,8BAAA;EtF+tVZ;EsFzuVM;IAUM,gCAAA;EtFkuVZ;EsF5uVM;IAUM,+BAAA;EtFquVZ;EsF/uVM;IAUM,oCAAA;EtFwuVZ;EsFlvVM;IAUM,kCAAA;EtF2uVZ;EsFrvVM;IAUM,gCAAA;EtF8uVZ;EsFxvVM;IAUM,uCAAA;EtFivVZ;EsF3vVM;IAUM,sCAAA;EtFovVZ;EsF9vVM;IAUM,iCAAA;EtFuvVZ;EsFjwVM;IAUM,2BAAA;EtF0vVZ;EsFpwVM;IAUM,iCAAA;EtF6vVZ;EsFvwVM;IAUM,+BAAA;EtFgwVZ;EsF1wVM;IAUM,6BAAA;EtFmwVZ;EsF7wVM;IAUM,+BAAA;EtFswVZ;EsFhxVM;IAUM,8BAAA;EtFywVZ;EsFnxVM;IAUM,oBAAA;EtF4wVZ;EsFtxVM;IAUM,mBAAA;EtF+wVZ;EsFzxVM;IAUM,mBAAA;EtFkxVZ;EsF5xVM;IAUM,mBAAA;EtFqxVZ;EsF/xVM;IAUM,mBAAA;EtFwxVZ;EsFlyVM;IAUM,mBAAA;EtF2xVZ;EsFryVM;IAUM,mBAAA;EtF8xVZ;EsFxyVM;IAUM,mBAAA;EtFiyVZ;EsF3yVM;IAUM,oBAAA;EtFoyVZ;EsF9yVM;IAUM,0BAAA;EtFuyVZ;EsFjzVM;IAUM,yBAAA;EtF0yVZ;EsFpzVM;IAUM,uBAAA;EtF6yVZ;EsFvzVM;IAUM,yBAAA;EtFgzVZ;EsF1zVM;IAUM,uBAAA;EtFmzVZ;EsF7zVM;IAUM,uBAAA;EtFszVZ;EsFh0VM;IAUM,0BAAA;IAAA,yBAAA;EtF0zVZ;EsFp0VM;IAUM,gCAAA;IAAA,+BAAA;EtF8zVZ;EsFx0VM;IAUM,+BAAA;IAAA,8BAAA;EtFk0VZ;EsF50VM;IAUM,6BAAA;IAAA,4BAAA;EtFs0VZ;EsFh1VM;IAUM,+BAAA;IAAA,8BAAA;EtF00VZ;EsFp1VM;IAUM,6BAAA;IAAA,4BAAA;EtF80VZ;EsFx1VM;IAUM,6BAAA;IAAA,4BAAA;EtFk1VZ;EsF51VM;IAUM,wBAAA;IAAA,2BAAA;EtFs1VZ;EsFh2VM;IAUM,8BAAA;IAAA,iCAAA;EtF01VZ;EsFp2VM;IAUM,6BAAA;IAAA,gCAAA;EtF81VZ;EsFx2VM;IAUM,2BAAA;IAAA,8BAAA;EtFk2VZ;EsF52VM;IAUM,6BAAA;IAAA,gCAAA;EtFs2VZ;EsFh3VM;IAUM,2BAAA;IAAA,8BAAA;EtF02VZ;EsFp3VM;IAUM,2BAAA;IAAA,8BAAA;EtF82VZ;EsFx3VM;IAUM,wBAAA;EtFi3VZ;EsF33VM;IAUM,8BAAA;EtFo3VZ;EsF93VM;IAUM,6BAAA;EtFu3VZ;EsFj4VM;IAUM,2BAAA;EtF03VZ;EsFp4VM;IAUM,6BAAA;EtF63VZ;EsFv4VM;IAUM,2BAAA;EtFg4VZ;EsF14VM;IAUM,2BAAA;EtFm4VZ;EsF74VM;IhFdF,0BAAA;EN85VJ;EsFh5VM;IhFdF,gCAAA;ENi6VJ;EsFn5VM;IhFdF,+BAAA;ENo6VJ;EsFt5VM;IhFdF,6BAAA;ENu6VJ;EsFz5VM;IhFdF,+BAAA;EN06VJ;EsF55VM;IhFdF,6BAAA;EN66VJ;EsF/5VM;IhFdF,6BAAA;ENg7VJ;EsFl6VM;IAUM,2BAAA;EtF25VZ;EsFr6VM;IAUM,iCAAA;EtF85VZ;EsFx6VM;IAUM,gCAAA;EtFi6VZ;EsF36VM;IAUM,8BAAA;EtFo6VZ;EsF96VM;IAUM,gCAAA;EtFu6VZ;EsFj7VM;IAUM,8BAAA;EtF06VZ;EsFp7VM;IAUM,8BAAA;EtF66VZ;EsFv7VM;IhFdF,yBAAA;ENw8VJ;EsF17VM;IhFdF,+BAAA;EN28VJ;EsF77VM;IhFdF,8BAAA;EN88VJ;EsFh8VM;IhFdF,4BAAA;ENi9VJ;EsFn8VM;IhFdF,8BAAA;ENo9VJ;EsFt8VM;IhFdF,4BAAA;ENu9VJ;EsFz8VM;IhFdF,4BAAA;EN09VJ;EsF58VM;IAUM,qBAAA;EtFq8VZ;EsF/8VM;IAUM,2BAAA;EtFw8VZ;EsFl9VM;IAUM,0BAAA;EtF28VZ;EsFr9VM;IAUM,wBAAA;EtF88VZ;EsFx9VM;IAUM,0BAAA;EtFi9VZ;EsF39VM;IAUM,wBAAA;EtFo9VZ;EsF99VM;IAUM,2BAAA;IAAA,0BAAA;EtFw9VZ;EsFl+VM;IAUM,iCAAA;IAAA,gCAAA;EtF49VZ;EsFt+VM;IAUM,gCAAA;IAAA,+BAAA;EtFg+VZ;EsF1+VM;IAUM,8BAAA;IAAA,6BAAA;EtFo+VZ;EsF9+VM;IAUM,gCAAA;IAAA,+BAAA;EtFw+VZ;EsFl/VM;IAUM,8BAAA;IAAA,6BAAA;EtF4+VZ;EsFt/VM;IAUM,yBAAA;IAAA,4BAAA;EtFg/VZ;EsF1/VM;IAUM,+BAAA;IAAA,kCAAA;EtFo/VZ;EsF9/VM;IAUM,8BAAA;IAAA,iCAAA;EtFw/VZ;EsFlgWM;IAUM,4BAAA;IAAA,+BAAA;EtF4/VZ;EsFtgWM;IAUM,8BAAA;IAAA,iCAAA;EtFggWZ;EsF1gWM;IAUM,4BAAA;IAAA,+BAAA;EtFogWZ;EsF9gWM;IAUM,yBAAA;EtFugWZ;EsFjhWM;IAUM,+BAAA;EtF0gWZ;EsFphWM;IAUM,8BAAA;EtF6gWZ;EsFvhWM;IAUM,4BAAA;EtFghWZ;EsF1hWM;IAUM,8BAAA;EtFmhWZ;EsF7hWM;IAUM,4BAAA;EtFshWZ;EsFhiWM;IhFdF,2BAAA;ENijWJ;EsFniWM;IhFdF,iCAAA;ENojWJ;EsFtiWM;IhFdF,gCAAA;ENujWJ;EsFziWM;IhFdF,8BAAA;EN0jWJ;EsF5iWM;IhFdF,gCAAA;EN6jWJ;EsF/iWM;IhFdF,8BAAA;ENgkWJ;EsFljWM;IAUM,4BAAA;EtF2iWZ;EsFrjWM;IAUM,kCAAA;EtF8iWZ;EsFxjWM;IAUM,iCAAA;EtFijWZ;EsF3jWM;IAUM,+BAAA;EtFojWZ;EsF9jWM;IAUM,iCAAA;EtFujWZ;EsFjkWM;IAUM,+BAAA;EtF0jWZ;EsFpkWM;IhFdF,0BAAA;ENqlWJ;EsFvkWM;IhFdF,gCAAA;ENwlWJ;EsF1kWM;IhFdF,+BAAA;EN2lWJ;EsF7kWM;IhFdF,6BAAA;EN8lWJ;EsFhlWM;IhFdF,+BAAA;ENimWJ;EsFnlWM;IhFdF,6BAAA;ENomWJ;EsFtlWM;IAUM,iBAAA;EtF+kWZ;EsFzlWM;IAUM,uBAAA;EtFklWZ;EsF5lWM;IAUM,sBAAA;EtFqlWZ;EsF/lWM;IAUM,oBAAA;EtFwlWZ;EsFlmWM;IAUM,sBAAA;EtF2lWZ;EsFrmWM;IAUM,oBAAA;EtF8lWZ;EsFxmWM;IAUM,qBAAA;EtFimWZ;EsF3mWM;IAUM,2BAAA;EtFomWZ;EsF9mWM;IAUM,0BAAA;EtFumWZ;EsFjnWM;IAUM,wBAAA;EtF0mWZ;EsFpnWM;IAUM,0BAAA;EtF6mWZ;EsFvnWM;IAUM,wBAAA;EtFgnWZ;EsF1nWM;IAUM,wBAAA;EtFmnWZ;EsF7nWM;IAUM,8BAAA;EtFsnWZ;EsFhoWM;IAUM,6BAAA;EtFynWZ;EsFnoWM;IAUM,2BAAA;EtF4nWZ;EsFtoWM;IAUM,6BAAA;EtF+nWZ;EsFzoWM;IAUM,2BAAA;EtFkoWZ;EsF5oWM;IhFdF,2BAAA;EN6pWJ;EsF/oWM;IhFdF,4BAAA;ENgqWJ;EsFlpWM;IhFdF,6BAAA;ENmqWJ;AACF;Ae5pWI;EuEMI;IhFdF,sBAAA;ENwqWJ;EsF1pWM;IhFdF,uBAAA;EN2qWJ;EsF7pWM;IhFdF,sBAAA;EN8qWJ;EsFhqWM;IAUM,8BAAA;EtFypWZ;EsFnqWM;IAUM,4BAAA;EtF4pWZ;EsFtqWM;IAUM,2BAAA;EtF+pWZ;EsFzqWM;IAUM,iCAAA;EtFkqWZ;EsF5qWM;IAUM,2BAAA;EtFqqWZ;EsF/qWM;IAUM,0BAAA;EtFwqWZ;EsFlrWM;IAUM,gCAAA;EtF2qWZ;EsFrrWM;IAUM,yBAAA;EtF8qWZ;EsFxrWM;IAUM,wBAAA;EtFirWZ;EsF3rWM;IAUM,+BAAA;EtForWZ;EsF9rWM;IAUM,yBAAA;EtFurWZ;EsFjsWM;IAUM,6BAAA;EtF0rWZ;EsFpsWM;IAUM,8BAAA;EtF6rWZ;EsFvsWM;IAUM,wBAAA;EtFgsWZ;EsF1sWM;IAUM,+BAAA;EtFmsWZ;EsF7sWM;IAUM,wBAAA;EtFssWZ;EsFhtWM;IAUM,yBAAA;EtFysWZ;EsFntWM;IAUM,8BAAA;EtF4sWZ;EsFttWM;IAUM,iCAAA;EtF+sWZ;EsFztWM;IAUM,sCAAA;EtFktWZ;EsF5tWM;IAUM,yCAAA;EtFqtWZ;EsF/tWM;IAUM,uBAAA;EtFwtWZ;EsFluWM;IAUM,uBAAA;EtF2tWZ;EsFruWM;IAUM,yBAAA;EtF8tWZ;EsFxuWM;IAUM,yBAAA;EtFiuWZ;EsF3uWM;IAUM,0BAAA;EtFouWZ;EsF9uWM;IAUM,4BAAA;EtFuuWZ;EsFjvWM;IAUM,kCAAA;EtF0uWZ;EsFpvWM;IAUM,sCAAA;EtF6uWZ;EsFvvWM;IAUM,oCAAA;EtFgvWZ;EsF1vWM;IAUM,kCAAA;EtFmvWZ;EsF7vWM;IAUM,yCAAA;EtFsvWZ;EsFhwWM;IAUM,wCAAA;EtFyvWZ;EsFnwWM;IAUM,wCAAA;EtF4vWZ;EsFtwWM;IAUM,kCAAA;EtF+vWZ;EsFzwWM;IAUM,gCAAA;EtFkwWZ;EsF5wWM;IAUM,8BAAA;EtFqwWZ;EsF/wWM;IAUM,gCAAA;EtFwwWZ;EsFlxWM;IAUM,+BAAA;EtF2wWZ;EsFrxWM;IAUM,oCAAA;EtF8wWZ;EsFxxWM;IAUM,kCAAA;EtFixWZ;EsF3xWM;IAUM,gCAAA;EtFoxWZ;EsF9xWM;IAUM,uCAAA;EtFuxWZ;EsFjyWM;IAUM,sCAAA;EtF0xWZ;EsFpyWM;IAUM,iCAAA;EtF6xWZ;EsFvyWM;IAUM,2BAAA;EtFgyWZ;EsF1yWM;IAUM,iCAAA;EtFmyWZ;EsF7yWM;IAUM,+BAAA;EtFsyWZ;EsFhzWM;IAUM,6BAAA;EtFyyWZ;EsFnzWM;IAUM,+BAAA;EtF4yWZ;EsFtzWM;IAUM,8BAAA;EtF+yWZ;EsFzzWM;IAUM,oBAAA;EtFkzWZ;EsF5zWM;IAUM,mBAAA;EtFqzWZ;EsF/zWM;IAUM,mBAAA;EtFwzWZ;EsFl0WM;IAUM,mBAAA;EtF2zWZ;EsFr0WM;IAUM,mBAAA;EtF8zWZ;EsFx0WM;IAUM,mBAAA;EtFi0WZ;EsF30WM;IAUM,mBAAA;EtFo0WZ;EsF90WM;IAUM,mBAAA;EtFu0WZ;EsFj1WM;IAUM,oBAAA;EtF00WZ;EsFp1WM;IAUM,0BAAA;EtF60WZ;EsFv1WM;IAUM,yBAAA;EtFg1WZ;EsF11WM;IAUM,uBAAA;EtFm1WZ;EsF71WM;IAUM,yBAAA;EtFs1WZ;EsFh2WM;IAUM,uBAAA;EtFy1WZ;EsFn2WM;IAUM,uBAAA;EtF41WZ;EsFt2WM;IAUM,0BAAA;IAAA,yBAAA;EtFg2WZ;EsF12WM;IAUM,gCAAA;IAAA,+BAAA;EtFo2WZ;EsF92WM;IAUM,+BAAA;IAAA,8BAAA;EtFw2WZ;EsFl3WM;IAUM,6BAAA;IAAA,4BAAA;EtF42WZ;EsFt3WM;IAUM,+BAAA;IAAA,8BAAA;EtFg3WZ;EsF13WM;IAUM,6BAAA;IAAA,4BAAA;EtFo3WZ;EsF93WM;IAUM,6BAAA;IAAA,4BAAA;EtFw3WZ;EsFl4WM;IAUM,wBAAA;IAAA,2BAAA;EtF43WZ;EsFt4WM;IAUM,8BAAA;IAAA,iCAAA;EtFg4WZ;EsF14WM;IAUM,6BAAA;IAAA,gCAAA;EtFo4WZ;EsF94WM;IAUM,2BAAA;IAAA,8BAAA;EtFw4WZ;EsFl5WM;IAUM,6BAAA;IAAA,gCAAA;EtF44WZ;EsFt5WM;IAUM,2BAAA;IAAA,8BAAA;EtFg5WZ;EsF15WM;IAUM,2BAAA;IAAA,8BAAA;EtFo5WZ;EsF95WM;IAUM,wBAAA;EtFu5WZ;EsFj6WM;IAUM,8BAAA;EtF05WZ;EsFp6WM;IAUM,6BAAA;EtF65WZ;EsFv6WM;IAUM,2BAAA;EtFg6WZ;EsF16WM;IAUM,6BAAA;EtFm6WZ;EsF76WM;IAUM,2BAAA;EtFs6WZ;EsFh7WM;IAUM,2BAAA;EtFy6WZ;EsFn7WM;IhFdF,0BAAA;ENo8WJ;EsFt7WM;IhFdF,gCAAA;ENu8WJ;EsFz7WM;IhFdF,+BAAA;EN08WJ;EsF57WM;IhFdF,6BAAA;EN68WJ;EsF/7WM;IhFdF,+BAAA;ENg9WJ;EsFl8WM;IhFdF,6BAAA;ENm9WJ;EsFr8WM;IhFdF,6BAAA;ENs9WJ;EsFx8WM;IAUM,2BAAA;EtFi8WZ;EsF38WM;IAUM,iCAAA;EtFo8WZ;EsF98WM;IAUM,gCAAA;EtFu8WZ;EsFj9WM;IAUM,8BAAA;EtF08WZ;EsFp9WM;IAUM,gCAAA;EtF68WZ;EsFv9WM;IAUM,8BAAA;EtFg9WZ;EsF19WM;IAUM,8BAAA;EtFm9WZ;EsF79WM;IhFdF,yBAAA;EN8+WJ;EsFh+WM;IhFdF,+BAAA;ENi/WJ;EsFn+WM;IhFdF,8BAAA;ENo/WJ;EsFt+WM;IhFdF,4BAAA;ENu/WJ;EsFz+WM;IhFdF,8BAAA;EN0/WJ;EsF5+WM;IhFdF,4BAAA;EN6/WJ;EsF/+WM;IhFdF,4BAAA;ENggXJ;EsFl/WM;IAUM,qBAAA;EtF2+WZ;EsFr/WM;IAUM,2BAAA;EtF8+WZ;EsFx/WM;IAUM,0BAAA;EtFi/WZ;EsF3/WM;IAUM,wBAAA;EtFo/WZ;EsF9/WM;IAUM,0BAAA;EtFu/WZ;EsFjgXM;IAUM,wBAAA;EtF0/WZ;EsFpgXM;IAUM,2BAAA;IAAA,0BAAA;EtF8/WZ;EsFxgXM;IAUM,iCAAA;IAAA,gCAAA;EtFkgXZ;EsF5gXM;IAUM,gCAAA;IAAA,+BAAA;EtFsgXZ;EsFhhXM;IAUM,8BAAA;IAAA,6BAAA;EtF0gXZ;EsFphXM;IAUM,gCAAA;IAAA,+BAAA;EtF8gXZ;EsFxhXM;IAUM,8BAAA;IAAA,6BAAA;EtFkhXZ;EsF5hXM;IAUM,yBAAA;IAAA,4BAAA;EtFshXZ;EsFhiXM;IAUM,+BAAA;IAAA,kCAAA;EtF0hXZ;EsFpiXM;IAUM,8BAAA;IAAA,iCAAA;EtF8hXZ;EsFxiXM;IAUM,4BAAA;IAAA,+BAAA;EtFkiXZ;EsF5iXM;IAUM,8BAAA;IAAA,iCAAA;EtFsiXZ;EsFhjXM;IAUM,4BAAA;IAAA,+BAAA;EtF0iXZ;EsFpjXM;IAUM,yBAAA;EtF6iXZ;EsFvjXM;IAUM,+BAAA;EtFgjXZ;EsF1jXM;IAUM,8BAAA;EtFmjXZ;EsF7jXM;IAUM,4BAAA;EtFsjXZ;EsFhkXM;IAUM,8BAAA;EtFyjXZ;EsFnkXM;IAUM,4BAAA;EtF4jXZ;EsFtkXM;IhFdF,2BAAA;ENulXJ;EsFzkXM;IhFdF,iCAAA;EN0lXJ;EsF5kXM;IhFdF,gCAAA;EN6lXJ;EsF/kXM;IhFdF,8BAAA;ENgmXJ;EsFllXM;IhFdF,gCAAA;ENmmXJ;EsFrlXM;IhFdF,8BAAA;ENsmXJ;EsFxlXM;IAUM,4BAAA;EtFilXZ;EsF3lXM;IAUM,kCAAA;EtFolXZ;EsF9lXM;IAUM,iCAAA;EtFulXZ;EsFjmXM;IAUM,+BAAA;EtF0lXZ;EsFpmXM;IAUM,iCAAA;EtF6lXZ;EsFvmXM;IAUM,+BAAA;EtFgmXZ;EsF1mXM;IhFdF,0BAAA;EN2nXJ;EsF7mXM;IhFdF,gCAAA;EN8nXJ;EsFhnXM;IhFdF,+BAAA;ENioXJ;EsFnnXM;IhFdF,6BAAA;ENooXJ;EsFtnXM;IhFdF,+BAAA;ENuoXJ;EsFznXM;IhFdF,6BAAA;EN0oXJ;EsF5nXM;IAUM,iBAAA;EtFqnXZ;EsF/nXM;IAUM,uBAAA;EtFwnXZ;EsFloXM;IAUM,sBAAA;EtF2nXZ;EsFroXM;IAUM,oBAAA;EtF8nXZ;EsFxoXM;IAUM,sBAAA;EtFioXZ;EsF3oXM;IAUM,oBAAA;EtFooXZ;EsF9oXM;IAUM,qBAAA;EtFuoXZ;EsFjpXM;IAUM,2BAAA;EtF0oXZ;EsFppXM;IAUM,0BAAA;EtF6oXZ;EsFvpXM;IAUM,wBAAA;EtFgpXZ;EsF1pXM;IAUM,0BAAA;EtFmpXZ;EsF7pXM;IAUM,wBAAA;EtFspXZ;EsFhqXM;IAUM,wBAAA;EtFypXZ;EsFnqXM;IAUM,8BAAA;EtF4pXZ;EsFtqXM;IAUM,6BAAA;EtF+pXZ;EsFzqXM;IAUM,2BAAA;EtFkqXZ;EsF5qXM;IAUM,6BAAA;EtFqqXZ;EsF/qXM;IAUM,2BAAA;EtFwqXZ;EsFlrXM;IhFdF,2BAAA;ENmsXJ;EsFrrXM;IhFdF,4BAAA;ENssXJ;EsFxrXM;IhFdF,6BAAA;ENysXJ;AACF;AelsXI;EuEMI;IhFdF,sBAAA;EN8sXJ;EsFhsXM;IhFdF,uBAAA;ENitXJ;EsFnsXM;IhFdF,sBAAA;ENotXJ;EsFtsXM;IAUM,8BAAA;EtF+rXZ;EsFzsXM;IAUM,4BAAA;EtFksXZ;EsF5sXM;IAUM,2BAAA;EtFqsXZ;EsF/sXM;IAUM,iCAAA;EtFwsXZ;EsFltXM;IAUM,2BAAA;EtF2sXZ;EsFrtXM;IAUM,0BAAA;EtF8sXZ;EsFxtXM;IAUM,gCAAA;EtFitXZ;EsF3tXM;IAUM,yBAAA;EtFotXZ;EsF9tXM;IAUM,wBAAA;EtFutXZ;EsFjuXM;IAUM,+BAAA;EtF0tXZ;EsFpuXM;IAUM,yBAAA;EtF6tXZ;EsFvuXM;IAUM,6BAAA;EtFguXZ;EsF1uXM;IAUM,8BAAA;EtFmuXZ;EsF7uXM;IAUM,wBAAA;EtFsuXZ;EsFhvXM;IAUM,+BAAA;EtFyuXZ;EsFnvXM;IAUM,wBAAA;EtF4uXZ;EsFtvXM;IAUM,yBAAA;EtF+uXZ;EsFzvXM;IAUM,8BAAA;EtFkvXZ;EsF5vXM;IAUM,iCAAA;EtFqvXZ;EsF/vXM;IAUM,sCAAA;EtFwvXZ;EsFlwXM;IAUM,yCAAA;EtF2vXZ;EsFrwXM;IAUM,uBAAA;EtF8vXZ;EsFxwXM;IAUM,uBAAA;EtFiwXZ;EsF3wXM;IAUM,yBAAA;EtFowXZ;EsF9wXM;IAUM,yBAAA;EtFuwXZ;EsFjxXM;IAUM,0BAAA;EtF0wXZ;EsFpxXM;IAUM,4BAAA;EtF6wXZ;EsFvxXM;IAUM,kCAAA;EtFgxXZ;EsF1xXM;IAUM,sCAAA;EtFmxXZ;EsF7xXM;IAUM,oCAAA;EtFsxXZ;EsFhyXM;IAUM,kCAAA;EtFyxXZ;EsFnyXM;IAUM,yCAAA;EtF4xXZ;EsFtyXM;IAUM,wCAAA;EtF+xXZ;EsFzyXM;IAUM,wCAAA;EtFkyXZ;EsF5yXM;IAUM,kCAAA;EtFqyXZ;EsF/yXM;IAUM,gCAAA;EtFwyXZ;EsFlzXM;IAUM,8BAAA;EtF2yXZ;EsFrzXM;IAUM,gCAAA;EtF8yXZ;EsFxzXM;IAUM,+BAAA;EtFizXZ;EsF3zXM;IAUM,oCAAA;EtFozXZ;EsF9zXM;IAUM,kCAAA;EtFuzXZ;EsFj0XM;IAUM,gCAAA;EtF0zXZ;EsFp0XM;IAUM,uCAAA;EtF6zXZ;EsFv0XM;IAUM,sCAAA;EtFg0XZ;EsF10XM;IAUM,iCAAA;EtFm0XZ;EsF70XM;IAUM,2BAAA;EtFs0XZ;EsFh1XM;IAUM,iCAAA;EtFy0XZ;EsFn1XM;IAUM,+BAAA;EtF40XZ;EsFt1XM;IAUM,6BAAA;EtF+0XZ;EsFz1XM;IAUM,+BAAA;EtFk1XZ;EsF51XM;IAUM,8BAAA;EtFq1XZ;EsF/1XM;IAUM,oBAAA;EtFw1XZ;EsFl2XM;IAUM,mBAAA;EtF21XZ;EsFr2XM;IAUM,mBAAA;EtF81XZ;EsFx2XM;IAUM,mBAAA;EtFi2XZ;EsF32XM;IAUM,mBAAA;EtFo2XZ;EsF92XM;IAUM,mBAAA;EtFu2XZ;EsFj3XM;IAUM,mBAAA;EtF02XZ;EsFp3XM;IAUM,mBAAA;EtF62XZ;EsFv3XM;IAUM,oBAAA;EtFg3XZ;EsF13XM;IAUM,0BAAA;EtFm3XZ;EsF73XM;IAUM,yBAAA;EtFs3XZ;EsFh4XM;IAUM,uBAAA;EtFy3XZ;EsFn4XM;IAUM,yBAAA;EtF43XZ;EsFt4XM;IAUM,uBAAA;EtF+3XZ;EsFz4XM;IAUM,uBAAA;EtFk4XZ;EsF54XM;IAUM,0BAAA;IAAA,yBAAA;EtFs4XZ;EsFh5XM;IAUM,gCAAA;IAAA,+BAAA;EtF04XZ;EsFp5XM;IAUM,+BAAA;IAAA,8BAAA;EtF84XZ;EsFx5XM;IAUM,6BAAA;IAAA,4BAAA;EtFk5XZ;EsF55XM;IAUM,+BAAA;IAAA,8BAAA;EtFs5XZ;EsFh6XM;IAUM,6BAAA;IAAA,4BAAA;EtF05XZ;EsFp6XM;IAUM,6BAAA;IAAA,4BAAA;EtF85XZ;EsFx6XM;IAUM,wBAAA;IAAA,2BAAA;EtFk6XZ;EsF56XM;IAUM,8BAAA;IAAA,iCAAA;EtFs6XZ;EsFh7XM;IAUM,6BAAA;IAAA,gCAAA;EtF06XZ;EsFp7XM;IAUM,2BAAA;IAAA,8BAAA;EtF86XZ;EsFx7XM;IAUM,6BAAA;IAAA,gCAAA;EtFk7XZ;EsF57XM;IAUM,2BAAA;IAAA,8BAAA;EtFs7XZ;EsFh8XM;IAUM,2BAAA;IAAA,8BAAA;EtF07XZ;EsFp8XM;IAUM,wBAAA;EtF67XZ;EsFv8XM;IAUM,8BAAA;EtFg8XZ;EsF18XM;IAUM,6BAAA;EtFm8XZ;EsF78XM;IAUM,2BAAA;EtFs8XZ;EsFh9XM;IAUM,6BAAA;EtFy8XZ;EsFn9XM;IAUM,2BAAA;EtF48XZ;EsFt9XM;IAUM,2BAAA;EtF+8XZ;EsFz9XM;IhFdF,0BAAA;EN0+XJ;EsF59XM;IhFdF,gCAAA;EN6+XJ;EsF/9XM;IhFdF,+BAAA;ENg/XJ;EsFl+XM;IhFdF,6BAAA;ENm/XJ;EsFr+XM;IhFdF,+BAAA;ENs/XJ;EsFx+XM;IhFdF,6BAAA;ENy/XJ;EsF3+XM;IhFdF,6BAAA;EN4/XJ;EsF9+XM;IAUM,2BAAA;EtFu+XZ;EsFj/XM;IAUM,iCAAA;EtF0+XZ;EsFp/XM;IAUM,gCAAA;EtF6+XZ;EsFv/XM;IAUM,8BAAA;EtFg/XZ;EsF1/XM;IAUM,gCAAA;EtFm/XZ;EsF7/XM;IAUM,8BAAA;EtFs/XZ;EsFhgYM;IAUM,8BAAA;EtFy/XZ;EsFngYM;IhFdF,yBAAA;ENohYJ;EsFtgYM;IhFdF,+BAAA;ENuhYJ;EsFzgYM;IhFdF,8BAAA;EN0hYJ;EsF5gYM;IhFdF,4BAAA;EN6hYJ;EsF/gYM;IhFdF,8BAAA;ENgiYJ;EsFlhYM;IhFdF,4BAAA;ENmiYJ;EsFrhYM;IhFdF,4BAAA;ENsiYJ;EsFxhYM;IAUM,qBAAA;EtFihYZ;EsF3hYM;IAUM,2BAAA;EtFohYZ;EsF9hYM;IAUM,0BAAA;EtFuhYZ;EsFjiYM;IAUM,wBAAA;EtF0hYZ;EsFpiYM;IAUM,0BAAA;EtF6hYZ;EsFviYM;IAUM,wBAAA;EtFgiYZ;EsF1iYM;IAUM,2BAAA;IAAA,0BAAA;EtFoiYZ;EsF9iYM;IAUM,iCAAA;IAAA,gCAAA;EtFwiYZ;EsFljYM;IAUM,gCAAA;IAAA,+BAAA;EtF4iYZ;EsFtjYM;IAUM,8BAAA;IAAA,6BAAA;EtFgjYZ;EsF1jYM;IAUM,gCAAA;IAAA,+BAAA;EtFojYZ;EsF9jYM;IAUM,8BAAA;IAAA,6BAAA;EtFwjYZ;EsFlkYM;IAUM,yBAAA;IAAA,4BAAA;EtF4jYZ;EsFtkYM;IAUM,+BAAA;IAAA,kCAAA;EtFgkYZ;EsF1kYM;IAUM,8BAAA;IAAA,iCAAA;EtFokYZ;EsF9kYM;IAUM,4BAAA;IAAA,+BAAA;EtFwkYZ;EsFllYM;IAUM,8BAAA;IAAA,iCAAA;EtF4kYZ;EsFtlYM;IAUM,4BAAA;IAAA,+BAAA;EtFglYZ;EsF1lYM;IAUM,yBAAA;EtFmlYZ;EsF7lYM;IAUM,+BAAA;EtFslYZ;EsFhmYM;IAUM,8BAAA;EtFylYZ;EsFnmYM;IAUM,4BAAA;EtF4lYZ;EsFtmYM;IAUM,8BAAA;EtF+lYZ;EsFzmYM;IAUM,4BAAA;EtFkmYZ;EsF5mYM;IhFdF,2BAAA;EN6nYJ;EsF/mYM;IhFdF,iCAAA;ENgoYJ;EsFlnYM;IhFdF,gCAAA;ENmoYJ;EsFrnYM;IhFdF,8BAAA;ENsoYJ;EsFxnYM;IhFdF,gCAAA;ENyoYJ;EsF3nYM;IhFdF,8BAAA;EN4oYJ;EsF9nYM;IAUM,4BAAA;EtFunYZ;EsFjoYM;IAUM,kCAAA;EtF0nYZ;EsFpoYM;IAUM,iCAAA;EtF6nYZ;EsFvoYM;IAUM,+BAAA;EtFgoYZ;EsF1oYM;IAUM,iCAAA;EtFmoYZ;EsF7oYM;IAUM,+BAAA;EtFsoYZ;EsFhpYM;IhFdF,0BAAA;ENiqYJ;EsFnpYM;IhFdF,gCAAA;ENoqYJ;EsFtpYM;IhFdF,+BAAA;ENuqYJ;EsFzpYM;IhFdF,6BAAA;EN0qYJ;EsF5pYM;IhFdF,+BAAA;EN6qYJ;EsF/pYM;IhFdF,6BAAA;ENgrYJ;EsFlqYM;IAUM,iBAAA;EtF2pYZ;EsFrqYM;IAUM,uBAAA;EtF8pYZ;EsFxqYM;IAUM,sBAAA;EtFiqYZ;EsF3qYM;IAUM,oBAAA;EtFoqYZ;EsF9qYM;IAUM,sBAAA;EtFuqYZ;EsFjrYM;IAUM,oBAAA;EtF0qYZ;EsFprYM;IAUM,qBAAA;EtF6qYZ;EsFvrYM;IAUM,2BAAA;EtFgrYZ;EsF1rYM;IAUM,0BAAA;EtFmrYZ;EsF7rYM;IAUM,wBAAA;EtFsrYZ;EsFhsYM;IAUM,0BAAA;EtFyrYZ;EsFnsYM;IAUM,wBAAA;EtF4rYZ;EsFtsYM;IAUM,wBAAA;EtF+rYZ;EsFzsYM;IAUM,8BAAA;EtFksYZ;EsF5sYM;IAUM,6BAAA;EtFqsYZ;EsF/sYM;IAUM,2BAAA;EtFwsYZ;EsFltYM;IAUM,6BAAA;EtF2sYZ;EsFrtYM;IAUM,2BAAA;EtF8sYZ;EsFxtYM;IhFdF,2BAAA;ENyuYJ;EsF3tYM;IhFdF,4BAAA;EN4uYJ;EsF9tYM;IhFdF,6BAAA;EN+uYJ;AACF;AexuYI;EuEMI;IhFdF,sBAAA;ENovYJ;EsFtuYM;IhFdF,uBAAA;ENuvYJ;EsFzuYM;IhFdF,sBAAA;EN0vYJ;EsF5uYM;IAUM,8BAAA;EtFquYZ;EsF/uYM;IAUM,4BAAA;EtFwuYZ;EsFlvYM;IAUM,2BAAA;EtF2uYZ;EsFrvYM;IAUM,iCAAA;EtF8uYZ;EsFxvYM;IAUM,2BAAA;EtFivYZ;EsF3vYM;IAUM,0BAAA;EtFovYZ;EsF9vYM;IAUM,gCAAA;EtFuvYZ;EsFjwYM;IAUM,yBAAA;EtF0vYZ;EsFpwYM;IAUM,wBAAA;EtF6vYZ;EsFvwYM;IAUM,+BAAA;EtFgwYZ;EsF1wYM;IAUM,yBAAA;EtFmwYZ;EsF7wYM;IAUM,6BAAA;EtFswYZ;EsFhxYM;IAUM,8BAAA;EtFywYZ;EsFnxYM;IAUM,wBAAA;EtF4wYZ;EsFtxYM;IAUM,+BAAA;EtF+wYZ;EsFzxYM;IAUM,wBAAA;EtFkxYZ;EsF5xYM;IAUM,yBAAA;EtFqxYZ;EsF/xYM;IAUM,8BAAA;EtFwxYZ;EsFlyYM;IAUM,iCAAA;EtF2xYZ;EsFryYM;IAUM,sCAAA;EtF8xYZ;EsFxyYM;IAUM,yCAAA;EtFiyYZ;EsF3yYM;IAUM,uBAAA;EtFoyYZ;EsF9yYM;IAUM,uBAAA;EtFuyYZ;EsFjzYM;IAUM,yBAAA;EtF0yYZ;EsFpzYM;IAUM,yBAAA;EtF6yYZ;EsFvzYM;IAUM,0BAAA;EtFgzYZ;EsF1zYM;IAUM,4BAAA;EtFmzYZ;EsF7zYM;IAUM,kCAAA;EtFszYZ;EsFh0YM;IAUM,sCAAA;EtFyzYZ;EsFn0YM;IAUM,oCAAA;EtF4zYZ;EsFt0YM;IAUM,kCAAA;EtF+zYZ;EsFz0YM;IAUM,yCAAA;EtFk0YZ;EsF50YM;IAUM,wCAAA;EtFq0YZ;EsF/0YM;IAUM,wCAAA;EtFw0YZ;EsFl1YM;IAUM,kCAAA;EtF20YZ;EsFr1YM;IAUM,gCAAA;EtF80YZ;EsFx1YM;IAUM,8BAAA;EtFi1YZ;EsF31YM;IAUM,gCAAA;EtFo1YZ;EsF91YM;IAUM,+BAAA;EtFu1YZ;EsFj2YM;IAUM,oCAAA;EtF01YZ;EsFp2YM;IAUM,kCAAA;EtF61YZ;EsFv2YM;IAUM,gCAAA;EtFg2YZ;EsF12YM;IAUM,uCAAA;EtFm2YZ;EsF72YM;IAUM,sCAAA;EtFs2YZ;EsFh3YM;IAUM,iCAAA;EtFy2YZ;EsFn3YM;IAUM,2BAAA;EtF42YZ;EsFt3YM;IAUM,iCAAA;EtF+2YZ;EsFz3YM;IAUM,+BAAA;EtFk3YZ;EsF53YM;IAUM,6BAAA;EtFq3YZ;EsF/3YM;IAUM,+BAAA;EtFw3YZ;EsFl4YM;IAUM,8BAAA;EtF23YZ;EsFr4YM;IAUM,oBAAA;EtF83YZ;EsFx4YM;IAUM,mBAAA;EtFi4YZ;EsF34YM;IAUM,mBAAA;EtFo4YZ;EsF94YM;IAUM,mBAAA;EtFu4YZ;EsFj5YM;IAUM,mBAAA;EtF04YZ;EsFp5YM;IAUM,mBAAA;EtF64YZ;EsFv5YM;IAUM,mBAAA;EtFg5YZ;EsF15YM;IAUM,mBAAA;EtFm5YZ;EsF75YM;IAUM,oBAAA;EtFs5YZ;EsFh6YM;IAUM,0BAAA;EtFy5YZ;EsFn6YM;IAUM,yBAAA;EtF45YZ;EsFt6YM;IAUM,uBAAA;EtF+5YZ;EsFz6YM;IAUM,yBAAA;EtFk6YZ;EsF56YM;IAUM,uBAAA;EtFq6YZ;EsF/6YM;IAUM,uBAAA;EtFw6YZ;EsFl7YM;IAUM,0BAAA;IAAA,yBAAA;EtF46YZ;EsFt7YM;IAUM,gCAAA;IAAA,+BAAA;EtFg7YZ;EsF17YM;IAUM,+BAAA;IAAA,8BAAA;EtFo7YZ;EsF97YM;IAUM,6BAAA;IAAA,4BAAA;EtFw7YZ;EsFl8YM;IAUM,+BAAA;IAAA,8BAAA;EtF47YZ;EsFt8YM;IAUM,6BAAA;IAAA,4BAAA;EtFg8YZ;EsF18YM;IAUM,6BAAA;IAAA,4BAAA;EtFo8YZ;EsF98YM;IAUM,wBAAA;IAAA,2BAAA;EtFw8YZ;EsFl9YM;IAUM,8BAAA;IAAA,iCAAA;EtF48YZ;EsFt9YM;IAUM,6BAAA;IAAA,gCAAA;EtFg9YZ;EsF19YM;IAUM,2BAAA;IAAA,8BAAA;EtFo9YZ;EsF99YM;IAUM,6BAAA;IAAA,gCAAA;EtFw9YZ;EsFl+YM;IAUM,2BAAA;IAAA,8BAAA;EtF49YZ;EsFt+YM;IAUM,2BAAA;IAAA,8BAAA;EtFg+YZ;EsF1+YM;IAUM,wBAAA;EtFm+YZ;EsF7+YM;IAUM,8BAAA;EtFs+YZ;EsFh/YM;IAUM,6BAAA;EtFy+YZ;EsFn/YM;IAUM,2BAAA;EtF4+YZ;EsFt/YM;IAUM,6BAAA;EtF++YZ;EsFz/YM;IAUM,2BAAA;EtFk/YZ;EsF5/YM;IAUM,2BAAA;EtFq/YZ;EsF//YM;IhFdF,0BAAA;ENghZJ;EsFlgZM;IhFdF,gCAAA;ENmhZJ;EsFrgZM;IhFdF,+BAAA;ENshZJ;EsFxgZM;IhFdF,6BAAA;ENyhZJ;EsF3gZM;IhFdF,+BAAA;EN4hZJ;EsF9gZM;IhFdF,6BAAA;EN+hZJ;EsFjhZM;IhFdF,6BAAA;ENkiZJ;EsFphZM;IAUM,2BAAA;EtF6gZZ;EsFvhZM;IAUM,iCAAA;EtFghZZ;EsF1hZM;IAUM,gCAAA;EtFmhZZ;EsF7hZM;IAUM,8BAAA;EtFshZZ;EsFhiZM;IAUM,gCAAA;EtFyhZZ;EsFniZM;IAUM,8BAAA;EtF4hZZ;EsFtiZM;IAUM,8BAAA;EtF+hZZ;EsFziZM;IhFdF,yBAAA;EN0jZJ;EsF5iZM;IhFdF,+BAAA;EN6jZJ;EsF/iZM;IhFdF,8BAAA;ENgkZJ;EsFljZM;IhFdF,4BAAA;ENmkZJ;EsFrjZM;IhFdF,8BAAA;ENskZJ;EsFxjZM;IhFdF,4BAAA;ENykZJ;EsF3jZM;IhFdF,4BAAA;EN4kZJ;EsF9jZM;IAUM,qBAAA;EtFujZZ;EsFjkZM;IAUM,2BAAA;EtF0jZZ;EsFpkZM;IAUM,0BAAA;EtF6jZZ;EsFvkZM;IAUM,wBAAA;EtFgkZZ;EsF1kZM;IAUM,0BAAA;EtFmkZZ;EsF7kZM;IAUM,wBAAA;EtFskZZ;EsFhlZM;IAUM,2BAAA;IAAA,0BAAA;EtF0kZZ;EsFplZM;IAUM,iCAAA;IAAA,gCAAA;EtF8kZZ;EsFxlZM;IAUM,gCAAA;IAAA,+BAAA;EtFklZZ;EsF5lZM;IAUM,8BAAA;IAAA,6BAAA;EtFslZZ;EsFhmZM;IAUM,gCAAA;IAAA,+BAAA;EtF0lZZ;EsFpmZM;IAUM,8BAAA;IAAA,6BAAA;EtF8lZZ;EsFxmZM;IAUM,yBAAA;IAAA,4BAAA;EtFkmZZ;EsF5mZM;IAUM,+BAAA;IAAA,kCAAA;EtFsmZZ;EsFhnZM;IAUM,8BAAA;IAAA,iCAAA;EtF0mZZ;EsFpnZM;IAUM,4BAAA;IAAA,+BAAA;EtF8mZZ;EsFxnZM;IAUM,8BAAA;IAAA,iCAAA;EtFknZZ;EsF5nZM;IAUM,4BAAA;IAAA,+BAAA;EtFsnZZ;EsFhoZM;IAUM,yBAAA;EtFynZZ;EsFnoZM;IAUM,+BAAA;EtF4nZZ;EsFtoZM;IAUM,8BAAA;EtF+nZZ;EsFzoZM;IAUM,4BAAA;EtFkoZZ;EsF5oZM;IAUM,8BAAA;EtFqoZZ;EsF/oZM;IAUM,4BAAA;EtFwoZZ;EsFlpZM;IhFdF,2BAAA;ENmqZJ;EsFrpZM;IhFdF,iCAAA;ENsqZJ;EsFxpZM;IhFdF,gCAAA;ENyqZJ;EsF3pZM;IhFdF,8BAAA;EN4qZJ;EsF9pZM;IhFdF,gCAAA;EN+qZJ;EsFjqZM;IhFdF,8BAAA;ENkrZJ;EsFpqZM;IAUM,4BAAA;EtF6pZZ;EsFvqZM;IAUM,kCAAA;EtFgqZZ;EsF1qZM;IAUM,iCAAA;EtFmqZZ;EsF7qZM;IAUM,+BAAA;EtFsqZZ;EsFhrZM;IAUM,iCAAA;EtFyqZZ;EsFnrZM;IAUM,+BAAA;EtF4qZZ;EsFtrZM;IhFdF,0BAAA;ENusZJ;EsFzrZM;IhFdF,gCAAA;EN0sZJ;EsF5rZM;IhFdF,+BAAA;EN6sZJ;EsF/rZM;IhFdF,6BAAA;ENgtZJ;EsFlsZM;IhFdF,+BAAA;ENmtZJ;EsFrsZM;IhFdF,6BAAA;ENstZJ;EsFxsZM;IAUM,iBAAA;EtFisZZ;EsF3sZM;IAUM,uBAAA;EtFosZZ;EsF9sZM;IAUM,sBAAA;EtFusZZ;EsFjtZM;IAUM,oBAAA;EtF0sZZ;EsFptZM;IAUM,sBAAA;EtF6sZZ;EsFvtZM;IAUM,oBAAA;EtFgtZZ;EsF1tZM;IAUM,qBAAA;EtFmtZZ;EsF7tZM;IAUM,2BAAA;EtFstZZ;EsFhuZM;IAUM,0BAAA;EtFytZZ;EsFnuZM;IAUM,wBAAA;EtF4tZZ;EsFtuZM;IAUM,0BAAA;EtF+tZZ;EsFzuZM;IAUM,wBAAA;EtFkuZZ;EsF5uZM;IAUM,wBAAA;EtFquZZ;EsF/uZM;IAUM,8BAAA;EtFwuZZ;EsFlvZM;IAUM,6BAAA;EtF2uZZ;EsFrvZM;IAUM,2BAAA;EtF8uZZ;EsFxvZM;IAUM,6BAAA;EtFivZZ;EsF3vZM;IAUM,2BAAA;EtFovZZ;EsF9vZM;IhFdF,2BAAA;EN+wZJ;EsFjwZM;IhFdF,4BAAA;ENkxZJ;EsFpwZM;IhFdF,6BAAA;ENqxZJ;AACF;AuF1zZA;EDkDQ;IAUM,4BAAA;EtFkwZZ;EsF5wZM;IAUM,0BAAA;EtFqwZZ;EsF/wZM;IAUM,6BAAA;EtFwwZZ;EsFlxZM;IAUM,4BAAA;EtF2wZZ;AACF;AuFrzZA;ED+BQ;IAUM,0BAAA;EtFgxZZ;EsF1xZM;IAUM,gCAAA;EtFmxZZ;EsF7xZM;IAUM,yBAAA;EtFsxZZ;EsFhyZM;IAUM,wBAAA;EtFyxZZ;EsFnyZM;IAUM,+BAAA;EtF4xZZ;EsFtyZM;IAUM,yBAAA;EtF+xZZ;EsFzyZM;IAUM,6BAAA;EtFkyZZ;EsF5yZM;IAUM,8BAAA;EtFqyZZ;EsF/yZM;IAUM,wBAAA;EtFwyZZ;EsFlzZM;IAUM,+BAAA;EtF2yZZ;EsFrzZM;IAUM,wBAAA;EtF8yZZ;AACF;AwF93ZA;;;;;;EAAA;ACEA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;EACA,8BAAA;EACA,UAAA;ElEOI,0BkENJ;EACA,6BAAA;ElFQE,uBAAA;AP83ZJ;AuB73ZM;EkElBN;IlEmBQ,gBAAA;EvBg4ZN;AACF;;AyFv4ZA;EACE,qBAAA;AzF04ZF;;AyFv4ZA;EACE,mBpFqoB4B;EoFpoB5B,gBpF4oB4B;AL8vY9B;;AyFv4ZA;EACE,mBAAA;EACA,mBpF+nB4B;EoF9nB5B,mBAAA;AzF04ZF;;A0Fn6ZI;EACE,2CAAA;EACA,yEAAA;A1Fs6ZN;;A0Fx6ZI;EACE,yBAAA;EACA,0EAAA;A1F26ZN;;A0F76ZI;EACE,yBAAA;EACA,wEAAA;A1Fg7ZN;;A0Fl7ZI;EACE,yBAAA;EACA,yEAAA;A1Fq7ZN;;A0Fv7ZI;EACE,wCAAA;EACA,yEAAA;A1F07ZN;;A0F57ZI;EACE,yBAAA;EACA,wEAAA;A1F+7ZN;;A0Fj8ZI;EACE,wCAAA;EACA,0EAAA;A1Fo8ZN;;A0Ft8ZI;EACE,2CAAA;EACA,wEAAA;A1Fy8ZN;;A2F78ZA;EACE,WAAA;ErFsDI,gDAAA;EqFpDJ,iBAAA;EpEaI,yBoEZJ;A3Fg9ZF;AuBh8ZM;EoEpBN;IpEqBQ,gBAAA;EvBm8ZN;AACF;;A4Fx9ZA,cAAA;AACA,eAAA;AACA,QAAA;AACA,cAAA;AACA,YAAA;AACA,wBAAA;AACA;;;;;;CAAA;AAOA;;;;;CAAA;AAkBA;EACI,oBAAA;EACA,gEAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;A5F+8ZJ;A4F58ZA;EACE,oBAAA;EACA,gEAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;A5F88ZF;A4F38ZA;EACI,mBAAA;EAEA,eAAA;A5F48ZJ;;A4Fv8ZI;EACI,wBAAA;A5F08ZR;;A4Fr8ZA;EAEI;;;;;;;;;gBAAA;EAUA,0GAAA;EACA,gCAAA;EACA,8BAAA;EACA,0CAAA;EACA,mCAAA;EACA,mCAAA;EACA,2BAAA;EACA,+BAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,+BAAA;A5Fu8ZJ;;A4Fp8ZA;EACI,yBAAA;EACA,uDAAA;EACA,qBAAA;EACA,6DAAA;EACA,UAAA;A5Fu8ZJ;;A4F96ZA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;A5Fi7ZJ;;A4F96ZA;EACI,yBAAA;EACA,YAAA;EACA,WAAA;A5Fi7ZJ;;A4F76ZA;;EAEI,aAAA;A5Fg7ZJ;;A4F76ZA,oDAAA;AAGA;EAEI,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,qCAAA;A5F86ZJ;;A4F36ZA;EAEI,gBAAA;EACA,wBAAA;A5F86ZJ;;A4F16ZA;EACI,YAAA;EACA,kBAAA;A5F66ZJ;A4F16ZQ;EACI,qBAAA;EACA,iBAAA;A5F46ZZ;A4Fz6ZQ;EACI,+BAAA;EACA,UAAA;A5F26ZZ;A4Fz6ZY;EACI,iBAAA;EACA,YAAA;A5F26ZhB;A4Fx6ZY;EACI,qBAAA;A5F06ZhB;A4Fv6ZY;EACI,UAAA;A5Fy6ZhB;A4Fp6ZI;EACI,gBAAA;EACA,YAAA;A5Fs6ZR;A4Fn6ZY;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,+BAAA;EACA,qBAAA;A5Fq6ZhB;;A4F/5ZA;EACI,4BAAA;EACA,sBAAA;EACA,8CAAA;EACA,sCAAA;EACA,wEAAA;EACA,sBAAA;EACA,8CAAA;EACA,6BAAA;EACA,wDAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;A5Fk6ZJ;;A4F/5ZA;+CAAA;AAEA;EACI;IACI,cAAA;IACA,UAAA;IACA,WAAA;IACA,kBAAA;IACA,WAAA;E5Fk6ZN;E4F/5ZE;IACI,SAAA;E5Fi6ZN;E4F95ZE,wCAAA;EACA,mBAAA;EACA;;IAEI,aAAA;E5Fg6ZN;E4F75ZE,6BAAA;EACA;IACI,cAAA;IACA,yBAAA;IACA,kBAAA;IACA,cAAA;IACA,eAAA;IACA,qBAAA;IACA,YAAA;E5F+5ZN;E4F55ZE;IACI,yBAAA;E5F85ZN;E4F35ZE,kDAAA;EACA;IACI,cAAA;IACA,6BAAA;E5F65ZN;E4F15ZE,qCAAA;EACA;IACI,cAAA;IACA,WAAA;E5F45ZN;E4Fz5ZE;;IAEI,eAAA;E5F25ZN;E4Fx5ZE;IACI,eAAA;E5F05ZN;E4Fv5ZE;;IAEI,yBAAA;E5Fy5ZN;E4Ft5ZE;;;IAGI,kBAAA;IACA,cAAA;IACA,eAAA;E5Fw5ZN;E4Fr5ZE,8BAAA;EACA;IACI,WAAA;IACA,gBAAA;IACA,cAAA;IACA,8DAAA;E5Fu5ZN;E4Fp5ZE,wBAAA;EACA;;IAEI,aAAA;E5Fs5ZN;E4Fn5ZE,wBAAA;EACA;IACI,cAAA;IACA,WAAA;E5Fq5ZN;E4Fl5ZE;IACI,gBAAA;IACA,+DAAA;E5Fo5ZN;AACF;A4Fj5ZA;EACI;IACI,cAAA;IACA,UAAA;E5Fm5ZN;AACF;A4Fh5ZA;EACI,cAAA;A5Fk5ZJ;;A4F/4ZA;EACI,cAAA;A5Fk5ZJ;;A4F/4ZA,aAAA;AACA;EACI,qBAAA;EACA,kBAAA;A5Fk5ZJ;;A4F/4ZA;EACI,qBAAA;EACA,yBAAA;EACA,0BAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;A5Fk5ZJ;;A4F/4ZA;EACI,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;A5Fk5ZJ;;A4F/4ZA;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;A5Fk5ZJ;;A4F/4ZA;EACI,aAAA;A5Fk5ZJ;;A4F/4ZA;EACI,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,mDAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,QAAA;A5Fk5ZJ;;A4F/4ZA;EACI,aAAA;A5Fk5ZJ;;A4F/4ZA;EACI,cAAA;A5Fk5ZJ;;A4F/4ZA;EACI,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;A5Fk5ZJ;;A4F/4ZA;EACI,cAAA;EACA,mBAAA;EACA,kBAAA;A5Fk5ZJ;;A4F/4ZA;EACI,UAAA;EACA,gCAAA;A5Fk5ZJ;;A4F/4ZA,wFAAA;AACA;;;EAGI,sBAAA;A5Fk5ZJ;;A4F74ZA;EACI,cAAA;EACA,qBAAA;EACA,6BAAA;A5Fg5ZJ;;A4F74ZA;EACI,kBAAA;A5Fg5ZJ;;A4F74ZE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;A5Fg5ZJ;;A4F74ZE;EACE,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;A5Fg5ZJ;;A4F74ZE;EACE;IAAK,6CAAA;E5Fi5ZP;E4Fh5ZE;IAAO,+CAAA;E5Fm5ZT;AACF;A4F94ZA;EACI,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;A5Fg5ZJ;;A4F74ZA;EACI;IACI,iBAAA;E5Fg5ZN;AACF;A4F74ZA;EACI;IACI,iBAAA;E5F+4ZN;AACF;A4F54ZA;EACI;IACI,gBAAA;E5F84ZN;AACF;A4F34ZA;EACI;IACI,gBAAA;E5F64ZN;AACF;A4F14ZA;EACI;IACI,gBAAA;E5F44ZN;AACF;A4Fz4ZA;EACI,yBAAA;A5F24ZJ;;A4Fx4ZA;EACI,oBAAA;A5F24ZJ;;A4Fx4ZA;EACI,mBAAA;A5F24ZJ;;A4Fx4ZA;EACI,mBAAA;EACA,YAAA;A5F24ZJ;;A4Fx4ZA;EACI,oBAAA;EACA,eAAA;A5F24ZJ;;A4Fx4ZA;EACI,cAAA;A5F24ZJ;;A4Fx4ZA;EACI,oBAAA;EACA,eAAA;A5F24ZJ;;A4Fx4ZA;EACI,WAAA;A5F24ZJ;;A4Fx4ZA;EACI,kBAAA;A5F24ZJ;;A4Fx4ZA;;EAEI,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mDAAA;A5F24ZJ;;A4Fx4ZA;;EAEI,oBAAA;A5F24ZJ;;A4Fx4ZA;;EAEI,mBAAA;A5F24ZJ;;A4Fx4ZA;;;EAEI,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;A5F44ZJ;;A4Fz4ZA;;EAEI,cAAA;A5F44ZJ;;A4Fz4ZA;;EAEI,iBAAA;EACA,cAAA;EACA,kBAAA;A5F44ZJ;;A4Fz4ZA;;EAEI,eAAA;A5F44ZJ;;A4Fz4ZA;;EAII,kBAAA;EACA,6BAAA;EACA,aAAA;EAGA,yBAAA;EACA,oBAAA;A5F44ZJ;;A4Fz4ZA;;EAEI,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;A5F44ZJ;;A4Fz4ZA;;;;;;EAMI,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,2DAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,uBAAA;A5F44ZJ;;A4Fz4ZA;;EAEI,mBAAA;EACA,yBAAA;EACA,cAAA;EAKA,kCAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;A5Fo4ZJ;;A4Fj4ZA;;EAEI,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;A5F44ZJ;;A4Fz4ZA;;;;;;EAMI,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,2DAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,uBAAA;A5F44ZJ;;A4Fz4ZA;;EAEI,mBAAA;EACA,yBAAA;EACA,cAAA;EAKA,oCAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;A5Fo4ZJ;;A4Fj4ZA;;EAEI,sBAAA;EACA,+GAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;A5F44ZJ;;A4Fz4ZA;;;;;;EAMI,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,2DAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,uBAAA;A5F44ZJ;;A4Fz4ZA;;EAEI,mBAAA;EACA,yBAAA;EACA,cAAA;A5F44ZJ;;A4Fz4ZA;;;;EAII,qHAAA;A5F44ZJ;;A4Fz4ZA;;EAEI,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;A5F44ZJ;;A4Fz4ZA;;;;;;EAMI,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,2DAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,uBAAA;A5F44ZJ;;A4Fz4ZA;;EAEI,mBAAA;EACA,yBAAA;EACA,cAAA;EAKA,kCAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;A5Fo4ZJ;;A4Fj4ZA;;EAEI,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;A5F44ZJ;;A4Fz4ZA;;;;;;EAMI,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,2DAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,uBAAA;A5F44ZJ;;A4Fz4ZA;;EAEI,mBAAA;EACA,yBAAA;EACA,cAAA;EAKA,oCAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;A5Fo4ZJ;;A4Fj4ZA;;EAEI,aAAA;EACA,8BAAA;EACA,mBAAA;A5F44ZJ;;A4Fz4ZA;;EAEI,cAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;A5F44ZJ;;A4Fz4ZA;;EAEI,cAAA;EACA,0BAAA;EACA,eAAA;A5F44ZJ;;A4Fz4ZA;;EAEI,gBAAA;A5F44ZJ;;A4Fz4ZA;;EAEI,wCAAA;A5F44ZJ;;A4Fz4ZA;EACI,gBAAA;A5F44ZJ;;A4Fz4ZA;EACI,YAAA;A5F44ZJ;;A4Fz4ZA;EACI,UAAA;A5F44ZJ;;A4Fz4ZA;EACI,UAAA;A5F44ZJ;;A4Fz4ZA;EACI,UAAA;A5F44ZJ;;A4Fz4ZA;EACI,aAAA;EAGA,yBAAA;EACA,eAAA;A5F44ZJ;;A4Fz4ZA;EACI,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;A5F44ZJ;;A4Fz4ZA;;;EAGI,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,2DAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,uBAAA;A5F44ZJ;;A4Fz4ZA;EACI,mBAAA;EACA,yBAAA;EACA,cAAA;EAIA,kCAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;A5Fq4ZJ;;A4Fl4ZA;EACI,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;A5F44ZJ;;A4Fz4ZA;;;EAGI,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,2DAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,uBAAA;A5F44ZJ;;A4Fz4ZA;EACI,mBAAA;EACA,yBAAA;EACA,cAAA;EAIA,oCAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;A5Fq4ZJ;;A4Fl4ZA;EACI,sBAAA;EACA,+GAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;A5F44ZJ;;A4Fz4ZA;;;EAGI,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,2DAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,uBAAA;A5F44ZJ;;A4Fz4ZA;EACI,mBAAA;EACA,yBAAA;EACA,cAAA;A5F44ZJ;;A4Fz4ZA;;EAEI,qHAAA;A5F44ZJ;;A4Fz4ZA;EACI,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;A5F44ZJ;;A4Fz4ZA;;;EAGI,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,2DAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,uBAAA;A5F44ZJ;;A4Fz4ZA;EACI,mBAAA;EACA,yBAAA;EACA,cAAA;EAIA,kCAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;A5Fq4ZJ;;A4Fl4ZA;EACI,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;A5F44ZJ;;A4Fz4ZA;;;EAGI,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,2DAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,uBAAA;A5F44ZJ;;A4Fz4ZA;EACI,mBAAA;EACA,yBAAA;EACA,cAAA;EAIA,oCAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;A5Fq4ZJ;;A4Fl4ZA;EACI,gBAAA;A5F44ZJ;;A4Fz4ZA;EACI,UAAA;A5F44ZJ;;A4Fz4ZA;EACI,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;A5F44ZJ;;A4Fz4ZA;EACI,gBAAA;A5F44ZJ;;A4Fz4ZA;EACI;IACI,iBAAA;E5F44ZN;E4Fv4ZE;IACI,aAAA;E5F24ZN;AAJF;A4Fn4ZA;EACI,+BAAA;A5F04ZJ;;A4Fv4ZA;EACI,SAAA;EACA,UAAA;EACA,gBAAA;A5F04ZJ;;A4Fv4ZA;EACI,cAAA;EACA,kBAAA;A5F04ZJ;;A4Fv4ZA;EACI,SAAA;A5F04ZJ;;A4Fv4ZA;EACI,yBAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;A5F04ZJ;;A4Fv4ZA;EACI,aAAA;A5F04ZJ;;A4Fv4ZA;EACI,aAAA;A5F04ZJ;;A4Fv4ZA;EACI,yBAAA;A5F04ZJ;;A4Fv4ZA;EACI,yBAAA;EACA,UAAA;A5F04ZJ;;A4Fv4ZA;EACI,qBAAA;EACA,yBAAA;EACA,UAAA;A5F04ZJ;;A4Fv4ZA;;EAEI,UAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;A5F04ZJ;;A4Fv4ZA;EACI,aAAA;A5F04ZJ;;A4Fv4ZA;EACI,cAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;A5F04ZJ;;A4Fv4ZA;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;A5F04ZJ;;A4Fv4ZA;EACI,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;A5F04ZJ;;A4Fv4ZA;;EAEI,qBAAA;A5F04ZJ;;A4Fv4ZA;EACI,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;A5F04ZJ;;A4Fv4ZA;EACI,cAAA;A5F04ZJ;;A4Fv4ZA;EACI,cAAA;A5F04ZJ;;A4Fv4ZA;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;A5F04ZJ;;A4Fv4ZA;EACI,8BAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;A5F04ZJ;;A4Fv4ZA;EACI,kCAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;A5F04ZJ;;A4Fv4ZA;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;A5F04ZJ;;A4Fv4ZA;EACI,aAAA;A5F04ZJ;;A4Fv4ZA;EACI,WAAA;EACA,8BAAA;EACA,yBAAA;A5F04ZJ;;A4Fv4ZA;EACI,WAAA;EACA,8BAAA;A5F04ZJ;;A4Fv4ZA;EACI,6BAAA;A5F04ZJ;;A4Fv4ZA;EACI,WAAA;A5F04ZJ;;A4Fv4ZA;EACI,eAAA;A5F04ZJ;;A4Fv4ZA;EACI,mBAAA;EACA,qBAAA;A5F04ZJ;;A4Fv4ZA;EACI,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,YAAA;A5F04ZJ;;A4Fv4ZA;EACI,WAAA;A5F04ZJ;;A4Fr4ZA;EACI,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;A5Fw4ZJ;;A4Fr4ZA;EACI,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;A5Fw4ZJ;;A4Fr4ZA;;0CAAA;AAGA;EACI,kBAAA;EACA,qBAAA;A5Fw4ZJ;;A4Fr4ZA;EACI,WAAA;EACA,oBAAA;EACA,2BAAA;A5Fw4ZJ;A4Ft4ZI;EACI,eAAA;A5Fw4ZR;;A4Fp4ZA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;A5Fu4ZJ;;A4Fp4ZA;EACI,gBAAA;EACA,WAAA;EACA,eAAA;EACA,wBAAA;A5Fu4ZJ;;A4Fp4ZA;EACI,qBAAA;EACA,0BAAA;EACA,cAAA;EACA,wBAAA;EACA,wBAAA;EACA,4BAAA;EACA,iDAAA;A5Fu4ZJ;;A4Fp4ZA;EACI,qBAAA;A5Fu4ZJ;;A4Fj4ZA;EACI,4BAAA;A5Fo4ZJ;;A4Fj4ZA;EACI,WAAA;A5Fo4ZJ;;A4Fj4ZA;EACI,gBAAA;EACA,eAAA;EAEA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;A5Fm4ZJ;;A4Fp3ZA;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;A5Fu3ZF;;A4Fp3ZA;EACE,WAAA;EACA,YAAA;A5Fu3ZF;;A4Fr3ZA,YAAA;AACA;EACE;IACE,YAAA;E5Fw3ZF;AACF;A4Fr3ZA;EAGI,iBAAA;A5Fq3ZJ;AepwcI;E6E44CJ;IAOQ,YAAA;E5Fq3ZN;AACF;AezwcI;E6E44CJ;IAWQ,YAAA;E5Fs3ZN;AACF;;A4Fj3ZA;EAEI,aAAA;A5Fm3ZJ;AelxcI;E6E65CJ;IAMQ,aAAA;E5Fm3ZN;AACF;AevxcI;E6E65CJ;IAUQ,aAAA;E5Fo3ZN;AACF;;A4F/2ZA;EACE,6BAAA;A5Fk3ZF;;A4F52ZA;EACI,sBAAA;A5F+2ZJ;;A4F52ZA;EACI,UAAA;A5F+2ZJ;;A4F52ZA;EACI,UAAA;A5F+2ZJ;;A4F52ZA;EACI,0DAAA;EACA,WAAA;A5F+2ZJ;;A4F52ZA;EAEI,mBAAA;A5F82ZJ;;A4F32ZA;EACI,yBjEtgDM;EiEugDN,WAAA;A5F82ZJ;;A4F32ZA;EACI,yBvFt6CW;EuFu6CP,WAAA;A5F82ZR;;A4F32ZA;EACI,yBvFh7CY;EuFi7CR,WAAA;A5F82ZR;;A4F32ZA;EACI,sBvF17CS;EuF27CL,WAAA;A5F82ZR;;A4F32ZA;EACI,yBvFphDQ;EuFqhDJ,WAAA;A5F82ZR;;A4F32ZA;EACI,yBvFz8CY;EuF08CR,WAAA;A5F82ZR;;A4F32ZA;EACI,eAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;A5F82ZJ;;A4F32ZA;EACI,qBAAA;A5F82ZJ;;A4F32ZA;EAEI,yBjEpjDc;EiEqjDd,0EAAA;A5F62ZJ;;A4F12ZA;EACI,cAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;A5F62ZJ;;A4F12ZA;EACI,wBAAA;A5F62ZJ;;A4F12ZA;EACI,YAAA;EACA,wCAAA;EACA,YAAA;EACA,iEAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;EACA,0BAAA;A5F62ZJ;;A4F12ZA;;EAEI,0DAAA;A5F62ZJ;;A4F12ZA;EACI,sCAAA;A5F62ZJ;;A4F12ZA;;EAEI,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,4BAAA;A5F62ZJ;;A4F12ZA;EACI,qBAAA;EACA,UAAA;EACA,qBAAA;A5F62ZJ;;A4F12ZA;EACI,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;A5F62ZJ;;A4F12ZA;EACI,SAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;A5F62ZJ;;A4F12ZA;;EAEI,cAAA;A5F62ZJ;;A4F12ZA;EACI,qBAAA;EACA,UAAA;EACA,qBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBAAA;EAGA,kCAAA;EACA,mCAAA;EAEA,2BAAA;A5F22ZJ;;A4Fx2ZA;EACI,aAAA;A5F22ZJ;;A4Fx2ZA;;0CAAA;AAIA;EACI,YAAA;A5F02ZJ;;A4Fn2ZA;EACI,WAAA;EACA,yBAAA;EACA,iBAAA;A5Fs2ZJ;;A4Fn2ZA;EACI,iBAAA;A5Fs2ZJ;;Aen9cI;E6EinDA;IACI,iBAAA;E5Fs2ZN;AACF;A4Fn2ZA;EACI,aAAA;A5Fq2ZJ;;A4Fj2ZA;EACI,aAAA;EACA,yDAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;A5Fo2ZJ;;A4Fj2ZA;EACI,aAAA;A5Fo2ZJ;;A4Fj2ZA;EACI,YAAA;EACA,wBAAA;EACA,WAAA;EACA,eAAA;A5Fo2ZJ;;A4Fj2ZA;EACI,YAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;A5Fo2ZJ;;A4Fj2ZA;EACI,eAAA;A5Fo2ZJ;;A4Fj2ZA;EACI,yBAAA;A5Fo2ZJ;;A4Fj2ZA;EACI,eAAA;A5Fo2ZJ;;A4Fj2ZA;EACI,cAAA;A5Fo2ZJ;;A4Fj2ZA;EACI,eAAA;A5Fo2ZJ;;A4Fj2ZA;EACI,eAAA;A5Fo2ZJ;;A4Fj2ZA;EACI,eAAA;A5Fo2ZJ;;A4Fj2ZA;EACI,WAAA;EACA,mBAAA;A5Fo2ZJ;;A4Fj2ZA;EACI,gBAAA;EACA,sBAAA;EACA,sBAAA;A5Fo2ZJ;;A4Fj2ZA;;KAAA;AAIA;EACI,YAAA;A5Fm2ZJ;;A4Fh2ZA;EACI,eAAA;EACA,oBAAA;A5Fm2ZJ;;A4Fh2ZA;EACI,mBAAA;A5Fm2ZJ;;A4Fh2ZA;EACI,wBAAA;A5Fm2ZJ;;A4Fh2ZA;EACI,mBAAA;A5Fm2ZJ;;A4F91ZA;EACI,iBAAA;A5Fi2ZJ;;A4F91ZA;EACI;IACI,wBAAA;E5Fi2ZN;E4F91ZE;IACI,wBAAA;E5Fg2ZN;E4F71ZE;IACI,yBAAA;E5F+1ZN;AACF;A4F51ZA;EACI,gBAAA;A5F81ZJ;;A4F31ZA;EACI,mBAAA;EACA,aAAA;EACA,eAAA;EACA,2BAAA;EACA,WAAA;A5F81ZJ;;A4F31ZA;EACI,qBAAA;A5F81ZJ;;A4F31ZA;EACI,oBAAA;A5F81ZJ;;A4F31ZA;EACI,0BAAA;A5F81ZJ;;A4F31ZA;EACI,mBAAA;A5F81ZJ;;A4F31ZA;EACI,eAAA;A5F81ZJ;;A4F31ZA;EACI,kBAAA;A5F81ZJ;;A4F31ZA;EACI,uBAAA;A5F81ZJ;;A4F31ZA;EACI,qBAAA;EACA,oBAAA;A5F81ZJ;;A4F31ZA;EACI,yBAAA;A5F81ZJ;;A4F31ZA;EACI,mBAAA;A5F81ZJ;;A4F31ZA;EACI,eAAA;A5F81ZJ;;A4F31ZA;EACI,eAAA;A5F81ZJ;;A4F31ZA;EACI,cAAA;EACA,yBAAA;EACA,4BAAA;A5F81ZJ;;A4F31ZA;EACI,0BAAA;EACA,6BAAA;A5F81ZJ;;A4F31ZA;EACI,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;A5F81ZJ;;A4F31ZA;EACI,oBAAA;EACA,uBAAA;A5F81ZJ;;A4F31ZA;EACI,sBAAA;EACA,cAAA;A5F81ZJ;;A4F31ZA;EACI,yBAAA;EACA,WAAA;A5F81ZJ;;A4F31ZA;EACI,yBAAA;EACA,yBAAA;A5F81ZJ;;A4F31ZA;EACI,yBAAA;EACA,WAAA;A5F81ZJ;;A4F31ZA;EACI,mBAAA;EACA,gFAAA;EACA,WAAA;A5F81ZJ;;A4F51ZA;EACI,mBAAA;EACA,gFAAA;EACA,WAAA;A5F+1ZJ;;A4F71ZA;EACI,mBAAA;EACA,gFAAA;EACA,WAAA;A5Fg2ZJ;;A4F71ZA;EACI,mBAAA;EACA,+EAAA;EACA,WAAA;A5Fg2ZJ;;A4F71ZA;EACI,gDAAA;A5Fg2ZJ;;AensdI;E6Eu2DA;IACI,aAAA;E5Fg2ZN;AACF;A4F71ZA;EACI,2BAAA;EACA,mCAAA;EACA,UAAA;EACA,SAAA;EACA,4BAAA;A5F+1ZJ;;A4F31ZA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,sBAAA;A5F81ZJ;;A4F31ZA;EACI;IACI,yBAAA;E5F81ZN;AACF;A4F31ZA;EACI,qEAAA;A5F61ZJ;;A4F31ZA;EACI,qEAAA;A5F81ZJ;;A4F51ZA;EACI,kEAAA;A5F+1ZJ;;A4F71ZA;EACI,qEAAA;A5Fg2ZJ;;A4F51ZA;EACI,uBAAA;A5F+1ZJ;;A4F51ZA;EAEI,eAAA;A5F+1ZJ;;A4F71ZA;EAGI,aAAA;EAGA,2BAAA;A5Fg2ZJ;;A6Fz0dA;;;;;;EAAA;AAOA;EACI,sBAAA;EACA,mBAAA;EACA,mBAAA;A7F40dJ;;A6Fx0dA;EAEI,sBAAA;EAEA,2CAAA;EAEA,yBAAA;A7F20dJ;;A6Fx0dA;EAEI,mCAAA;A7F20dJ;;A6Fx0dA;EAEI,4BAAA;EAEA,gDAAA;A7F20dJ;;A6Fx0dA;EAEI,4BAAA;EAEA,0DAAA;A7F20dJ;;A6Fx0dA;EAEI,4BAAA;EAEA,0DAAA;A7F20dJ;;A6Fx0dA;EAEI,mBAAA;EAEA,qCAAA;A7F20dJ;;A6Fx0dA;EAEI,mBAAA;EAEA,+CAAA;A7F20dJ;;A6Fx0dA;EAEI,mBAAA;EAEA,+CAAA;A7F20dJ;;A6Fx0dA;EAEI,mBAAA;EAEA,+CAAA;A7F20dJ;;A6Fx0dA;EAEI,mBAAA;EAEA,+CAAA;A7F20dJ;;A6Fx0dA;EAEI,wBAAA;EAEA,qDAAA;A7F20dJ;;A6Fx0dA;EAEI,wBAAA;EAEA,uDAAA;A7F20dJ;;A6Fx0dA;EAEI,sBAAA;EAEA,qDAAA;A7F20dJ;;A6Fx0dA;EAEI,sBAAA;EAEA,qDAAA;A7F20dJ;;A6Fx0dA;EAEI;IAEI,kCAAA;IAEA,mCAAA;IAEA,uCAAA;E7F00dN;E6Fv0dE;IACI,UAAA;E7Fy0dN;AACF;A6Ft0dA,uBAAA;AAyCA;EAEI;IAKI,8DAAA;IAEA,+BAAA;E7F0zdN;E6FvzdE;IAGI,iEAAA;IAEA,+CAAA;E7FwzdN;E6FrzdE;IAEI,iEAAA;IAEA,gDAAA;E7FuzdN;E6FpzdE;IAEI,+DAAA;IAEA,4CAAA;E7FszdN;E6FnzdE;IAEI,+CAAA;E7FqzdN;AACF;A6FlzdA;EAEI,sBAAA;EAEA,+BAAA;A7FozdJ;A6FnydA;EAEI;IAGI,UAAA;E7F2ydN;E6FxydE;IAEI,UAAA;E7FyydN;AACF;A6FtydA;EAEI,qBAAA;A7FwydJ;;A6FrydA,6EAAA;AAkBA;EACI;IAEI,2BAAA;E7FqydN;E6FlydE;IAEI,oCAAA;E7FoydN;E6FjydE;IAEI,2BAAA;E7FmydN;AACF;A6FhydA;EAEI,qBAAA;EAEA,sCAAA;A7FkydJ;A6F1vdA;EACI;IAEI,2BAAA;E7F2xdN;E6FxxdE;IAEI,iCAAA;E7F0xdN;E6FvxdE;IAEI,iCAAA;E7FyxdN;E6FtxdE;IAEI,iCAAA;E7FwxdN;E6FrxdE;IAEI,iCAAA;E7FuxdN;E6FpxdE;IAEI,iCAAA;E7FsxdN;E6FnxdE;IAEI,2BAAA;E7FqxdN;AACF;A6FlxdA;EAEI,0BAAA;A7FoxdJ;A6FvvdA;EAEI;IAGI,+BAAA;E7FswdN;E6FnwdE;IAMI,mCAAA;E7FiwdN;E6F9vdE;IAKI,kCAAA;E7F6vdN;AACF;A6F1vdA;EAEI,sBAAA;A7F4vdJ;A6F/tdA;EAEI;IAGI,+BAAA;E7F8udN;E6F3udE;IAMI,mCAAA;E7FyudN;E6FtudE;IAKI,kCAAA;E7FqudN;AACF;A6FludA;EAEI,sBAAA;A7FoudJ;A6FjsdA;EACI;IAEI,wBAAA;E7F8tdN;E6F3tdE;IAEI,0CAAA;E7F6tdN;E6F1tdE;IAEI,wCAAA;E7F4tdN;E6FztdE;IAEI,0CAAA;E7F2tdN;E6FxtdE;IAEI,wCAAA;E7F0tdN;E6FvtdE;IAEI,wBAAA;E7FytdN;AACF;A6FttdA;EAEI,sCAAA;EAEA,yBAAA;A7FwtdJ;A6F1rdA;EACI;IAEI,mCAAA;E7FmtdN;E6FhtdE;IAEI,oCAAA;E7FktdN;E6F/sdE;IAEI,kCAAA;E7FitdN;E6F9sdE;IAEI,mCAAA;E7FgtdN;E6F7sdE;IAEI,kCAAA;E7F+sdN;AACF;A6F5sdA;EAEI,4BAAA;EAEA,qBAAA;A7F8sdJ;A6F1qdA;EACI;IAEI,2BAAA;E7FmsdN;E6FhsdE;IAGI,0DAAA;E7FisdN;E6F9rdE;IAKI,yDAAA;E7F6rdN;E6F1rdE;IAII,0DAAA;E7F0rdN;E6FvrdE;IAEI,2BAAA;E7FyrdN;AACF;A6FtrdA;EAEI,oBAAA;A7FwrdJ;;A6FrrdA,6EAAA;AAsCA;EACI;IAEI,+BAAA;E7FirdN;E6F9qdE;IAEI,2DAAA;E7FgrdN;E6F7qdE;IAEI,yDAAA;E7F+qdN;E6F5qdE;IAEI,2DAAA;E7F8qdN;E6F3qdE;IAEI,yDAAA;E7F6qdN;E6F1qdE;IAEI,0DAAA;E7F4qdN;E6FzqdE;IAEI,+BAAA;E7F2qdN;AACF;A6FxqdA;EAEI,sBAAA;A7F0qdJ;A6F1ndA;EAEI;IAII,+BAAA;E7F4pdN;E6FzpdE;IAEI,0CAAA;E7F2pdN;E6FxpdE;IAEI,wCAAA;E7F0pdN;E6FvpdE;IAEI,4CAAA;E7FypdN;E6FtpdE;IAEI,4CAAA;E7FwpdN;E6FrpdE;IAEI,gDAAA;E7FupdN;E6FppdE;IAEI,gDAAA;E7FspdN;E6FnpdE;IAEI,oDAAA;E7FqpdN;AACF;A6FlpdA;EAEI,qBAAA;EAEA,wBAAA;A7FopdJ;A6FtndA;EACI;IAEI,mBAAA;E7F+odN;E6F5odE;IAEI,qBAAA;E7F8odN;E6F3odE;IAEI,mBAAA;E7F6odN;E6F1odE;IAEI,qBAAA;E7F4odN;E6FzodE;IAEI,mBAAA;E7F2odN;AACF;A6FxodA;EAEI,yBAAA;EAEA,wBAAA;EAEA,uDAAA;EAEA,sCAAA;A7F0odJ;;A6FvodA,mBAAA;AAqBA;EACI;IAEI,yCAAA;IACA,YAAA;E7FuodN;E6FpodE;IAEI,qCAAA;IACA,YAAA;E7FsodN;E6FnodE;IAEI,mBAAA;IACA,UAAA;E7FqodN;AACF;A6FlodA;EAEI,0BAAA;A7FoodJ;A6F7mdA;EACI;IAEI,yCAAA;IACA,YAAA;E7FiodN;E6F9ndE;IAEI,qCAAA;IACA,YAAA;E7FgodN;E6F7ndE;IAEI,mBAAA;IACA,UAAA;E7F+ndN;AACF;A6F5ndA;EAEI,0BAAA;A7F8ndJ;A6FvmdA;EACI;IAEI,wCAAA;IACA,YAAA;E7F2ndN;E6FxndE;IAEI,qCAAA;IACA,YAAA;E7F0ndN;E6FvndE;IAEI,mBAAA;IACA,UAAA;E7FyndN;AACF;A6FtndA;EAEI,2BAAA;A7FwndJ;A6FjmdA;EACI;IAEI,wCAAA;IACA,YAAA;E7FqndN;E6FlndE;IAEI,qCAAA;IACA,YAAA;E7FondN;E6FjndE;IAEI,mBAAA;IACA,UAAA;E7FmndN;AACF;A6FhndA;EAEI,wBAAA;A7FkndJ;;A6F/mdA,eAAA;AAqBA;EACI;IAEI,mBAAA;IACA,UAAA;E7F+mdN;E6F5mdE;IAEI,qCAAA;IACA,YAAA;E7F8mdN;E6F3mdE;IAEI,uCAAA;IACA,YAAA;E7F6mdN;AACF;A6F1mdA;EAEI,2BAAA;A7F4mdJ;A6FrldA;EACI;IAEI,mBAAA;IACA,UAAA;E7FymdN;E6FtmdE;IAEI,qCAAA;IACA,YAAA;E7FwmdN;E6FrmdE;IAEI,yCAAA;IACA,YAAA;E7FumdN;AACF;A6FpmdA;EAEI,2BAAA;A7FsmdJ;A6F/kdA;EACI;IAEI,mBAAA;IACA,UAAA;E7FmmdN;E6FhmdE;IAEI,qCAAA;IACA,YAAA;E7FkmdN;E6F/ldE;IAEI,wCAAA;IACA,YAAA;E7FimdN;AACF;A6F9ldA;EAEI,4BAAA;A7FgmdJ;A6FzkdA;EACI;IAEI,mBAAA;IACA,UAAA;E7F6ldN;E6F1ldE;IAEI,qCAAA;IACA,YAAA;E7F4ldN;E6FzldE;IAEI,wCAAA;IACA,YAAA;E7F2ldN;AACF;A6FxldA;EAEI,yBAAA;A7F0ldJ;;A6FvldA,wBAAA;AA+CA;EAEI;IAOI,8DAAA;E7FukdN;E6FpkdE;IACI,UAAA;IAEA,iCAAA;E7FskdN;E6FnkdE;IAEI,iCAAA;E7FqkdN;E6FlkdE;IAEI,iCAAA;E7FokdN;E6FjkdE;IACI,UAAA;IAEA,oCAAA;E7FmkdN;E6FhkdE;IAEI,oCAAA;E7FkkdN;E6F/jdE;IACI,UAAA;IAEA,2BAAA;E7FikdN;AACF;A6F9jdA;EAEI,yBAAA;EAEA,wDAAA;EAEA,wBAAA;A7FgkdJ;A6FthdA;EAEI;IAMI,8DAAA;E7FgjdN;E6F7idE;IACI,UAAA;IAEA,+CAAA;E7F+idN;E6F5idE;IACI,UAAA;IAEA,8CAAA;E7F8idN;E6F3idE;IAEI,gDAAA;E7F6idN;E6F1idE;IAEI,+CAAA;E7F4idN;E6FzidE;IAEI,+BAAA;E7F2idN;AACF;A6FxidA;EAEI,4BAAA;A7F0idJ;A6FhgdA;EAEI;IAMI,8DAAA;E7F0hdN;E6FvhdE;IACI,UAAA;IAEA,+CAAA;E7FyhdN;E6FthdE;IACI,UAAA;IAEA,4CAAA;E7FwhdN;E6FrhdE;IAEI,gDAAA;E7FuhdN;E6FphdE;IAEI,+CAAA;E7FshdN;E6FnhdE;IAEI,+BAAA;E7FqhdN;AACF;A6FlhdA;EAEI,4BAAA;A7FohdJ;A6F1+cA;EAEI;IAMI,8DAAA;E7FogdN;E6FjgdE;IACI,UAAA;IAEA,8CAAA;E7FmgdN;E6FhgdE;IACI,UAAA;IAEA,6CAAA;E7FkgdN;E6F//cE;IAEI,+CAAA;E7FigdN;E6F9/cE;IAEI,gDAAA;E7FggdN;E6F7/cE;IAEI,+BAAA;E7F+/cN;AACF;A6F5/cA;EAEI,6BAAA;A7F8/cJ;A6Fp9cA;EAEI;IAMI,8DAAA;E7F8+cN;E6F3+cE;IACI,UAAA;IAEA,8CAAA;E7F6+cN;E6F1+cE;IACI,UAAA;IAEA,+CAAA;E7F4+cN;E6Fz+cE;IAEI,+CAAA;E7F2+cN;E6Fx+cE;IAEI,gDAAA;E7F0+cN;E6Fv+cE;IAEI,+BAAA;E7Fy+cN;AACF;A6Ft+cA;EAEI,0BAAA;A7Fw+cJ;;A6Fr+cA,oBAAA;AAqBA;EACI;IAEI,iCAAA;E7Fo+cN;E6Fj+cE;IAEI,UAAA;IAEA,iCAAA;E7Fk+cN;E6F/9cE;IACI,UAAA;IAEA,iCAAA;E7Fi+cN;AACF;A6F99cA;EAEI,yBAAA;EAEA,wDAAA;EAEA,yBAAA;A7Fg+cJ;A6Fz8cA;EACI;IAEI,gDAAA;E7F49cN;E6Fz9cE;IAEI,UAAA;IAEA,+CAAA;E7F09cN;E6Fv9cE;IACI,UAAA;IAEA,8CAAA;E7Fy9cN;AACF;A6Ft9cA;EAEI,6BAAA;A7Fw9cJ;A6Fv8cA;EACI;IACI,UAAA;IAEA,8CAAA;E7Fs9cN;E6Fn9cE;IACI,UAAA;IAEA,+CAAA;E7Fq9cN;AACF;A6Fl9cA;EAEI,6BAAA;A7Fo9cJ;A6Fn8cA;EACI;IACI,UAAA;IAEA,+CAAA;E7Fk9cN;E6F/8cE;IACI,UAAA;IAEA,8CAAA;E7Fi9cN;AACF;A6F98cA;EAEI,8BAAA;A7Fg9cJ;A6Fz7cA;EACI;IAEI,iDAAA;E7F48cN;E6Fz8cE;IAEI,UAAA;IAEA,8CAAA;E7F08cN;E6Fv8cE;IACI,UAAA;IAEA,+CAAA;E7Fy8cN;AACF;A6Ft8cA;EAEI,2BAAA;A7Fw8cJ;;A6Fr8cA,sBAAA;AAWA;EACI;IACI,UAAA;E7Fs8cN;E6Fn8cE;IACI,UAAA;E7Fq8cN;AACF;A6Fl8cA;EAEI,sBAAA;A7Fo8cJ;A6Fn7cA;EACI;IACI,UAAA;IAEA,mCAAA;E7Fk8cN;E6F/7cE;IACI,UAAA;IAEA,+BAAA;E7Fi8cN;AACF;A6F97cA;EAEI,0BAAA;A7Fg8cJ;A6F/6cA;EACI;IACI,UAAA;IAEA,qCAAA;E7F87cN;E6F37cE;IACI,UAAA;IAEA,+BAAA;E7F67cN;AACF;A6F17cA;EAEI,6BAAA;A7F47cJ;A6F36cA;EACI;IACI,UAAA;IAEA,mCAAA;E7F07cN;E6Fv7cE;IACI,UAAA;IAEA,+BAAA;E7Fy7cN;AACF;A6Ft7cA;EAEI,0BAAA;A7Fw7cJ;A6Fv6cA;EACI;IACI,UAAA;IAEA,qCAAA;E7Fs7cN;E6Fn7cE;IACI,UAAA;IAEA,+BAAA;E7Fq7cN;AACF;A6Fl7cA;EAEI,6BAAA;A7Fo7cJ;A6Fn6cA;EACI;IACI,UAAA;IAEA,kCAAA;E7Fk7cN;E6F/6cE;IACI,UAAA;IAEA,+BAAA;E7Fi7cN;AACF;A6F96cA;EAEI,2BAAA;A7Fg7cJ;A6F/5cA;EACI;IACI,UAAA;IAEA,oCAAA;E7F86cN;E6F36cE;IACI,UAAA;IAEA,+BAAA;E7F66cN;AACF;A6F16cA;EAEI,8BAAA;A7F46cJ;A6F35cA;EACI;IACI,UAAA;IAEA,kCAAA;E7F06cN;E6Fv6cE;IACI,UAAA;IAEA,+BAAA;E7Fy6cN;AACF;A6Ft6cA;EAEI,wBAAA;A7Fw6cJ;A6Fv5cA;EACI;IACI,UAAA;IAEA,oCAAA;E7Fs6cN;E6Fn6cE;IACI,UAAA;IAEA,+BAAA;E7Fq6cN;AACF;A6Fl6cA;EAEI,2BAAA;A7Fo6cJ;A6Fn5cA;EACI;IACI,UAAA;IAEA,uCAAA;E7Fk6cN;E6F/5cE;IACI,UAAA;IAEA,+BAAA;E7Fi6cN;AACF;A6F95cA;EAEI,6BAAA;A7Fg6cJ;A6F/4cA;EACI;IACI,UAAA;IAEA,sCAAA;E7F85cN;E6F35cE;IACI,UAAA;IAEA,+BAAA;E7F65cN;AACF;A6F15cA;EAEI,8BAAA;A7F45cJ;A6F34cA;EACI;IACI,UAAA;IAEA,sCAAA;E7F05cN;E6Fv5cE;IACI,UAAA;IAEA,+BAAA;E7Fy5cN;AACF;A6Ft5cA;EAEI,gCAAA;A7Fw5cJ;A6Fv4cA;EACI;IACI,UAAA;IAEA,qCAAA;E7Fs5cN;E6Fn5cE;IACI,UAAA;IAEA,+BAAA;E7Fq5cN;AACF;A6Fl5cA;EAEI,iCAAA;A7Fo5cJ;;A6Fj5cA,iBAAA;AAWA;EACI;IACI,UAAA;E7Fk5cN;E6F/4cE;IACI,UAAA;E7Fi5cN;AACF;A6F94cA;EAEI,uBAAA;A7Fg5cJ;A6Fj4cA;EACI;IACI,UAAA;E7F84cN;E6F34cE;IACI,UAAA;IAEA,kCAAA;E7F64cN;AACF;A6F14cA;EAEI,2BAAA;A7F44cJ;A6F73cA;EACI;IACI,UAAA;E7F04cN;E6Fv4cE;IACI,UAAA;IAEA,oCAAA;E7Fy4cN;AACF;A6Ft4cA;EAEI,8BAAA;A7Fw4cJ;A6Fz3cA;EACI;IACI,UAAA;E7Fs4cN;E6Fn4cE;IACI,UAAA;IAEA,mCAAA;E7Fq4cN;AACF;A6Fl4cA;EAEI,2BAAA;A7Fo4cJ;A6Fr3cA;EACI;IACI,UAAA;E7Fk4cN;E6F/3cE;IACI,UAAA;IAEA,qCAAA;E7Fi4cN;AACF;A6F93cA;EAEI,8BAAA;A7Fg4cJ;A6Fj3cA;EACI;IACI,UAAA;E7F83cN;E6F33cE;IACI,UAAA;IAEA,kCAAA;E7F63cN;AACF;A6F13cA;EAEI,4BAAA;A7F43cJ;A6F72cA;EACI;IACI,UAAA;E7F03cN;E6Fv3cE;IACI,UAAA;IAEA,oCAAA;E7Fy3cN;AACF;A6Ft3cA;EAEI,+BAAA;A7Fw3cJ;A6Fz2cA;EACI;IACI,UAAA;E7Fs3cN;E6Fn3cE;IACI,UAAA;IAEA,mCAAA;E7Fq3cN;AACF;A6Fl3cA;EAEI,yBAAA;A7Fo3cJ;A6Fr2cA;EACI;IACI,UAAA;E7Fk3cN;E6F/2cE;IACI,UAAA;IAEA,qCAAA;E7Fi3cN;AACF;A6F92cA;EAEI,4BAAA;A7Fg3cJ;A6F/1cA;EACI;IACI,UAAA;IAEA,+BAAA;E7F82cN;E6F32cE;IACI,UAAA;IAEA,uCAAA;E7F62cN;AACF;A6F12cA;EAEI,8BAAA;A7F42cJ;A6F31cA;EACI;IACI,UAAA;IAEA,+BAAA;E7F02cN;E6Fv2cE;IACI,UAAA;IAEA,sCAAA;E7Fy2cN;AACF;A6Ft2cA;EAEI,+BAAA;A7Fw2cJ;A6Fv1cA;EACI;IACI,UAAA;IAEA,+BAAA;E7Fs2cN;E6Fn2cE;IACI,UAAA;IAEA,qCAAA;E7Fq2cN;AACF;A6Fl2cA;EAEI,kCAAA;A7Fo2cJ;A6Fn1cA;EACI;IACI,UAAA;IAEA,+BAAA;E7Fk2cN;E6F/1cE;IACI,UAAA;IAEA,sCAAA;E7Fi2cN;AACF;A6F91cA;EAEI,iCAAA;A7Fg2cJ;;A6F71cA,aAAA;AAsCA;EACI;IAEI,8FAAA;IAEA,mCAAA;E7F21cN;E6Fx1cE;IAEI,kGAAA;IAEA,mCAAA;E7F01cN;E6Fv1cE;IAEI,kGAAA;IAEA,kCAAA;E7Fy1cN;E6Ft1cE;IAEI,oGAAA;IAEA,kCAAA;E7Fw1cN;E6Fr1cE;IAEI,2FAAA;IAEA,kCAAA;E7Fu1cN;AACF;A6Fp1cA;EAEI,4BAAA;EAEA,oBAAA;A7Fs1cJ;A6FlzcA;EACI;IAEI,sDAAA;IAEA,kCAAA;IACA,UAAA;E7Fi1cN;E6F90cE;IAEI,uDAAA;IAEA,kCAAA;E7Fg1cN;E6F70cE;IAEI,sDAAA;IACA,UAAA;E7F+0cN;E6F50cE;IAEI,sDAAA;E7F80cN;E6F30cE;IAEI,6BAAA;E7F60cN;AACF;A6F10cA;EAEI,uCAAA;EAEA,uBAAA;A7F40cJ;A6FxycA;EACI;IAEI,sDAAA;IAEA,kCAAA;IACA,UAAA;E7Fu0cN;E6Fp0cE;IAEI,uDAAA;IAEA,kCAAA;E7Fs0cN;E6Fn0cE;IAEI,sDAAA;IACA,UAAA;E7Fq0cN;E6Fl0cE;IAEI,sDAAA;E7Fo0cN;E6Fj0cE;IAEI,6BAAA;E7Fm0cN;AACF;A6Fh0cA;EAEI,uCAAA;EAEA,uBAAA;A7Fk0cJ;A6F5ycA;EACI;IAEI,6BAAA;E7F+zcN;E6F5zcE;IAEI,uDAAA;IACA,UAAA;E7F8zcN;E6F3zcE;IAEI,sDAAA;IACA,UAAA;E7F6zcN;AACF;A6F1zcA;EAEI,yBAAA;EAEA,wDAAA;EAEA,wBAAA;EAEA,uCAAA;A7F4zcJ;A6FtycA;EACI;IAEI,6BAAA;E7FyzcN;E6FtzcE;IAEI,uDAAA;IACA,UAAA;E7FwzcN;E6FrzcE;IAEI,sDAAA;IACA,UAAA;E7FuzcN;AACF;A6FpzcA;EAEI,yBAAA;EAEA,wDAAA;EAEA,uCAAA;EAEA,wBAAA;A7FszcJ;;A6FnzcA,eAAA;AAyBA;EACI;IAEI,gDAAA;IACA,UAAA;E7FkzcN;E6F/ycE;IAEI,uBAAA;IACA,UAAA;E7FizcN;E6F9ycE;IAEI,uBAAA;E7FgzcN;E6F7ycE;IAEI,+BAAA;E7F+ycN;AACF;A6F5ycA;EAEI,iCAAA;EAEA,mCAAA;A7F8ycJ;A6FnxcA;EACI;IAEI,gDAAA;IACA,UAAA;E7F0ycN;E6FvycE;IAEI,wBAAA;IACA,UAAA;E7FyycN;E6FtycE;IAEI,sBAAA;E7FwycN;E6FrycE;IAEI,+BAAA;E7FuycN;AACF;A6FpycA;EAEI,gCAAA;EAEA,mCAAA;A7FsycJ;A6FvxcA;EACI;IACI,UAAA;E7FoycN;E6FjycE;IAEI,+CAAA;IACA,UAAA;E7FmycN;AACF;A6FhycA;EAEI,kCAAA;EAEA,kCAAA;A7FkycJ;A6FnxcA;EACI;IACI,UAAA;E7FgycN;E6F7xcE;IAEI,iDAAA;IACA,UAAA;E7F+xcN;AACF;A6F5xcA;EAEI,iCAAA;EAEA,kCAAA;A7F8xcJ;;A6F3xcA,uBAAA;AAeA;EACI;IAEI,qCAAA;IACA,UAAA;E7F4xcN;E6FzxcE;IAEI,+BAAA;IACA,UAAA;E7F2xcN;AACF;A6FxxcA;EAEI,wBAAA;EAEA,wBAAA;A7F0xcJ;A6FzwcA;EACI;IAEI,oCAAA;IACA,UAAA;E7FwxcN;E6FrxcE;IAEI,+BAAA;IACA,UAAA;E7FuxcN;AACF;A6FpxcA;EAEI,gCAAA;EAEA,6BAAA;A7FsxcJ;A6FrwcA;EACI;IAEI,mCAAA;IACA,UAAA;E7FoxcN;E6FjxcE;IAEI,+BAAA;IACA,UAAA;E7FmxcN;AACF;A6FhxcA;EAEI,iCAAA;EAEA,8BAAA;A7FkxcJ;A6FjwcA;EACI;IAEI,mCAAA;IACA,UAAA;E7FgxcN;E6F7wcE;IAEI,+BAAA;IACA,UAAA;E7F+wcN;AACF;A6F5wcA;EAEI,8BAAA;EAEA,6BAAA;A7F8wcJ;A6F7vcA;EACI;IAEI,oCAAA;IACA,UAAA;E7F4wcN;E6FzwcE;IAEI,+BAAA;IACA,UAAA;E7F2wcN;AACF;A6FxwcA;EAEI,+BAAA;EAEA,8BAAA;A7F0wcJ;;A6FvwcA,mBAAA;AAaA;EACI;IACI,UAAA;E7FwwcN;E6FrwcE;IAEI,oCAAA;IACA,UAAA;E7FuwcN;AACF;A6FpwcA;EAEI,yBAAA;EAEA,wBAAA;A7FswcJ;A6FvvcA;EACI;IACI,UAAA;E7FowcN;E6FjwcE;IAEI,mCAAA;IACA,UAAA;E7FmwcN;AACF;A6FhwcA;EAEI,iCAAA;EAEA,6BAAA;A7FkwcJ;A6FnvcA;EACI;IACI,UAAA;E7FgwcN;E6F7vcE;IAEI,oCAAA;IACA,UAAA;E7F+vcN;AACF;A6F5vcA;EAEI,kCAAA;EAEA,8BAAA;A7F8vcJ;A6F/ucA;EACI;IACI,UAAA;E7F4vcN;E6FzvcE;IAEI,oCAAA;IACA,UAAA;E7F2vcN;AACF;A6FxvcA;EAEI,+BAAA;EAEA,6BAAA;A7F0vcJ;A6F3ucA;EACI;IACI,UAAA;E7FwvcN;E6FrvcE;IAEI,mCAAA;IACA,UAAA;E7FuvcN;AACF;A6FpvcA;EAEI,gCAAA;EAEA,8BAAA;A7FsvcJ;;A6FnvcA,aAAA;AA+BA;EACI;IAEI,sCAAA;E7FgvcN;E6F7ucE;IAGI,mCAAA;IAEA,sCAAA;E7F8ucN;E6F3ucE;IAGI,mCAAA;IAEA,sCAAA;IACA,UAAA;E7F4ucN;E6FzucE;IAEI,mCAAA;IACA,UAAA;E7F2ucN;AACF;A6FxucA;EAEI,sBAAA;EAEA,qDAAA;EAEA,qBAAA;EAEA,0BAAA;A7F0ucJ;A6F7scA;EACI;IACI,UAAA;IAEA,mCAAA;IAEA,+BAAA;E7FsucN;E6FnucE;IAEI,yBAAA;E7FqucN;E6FlucE;IAEI,uBAAA;E7FoucN;E6FjucE;IACI,UAAA;IAEA,mBAAA;E7FmucN;AACF;A6FhucA;EAEI,4BAAA;A7FkucJ;;A6F/tcA,6EAAA;AAeA;EACI;IACI,UAAA;IAEA,8DAAA;E7FgucN;E6F7tcE;IACI,UAAA;IAEA,+BAAA;E7F+tcN;AACF;A6F5tcA;EAEI,sBAAA;A7F8tcJ;;A6F3tcA,6EAAA;AAaA;EACI;IACI,UAAA;E7F4tcN;E6FztcE;IACI,UAAA;IAEA,4DAAA;E7F2tcN;AACF;A6FxtcA;EAEI,uBAAA;A7F0tcJ;;A6FvtcA,sBAAA;AAaA;EACI;IACI,UAAA;IAEA,iCAAA;E7FwtcN;E6FrtcE;IACI,UAAA;E7FutcN;AACF;A6FptcA;EAEI,sBAAA;A7FstcJ;A6FjscA;EACI;IACI,UAAA;IAEA,4DAAA;IAEA,iEAAA;E7FotcN;E6FjtcE;IACI,UAAA;IAEA,+DAAA;IAEA,8DAAA;E7FmtcN;AACF;A6FhtcA;EAEI,0BAAA;A7FktcJ;A6F7rcA;EACI;IACI,UAAA;IAEA,4DAAA;IAEA,iEAAA;E7FgtcN;E6F7scE;IACI,UAAA;IAEA,+DAAA;IAEA,8DAAA;E7F+scN;AACF;A6F5scA;EAEI,0BAAA;A7F8scJ;A6FzrcA;EACI;IACI,UAAA;IAEA,2DAAA;IAEA,iEAAA;E7F4scN;E6FzscE;IACI,UAAA;IAEA,gEAAA;IAEA,8DAAA;E7F2scN;AACF;A6FxscA;EAEI,2BAAA;A7F0scJ;A6FrrcA;EACI;IACI,UAAA;IAEA,2DAAA;IAEA,iEAAA;E7FwscN;E6FrscE;IACI,UAAA;IAEA,gEAAA;IAEA,8DAAA;E7FuscN;AACF;A6FpscA;EAEI,wBAAA;A7FsscJ;;A6FnscA,kBAAA;AAiBA;EACI;IACI,UAAA;E7FmscN;E6FhscE;IACI,UAAA;IAEA,iCAAA;E7FkscN;E6F/rcE;IACI,UAAA;E7FiscN;AACF;A6F9rcA;EAEI,uBAAA;A7FgscJ;A6F3qcA;EACI;IACI,UAAA;IAEA,gEAAA;IAEA,iEAAA;E7F8rcN;E6F3rcE;IACI,UAAA;IAEA,2DAAA;IAEA,8DAAA;E7F6rcN;AACF;A6F1rcA;EAEI,2BAAA;EAEA,+BAAA;A7F4rcJ;A6F3qcA;EACI;IACI,UAAA;IAEA,+DAAA;E7F0rcN;E6FvrcE;IACI,UAAA;IAEA,gDAAA;E7FyrcN;AACF;A6FtrcA;EAEI,2BAAA;EAEA,6BAAA;A7FwrcJ;A6FvqcA;EACI;IACI,UAAA;IAEA,gEAAA;E7FsrcN;E6FnrcE;IACI,UAAA;IAEA,+CAAA;E7FqrcN;AACF;A6FlrcA;EAEI,4BAAA;EAEA,8BAAA;A7ForcJ;A6F/pcA;EACI;IACI,UAAA;IAEA,+DAAA;IAEA,iEAAA;E7FkrcN;E6F/qcE;IACI,UAAA;IAEA,4DAAA;IAEA,8DAAA;E7FircN;AACF;A6F9qcA;EAEI,yBAAA;EAEA,+BAAA;A7FgrcJ;;A6F7qcA,sBAAA;AAcA;EACI;IAEI,mCAAA;IACA,mBAAA;E7F8qcN;E6F3qcE;IAEI,+BAAA;E7F6qcN;AACF;A6F1qcA;EAEI,2BAAA;A7F4qcJ;A6F5pcA;EACI;IAEI,mCAAA;IACA,mBAAA;E7F0qcN;E6FvqcE;IAEI,+BAAA;E7FyqcN;AACF;A6FtqcA;EAEI,2BAAA;A7FwqcJ;A6FxpcA;EACI;IAEI,kCAAA;IACA,mBAAA;E7FsqcN;E6FnqcE;IAEI,+BAAA;E7FqqcN;AACF;A6FlqcA;EAEI,4BAAA;A7FoqcJ;A6FppcA;EACI;IAEI,kCAAA;IACA,mBAAA;E7FkqcN;E6F/pcE;IAEI,+BAAA;E7FiqcN;AACF;A6F9pcA;EAEI,yBAAA;A7FgqcJ;;A6F7pcA,kBAAA;AAcA;EACI;IAEI,+BAAA;E7F8pcN;E6F3pcE;IACI,kBAAA;IAEA,kCAAA;E7F6pcN;AACF;A6F1pcA;EAEI,4BAAA;A7F4pcJ;A6F5ocA;EACI;IAEI,+BAAA;E7F0pcN;E6FvpcE;IACI,kBAAA;IAEA,mCAAA;E7FypcN;AACF;A6FtpcA;EAEI,4BAAA;A7FwpcJ;A6FxocA;EACI;IAEI,+BAAA;E7FspcN;E6FnpcE;IACI,kBAAA;IAEA,kCAAA;E7FqpcN;AACF;A6FlpcA;EAEI,6BAAA;A7FopcJ;A6FpocA;EACI;IAEI,+BAAA;E7FkpcN;E6F/ocE;IACI,kBAAA;IAEA,mCAAA;E7FipcN;AACF;A6F9ocA;EAEI,0BAAA;A7FgpcJ;;A8Fp8kBA;EACI,SAAA;EACA,UAAA;EACA,eAAA;A9Fu8kBJ;;A8Fp8kBA;;EAEI,SAAA;EACA,UAAA;EACA,gBAAA;A9Fu8kBJ;;A8Fp8kBA;EACI,cAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;A9Fu8kBJ;;A8Fp8kBA;EACI,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;A9Fu8kBJ;;A8Fp8kBA;EACI,qBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EAEA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;A9Fs8kBJ;;A8Fn8kBA;EACI,cAAA;EACA,cAAA;EACA,0BAAA;EACA,gBAAA;A9Fs8kBJ;;A8Fn8kBA;EACI,qBAAA;A9Fs8kBJ;;A8Fn8kBA;;EAEI,qBAAA;EACA,oBAAA;A9Fs8kBJ;;A8Fn8kBA;;EAEI,cAAA;A9Fs8kBJ;;A8Fn8kBA;EACI,gBAAA;EACA,gBAAA;EACA,qBAAA;A9Fs8kBJ;;A8Fn8kBA;EACI,cAAA;A9Fs8kBJ;;A8Fn8kBA;;EAEI,qBAAA;A9Fs8kBJ;;A8Fn8kBA;;EAEI,cAAA;A9Fs8kBJ;;A8Fn8kBA;;EAEI,UAAA;A9Fs8kBJ;;A8Fn8kBA;;EAEI,uBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;A9Fs8kBJ;;A8Fn8kBA;;EAEI,cAAA;EACA,cAAA;A9Fs8kBJ;;A8Fn8kBA;;;EAGI,iBAAA;A9Fs8kBJ;;A8Fn8kBA;;;;EAII,qBAAA;EACA,eAAA;EACA,YAAA;EACA,0BAAA;EAEA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;A9Fq8kBJ;;A8Fl8kBA;;EAEI,UAAA;A9Fq8kBJ;;A8Fl8kBA;;EAEI,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;A9Fq8kBJ;;A8Fl8kBA;;EAEI,qBAAA;A9Fq8kBJ;;A8Fl8kBA;;EAEI,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;A9Fq8kBJ;;A8Fl8kBA;;;;EAII,cAAA;EACA,qBAAA;A9Fq8kBJ;;A8Fl8kBA;EACI,YAAA;EACA,cAAA;A9Fq8kBJ;;A8Fl8kBA;EACI,YAAA;EACA,cAAA;A9Fq8kBJ;;A8Fl8kBA;;;EAGI,mBAAA;A9Fq8kBJ;;A8Fl8kBA;;;EAGI,0BAAA;EACA,qBAAA;EACA,mBAAA;A9Fq8kBJ;;A8Fl8kBA;EACI,oBAAA;A9Fq8kBJ;;A8Fl8kBA;EACI,qBAAA;EACA,iBAAA;EACA,sBAAA;A9Fq8kBJ;;A8Fl8kBA;EAEI;;IAEI,mBAAA;E9Fo8kBN;AACF;A8Fj8kBA;EACI,qBAAA;EACA,WAAA;EACA,iBAAA;A9Fm8kBJ;;A8Fh8kBA;EACI,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;A9Fm8kBJ;;A8Fh8kBA;EACI,WAAA;EACA,aAAA;A9Fm8kBJ;;A8Fh8kBA;;EAEI,YAAA;EACA,iBAAA;EACA,mBAAA;A9Fm8kBJ;;A8Fh8kBA;;EAEI,YAAA;EACA,6BAAA;EACA,SAAA;A9Fm8kBJ;;A8Fh8kBA;;EAEI,YAAA;EACA,iBAAA;A9Fm8kBJ;;A8Fh8kBA;EACI,qBAAA;EACA,YAAA;EACA,iBAAA;A9Fm8kBJ;;A8Fh8kBA;EACI,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,6BAAA;A9Fm8kBJ;;A8Fh8kBA;EACI,qBAAA;A9Fm8kBJ;;A8Fh8kBA;EACI,mBAAA;A9Fm8kBJ;;A8Fh8kBA;EACI,mBAAA;EACA,qBAAA;EACA,mBAAA;A9Fm8kBJ;;A8Fh8kBA;EACI,0BAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;A9Fm8kBJ;;A8Fh8kBA;EACI,mBAAA;EACA,yBAAA;A9Fm8kBJ;;A8Fh8kBA;EACI,WAAA;A9Fm8kBJ;;A8Fh8kBA;EACI,0BAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;A9Fm8kBJ;;A8Fh8kBA;EACI,UAAA;A9Fm8kBJ;;A8Fh8kBA;EACI,UAAA;A9Fm8kBJ;;A8Fh8kBA;EAEI;;IAEI,aAAA;E9Fk8kBN;AACF;A8F/7kBA;EACI;IACI,aAAA;E9Fi8kBN;AACF;A8F97kBA;EACI,sBAAA;A9Fg8kBJ;;A8F77kBA;EACI,qBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;A9Fg8kBJ;;A8F77kBA;;EAEI,mBAAA;A9Fg8kBJ;;A8F77kBA;EACI,YAAA;A9Fg8kBJ;;A8F77kBA;EACI,sBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,4CAAA;A9Fg8kBJ;;A8F77kBA;EACI,YAAA;EACA,oBAAA;A9Fg8kBJ;;A8F77kBA;EAGI,gBAAA;A9Fg8kBJ;;A8F77kBA;EACI,aAAA;EAEA,gBAAA;A9Fg8kBJ;;A8F77kBA;EACI,aAAA;EACA,kBAAA;A9Fg8kBJ;;A8F77kBA;EACI,WAAA;A9Fg8kBJ;;A8F77kBA;EACI,WAAA;A9Fg8kBJ;;A8F77kBA;;EAEI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;A9Fg8kBJ;;A8F77kBA;EACI,YAAA;EACA,sBAAA;A9Fg8kBJ;;A8F77kBA;EACI,YAAA;EACA,aAAA;EACA,gCAAA;EACA,WAAA;A9Fg8kBJ;;A8F77kBA;EACI,aAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;A9Fg8kBJ;;A8F77kBA;EACI,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;A9Fg8kBJ;;A8F77kBA;EACI,mBAAA;EACA,YAAA;A9Fg8kBJ;;A8F77kBA;EACI,aAAA;EACA,eAAA;EACA,WAAA;A9Fg8kBJ;;A8F77kBA;EACI,UAAA;EACA,eAAA;A9Fg8kBJ;;A8F77kBA;EACI,kBAAA;EACA,eAAA;A9Fg8kBJ;;A8F77kBA;;EAEI,YAAA;EACA,sBAAA;A9Fg8kBJ;;A8F77kBA;EACI,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;A9Fg8kBJ;;A8F77kBA;EACI,YAAA;EACA,aAAA;EACA,gCAAA;EACA,WAAA;A9Fg8kBJ;;A8F77kBA;EACI,mBAAA;A9Fg8kBJ;;A8F77kBA;EACI,kBAAA;EACA,WAAA;EACA,MAAA;A9Fg8kBJ;;A8F77kBA;EACI,mBAAA;A9Fg8kBJ;;A8F77kBA;EACI,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;A9Fg8kBJ;;A8F77kBA;EACI,WAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;EACA,6BAAA;EACA,sBAAA;EACA,0BAAA;A9Fg8kBJ;;A8F77kBA;EACI,6BAAA;A9Fg8kBJ;;A8F77kBA;EACI,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;A9Fg8kBJ;;A8F77kBA;EACI,aAAA;A9Fg8kBJ;;A8F77kBA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;A9Fg8kBJ;;A8F77kBA;EACI,WAAA;EACA,gBAAA;EACA,cAAA;A9Fg8kBJ;;A8F77kBA;EACI,kBAAA;A9Fg8kBJ;;A8F77kBA;EACI,kBAAA;A9Fg8kBJ;;A8F77kBA;EACI,kBAAA;EACA,QAAA;EACA,QAAA;EACA,oBAAA;A9Fg8kBJ;;A8F77kBA;EACI,gBAAA;A9Fg8kBJ;;A8F77kBA;EACI,WAAA;A9Fg8kBJ;;A8F77kBA;EACI,kBAAA;EACA,WAAA;A9Fg8kBJ;;A8F77kBA;EACI,oBAAA;A9Fg8kBJ;;A8F77kBA;EACI,UAAA;EACA,qBAAA;A9Fg8kBJ;;A8F77kBA;EACI,UAAA;EACA,mBAAA;A9Fg8kBJ;;A8F77kBA;EACI,UAAA;EACA,mBAAA;A9Fg8kBJ;;A8F77kBA;EACI,UAAA;EACA,qBAAA;A9Fg8kBJ;;A8F77kBA;;EAEI,wBAAA;EACA,yBAAA;EACA,qBAAA;EACA,UAAA;EACA,4DAAA;EACA,4BAAA;A9Fg8kBJ;;A8F77kBA;EACI,wBAAA;EACA,yBAAA;EACA,qBAAA;EACA,UAAA;EACA,8DAAA;EACA,4BAAA;A9Fg8kBJ;;A8F77kBA;;;;EAII,yCAAA;EACA,6BAAA;A9Fg8kBJ;;A8F77kBA;;EAEI,0CAAA;EACA,6BAAA;A9Fg8kBJ;;A8F77kBA;;EAEI,2CAAA;EACA,6BAAA;A9Fg8kBJ;;A8F77kBA;EACI,4CAAA;EACA,6BAAA;A9Fg8kBJ;;A8F77kBA;EACI;IACI,UAAA;IACA,qBAAA;IACA,oBAAA;E9Fg8kBN;E8F77kBE;IACI,UAAA;IACA,qBAAA;IACA,oBAAA;E9F+7kBN;AACF;A8F57kBA;EACI;IACI,UAAA;IACA,qBAAA;IACA,oBAAA;E9F87kBN;E8F37kBE;IACI,UAAA;IACA,qBAAA;IACA,oBAAA;E9F67kBN;AACF;A8F17kBA;EACI;IACI,oBAAA;E9F47kBN;E8Fz7kBE;IACI,wBAAA;E9F27kBN;AACF;A8Fx7kBA;EACI,sBAAA;EACA,yBAAA;EACA,kBAAA;A9F07kBJ;;A8Fv7kBA;EACI,yBAAA;EACA,qBAAA;A9F07kBJ;;A8Fv7kBA;EACI,gBAAA;EACA,qBAAA;A9F07kBJ;;A8Fv7kBA;EACI,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;EACA,iDAAA;EACA,2BAAA;EACA,4BAAA;A9F07kBJ;;A8Fv7kBA;EACI,gBAAA;EACA,yBAAA;A9F07kBJ;;A8Fv7kBA;EACI,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,8CAAA;A9F07kBJ;;A8Fv7kBA;EACI,SAAA;EACA,WAAA;EACA,aAAA;A9F07kBJ;;A8Fv7kBA;EACI,gBAAA;A9F07kBJ;;A8Fv7kBA;EACI,kBAAA;A9F07kBJ;;A8Fv7kBA;EACI,qCAAA;EACA,8CAAA;A9F07kBJ;;A8Fv7kBA;EACI,6CAAA;A9F07kBJ;;A8Fv7kBA;EACI,sBAAA;EACA,cAAA;EACA,6BAAA;A9F07kBJ;;A8Fv7kBA;EACI,qBAAA;A9F07kBJ;;A8Fv7kBA;EACI,aAAA;A9F07kBJ;;A8Fv7kBA;EACI,gBAAA;A9F07kBJ;;A8Fv7kBA;EACI,kBAAA;A9F07kBJ;;A8Fv7kBA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,4EAAA;EACA,2BAAA;EACA,oBAAA;EACA,eAAA;A9F07kBJ;;A8Fv7kBA;EACI,8BAAA;EACA,kFAAA;A9F07kBJ;;A8Fv7kBA;EACI,cAAA;A9F07kBJ;;A8Fv7kBA;EACI,YAAA;EACA,uBAAA;A9F07kBJ;;A8Fv7kBA;EACI,aAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;A9F07kBJ;;A8Fv7kBA;EACI,qBAAA;A9F07kBJ;;A8Fv7kBA;;EAEI,iBAAA;A9F07kBJ;;A8Fv7kBA;EACI,aAAA;A9F07kBJ;;A8Fv7kBA;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,yCAAA;A9F07kBJ;;A8Fv7kBA;EACI,UAAA;A9F07kBJ;;A8Fv7kBA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;A9F07kBJ;;A8Fv7kBA;EACI,YAAA;A9F07kBJ;;A8Fv7kBA;EACI,YAAA;A9F07kBJ;;A8Fv7kBA;EACI,YAAA;EACA,mBAAA;A9F07kBJ;;A8Fv7kBA;EACI,4BAAA;A9F07kBJ;;A8Fv7kBA;EACI,4BAAA;A9F07kBJ;;A8Fv7kBA;EACI,4BAAA;A9F07kBJ;;A8Fv7kBA;EACI,4BAAA;A9F07kBJ;;A8Fv7kBA;EACI,6BAAA;A9F07kBJ;;A8Fv7kBA;EACI,6BAAA;A9F07kBJ;;A8Fv7kBA;EACI,6BAAA;A9F07kBJ;;A8Fv7kBA;EACI,6BAAA;A9F07kBJ;;A8Fv7kBA;EACI,6BAAA;A9F07kBJ;;A8Fv7kBA;EACI,4BAAA;A9F07kBJ;;A8Fv7kBA;EACI,oBAAA;EACA,gCAAA;A9F07kBJ;;A8Fv7kBA;EACI,6BAAA;A9F07kBJ;;A8Fv7kBA;EACI,SAAA;EACA,qBAAA;A9F07kBJ;;A8Fv7kBA;EACI,8BAAA;A9F07kBJ;;A8Fv7kBA;EACI,qBAAA;A9F07kBJ;;A8Fv7kBA;EACI,8BAAA;A9F07kBJ;;A8Fv7kBA;EACI,qBAAA;A9F07kBJ;;A8Fv7kBA;EACI,kBAAA;EACA,kBAAA;A9F07kBJ;;A8Fv7kBA;;EAEI,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;A9F07kBJ;;A8Fv7kBA;EACI,UAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;A9F07kBJ;;A8Fv7kBA;EACI,QAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,gCAAA;EACA,wBAAA;A9F07kBJ;;A8Fv7kBA;EACI,mBAAA;A9F07kBJ;;A8Fv7kBA;EACI,gBAAA;A9F07kBJ;;A8Fv7kBA;EACI,sBAAA;A9F07kBJ;;A8Fv7kBA;EACI,SAAA;A9F07kBJ;;A8Fv7kBA;EACI,aAAA;A9F07kBJ;;A8Fv7kBA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;A9F07kBJ;;A8Fv7kBA;EACI,mDAAA;A9F07kBJ;;A8Fv7kBA;EACI,sCAAA;A9F07kBJ;;A8Fv7kBA;EACI,kBAAA;EACA,aAAA;EACA,0BAAA;A9F07kBJ;;A8Fv7kBA;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,2BAAA;A9F07kBJ;;A8Fv7kBA;EACI,aAAA;A9F07kBJ;;A8Fv7kBA;EACI,eAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;A9F07kBJ;;A8Fv7kBA;EACI,cAAA;A9F07kBJ;;A8Fv7kBA;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,iCAAA;EACA,oBAAA;A9F07kBJ;;A8Fv7kBA;EACI,mBAAA;A9F07kBJ;;A8Fv7kBA;EACI,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;A9F07kBJ;;A8Fv7kBA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;A9F07kBJ;;A8Fv7kBA;EACI,iBAAA;EACA,eAAA;EACA,eAAA;A9F07kBJ;;A8Fv7kBA;EACI,cAAA;A9F07kBJ;;A8Fv7kBA;EACI,iCAAA;A9F07kBJ;;A8Fv7kBA;EACI,aAAA;A9F07kBJ;;A8Fv7kBA;;EAEI,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,sEAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EAEA,WAAA;EAGA,aAAA;A9F07kBJ;;A8Fv7kBA;;;;EAII,iBAAA;EACA,mBAAA;A9F07kBJ;;A8Fv7kBA;EAEI;;IAEI,iBAAA;E9Fy7kBN;AACF;A8Ft7kBA;EACI,YAAA;EACA,eAAA;EACA,cAAA;A9Fw7kBJ;;A8Fr7kBA;;EAEI,mBAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,cAAA;EACA,oBAAA;EACA,mBAAA;A9Fw7kBJ;;A8Fr7kBA;;;;EAII,cAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,WAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,YAAA;A9Fw7kBJ;;A8Fr7kBA;;;;;;;EAOI,WAAA;A9Fw7kBJ;;A8Fr7kBA;;;;;;EAMI,WAAA;A9Fw7kBJ;;A8Fr7kBA;;;;;EAKI,cAAA;EACA,kCAAA;A9Fw7kBJ;;A8Fr7kBA;;;EAGI,WAAA;A9Fw7kBJ;;A8Fr7kBA;;EAEI,cAAA;A9Fw7kBJ;;A8Fr7kBA;;;EAGI,WAAA;A9Fw7kBJ;;A8Fr7kBA;;EAEI,gBAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,kBAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,YAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,kBAAA;EACA,eAAA;EACA,yBAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,8BAAA;EACA,mBAAA;A9Fw7kBJ;;A8Fr7kBA;;EAEI,gBAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,SAAA;EACA,uBAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,qBAAA;EACA,eAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,yCAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,YAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,YAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,4BAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,UAAA;EACA,oBAAA;EACA,gCAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,kBAAA;EACA,UAAA;A9Fw7kBJ;;A8Fr7kBA;;;;EAII,cAAA;A9Fw7kBJ;;A8Fr7kBA;;EAEI,8BAAA;EACA,uBAAA;A9Fw7kBJ;;A8Fr7kBA;;;;EAII,yBAAA;A9Fw7kBJ;;A8Fr7kBA;;;;;EAKI,uBAAA;A9Fw7kBJ;;A8Fr7kBA;;;;;EAKI,cAAA;A9Fw7kBJ;;A8Fr7kBA;;;;;;EAMI,cAAA;A9Fw7kBJ;;A8Fr7kBA;;;EAGI,cAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,8BAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,cAAA;A9Fw7kBJ;;A8Fr7kBA;;EAEI,cAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,cAAA;EACA,eAAA;EACA,oBAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,8BAAA;A9Fw7kBJ;;A8Fr7kBA;EACI,gBAAA;A9Fw7kBJ;;A8Fr7kBA;;;;;;;;;;;EAMI,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;A9F67kBJ;;A8F17kBA;;;;;;;;;;;EAMI,8BAAA;A9Fk8kBJ;;A8F/7kBA;;;;;;;;;;;EAMI,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;A9Fu8kBJ;;A8Fp8kBA;EAEI;;;;;;;;;;;IAMI,WAAA;IACA,kBAAA;E9F28kBN;AACF;A8Fx8kBA;;;;;;;;;;;EAMI,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;A9F+8kBJ;;A8F58kBA;;;;;;;;;;;EAMI,aAAA;A9Fo9kBJ;;A8Fj9kBA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAoCI,gBAAA;A9F6jlBJ;;A8F1jlBA;EACI,gBAAA;EACA,mBAAA;EACA,eAAA;A9F6jlBJ;;A8F1jlBA;EACI,eAAA;A9F6jlBJ;;A8F1jlBA;EACI,eAAA;A9F6jlBJ;;A8F1jlBA;EACI,eAAA;A9F6jlBJ;;A8F1jlBA;EACI,eAAA;A9F6jlBJ;;A8F1jlBA;EACI,eAAA;A9F6jlBJ;;A8F1jlBA;EACI,cAAA;A9F6jlBJ;;A8F1jlBA;EACI,gBAAA;EACA,cAAA;EACA,mBAAA;A9F6jlBJ;;A8F1jlBA;EACI,cAAA;EACA,mCAAA;A9F6jlBJ;;A8F1jlBA;EACI,sEAAA;A9F6jlBJ;;A8F1jlBA;EACI,eAAA;EACA,mBAAA;A9F6jlBJ;;A8F1jlBA;EACI,YAAA;A9F6jlBJ;;A8F1jlBA;EACI,cAAA;EACA,SAAA;EACA,6BAAA;A9F6jlBJ;;A8F1jlBA;EACI,cAAA;EACA,eAAA;EACA,6BAAA;EACA,8BAAA;EACA,gBAAA;A9F6jlBJ;;A8F1jlBA;EACI,8BAAA;EACA,qBAAA;A9F6jlBJ;;A8F1jlBA;;EAEI,sBAAA;EACA,UAAA;A9F6jlBJ;;A8F1jlBA;;EAEI,kBAAA;A9F6jlBJ;;A8F1jlBA;EACI,WAAA;EACA,yBAAA;EACA,yBAAA;A9F6jlBJ;;A8F1jlBA;EACI,yBAAA;A9F6jlBJ;;A8F1jlBA;;EAEI,kBAAA;EACA,yBAAA;A9F6jlBJ;;A8F1jlBA;;EAEI,yBAAA;A9F6jlBJ;;A8F1jlBA;EACI,gBAAA;EACA,mBAAA;A9F6jlBJ;;A8F1jlBA;EACI,mCAAA;A9F6jlBJ;;A8F1jlBA;EACI,gBAAA;A9F6jlBJ;;A8F1jlBA;EACI,aAAA;A9F6jlBJ;;A8F1jlBA;EACI,cAAA;EACA,qBAAA;EACA,wBAAA;EACA,aAAA;A9F6jlBJ;;A8F1jlBA;EACI,cAAA;A9F6jlBJ;;A8F1jlBA;EACI,YAAA;EACA,0BAAA;A9F6jlBJ;;A8F1jlBA;EACI,YAAA;A9F6jlBJ;;A8F1jlBA;EACI,eAAA;A9F6jlBJ;;A8F1jlBA;EACI,wBAAA;EACA,gBAAA;A9F6jlBJ;;A8F1jlBA;;;;;;;EAII,8BAAA;A9FgklBJ;;A8F7jlBA;EACI,6EAAA;A9FgklBJ;;A8F3jlBA;EACI,8BAAA;EACA,yBAAA;A9F8jlBJ;;A8F3jlBA;EACI,sBAAA;EACA,iBAAA;EACA,8BAAA;A9F8jlBJ;;A8F3jlBA;EACI;IACI,4BAAA;IACA,6BAAA;IACA,8BAAA;E9F8jlBN;AACF;A8F3jlBA;EACI,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,iBAAA;A9F6jlBJ;;A8F1jlBA;EACI;IACI,4BAAA;E9F6jlBN;AACF;A8F1jlBA;EACI,kBAAA;A9F4jlBJ;;A8FzjlBA;EACI,mBAAA;A9F4jlBJ;;A8FzjlBA;EACI,kBAAA;A9F4jlBJ;;A8FzjlBA;EACI,mBAAA;A9F4jlBJ;;A8FzjlBA;EACI,oBAAA;A9F4jlBJ;;A8FzjlBA;EACI,aAAA;A9F4jlBJ;;A8FzjlBA;EACI,UAAA;EACA,8BAAA;A9F4jlBJ;;A8FzjlBA;EACI,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;A9F4jlBJ;;A8FzjlBA;EACI,yCAAA;A9F4jlBJ;;A8FzjlBA;EACI;IACI,qBAAA;IACA,eAAA;E9F4jlBN;AACF;A8FzjlBA;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;A9F2jlBJ;;A8FxjlBA;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;A9F2jlBJ;;A8FxjlBA;EACI,8BAAA;A9F2jlBJ;;A8FxjlBA;EACI,mBAAA;EACA,aAAA;A9F2jlBJ;;A8FxjlBA;EACI,eAAA;A9F2jlBJ;;A8FxjlBA;EACI,kBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;A9F2jlBJ;;A8FxjlBA;EACI,YAAA;A9F2jlBJ;;A8FxjlBA;EACI,YAAA;A9F2jlBJ;;A8FxjlBA;EACI,eAAA;EACA,WAAA;EACA,mBAAA;A9F2jlBJ;;A8FxjlBA;EACI,aAAA;EACA,qCAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;A9F2jlBJ;;A8FxjlBA;EACI,SAAA;EACA,SAAA;EACA,kBAAA;EACA,mCAAA;A9F2jlBJ;;A8FxjlBA;EACI,iBAAA;A9F2jlBJ;;A8FxjlBA;EACI,mBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;A9F2jlBJ;;A8FxjlBA;EACI,8BAAA;A9F2jlBJ;;A8FxjlBA;EACI,yBAAA;A9F2jlBJ;;A8FxjlBA;EACI,cAAA;EACA,wBAAA;A9F2jlBJ;;A8FxjlBA;EACI,YAAA;EACA,0BAAA;A9F2jlBJ;;A8FxjlBA;EACI,YAAA;A9F2jlBJ;;A8FxjlBA;EACI,SAAA;A9F2jlBJ;;A8FxjlBA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;A9F2jlBJ;;A8FxjlBA;EACI,8BAAA;A9F2jlBJ;;A8FxjlBA;EACI,aAAA;A9F2jlBJ;;A8FxjlBA;EACI,gBAAA;A9F2jlBJ;;A8FxjlBA;EACI;IACI,cAAA;IACA,eAAA;E9F2jlBN;E8FxjlBE;IACI,gBAAA;IACA,wBAAA;E9F0jlBN;E8FvjlBE;IACI,mBAAA;E9FyjlBN;E8FtjlBE;IACI,gBAAA;E9FwjlBN;AACF;A8FrjlBA;;;EAGI,iBAAA;EACA,kBAAA;EACA,gBAAA;A9FujlBJ;;A8FpjlBA;EACI,gBAAA;A9FujlBJ;;A8FpjlBA;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,6BAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;A9FujlBJ;;A8FpjlBA;EACI,yBAAA;A9FujlBJ;;A8FpjlBA;EACI;IACI,aAAA;E9FujlBN;AACF;A8FpjlBA;EACI,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;A9FsjlBJ;;A8FnjlBA;EACI,cAAA;EACA,qBAAA;A9FsjlBJ;;A8FnjlBA;EACI,8BAAA;A9FsjlBJ;;A8FnjlBA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,qBAAA;EACA,UAAA;EACA,mBAAA;A9FsjlBJ;;A8FnjlBA;EACI,cAAA;A9FsjlBJ;;A8FnjlBA;EACI,cAAA;A9FsjlBJ;;A8FnjlBA;EACI,cAAA;A9FsjlBJ;;A8FnjlBA;EACI,cAAA;A9FsjlBJ;;A8FnjlBA;EACI,cAAA;A9FsjlBJ;;A8FnjlBA;EACI,cAAA;A9FsjlBJ;;A8FnjlBA;EACI,mBAAA;A9FsjlBJ;;A8FnjlBA;EACI,mBAAA;A9FsjlBJ;;A8FnjlBA;EACI,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;EACA,6BAAA;A9FsjlBJ;;A8FnjlBA;EACI,8BAAA;EACA,qBAAA;A9FsjlBJ;;A8FnjlBA;EACI;IACI,cAAA;E9FsjlBN;AACF;A8FnjlBA;EACI,kBAAA;EACA,cAAA;EACA,cAAA;EACA,wBAAA;EACA,qBAAA;A9FqjlBJ;;A8FljlBA;EACI,cAAA;A9FqjlBJ;;A8FljlBA;EACI,YAAA;EACA,0BAAA;A9FqjlBJ;;A8FljlBA;EACI,YAAA;A9FqjlBJ;;A8FljlBA;EACI,gCAAA;EACA,cAAA;A9FqjlBJ;;A8FljlBA;EACI,cAAA;A9FqjlBJ;;A8FljlBA;EACI,oBAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;A9FqjlBJ;;A8FljlBA;EACI,qBAAA;A9FqjlBJ;;A8FljlBA;EACI,cAAA;A9FqjlBJ;;A8FljlBA;EACI,8BAAA;A9FqjlBJ;;A8FljlBA;EACI,eAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,+CAAA;A9FqjlBJ;;A8FljlBA;EACI,mBAAA;EACA,2CAAA;A9FqjlBJ;;A8FljlBA;EACI;IACI,aAAA;IACA,uBAAA;IACA,YAAA;E9FqjlBN;AACF;A8FljlBA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,0EAAA;A9FojlBJ;;A8FjjlBA;EACI;IACI,cAAA;E9FojlBN;AACF;A8FjjlBA;EACI,qBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;A9FmjlBJ;;A8FhjlBA;EACI,8BAAA;A9FmjlBJ;;A8FhjlBA;EACI,kBAAA;EACA,wEAAA;A9FmjlBJ;;A8FhjlBA;EACI;IACI,YAAA;IACA,iBAAA;E9FmjlBN;E8FhjlBE;IACI,kBAAA;E9FkjlBN;AACF;A8F/ilBA;EACI,qBAAA;A9FijlBJ;;A8F9ilBA;EACI,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;A9FijlBJ;;A8F9ilBA;EACI,8BAAA;A9FijlBJ;;A8F9ilBA;EACI,cAAA;EACA,qBAAA;A9FijlBJ;;A8F9ilBA;EACI,8BAAA;A9FijlBJ;;A8F9ilBA;;EAEI,cAAA;A9FijlBJ;;A8F9ilBA;;EAEI,cAAA;A9FijlBJ;;A8F9ilBA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;A9FijlBJ;;A8F9ilBA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;A9FijlBJ;;A8F9ilBA;EACI,iBAAA;A9FijlBJ;;A8F9ilBA;EACI,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,+CAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;A9FijlBJ;;A8F9ilBA;EACI,yBAAA;A9FijlBJ;;A8F9ilBA;EACI,kBAAA;EACA,cAAA;EACA,cAAA;EACA,qBAAA;A9FijlBJ;;A8F9ilBA;EACI,8BAAA;A9FijlBJ;;A8F9ilBA;;EAEI,cAAA;A9FijlBJ;;A8F9ilBA;;EAEI,cAAA;A9FijlBJ;;A8F9ilBA;EACI,kBAAA;EACA,oBAAA;EACA,sCAAA;EACA,UAAA;A9FijlBJ;;A8F9ilBA;EACI,iBAAA;A9FijlBJ;;A8F9ilBA;EAEI;;;IAGI,aAAA;E9FgjlBN;AACF;A8F7ilBA;EACI,aAAA;A9F+ilBJ;;A8F5ilBA;EACI,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,2BAAA;A9F+ilBJ;;A8F5ilBA;EACI,yBAAA;A9F+ilBJ;;A8F5ilBA;EACI;IACI,eAAA;E9F+ilBN;AACF;A8F5ilBA;EACI,yBAAA;A9F8ilBJ;;A8F3ilBA;EACI,wCAAA;A9F8ilBJ;;A8F3ilBA;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;EACA,6BAAA;EACA,oBAAA;A9F8ilBJ;;A8F3ilBA;;;EAGI,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EAGA,gBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;A9F8ilBJ;;A8F3ilBA;;EAEI,mBAAA;A9F8ilBJ;;A8F3ilBA;EACI,iBAAA;EACA,kBAAA;EACA,qBAAA;A9F8ilBJ;;A8F3ilBA;EACI,YAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,6FAAA;EAGA,gBAAA;A9F8ilBJ;;A8F3ilBA;EACI,8BAAA;EACA,qHAAA;A9F8ilBJ;;A8F3ilBA;EACI,mDAAA;A9F8ilBJ;;A8F3ilBA;EACI,kBAAA;A9F8ilBJ;;A8F3ilBA;EACI,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,4CAAA;EACA,sBAAA;EACA,gBAAA;A9F8ilBJ;;A8F3ilBA;EACI,YAAA;EACA,yBAAA;EACA,mHAAA;A9F8ilBJ;;A8F3ilBA;EACI,aAAA;A9F8ilBJ;;A8F3ilBA;EACI,eAAA;A9F8ilBJ;;A8F3ilBA;EACI,cAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,iCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;A9F8ilBJ;;A8F3ilBA;EACI,8BAAA;A9F8ilBJ;;A8F3ilBA;EACI,cAAA;EACA,yBAAA;A9F8ilBJ;;A8F3ilBA;EACI,cAAA;EACA,yCAAA;A9F8ilBJ;;A8F3ilBA;EACI,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;A9F8ilBJ;;A8F3ilBA;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,2BAAA;A9F8ilBJ;;A8F3ilBA;EACI,aAAA;EACA,YAAA;EACA,aAAA;A9F8ilBJ;;A8F3ilBA;EACI,6BAAA;A9F8ilBJ;;A8F3ilBA;EACI,cAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;A9F8ilBJ;;A8F3ilBA;EACI,cAAA;A9F8ilBJ;;A8F3ilBA;EACI;IACI,mBAAA;E9F8ilBN;E8F3ilBE;IACI,kBAAA;IACA,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,eAAA;IACA,qCAAA;E9F6ilBN;E8F1ilBE;IACI,2BAAA;IACA,kBAAA;E9F4ilBN;AACF;A8FzilBA;EACI;IACI,kBAAA;IACA,QAAA;IACA,WAAA;IACA,yBAAA;E9F2ilBN;E8FxilBE;IACI,QAAA;IACA,UAAA;E9F0ilBN;AACF;A8FvilBA;EACI,eAAA;EACA,WAAA;EACA,SAAA;A9FyilBJ;;A8FtilBA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,qBAAA;A9FyilBJ;;A8FtilBA;EACI;IACI,kBAAA;IACA,QAAA;IACA,WAAA;IACA,aAAA;IACA,uBAAA;E9FyilBN;E8FtilBE;IACI,aAAA;E9FwilBN;AACF;A8FrilBA;;;EAGI,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A9FuilBJ;;A8FpilBA;;;EAGI,2BAAA;A9FuilBJ;;A8FpilBA;;;EAGI,qBAAA;A9FuilBJ;;A8FpilBA;;;EAGI,yBAAA;EACA,yBAAA;A9FuilBJ;;A8FpilBA;;;EAGI,aAAA;A9FuilBJ;;A8FpilBA;;;EAGI,6BAAA;A9FuilBJ;;A8FpilBA;;;EAGI,qBAAA;EACA,yBAAA;A9FuilBJ;;A8FpilBA;EACI,aAAA;A9FuilBJ;;A8FpilBA;EACI,gBAAA;A9FuilBJ;;A8FpilBA;EACI;IACI,aAAA;E9FuilBN;E8FpilBE;IACI,iBAAA;E9FsilBN;AACF;A8FnilBA;EACI,qBAAA;A9FqilBJ;;A8FlilBA;EACI,qBAAA;A9FqilBJ;;A8FlilBA;EACI,mBAAA;A9FqilBJ;;A8FlilBA;EACI,YAAA;A9FqilBJ;;A8FlilBA;EACI,oCAAA;A9FqilBJ;;A8FlilBA;EACI,YAAA;EACA,eAAA;A9FqilBJ;;A8FlilBA;EACI,kBAAA;A9FqilBJ;;A8FlilBA;EACI;IACI,iBAAA;E9FqilBN;E8FlilBE;IACI,aAAA;E9FoilBN;AACF;A8FjilBA;EACI,eAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;A9FmilBJ;;A8FhilBA;EACI,aAAA;A9FmilBJ;;A8FhilBA;EACI;IACI,YAAA;IACA,SAAA;IACA,yBAAA;IACA,YAAA;IACA,sBAAA;E9FmilBN;E8FhilBE;IACI,OAAA;E9FkilBN;E8F/hlBE;IACI,yBAAA;E9FiilBN;AACF;A8F9hlBA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EACA,oEAAA;EACA,oBAAA;A9FgilBJ;;A8F7hlBA;EACI;IACI,UAAA;IACA,mBAAA;E9FgilBN;AACF;A8F7hlBA;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gCAAA;A9F+hlBJ;;A8F5hlBA;EACI,qBAAA;A9F+hlBJ;;A8F5hlBA;EACI;IACI,aAAA;E9F+hlBN;AACF;A8F5hlBA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,wEAAA;A9F8hlBJ;;A8F3hlBA;EACI,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;A9F8hlBJ;;A8F3hlBA;EACI,eAAA;EACA,cAAA;A9F8hlBJ;;A8F3hlBA;EACI,gBAAA;A9F8hlBJ;;A8F3hlBA;EACI,mBAAA;A9F8hlBJ;;A8F3hlBA;EACI,eAAA;EACA,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,6BAAA;A9F8hlBJ;;A8F3hlBA;EACI,qBAAA;A9F8hlBJ;;A8F3hlBA;EACI,aAAA;A9F8hlBJ;;A8F3hlBA;EACI,aAAA;A9F8hlBJ;;A8F3hlBA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EAEA,4BAAA;A9F8hlBJ;;A8F3hlBA;EACI,yBAAA;A9F8hlBJ;;A8F3hlBA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;A9F8hlBJ;;A8F3hlBA;EACI,cAAA;A9F8hlBJ;;A8F3hlBA;;EAEI,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,uCAAA;A9F8hlBJ;;A8F3hlBA;;EAEI,8BAAA;A9F8hlBJ;;A8F3hlBA;;EAEI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;A9F8hlBJ;;A8F3hlBA;;;;EAII,cAAA;A9F8hlBJ;;A8F3hlBA;;;;EAII,cAAA;A9F8hlBJ;;A8F3hlBA;;EAEI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,wCAAA;EACA,qCAAA;A9F8hlBJ;;A8F3hlBA;;EAEI,UAAA;EACA,iCAAA;A9F8hlBJ;;A8F3hlBA;EACI,gBAAA;EACA,iBAAA;A9F8hlBJ;;A8F3hlBA;EACI,kBAAA;A9F8hlBJ;;A8F3hlBA;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,kCAAA;EACA,eAAA;A9F8hlBJ;;A8F3hlBA;EACI,yCAAA;A9F8hlBJ;;A8F3hlBA;EACI,cAAA;A9F8hlBJ;;A8F3hlBA;EACI,cAAA;A9F8hlBJ;;A8F3hlBA;EACI,8BAAA;A9F8hlBJ;;A8F3hlBA;EACI,cAAA;A9F8hlBJ;;A8F3hlBA;EACI,cAAA;A9F8hlBJ;;A8F3hlBA;EACI,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;A9F8hlBJ;;A8F3hlBA;EACI,qBAAA;A9F8hlBJ;;A8F3hlBA;EACI;IACI,cAAA;E9F8hlBN;AACF;A8F3hlBA;EACI,iBAAA;A9F6hlBJ;;A8F1hlBA;;EAEI,gBAAA;EACA,gBAAA;A9F6hlBJ;;A8F1hlBA;;EAEI,eAAA;A9F6hlBJ;;A8F1hlBA;;EAEI,gBAAA;EACA,cAAA;A9F6hlBJ;;A8F1hlBA;EACI,cAAA;EACA,mBAAA;A9F6hlBJ;;A8F1hlBA;EACI,kBAAA;A9F6hlBJ;;A8F1hlBA;EACI,oEAAA;A9F6hlBJ;;A8F1hlBA;EACI,qEAAA;A9F6hlBJ;;A8F1hlBA;EACI,eAAA;EACA,iBAAA;A9F6hlBJ;;A8F1hlBA;EACI;IACI,kBAAA;E9F6hlBN;E8F1hlBE;IACI,iBAAA;E9F4hlBN;AACF;A8FzhlBA;EACI,UAAA;EACA,mBAAA;A9F2hlBJ;;A8FxhlBA;EACI,mBAAA;A9F2hlBJ;;A8FxhlBA;EACI,UAAA;A9F2hlBJ;;A8FxhlBA;EACI,kBAAA;A9F2hlBJ;;A8FxhlBA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;A9F2hlBJ;;A8FxhlBA;EACI,UAAA;EACA,oEAAA;A9F2hlBJ;;A8FxhlBA;EACI,qEAAA;A9F2hlBJ;;A8FxhlBA;EACI,UAAA;EACA,mBAAA;A9F2hlBJ;;A8FxhlBA;EACI;IACI,SAAA;IACA,YAAA;IACA,iBAAA;IACA,uBAAA;E9F2hlBN;E8FxhlBE;IACI,mCAAA;E9F0hlBN;E8FvhlBE;;IAEI,aAAA;E9FyhlBN;E8FthlBE;IACI,kBAAA;E9FwhlBN;E8FrhlBE;IACI,iBAAA;E9FuhlBN;AACF;A8FphlBA;EACI,oBAAA;EACA,qBAAA;A9FshlBJ;;A8FnhlBA;EACI,cAAA;A9FshlBJ;;A8FnhlBA;EACI,kBAAA;A9FshlBJ;;A8FnhlBA;EACI,mBAAA;EACA,uBAAA;A9FshlBJ;;A8FnhlBA;EACI,cAAA;A9FshlBJ;;A8FnhlBA;;EAEI,WAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;A9FshlBJ;;A8FnhlBA;EACI,OAAA;EACA,yEAAA;A9FshlBJ;;A8FnhlBA;EACI,yEAAA;A9FshlBJ;;A8FnhlBA;EACI,QAAA;EACA,0EAAA;A9FshlBJ;;A8FnhlBA;EACI,0EAAA;A9FshlBJ;;A8FnhlBA;;EAEI,mBAAA;A9FshlBJ;;A+Fn7qBA;EACI,gBAAA;A/Fs7qBJ;A+Fn7qBQ;EACI,mDAAA;A/Fq7qBZ;A+Fh7qBQ;EACI,qDAAA;A/Fk7qBZ;A+F76qBQ;EACI,kDAAA;A/F+6qBZ;;A+Fz6qBI;EACI,wCAAA;A/F46qBR;A+Fz6qBI;EACI,0CAAA;A/F26qBR;A+Fx6qBI;EACI,uCAAA;A/F06qBR;;A+Fr6qBA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;A/Fw6qBJ;A+Ft6qBI;EACI,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;A/Fw6qBR;A+Ft6qBQ;EAEI,WAAA;EACA,YAAA;EACA,wBAAA;A/Fu6qBZ;A+Fp6qBQ;EAEI,WAAA;EACA,YAAA;EACA,wBAAA;A/Fq6qBZ;A+Fl6qBQ;EAEI,WAAA;EACA,YAAA;EACA,wBAAA;A/Fm6qBZ;A+F/5qBI;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAjHM;EAkHN,WAAA;EACA,YAAA;EACA,wEAAA;EACA,yBAAA;A/Fi6qBR;A+F/5qBQ;EACI,wCAAA;A/Fi6qBZ;A+F95qBQ;EACI,8BAAA;A/Fg6qBZ;A+F75qBQ;EACI,aAAA;EACA,sBAAA;EACA,oBAAA;A/F+5qBZ;A+F75qBY;EACI,gBAAA;A/F+5qBhB;A+F55qBY;EACI,eAAA;EACA,eAAA;A/F85qBhB;A+F15qBQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,yBA7IQ;EA8IR,cArJE;EAsJF,YAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;A/F45qBZ;;A+Fv5qBA;EACI,UAAA;EACA,mBAAA;A/F05qBJ;A+Fx5qBI;EACI,cAAA;A/F05qBR;A+FpjrBI;EAqJJ;IASQ,WAAA;IACA,gBAAA;IACA,gBAAA;E/F05qBN;AACF;;A+Fv5qBA;EACI,iBAAA;A/F05qBJ;A+Fx5qBI;EAEI,4BAAA;EACA,YAAA;EACA,aAAA;A/Fy5qBR;;A+Fr5qBA;EACI,aAAA;EACA,UAAA;EACA,sBAAA;EACA,iBAAA;A/Fw5qBJ;A+F3krBI;EA+KJ;IAOQ,WAAA;E/Fy5qBN;AACF;A+Fv5qBI;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;A/Fy5qBR;A+Ft5qBI;EACI,WAAA;EACA,iBAAA;A/Fw5qBR;A+Ft5qBQ;EACI,qBAAA;EACA,eAAA;EACA,WAAA;A/Fw5qBZ;;A+Fn5qBA;EACI,cAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;A/Fs5qBJ;;A+Fn5qBA;;EAEI,cAAA;EACA,kBAAA;A/Fs5qBJ;;A+Fn5qBA;;;EAGI,uBAAA;A/Fs5qBJ;;A+Fn5qBA;;;;;EAKI,cAAA;A/Fs5qBJ;;A+Fn5qBA;EACI,cAAA;A/Fs5qBJ;;A+Fn5qBA;;;;;EAKI,cAAA;A/Fs5qBJ;;A+Fn5qBA;;EAEI,cAAA;A/Fs5qBJ;;A+Fn5qBA;;;;;;;;EAQI,cAAA;A/Fs5qBJ;;A+Fn5qBA;;;;;;EAMI,cAAA;A/Fs5qBJ;;A+Fn5qBA;EACI,kBAAA;A/Fs5qBJ;;A+Fn5qBA;EACI,iBAAA;A/Fs5qBJ;;A+Fn5qBA;EACI,0BAAA;A/Fs5qBJ;;AgGlsrBA;;;EACI,kBrEgDsB;EqE/CtB,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AhGusrBJ;AgG9rrBE;EACE,iBAAA;EACA,kBAAA;EACA,QAAA;AhGgsrBJ;AgG9rrBI;EAEE,uBAAA;EACA,kBAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,iBrEkCsB;EqEjCtB,UAAA;AhG+rrBN;AgG5rrBI;EACE,4BrEUqB;A3BorrB3B;;AgG1rrBE;EAGE,MAAA;EACA,gBAAA;AhG2rrBJ;AgGzrrBI;EAEE,gBAAA;EACA,4BrEJyB;A3B8rrB/B;AgGvrrBI;EACE,MAAA;AhGyrrBN;AgGtrrBI;EACE,SAAA;EACA,4BrEZqB;A3BosrB3B;;AgGprrBE;EAGE,SAAA;EACA,mBAAA;AhGqrrBJ;AgGnrrBI;EAEE,mBAAA;EACA,sBAAA;AhGorrBN;AgGjrrBI;EACE,SAAA;AhGmrrBN;AgGhrrBI;EACE,YAAA;EACA,yBrElCqB;A3BotrB3B;;AiGhwrBA;EACE,qBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AjGmwrBF;;AiGhwrBA;EACE,2DtEgDwB;EsE/CxB,iBtE8CsB;EsE7CtB,sBAAA;EACA,WtEqCuB;EsEpCvB,yBAAA;EACA,qBtEwC0B;EsEvC1B,qBAAA;EACA,kBAAA;AjGmwrBF;;AiG/vrBE;EACE,UAAA;AjGkwrBJ;AiG/vrBE;EACE,cAAA;AjGiwrBJ;AiG9vrBE;;EAEE,iCAAA;EACA,kCAAA;AjGgwrBJ;;AiG5vrBA;EACE,kBAAA;EACA,UAAA;AjG+vrBF;;AiG5vrBA;EACE,UAAA;AjG+vrBF;AiG7vrBE;EACE,iBAAA;AjG+vrBJ;AiGtvrBI;EACE,UAAA;EACA,WAAA;AjGwvrBN;AiGpvrBE;EACE,oBAAA;AjGsvrBJ;AiG/urBE;EACE,iBtEJwB;A3BqvrB5B;AiG/urBI;EACE,UAAA;EACA,WAAA;AjGivrBN;AiG7urBE;EACE,kBtEbwB;A3B4vrB5B;AiG7urBI;EACE,UAAA;EACA,WAAA;AjG+urBN;;AiG1urBA;EACE,kBAAA;EACA,yBtE5C6B;EsE6C7B,gCAAA;EACA,8BtEpC0B;EsEqC1B,cAAA;EACA,kBAAA;AjG6urBF;AiG3urBE;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;AjG6urBJ;AiG3urBI;EACE,yBAAA;AjG6urBN;AiGzurBE;EACE,+BtEnDwB;A3B8xrB5B;;AiGvurBA;;;;;;EAME,qBAAA;EACA,aAAA;AjG0urBF;;AiGvurBA;;;EAGE,aAAA;EACA,WtEzEyB;EsE0EzB,iBAAA;EACA,mBAAA;AjG0urBF;;AiGvurBA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;AjG0urBF;;AiGvurBA;EACE,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,YtEnFmC;EsEoFnC,WtEpFmC;EsEqFnC,mBAAA;EACA,gBAAA;AjG0urBF;AiGxurBE;EACE,SAAA;AjG0urBJ;AiGvurBE;EACE,UAAA;AjGyurBJ;AiGvurBI;EACE,WAAA;AjGyurBN;AiGrurBE;EACE,kBAAA;EACA,MAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AjGuurBJ;AiGrurBI;EACE,QAAA;AjGuurBN;AiGpurBI;EACE,SAAA;AjGsurBN;AiGjurBI;EACE,qBAAA;AjGmurBN;;AiG9trBA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,QAAA;AjGiurBF;AiG3trBE;EACE,UAAA;AjG6trBJ;AiG3trBI;EACE,wBAAA;EACA,UAAA;AjG6trBN;AiGztrBE;EACE,WAAA;AjG2trBJ;AiGztrBI;EACE,yBAAA;EACA,WAAA;AjG2trBN;;AiGttrBA;EACE,WAAA;AjGytrBF;;AiGttrBA;EACE,ctE9JmB;EsE+JnB,kBAAA;AjGytrBF;AiGvtrBE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AjGytrBJ;AiGttrBE;EACE,qBAAA;EACA,WAAA;EACA,WAAA;AjGwtrBJ;;AiGptrBA;EACE,ctE/KmB;EsEgLnB,kBAAA;AjGutrBF;AiGrtrBE;;EAEE,qBAAA;EACA,WAAA;EACA,WAAA;AjGutrBJ;;AiGntrBA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;AjGstrBF;AiGptrBE;EACE,qBAAA;AjGstrBJ;AiGntrBE;EACE,qBAAA;AjGqtrBJ;AiGntrBI;EACE,qBAAA;EACA,iBAAA;AjGqtrBN;AiGntrBM;EACE,WAAA;AjGqtrBR;AiGltrBM;;EAEE,wBAAA;EACA,SAAA;AjGotrBR;AiGjtrBM;EACE,0BAAA;AjGmtrBR;AiG/srBI;EACE,gBAAA;EACA,qBAAA;AjGitrBN;;AiG5srBA;EACE,YAAA;EACA,8BAAA;EACA,WAAA;AjG+srBF;AiG7srBE;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;AjG+srBJ;AiG5srBE;EACE,kBAAA;EACA,iBAAA;EACA,kCAAA;AjG8srBJ;AiG5srBI;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,kCAAA;AjG8srBN;AiG5srBM;EACE,gBAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;AjG8srBR;AiG5srBQ;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;AjG8srBV;AiG5srBU;EACE,eAAA;EACA,yBtE/RmB;A3B6+rB/B;AiG3srBU;EACE,yBtE/RiB;EsEgSjB,YAAA;EACA,iBAAA;AjG6srBZ;AiG3srBY;EACE,yBtEpSe;A3Bi/rB7B;AiGzsrBU;EACE,WtE1Sc;A3Bq/rB1B;AiGzsrBY;EACE,eAAA;EACA,6BAAA;AjG2srBd;;AiGlsrBA;EACE,WtExTwB;EsEyTxB,qBAAA;EACA,atE5SsB;EsE6StB,mBtE7SsB;EsE8StB,kBAAA;EACA,gBtErTuB;A3B0/rBzB;AiGnsrBE;EACE,eAAA;AjGqsrBJ;AiGnsrBI;EACE,qBtE5TsB;EsE6TtB,yBtEvUyB;A3B4gsB/B;;AiGhsrBA;;EAEE,mBAAA;AjGmsrBF;;AiGhsrBA;EACE,mBAAA;AjGmsrBF;;AiGhsrBA;;;EAGE,WtEnVuB;EsEoVvB,qBAAA;EACA,atEzUsB;EsE0UtB,mBtE1UsB;EsE2UtB,kBAAA;EACA,gBtElVuB;A3BqhsBzB;;AiG9rrBE;;;;EAGE,qBtE3VwB;EsE4VxB,yBtElWyB;EsEmWzB,WAAA;AjGksrBJ;AiGhsrBI;;;;EACE,yBAAA;AjGqsrBN;AiGjsrBE;;EACE,WtE5WsB;EsE6WtB,oBAAA;AjGosrBJ;AiGlsrBI;;EACE,eAAA;EACA,6BAAA;AjGqsrBN;;AiGhsrBA;;;;EAIE,eAAA;AjGmsrBF;AiGjsrBE;;;;EACE,qBtEtXwB;EsEuXxB,yBtEjY2B;A3BuksB/B;AiGnsrBE;;;;EACE,iBAAA;AjGwsrBJ;AiGrsrBE;;;;EACE,qBtE/XwB;EsEgYxB,yBtExY4B;EsEyY5B,WAAA;AjG0srBJ;AiGxsrBI;;;;EACE,yBAAA;AjG6srBN;AiG1srBI;;;;EACE,cAAA;AjG+srBN;AiG5srBI;;;;EACE,YAAA;AjGitrBN;AiG7srBE;;;;;;;;;;EAGE,qBtEnZwB;EsEoZxB,yBtE1ZyB;EsE2ZzB,WAAA;AjGstrBJ;AiGptrBI;;;;;;;;;;EACE,yBAAA;AjG+trBN;AiG3trBE;;;;EACE,qBtE7ZwB;EsE8ZxB,yBAAA;EACA,WAAA;AjGgurBJ;AiG9trBI;;;;EACE,yBAAA;AjGmurBN;AiG/trBE;;;;;;;;;;;;;;;;EACE,yCAAA;AjGgvrBJ;AiG5urBI;;;;;;;;;;;;;;;;EACE,yBtEtbyB;EsEubzB,WtElbmB;A3B+qsBzB;AiGzvrBE;;;;EACE,eAAA;EACA,WtE1bsB;A3BwrsB1B;AiG5vrBI;;;;EACE,6BAAA;AjGiwrBN;;AiGtvrBI;;;;;EACE,yBtExcuB;A3BqssB7B;AiGzvrBE;;EACE,yBtEjd2B;A3B6ssB/B;;AiGxvrBA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;AjG2vrBF;;AiGxvrBA;;;EAGE,6BAAA;EACA,qBtErd0B;EsEsd1B,kBAAA;AjG2vrBF;AiGzvrBE;;;EACE,eAAA;AjG6vrBJ;AiG3vrBI;;;;;;EAEE,yBAAA;AjGiwrBN;AiG7vrBE;;;EAGE,yBAAA;EACA,YAAA;EACA,MAAA;AjG+vrBJ;;AiG3vrBA;;;EAGE,yBtEvf6B;EsEwf7B,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,qBtEpf0B;EsEqf1B,yBAAA;AjG8vrBF;AiG5vrBE;;;EACE,eAAA;AjGgwrBJ;AiG7vrBE;;;EACE,aAAA;EACA,kBAAA;AjGiwrBJ;;AiG7vrBA;;;EAGE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AjGgwrBF;AiG9vrBE;;;EACE,8BtE3gBwB;EsE4gBxB,+BtE5gBwB;A3B8wsB5B;AiG/vrBE;;;EACE,yBAAA;EAGA,iBAAA;EACA,iCtEphBwB;EsEqhBxB,kCtErhBwB;A3BwxsB5B;AiGhwrBE;;;EACE,sBtEhiBsB;A3BoysB1B;AiGlwrBI;;;EACE,4BAAA;AjGswrBN;AiGnwrBI;;;EACE,yBAAA;AjGuwrBN;AiGnwrBE;;;EACE,kBAAA;EACA,UAAA;AjGuwrBJ;;AiGnwrBA;EACE,eAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AjGswrBF;AiGpwrBE;EACE,eAAA;EACA,yBtE/jByB;EsEgkBzB,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;AjGswrBJ;;AiGlwrBA;EACE,mBtEnlB6B;EsEolB7B,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AjGqwrBF;;AiGlwrBA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,OAAA;EACA,MAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AjGqwrBF;AiGnwrBE;;;EAGE,WAAA;EACA,iBAAA;AjGqwrBJ;AiGlwrBE;EACE;;;IAGE,WAAA;IACA,iBAAA;EjGowrBJ;AACF;AiGjwrBE;;EAEE,kBAAA;AjGmwrBJ;;AAl5sBA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;AAq5sBJ;;AAl5sBA;EACE;IAEE,aAAA;IACA,gBAAA;IACA,cAAA;IACA,qBAAA;IACA,iBAAA;IACA,kBAAA;EAo5sBF;AACF;AAp3sBE;EACE;IACE,uBAAA;EAk5sBJ;EAh5sBE;IACE,yBAAA;EAk5sBJ;EAh5sBE;IACE,yCAAA;EAk5sBJ;EAh5sBE;IACE,uBAAA;EAk5sBJ;AACF;AA/4sBE;EACE,4BAAA;EACA,sBAAA;AAi5sBJ;;AA/4sBE;EACE,4BAAA;EACA,sBAAA;AAk5sBJ;;AA/4sBE;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AAk5sBJ;;AAh5sBE;;EAEE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,yBAAA;AAm5sBJ;;AAj5sBE;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,yCAAA;EACA,WAAA;EACA,mCAAA;EACA,yCAAA;EACA,yBAAA;EACA,kBAAA;AAo5sBJ;;AAl5sBA,aAAA;AACA;EACE,UAAA;EACA,YAAA;AAq5sBF;;AAn5sBA;;EAEE,6BAAA;EACA,+BAAA;AAs5sBF;;AAp5sBA;EACE,MAAA;EACA,OAAA;AAu5sBF;;AAr5sBA;EACE,SAAA;EACA,QAAA;AAw5sBF;;AAt5sBA;EACE,WAAA;EACA,SAAA;EACA,wBAAA;AAy5sBF;;AAt5sBA;EACE,gBAAA;AAy5sBF;;AAt5sBA;EACA,6DAEA;AAu5sBA","sourcesContent":["// @tailwind base;\r\n// @tailwind components;\r\n// @tailwind utilities;\r\n\r\n\r\n@import \"variables\";\r\n\r\n// $enable-ltr: true;\r\n// $enable-rtl: true;\r\n\r\n// Import CoreUI for React components library\r\n@import \"@coreui/coreui/scss/coreui\";\r\n// Import Chart.js custom tooltips styles\r\n@import \"@coreui/chartjs/scss/coreui-chartjs\";\r\n@import \"color-bg\";\r\n@import \"layout\";\r\n// @import \"example\";\r\n// If you want to add custom CSS you can put it here.\r\n@import \"custom\";\r\n@import \"animate\";\r\n@import \"pagination\";\r\n@import \"styletree\";\r\n@import \"datepicker\";\r\n\r\n\r\n.centered {\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n}\r\n\r\n@media screen, print {\r\n  .is-text-multiple {\r\n    // width: 90mm;\r\n    height: 130mm;\r\n    overflow: hidden;\r\n    line-height: 1;\r\n    display: inline-table;\r\n    margin-left: 20px;\r\n    margin-right: 20px;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes color_change {\r\n    0% {\r\n      background-color: white;\r\n    }\r\n    50% {\r\n      background-color: #11f542;\r\n    }\r\n    70% {\r\n      background-color: rgba(7, 182, 45, 0.637);\r\n    }\r\n    100% {\r\n      background-color: white;\r\n    }\r\n  }\r\n  @-moz-keyframes color_change {\r\n    0% {\r\n      background-color: white;\r\n    }\r\n    50% {\r\n      background-color: #11f542;\r\n    }\r\n    70% {\r\n      background-color: rgba(7, 182, 45, 0.637);;\r\n    }\r\n    100% {\r\n      background-color: white;\r\n    }\r\n  }\r\n  \r\n  @keyframes color_change {\r\n    0% {\r\n      background-color: white;\r\n    }\r\n    50% {\r\n      background-color: #11f542;\r\n    }\r\n    70% {\r\n      background-color: rgba(7, 182, 45, 0.637);;\r\n    }\r\n    100% {\r\n      background-color: white;\r\n    }\r\n  }\r\n  \r\n  .has-anim {\r\n    animation-name: color_change;\r\n    animation-duration: 5s;\r\n  }\r\n  .rows-changed {\r\n    animation-name: color_change;\r\n    animation-duration: 5s;\r\n  }\r\n\r\n  .ribbon {\r\n    width: 150px;\r\n    height: 150px;\r\n    overflow: hidden;\r\n    position: absolute;\r\n  }\r\n  .ribbon::before,\r\n  .ribbon::after {\r\n    position: absolute;\r\n    z-index: -1;\r\n    content: '';\r\n    display: block;\r\n    border: 5px solid #2980b9;\r\n  }\r\n  .ribbon span {\r\n    position: absolute;\r\n    display: block;\r\n    width: 225px;\r\n    padding: 15px 0;\r\n    background-color: #3498db;\r\n    box-shadow: 0 5px 10px rgba(0,0,0,.1);\r\n    color: #fff;\r\n    font: 700 18px/1 'Lato', sans-serif;\r\n    text-shadow: 0 1px 1px rgba(0,0,0,.2);\r\n    text-transform: uppercase;\r\n    text-align: center;\r\n  }\r\n/* top right*/\r\n.ribbon-top-right {\r\n  top: -10px;\r\n  right: -10px;\r\n}\r\n.ribbon-top-right::before,\r\n.ribbon-top-right::after {\r\n  border-top-color: transparent;\r\n  border-right-color: transparent;\r\n}\r\n.ribbon-top-right::before {\r\n  top: 0;\r\n  left: 0;\r\n}\r\n.ribbon-top-right::after {\r\n  bottom: 0;\r\n  right: 0;\r\n}\r\n.ribbon-top-right span {\r\n  left: -25px;\r\n  top: 30px;\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.sidebar-nav .nav-link.active {\r\n  font-weight: 700;\r\n}\r\n\r\n.bg-dashboard {\r\nbackground:\r\n\r\nlinear-gradient(\r\n180deg,\r\n#F6FBF8 0%,\r\n#EDF5F2 100%\r\n);\r\n}","@mixin bsBanner($file) {\n  /*!\n   * CoreUI #{$file} v4.3.0 (https://coreui.io)\n   * Copyright (c) 2023 creativeLabs Łukasz Holeczek\n   * Licensed under MIT (https://github.com/coreui/coreui/blob/main/LICENSE)\n   */\n}\n",":root {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}high-emphasis: #{$text-high-emphasis};\n  --#{$prefix}medium-emphasis: #{$text-medium-emphasis};\n  --#{$prefix}disabled: #{$text-disabled};\n\n  --#{$prefix}high-emphasis-inverse: #{$text-high-emphasis-inverse};\n  --#{$prefix}medium-emphasis-inverse: #{$text-medium-emphasis-inverse};\n  --#{$prefix}disabled-inverse: #{$text-disabled-inverse};\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.0.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\n// ol,\n// ul {\n//   @include ltr-rtl(\"padding-left\", 2rem); // TODO: find solution\n// }\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  @include ltr-rtl(\"margin-left\", 0); // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}pre-color, $pre-color);\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: var(--#{$prefix}kbd-color, $kbd-color);\n  background-color: var(--#{$prefix}kbd-bg, $kbd-bg);\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: var(--#{$prefix}table-caption-color, $table-caption-color);\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  @include ltr-rtl(\"float\", left); // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n\n*[dir=\"rtl\"] {\n  [type=\"tel\"],\n  [type=\"url\"],\n  [type=\"email\"],\n  [type=\"number\"] {\n    direction: ltr;\n  }\n}\n\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:     #fff !default;\n$gray-base: #3c4b64 !default;\n$gray-100:  #ebedef !default;\n$gray-200:  #d8dbe0 !default;\n$gray-300:  #c4c9d0 !default;\n$gray-400:  #b1b7c1 !default;\n$gray-500:  #9da5b1 !default;\n$gray-600:  #8a93a2 !default;\n$gray-700:  #768192 !default;\n$gray-800:  #636f83 !default;\n$gray-900:  #4f5d73 !default;\n$black:     #000015 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n$high-emphasis:            rgba(shift-color($gray-base, +26%), .95) !default;\n$medium-emphasis:          rgba(shift-color($gray-base, +26%), .681) !default;\n$disabled:                 rgba(shift-color($gray-base, +26%), .38) !default;\n\n$high-emphasis-inverse:    rgba($white, .87) !default;\n$medium-emphasis-inverse:  rgba($white, .6) !default;\n$disabled-inverse:         rgba($white, .38) !default;\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// fusv-disable\n$primary-dark:  #1f1498 !default;\n$primary-base:  #321fdb !default;\n$primary-50:    #988fed !default;\n$primary-25:    #ccc7f6 !default;\n\n$secondary-dark:  #212233 !default;\n$secondary-base:  #9da5b1 !default;\n$secondary-50:    #9da5b1 !default;\n$secondary-25:    #ced2d8 !default;\n\n$success-dark:  #1b9e3e !default;\n$success-base:  #2eb85c !default;\n$success-50:    #96dbad !default;\n$success-25:    #cbedd6 !default;\n\n$info-dark:  #2982cc !default;\n$info-base:  #39f !default;\n$info-50:    #80c6ff !default;\n$info-25:    #c0e6ff !default;\n\n$warning-dark:  #f6960b !default;\n$warning-base:  #f9b115 !default;\n$warning-50:    #fcd88a !default;\n$warning-25:    #feecc5 !default;\n\n$danger-dark:  #d93737 !default;\n$danger-base:  #e55353 !default;\n$danger-50:    #f2a9a9 !default;\n$danger-25:    #f9d4d4 !default;\n\n$light-dark:     $gray-100 !default;\n$light-base:     $gray-100 !default;\n$light-50:       shift-color($light-base, -70%) !default;\n$light-25:       shift-color($light-base, -80%) !default;\n\n$dark-dark:      $gray-900 !default;\n$dark-base:      $gray-900 !default;\n$dark-50:        shift-color($dark-base, -70%) !default;\n$dark-25:        shift-color($dark-base, -80%) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $primary-base !default;\n$secondary:     $secondary-base !default;\n$success:       $success-base !default;\n$info:          $info-base !default;\n$warning:       $warning-base !default;\n$danger:        $danger-base !default;\n$light:         $light-base !default;\n$dark:          $dark-base !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-colors-rgb\n$theme-colors-rgb: map-loop($theme-colors, to-rgb, \"$value\") !default;\n// scss-docs-end theme-colors-rgb\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $high-emphasis-inverse !default;\n$color-contrast-light:     $high-emphasis !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n$enable-ltr:                  true !default;\n$enable-rtl:                  false !default;\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             cui- !default; // Deprecated in v4.3.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Set mobile breakpoint\n\n$mobile-breakpoint:           md !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $high-emphasis !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      $medium-emphasis !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       $disabled !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n\n$border-style:                solid !default;\n$border-color:                $gray-200 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.0.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $high-emphasis-inverse !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:                $font-size-base * 1.25 !default;\n$lead-font-weight:              300 !default;\n\n$small-font-size:               .875em !default;\n\n$sub-sup-font-size:             .75em !default;\n\n$text-high-emphasis:            $high-emphasis !default;\n$text-medium-emphasis:          $medium-emphasis !default;\n$text-disabled:                 $disabled !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 4.3.0\n// fusv-enable\n\n$text-high-emphasis-inverse:    $high-emphasis-inverse !default;\n$text-medium-emphasis-inverse:  $medium-emphasis-inverse !default;\n$text-disabled-inverse:         $disabled-inverse !default;\n\n$initialism-font-size:          $small-font-size !default;\n\n$blockquote-margin-y:           $spacer !default;\n$blockquote-font-size:          $font-size-base * 1.25 !default;\n$blockquote-footer-color:       $gray-600 !default;\n$blockquote-footer-font-size:   $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v4.2.6\n$hr-height:                   null !default; // Deprecated in v4.2.6\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n// Icons\n$icon-size-base:  1rem !default;\n$icon-size-sm:    $icon-size-base * .875 !default;\n$icon-size-lg:    $icon-size-base * 1.25 !default;\n$icon-size-xl:    $icon-size-base * 1.5 !default;\n$icon-size-xxl:   $icon-size-base * 2 !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}body-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba($black, $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba($black, $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba($black, $table-hover-bg-factor) !default;\n\n$table-border-factor:         .1 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n\n// scss-docs-start button-variants\n$button-variants: (\n  \"primary\": btn-color-map($primary, $primary),\n  \"secondary\": btn-color-map($secondary, $secondary),\n  \"success\": btn-color-map($success, $success),\n  \"danger\": btn-color-map($danger, $danger),\n  \"warning\": btn-color-map($warning, $warning),\n  \"info\": btn-color-map($info, $info),\n  \"light\": btn-color-map($light, $light),\n  \"dark\": btn-color-map($dark, $dark)\n) !default;\n\n$button-outline-ghost-variants: (\n  \"primary\": btn-outline-color-map($primary),\n  \"secondary\": btn-outline-color-map($secondary),\n  \"success\": btn-outline-color-map($success),\n  \"danger\": btn-outline-color-map($danger),\n  \"warning\": btn-outline-color-map($warning),\n  \"info\": btn-outline-color-map($info),\n  \"light\": btn-outline-color-map($light),\n  \"dark\": btn-outline-color-map($dark)\n) !default;\n// scss-docs-end button-variants\n// scss-docs-end btn-variables\n\n\n// Forms\n// scss-docs-start form-variables\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      $box-shadow-inset !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n\n$form-switch-widths: (\n  lg: (\n    width: 1.75em,\n    height: 1.25em\n  ),\n  xl: (\n    width: 2em,\n    height: 1.5em\n  )\n) !default;\n// scss-docs-end form-switch-variables\n\n$form-check-inline-margin-end:    1rem !default;\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          $box-shadow-inset !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     $box-shadow-inset !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n// scss-docs-end form-variables\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-sidebar-backdrop:           1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               $box-shadow !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v4.2.6\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $high-emphasis-inverse !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%) !default;\n$accordion-button-active-color:           shade-color($primary, 10%) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $accordion-button-color !default;\n$accordion-icon-active-color:             $accordion-button-active-color !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 4.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                $box-shadow !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in 4.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $high-emphasis-inverse !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n$badge-font-size-sm:                .65em !default;\n$badge-padding-y-sm:                .3em !default;\n$badge-padding-x-sm:                .5em !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       $box-shadow-sm !default;\n$modal-content-box-shadow-sm-up:    $box-shadow !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Avatars\n// scss-docs-start avatar-variables\n$avatar-width:  2rem !default;\n\n$avatar-widths: (\n  sm: 1.5rem,\n  md: 2.5rem,\n  lg: 3rem,\n  xl: 4rem\n) !default;\n\n$avatar-transition: margin .15s !default;\n// scss-docs-end avatar-variables\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-bg-scale:                -80% !default;\n$alert-border-scale:            -70% !default;\n$alert-color-scale:             40% !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// scss-docs-start alert-variants\n$alert-variants: () !default;\n@each $state, $value in $theme-colors {\n  $map: ();\n  $alert-variants: map-merge($alert-variants, map-merge($map, ($state: alert-color-map($value))));\n}\n\n// Callouts\n// scss-docs-start callout-variables\n$callout-padding-y:                 $spacer !default;\n$callout-padding-x:                 $spacer !default;\n$callout-margin-y:                  $spacer !default;\n$callout-margin-x:                  0 !default;\n$callout-border-radius:             var(--#{$prefix}border-radius) !default;\n$callout-border-width:              var(--#{$prefix}border-width) !default;\n$callout-border-color:              var(--#{$prefix}border-color) !default;\n$callout-border-left-width:         calc($callout-border-width * 4) !default; // stylelint-disable-line function-disallowed-list\n\n$callout-variants: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"danger\":     $danger,\n  \"warning\":    $warning,\n  \"info\":       $info,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end callout-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $high-emphasis-inverse !default;\n$progress-bar-bg:                   var(--#{$prefix}primary) !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n$progress-group-margin-bottom:         $spacer !default;\n$progress-group-header-margin-bottom:  $spacer * .25 !default;\n// scss-docs-end progress-variables\n\n// List group\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n$list-group-item-bg-scale:          -80% !default;\n$list-group-item-color-scale:       40% !default;\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n$list-group-variants: (\n  \"primary\": list-group-color-map($primary),\n  \"secondary\": list-group-color-map($secondary),\n  \"success\": list-group-color-map($success),\n  \"danger\": list-group-color-map($danger),\n  \"warning\": list-group-color-map($warning),\n  \"info\": list-group-color-map($info),\n  \"light\": list-group-color-map($light),\n  \"dark\": list-group-color-map($dark)\n) !default;\n// scss-docs-end list-group-variables\n\n\n// Header\n// scss-docs-start header-variables\n$header-min-height:             4rem !default;\n$header-padding-y:              $spacer * .5 !default;\n$header-padding-x:              $spacer * .5 !default;\n$header-brand-font-size:        $font-size-lg !default;\n$header-color:                  rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$header-bg:                     var(--#{$prefix}body-bg) !default;\n$header-border-color:           var(--#{$prefix}border-color) !default;\n$header-border-width:           var(--#{$prefix}border-width) !default;\n$header-hover-color:            rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$header-active-color:           rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$header-disabled-color:         rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n\n// Compute the header-brand padding-y so the header-brand will have the same height as header-text and nav-link\n$nav-link-height:               $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$header-brand-height:           $header-brand-font-size * $line-height-base !default;\n$header-brand-padding-y:        ($nav-link-height - $header-brand-height) * .5 !default;\n$header-brand-margin-end:       1rem !default;\n$header-brand-font-size:        $font-size-lg !default;\n$header-brand-color:            $gray-900 !default;\n$header-brand-hover-color:      shade-color($gray-900, 10%) !default;\n\n$header-toggler-padding-y:      .25rem !default;\n$header-toggler-padding-x:      .75rem !default;\n$header-toggler-font-size:      $font-size-lg !default;\n$header-toggler-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$header-toggler-bg:             transparent !default;\n$header-toggler-border-radius:  $btn-border-radius !default;\n$header-toggler-hover-color:    rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n\n$header-toggler-icon-color:        currentColor !default; // stylelint-disable-line value-keyword-case\n$header-toggler-icon-bg:           url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-toggler-icon-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\") !default;\n$header-toggler-hover-icon-color:  currentColor !default; // stylelint-disable-line value-keyword-case\n$header-toggler-hover-icon-bg:     url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-toggler-hover-icon-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\") !default;\n\n$header-nav-link-padding-x:     .5rem !default;\n$header-nav-link-padding-y:     .5rem !default;\n\n$header-divider-border-width:   var(--#{$prefix}border-width) !default;\n$header-divider-border-color:   var(--#{$prefix}border-color) !default;\n// scss-docs-end header-variables\n\n// Subheader\n// scss-docs-start subheader-variables\n$subheader-min-height:           3rem !default;\n$subheader-padding-y:            $spacer * .5 !default;\n$subheader-padding-x:            $spacer !default;\n$subheader-border-color:         var(--#{$prefix}border-color) !default;\n$subheader-border-width:         var(--#{$prefix}border-width) !default;\n\n$subheader-nav-link-padding-x:  .5rem !default;\n// scss-docs-end subheader-variables\n\n// Default theme\n// scss-docs-start subheader-default-themes\n$subheader-bg:                     $white !default;\n$subheader-color:                  var(--#{$prefix}secondary-color) !default;\n$subheader-hover-color:            var(--#{$prefix}body-color) !default;\n$subheader-active-color:           var(--#{$prefix}body-color) !default;\n$subheader-disabled-color:         $disabled !default;\n// scss-docs-end subheader-default-themes\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n// scss-docs-start carousel-variables\n$carousel-control-color:             $high-emphasis-inverse !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $high-emphasis-inverse !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $high-emphasis !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n// scss-docs-start sidebar-variables\n$sidebar-width:                            16rem !default;\n$sidebar-widths: (\n  sm: 12rem,\n  lg: 20rem,\n  xl: 24rem\n) !default;\n$sidebar-padding-y:                        0 !default;\n$sidebar-padding-x:                        0 !default;\n$sidebar-color:                            $high-emphasis-inverse !default;\n$sidebar-bg:                               $gray-base !default;\n$sidebar-border-width:                     0 !default;\n$sidebar-border-color:                     transparent !default;\n$sidebar-transition:                       margin-left .15s, margin-right .15s, box-shadow .075s, transform .15s, width .15s, z-index 0s ease .15s !default;\n\n$sidebar-brand-height:                     4rem !default;\n$sidebar-brand-color:                      $high-emphasis-inverse !default;\n$sidebar-brand-bg:                         rgba($black, .2) !default;\n\n$sidebar-header-height:                    4rem !default;\n$sidebar-header-padding-y:                 .75rem !default;\n$sidebar-header-padding-x:                 1rem !default;\n$sidebar-header-bg:                        rgba($black, .2) !default;\n$sidebar-header-height-transition:         height .15s, padding .15s !default;\n\n$sidebar-narrow-width:                     4rem !default;\n\n$sidebar-backdrop-bg:                      $black !default;\n$sidebar-backdrop-opacity:                 .5 !default;\n\n$sidebar-nav-title-padding-y:              .75rem !default;\n$sidebar-nav-title-padding-x:              1rem !default;\n$sidebar-nav-title-margin-top:             1rem !default;\n$sidebar-nav-title-color:                  $medium-emphasis-inverse !default;\n$sidebar-nav-title-transition:             height .15s, margin .15s !default;\n\n$sidebar-nav-link-padding-y:               .8445rem !default;\n$sidebar-nav-link-padding-x:               1rem !default;\n$sidebar-nav-link-color:                   $medium-emphasis-inverse !default;\n$sidebar-nav-link-bg:                      transparent !default;\n$sidebar-nav-link-border-width:            0 !default;\n$sidebar-nav-link-border-color:            transparent !default;\n$sidebar-nav-link-border-radius:           0 !default;\n$sidebar-nav-link-transition:              background .15s ease, color .15s ease !default;\n$sidebar-nav-link-icon-color:              $medium-emphasis-inverse !default;\n\n$sidebar-nav-link-hover-color:             $high-emphasis-inverse !default;\n$sidebar-nav-link-hover-bg:                rgba($white, .05) !default;\n$sidebar-nav-link-hover-icon-color:        $high-emphasis-inverse !default;\n\n$sidebar-nav-link-active-color:            $high-emphasis-inverse !default;\n$sidebar-nav-link-active-bg:               rgba($white, .05) !default;\n$sidebar-nav-link-active-icon-color:       $high-emphasis-inverse !default;\n\n$sidebar-nav-link-disabled-color:          $disabled-inverse !default;\n$sidebar-nav-link-disabled-icon-color:     $sidebar-nav-link-icon-color !default;\n\n$sidebar-nav-icon-width:                   4rem !default;\n$sidebar-nav-icon-height:                  1.25rem !default;\n$sidebar-nav-icon-font-size:               $sidebar-nav-icon-height !default;\n\n$sidebar-nav-group-bg:                     rgba(0, 0, 0, .2) !default;\n$sidebar-nav-group-transition:             background .15s ease-in-out !default;\n$sidebar-nav-group-toggle-show-color:      $sidebar-nav-link-color !default;\n\n$sidebar-nav-group-items-padding-y:        0 !default;\n$sidebar-nav-group-items-padding-x:        0 !default;\n$sidebar-nav-group-items-transition:       height .15s ease !default;\n\n$sidebar-nav-group-indicator-color:        $medium-emphasis-inverse !default;\n$sidebar-nav-group-indicator-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$sidebar-nav-group-indicator-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$sidebar-nav-group-indicator-hover-color:  $sidebar-nav-link-hover-color !default;\n$sidebar-nav-group-indicator-hover-icon:   url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$sidebar-nav-group-indicator-hover-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$sidebar-nav-group-indicator-transition:   transform .15s !default;\n\n$sidebar-footer-height:                    auto !default;\n$sidebar-footer-padding-y:                 .75rem !default;\n$sidebar-footer-padding-x:                 1rem !default;\n$sidebar-footer-bg:                        rgba($black, .2) !default;\n$sidebar-footer-height-transition:         height .15s, padding .15s !default;\n\n$sidebar-toggler-height:                   3rem !default;\n$sidebar-toggler-bg:                       rgba($black, .2) !default;\n$sidebar-toggler-transition:               transform .15s !default;\n\n$sidebar-toggler-indicator-width:          4rem !default;\n$sidebar-toggler-indicator-height:         3rem !default;\n$sidebar-toggler-indicator-color:          $disabled-inverse !default;\n$sidebar-toggler-indicator-icon:           url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-toggler-indicator-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\") !default;\n$sidebar-toggler-hover-bg:                 rgba(0, 0, 0, .3) !default;\n$sidebar-toggler-indicator-hover-color:    $sidebar-nav-link-hover-color !default;\n$sidebar-toggler-indicator-hover-icon:     url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-toggler-indicator-hover-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\") !default;\n// scss-docs-end sidebar-variables\n\n// Footer\n// scss-docs-start footer-variables\n$footer-min-height:    3rem !default;\n$footer-padding-y:     $spacer * .5 !default;\n$footer-padding-x:     $spacer !default;\n$footer-bg:            var(--#{$prefix}tertiary-bg) !default;\n$footer-color:         var(--#{$prefix}body-color) !default;\n$footer-border-width:  var(--#{$prefix}border-width) !default;\n$footer-border-color:  var(--#{$prefix}border-color) !default;\n// scss-docs-end footer-variables\n\n// Spinners\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $high-emphasis !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v4.2.6, removing in v6\n\n$pre-color:                         null !default;\n","@mixin ltr {\n  @if $enable-ltr {\n    html:not([dir=\"rtl\"]) & {\n      @content;\n    }\n  }\n}\n\n@mixin rtl {\n  @if $enable-rtl {\n    *[dir=\"rtl\"] & {\n      @content;\n    }\n  }\n}\n\n@function reflect($element) {\n  $string: #{$element};\n  @if str-index($string, \"left\") {\n    @return str-replace($string, \"left\", \"right\");\n  }\n  @if str-index($string, \"right\") {\n    @return str-replace($string, \"right\", \"left\");\n  }\n\n  @return unquote($string);\n}\n\n@mixin ltr-rtl($property, $value, $property-rtl: null, $value-rtl: null, $important: null) {\n  $property-reflected: reflect($property);\n  $value-reflected: reflect($value);\n\n  @if $enable-ltr and $enable-rtl {\n    @include ltr() {\n      #{$property}: $value $important;\n    }\n    @include rtl() {\n      @if $value-rtl {\n        #{$property-reflected}: $value-rtl $important;\n      }\n      @else {\n        #{$property-reflected}: $value-reflected $important;\n      }\n    }\n  }\n  @else {\n    @if $enable-rtl {\n      @if $value-rtl {\n        #{$property-reflected}: $value-rtl $important;\n      }\n      @else {\n        #{$property-reflected}: $value-reflected $important;\n      }\n    }\n    @else {\n      #{$property}: $value $important;\n    }\n  }\n}\n\n@mixin ltr-rtl-value-only($property, $value, $value-rtl: null, $important: null) {\n  $value-reflected: reflect($value);\n\n  @if $enable-ltr and $enable-rtl {\n    @include ltr() {\n      #{$property}: $value $important;\n    }\n    @include rtl() {\n      @if $value-rtl {\n        #{$property}: $value-rtl $important;\n      } @else {\n        #{$property}: $value-reflected $important;\n      }\n    }\n  }\n  @else {\n    @if $enable-rtl {\n      @if $value-rtl {\n        #{$property}: $value-rtl $important;\n      } @else {\n        #{$property}: $value-reflected $important;\n      }\n    } @else {\n      #{$property}: $value $important;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-top-right-radius\", valid-radius($radius));\n    @include ltr-rtl(\"border-bottom-right-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-top-left-radius\", valid-radius($radius));\n    @include ltr-rtl(\"border-bottom-left-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-top-right-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-bottom-right-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-bottom-left-radius\", valid-radius($radius));\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    @include ltr-rtl(\"margin-right\", $list-inline-padding);\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  @include ltr-rtl(\"padding-left\", 0);\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: var(--#{$prefix}thumbnail-bg, $thumbnail-bg);\n  border: $thumbnail-border-width solid var(--#{$prefix}thumbnail-border-color, $thumbnail-border-color);\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: var(--#{$prefix}figure-caption-color, $figure-caption-color);\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","@mixin box-shadow($shadow...) {\n  @if $enable-shadows {\n    $result: ();\n\n    @each $value in $shadow {\n      @if $value != null {\n        $result: append($result, $value, \"comma\");\n      }\n      @if $value == none and length($shadow) > 1 {\n        @warn \"The keyword 'none' must be used as a single argument.\";\n      }\n    }\n\n    @if (length($result) > 0) {\n      box-shadow: $result;\n    }\n  }\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n\n  --#{$prefix}mobile-breakpoint: #{$mobile-breakpoint};\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  @include ltr-rtl(\"margin-left\", if($num == 0, 0, percentage($num)));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: divide(100%, $count);\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: var(--#{$prefix}form-label-color, $form-label-color);\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: var(--#{$prefix}form-label-color, $form-label-color);\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: var(--#{$prefix}form-text-color, $form-text-color);\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: var(--#{$prefix}input-color, $input-color);\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: var(--#{$prefix}input-bg, $input-bg);\n  background-clip: padding-box;\n  border: $input-border-width solid var(--#{$prefix}input-border-color, $input-border-color);\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: var(--#{$prefix}input-focus-color, $input-focus-color);\n    background-color: var(--#{$prefix}input-focus-bg, $input-focus-bg);\n    border-color: var(--#{$prefix}input-focus-border-color, $input-focus-border-color);\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  // Add some height to date inputs on iOS\n  // https://github.com/twbs/bootstrap/issues/23307\n  // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: var(--#{$prefix}input-placeholder-color, $input-placeholder-color);\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: var(--#{$prefix}form-file-button-color, $form-file-button-color);\n    @include gradient-bg(var(--#{$prefix}form-file-button-bg, $form-file-button-bg));\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: var(--#{$prefix}form-file-button-hover-bg, $form-file-button-hover-bg);\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: var(--#{$prefix}input-plaintext-color, $input-plaintext-color);\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  @include ltr-rtl-value-only(\"padding\", $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x, $form-select-padding-y $form-select-padding-x $form-select-padding-y $form-select-indicator-padding);\n  -moz-padding-start: subtract($form-select-padding-x, 3px); // See https://github.com/twbs/bootstrap/issues/32636\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: var(--#{$prefix}form-select-color, $form-select-color);\n  appearance: none;\n  background-color: var(--#{$prefix}form-select-bg, $form-select-bg);\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  @include ltr-rtl-value-only(\"background-position\", $form-select-bg-position);\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid var(--#{$prefix}form-select-border-color, $form-select-border-color);\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: var(--#{$prefix}form-select-focus-border-color, $form-select-focus-border-color);\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    @include ltr-rtl(\"padding-right\", $form-select-padding-x);\n    background-image: none;\n  }\n\n  &:disabled {\n    color: var(--#{$prefix}form-select-disabled-color, $form-select-disabled-color);\n    background-color: var(--#{$prefix}form-select-disabled-bg, $form-select-disabled-bg);\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 var(--#{$prefix}form-select-color, $form-select-color);\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  @include ltr-rtl(\"padding-left\", $form-select-padding-x-sm);\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  @include ltr-rtl(\"padding-left\", $form-select-padding-x-lg);\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  @include ltr-rtl(\"padding-left\", $form-check-padding-start);\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    @include ltr-rtl(\"float\", left);\n    @include ltr-rtl(\"margin-left\", $form-check-padding-start * -1);\n  }\n}\n\n.form-check-reverse {\n  @include ltr-rtl(\"padding-right\", $form-check-padding-start);\n  @include ltr-rtl(\"padding-left\", 0);\n  @include ltr-rtl(\"text-align\", right);\n\n  .form-check-input {\n    @include ltr-rtl(\"float\", right);\n    @include ltr-rtl(\"margin-right\", $form-check-padding-start * -1);\n    @include ltr-rtl(\"margin-left\", 0);\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: var(--#{$prefix}form-check-input-checked-bg-color, $form-check-input-checked-bg-color);\n    border-color: var(--#{$prefix}form-check-input-checked-border-color, $form-check-input-checked-border-color);\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: var(--#{$prefix}form-check-label-color, $form-check-label-color);\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  @include ltr-rtl(\"padding-left\", $form-switch-padding-start);\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    @include ltr-rtl(\"margin-left\", $form-switch-padding-start * -1);\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    @include ltr-rtl(\"padding-right\", $form-check-padding-start);\n    @include ltr-rtl(\"padding-left\", 0);\n\n    .form-check-input {\n      @include ltr-rtl(\"margin-right\", $form-check-padding-start * -1);\n      @include ltr-rtl(\"margin-left\", 0);\n    }\n  }\n}\n\n@each $size, $map in $form-switch-widths {\n  $width: map-get($map, \"width\");\n  $height: map-get($map, \"height\");\n\n  .form-switch-#{$size} {\n    min-height: $height;\n    @include ltr-rtl(\"padding-left\", $width + .5em);\n\n    .form-check-input {\n      width: $width;\n      height: $height;\n      @include ltr-rtl(\"margin-left\", ($width + .5em) * -1);\n    }\n\n    .form-check-label {\n      // stylelint-disable-next-line function-disallowed-list\n      padding-top: calc((#{$height} - #{$font-size-base}) / 2);\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  @include ltr-rtl(\"margin-right\", $form-check-inline-margin-end);\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n","// Color system\r\n@import \"@coreui/coreui/scss/functions\";\r\n\r\n$enable-shadows: true;\r\n$primary: #0f766e;\r\n$primary-sidebar: #04889F;\r\n$enable-gradients: true;\r\n// $font-family-sans-serif: // Cross-platform generic font family (default user interface font)\r\n//         system-ui,\r\n//         // Safari for macOS and iOS (San Francisco)\r\n//         -apple-system,\r\n//         // Windows\r\n//         \"Segoe UI\",\r\n//         // Android \r\n//         Roboto,\r\n//         // older macOS and iOS\r\n//         \"Helvetica Neue\"\r\n//         // Linux\r\n//         \"Noto Sans\",\r\n//         \"Liberation Sans\",\r\n//         // Basic web fallback\r\n//         Arial,\r\n//         // Sans serif fallback\r\n//         sans-serif,\r\n//         // Emoji fonts\r\n//         \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\r\n\r\n\r\n$font-family-sans-serif:\r\n\"Inter\",\r\nsystem-ui,\r\n-apple-system,\r\nBlinkMacSystemFont,\r\n\"Segoe UI\",\r\nRoboto,\r\nHelvetica,\r\nArial,\r\nsans-serif;\r\n\r\n// $danger: #ff4136;\r\n\r\n// $theme-colors: (\r\n//   \"primary\": $primary,\r\n//   \"danger\": $danger\r\n// );\r\n\r\n$datepicker__background-color: #f0f0f0 !default;\r\n$datepicker__border-color: #aeaeae !default;\r\n$datepicker__highlighted-color: #3dcc4a !default;\r\n$datepicker__muted-color: #ccc !default;\r\n$datepicker__selected-color: #216ba5 !default;\r\n$datepicker__text-color: #000 !default;\r\n$datepicker__header-color: #000 !default;\r\n$datepicker__navigation-disabled-color: lighten($datepicker__muted-color,\r\n                10%) !default;\r\n\r\n$datepicker__border-radius: 0.3rem !default;\r\n$datepicker__day-margin: 0.166rem !default;\r\n$datepicker__font-size: 0.8rem !default;\r\n$datepicker__font-family: \"Helvetica Neue\",\r\n        helvetica,\r\n        arial,\r\n        sans-serif !default;\r\n$datepicker__item-size: 1.7rem !default;\r\n$datepicker__margin: 0.4rem !default;\r\n$datepicker__navigation-button-size: 32px !default;\r\n$datepicker__triangle-size: 8px !default;\r\n$breadcrumb-active-color: #5d697e;\r\n// $prefix: cui;\r\n$enable-deprecation-messages: false !default;\r\n$zindex-fixed: 1000;\r\n$zindex-sidebar-backdrop: 799;\r\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg(var(--#{$prefix}form-range-thumb-bg, $form-range-thumb-bg));\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg(var(--#{$prefix}form-range-thumb-active-bg, $form-range-thumb-active-bg));\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: var(--#{$prefix}form-range-track-bg, $form-range-track-bg);\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg(var(--#{$prefix}form-range-thumb-bg, $form-range-thumb-bg));\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg(var(--#{$prefix}form-range-thumb-active-bg, $form-range-thumb-active-bg));\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: var(--#{$prefix}form-range-track-bg, $form-range-track-bg);\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: var(--#{$prefix}form-range-thumb-disabled-bg, $form-range-thumb-disabled-bg);\n    }\n\n    &::-moz-range-thumb {\n      background-color: var(--#{$prefix}form-range-thumb-disabled-bg, $form-range-thumb-disabled-bg);\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    @include ltr-rtl(\"left\", 0);\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: var(--#{$prefix}input-group-addon-color, $input-group-addon-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}input-group-addon-bg, $input-group-addon-bg);\n  border: $input-border-width solid var(--#{$prefix}input-group-addon-border-color, $input-group-addon-border-color);\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  @include ltr-rtl(\"padding-right\", $form-select-padding-x + $form-select-indicator-padding);\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    @include ltr-rtl(\"margin-left\", calc(#{$input-border-width} * -1));\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        @include ltr-rtl(\"padding-right\", $input-height-inner);\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        @include ltr-rtl-value-only(\"background-position\", right $input-height-inner-quarter center, left $input-height-inner-quarter center);\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        @include ltr-rtl(\"padding-right\", $input-height-inner);\n        @include ltr-rtl-value-only(\"background-position\", top $input-height-inner-quarter right $input-height-inner-quarter, top $input-height-inner-quarter left $input-height-inner-quarter);\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          @include ltr-rtl(\"padding-right\", $form-select-feedback-icon-padding-end);\n          @include ltr-rtl-value-only(\"background-position\", #{$form-select-bg-position, $form-select-feedback-icon-position});\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      @include ltr-rtl(\"margin-left\", .5em);\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n.btn-transparent {\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-hover-border-color: transparent;\n}\n\n// scss-docs-start btn-variant-loops\n@each $state, $variant in $button-variants {\n  .btn-#{$state} {\n    @include button-variant($variant);\n  }\n}\n\n@each $state, $variant in $button-outline-ghost-variants {\n  .btn-outline-#{$state} {\n    @include button-outline-variant($variant);\n  }\n}\n\n@each $state, $variant in $button-outline-ghost-variants {\n  .btn-ghost-#{$state} {\n    @include button-ghost-variant($variant);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: none;\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix(color-contrast($primary), $primary, 15%))};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant($variant) {\n  $background: map-get($variant, \"bg\");\n  $border-color: map-get($variant, \"border-color\");\n  $color: map-get($variant, \"color\");\n  $hover-background: map-get($variant, \"hover-bg\");\n  $hover-border-color: map-get($variant, \"hover-border-color\");\n  $hover-color: map-get($variant, \"hover-color\");\n  $active-background: map-get($variant, \"active-bg\");\n  $active-border-color: map-get($variant, \"active-border-color\");\n  $active-color: map-get($variant, \"active-color\");\n  $disabled-background: map-get($variant, \"disabled-bg\");\n  $disabled-border-color: map-get($variant, \"disabled-border-color\");\n  $disabled-color: map-get($variant, \"disabled-color\");\n  $shadow: map-get($variant, \"shadow\");\n\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border-color};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border-color};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border-color, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border-color};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border-color};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant($variant) {\n  $color: map-get($variant, \"color\");\n  $hover-background: map-get($variant, \"hover-bg\");\n  $hover-border-color: map-get($variant, \"hover-border-color\");\n  $hover-color: map-get($variant, \"hover-color\");\n  $active-background: map-get($variant, \"active-bg\");\n  $active-border-color: map-get($variant, \"active-border-color\");\n  $active-color: map-get($variant, \"active-color\");\n  $disabled-color: map-get($variant, \"disabled-color\");\n  $shadow: map-get($variant, \"shadow\");\n\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border-color};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border-color};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-ghost-variant-mixin\n@mixin button-ghost-variant($variant) {\n  $color: map-get($variant, \"color\");\n  $hover-background: map-get($variant, \"hover-bg\");\n  $hover-border-color: map-get($variant, \"hover-border-color\");\n  $hover-color: map-get($variant, \"hover-color\");\n  $active-background: map-get($variant, \"active-bg\");\n  $active-border-color: map-get($variant, \"active-border-color\");\n  $active-color: map-get($variant, \"active-color\");\n  $disabled-color: map-get($variant, \"disabled-color\");\n  $shadow: map-get($variant, \"shadow\");\n\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border-color};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border-color};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-shadow: #{$shadow};\n}\n// scss-docs-end btn-ghost-variant-mixin\n\n// Button sizes\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-coreui-popper] {\n    top: 100%;\n    @include ltr-rtl(\"left\", 0);\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `cui-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --cui-position: start;\n\n      &[data-coreui-popper] {\n        @include ltr-rtl(\"right\", auto);\n        @include ltr-rtl(\"left\", 0);\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --cui-position: end;\n\n      &[data-coreui-popper] {\n        @include ltr-rtl(\"right\", 0);\n        @include ltr-rtl(\"left\", auto);\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-coreui-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-coreui-popper] {\n    top: 0;\n    @include ltr-rtl(\"right\", auto);\n    @include ltr-rtl(\"left\", 100%);\n    margin-top: 0;\n    @include ltr-rtl(\"margin-left\", var(--#{$prefix}dropdown-spacer));\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-coreui-popper] {\n    top: 0;\n    @include ltr-rtl(\"right\", 100%);\n    @include ltr-rtl(\"left\", auto);\n    margin-top: 0;\n    @include ltr-rtl(\"margin-right\", var(--#{$prefix}dropdown-spacer));\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      @include ltr-rtl(\"margin-left\", $spacing);\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        @include ltr-rtl(\"margin-right\", $spacing);\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      @include ltr-rtl(\"margin-left\", 0);\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    @include ltr-rtl(\"margin-left\", calc(#{$btn-border-width} * -1));\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    @include ltr-rtl(\"margin-left\", 0);\n  }\n\n  .dropstart &::before {\n    @include ltr-rtl(\"margin-right\", 0);\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  @include ltr-rtl(\"margin-right\", var(--#{$prefix}navbar-brand-margin-end));\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v4.3.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    @include ltr-rtl(\"margin-left\", var(--#{$prefix}card-spacer-x));\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        @include ltr-rtl(\"margin-left\", 0);\n        @include ltr-rtl(\"border-left\", 0);\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    @include ltr-rtl(\"padding-left\",  var(--#{$prefix}breadcrumb-item-padding-x));\n\n    &::before {\n      @include ltr-rtl(\"float\", left); // Suppress inline spacings and underlining of the separator\n      @include ltr-rtl(\"padding-right\", var(--#{$prefix}breadcrumb-item-padding-x));\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      @include ltr-rtl(\n        \"content\",\n        var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)),\n        null,\n        var(--#{$prefix}breadcrumb-divider-flipped, escape-svg($breadcrumb-divider-flipped))\n      );\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    @include ltr-rtl(\"margin-left\", $pagination-margin-start);\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--#{$prefix}badge-border-radius, 0); // stylelint-disable-line property-disallowed-list\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n//\n// Badge Sizes\n//\n\n.badge-sm {\n  --#{$prefix}badge-padding-x: #{$badge-padding-x-sm};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y-sm};\n  @include font-size($badge-font-size-sm);\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  @include ltr-rtl(\"padding-right\", $alert-dismissible-padding-r);\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    @include ltr-rtl(\"right\", 0);\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert.\n@each $state, $value in $alert-variants {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: #{map-get($value, \"alert-color\")};\n    --#{$prefix}alert-bg: #{map-get($value, \"alert-bg\")};\n    --#{$prefix}alert-border-color: #{map-get($value, \"alert-border\")};\n    --#{$prefix}alert-link-color: #{shade-color(map-get($value, \"alert-color\"), 20%)};\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n\n.progress-thin {\n  height: 4px;\n}\n\n// White progress bar\n.progress.progress-white {\n  background-color: rgba(255, 255, 255, .2);\n  .progress-bar {\n    background-color: $white;\n  }\n}\n\n.progress-group {\n  display: flex;\n  flex-flow: row wrap;\n  margin-bottom: $progress-group-margin-bottom;\n}\n\n.progress-group-prepend {\n  flex: 0 0 100px;\n  align-self: center;\n}\n\n.progress-group-header {\n  display: flex;\n  flex-basis: 100%;\n  align-items: center;\n  margin-bottom: $progress-group-header-margin-bottom;\n}\n\n.progress-group-bars {\n  flex-grow: 1;\n  align-self: center;\n\n  .progress:not(:last-child) {\n    margin-bottom: 2px;\n  }\n}\n\n.progress-group-header + .progress-group-bars {\n  flex-basis: 100%;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  @include ltr-rtl(\"padding-left\", 0); // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          @include ltr-rtl(\"border-left-width\", 0);\n\n          &.active {\n            @include ltr-rtl(\"margin-left\", calc(-1 * var(--#{$prefix}list-group-border-width)));\n            @include ltr-rtl(\"border-left-width\", var(--#{$prefix}list-group-border-width));\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state, $variant in $list-group-variants {\n  .list-group-item-#{$state} {\n    @include list-group-item-variant($state, $variant);\n  }\n}\n// scss-docs-end list-group-modifiers\n","@include deprecate(\"`list-group-item-variant()`\", \"v4.3.0\", \"v6.0.0\");\n\n// List Groups\n// scss-docs-start list-group-mixin\n@mixin list-group-item-variant($state, $variant) {\n  $background: map-get($variant, \"bg\");\n  $background-hover: map-get($variant, \"bg-hover\");\n  $color: contrast-ratio-correction(map-get($variant, \"color\"), map-get($variant, \"bg\"), abs($alert-color-scale), $state);\n\n  --#{$prefix}list-group-color: #{$color};\n  --#{$prefix}list-group-bg: #{$background};\n  --#{$prefix}list-group-hover-bg: #{$background-hover};\n  --#{$prefix}list-group-action-hover-color: #{$color};\n  --#{$prefix}list-group-action-active-color: #{$white};\n  --#{$prefix}list-group-action-active-bg: #{$color};\n  --#{$prefix}list-group-action-active-border-color: #{$color};\n}\n// scss-docs-end list-group-mixin\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n.btn-close-white {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    @include ltr-rtl(\"margin-right\", calc(-.5 * var(--#{$prefix}toast-padding-x)));\n    @include ltr-rtl(\"margin-left\", var(--#{$prefix}toast-padding-x));\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  @include ltr-rtl(\"left\", 0);\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    @include ltr-rtl-value-only(\"margin\", calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto, calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)));\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v4\", \"v4.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: var(--#{$prefix}carousel-control-color, $carousel-control-color);\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}carousel-control-color, $carousel-control-color);\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-coreui-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  [data-coreui-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg, $carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color, $carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n.carousel-dark {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-dark-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-dark-caption-color};\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-coreui-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        @include ltr-rtl(\"left\", 0);\n        width: var(--#{$prefix}offcanvas-width);\n        @include ltr-rtl(\"border-right\", var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color));\n        @include ltr-rtl-value-only(\"transform\", translateX(-100%), translateX(100%));\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        @include ltr-rtl(\"right\", 0);\n        width: var(--#{$prefix}offcanvas-width);\n        @include ltr-rtl(\"border-left\", var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color));\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none !important; // stylelint-disable-line declaration-no-important\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, var(--#{$prefix}offcanvas-backdrop-bg, $offcanvas-backdrop-bg), $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    @include ltr-rtl(\"margin-right\", calc(-.5 * var(--#{$prefix}offcanvas-padding-x)));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n",".avatar {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  vertical-align: middle;\n  @include border-radius(50em);\n  @include transition($avatar-transition);\n  @include avatar($avatar-width);\n}\n\n.avatar-img {\n  width: 100%;\n  height: auto;\n  @include border-radius(50em);\n}\n\n.avatar-status {\n  position: absolute;\n  @include ltr-rtl(\"right\", 0);\n  bottom: 0;\n  display: block;\n  border: 1px solid $white;\n  @include border-radius(50em);\n}\n\n@each $width, $value in $avatar-widths {\n  .avatar-#{$width} {\n    @include avatar($value);\n  }\n}\n\n.avatars-stack {\n  display: flex;\n\n  .avatar {\n    @include ltr-rtl(\"margin-right\", - ($avatar-width * .4));\n\n    &:hover {\n      @include ltr-rtl(\"margin-right\", 0);\n    }\n  }\n\n  @each $width, $value in $avatar-widths {\n    .avatar-#{$width} {\n      @include ltr-rtl(\"margin-right\", - ($value * .4));\n    }\n  }\n}\n","@mixin avatar($width) {\n  width: $width;\n  height: $width;\n  font-size: $width * .4;\n\n  .avatar-status {\n    width: divide($width, 3.75);\n    height: divide($width, 3.75);\n  }\n}\n",".callout {\n  // scss-docs-start callout-css-vars\n  --#{$prefix}callout-padding-x: #{$callout-padding-x};\n  --#{$prefix}callout-padding-y: #{$callout-padding-y};\n  --#{$prefix}callout-margin-x: #{$callout-margin-x};\n  --#{$prefix}callout-margin-y: #{$callout-margin-y};\n  --#{$prefix}callout-border-width: #{$callout-border-width};\n  --#{$prefix}callout-border-color: #{$callout-border-color};\n  --#{$prefix}callout-border-left-width: #{$callout-border-left-width};\n  --#{$prefix}callout-border-radius: #{$callout-border-radius};\n  // scss-docs-end callout-css-vars\n\n  padding: var(--#{$prefix}callout-padding-y) var(--#{$prefix}callout-padding-x);\n  margin: var(--#{$prefix}callout-margin-y) var(--#{$prefix}callout-margin-x);\n  border: var(--#{$prefix}callout-border-width) solid var(--#{$prefix}callout-border-color);\n  @include ltr-rtl(\"border-left-width\", var(--#{$prefix}callout-border-left-width));\n  @include ltr-rtl(\"border-left-color\", var(--#{$prefix}callout-border-left-color));\n  @include border-radius(var(--#{$prefix}callout-border-radius));\n}\n\n// scss-docs-start callout-modifiers\n// Generate contextual modifier classes for colorizing the collor.\n@each $state, $value in $callout-variants {\n  .callout-#{$state} {\n    --#{$prefix}callout-border-left-color: #{$value};\n  }\n}\n// scss-docs-end callout-modifiers\n",".footer {\n  // scss-docs-start footer-css-vars\n  --#{$prefix}footer-min-height: #{$footer-min-height};\n  --#{$prefix}footer-padding-x: #{$footer-padding-x};\n  --#{$prefix}footer-padding-y: #{$footer-padding-y};\n  --#{$prefix}footer-color: #{$footer-color};\n  --#{$prefix}footer-bg: #{$footer-bg};\n  --#{$prefix}footer-border-color: #{$footer-border-color};\n  --#{$prefix}footer-border: #{$footer-border-width} solid var(--#{$prefix}footer-border-color);\n  // scss-docs-end footer-css-vars\n\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between;\n  min-height: var(--#{$prefix}footer-min-height);\n  padding: var(--#{$prefix}footer-padding-y) var(--#{$prefix}footer-padding-x);\n  color: var(--#{$prefix}footer-color);\n  background: var(--#{$prefix}footer-bg);\n  border-top: var(--#{$prefix}footer-border);\n}\n\n.footer-fixed {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.footer-sticky {\n  position: sticky;\n  bottom: 0;\n  z-index: $zindex-fixed;\n}\n",".header {\n  // scss-docs-start header-css-vars\n  --#{$prefix}header-min-height: #{$header-min-height};\n  --#{$prefix}header-padding-x: #{$header-padding-x};\n  --#{$prefix}header-padding-y: #{$header-padding-y};\n  --#{$prefix}header-bg: #{$header-bg};\n  --#{$prefix}header-color: #{$header-color};\n  --#{$prefix}header-border-color: #{$header-border-color};\n  --#{$prefix}header-border: #{$header-border-width} solid var(--#{$prefix}header-border-color);\n  --#{$prefix}header-hover-color: #{$header-hover-color};\n  --#{$prefix}header-disabled-color: #{$header-disabled-color};\n  --#{$prefix}header-active-color: #{$header-active-color};\n  --#{$prefix}header-brand-padding-y: #{$header-brand-padding-y};\n  --#{$prefix}header-brand-color: #{$header-brand-color};\n  --#{$prefix}header-brand-hover-color: #{$header-brand-hover-color};\n  --#{$prefix}header-toggler-padding-x: #{$header-toggler-padding-x};\n  --#{$prefix}header-toggler-padding-y: #{$header-toggler-padding-y};\n  --#{$prefix}header-toggler-bg: #{$header-toggler-bg};\n  --#{$prefix}header-toggler-color: #{$header-toggler-color};\n  --#{$prefix}header-toggler-border-radius: #{$header-toggler-border-radius};\n  --#{$prefix}header-toggler-hover-color: #{$header-toggler-hover-color};\n  --#{$prefix}header-toggler-icon-bg: #{escape-svg($header-toggler-icon-bg)};\n  --#{$prefix}header-toggler-hover-icon-bg: #{escape-svg($header-toggler-hover-icon-bg)};\n  --#{$prefix}header-nav-link-padding-x: #{$header-nav-link-padding-x};\n  --#{$prefix}header-nav-link-padding-y: #{$header-nav-link-padding-y};\n  --#{$prefix}header-divider-border-color: #{$header-divider-border-color};\n  --#{$prefix}header-divider-border: #{$header-divider-border-width} solid var(--#{$prefix}header-divider-border-color);\n  --#{$prefix}subheader-min-height: #{$subheader-min-height};\n  // scss-docs-end header-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  min-height: var(--#{$prefix}header-min-height);\n  padding: var(--#{$prefix}header-padding-y) var(--#{$prefix}header-padding-x);\n  background: var(--#{$prefix}header-bg);\n  border-bottom: var(--#{$prefix}header-border);\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n\n  .container:first-child,\n  .container-fluid:first-child {\n    min-height: calc(var(--#{$prefix}header-min-height) - (2 * var(--#{$prefix}header-padding-y))); // stylelint-disable-line function-disallowed-list\n  }\n\n  .container:nth-child(n+2),\n  .container-fluid:nth-child(n+2) {\n    min-height: calc(var(--#{$prefix}subheader-min-height) - (2 * var(--#{$prefix}header-padding-y))); // stylelint-disable-line function-disallowed-list\n  }\n\n  &.header-sticky {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-fixed - 1;\n  }\n}\n\n.header-divider {\n  flex-basis: calc(100% + (2 * var(--#{$prefix}header-padding-x))); // stylelint-disable-line function-disallowed-list\n  height: 0;\n  margin: var(--#{$prefix}header-padding-y) calc(var(--#{$prefix}header-padding-x) * -1); // stylelint-disable-line function-disallowed-list\n  border-top: var(--#{$prefix}header-divider-border);\n}\n\n// Header brand\n//\n// Used for brand, project, or site names.\n\n.header-brand {\n  padding-top: var(--#{$prefix}header-brand-padding-y);\n  padding-bottom: var(--#{$prefix}header-brand-padding-y);\n  @include ltr-rtl(\"margin-right\", $header-brand-margin-end);\n  @include font-size($header-brand-font-size);\n  color: var(--#{$prefix}header-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}header-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n// Header nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.header-nav {\n  display: flex;\n  flex-direction: row; // cannot use `inherit` to get the `.header`s value\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding: var(--#{$prefix}header-nav-link-padding-y) var(--#{$prefix}header-nav-link-padding-x);\n    color: var(--#{$prefix}header-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}header-hover-color);\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}header-disabled-color);\n    }\n  }\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}header-active-color);\n  }\n\n  .dropdown-menu {\n    position: absolute;\n  }\n}\n\n\n// Header text\n//\n//\n\n.header-text {\n  padding-top: var(--#{$prefix}header-nav-link-padding-y);\n  padding-bottom: var(--#{$prefix}header-nav-link-padding-y);\n  color: var(--#{$prefix}header-color);\n\n  a {\n    color: var(--#{$prefix}header-active-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}header-active-color);\n    }\n  }\n}\n\n.header-toggler {\n  padding: var(--#{$prefix}header-toggler-padding-y) var(--#{$prefix}header-toggler-padding-x);\n  @include font-size($header-toggler-font-size);\n  color: var(--#{$prefix}header-toggler-color);\n  background-color: var(--#{$prefix}header-toggler-bg);\n  border: 0; // remove default button style\n  @include border-radius(var(--#{$prefix}header-toggler-border-radius));\n\n  &:hover {\n    color: var(--#{$prefix}header-toggler-hover-color);\n    text-decoration: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  // Opinionated: add \"hand\" cursor to non-disabled .navbar-toggler elements\n  &:not(:disabled) {\n    cursor: pointer;\n  }\n}\n\n.header-toggler-icon {\n  display: block;\n  height: $header-toggler-font-size * 1.25;\n  background-image: var(--#{$prefix}header-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 100% 100%;\n\n  &:hover {\n    background-image: var(--#{$prefix}header-toggler-hover-icon-bg);\n  }\n}\n",".icon {\n  display: inline-block;\n  color: inherit;\n  text-align: center;\n  vertical-align: -.125rem; // Fix the position of icon\n  fill: currentcolor;\n  &:not(.icon-c-s):not(.icon-custom-size) {\n    @include icon-size($icon-size-base);\n\n    &.icon-xxl {\n      @include icon-size($icon-size-xxl);\n    }\n\n    &.icon-xl {\n      @include icon-size($icon-size-xl);\n    }\n\n    &.icon-lg {\n      @include icon-size($icon-size-lg);\n    }\n\n    &.icon-sm {\n      @include icon-size($icon-size-sm);\n    }\n\n    @for $i from 3 through 9 {\n      &.icon-#{$i}xl {\n        @include icon-size($i * $icon-size-base);\n      }\n    }\n  }\n}\n","// Icon sizes\n@mixin icon-size($icon-size) {\n  width: $icon-size;\n  height: $icon-size;\n  font-size: $icon-size;\n}\n",".sidebar {\n  // scss-docs-start sidebar-css-vars\n  --#{$prefix}sidebar-width: #{$sidebar-width};\n  --#{$prefix}sidebar-bg: #{$sidebar-bg};\n  --#{$prefix}sidebar-padding-x: #{$sidebar-padding-x};\n  --#{$prefix}sidebar-padding-y: #{$sidebar-padding-y};\n  --#{$prefix}sidebar-color: #{$sidebar-color};\n  --#{$prefix}sidebar-border-width: #{$sidebar-border-width};\n  --#{$prefix}sidebar-border-color: #{$sidebar-border-color};\n  --#{$prefix}sidebar-brand-color: #{$sidebar-brand-color};\n  --#{$prefix}sidebar-brand-height: #{$sidebar-brand-height};\n  --#{$prefix}sidebar-brand-bg: #{$sidebar-brand-bg};\n  --#{$prefix}sidebar-header-height: #{$sidebar-header-height};\n  --#{$prefix}sidebar-header-bg: #{$sidebar-header-bg};\n  --#{$prefix}sidebar-header-padding-x: #{$sidebar-header-padding-x};\n  --#{$prefix}sidebar-header-padding-y: #{$sidebar-header-padding-y};\n  --#{$prefix}sidebar-footer-bg: #{$sidebar-footer-bg};\n  --#{$prefix}sidebar-footer-height: #{$sidebar-footer-height};\n  --#{$prefix}sidebar-footer-padding-x: #{$sidebar-footer-padding-x};\n  --#{$prefix}sidebar-footer-padding-y: #{$sidebar-footer-padding-y};\n  --#{$prefix}sidebar-toggler-bg: #{$sidebar-toggler-bg};\n  --#{$prefix}sidebar-toggler-height: #{$sidebar-toggler-height};\n  --#{$prefix}sidebar-toggler-indicator: #{escape-svg($sidebar-toggler-indicator-icon)};\n  --#{$prefix}sidebar-toggler-indicator-width: #{$sidebar-toggler-indicator-width};\n  --#{$prefix}sidebar-toggler-indicator-height: #{$sidebar-toggler-indicator-height};\n  --#{$prefix}sidebar-toggler-hover-bg: #{$sidebar-toggler-hover-bg};\n  --#{$prefix}sidebar-toggler-indicator-hover: #{escape-svg($sidebar-toggler-indicator-hover-icon)};\n\n  --#{$prefix}sidebar-narrow-width: #{$sidebar-narrow-width};\n\n  --#{$prefix}sidebar-nav-title-padding-x: #{$sidebar-nav-title-padding-x};\n  --#{$prefix}sidebar-nav-title-padding-y: #{$sidebar-nav-title-padding-y};\n  --#{$prefix}sidebar-nav-title-margin-top: #{$sidebar-nav-title-margin-top};\n  --#{$prefix}sidebar-nav-title-color: #{$sidebar-nav-title-color};\n  --#{$prefix}sidebar-nav-link-padding-x: #{$sidebar-nav-link-padding-x};\n  --#{$prefix}sidebar-nav-link-padding-y: #{$sidebar-nav-link-padding-y};\n  --#{$prefix}sidebar-nav-link-color: #{$sidebar-nav-link-color};\n  --#{$prefix}sidebar-nav-link-bg: #{$sidebar-nav-link-bg};\n  --#{$prefix}sidebar-nav-link-border-color: #{$sidebar-nav-link-border-color};\n  --#{$prefix}sidebar-nav-link-border: #{$sidebar-nav-link-border-width} solid var(--#{$prefix}sidebar-nav-link-border-color);\n  --#{$prefix}sidebar-nav-link-border-radius: #{$sidebar-nav-link-border-radius};\n  --#{$prefix}sidebar-nav-link-active-color: #{$sidebar-nav-link-active-color};\n  --#{$prefix}sidebar-nav-link-active-bg: #{$sidebar-nav-link-active-bg};\n  --#{$prefix}sidebar-nav-link-active-icon-color: #{$sidebar-nav-link-active-icon-color};\n  --#{$prefix}sidebar-nav-link-disabled-color: #{$sidebar-nav-link-disabled-color};\n  --#{$prefix}sidebar-nav-link-disabled-icon-color: #{$sidebar-nav-link-disabled-icon-color};\n  --#{$prefix}sidebar-nav-link-hover-color: #{$sidebar-nav-link-hover-color};\n  --#{$prefix}sidebar-nav-link-hover-bg: #{$sidebar-nav-link-hover-bg};\n  --#{$prefix}sidebar-nav-link-hover-icon-color: #{$sidebar-nav-link-hover-icon-color};\n  --#{$prefix}sidebar-nav-icon-width: #{$sidebar-nav-icon-width};\n  --#{$prefix}sidebar-nav-icon-height: #{$sidebar-nav-icon-height};\n  --#{$prefix}sidebar-nav-icon-font-size: #{$sidebar-nav-icon-font-size};\n  --#{$prefix}sidebar-nav-link-icon-color: #{$sidebar-nav-link-icon-color};\n  --#{$prefix}sidebar-nav-group-bg: #{$sidebar-nav-group-bg};\n  --#{$prefix}sidebar-nav-group-items-padding-y: #{$sidebar-nav-group-items-padding-y};\n  --#{$prefix}sidebar-nav-group-items-padding-x: #{$sidebar-nav-group-items-padding-x};\n  --#{$prefix}sidebar-nav-group-indicator: #{escape-svg($sidebar-nav-group-indicator-icon)};\n  --#{$prefix}sidebar-nav-group-indicator-hover: #{escape-svg($sidebar-nav-group-indicator-hover-icon)};\n  --#{$prefix}sidebar-nav-group-toggle-show-color: #{$sidebar-nav-group-toggle-show-color};\n  // scss-docs-end sidebar-css-vars\n\n  position: relative;\n  display: flex;\n  // $sidebar-width is the width of the columns\n  flex: 0 0 var(--#{$prefix}sidebar-width);\n  flex-direction: column;\n  // put the nav on the left\n  order: -1;\n  width: var(--#{$prefix}sidebar-width);\n  padding: var(--#{$prefix}sidebar-padding-y) var(--#{$prefix}sidebar-padding-x);\n  color: var(--#{$prefix}sidebar-color);\n  background: var(--#{$prefix}sidebar-bg);\n  @include ltr-rtl(\"border-right\", var(--#{$prefix}sidebar-border-width) solid var(--#{$prefix}sidebar-border-color));\n  box-shadow: none;\n  @include transition($sidebar-transition);\n\n  &:not(.sidebar-end){\n    @include ltr-rtl(\"margin-left\", 0);\n    ~ * {\n      --#{$prefix}sidebar-occupy-start: #{$sidebar-width};\n    }\n  }\n\n  &.sidebar-end {\n    order: 99;\n    @include ltr-rtl(\"margin-right\", 0);\n    ~ * {\n      --#{$prefix}sidebar-occupy-end: #{$sidebar-width};\n    }\n  }\n\n  &[class*=\"bg-\"]  {\n    border-color: rgba($black, .1);\n  }\n\n  @each $width, $value in $sidebar-widths {\n    &.sidebar-#{$width} {\n      --#{$prefix}sidebar-width: #{$value};\n      @include media-breakpoint-up($mobile-breakpoint) {\n        &:not(.sidebar-end):not(.hide) {\n          ~ * {\n            --#{$prefix}sidebar-occupy-start: #{$value};\n          }\n        }\n        &.sidebar-end:not(.hide) {\n          ~ * {\n            --#{$prefix}sidebar-occupy-end: #{$value};\n          }\n        }\n      }\n    }\n  }\n\n  @include media-breakpoint-up($mobile-breakpoint) {\n    &.hide {\n      &:not(.sidebar-end){\n        @include ltr-rtl(\"margin-left\", calc(-1 * var(--#{$prefix}sidebar-width)));\n        ~ * {\n          --#{$prefix}sidebar-occupy-start: 0;\n        }\n      }\n      &.sidebar-end {\n        @include ltr-rtl(\"margin-right\", calc(-1 * var(--#{$prefix}sidebar-width)));\n        ~ * {\n          --#{$prefix}sidebar-occupy-end: 0;\n        }\n      }\n    }\n  }\n\n  &.sidebar-fixed {\n    @include media-breakpoint-up($mobile-breakpoint) {\n      position: fixed;\n      top: 0;\n      bottom: 0;\n      z-index: $zindex-fixed;\n\n      &:not(.sidebar-end) {\n        @include ltr-rtl(\"left\", 0);\n      }\n\n      &.sidebar-end {\n        @include ltr-rtl(\"right\", 0);\n      }\n    }\n  }\n\n  &.sidebar-sticky {\n    @include media-breakpoint-up($mobile-breakpoint) {\n      position: sticky;\n      top: 0;\n      height: 100vh;\n    }\n  }\n\n  &.sidebar-overlaid {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    z-index: $zindex-fixed + 2;\n\n    &:not(.sidebar-end) {\n      @include ltr-rtl(\"left\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-start: 0;\n      }\n    }\n\n    &.sidebar-end {\n      @include ltr-rtl(\"right\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-end: 0;\n      }\n    }\n  }\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    // Some of our components use this property to detect if the sidebar has mobile behavior.\n    --#{$prefix}is-mobile: true;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    z-index: $zindex-fixed + 1;\n\n    &:not(.sidebar-end) {\n      @include ltr-rtl(\"left\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-start: 0 !important; // stylelint-disable-line\n      }\n\n      &:not(.show) {\n        @include ltr-rtl(\"margin-left\", calc(-1 * var(--#{$prefix}sidebar-width)));\n      }\n    }\n    &.sidebar-end {\n      @include ltr-rtl(\"right\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-end: 0 !important; // stylelint-disable-line\n      }\n\n      &:not(.show) {\n        @include ltr-rtl(\"margin-right\", calc(-1 * var(--#{$prefix}sidebar-width)));\n      }\n    }\n  }\n}\n\n.sidebar-close {\n  position: absolute;\n  top: 0;\n  @include ltr-rtl(\"right\", 0);\n  width: var(--#{$prefix}sidebar-width);\n  height: var(--#{$prefix}sidebar-header-height);\n  color: var(--#{$prefix}sidebar-color);\n  background: transparent;\n  border: 0;\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n}\n\n.sidebar-brand {\n  display: flex;\n  flex: 0 0 var(--#{$prefix}sidebar-brand-height);\n  align-items: center;\n  justify-content: center;\n  color: var(--#{$prefix}sidebar-brand-color);\n  background: var(--#{$prefix}sidebar-brand-bg);\n\n  .sidebar-brand-narrow {\n    display: none;\n  }\n}\n\n.sidebar-header {\n  flex: 0 0 var(--#{$prefix}sidebar-header-height);\n  padding: var(--#{$prefix}sidebar-header-padding-y) var(--#{$prefix}sidebar-header-padding-x);\n  text-align: center;\n  background: var(--#{$prefix}sidebar-header-bg);\n  @include transition($sidebar-header-height-transition);\n\n  .nav-link {\n    display: flex;\n    align-items: center;\n    min-height: var(--#{$prefix}sidebar-header-height);\n  }\n}\n\n.sidebar-footer {\n  flex: 0 0 var(--#{$prefix}sidebar-footer-height);\n  padding: var(--#{$prefix}sidebar-footer-padding-y) var(--#{$prefix}sidebar-footer-padding-x);\n  background: var(--#{$prefix}sidebar-footer-bg);\n  @include transition($sidebar-footer-height-transition);\n}\n\n.sidebar-toggler {\n  display: flex;\n  flex: 0 0 var(--#{$prefix}sidebar-toggler-height);\n  justify-content: flex-end;\n  width: inherit;\n  padding: 0;\n  cursor: pointer;\n  background-color: var(--#{$prefix}sidebar-toggler-bg);\n  border: 0;\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    display: none;\n  }\n\n  &::before {\n    display: block;\n    width: var(--#{$prefix}sidebar-toggler-indicator-width);\n    height: var(--#{$prefix}sidebar-toggler-indicator-height);\n    content: \"\";\n    background-image: var(--#{$prefix}sidebar-toggler-indicator);\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: calc(var(--#{$prefix}sidebar-toggler-indicator-height) * .25); // stylelint-disable-line function-disallowed-list\n    @include transition($sidebar-toggler-transition);\n    @include rtl() {\n      transform: rotate(-180deg);\n    }\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:hover {\n    background-color: var(--#{$prefix}sidebar-toggler-hover-bg);\n    &::before {\n      background-image: var(--#{$prefix}sidebar-toggler-indicator-hover);\n    }\n  }\n\n  .sidebar-end & {\n    justify-content: flex-start;\n    &::before {\n      transform: rotate(-180deg);\n    }\n  }\n}\n\n// Backdrop background\n\n.sidebar-backdrop {\n  // scss-docs-start sidebar-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-sidebar-backdrop};\n  --#{$prefix}backdrop-bg: #{$sidebar-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$sidebar-backdrop-opacity};\n  // scss-docs-end sidebar-backdrop-css-vars\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n  }\n}\n","// Sidebar navigation\n\n.sidebar-nav {\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: 0;\n  margin-bottom: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  list-style: none;\n\n  .nav-title {\n    padding: var(--#{$prefix}sidebar-nav-title-padding-y) var(--#{$prefix}sidebar-nav-title-padding-x);\n    margin-top: var(--#{$prefix}sidebar-nav-title-margin-top);\n    font-size: 80%;\n    font-weight: 700;\n    color: var(--#{$prefix}sidebar-nav-title-color);\n    text-transform: uppercase;\n    @include transition($sidebar-nav-title-transition);\n  }\n\n  .nav-link {\n    display: flex;\n    flex: 1;\n    align-items: center;\n    padding: var(--#{$prefix}sidebar-nav-link-padding-y) var(--#{$prefix}sidebar-nav-link-padding-x);\n    color: var(--#{$prefix}sidebar-nav-link-color);\n    text-decoration: none;\n    white-space: nowrap;\n    background: var(--#{$prefix}sidebar-nav-link-bg);\n    border: var(--#{$prefix}sidebar-nav-link-border);\n    @include border-radius(var(--#{$prefix}sidebar-nav-link-border-radius));\n    @include transition($sidebar-nav-link-transition);\n\n    &.active {\n      color: var(--#{$prefix}sidebar-nav-link-active-color);\n      background: var(--#{$prefix}sidebar-nav-link-active-bg);\n\n      .nav-icon {\n        color: var(--#{$prefix}sidebar-nav-link-active-icon-color);\n      }\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}sidebar-nav-link-disabled-color);\n      pointer-events: none;\n      cursor: not-allowed;\n      background: transparent;\n\n      .nav-icon {\n        color: var(--#{$prefix}sidebar-nav-link-disabled-icon-color);\n      }\n\n      &:hover {\n        color: var(--#{$prefix}sidebar-nav-link-disabled-color);\n\n        .nav-icon {\n          color: var(--#{$prefix}sidebar-nav-link-disabled-icon-color);\n        }\n\n        &.nav-dropdown-toggle::after {\n          background-image: var(--#{$prefix}sidebar-nav-group-indicator-hover);\n        }\n      }\n    }\n\n    @media (hover: hover), (-ms-high-contrast: none) {\n      &:hover {\n        color: var(--#{$prefix}sidebar-nav-link-hover-color);\n        text-decoration: none;\n        background: var(--#{$prefix}sidebar-nav-link-hover-bg);\n\n        .nav-icon {\n          color: var(--#{$prefix}sidebar-nav-link-hover-icon-color);\n        }\n\n        &.nav-group-toggle::after {\n          background-image: var(--#{$prefix}sidebar-nav-group-indicator-hover);\n        }\n      }\n    }\n  }\n\n  .nav-icon {\n    flex: 0 0 var(--#{$prefix}sidebar-nav-icon-width);\n    height: var(--#{$prefix}sidebar-nav-icon-height);\n    font-size: var(--#{$prefix}sidebar-nav-icon-font-size);\n    color: var(--#{$prefix}sidebar-nav-link-icon-color);\n    text-align: center;\n    pointer-events: none;\n    fill: currentcolor;\n    @include transition(inherit);\n\n    &:first-child {\n      @include ltr-rtl(\"margin-left\", calc(var(--#{$prefix}sidebar-nav-link-padding-x) * -1));\n    }\n  }\n  // stylelint-disable-next-line selector-no-qualifying-type\n  svg.nav-icon {\n    overflow: hidden; // fix chrome 105+ width issue\n  }\n\n  .nav-group {\n    position: relative;\n    @include transition($sidebar-nav-group-transition);\n\n    .nav-group-items {\n      padding: var(--#{$prefix}sidebar-nav-group-items-padding-y) var(--#{$prefix}sidebar-nav-group-items-padding-x);\n      overflow: hidden;\n      @include transition($sidebar-nav-group-items-transition);\n    }\n\n    &:not(.show) .nav-group-items {\n      display: none;\n    }\n\n    &.show {\n      background: var(--#{$prefix}sidebar-nav-group-bg);\n\n      .nav-group-toggle {\n        color: var(--#{$prefix}sidebar-nav-group-toggle-show-color);\n      }\n\n      > .nav-group-toggle::after {\n        transform: rotate(180deg);\n      }\n\n      + .show {\n        margin-top: 1px;\n      }\n    }\n  }\n\n  .nav-group-toggle {\n    cursor: pointer;\n\n    &::after {\n      display: block;\n      flex: 0 12px;\n      height: 12px;\n      @include ltr-rtl(\"margin-left\", auto);\n      content: \"\";\n      background-image: var(--#{$prefix}sidebar-nav-group-indicator);\n      background-repeat: no-repeat;\n      background-position: center;\n      @include transition($sidebar-nav-group-indicator-transition);\n    }\n  }\n\n  .nav-group-items {\n    padding: 0;\n    list-style: none;\n\n    .nav-link {\n      @include ltr-rtl(\"padding-left\", var(--#{$prefix}sidebar-nav-icon-width));\n\n      .nav-icon {\n        @include ltr-rtl(\"margin-left\", calc(var(--#{$prefix}sidebar-nav-icon-width) * -1));\n      }\n    }\n  }\n\n  &.compact,\n  .compact {\n    .nav-link {\n      padding-top: calc(var(--#{$prefix}sidebar-nav-link-padding-y) * .5); // stylelint-disable-line function-disallowed-list\n      padding-bottom: calc(var(--#{$prefix}sidebar-nav-link-padding-y) * .5); // stylelint-disable-line function-disallowed-list\n    }\n  }\n}\n","%sidebar-narrow {\n  @include media-breakpoint-up($mobile-breakpoint) {\n    z-index: $zindex-fixed + 1;\n    flex: 0 0 var(--#{$prefix}sidebar-narrow-width);\n    width: var(--#{$prefix}sidebar-narrow-width);\n    padding-bottom: var(--#{$prefix}sidebar-toggler-height);\n    overflow: visible;\n\n    &.sidebar-fixed {\n      z-index: $zindex-fixed + 1;\n      width: var(--#{$prefix}sidebar-narrow-width);\n    }\n\n    .sidebar-brand-full {\n      display: none;\n    }\n\n    .sidebar-brand-narrow {\n      display: block;\n    }\n\n    .d-narrow-none,\n    .nav-label,\n    .nav-title,\n    .nav-group-items,\n    .nav-group.show .nav-group-items,\n    .sidebar-footer,\n    .sidebar-form,\n    .sidebar-header {\n      height: 0 !important; // stylelint-disable-line declaration-no-important\n      padding: 0;\n      margin: 0;\n      visibility: hidden;\n      opacity: 0;\n    }\n\n    .sidebar-toggler {\n      position: fixed;\n      bottom: 0;\n\n      &::before {\n        @include ltr-rtl(\"transform\", rotate(-180deg), null, rotate(0deg));\n      }\n    }\n\n    &.sidebar-end .sidebar-toggler::before {\n      transform: rotate(0deg);\n    }\n  }\n}\n\n.sidebar-narrow {\n  @extend %sidebar-narrow;\n  &:not(.sidebar-end) ~ * {\n    --#{$prefix}sidebar-occupy-start: #{$sidebar-narrow-width};\n  }\n  &.sidebar-end ~ * {\n    --#{$prefix}sidebar-occupy-end: #{$sidebar-narrow-width};\n  }\n}\n\n.sidebar-narrow-unfoldable {\n  position: fixed;\n  z-index: $zindex-fixed + 1;\n\n  &:not(.sidebar-end) ~ * {\n    --#{$prefix}sidebar-occupy-start: #{$sidebar-narrow-width};\n  }\n  &.sidebar-end ~ * {\n    --#{$prefix}sidebar-occupy-end: #{$sidebar-narrow-width};\n  }\n\n  &:not(:hover) {\n    @extend %sidebar-narrow;\n  }\n\n  &:hover {\n    .sidebar-toggler {\n      &::before {\n        @include ltr-rtl(\"transform\", rotate(-180deg), null, rotate(0deg));\n      }\n    }\n\n    &.sidebar-end .sidebar-toggler::before {\n      transform: rotate(0deg);\n    }\n  }\n}\n\n// Responsive behavior\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-down($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n    .sidebar:not(.show).sidebar-self-hiding#{$infix} {\n      &.sidebar-narrow,\n      &.sidebar-narrow-unfoldable {\n        &:not(.sidebar-end) {\n          @include ltr-rtl(\"margin-left\", calc(var(--#{$prefix}sidebar-narrow-width) * -1));\n        }\n        &.sidebar-end {\n          @include ltr-rtl(\"margin-right\", calc(var(--#{$prefix}sidebar-narrow-width) * -1));\n        }\n      }\n    }\n  }\n}\n",".subheader {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  min-height: $subheader-min-height;\n  padding: $subheader-padding-y $subheader-padding-x;\n  background: var(--#{$prefix}subheader-bg, $subheader-bg);\n  border-bottom: var(--#{$prefix}subheader-border-width, $subheader-border-width) solid var(--#{$prefix}subheader-border-color, $subheader-border-color);\n}\n\n.subheader-sticky {\n  position: sticky;\n  top: 0;\n  z-index: $zindex-fixed - 1;\n}\n\n// Subheader nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.subheader-nav {\n  display: flex;\n  flex-direction: row; // cannot use `inherit` to get the `.header`s value\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: $subheader-nav-link-padding-x;\n    padding-left: $subheader-nav-link-padding-x;\n    color: var(--#{$prefix}subheader-color, $subheader-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}subheader-hover-color, $subheader-hover-color);\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}subheader-disabled-color, $subheader-disabled-color);\n    }\n  }\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}subheader-active-color, $subheader-active-color);\n  }\n\n  .dropdown-menu {\n    position: absolute;\n  }\n}\n\n// Subheader text\n//\n//\n\n.subheader-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}subheader-color, $subheader-color);\n\n  a {\n    color: var(--#{$prefix}subheader-active-color, $subheader-active-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}subheader-active-color, $subheader-active-color);\n    }\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--cui-focus-ring-x`, `--cui-focus-ring-y`, or `--cui-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    @include ltr-rtl(\"left\", 0);\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  padding: 0;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix, $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    // Generate RTL version\n    $generate-rtl: if(map-has-key($utility, rtl), map-get($utility, rtl), false);\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            @if $generate-rtl == true {\n              @include ltr-rtl($property, $value, null, null, if($enable-important-utilities, !important, null));\n            } @else {\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/*!\n * CoreUI Plugins - Chart.js for CoreUI 3\n * @version v3.1.2\n * @link https://coreui.io\n * Copyright (c) 2021 creativeLabs Łukasz Holeczek\n * Licensed under MIT (https://github.com/coreui/coreui-chartjs/blob/main/LICENSE)\n */\n\n\n@import \"@coreui/coreui/scss/functions\";\n@import \"@coreui/coreui/scss/variables\";\n@import \"@coreui/coreui/scss/mixins\";\n@import \"tooltips\";\n","// Custom tooltips\n\n.chartjs-tooltip {\n  position: absolute;\n  z-index: $zindex-sticky + 1;\n  padding: ($spacer * .25) ($spacer * .5);\n  color: #fff;\n  pointer-events: none;\n  background: rgba(0, 0, 0, .7);\n  opacity: 0;\n  @include transition(all .15s ease);\n  transform: translate(-50%, 0);\n  @include border-radius($border-radius);\n}\n\n.chartjs-tooltip-header {\n  margin-bottom: ($spacer * .5);\n}\n\n.chartjs-tooltip-header-item {\n  font-size: $font-size-sm;\n  font-weight: $font-weight-bold;\n}\n\n.chartjs-tooltip-body-item {\n  align-items: center;\n  font-size: $font-size-sm;\n  white-space: nowrap;\n}\n","@each $color, $value in $theme-colors {\r\n    $color-rgb: to-rgb($value);\r\n    .text-bg-#{$color} {\r\n      color: color-contrast($value) if($enable-important-utilities, !important, null);\r\n      background-color: RGBA($color-rgb, var(--cui-bg-opacity, 1)) if($enable-important-utilities, !important, null);\r\n    }\r\n  }\r\n  ",".wrapper {\n  width: 100%;\n  @include ltr-rtl(\"padding-left\", var(--cui-sidebar-occupy-start, 0));\n  will-change: auto;\n  @include transition(padding .15s);\n}\n","// Here you can add other styles\r\n/*Color Codes*/\r\n/*Shadow Codes*/\r\n/*Fonts*/\r\n/*Screen Size*/\r\n/*Animation*/\r\n/* Media query Manager */\r\n/*\r\n0 - 600px       :   Phone\r\n601 - 900px     :   Tablet Potrait\r\n901 - 1200px    :   Tablet Landscape\r\n1201 - 1800px   :   Desktop\r\n1801 +          :   BigDesktop\r\n*/\r\n/*Break-point argument choices:\r\n- mob\r\n- tab-p\r\n- tab-l\r\n- b-desktop\r\n*/\r\n// @import url(https://fonts.googleapis.com/css?family=Roboto:100,300,400,900,700,500,300,100);\r\n// @import \"https://fonts.googleapis.com/css2?family=Comfortaa:wght@300;400;500;600;700&family=Nunito:ital,wght@0,200;0,300;0,400;0,600;0,700;0,800;0,900;1,200&display=swap\";\r\n// @import url('https://fonts.cdnfonts.com/css/merchant-copy-doublesize');\r\n\r\n// html, body {\r\n//   width: 100%;\r\n//   max-width: 100vw;\r\n//   overflow-x: hidden;\r\n//   margin: 0;\r\n//   padding: 0;\r\n// }\r\n\r\n@font-face {\r\n    font-family: 'Inter';\r\n    src: url('../assets/fonts/Inter-VariableFont.ttf') format('truetype');\r\n    font-weight: 100 900;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'Inter';\r\n  src: url('../assets/fonts/Inter-Italic-VariableFont.ttf') format('truetype');\r\n  font-style: italic;\r\n  font-weight: 100 900;\r\n  font-display: swap;\r\n}\r\n\r\nbody {\r\n    background: #838389;\r\n    // font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, 'Nunito', Helvetica, Arial, sans-serif;\r\n    font-size: 11pt;\r\n\r\n}\r\n\r\n:root {\r\n    iframe#webpack-dev-server-client-overlay {\r\n        display: none !important\r\n    }\r\n}\r\n\r\n\r\n:root {\r\n    // --cui-font-sans-serif: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\r\n    --cui-font-sans-serif:\r\n        \"Inter\",\r\n        system-ui,\r\n        -apple-system,\r\n        BlinkMacSystemFont,\r\n        \"Segoe UI\",\r\n        Roboto,\r\n        Helvetica,\r\n        Arial,\r\n        sans-serif;\r\n    --cui-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\r\n    --cui-card-cap-padding-y: 0.5rem;\r\n    --cui-card-cap-padding-x: 1rem;\r\n    --cui-card-border-color: rgba(0,0,21,.125);\r\n    --cui-card-cap-bg: rgba(0,0,21,.03);\r\n    --cui-sidebar-nav-link-color: white;\r\n    --cui-card-border-width:1px;\r\n    --cui-card-border-color:#E5E7EB;\r\n    --cui-card-cap-bg:#FFFFFF;\r\n    --cui-primary: #0f766e;\r\n    --cui-btn-bg: #0f766e;\r\n    --cui-primary-rgb: 15, 118, 110;\r\n}\r\n\r\n.form-control:disabled, .form-control[readonly] {\r\n    background-color: #d8dbe0;\r\n    background-color: var(--cui-input-disabled-bg,#d8dbe0);\r\n    border-color: #b1b7c1;\r\n    border-color: var(--cui-input-disabled-border-color,#b1b7c1);\r\n    opacity: 1;\r\n}\r\n\r\n\r\n\r\n// .with_logo {\r\n//     background-image: url('../assets/brand/bg-logo.png');\r\n//     background-repeat: no-repeat;\r\n//     background-size: 100% 100%;\r\n//      -webkit-print-color-adjust: exact;\r\n//     print-color-adjust: exact;\r\n// }\r\n\r\n// @media print {\r\n//     .with_logo {\r\n//     background-image: url('../assets/brand/bg-logo.png') !important;\r\n//         // background-image: url('../static/media/bg-logo.png') !important;\r\n//         background-repeat: no-repeat !important;\r\n//         background-size: 100% 100% !important;\r\n\r\n//         -webkit-print-color-adjust: exact !important;\r\n//         print-color-adjust: exact !important;\r\n//     }\r\n// }\r\n\r\n.reg_pelanggan {\r\n    position: absolute;\r\n    top: 40mm;\r\n    left: 30mm;\r\n    right: 10mm;\r\n}\r\n\r\n.card.disabled {\r\n    background-color: #e9ecef;\r\n    opacity: 0.7;\r\n    z-index: 20;\r\n}\r\n\r\n\r\n.toggle,\r\n[id^=drop] {\r\n    display: none;\r\n}\r\n\r\n/* Giving a background-color to the nav container. */\r\n\r\n\r\n.foto_tambah_pelanggan {\r\n    padding-top: 38% !important;\r\n    padding-top: 38%;\r\n    background-position: 50%;\r\n    border-radius: 10px;\r\n    background-color: rgb(0, 0, 0, 0.65);\r\n}\r\n\r\n.foto_tambah_mitra {\r\n    padding-top: 38% !important;\r\n    padding-top: 38%;\r\n    background-position: 50%;\r\n\r\n}\r\n\r\n.pie-chart {\r\n    margin: 20px;\r\n    text-align: center;\r\n\r\n    &>svg {\r\n        &>path {\r\n            stroke: var(--color1);\r\n            stroke-width: 1px;\r\n        }\r\n\r\n        &>a {\r\n            transition: opacity var(--fade);\r\n            opacity: 0;\r\n\r\n            &>text {\r\n                font-weight: bold;\r\n                opacity: 0.4;\r\n            }\r\n\r\n            &>path {\r\n                stroke: var(--color4);\r\n            }\r\n\r\n            &:hover {\r\n                opacity: 1;\r\n            }\r\n        }\r\n    }\r\n\r\n    &>.legend {\r\n        text-align: left;\r\n        margin: 15px;\r\n\r\n        &>.legend-line {\r\n            &>.color {\r\n                height: 12px;\r\n                width: 12px;\r\n                margin-right: 5px;\r\n                border: 1px solid var(--color1);\r\n                display: inline-block;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.dropdown-menu {\r\n    background-clip: padding-box;\r\n    background-color: #fff;\r\n    background-color: var(--cui-dropdown-bg,#fff);\r\n    border: 1px solid rgba(0,0,21,.15);\r\n    border: 1px solid var(--cui-dropdown-border-color,rgba(0,0,21,.15));\r\n    border-radius: 0.25rem;\r\n    box-shadow: 0 0.5rem 1rem rgba(0,0,21,.15);\r\n    color: rgba(44,56,74,.95);\r\n    color: var(--cui-dropdown-color,rgba(44,56,74,.95));\r\n    display: none;\r\n    font-size: 1rem;\r\n    list-style: none;\r\n    margin: 0;\r\n    min-width: 10rem;\r\n    padding: 0.5rem 0;\r\n    position: absolute;\r\n    text-align: start;\r\n    z-index: 1000;\r\n}\r\n\r\n/* Media Queries\r\n--------------------------------------------- */\r\n@media all and (max-width: 768px) {\r\n    .logo {\r\n        display: block;\r\n        padding: 0;\r\n        width: 100%;\r\n        text-align: center;\r\n        float: none;\r\n    }\r\n\r\n    nav {\r\n        margin: 0;\r\n    }\r\n\r\n    /* Hide the navigation menu by default */\r\n    /* Also hide the  */\r\n    .toggle+a,\r\n    .menu {\r\n        display: none;\r\n    }\r\n\r\n    /* Stylinf the toggle lable */\r\n    .toggle {\r\n        display: block;\r\n        background-color: #ffffff;\r\n        padding: 14px 20px;\r\n        color: #1A1919;\r\n        font-size: 17px;\r\n        text-decoration: none;\r\n        border: none;\r\n    }\r\n\r\n    .toggle:hover {\r\n        background-color: #badefc;\r\n    }\r\n\r\n    /* Display Dropdown when clicked on Parent Lable */\r\n    [id^=drop]:checked+ul {\r\n        display: block;\r\n        width: -webkit-fill-available;\r\n    }\r\n\r\n    /* Change menu item's width to 100% */\r\n    nav ul li {\r\n        display: block;\r\n        width: 100%;\r\n    }\r\n\r\n    nav ul ul .toggle,\r\n    nav ul ul a {\r\n        padding: 0 40px;\r\n    }\r\n\r\n    nav ul ul ul a {\r\n        padding: 0 80px;\r\n    }\r\n\r\n    nav a:hover,\r\n    nav ul ul ul a {\r\n        background-color: #badefc;\r\n    }\r\n\r\n    nav ul li ul li .toggle,\r\n    nav ul ul a,\r\n    nav ul ul ul a {\r\n        padding: 14px 20px;\r\n        color: #1A1919;\r\n        font-size: 17px;\r\n    }\r\n\r\n    /* Hide Dropdowns by Default */\r\n    nav ul ul {\r\n        float: none;\r\n        position: static;\r\n        color: #1A1919;\r\n        /* has to be the same number as the \"line-height\" of \"nav a\" */\r\n    }\r\n\r\n    /* Hide menus on hover */\r\n    nav ul ul li:hover>ul,\r\n    nav ul li:hover>ul {\r\n        display: none;\r\n    }\r\n\r\n    /* Fisrt Tier Dropdown */\r\n    nav ul ul li {\r\n        display: block;\r\n        width: 100%;\r\n    }\r\n\r\n    nav ul ul ul li {\r\n        position: static;\r\n        /* has to be the same number as the \"width\" of \"nav ul ul li\" */\r\n    }\r\n}\r\n\r\n@media all and (max-width: 330px) {\r\n    nav ul li {\r\n        display: block;\r\n        width: 94%;\r\n    }\r\n}\r\n\r\n.dropdown a {\r\n    color: #1A1919;\r\n}\r\n\r\n.dropdown a:hover {\r\n    color: #1A1919;\r\n}\r\n\r\n/* Dropdown */\r\n.dropdown {\r\n    display: inline-block;\r\n    position: relative;\r\n}\r\n\r\n.dd-button {\r\n    display: inline-block;\r\n    background-color: #badefc;\r\n    outline: 1px solid #a5c3e4;\r\n    outline-offset: -1px;\r\n    color: #1A1919;\r\n    cursor: pointer;\r\n    white-space: nowrap;\r\n    padding: 14px 20px;\r\n}\r\n\r\n.dd-button span {\r\n    padding: 0 16px 0 0;\r\n    vertical-align: middle;\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    letter-spacing: 0.5px;\r\n}\r\n\r\n.dd-button:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 0.7rem;\r\n    transform: translateY(-50%);\r\n    width: 0;\r\n    height: 0;\r\n    border-left: 5px solid transparent;\r\n    border-right: 5px solid transparent;\r\n    border-top: 5px solid #1A1919;\r\n}\r\n\r\n.dd-input {\r\n    display: none;\r\n}\r\n\r\n.dd-menu {\r\n    position: absolute;\r\n    top: 100%;\r\n    border-radius: 4px;\r\n    padding: 0;\r\n    margin: 4px 0 0 0;\r\n    box-shadow: 2px 5px 12px 0px rgba(14, 97, 185, 0.1);\r\n    background-color: #ffffff;\r\n    list-style-type: none;\r\n    z-index: 99;\r\n    right: 0;\r\n}\r\n\r\n.dd-input+.dd-menu {\r\n    display: none;\r\n}\r\n\r\n.dd-input:checked+.dd-menu {\r\n    display: block;\r\n}\r\n\r\n.dd-menu li {\r\n    padding: 0.8rem 1.5rem;\r\n    cursor: pointer;\r\n    white-space: nowrap;\r\n    font-weight: 400;\r\n}\r\n\r\n.dd-menu li a {\r\n    display: block;\r\n    margin: -10px -20px;\r\n    padding: 10px 20px;\r\n}\r\n\r\n.dd-menu li.divider {\r\n    padding: 0;\r\n    border-bottom: 1px solid #a5c3e4;\r\n}\r\n\r\n/* apply a natural box layout model to all elements, but allowing components to change */\r\n*,\r\n::after,\r\n::before {\r\n    box-sizing: border-box;\r\n}\r\n\r\n\r\n\r\na {\r\n    color: #0e61b9;\r\n    text-decoration: none;\r\n    transition: color 0.1s linear;\r\n}\r\n\r\n.preloader-container {\r\n    position: relative;\r\n  }\r\n\r\n  tbody.ct-centered {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .preloader-ct {\r\n    border: 8px solid #3498db;\r\n    border-top: 8px solid #f0f0f0;\r\n    border-radius: 50%;\r\n    width: 50px;\r\n    height: 50px;\r\n    animation: spin 1s linear infinite;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n  }\r\n\r\n  @keyframes spin {\r\n    0% { transform: translate(-50%, -50%) rotate(0deg); }\r\n    100% { transform: translate(-50%, -50%) rotate(360deg); }\r\n  }\r\n\r\n\r\n\r\n\r\n.projectname-container {\r\n    font-size: 15px;\r\n    width: 100%;\r\n    padding-right: 15px;\r\n    padding-left: 15px;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n    .projectname-container {\r\n        max-width: 1360px;\r\n    }\r\n}\r\n\r\n@media (max-width: 1399px) and (min-width: 1200px) {\r\n    .projectname-container {\r\n        max-width: 1140px;\r\n    }\r\n}\r\n\r\n@media (max-width: 1199px) and (min-width: 992px) {\r\n    .projectname-container {\r\n        max-width: 960px;\r\n    }\r\n}\r\n\r\n@media (max-width: 991px) and (min-width: 768px) {\r\n    .projectname-container {\r\n        max-width: 720px;\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) and (min-width: 576px) {\r\n    .projectname-container {\r\n        max-width: 540px;\r\n    }\r\n}\r\n\r\n.projectname-breadcrumb--section {\r\n    background-color: #f9f9f9;\r\n}\r\n\r\n.projectname-page-header .breadcrumbs ol {\r\n    display: inline-flex;\r\n}\r\n\r\n.projectname-page-header .breadcrumbs ol .breadcrumb {\r\n    margin: 1rem 0.5rem;\r\n}\r\n\r\n.projectname-page-header .breadcrumbs ol .breadcrumb::after {\r\n    margin-left: 0.5rem;\r\n    content: \"/\";\r\n}\r\n\r\n.projectname-page-header .breadcrumbs ol .breadcrumb:last-child {\r\n    pointer-events: none;\r\n    cursor: default;\r\n}\r\n\r\n.projectname-page-header .breadcrumbs ol .breadcrumb:last-child a {\r\n    color: #1A1919;\r\n}\r\n\r\n.projectname-page-header .breadcrumbs ol .breadcrumb:last-child a:hover {\r\n    pointer-events: none;\r\n    cursor: default;\r\n}\r\n\r\n.projectname-page-header .breadcrumbs ol .breadcrumb:last-child::after {\r\n    content: \"\";\r\n}\r\n\r\n.projectname-form-container {\r\n    padding: 2rem 0rem;\r\n}\r\n\r\n.projectname-right--section,\r\n.projectname-model {\r\n    background: #ffffff;\r\n    border-radius: 6px;\r\n    border: 0px solid #a5c3e4;\r\n    box-shadow: 2px 5px 12px 0px rgba(14, 97, 185, 0.1);\r\n}\r\n\r\n.projectname-right--section .form--header,\r\n.projectname-model .form--header {\r\n    padding: 1.5rem 3rem;\r\n}\r\n\r\n.projectname-right--section .form--header_heading,\r\n.projectname-model .form--header_heading {\r\n    align-items: center;\r\n}\r\n\r\n.projectname-right--section .form--header_heading h2,\r\n.projectname-model .form--header_heading h2 {\r\n    font-family: \"Mulish\", sans-serif;\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n    line-height: 40px;\r\n}\r\n\r\n.projectname-right--section .form--header_heading-description,\r\n.projectname-model .form--header_heading-description {\r\n    color: #767676;\r\n}\r\n\r\n.projectname-right--section .form--header_sub-heading,\r\n.projectname-model .form--header_sub-heading {\r\n    font-size: 1.2rem;\r\n    margin: 1rem 0;\r\n    margin-top: 1.5rem;\r\n}\r\n\r\n.projectname-right--section .form--body,\r\n.projectname-model .form--body {\r\n    padding: 0 3rem;\r\n}\r\n\r\n.projectname-right--section .form--footer,\r\n.projectname-model .form--footer {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    margin-top: 1.5rem;\r\n    border-top: 1px solid #DFE0E2;\r\n    display: flex;\r\n    -webkit-box-pack: justify;\r\n    -ms-flex-pack: justify;\r\n    justify-content: flex-end;\r\n    padding: 1.5rem 3rem;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button_outline-brand,\r\n.projectname-model .form--footer .slds-button_outline-brand {\r\n    padding: 0.3rem 1.5rem;\r\n    background: transparent;\r\n    color: #0e61b9;\r\n    border: 0px;\r\n    box-shadow: none;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button_outline-brand,\r\n.projectname-right--section .form--footer .slds-button_outline-brand:link,\r\n.projectname-right--section .form--footer .slds-button_outline-brand:visited,\r\n.projectname-model .form--footer .slds-button_outline-brand,\r\n.projectname-model .form--footer .slds-button_outline-brand:link,\r\n.projectname-model .form--footer .slds-button_outline-brand:visited {\r\n    align-items: center;\r\n    border-radius: 2px;\r\n    display: inline-flex;\r\n    flex: 0 0 auto;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    justify-content: center;\r\n    min-width: 88px;\r\n    outline: 0;\r\n    text-decoration: none;\r\n    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;\r\n    position: relative;\r\n    vertical-align: middle;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    will-change: box-shadow;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button_outline-brand:hover,\r\n.projectname-model .form--footer .slds-button_outline-brand:hover {\r\n    background: #215FAB;\r\n    border: 1px solid #0e61b9;\r\n    color: #ffffff;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button_outline-brand:hover,\r\n.projectname-model .form--footer .slds-button_outline-brand:hover {\r\n    background: rgba(14, 97, 185, 0.1);\r\n    color: #0e61b9;\r\n    border: 0px;\r\n    box-shadow: none;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button_neutral,\r\n.projectname-model .form--footer .slds-button_neutral {\r\n    padding: 0.3rem 1.5rem;\r\n    background: transparent;\r\n    color: #6C6E75;\r\n    border: 0px;\r\n    box-shadow: none;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button_neutral,\r\n.projectname-right--section .form--footer .slds-button_neutral:link,\r\n.projectname-right--section .form--footer .slds-button_neutral:visited,\r\n.projectname-model .form--footer .slds-button_neutral,\r\n.projectname-model .form--footer .slds-button_neutral:link,\r\n.projectname-model .form--footer .slds-button_neutral:visited {\r\n    align-items: center;\r\n    border-radius: 2px;\r\n    display: inline-flex;\r\n    flex: 0 0 auto;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    justify-content: center;\r\n    min-width: 88px;\r\n    outline: 0;\r\n    text-decoration: none;\r\n    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;\r\n    position: relative;\r\n    vertical-align: middle;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    will-change: box-shadow;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button_neutral:hover,\r\n.projectname-model .form--footer .slds-button_neutral:hover {\r\n    background: #215FAB;\r\n    border: 1px solid #0e61b9;\r\n    color: #ffffff;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button_neutral:hover,\r\n.projectname-model .form--footer .slds-button_neutral:hover {\r\n    background: rgba(108, 110, 117, 0.1);\r\n    color: #6C6E75;\r\n    border: 0px;\r\n    box-shadow: none;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button.slds-button_brand,\r\n.projectname-model .form--footer .slds-button.slds-button_brand {\r\n    padding: 0.3rem 1.5rem;\r\n    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\r\n    background: #0e61b9;\r\n    border: 1px solid #0e61b9;\r\n    color: #ffffff;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button.slds-button_brand,\r\n.projectname-right--section .form--footer .slds-button.slds-button_brand:link,\r\n.projectname-right--section .form--footer .slds-button.slds-button_brand:visited,\r\n.projectname-model .form--footer .slds-button.slds-button_brand,\r\n.projectname-model .form--footer .slds-button.slds-button_brand:link,\r\n.projectname-model .form--footer .slds-button.slds-button_brand:visited {\r\n    align-items: center;\r\n    border-radius: 2px;\r\n    display: inline-flex;\r\n    flex: 0 0 auto;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    justify-content: center;\r\n    min-width: 88px;\r\n    outline: 0;\r\n    text-decoration: none;\r\n    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;\r\n    position: relative;\r\n    vertical-align: middle;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    will-change: box-shadow;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button.slds-button_brand:hover,\r\n.projectname-model .form--footer .slds-button.slds-button_brand:hover {\r\n    background: #215FAB;\r\n    border: 1px solid #0e61b9;\r\n    color: #ffffff;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button.slds-button_brand:active,\r\n.projectname-right--section .form--footer .slds-button.slds-button_brand:focus,\r\n.projectname-model .form--footer .slds-button.slds-button_brand:active,\r\n.projectname-model .form--footer .slds-button.slds-button_brand:focus {\r\n    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button_destructive,\r\n.projectname-model .form--footer .slds-button_destructive {\r\n    padding: 0.3rem 1.5rem;\r\n    background: transparent;\r\n    color: #E71D36;\r\n    border: 0px;\r\n    box-shadow: none;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button_destructive,\r\n.projectname-right--section .form--footer .slds-button_destructive:link,\r\n.projectname-right--section .form--footer .slds-button_destructive:visited,\r\n.projectname-model .form--footer .slds-button_destructive,\r\n.projectname-model .form--footer .slds-button_destructive:link,\r\n.projectname-model .form--footer .slds-button_destructive:visited {\r\n    align-items: center;\r\n    border-radius: 2px;\r\n    display: inline-flex;\r\n    flex: 0 0 auto;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    justify-content: center;\r\n    min-width: 88px;\r\n    outline: 0;\r\n    text-decoration: none;\r\n    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;\r\n    position: relative;\r\n    vertical-align: middle;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    will-change: box-shadow;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button_destructive:hover,\r\n.projectname-model .form--footer .slds-button_destructive:hover {\r\n    background: #215FAB;\r\n    border: 1px solid #0e61b9;\r\n    color: #ffffff;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button_destructive:hover,\r\n.projectname-model .form--footer .slds-button_destructive:hover {\r\n    background: rgba(231, 29, 54, 0.1);\r\n    color: #E71D36;\r\n    border: 0px;\r\n    box-shadow: none;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button_success,\r\n.projectname-model .form--footer .slds-button_success {\r\n    padding: 0.3rem 1.5rem;\r\n    background: transparent;\r\n    color: #90be6d;\r\n    border: 0px;\r\n    box-shadow: none;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button_success,\r\n.projectname-right--section .form--footer .slds-button_success:link,\r\n.projectname-right--section .form--footer .slds-button_success:visited,\r\n.projectname-model .form--footer .slds-button_success,\r\n.projectname-model .form--footer .slds-button_success:link,\r\n.projectname-model .form--footer .slds-button_success:visited {\r\n    align-items: center;\r\n    border-radius: 2px;\r\n    display: inline-flex;\r\n    flex: 0 0 auto;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    justify-content: center;\r\n    min-width: 88px;\r\n    outline: 0;\r\n    text-decoration: none;\r\n    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;\r\n    position: relative;\r\n    vertical-align: middle;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    will-change: box-shadow;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button_success:hover,\r\n.projectname-model .form--footer .slds-button_success:hover {\r\n    background: #215FAB;\r\n    border: 1px solid #0e61b9;\r\n    color: #ffffff;\r\n}\r\n\r\n.projectname-right--section .form--footer .slds-button_success:hover,\r\n.projectname-model .form--footer .slds-button_success:hover {\r\n    background: rgba(144, 190, 109, 0.1);\r\n    color: #90be6d;\r\n    border: 0px;\r\n    box-shadow: none;\r\n}\r\n\r\n.projectname-right--section .yn_question,\r\n.projectname-model .yn_question {\r\n    display: grid;\r\n    grid-template-columns: 3fr 1fr;\r\n    align-items: center;\r\n}\r\n\r\n.projectname-right--section .yn_question .question,\r\n.projectname-model .yn_question .question {\r\n    color: #333333;\r\n    font-family: HelveticaNeue-Medium;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    line-height: 30px;\r\n}\r\n\r\n.projectname-right--section .yn_question .question .sub_section,\r\n.projectname-model .yn_question .question .sub_section {\r\n    color: #333333;\r\n    font-family: HelveticaNeue;\r\n    font-size: 12px;\r\n}\r\n\r\n.projectname-right--section .yn_question .anwser .projectname-radio-buttons,\r\n.projectname-model .yn_question .anwser .projectname-radio-buttons {\r\n    margin-top: 0rem;\r\n}\r\n\r\n.projectname-right--section .yn_question .anwser .projectname-radio-buttons .slds-radio label,\r\n.projectname-model .yn_question .anwser .projectname-radio-buttons .slds-radio label {\r\n    padding: 1.25rem 2.25rem 1.25rem 2.25rem;\r\n}\r\n\r\n.projectname-right--section:not(:first-child) {\r\n    margin-top: 2rem;\r\n}\r\n\r\n.projectname-model {\r\n    margin: auto;\r\n}\r\n\r\n.projectname-model--lg {\r\n    width: 90%;\r\n}\r\n\r\n.projectname-model--md {\r\n    width: 60%;\r\n}\r\n\r\n.projectname-model--sm {\r\n    width: 35%;\r\n}\r\n\r\n.projectname-button--section {\r\n    display: flex;\r\n    -webkit-box-pack: justify;\r\n    -ms-flex-pack: justify;\r\n    justify-content: flex-end;\r\n    padding: 2rem 0;\r\n}\r\n\r\n.projectname-button--section .slds-button_outline-brand {\r\n    padding: 0.3rem 1.5rem;\r\n    background: transparent;\r\n    color: #0e61b9;\r\n    border: 0px;\r\n    box-shadow: none;\r\n}\r\n\r\n.projectname-button--section .slds-button_outline-brand,\r\n.projectname-button--section .slds-button_outline-brand:link,\r\n.projectname-button--section .slds-button_outline-brand:visited {\r\n    align-items: center;\r\n    border-radius: 2px;\r\n    display: inline-flex;\r\n    flex: 0 0 auto;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    justify-content: center;\r\n    min-width: 88px;\r\n    outline: 0;\r\n    text-decoration: none;\r\n    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;\r\n    position: relative;\r\n    vertical-align: middle;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    will-change: box-shadow;\r\n}\r\n\r\n.projectname-button--section .slds-button_outline-brand:hover {\r\n    background: #215FAB;\r\n    border: 1px solid #0e61b9;\r\n    color: #ffffff;\r\n}\r\n\r\n.projectname-button--section .slds-button_outline-brand:hover {\r\n    background: rgba(14, 97, 185, 0.1);\r\n    color: #0e61b9;\r\n    border: 0px;\r\n    box-shadow: none;\r\n}\r\n\r\n.projectname-button--section .slds-button_neutral {\r\n    padding: 0.3rem 1.5rem;\r\n    background: transparent;\r\n    color: #6C6E75;\r\n    border: 0px;\r\n    box-shadow: none;\r\n}\r\n\r\n.projectname-button--section .slds-button_neutral,\r\n.projectname-button--section .slds-button_neutral:link,\r\n.projectname-button--section .slds-button_neutral:visited {\r\n    align-items: center;\r\n    border-radius: 2px;\r\n    display: inline-flex;\r\n    flex: 0 0 auto;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    justify-content: center;\r\n    min-width: 88px;\r\n    outline: 0;\r\n    text-decoration: none;\r\n    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;\r\n    position: relative;\r\n    vertical-align: middle;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    will-change: box-shadow;\r\n}\r\n\r\n.projectname-button--section .slds-button_neutral:hover {\r\n    background: #215FAB;\r\n    border: 1px solid #0e61b9;\r\n    color: #ffffff;\r\n}\r\n\r\n.projectname-button--section .slds-button_neutral:hover {\r\n    background: rgba(108, 110, 117, 0.1);\r\n    color: #6C6E75;\r\n    border: 0px;\r\n    box-shadow: none;\r\n}\r\n\r\n.projectname-button--section .slds-button.slds-button_brand {\r\n    padding: 0.3rem 1.5rem;\r\n    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\r\n    background: #0e61b9;\r\n    border: 1px solid #0e61b9;\r\n    color: #ffffff;\r\n}\r\n\r\n.projectname-button--section .slds-button.slds-button_brand,\r\n.projectname-button--section .slds-button.slds-button_brand:link,\r\n.projectname-button--section .slds-button.slds-button_brand:visited {\r\n    align-items: center;\r\n    border-radius: 2px;\r\n    display: inline-flex;\r\n    flex: 0 0 auto;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    justify-content: center;\r\n    min-width: 88px;\r\n    outline: 0;\r\n    text-decoration: none;\r\n    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;\r\n    position: relative;\r\n    vertical-align: middle;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    will-change: box-shadow;\r\n}\r\n\r\n.projectname-button--section .slds-button.slds-button_brand:hover {\r\n    background: #215FAB;\r\n    border: 1px solid #0e61b9;\r\n    color: #ffffff;\r\n}\r\n\r\n.projectname-button--section .slds-button.slds-button_brand:active,\r\n.projectname-button--section .slds-button.slds-button_brand:focus {\r\n    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.projectname-button--section .slds-button_destructive {\r\n    padding: 0.3rem 1.5rem;\r\n    background: transparent;\r\n    color: #E71D36;\r\n    border: 0px;\r\n    box-shadow: none;\r\n}\r\n\r\n.projectname-button--section .slds-button_destructive,\r\n.projectname-button--section .slds-button_destructive:link,\r\n.projectname-button--section .slds-button_destructive:visited {\r\n    align-items: center;\r\n    border-radius: 2px;\r\n    display: inline-flex;\r\n    flex: 0 0 auto;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    justify-content: center;\r\n    min-width: 88px;\r\n    outline: 0;\r\n    text-decoration: none;\r\n    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;\r\n    position: relative;\r\n    vertical-align: middle;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    will-change: box-shadow;\r\n}\r\n\r\n.projectname-button--section .slds-button_destructive:hover {\r\n    background: #215FAB;\r\n    border: 1px solid #0e61b9;\r\n    color: #ffffff;\r\n}\r\n\r\n.projectname-button--section .slds-button_destructive:hover {\r\n    background: rgba(231, 29, 54, 0.1);\r\n    color: #E71D36;\r\n    border: 0px;\r\n    box-shadow: none;\r\n}\r\n\r\n.projectname-button--section .slds-button_success {\r\n    padding: 0.3rem 1.5rem;\r\n    background: transparent;\r\n    color: #90be6d;\r\n    border: 0px;\r\n    box-shadow: none;\r\n}\r\n\r\n.projectname-button--section .slds-button_success,\r\n.projectname-button--section .slds-button_success:link,\r\n.projectname-button--section .slds-button_success:visited {\r\n    align-items: center;\r\n    border-radius: 2px;\r\n    display: inline-flex;\r\n    flex: 0 0 auto;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    justify-content: center;\r\n    min-width: 88px;\r\n    outline: 0;\r\n    text-decoration: none;\r\n    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;\r\n    position: relative;\r\n    vertical-align: middle;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    will-change: box-shadow;\r\n}\r\n\r\n.projectname-button--section .slds-button_success:hover {\r\n    background: #215FAB;\r\n    border: 1px solid #0e61b9;\r\n    color: #ffffff;\r\n}\r\n\r\n.projectname-button--section .slds-button_success:hover {\r\n    background: rgba(144, 190, 109, 0.1);\r\n    color: #90be6d;\r\n    border: 0px;\r\n    box-shadow: none;\r\n}\r\n\r\n.projectname-radio-buttons {\r\n    margin-top: 1rem;\r\n}\r\n\r\n.projectname-radio-buttons .slds-radio {\r\n    padding: 0;\r\n}\r\n\r\n.projectname-radio-buttons .slds-radio label {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0.25rem 1.25rem 0.25rem 1.25rem;\r\n    border: 1px solid #ddd;\r\n    border-radius: 3px;\r\n    min-height: 2.5rem;\r\n}\r\n\r\n.projectname-radio-buttons .slds-radio label .slds-form-element__label {\r\n    padding-right: 0;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .projectname-radio-buttons .slds-radio+.slds-radio {\r\n        margin-left: 1rem;\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .projectname-radio-buttons.btns-x {\r\n        display: flex;\r\n    }\r\n}\r\n\r\n.projectname-vertical-wizard {\r\n    border-right: 1px solid #DFE0E2;\r\n}\r\n\r\n.projectname-vertical-wizard ul {\r\n    margin: 0;\r\n    padding: 0;\r\n    list-style: none;\r\n}\r\n\r\n.projectname-vertical-wizard li {\r\n    display: block;\r\n    position: relative;\r\n}\r\n\r\n.projectname-vertical-wizard li.complete .ico {\r\n    left: 8px;\r\n}\r\n\r\n.projectname-vertical-wizard li.complete a::before {\r\n    background-color: #90be6d;\r\n    opacity: 1;\r\n    height: calc(100% - 25px);\r\n    bottom: -9px;\r\n}\r\n\r\n.projectname-vertical-wizard li.complete a::after {\r\n    display: none;\r\n}\r\n\r\n.projectname-vertical-wizard li.locked>a:after {\r\n    display: none;\r\n}\r\n\r\n.projectname-vertical-wizard li.current {\r\n    background-color: #f4f4f4;\r\n}\r\n\r\n.projectname-vertical-wizard li.current a:before {\r\n    background-color: #0e61b9;\r\n    opacity: 1;\r\n}\r\n\r\n.projectname-vertical-wizard li.current a:after {\r\n    border-color: #0e61b9;\r\n    background-color: #0e61b9;\r\n    opacity: 1;\r\n}\r\n\r\n.projectname-vertical-wizard li.current:before,\r\n.projectname-vertical-wizard li.current:after {\r\n    left: 100%;\r\n    top: 50%;\r\n    border: solid transparent;\r\n    content: \" \";\r\n    height: 0;\r\n    width: 0;\r\n    position: absolute;\r\n    pointer-events: none;\r\n}\r\n\r\n.projectname-vertical-wizard li:last-child>a:before {\r\n    display: none;\r\n}\r\n\r\n.projectname-vertical-wizard a {\r\n    display: block;\r\n    padding: 10px 10px 20px 40px;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    letter-spacing: 0.35px;\r\n    color: #1A1919;\r\n}\r\n\r\n.projectname-vertical-wizard a::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    width: 1px;\r\n    height: calc(100% - 25px);\r\n    background-color: #aaacb1;\r\n    left: 13px;\r\n    bottom: -9px;\r\n    z-index: 3;\r\n}\r\n\r\n.projectname-vertical-wizard a::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    border: 2px solid #aaacb1;\r\n    border-radius: 50%;\r\n    top: 14px;\r\n    left: 6px;\r\n    width: 16px;\r\n    height: 16px;\r\n    z-index: 3;\r\n}\r\n\r\n.projectname-vertical-wizard a:hover,\r\n.projectname-vertical-wizard a:focus {\r\n    text-decoration: none;\r\n}\r\n\r\n.projectname-vertical-wizard .ico {\r\n    pointer-events: none;\r\n    font-size: 14px;\r\n    position: absolute;\r\n    left: 10px;\r\n    top: 15px;\r\n    z-index: 2;\r\n}\r\n\r\n.projectname-vertical-wizard .ico.ico-green {\r\n    color: #90be6d;\r\n}\r\n\r\n.projectname-vertical-wizard .ico.ico-muted {\r\n    color: #aaacb1;\r\n}\r\n\r\n.projectname-vertical-wizard .desc {\r\n    display: block;\r\n    line-height: 1.8;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    letter-spacing: 0px;\r\n    color: #aaacb1;\r\n}\r\n\r\n.projectname-vertical-wizard ul>li.current:after {\r\n    border-color: rgba(0, 0, 0, 0);\r\n    border-left-color: #f4f4f4;\r\n    border-width: 10px;\r\n    margin-top: -10px;\r\n}\r\n\r\n.projectname-vertical-wizard ul>li.current:before {\r\n    border-color: rgba(14, 97, 185, 0);\r\n    border-left-color: #DFE0E2;\r\n    border-width: 11px;\r\n    margin-top: -11px;\r\n}\r\n\r\nlabel.slds-form-element__label {\r\n    font-family: Muli;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.projectname-container .slds-tabs_scoped__content {\r\n    padding: 0rem;\r\n}\r\n\r\n.projectname-container .slds-tabs_scoped__nav {\r\n    border: 0px;\r\n    border-radius: 0px 6px 0px 0px;\r\n    background-color: #e8e8e8;\r\n}\r\n\r\n.projectname-container .slds-tabs_scoped__content {\r\n    border: 0px;\r\n    border-radius: 0px 0px 6px 6px;\r\n}\r\n\r\n.projectname-container .slds-is-active {\r\n    border-top: 3px solid #1A1919;\r\n}\r\n\r\n.projectname-container .slds-is-active .slds-tabs_scoped__link {\r\n    border: 0px;\r\n}\r\n\r\n.projectname-container .slds-tabs_scoped__link {\r\n    padding: 0 2rem;\r\n}\r\n\r\n.form-label.sm {\r\n    font-size: 0.875rem;\r\n    margin-bottom: 0.3rem;\r\n}\r\n\r\n.block-panel {\r\n    display: flex;\r\n    justify-items: center;\r\n    flex-direction: column;\r\n    text-align: center;\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: black;\r\n    z-index: 1600;\r\n    opacity: 0.5;\r\n}\r\n\r\n.z-10 {\r\n    z-index: 10;\r\n}\r\n\r\n\r\n\r\n.block-panel p {\r\n    justify-content: center;\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    height: 100%;\r\n    color: white;\r\n}\r\n\r\n.block-panel-p {\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n    text-align: center;\r\n    /* opacity: 1; */\r\n    z-index: 1700;\r\n    position: absolute;\r\n    color: white;\r\n}\r\n\r\n/*****************************************\r\n  upload button styles\r\n******************************************/\r\n.file-upload {\r\n    position: relative;\r\n    display: inline-block;\r\n}\r\n\r\n.file-upload__label {\r\n    color: #fff;\r\n    border-radius: .4em;\r\n    transition: background .3s;\r\n\r\n    &:hover {\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n.file-upload__input {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    font-size: 1;\r\n    width: 0;\r\n    height: 100%;\r\n    opacity: 0;\r\n}\r\n\r\n.bg-image {\r\n    padding-top: 50%;\r\n    width: 100%;\r\n    cursor: pointer;\r\n    background-position: 50%;\r\n}\r\n\r\n.bg-image-cover {\r\n    text-decoration: none;\r\n    color: rgba(0, 0, 0, .87);\r\n    display: block;\r\n    background-position: 50%;\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    transition: all .2s cubic-bezier(.4, 0, .2, 1);\r\n}\r\n\r\n.bg-image:hover {\r\n    transform: scale(1.2);\r\n    // box-shadow: 5px 4px 5px 0px rgba(0, 0, 0, 0.75);\r\n    // -webkit-box-shadow: 5px 4px 5px 0px rgba(0, 0, 0, 0.75);\r\n    // -moz-box-shadow: 5px 4px 5px 0px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.foto_avatar {\r\n    padding-top: 140% !important;\r\n}\r\n\r\n.react-datepicker__input-container input {\r\n    width: 100%;\r\n}\r\n\r\n.footer {\r\n    overflow: hidden;\r\n    margin-top: 5mm;\r\n    // border-radius: 7px;\r\n    width: 100%;\r\n    background: #303c54;\r\n    color: white;\r\n    text-align: center;\r\n    font-weight: bold;\r\n    text-transform: uppercase;\r\n    border-left: 1px solid;\r\n}\r\n\r\n// .header-search-wrapper .ant-input {\r\n//   width: 100%;\r\n//    flex: 1;\r\n//   min-width: 0; // WAJIB untuk flex overflow fix\r\n// }\r\n\r\n// .example-content-main {\r\n//   width: clamp(280px, 92vw, 500px);\r\n//   margin: 0 auto;\r\n//   box-sizing: border-box;\r\n// }\r\n\r\n.header-search-wrapper {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.example-content-main {\r\n  width: 100%;\r\n  z-index: 200;\r\n}\r\n/* Desktop */\r\n@media (min-width: 992px) {\r\n  .example-content-main {\r\n    width: 500px;   // lebih panjang dari sebelumnya\r\n  }\r\n}\r\n\r\n.main-filter-table {\r\n\r\n    // width: 20rem;\r\n    flex-wrap: nowrap;\r\n\r\n    @include media-breakpoint-up(sm) {\r\n        // @include make-col(9);\r\n        width: 200px;\r\n    }\r\n\r\n    @include media-breakpoint-up(lg) {\r\n        width: 500px;\r\n    }\r\n\r\n\r\n}\r\n\r\n.main-search-button {\r\n\r\n    display: flex;\r\n\r\n    @include media-breakpoint-up(sm) {\r\n        // @include make-col(9);\r\n        display: none;\r\n    }\r\n\r\n    @include media-breakpoint-up(lg) {\r\n        display: none;\r\n    }\r\n\r\n\r\n}\r\n\r\n.ant-form-item {\r\n  margin-bottom: 8px !important;\r\n}\r\n\r\n\r\n\r\n// for image smoth\r\n.smooth-image {\r\n    transition: opacity 1s;\r\n}\r\n\r\n.image-visible {\r\n    opacity: 1;\r\n}\r\n\r\n.image-hidden {\r\n    opacity: 0;\r\n}\r\n\r\n.smooth-no-image {\r\n    background-image: linear-gradient(90deg, #ccc, #999, #ccc);\r\n    color: #fff;\r\n}\r\n\r\nimg[alt=\"img-logo\"] {\r\n    // border: 4px solid white;\r\n    border-radius: 10px;\r\n}\r\n\r\n.label-primary {\r\n    background-color: $primary;\r\n    color: #fff;\r\n}\r\n\r\n.label-danger {\r\n    background-color: $danger;\r\n        color: #fff;\r\n}\r\n\r\n.label-warning {\r\n    background-color: $warning;\r\n        color: #fff;\r\n}\r\n\r\n.label-info {\r\n    background-color: $info;\r\n        color: #fff;\r\n}\r\n\r\n.label-light {\r\n    background-color: $light;\r\n        color: #fff;\r\n}\r\n\r\n.label-success {\r\n    background-color: $success;\r\n        color: #fff;\r\n}\r\n\r\n.label {\r\n    display: inline;\r\n    padding: 0.2em 0.6em 0.3em;\r\n    font-weight: bold;\r\n    line-height: 1;\r\n    color: #fff;\r\n    text-align: center;\r\n    white-space: nowrap;\r\n    vertical-align: baseline;\r\n    border-radius: 0.25em;\r\n}\r\n\r\n.form-check-input:checked {\r\n    border-color: #c3ddd1;\r\n}\r\n\r\n.sidebar {\r\n    // background-color: #274546;\r\n    background-color: $primary-sidebar;\r\n    background:linear-gradient(180deg, #134E4A 0%,#115E59 50%,#0F766E 100%);\r\n}\r\n\r\n.ui.horizontal.divider {\r\n    display: table;\r\n    white-space: nowrap;\r\n    height: auto;\r\n    margin: '';\r\n    line-height: 1;\r\n    text-align: center;\r\n}\r\n\r\nh4.ui.headers {\r\n    font-size: 1.07142857rem;\r\n}\r\n\r\n.ui.headers {\r\n    border: none;\r\n    margin: calc(2rem - 0.14285714em) 0 1rem;\r\n    padding: 0 0;\r\n    font-family: Lato, 'Helvetica Neue', Arial, Helvetica, sans-serif;\r\n    font-weight: 700;\r\n    line-height: 1.28571429em;\r\n    text-transform: none;\r\n    color: rgba(0, 0, 0, .87);\r\n}\r\n\r\n.ui.horizontal.divider:after,\r\n.ui.horizontal.divider:before {\r\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAACCAYAAACuTHuKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1OThBRDY4OUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1OThBRDY4QUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU5OEFENjg3Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU5OEFENjg4Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VU513gAAADVJREFUeNrs0DENACAQBDBIWLGBJQby/mUcJn5sJXQmOQMAAAAAAJqt+2prAAAAAACg2xdgANk6BEVuJgyMAAAAAElFTkSuQmCC);\r\n}\r\n\r\n.ui.horizontal.divider:before {\r\n    background-position: right 1em top 50%;\r\n}\r\n\r\n.ui.horizontal.divider:after,\r\n.ui.horizontal.divider:before {\r\n    content: '';\r\n    display: table-cell;\r\n    position: relative;\r\n    top: 50%;\r\n    width: 50%;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.ui.header .icon:only-child {\r\n    display: inline-block;\r\n    padding: 0;\r\n    margin-right: 0.75rem;\r\n}\r\n\r\n.ui.header>.icon {\r\n    display: table-cell;\r\n    opacity: 1;\r\n    font-size: 1.5em;\r\n    padding-top: 0;\r\n    vertical-align: middle;\r\n}\r\n\r\n.ui.divider>.icon {\r\n    margin: 0;\r\n    font-size: 1rem;\r\n    height: 1em;\r\n    vertical-align: middle;\r\n}\r\n\r\ni.icon,\r\ni.icons {\r\n    font-size: 1em;\r\n}\r\n\r\ni.icon {\r\n    display: inline-block;\r\n    opacity: 1;\r\n    margin: 0 0.25rem 0 0;\r\n    width: 1.18em;\r\n    height: 1em;\r\n    font-family: Icons;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    text-decoration: inherit;\r\n    text-align: center;\r\n    // speak: none;\r\n    // font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    -webkit-font-smoothing: antialiased;\r\n    -webkit-backface-visibility: hidden;\r\n    backface-visibility: hidden;\r\n}\r\n\r\n.rdt_Table {\r\n    padding: 10px;\r\n}\r\n\r\n/*****************************************\r\n design styles\r\n******************************************/\r\n\r\n.page-multiple.A4 {\r\n    width: 270mm;\r\n}\r\n\r\n// .page-multiple.A4 {\r\n//     width: 270mm;\r\n// }\r\n\r\n#print_target .page-multiple.A58.portrait {\r\n    width: 80mm;\r\n    font-size: 8pt !important;\r\n    line-height: 10pt;\r\n}\r\n\r\n.simplebar-init {\r\n    max-height: 36rem;\r\n}\r\n\r\n@include media-breakpoint-up(sm) {\r\n    .simplebar-init {\r\n        max-height: 30rem;\r\n    }\r\n}\r\n\r\n.accordion-body {\r\n    padding: 10px;\r\n}\r\n\r\n\r\n.receipt {\r\n    padding: 10px;\r\n    /* font-family: 'Merchant Copy Doublesize', sans-serif; */\r\n    /* border: 1px solid; */\r\n    /* font-size: 8pt; */\r\n    font-size: 16px;\r\n}\r\n\r\n.receipt img {\r\n    width: 27.9px;\r\n}\r\n\r\n.garis {\r\n    color: black;\r\n    border: 1px dashed black;\r\n    height: 1px;\r\n    margin-top: 5px;\r\n}\r\n\r\n.garis-solid {\r\n    color: black;\r\n    border: 1px solid black;\r\n    height: 2px;\r\n    margin-top: 5px;\r\n}\r\n\r\n.fs-8pt {\r\n    font-size: 12pt;\r\n}\r\n\r\n.receipt hr {\r\n    opacity: unset !important;\r\n}\r\n\r\n.mt-3px {\r\n    margin-top: 3px;\r\n}\r\n\r\n.fs-5pt {\r\n    font-size: 5pt;\r\n}\r\n\r\n.fs-10pt {\r\n    font-size: 12pt;\r\n}\r\n\r\n.fs-12pt {\r\n    font-size: 14pt;\r\n}\r\n\r\n.fs-11pt {\r\n    font-size: 11pt;\r\n}\r\n\r\n.w-14rem {\r\n    width: 7rem;\r\n    vertical-align: top;\r\n}\r\n\r\n.nama {\r\n    overflow: hidden;\r\n    /* max-width: 100px; */\r\n    /* max-height: 15px; */\r\n}\r\n\r\n/* .nama::before {\r\n   content: '..'\r\n  } */\r\n\r\n.float-right {\r\n    float: right;\r\n}\r\n\r\n.text-small {\r\n    font-size: 10px;\r\n    line-height: inherit;\r\n}\r\n\r\n.receipt table tr td {\r\n    vertical-align: top;\r\n}\r\n\r\ntable.invoice-table {\r\n    page-break-after: always;\r\n}\r\n\r\ntable.invoice-table tr td {\r\n    vertical-align: top;\r\n}\r\n\r\n\r\n\r\n.border-invoice {\r\n    border: 1px solid;\r\n}\r\n\r\n@media print {\r\n    .border {\r\n        border: unset !important;\r\n    }\r\n\r\n    .border-invoice {\r\n        border: unset !important;\r\n    }\r\n\r\n    .cm-1 {\r\n        padding: unset !important;\r\n    }\r\n}\r\n\r\n.modal-open {\r\n    overflow: hidden;\r\n}\r\n\r\n.tags {\r\n    align-items: center;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: flex-start;\r\n    margin: 5px;\r\n}\r\n\r\n.tags .tag {\r\n    margin-bottom: 0.1rem\r\n}\r\n\r\n.tags .tag:not(:last-child) {\r\n    margin-right: .5rem\r\n}\r\n\r\n.tags:last-child {\r\n    /* margin-bottom: -.5rem */\r\n}\r\n\r\n.tags:not(:last-child) {\r\n    margin-bottom: 1rem\r\n}\r\n\r\n.tags.are-medium .tag:not(.is-normal):not(.is-large) {\r\n    font-size: 1rem\r\n}\r\n\r\n.tags.are-large .tag:not(.is-normal):not(.is-medium) {\r\n    font-size: 1.25rem\r\n}\r\n\r\n.tags.is-centered {\r\n    justify-content: center\r\n}\r\n\r\n.tags.is-centered .tag {\r\n    margin-right: .25rem;\r\n    margin-left: .25rem\r\n}\r\n\r\n.tags.is-right {\r\n    justify-content: flex-end\r\n}\r\n\r\n.tags.is-right .tag:not(:first-child) {\r\n    margin-left: .5rem\r\n}\r\n\r\n.tags.is-right .tag:not(:last-child) {\r\n    margin-right: 0\r\n}\r\n\r\n.tags.has-addons .tag {\r\n    margin-right: 0\r\n}\r\n\r\n.tags.has-addons .tag:not(:first-child) {\r\n    margin-left: 0;\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0\r\n}\r\n\r\n.tags.has-addons .tag:not(:last-child) {\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0\r\n}\r\n\r\n.tag:not(body) {\r\n    align-items: center;\r\n    background-color: #f5f5f5;\r\n    border-radius: .375em;\r\n    color: #4a4a4a;\r\n    display: inline-flex;\r\n    font-size: .75rem;\r\n    height: 2em;\r\n    justify-content: center;\r\n    line-height: 1.5;\r\n    padding-left: .75em;\r\n    padding-right: .75em;\r\n    white-space: nowrap\r\n}\r\n\r\n.tag:not(body) .delete {\r\n    margin-left: .25rem;\r\n    margin-right: -.375rem\r\n}\r\n\r\n.tag:not(body).is-white {\r\n    background-color: #fff;\r\n    color: #0a0a0a\r\n}\r\n\r\n.tag:not(body).is-black {\r\n    background-color: #0a0a0a;\r\n    color: #fff\r\n}\r\n\r\n.tag:not(body).is-light {\r\n    background-color: #f5f5f5;\r\n    color: rgba(0, 0, 0, .7)\r\n}\r\n\r\n.tag:not(body).is-dark {\r\n    background-color: #363636;\r\n    color: #fff\r\n}\r\n\r\n.tag:not(body).is-primary {\r\n    --cui-bg-opacity: 1;\r\n    background-color: rgba(var(--cui-primary-rgb), var(--cui-bg-opacity)) !important;\r\n    color: #fff\r\n}\r\n.tag:not(body).is-success {\r\n    --cui-bg-opacity: 1;\r\n    background-color: rgba(var(--cui-success-rgb), var(--cui-bg-opacity)) !important;\r\n    color: #fff\r\n}\r\n.tag:not(body).is-warning {\r\n    --cui-bg-opacity: 1;\r\n    background-color: rgba(var(--cui-warning-rgb), var(--cui-bg-opacity)) !important;\r\n    color: #fff\r\n}\r\n\r\n.tag:not(body).is-danger {\r\n    --cui-bg-opacity: 1;\r\n    background-color: rgba(var(--cui-danger-rgb), var(--cui-bg-opacity)) !important;\r\n    color: #fff\r\n}\r\n\r\n.nav-link.active {\r\n    background-color: var(--cui-btn-bg, transparent);\r\n}\r\n\r\n@include media-breakpoint-down(md) {\r\n    .is-sm {\r\n        display: grid;\r\n    }\r\n}\r\n\r\n.sticky {\r\n    position: sticky !important;\r\n    position: -webkit-sticky !important;\r\n    z-index: 2;\r\n    top: -1px;\r\n    background-color: whitesmoke;\r\n}\r\n\r\n\r\n.stick {\r\n    display: flex;\r\n    align-items: center;\r\n    background-color: white;\r\n    border-bottom: 1px solid #eee;\r\n    box-sizing: border-box;\r\n}\r\n\r\n@media only screen and (max-width: 576px) {\r\n    .rc-pagination-options {\r\n        display: block !important;\r\n    }\r\n}\r\n\r\n.border-left-primary {\r\n    border-left: .25rem solid rgba(var(--cui-primary-rgb), 1) !important; \r\n}\r\n.border-left-success {\r\n    border-left: .25rem solid rgba(var(--cui-success-rgb), 1) !important; \r\n}\r\n.border-left-info {\r\n    border-left: .25rem solid rgba(var(--cui-info-rgb), 1) !important; \r\n}\r\n.border-left-warning {\r\n    border-left: .25rem solid rgba(var(--cui-warning-rgb), 1) !important; \r\n}\r\n\r\n\r\n.field.is-grouped.is-grouped-multiline:last-child {\r\n    margin-bottom: -0.75rem;\r\n}\r\n\r\n.field.is-grouped.is-grouped-multiline {\r\n    -ms-flex-wrap: wrap;\r\n    flex-wrap: wrap;\r\n}\r\n.field.is-grouped {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: start;\r\n    -ms-flex-pack: start;\r\n    justify-content: flex-start;\r\n}","@charset \"UTF-8\";\r\n\r\n/*!\r\n * animate.css - https://animate.style/\r\n * Version - 4.1.1\r\n * Licensed under the Hippocratic License 2.1 - http://firstdonoharm.dev\r\n *\r\n * Copyright (c) 2022 Animate.css\r\n */\r\n:root {\r\n    --animate-duration: 1s;\r\n    --animate-delay: 1s;\r\n    --animate-repeat: 1;\r\n\r\n}\r\n\r\n.animate__animated {\r\n    -webkit-animation-duration: 1s;\r\n    animation-duration: 1s;\r\n    -webkit-animation-duration: var(--animate-duration);\r\n    animation-duration: var(--animate-duration);\r\n    -webkit-animation-fill-mode: both;\r\n    animation-fill-mode: both;\r\n}\r\n\r\n.animate__animated.animate__infinite {\r\n    -webkit-animation-iteration-count: infinite;\r\n    animation-iteration-count: infinite;\r\n}\r\n\r\n.animate__animated.animate__repeat-1 {\r\n    -webkit-animation-iteration-count: 1;\r\n    animation-iteration-count: 1;\r\n    -webkit-animation-iteration-count: var(--animate-repeat);\r\n    animation-iteration-count: var(--animate-repeat);\r\n}\r\n\r\n.animate__animated.animate__repeat-2 {\r\n    -webkit-animation-iteration-count: calc(1 * 2);\r\n    animation-iteration-count: calc(1 * 2);\r\n    -webkit-animation-iteration-count: calc(var(--animate-repeat) * 2);\r\n    animation-iteration-count: calc(var(--animate-repeat) * 2);\r\n}\r\n\r\n.animate__animated.animate__repeat-3 {\r\n    -webkit-animation-iteration-count: calc(1 * 3);\r\n    animation-iteration-count: calc(1 * 3);\r\n    -webkit-animation-iteration-count: calc(var(--animate-repeat) * 3);\r\n    animation-iteration-count: calc(var(--animate-repeat) * 3);\r\n}\r\n\r\n.animate__animated.animate__delay-1s {\r\n    -webkit-animation-delay: 1s;\r\n    animation-delay: 1s;\r\n    -webkit-animation-delay: var(--animate-delay);\r\n    animation-delay: var(--animate-delay);\r\n}\r\n\r\n.animate__animated.animate__delay-2s {\r\n    -webkit-animation-delay: calc(1s * 2);\r\n    animation-delay: calc(1s * 2);\r\n    -webkit-animation-delay: calc(var(--animate-delay) * 2);\r\n    animation-delay: calc(var(--animate-delay) * 2);\r\n}\r\n\r\n.animate__animated.animate__delay-3s {\r\n    -webkit-animation-delay: calc(1s * 3);\r\n    animation-delay: calc(1s * 3);\r\n    -webkit-animation-delay: calc(var(--animate-delay) * 3);\r\n    animation-delay: calc(var(--animate-delay) * 3);\r\n}\r\n\r\n.animate__animated.animate__delay-4s {\r\n    -webkit-animation-delay: calc(1s * 4);\r\n    animation-delay: calc(1s * 4);\r\n    -webkit-animation-delay: calc(var(--animate-delay) * 4);\r\n    animation-delay: calc(var(--animate-delay) * 4);\r\n}\r\n\r\n.animate__animated.animate__delay-5s {\r\n    -webkit-animation-delay: calc(1s * 5);\r\n    animation-delay: calc(1s * 5);\r\n    -webkit-animation-delay: calc(var(--animate-delay) * 5);\r\n    animation-delay: calc(var(--animate-delay) * 5);\r\n}\r\n\r\n.animate__animated.animate__faster {\r\n    -webkit-animation-duration: calc(1s / 2);\r\n    animation-duration: calc(1s / 2);\r\n    -webkit-animation-duration: calc(var(--animate-duration) / 2);\r\n    animation-duration: calc(var(--animate-duration) / 2);\r\n}\r\n\r\n.animate__animated.animate__fast {\r\n    -webkit-animation-duration: calc(1s * 0.8);\r\n    animation-duration: calc(1s * 0.8);\r\n    -webkit-animation-duration: calc(var(--animate-duration) * 0.8);\r\n    animation-duration: calc(var(--animate-duration) * 0.8);\r\n}\r\n\r\n.animate__animated.animate__slow {\r\n    -webkit-animation-duration: calc(1s * 2);\r\n    animation-duration: calc(1s * 2);\r\n    -webkit-animation-duration: calc(var(--animate-duration) * 2);\r\n    animation-duration: calc(var(--animate-duration) * 2);\r\n}\r\n\r\n.animate__animated.animate__slower {\r\n    -webkit-animation-duration: calc(1s * 3);\r\n    animation-duration: calc(1s * 3);\r\n    -webkit-animation-duration: calc(var(--animate-duration) * 3);\r\n    animation-duration: calc(var(--animate-duration) * 3);\r\n}\r\n\r\n@media print,\r\n(prefers-reduced-motion: reduce) {\r\n    .animate__animated {\r\n        -webkit-animation-duration: 1ms !important;\r\n        animation-duration: 1ms !important;\r\n        -webkit-transition-duration: 1ms !important;\r\n        transition-duration: 1ms !important;\r\n        -webkit-animation-iteration-count: 1 !important;\r\n        animation-iteration-count: 1 !important;\r\n    }\r\n\r\n    .animate__animated[class*='Out'] {\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n/* Attention seekers  */\r\n@-webkit-keyframes bounce {\r\n\r\n    from,\r\n    20%,\r\n    53%,\r\n    to {\r\n        -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    40%,\r\n    43% {\r\n        -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\r\n        animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\r\n        -webkit-transform: translate3d(0, -30px, 0) scaleY(1.1);\r\n        transform: translate3d(0, -30px, 0) scaleY(1.1);\r\n    }\r\n\r\n    70% {\r\n        -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\r\n        animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\r\n        -webkit-transform: translate3d(0, -15px, 0) scaleY(1.05);\r\n        transform: translate3d(0, -15px, 0) scaleY(1.05);\r\n    }\r\n\r\n    80% {\r\n        -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n        transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n        -webkit-transform: translate3d(0, 0, 0) scaleY(0.95);\r\n        transform: translate3d(0, 0, 0) scaleY(0.95);\r\n    }\r\n\r\n    90% {\r\n        -webkit-transform: translate3d(0, -4px, 0) scaleY(1.02);\r\n        transform: translate3d(0, -4px, 0) scaleY(1.02);\r\n    }\r\n}\r\n\r\n@keyframes bounce {\r\n\r\n    from,\r\n    20%,\r\n    53%,\r\n    to {\r\n        -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    40%,\r\n    43% {\r\n        -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\r\n        animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\r\n        -webkit-transform: translate3d(0, -30px, 0) scaleY(1.1);\r\n        transform: translate3d(0, -30px, 0) scaleY(1.1);\r\n    }\r\n\r\n    70% {\r\n        -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\r\n        animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\r\n        -webkit-transform: translate3d(0, -15px, 0) scaleY(1.05);\r\n        transform: translate3d(0, -15px, 0) scaleY(1.05);\r\n    }\r\n\r\n    80% {\r\n        -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n        transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n        -webkit-transform: translate3d(0, 0, 0) scaleY(0.95);\r\n        transform: translate3d(0, 0, 0) scaleY(0.95);\r\n    }\r\n\r\n    90% {\r\n        -webkit-transform: translate3d(0, -4px, 0) scaleY(1.02);\r\n        transform: translate3d(0, -4px, 0) scaleY(1.02);\r\n    }\r\n}\r\n\r\n.animate__bounce {\r\n    -webkit-animation-name: bounce;\r\n    animation-name: bounce;\r\n    -webkit-transform-origin: center bottom;\r\n    transform-origin: center bottom;\r\n}\r\n\r\n@-webkit-keyframes flash {\r\n\r\n    from,\r\n    50%,\r\n    to {\r\n        opacity: 1;\r\n    }\r\n\r\n    25%,\r\n    75% {\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes flash {\r\n\r\n    from,\r\n    50%,\r\n    to {\r\n        opacity: 1;\r\n    }\r\n\r\n    25%,\r\n    75% {\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.animate__flash {\r\n    -webkit-animation-name: flash;\r\n    animation-name: flash;\r\n}\r\n\r\n/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */\r\n@-webkit-keyframes pulse {\r\n    from {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n        transform: scale3d(1, 1, 1);\r\n    }\r\n\r\n    50% {\r\n        -webkit-transform: scale3d(1.05, 1.05, 1.05);\r\n        transform: scale3d(1.05, 1.05, 1.05);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n        transform: scale3d(1, 1, 1);\r\n    }\r\n}\r\n\r\n@keyframes pulse {\r\n    from {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n        transform: scale3d(1, 1, 1);\r\n    }\r\n\r\n    50% {\r\n        -webkit-transform: scale3d(1.05, 1.05, 1.05);\r\n        transform: scale3d(1.05, 1.05, 1.05);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n        transform: scale3d(1, 1, 1);\r\n    }\r\n}\r\n\r\n.animate__pulse {\r\n    -webkit-animation-name: pulse;\r\n    animation-name: pulse;\r\n    -webkit-animation-timing-function: ease-in-out;\r\n    animation-timing-function: ease-in-out;\r\n}\r\n\r\n@-webkit-keyframes rubberBand {\r\n    from {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n        transform: scale3d(1, 1, 1);\r\n    }\r\n\r\n    30% {\r\n        -webkit-transform: scale3d(1.25, 0.75, 1);\r\n        transform: scale3d(1.25, 0.75, 1);\r\n    }\r\n\r\n    40% {\r\n        -webkit-transform: scale3d(0.75, 1.25, 1);\r\n        transform: scale3d(0.75, 1.25, 1);\r\n    }\r\n\r\n    50% {\r\n        -webkit-transform: scale3d(1.15, 0.85, 1);\r\n        transform: scale3d(1.15, 0.85, 1);\r\n    }\r\n\r\n    65% {\r\n        -webkit-transform: scale3d(0.95, 1.05, 1);\r\n        transform: scale3d(0.95, 1.05, 1);\r\n    }\r\n\r\n    75% {\r\n        -webkit-transform: scale3d(1.05, 0.95, 1);\r\n        transform: scale3d(1.05, 0.95, 1);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n        transform: scale3d(1, 1, 1);\r\n    }\r\n}\r\n\r\n@keyframes rubberBand {\r\n    from {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n        transform: scale3d(1, 1, 1);\r\n    }\r\n\r\n    30% {\r\n        -webkit-transform: scale3d(1.25, 0.75, 1);\r\n        transform: scale3d(1.25, 0.75, 1);\r\n    }\r\n\r\n    40% {\r\n        -webkit-transform: scale3d(0.75, 1.25, 1);\r\n        transform: scale3d(0.75, 1.25, 1);\r\n    }\r\n\r\n    50% {\r\n        -webkit-transform: scale3d(1.15, 0.85, 1);\r\n        transform: scale3d(1.15, 0.85, 1);\r\n    }\r\n\r\n    65% {\r\n        -webkit-transform: scale3d(0.95, 1.05, 1);\r\n        transform: scale3d(0.95, 1.05, 1);\r\n    }\r\n\r\n    75% {\r\n        -webkit-transform: scale3d(1.05, 0.95, 1);\r\n        transform: scale3d(1.05, 0.95, 1);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n        transform: scale3d(1, 1, 1);\r\n    }\r\n}\r\n\r\n.animate__rubberBand {\r\n    -webkit-animation-name: rubberBand;\r\n    animation-name: rubberBand;\r\n}\r\n\r\n@-webkit-keyframes shakeX {\r\n\r\n    from,\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    10%,\r\n    30%,\r\n    50%,\r\n    70%,\r\n    90% {\r\n        -webkit-transform: translate3d(-10px, 0, 0);\r\n        transform: translate3d(-10px, 0, 0);\r\n    }\r\n\r\n    20%,\r\n    40%,\r\n    60%,\r\n    80% {\r\n        -webkit-transform: translate3d(10px, 0, 0);\r\n        transform: translate3d(10px, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes shakeX {\r\n\r\n    from,\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    10%,\r\n    30%,\r\n    50%,\r\n    70%,\r\n    90% {\r\n        -webkit-transform: translate3d(-10px, 0, 0);\r\n        transform: translate3d(-10px, 0, 0);\r\n    }\r\n\r\n    20%,\r\n    40%,\r\n    60%,\r\n    80% {\r\n        -webkit-transform: translate3d(10px, 0, 0);\r\n        transform: translate3d(10px, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__shakeX {\r\n    -webkit-animation-name: shakeX;\r\n    animation-name: shakeX;\r\n}\r\n\r\n@-webkit-keyframes shakeY {\r\n\r\n    from,\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    10%,\r\n    30%,\r\n    50%,\r\n    70%,\r\n    90% {\r\n        -webkit-transform: translate3d(0, -10px, 0);\r\n        transform: translate3d(0, -10px, 0);\r\n    }\r\n\r\n    20%,\r\n    40%,\r\n    60%,\r\n    80% {\r\n        -webkit-transform: translate3d(0, 10px, 0);\r\n        transform: translate3d(0, 10px, 0);\r\n    }\r\n}\r\n\r\n@keyframes shakeY {\r\n\r\n    from,\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    10%,\r\n    30%,\r\n    50%,\r\n    70%,\r\n    90% {\r\n        -webkit-transform: translate3d(0, -10px, 0);\r\n        transform: translate3d(0, -10px, 0);\r\n    }\r\n\r\n    20%,\r\n    40%,\r\n    60%,\r\n    80% {\r\n        -webkit-transform: translate3d(0, 10px, 0);\r\n        transform: translate3d(0, 10px, 0);\r\n    }\r\n}\r\n\r\n.animate__shakeY {\r\n    -webkit-animation-name: shakeY;\r\n    animation-name: shakeY;\r\n}\r\n\r\n@-webkit-keyframes headShake {\r\n    0% {\r\n        -webkit-transform: translateX(0);\r\n        transform: translateX(0);\r\n    }\r\n\r\n    6.5% {\r\n        -webkit-transform: translateX(-6px) rotateY(-9deg);\r\n        transform: translateX(-6px) rotateY(-9deg);\r\n    }\r\n\r\n    18.5% {\r\n        -webkit-transform: translateX(5px) rotateY(7deg);\r\n        transform: translateX(5px) rotateY(7deg);\r\n    }\r\n\r\n    31.5% {\r\n        -webkit-transform: translateX(-3px) rotateY(-5deg);\r\n        transform: translateX(-3px) rotateY(-5deg);\r\n    }\r\n\r\n    43.5% {\r\n        -webkit-transform: translateX(2px) rotateY(3deg);\r\n        transform: translateX(2px) rotateY(3deg);\r\n    }\r\n\r\n    50% {\r\n        -webkit-transform: translateX(0);\r\n        transform: translateX(0);\r\n    }\r\n}\r\n\r\n@keyframes headShake {\r\n    0% {\r\n        -webkit-transform: translateX(0);\r\n        transform: translateX(0);\r\n    }\r\n\r\n    6.5% {\r\n        -webkit-transform: translateX(-6px) rotateY(-9deg);\r\n        transform: translateX(-6px) rotateY(-9deg);\r\n    }\r\n\r\n    18.5% {\r\n        -webkit-transform: translateX(5px) rotateY(7deg);\r\n        transform: translateX(5px) rotateY(7deg);\r\n    }\r\n\r\n    31.5% {\r\n        -webkit-transform: translateX(-3px) rotateY(-5deg);\r\n        transform: translateX(-3px) rotateY(-5deg);\r\n    }\r\n\r\n    43.5% {\r\n        -webkit-transform: translateX(2px) rotateY(3deg);\r\n        transform: translateX(2px) rotateY(3deg);\r\n    }\r\n\r\n    50% {\r\n        -webkit-transform: translateX(0);\r\n        transform: translateX(0);\r\n    }\r\n}\r\n\r\n.animate__headShake {\r\n    -webkit-animation-timing-function: ease-in-out;\r\n    animation-timing-function: ease-in-out;\r\n    -webkit-animation-name: headShake;\r\n    animation-name: headShake;\r\n}\r\n\r\n@-webkit-keyframes swing {\r\n    20% {\r\n        -webkit-transform: rotate3d(0, 0, 1, 15deg);\r\n        transform: rotate3d(0, 0, 1, 15deg);\r\n    }\r\n\r\n    40% {\r\n        -webkit-transform: rotate3d(0, 0, 1, -10deg);\r\n        transform: rotate3d(0, 0, 1, -10deg);\r\n    }\r\n\r\n    60% {\r\n        -webkit-transform: rotate3d(0, 0, 1, 5deg);\r\n        transform: rotate3d(0, 0, 1, 5deg);\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: rotate3d(0, 0, 1, -5deg);\r\n        transform: rotate3d(0, 0, 1, -5deg);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: rotate3d(0, 0, 1, 0deg);\r\n        transform: rotate3d(0, 0, 1, 0deg);\r\n    }\r\n}\r\n\r\n@keyframes swing {\r\n    20% {\r\n        -webkit-transform: rotate3d(0, 0, 1, 15deg);\r\n        transform: rotate3d(0, 0, 1, 15deg);\r\n    }\r\n\r\n    40% {\r\n        -webkit-transform: rotate3d(0, 0, 1, -10deg);\r\n        transform: rotate3d(0, 0, 1, -10deg);\r\n    }\r\n\r\n    60% {\r\n        -webkit-transform: rotate3d(0, 0, 1, 5deg);\r\n        transform: rotate3d(0, 0, 1, 5deg);\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: rotate3d(0, 0, 1, -5deg);\r\n        transform: rotate3d(0, 0, 1, -5deg);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: rotate3d(0, 0, 1, 0deg);\r\n        transform: rotate3d(0, 0, 1, 0deg);\r\n    }\r\n}\r\n\r\n.animate__swing {\r\n    -webkit-transform-origin: top center;\r\n    transform-origin: top center;\r\n    -webkit-animation-name: swing;\r\n    animation-name: swing;\r\n}\r\n\r\n@-webkit-keyframes tada {\r\n    from {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n        transform: scale3d(1, 1, 1);\r\n    }\r\n\r\n    10%,\r\n    20% {\r\n        -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);\r\n        transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);\r\n    }\r\n\r\n    30%,\r\n    50%,\r\n    70%,\r\n    90% {\r\n        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\r\n        transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\r\n    }\r\n\r\n    40%,\r\n    60%,\r\n    80% {\r\n        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\r\n        transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n        transform: scale3d(1, 1, 1);\r\n    }\r\n}\r\n\r\n@keyframes tada {\r\n    from {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n        transform: scale3d(1, 1, 1);\r\n    }\r\n\r\n    10%,\r\n    20% {\r\n        -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);\r\n        transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);\r\n    }\r\n\r\n    30%,\r\n    50%,\r\n    70%,\r\n    90% {\r\n        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\r\n        transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\r\n    }\r\n\r\n    40%,\r\n    60%,\r\n    80% {\r\n        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\r\n        transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n        transform: scale3d(1, 1, 1);\r\n    }\r\n}\r\n\r\n.animate__tada {\r\n    -webkit-animation-name: tada;\r\n    animation-name: tada;\r\n}\r\n\r\n/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */\r\n@-webkit-keyframes wobble {\r\n    from {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    15% {\r\n        -webkit-transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\r\n        transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\r\n    }\r\n\r\n    30% {\r\n        -webkit-transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\r\n        transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\r\n    }\r\n\r\n    45% {\r\n        -webkit-transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\r\n        transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\r\n    }\r\n\r\n    60% {\r\n        -webkit-transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\r\n        transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\r\n    }\r\n\r\n    75% {\r\n        -webkit-transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\r\n        transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes wobble {\r\n    from {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    15% {\r\n        -webkit-transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\r\n        transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\r\n    }\r\n\r\n    30% {\r\n        -webkit-transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\r\n        transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\r\n    }\r\n\r\n    45% {\r\n        -webkit-transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\r\n        transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\r\n    }\r\n\r\n    60% {\r\n        -webkit-transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\r\n        transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\r\n    }\r\n\r\n    75% {\r\n        -webkit-transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\r\n        transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__wobble {\r\n    -webkit-animation-name: wobble;\r\n    animation-name: wobble;\r\n}\r\n\r\n@-webkit-keyframes jello {\r\n\r\n    from,\r\n    11.1%,\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    22.2% {\r\n        -webkit-transform: skewX(-12.5deg) skewY(-12.5deg);\r\n        transform: skewX(-12.5deg) skewY(-12.5deg);\r\n    }\r\n\r\n    33.3% {\r\n        -webkit-transform: skewX(6.25deg) skewY(6.25deg);\r\n        transform: skewX(6.25deg) skewY(6.25deg);\r\n    }\r\n\r\n    44.4% {\r\n        -webkit-transform: skewX(-3.125deg) skewY(-3.125deg);\r\n        transform: skewX(-3.125deg) skewY(-3.125deg);\r\n    }\r\n\r\n    55.5% {\r\n        -webkit-transform: skewX(1.5625deg) skewY(1.5625deg);\r\n        transform: skewX(1.5625deg) skewY(1.5625deg);\r\n    }\r\n\r\n    66.6% {\r\n        -webkit-transform: skewX(-0.78125deg) skewY(-0.78125deg);\r\n        transform: skewX(-0.78125deg) skewY(-0.78125deg);\r\n    }\r\n\r\n    77.7% {\r\n        -webkit-transform: skewX(0.390625deg) skewY(0.390625deg);\r\n        transform: skewX(0.390625deg) skewY(0.390625deg);\r\n    }\r\n\r\n    88.8% {\r\n        -webkit-transform: skewX(-0.1953125deg) skewY(-0.1953125deg);\r\n        transform: skewX(-0.1953125deg) skewY(-0.1953125deg);\r\n    }\r\n}\r\n\r\n@keyframes jello {\r\n\r\n    from,\r\n    11.1%,\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    22.2% {\r\n        -webkit-transform: skewX(-12.5deg) skewY(-12.5deg);\r\n        transform: skewX(-12.5deg) skewY(-12.5deg);\r\n    }\r\n\r\n    33.3% {\r\n        -webkit-transform: skewX(6.25deg) skewY(6.25deg);\r\n        transform: skewX(6.25deg) skewY(6.25deg);\r\n    }\r\n\r\n    44.4% {\r\n        -webkit-transform: skewX(-3.125deg) skewY(-3.125deg);\r\n        transform: skewX(-3.125deg) skewY(-3.125deg);\r\n    }\r\n\r\n    55.5% {\r\n        -webkit-transform: skewX(1.5625deg) skewY(1.5625deg);\r\n        transform: skewX(1.5625deg) skewY(1.5625deg);\r\n    }\r\n\r\n    66.6% {\r\n        -webkit-transform: skewX(-0.78125deg) skewY(-0.78125deg);\r\n        transform: skewX(-0.78125deg) skewY(-0.78125deg);\r\n    }\r\n\r\n    77.7% {\r\n        -webkit-transform: skewX(0.390625deg) skewY(0.390625deg);\r\n        transform: skewX(0.390625deg) skewY(0.390625deg);\r\n    }\r\n\r\n    88.8% {\r\n        -webkit-transform: skewX(-0.1953125deg) skewY(-0.1953125deg);\r\n        transform: skewX(-0.1953125deg) skewY(-0.1953125deg);\r\n    }\r\n}\r\n\r\n.animate__jello {\r\n    -webkit-animation-name: jello;\r\n    animation-name: jello;\r\n    -webkit-transform-origin: center;\r\n    transform-origin: center;\r\n}\r\n\r\n@-webkit-keyframes heartBeat {\r\n    0% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n    }\r\n\r\n    14% {\r\n        -webkit-transform: scale(1.3);\r\n        transform: scale(1.3);\r\n    }\r\n\r\n    28% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n    }\r\n\r\n    42% {\r\n        -webkit-transform: scale(1.3);\r\n        transform: scale(1.3);\r\n    }\r\n\r\n    70% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n@keyframes heartBeat {\r\n    0% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n    }\r\n\r\n    14% {\r\n        -webkit-transform: scale(1.3);\r\n        transform: scale(1.3);\r\n    }\r\n\r\n    28% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n    }\r\n\r\n    42% {\r\n        -webkit-transform: scale(1.3);\r\n        transform: scale(1.3);\r\n    }\r\n\r\n    70% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n.animate__heartBeat {\r\n    -webkit-animation-name: heartBeat;\r\n    animation-name: heartBeat;\r\n    -webkit-animation-duration: calc(1s * 1.3);\r\n    animation-duration: calc(1s * 1.3);\r\n    -webkit-animation-duration: calc(var(--animate-duration) * 1.3);\r\n    animation-duration: calc(var(--animate-duration) * 1.3);\r\n    -webkit-animation-timing-function: ease-in-out;\r\n    animation-timing-function: ease-in-out;\r\n}\r\n\r\n/* Back entrances */\r\n@-webkit-keyframes backInDown {\r\n    0% {\r\n        -webkit-transform: translateY(-1200px) scale(0.7);\r\n        transform: translateY(-1200px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: translateY(0px) scale(0.7);\r\n        transform: translateY(0px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes backInDown {\r\n    0% {\r\n        -webkit-transform: translateY(-1200px) scale(0.7);\r\n        transform: translateY(-1200px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: translateY(0px) scale(0.7);\r\n        transform: translateY(0px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.animate__backInDown {\r\n    -webkit-animation-name: backInDown;\r\n    animation-name: backInDown;\r\n}\r\n\r\n@-webkit-keyframes backInLeft {\r\n    0% {\r\n        -webkit-transform: translateX(-2000px) scale(0.7);\r\n        transform: translateX(-2000px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: translateX(0px) scale(0.7);\r\n        transform: translateX(0px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes backInLeft {\r\n    0% {\r\n        -webkit-transform: translateX(-2000px) scale(0.7);\r\n        transform: translateX(-2000px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: translateX(0px) scale(0.7);\r\n        transform: translateX(0px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.animate__backInLeft {\r\n    -webkit-animation-name: backInLeft;\r\n    animation-name: backInLeft;\r\n}\r\n\r\n@-webkit-keyframes backInRight {\r\n    0% {\r\n        -webkit-transform: translateX(2000px) scale(0.7);\r\n        transform: translateX(2000px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: translateX(0px) scale(0.7);\r\n        transform: translateX(0px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes backInRight {\r\n    0% {\r\n        -webkit-transform: translateX(2000px) scale(0.7);\r\n        transform: translateX(2000px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: translateX(0px) scale(0.7);\r\n        transform: translateX(0px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.animate__backInRight {\r\n    -webkit-animation-name: backInRight;\r\n    animation-name: backInRight;\r\n}\r\n\r\n@-webkit-keyframes backInUp {\r\n    0% {\r\n        -webkit-transform: translateY(1200px) scale(0.7);\r\n        transform: translateY(1200px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: translateY(0px) scale(0.7);\r\n        transform: translateY(0px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes backInUp {\r\n    0% {\r\n        -webkit-transform: translateY(1200px) scale(0.7);\r\n        transform: translateY(1200px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: translateY(0px) scale(0.7);\r\n        transform: translateY(0px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.animate__backInUp {\r\n    -webkit-animation-name: backInUp;\r\n    animation-name: backInUp;\r\n}\r\n\r\n/* Back exits */\r\n@-webkit-keyframes backOutDown {\r\n    0% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n\r\n    20% {\r\n        -webkit-transform: translateY(0px) scale(0.7);\r\n        transform: translateY(0px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: translateY(700px) scale(0.7);\r\n        transform: translateY(700px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n}\r\n\r\n@keyframes backOutDown {\r\n    0% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n\r\n    20% {\r\n        -webkit-transform: translateY(0px) scale(0.7);\r\n        transform: translateY(0px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: translateY(700px) scale(0.7);\r\n        transform: translateY(700px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n}\r\n\r\n.animate__backOutDown {\r\n    -webkit-animation-name: backOutDown;\r\n    animation-name: backOutDown;\r\n}\r\n\r\n@-webkit-keyframes backOutLeft {\r\n    0% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n\r\n    20% {\r\n        -webkit-transform: translateX(0px) scale(0.7);\r\n        transform: translateX(0px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: translateX(-2000px) scale(0.7);\r\n        transform: translateX(-2000px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n}\r\n\r\n@keyframes backOutLeft {\r\n    0% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n\r\n    20% {\r\n        -webkit-transform: translateX(0px) scale(0.7);\r\n        transform: translateX(0px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: translateX(-2000px) scale(0.7);\r\n        transform: translateX(-2000px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n}\r\n\r\n.animate__backOutLeft {\r\n    -webkit-animation-name: backOutLeft;\r\n    animation-name: backOutLeft;\r\n}\r\n\r\n@-webkit-keyframes backOutRight {\r\n    0% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n\r\n    20% {\r\n        -webkit-transform: translateX(0px) scale(0.7);\r\n        transform: translateX(0px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: translateX(2000px) scale(0.7);\r\n        transform: translateX(2000px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n}\r\n\r\n@keyframes backOutRight {\r\n    0% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n\r\n    20% {\r\n        -webkit-transform: translateX(0px) scale(0.7);\r\n        transform: translateX(0px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: translateX(2000px) scale(0.7);\r\n        transform: translateX(2000px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n}\r\n\r\n.animate__backOutRight {\r\n    -webkit-animation-name: backOutRight;\r\n    animation-name: backOutRight;\r\n}\r\n\r\n@-webkit-keyframes backOutUp {\r\n    0% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n\r\n    20% {\r\n        -webkit-transform: translateY(0px) scale(0.7);\r\n        transform: translateY(0px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: translateY(-700px) scale(0.7);\r\n        transform: translateY(-700px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n}\r\n\r\n@keyframes backOutUp {\r\n    0% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n\r\n    20% {\r\n        -webkit-transform: translateY(0px) scale(0.7);\r\n        transform: translateY(0px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: translateY(-700px) scale(0.7);\r\n        transform: translateY(-700px) scale(0.7);\r\n        opacity: 0.7;\r\n    }\r\n}\r\n\r\n.animate__backOutUp {\r\n    -webkit-animation-name: backOutUp;\r\n    animation-name: backOutUp;\r\n}\r\n\r\n/* Bouncing entrances  */\r\n@-webkit-keyframes bounceIn {\r\n\r\n    from,\r\n    20%,\r\n    40%,\r\n    60%,\r\n    80%,\r\n    to {\r\n        -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n    }\r\n\r\n    0% {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.3, 0.3, 0.3);\r\n        transform: scale3d(0.3, 0.3, 0.3);\r\n    }\r\n\r\n    20% {\r\n        -webkit-transform: scale3d(1.1, 1.1, 1.1);\r\n        transform: scale3d(1.1, 1.1, 1.1);\r\n    }\r\n\r\n    40% {\r\n        -webkit-transform: scale3d(0.9, 0.9, 0.9);\r\n        transform: scale3d(0.9, 0.9, 0.9);\r\n    }\r\n\r\n    60% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(1.03, 1.03, 1.03);\r\n        transform: scale3d(1.03, 1.03, 1.03);\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: scale3d(0.97, 0.97, 0.97);\r\n        transform: scale3d(0.97, 0.97, 0.97);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n        transform: scale3d(1, 1, 1);\r\n    }\r\n}\r\n\r\n@keyframes bounceIn {\r\n\r\n    from,\r\n    20%,\r\n    40%,\r\n    60%,\r\n    80%,\r\n    to {\r\n        -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n    }\r\n\r\n    0% {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.3, 0.3, 0.3);\r\n        transform: scale3d(0.3, 0.3, 0.3);\r\n    }\r\n\r\n    20% {\r\n        -webkit-transform: scale3d(1.1, 1.1, 1.1);\r\n        transform: scale3d(1.1, 1.1, 1.1);\r\n    }\r\n\r\n    40% {\r\n        -webkit-transform: scale3d(0.9, 0.9, 0.9);\r\n        transform: scale3d(0.9, 0.9, 0.9);\r\n    }\r\n\r\n    60% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(1.03, 1.03, 1.03);\r\n        transform: scale3d(1.03, 1.03, 1.03);\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: scale3d(0.97, 0.97, 0.97);\r\n        transform: scale3d(0.97, 0.97, 0.97);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n        transform: scale3d(1, 1, 1);\r\n    }\r\n}\r\n\r\n.animate__bounceIn {\r\n    -webkit-animation-duration: calc(1s * 0.75);\r\n    animation-duration: calc(1s * 0.75);\r\n    -webkit-animation-duration: calc(var(--animate-duration) * 0.75);\r\n    animation-duration: calc(var(--animate-duration) * 0.75);\r\n    -webkit-animation-name: bounceIn;\r\n    animation-name: bounceIn;\r\n}\r\n\r\n@-webkit-keyframes bounceInDown {\r\n\r\n    from,\r\n    60%,\r\n    75%,\r\n    90%,\r\n    to {\r\n        -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n    }\r\n\r\n    0% {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, -3000px, 0) scaleY(3);\r\n        transform: translate3d(0, -3000px, 0) scaleY(3);\r\n    }\r\n\r\n    60% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 25px, 0) scaleY(0.9);\r\n        transform: translate3d(0, 25px, 0) scaleY(0.9);\r\n    }\r\n\r\n    75% {\r\n        -webkit-transform: translate3d(0, -10px, 0) scaleY(0.95);\r\n        transform: translate3d(0, -10px, 0) scaleY(0.95);\r\n    }\r\n\r\n    90% {\r\n        -webkit-transform: translate3d(0, 5px, 0) scaleY(0.985);\r\n        transform: translate3d(0, 5px, 0) scaleY(0.985);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes bounceInDown {\r\n\r\n    from,\r\n    60%,\r\n    75%,\r\n    90%,\r\n    to {\r\n        -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n    }\r\n\r\n    0% {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, -3000px, 0) scaleY(3);\r\n        transform: translate3d(0, -3000px, 0) scaleY(3);\r\n    }\r\n\r\n    60% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 25px, 0) scaleY(0.9);\r\n        transform: translate3d(0, 25px, 0) scaleY(0.9);\r\n    }\r\n\r\n    75% {\r\n        -webkit-transform: translate3d(0, -10px, 0) scaleY(0.95);\r\n        transform: translate3d(0, -10px, 0) scaleY(0.95);\r\n    }\r\n\r\n    90% {\r\n        -webkit-transform: translate3d(0, 5px, 0) scaleY(0.985);\r\n        transform: translate3d(0, 5px, 0) scaleY(0.985);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__bounceInDown {\r\n    -webkit-animation-name: bounceInDown;\r\n    animation-name: bounceInDown;\r\n}\r\n\r\n@-webkit-keyframes bounceInLeft {\r\n\r\n    from,\r\n    60%,\r\n    75%,\r\n    90%,\r\n    to {\r\n        -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n    }\r\n\r\n    0% {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-3000px, 0, 0) scaleX(3);\r\n        transform: translate3d(-3000px, 0, 0) scaleX(3);\r\n    }\r\n\r\n    60% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(25px, 0, 0) scaleX(1);\r\n        transform: translate3d(25px, 0, 0) scaleX(1);\r\n    }\r\n\r\n    75% {\r\n        -webkit-transform: translate3d(-10px, 0, 0) scaleX(0.98);\r\n        transform: translate3d(-10px, 0, 0) scaleX(0.98);\r\n    }\r\n\r\n    90% {\r\n        -webkit-transform: translate3d(5px, 0, 0) scaleX(0.995);\r\n        transform: translate3d(5px, 0, 0) scaleX(0.995);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes bounceInLeft {\r\n\r\n    from,\r\n    60%,\r\n    75%,\r\n    90%,\r\n    to {\r\n        -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n    }\r\n\r\n    0% {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-3000px, 0, 0) scaleX(3);\r\n        transform: translate3d(-3000px, 0, 0) scaleX(3);\r\n    }\r\n\r\n    60% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(25px, 0, 0) scaleX(1);\r\n        transform: translate3d(25px, 0, 0) scaleX(1);\r\n    }\r\n\r\n    75% {\r\n        -webkit-transform: translate3d(-10px, 0, 0) scaleX(0.98);\r\n        transform: translate3d(-10px, 0, 0) scaleX(0.98);\r\n    }\r\n\r\n    90% {\r\n        -webkit-transform: translate3d(5px, 0, 0) scaleX(0.995);\r\n        transform: translate3d(5px, 0, 0) scaleX(0.995);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__bounceInLeft {\r\n    -webkit-animation-name: bounceInLeft;\r\n    animation-name: bounceInLeft;\r\n}\r\n\r\n@-webkit-keyframes bounceInRight {\r\n\r\n    from,\r\n    60%,\r\n    75%,\r\n    90%,\r\n    to {\r\n        -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n    }\r\n\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(3000px, 0, 0) scaleX(3);\r\n        transform: translate3d(3000px, 0, 0) scaleX(3);\r\n    }\r\n\r\n    60% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(-25px, 0, 0) scaleX(1);\r\n        transform: translate3d(-25px, 0, 0) scaleX(1);\r\n    }\r\n\r\n    75% {\r\n        -webkit-transform: translate3d(10px, 0, 0) scaleX(0.98);\r\n        transform: translate3d(10px, 0, 0) scaleX(0.98);\r\n    }\r\n\r\n    90% {\r\n        -webkit-transform: translate3d(-5px, 0, 0) scaleX(0.995);\r\n        transform: translate3d(-5px, 0, 0) scaleX(0.995);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes bounceInRight {\r\n\r\n    from,\r\n    60%,\r\n    75%,\r\n    90%,\r\n    to {\r\n        -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n    }\r\n\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(3000px, 0, 0) scaleX(3);\r\n        transform: translate3d(3000px, 0, 0) scaleX(3);\r\n    }\r\n\r\n    60% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(-25px, 0, 0) scaleX(1);\r\n        transform: translate3d(-25px, 0, 0) scaleX(1);\r\n    }\r\n\r\n    75% {\r\n        -webkit-transform: translate3d(10px, 0, 0) scaleX(0.98);\r\n        transform: translate3d(10px, 0, 0) scaleX(0.98);\r\n    }\r\n\r\n    90% {\r\n        -webkit-transform: translate3d(-5px, 0, 0) scaleX(0.995);\r\n        transform: translate3d(-5px, 0, 0) scaleX(0.995);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__bounceInRight {\r\n    -webkit-animation-name: bounceInRight;\r\n    animation-name: bounceInRight;\r\n}\r\n\r\n@-webkit-keyframes bounceInUp {\r\n\r\n    from,\r\n    60%,\r\n    75%,\r\n    90%,\r\n    to {\r\n        -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n    }\r\n\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, 3000px, 0) scaleY(5);\r\n        transform: translate3d(0, 3000px, 0) scaleY(5);\r\n    }\r\n\r\n    60% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, -20px, 0) scaleY(0.9);\r\n        transform: translate3d(0, -20px, 0) scaleY(0.9);\r\n    }\r\n\r\n    75% {\r\n        -webkit-transform: translate3d(0, 10px, 0) scaleY(0.95);\r\n        transform: translate3d(0, 10px, 0) scaleY(0.95);\r\n    }\r\n\r\n    90% {\r\n        -webkit-transform: translate3d(0, -5px, 0) scaleY(0.985);\r\n        transform: translate3d(0, -5px, 0) scaleY(0.985);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes bounceInUp {\r\n\r\n    from,\r\n    60%,\r\n    75%,\r\n    90%,\r\n    to {\r\n        -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n    }\r\n\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, 3000px, 0) scaleY(5);\r\n        transform: translate3d(0, 3000px, 0) scaleY(5);\r\n    }\r\n\r\n    60% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, -20px, 0) scaleY(0.9);\r\n        transform: translate3d(0, -20px, 0) scaleY(0.9);\r\n    }\r\n\r\n    75% {\r\n        -webkit-transform: translate3d(0, 10px, 0) scaleY(0.95);\r\n        transform: translate3d(0, 10px, 0) scaleY(0.95);\r\n    }\r\n\r\n    90% {\r\n        -webkit-transform: translate3d(0, -5px, 0) scaleY(0.985);\r\n        transform: translate3d(0, -5px, 0) scaleY(0.985);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__bounceInUp {\r\n    -webkit-animation-name: bounceInUp;\r\n    animation-name: bounceInUp;\r\n}\r\n\r\n/* Bouncing exits  */\r\n@-webkit-keyframes bounceOut {\r\n    20% {\r\n        -webkit-transform: scale3d(0.9, 0.9, 0.9);\r\n        transform: scale3d(0.9, 0.9, 0.9);\r\n    }\r\n\r\n    50%,\r\n    55% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(1.1, 1.1, 1.1);\r\n        transform: scale3d(1.1, 1.1, 1.1);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.3, 0.3, 0.3);\r\n        transform: scale3d(0.3, 0.3, 0.3);\r\n    }\r\n}\r\n\r\n@keyframes bounceOut {\r\n    20% {\r\n        -webkit-transform: scale3d(0.9, 0.9, 0.9);\r\n        transform: scale3d(0.9, 0.9, 0.9);\r\n    }\r\n\r\n    50%,\r\n    55% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(1.1, 1.1, 1.1);\r\n        transform: scale3d(1.1, 1.1, 1.1);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.3, 0.3, 0.3);\r\n        transform: scale3d(0.3, 0.3, 0.3);\r\n    }\r\n}\r\n\r\n.animate__bounceOut {\r\n    -webkit-animation-duration: calc(1s * 0.75);\r\n    animation-duration: calc(1s * 0.75);\r\n    -webkit-animation-duration: calc(var(--animate-duration) * 0.75);\r\n    animation-duration: calc(var(--animate-duration) * 0.75);\r\n    -webkit-animation-name: bounceOut;\r\n    animation-name: bounceOut;\r\n}\r\n\r\n@-webkit-keyframes bounceOutDown {\r\n    20% {\r\n        -webkit-transform: translate3d(0, 10px, 0) scaleY(0.985);\r\n        transform: translate3d(0, 10px, 0) scaleY(0.985);\r\n    }\r\n\r\n    40%,\r\n    45% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, -20px, 0) scaleY(0.9);\r\n        transform: translate3d(0, -20px, 0) scaleY(0.9);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, 2000px, 0) scaleY(3);\r\n        transform: translate3d(0, 2000px, 0) scaleY(3);\r\n    }\r\n}\r\n\r\n@keyframes bounceOutDown {\r\n    20% {\r\n        -webkit-transform: translate3d(0, 10px, 0) scaleY(0.985);\r\n        transform: translate3d(0, 10px, 0) scaleY(0.985);\r\n    }\r\n\r\n    40%,\r\n    45% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, -20px, 0) scaleY(0.9);\r\n        transform: translate3d(0, -20px, 0) scaleY(0.9);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, 2000px, 0) scaleY(3);\r\n        transform: translate3d(0, 2000px, 0) scaleY(3);\r\n    }\r\n}\r\n\r\n.animate__bounceOutDown {\r\n    -webkit-animation-name: bounceOutDown;\r\n    animation-name: bounceOutDown;\r\n}\r\n\r\n@-webkit-keyframes bounceOutLeft {\r\n    20% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(20px, 0, 0) scaleX(0.9);\r\n        transform: translate3d(20px, 0, 0) scaleX(0.9);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-2000px, 0, 0) scaleX(2);\r\n        transform: translate3d(-2000px, 0, 0) scaleX(2);\r\n    }\r\n}\r\n\r\n@keyframes bounceOutLeft {\r\n    20% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(20px, 0, 0) scaleX(0.9);\r\n        transform: translate3d(20px, 0, 0) scaleX(0.9);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-2000px, 0, 0) scaleX(2);\r\n        transform: translate3d(-2000px, 0, 0) scaleX(2);\r\n    }\r\n}\r\n\r\n.animate__bounceOutLeft {\r\n    -webkit-animation-name: bounceOutLeft;\r\n    animation-name: bounceOutLeft;\r\n}\r\n\r\n@-webkit-keyframes bounceOutRight {\r\n    20% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(-20px, 0, 0) scaleX(0.9);\r\n        transform: translate3d(-20px, 0, 0) scaleX(0.9);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(2000px, 0, 0) scaleX(2);\r\n        transform: translate3d(2000px, 0, 0) scaleX(2);\r\n    }\r\n}\r\n\r\n@keyframes bounceOutRight {\r\n    20% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(-20px, 0, 0) scaleX(0.9);\r\n        transform: translate3d(-20px, 0, 0) scaleX(0.9);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(2000px, 0, 0) scaleX(2);\r\n        transform: translate3d(2000px, 0, 0) scaleX(2);\r\n    }\r\n}\r\n\r\n.animate__bounceOutRight {\r\n    -webkit-animation-name: bounceOutRight;\r\n    animation-name: bounceOutRight;\r\n}\r\n\r\n@-webkit-keyframes bounceOutUp {\r\n    20% {\r\n        -webkit-transform: translate3d(0, -10px, 0) scaleY(0.985);\r\n        transform: translate3d(0, -10px, 0) scaleY(0.985);\r\n    }\r\n\r\n    40%,\r\n    45% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 20px, 0) scaleY(0.9);\r\n        transform: translate3d(0, 20px, 0) scaleY(0.9);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, -2000px, 0) scaleY(3);\r\n        transform: translate3d(0, -2000px, 0) scaleY(3);\r\n    }\r\n}\r\n\r\n@keyframes bounceOutUp {\r\n    20% {\r\n        -webkit-transform: translate3d(0, -10px, 0) scaleY(0.985);\r\n        transform: translate3d(0, -10px, 0) scaleY(0.985);\r\n    }\r\n\r\n    40%,\r\n    45% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 20px, 0) scaleY(0.9);\r\n        transform: translate3d(0, 20px, 0) scaleY(0.9);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, -2000px, 0) scaleY(3);\r\n        transform: translate3d(0, -2000px, 0) scaleY(3);\r\n    }\r\n}\r\n\r\n.animate__bounceOutUp {\r\n    -webkit-animation-name: bounceOutUp;\r\n    animation-name: bounceOutUp;\r\n}\r\n\r\n/* Fading entrances  */\r\n@-webkit-keyframes fadeIn {\r\n    from {\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes fadeIn {\r\n    from {\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.animate__fadeIn {\r\n    -webkit-animation-name: fadeIn;\r\n    animation-name: fadeIn;\r\n}\r\n\r\n@-webkit-keyframes fadeInDown {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, -100%, 0);\r\n        transform: translate3d(0, -100%, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeInDown {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, -100%, 0);\r\n        transform: translate3d(0, -100%, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeInDown {\r\n    -webkit-animation-name: fadeInDown;\r\n    animation-name: fadeInDown;\r\n}\r\n\r\n@-webkit-keyframes fadeInDownBig {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, -2000px, 0);\r\n        transform: translate3d(0, -2000px, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeInDownBig {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, -2000px, 0);\r\n        transform: translate3d(0, -2000px, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeInDownBig {\r\n    -webkit-animation-name: fadeInDownBig;\r\n    animation-name: fadeInDownBig;\r\n}\r\n\r\n@-webkit-keyframes fadeInLeft {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-100%, 0, 0);\r\n        transform: translate3d(-100%, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeInLeft {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-100%, 0, 0);\r\n        transform: translate3d(-100%, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeInLeft {\r\n    -webkit-animation-name: fadeInLeft;\r\n    animation-name: fadeInLeft;\r\n}\r\n\r\n@-webkit-keyframes fadeInLeftBig {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-2000px, 0, 0);\r\n        transform: translate3d(-2000px, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeInLeftBig {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-2000px, 0, 0);\r\n        transform: translate3d(-2000px, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeInLeftBig {\r\n    -webkit-animation-name: fadeInLeftBig;\r\n    animation-name: fadeInLeftBig;\r\n}\r\n\r\n@-webkit-keyframes fadeInRight {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(100%, 0, 0);\r\n        transform: translate3d(100%, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeInRight {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(100%, 0, 0);\r\n        transform: translate3d(100%, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeInRight {\r\n    -webkit-animation-name: fadeInRight;\r\n    animation-name: fadeInRight;\r\n}\r\n\r\n@-webkit-keyframes fadeInRightBig {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(2000px, 0, 0);\r\n        transform: translate3d(2000px, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeInRightBig {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(2000px, 0, 0);\r\n        transform: translate3d(2000px, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeInRightBig {\r\n    -webkit-animation-name: fadeInRightBig;\r\n    animation-name: fadeInRightBig;\r\n}\r\n\r\n@-webkit-keyframes fadeInUp {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, 100%, 0);\r\n        transform: translate3d(0, 100%, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeInUp {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, 100%, 0);\r\n        transform: translate3d(0, 100%, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeInUp {\r\n    -webkit-animation-name: fadeInUp;\r\n    animation-name: fadeInUp;\r\n}\r\n\r\n@-webkit-keyframes fadeInUpBig {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, 2000px, 0);\r\n        transform: translate3d(0, 2000px, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeInUpBig {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, 2000px, 0);\r\n        transform: translate3d(0, 2000px, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeInUpBig {\r\n    -webkit-animation-name: fadeInUpBig;\r\n    animation-name: fadeInUpBig;\r\n}\r\n\r\n@-webkit-keyframes fadeInTopLeft {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-100%, -100%, 0);\r\n        transform: translate3d(-100%, -100%, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeInTopLeft {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-100%, -100%, 0);\r\n        transform: translate3d(-100%, -100%, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeInTopLeft {\r\n    -webkit-animation-name: fadeInTopLeft;\r\n    animation-name: fadeInTopLeft;\r\n}\r\n\r\n@-webkit-keyframes fadeInTopRight {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(100%, -100%, 0);\r\n        transform: translate3d(100%, -100%, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeInTopRight {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(100%, -100%, 0);\r\n        transform: translate3d(100%, -100%, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeInTopRight {\r\n    -webkit-animation-name: fadeInTopRight;\r\n    animation-name: fadeInTopRight;\r\n}\r\n\r\n@-webkit-keyframes fadeInBottomLeft {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-100%, 100%, 0);\r\n        transform: translate3d(-100%, 100%, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeInBottomLeft {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-100%, 100%, 0);\r\n        transform: translate3d(-100%, 100%, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeInBottomLeft {\r\n    -webkit-animation-name: fadeInBottomLeft;\r\n    animation-name: fadeInBottomLeft;\r\n}\r\n\r\n@-webkit-keyframes fadeInBottomRight {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(100%, 100%, 0);\r\n        transform: translate3d(100%, 100%, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeInBottomRight {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(100%, 100%, 0);\r\n        transform: translate3d(100%, 100%, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeInBottomRight {\r\n    -webkit-animation-name: fadeInBottomRight;\r\n    animation-name: fadeInBottomRight;\r\n}\r\n\r\n/* Fading exits */\r\n@-webkit-keyframes fadeOut {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes fadeOut {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.animate__fadeOut {\r\n    -webkit-animation-name: fadeOut;\r\n    animation-name: fadeOut;\r\n}\r\n\r\n@-webkit-keyframes fadeOutDown {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, 100%, 0);\r\n        transform: translate3d(0, 100%, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeOutDown {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, 100%, 0);\r\n        transform: translate3d(0, 100%, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeOutDown {\r\n    -webkit-animation-name: fadeOutDown;\r\n    animation-name: fadeOutDown;\r\n}\r\n\r\n@-webkit-keyframes fadeOutDownBig {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, 2000px, 0);\r\n        transform: translate3d(0, 2000px, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeOutDownBig {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, 2000px, 0);\r\n        transform: translate3d(0, 2000px, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeOutDownBig {\r\n    -webkit-animation-name: fadeOutDownBig;\r\n    animation-name: fadeOutDownBig;\r\n}\r\n\r\n@-webkit-keyframes fadeOutLeft {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-100%, 0, 0);\r\n        transform: translate3d(-100%, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeOutLeft {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-100%, 0, 0);\r\n        transform: translate3d(-100%, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeOutLeft {\r\n    -webkit-animation-name: fadeOutLeft;\r\n    animation-name: fadeOutLeft;\r\n}\r\n\r\n@-webkit-keyframes fadeOutLeftBig {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-2000px, 0, 0);\r\n        transform: translate3d(-2000px, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeOutLeftBig {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-2000px, 0, 0);\r\n        transform: translate3d(-2000px, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeOutLeftBig {\r\n    -webkit-animation-name: fadeOutLeftBig;\r\n    animation-name: fadeOutLeftBig;\r\n}\r\n\r\n@-webkit-keyframes fadeOutRight {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(100%, 0, 0);\r\n        transform: translate3d(100%, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeOutRight {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(100%, 0, 0);\r\n        transform: translate3d(100%, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeOutRight {\r\n    -webkit-animation-name: fadeOutRight;\r\n    animation-name: fadeOutRight;\r\n}\r\n\r\n@-webkit-keyframes fadeOutRightBig {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(2000px, 0, 0);\r\n        transform: translate3d(2000px, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeOutRightBig {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(2000px, 0, 0);\r\n        transform: translate3d(2000px, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeOutRightBig {\r\n    -webkit-animation-name: fadeOutRightBig;\r\n    animation-name: fadeOutRightBig;\r\n}\r\n\r\n@-webkit-keyframes fadeOutUp {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, -100%, 0);\r\n        transform: translate3d(0, -100%, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeOutUp {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, -100%, 0);\r\n        transform: translate3d(0, -100%, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeOutUp {\r\n    -webkit-animation-name: fadeOutUp;\r\n    animation-name: fadeOutUp;\r\n}\r\n\r\n@-webkit-keyframes fadeOutUpBig {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, -2000px, 0);\r\n        transform: translate3d(0, -2000px, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeOutUpBig {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, -2000px, 0);\r\n        transform: translate3d(0, -2000px, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeOutUpBig {\r\n    -webkit-animation-name: fadeOutUpBig;\r\n    animation-name: fadeOutUpBig;\r\n}\r\n\r\n@-webkit-keyframes fadeOutTopLeft {\r\n    from {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-100%, -100%, 0);\r\n        transform: translate3d(-100%, -100%, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeOutTopLeft {\r\n    from {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-100%, -100%, 0);\r\n        transform: translate3d(-100%, -100%, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeOutTopLeft {\r\n    -webkit-animation-name: fadeOutTopLeft;\r\n    animation-name: fadeOutTopLeft;\r\n}\r\n\r\n@-webkit-keyframes fadeOutTopRight {\r\n    from {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(100%, -100%, 0);\r\n        transform: translate3d(100%, -100%, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeOutTopRight {\r\n    from {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(100%, -100%, 0);\r\n        transform: translate3d(100%, -100%, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeOutTopRight {\r\n    -webkit-animation-name: fadeOutTopRight;\r\n    animation-name: fadeOutTopRight;\r\n}\r\n\r\n@-webkit-keyframes fadeOutBottomRight {\r\n    from {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(100%, 100%, 0);\r\n        transform: translate3d(100%, 100%, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeOutBottomRight {\r\n    from {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(100%, 100%, 0);\r\n        transform: translate3d(100%, 100%, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeOutBottomRight {\r\n    -webkit-animation-name: fadeOutBottomRight;\r\n    animation-name: fadeOutBottomRight;\r\n}\r\n\r\n@-webkit-keyframes fadeOutBottomLeft {\r\n    from {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-100%, 100%, 0);\r\n        transform: translate3d(-100%, 100%, 0);\r\n    }\r\n}\r\n\r\n@keyframes fadeOutBottomLeft {\r\n    from {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-100%, 100%, 0);\r\n        transform: translate3d(-100%, 100%, 0);\r\n    }\r\n}\r\n\r\n.animate__fadeOutBottomLeft {\r\n    -webkit-animation-name: fadeOutBottomLeft;\r\n    animation-name: fadeOutBottomLeft;\r\n}\r\n\r\n/* Flippers */\r\n@-webkit-keyframes flip {\r\n    from {\r\n        -webkit-transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, -360deg);\r\n        transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, -360deg);\r\n        -webkit-animation-timing-function: ease-out;\r\n        animation-timing-function: ease-out;\r\n    }\r\n\r\n    40% {\r\n        -webkit-transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\r\n        transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\r\n        -webkit-animation-timing-function: ease-out;\r\n        animation-timing-function: ease-out;\r\n    }\r\n\r\n    50% {\r\n        -webkit-transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\r\n        transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\r\n        -webkit-animation-timing-function: ease-in;\r\n        animation-timing-function: ease-in;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: perspective(400px) scale3d(0.95, 0.95, 0.95) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);\r\n        transform: perspective(400px) scale3d(0.95, 0.95, 0.95) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);\r\n        -webkit-animation-timing-function: ease-in;\r\n        animation-timing-function: ease-in;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);\r\n        transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);\r\n        -webkit-animation-timing-function: ease-in;\r\n        animation-timing-function: ease-in;\r\n    }\r\n}\r\n\r\n@keyframes flip {\r\n    from {\r\n        -webkit-transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, -360deg);\r\n        transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, -360deg);\r\n        -webkit-animation-timing-function: ease-out;\r\n        animation-timing-function: ease-out;\r\n    }\r\n\r\n    40% {\r\n        -webkit-transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\r\n        transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\r\n        -webkit-animation-timing-function: ease-out;\r\n        animation-timing-function: ease-out;\r\n    }\r\n\r\n    50% {\r\n        -webkit-transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\r\n        transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\r\n        -webkit-animation-timing-function: ease-in;\r\n        animation-timing-function: ease-in;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: perspective(400px) scale3d(0.95, 0.95, 0.95) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);\r\n        transform: perspective(400px) scale3d(0.95, 0.95, 0.95) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);\r\n        -webkit-animation-timing-function: ease-in;\r\n        animation-timing-function: ease-in;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);\r\n        transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);\r\n        -webkit-animation-timing-function: ease-in;\r\n        animation-timing-function: ease-in;\r\n    }\r\n}\r\n\r\n.animate__animated.animate__flip {\r\n    -webkit-backface-visibility: visible;\r\n    backface-visibility: visible;\r\n    -webkit-animation-name: flip;\r\n    animation-name: flip;\r\n}\r\n\r\n@-webkit-keyframes flipInX {\r\n    from {\r\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\r\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\r\n        -webkit-animation-timing-function: ease-in;\r\n        animation-timing-function: ease-in;\r\n        opacity: 0;\r\n    }\r\n\r\n    40% {\r\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\r\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\r\n        -webkit-animation-timing-function: ease-in;\r\n        animation-timing-function: ease-in;\r\n    }\r\n\r\n    60% {\r\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\r\n        transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\r\n        opacity: 1;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\r\n        transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: perspective(400px);\r\n        transform: perspective(400px);\r\n    }\r\n}\r\n\r\n@keyframes flipInX {\r\n    from {\r\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\r\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\r\n        -webkit-animation-timing-function: ease-in;\r\n        animation-timing-function: ease-in;\r\n        opacity: 0;\r\n    }\r\n\r\n    40% {\r\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\r\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\r\n        -webkit-animation-timing-function: ease-in;\r\n        animation-timing-function: ease-in;\r\n    }\r\n\r\n    60% {\r\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\r\n        transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\r\n        opacity: 1;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\r\n        transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: perspective(400px);\r\n        transform: perspective(400px);\r\n    }\r\n}\r\n\r\n.animate__flipInX {\r\n    -webkit-backface-visibility: visible !important;\r\n    backface-visibility: visible !important;\r\n    -webkit-animation-name: flipInX;\r\n    animation-name: flipInX;\r\n}\r\n\r\n@-webkit-keyframes flipInY {\r\n    from {\r\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\r\n        transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\r\n        -webkit-animation-timing-function: ease-in;\r\n        animation-timing-function: ease-in;\r\n        opacity: 0;\r\n    }\r\n\r\n    40% {\r\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\r\n        transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\r\n        -webkit-animation-timing-function: ease-in;\r\n        animation-timing-function: ease-in;\r\n    }\r\n\r\n    60% {\r\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\r\n        transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\r\n        opacity: 1;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -5deg);\r\n        transform: perspective(400px) rotate3d(0, 1, 0, -5deg);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: perspective(400px);\r\n        transform: perspective(400px);\r\n    }\r\n}\r\n\r\n@keyframes flipInY {\r\n    from {\r\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\r\n        transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\r\n        -webkit-animation-timing-function: ease-in;\r\n        animation-timing-function: ease-in;\r\n        opacity: 0;\r\n    }\r\n\r\n    40% {\r\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\r\n        transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\r\n        -webkit-animation-timing-function: ease-in;\r\n        animation-timing-function: ease-in;\r\n    }\r\n\r\n    60% {\r\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\r\n        transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\r\n        opacity: 1;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -5deg);\r\n        transform: perspective(400px) rotate3d(0, 1, 0, -5deg);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: perspective(400px);\r\n        transform: perspective(400px);\r\n    }\r\n}\r\n\r\n.animate__flipInY {\r\n    -webkit-backface-visibility: visible !important;\r\n    backface-visibility: visible !important;\r\n    -webkit-animation-name: flipInY;\r\n    animation-name: flipInY;\r\n}\r\n\r\n@-webkit-keyframes flipOutX {\r\n    from {\r\n        -webkit-transform: perspective(400px);\r\n        transform: perspective(400px);\r\n    }\r\n\r\n    30% {\r\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\r\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\r\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes flipOutX {\r\n    from {\r\n        -webkit-transform: perspective(400px);\r\n        transform: perspective(400px);\r\n    }\r\n\r\n    30% {\r\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\r\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\r\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.animate__flipOutX {\r\n    -webkit-animation-duration: calc(1s * 0.75);\r\n    animation-duration: calc(1s * 0.75);\r\n    -webkit-animation-duration: calc(var(--animate-duration) * 0.75);\r\n    animation-duration: calc(var(--animate-duration) * 0.75);\r\n    -webkit-animation-name: flipOutX;\r\n    animation-name: flipOutX;\r\n    -webkit-backface-visibility: visible !important;\r\n    backface-visibility: visible !important;\r\n}\r\n\r\n@-webkit-keyframes flipOutY {\r\n    from {\r\n        -webkit-transform: perspective(400px);\r\n        transform: perspective(400px);\r\n    }\r\n\r\n    30% {\r\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\r\n        transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\r\n        transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes flipOutY {\r\n    from {\r\n        -webkit-transform: perspective(400px);\r\n        transform: perspective(400px);\r\n    }\r\n\r\n    30% {\r\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\r\n        transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\r\n        transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.animate__flipOutY {\r\n    -webkit-animation-duration: calc(1s * 0.75);\r\n    animation-duration: calc(1s * 0.75);\r\n    -webkit-animation-duration: calc(var(--animate-duration) * 0.75);\r\n    animation-duration: calc(var(--animate-duration) * 0.75);\r\n    -webkit-backface-visibility: visible !important;\r\n    backface-visibility: visible !important;\r\n    -webkit-animation-name: flipOutY;\r\n    animation-name: flipOutY;\r\n}\r\n\r\n/* Lightspeed */\r\n@-webkit-keyframes lightSpeedInRight {\r\n    from {\r\n        -webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);\r\n        transform: translate3d(100%, 0, 0) skewX(-30deg);\r\n        opacity: 0;\r\n    }\r\n\r\n    60% {\r\n        -webkit-transform: skewX(20deg);\r\n        transform: skewX(20deg);\r\n        opacity: 1;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: skewX(-5deg);\r\n        transform: skewX(-5deg);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes lightSpeedInRight {\r\n    from {\r\n        -webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);\r\n        transform: translate3d(100%, 0, 0) skewX(-30deg);\r\n        opacity: 0;\r\n    }\r\n\r\n    60% {\r\n        -webkit-transform: skewX(20deg);\r\n        transform: skewX(20deg);\r\n        opacity: 1;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: skewX(-5deg);\r\n        transform: skewX(-5deg);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__lightSpeedInRight {\r\n    -webkit-animation-name: lightSpeedInRight;\r\n    animation-name: lightSpeedInRight;\r\n    -webkit-animation-timing-function: ease-out;\r\n    animation-timing-function: ease-out;\r\n}\r\n\r\n@-webkit-keyframes lightSpeedInLeft {\r\n    from {\r\n        -webkit-transform: translate3d(-100%, 0, 0) skewX(30deg);\r\n        transform: translate3d(-100%, 0, 0) skewX(30deg);\r\n        opacity: 0;\r\n    }\r\n\r\n    60% {\r\n        -webkit-transform: skewX(-20deg);\r\n        transform: skewX(-20deg);\r\n        opacity: 1;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: skewX(5deg);\r\n        transform: skewX(5deg);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes lightSpeedInLeft {\r\n    from {\r\n        -webkit-transform: translate3d(-100%, 0, 0) skewX(30deg);\r\n        transform: translate3d(-100%, 0, 0) skewX(30deg);\r\n        opacity: 0;\r\n    }\r\n\r\n    60% {\r\n        -webkit-transform: skewX(-20deg);\r\n        transform: skewX(-20deg);\r\n        opacity: 1;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: skewX(5deg);\r\n        transform: skewX(5deg);\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__lightSpeedInLeft {\r\n    -webkit-animation-name: lightSpeedInLeft;\r\n    animation-name: lightSpeedInLeft;\r\n    -webkit-animation-timing-function: ease-out;\r\n    animation-timing-function: ease-out;\r\n}\r\n\r\n@-webkit-keyframes lightSpeedOutRight {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(100%, 0, 0) skewX(30deg);\r\n        transform: translate3d(100%, 0, 0) skewX(30deg);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes lightSpeedOutRight {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(100%, 0, 0) skewX(30deg);\r\n        transform: translate3d(100%, 0, 0) skewX(30deg);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.animate__lightSpeedOutRight {\r\n    -webkit-animation-name: lightSpeedOutRight;\r\n    animation-name: lightSpeedOutRight;\r\n    -webkit-animation-timing-function: ease-in;\r\n    animation-timing-function: ease-in;\r\n}\r\n\r\n@-webkit-keyframes lightSpeedOutLeft {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(-100%, 0, 0) skewX(-30deg);\r\n        transform: translate3d(-100%, 0, 0) skewX(-30deg);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes lightSpeedOutLeft {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(-100%, 0, 0) skewX(-30deg);\r\n        transform: translate3d(-100%, 0, 0) skewX(-30deg);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.animate__lightSpeedOutLeft {\r\n    -webkit-animation-name: lightSpeedOutLeft;\r\n    animation-name: lightSpeedOutLeft;\r\n    -webkit-animation-timing-function: ease-in;\r\n    animation-timing-function: ease-in;\r\n}\r\n\r\n/* Rotating entrances */\r\n@-webkit-keyframes rotateIn {\r\n    from {\r\n        -webkit-transform: rotate3d(0, 0, 1, -200deg);\r\n        transform: rotate3d(0, 0, 1, -200deg);\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes rotateIn {\r\n    from {\r\n        -webkit-transform: rotate3d(0, 0, 1, -200deg);\r\n        transform: rotate3d(0, 0, 1, -200deg);\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.animate__rotateIn {\r\n    -webkit-animation-name: rotateIn;\r\n    animation-name: rotateIn;\r\n    -webkit-transform-origin: center;\r\n    transform-origin: center;\r\n}\r\n\r\n@-webkit-keyframes rotateInDownLeft {\r\n    from {\r\n        -webkit-transform: rotate3d(0, 0, 1, -45deg);\r\n        transform: rotate3d(0, 0, 1, -45deg);\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes rotateInDownLeft {\r\n    from {\r\n        -webkit-transform: rotate3d(0, 0, 1, -45deg);\r\n        transform: rotate3d(0, 0, 1, -45deg);\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.animate__rotateInDownLeft {\r\n    -webkit-animation-name: rotateInDownLeft;\r\n    animation-name: rotateInDownLeft;\r\n    -webkit-transform-origin: left bottom;\r\n    transform-origin: left bottom;\r\n}\r\n\r\n@-webkit-keyframes rotateInDownRight {\r\n    from {\r\n        -webkit-transform: rotate3d(0, 0, 1, 45deg);\r\n        transform: rotate3d(0, 0, 1, 45deg);\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes rotateInDownRight {\r\n    from {\r\n        -webkit-transform: rotate3d(0, 0, 1, 45deg);\r\n        transform: rotate3d(0, 0, 1, 45deg);\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.animate__rotateInDownRight {\r\n    -webkit-animation-name: rotateInDownRight;\r\n    animation-name: rotateInDownRight;\r\n    -webkit-transform-origin: right bottom;\r\n    transform-origin: right bottom;\r\n}\r\n\r\n@-webkit-keyframes rotateInUpLeft {\r\n    from {\r\n        -webkit-transform: rotate3d(0, 0, 1, 45deg);\r\n        transform: rotate3d(0, 0, 1, 45deg);\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes rotateInUpLeft {\r\n    from {\r\n        -webkit-transform: rotate3d(0, 0, 1, 45deg);\r\n        transform: rotate3d(0, 0, 1, 45deg);\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.animate__rotateInUpLeft {\r\n    -webkit-animation-name: rotateInUpLeft;\r\n    animation-name: rotateInUpLeft;\r\n    -webkit-transform-origin: left bottom;\r\n    transform-origin: left bottom;\r\n}\r\n\r\n@-webkit-keyframes rotateInUpRight {\r\n    from {\r\n        -webkit-transform: rotate3d(0, 0, 1, -90deg);\r\n        transform: rotate3d(0, 0, 1, -90deg);\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes rotateInUpRight {\r\n    from {\r\n        -webkit-transform: rotate3d(0, 0, 1, -90deg);\r\n        transform: rotate3d(0, 0, 1, -90deg);\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.animate__rotateInUpRight {\r\n    -webkit-animation-name: rotateInUpRight;\r\n    animation-name: rotateInUpRight;\r\n    -webkit-transform-origin: right bottom;\r\n    transform-origin: right bottom;\r\n}\r\n\r\n/* Rotating exits */\r\n@-webkit-keyframes rotateOut {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: rotate3d(0, 0, 1, 200deg);\r\n        transform: rotate3d(0, 0, 1, 200deg);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes rotateOut {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: rotate3d(0, 0, 1, 200deg);\r\n        transform: rotate3d(0, 0, 1, 200deg);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.animate__rotateOut {\r\n    -webkit-animation-name: rotateOut;\r\n    animation-name: rotateOut;\r\n    -webkit-transform-origin: center;\r\n    transform-origin: center;\r\n}\r\n\r\n@-webkit-keyframes rotateOutDownLeft {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: rotate3d(0, 0, 1, 45deg);\r\n        transform: rotate3d(0, 0, 1, 45deg);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes rotateOutDownLeft {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: rotate3d(0, 0, 1, 45deg);\r\n        transform: rotate3d(0, 0, 1, 45deg);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.animate__rotateOutDownLeft {\r\n    -webkit-animation-name: rotateOutDownLeft;\r\n    animation-name: rotateOutDownLeft;\r\n    -webkit-transform-origin: left bottom;\r\n    transform-origin: left bottom;\r\n}\r\n\r\n@-webkit-keyframes rotateOutDownRight {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: rotate3d(0, 0, 1, -45deg);\r\n        transform: rotate3d(0, 0, 1, -45deg);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes rotateOutDownRight {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: rotate3d(0, 0, 1, -45deg);\r\n        transform: rotate3d(0, 0, 1, -45deg);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.animate__rotateOutDownRight {\r\n    -webkit-animation-name: rotateOutDownRight;\r\n    animation-name: rotateOutDownRight;\r\n    -webkit-transform-origin: right bottom;\r\n    transform-origin: right bottom;\r\n}\r\n\r\n@-webkit-keyframes rotateOutUpLeft {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: rotate3d(0, 0, 1, -45deg);\r\n        transform: rotate3d(0, 0, 1, -45deg);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes rotateOutUpLeft {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: rotate3d(0, 0, 1, -45deg);\r\n        transform: rotate3d(0, 0, 1, -45deg);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.animate__rotateOutUpLeft {\r\n    -webkit-animation-name: rotateOutUpLeft;\r\n    animation-name: rotateOutUpLeft;\r\n    -webkit-transform-origin: left bottom;\r\n    transform-origin: left bottom;\r\n}\r\n\r\n@-webkit-keyframes rotateOutUpRight {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: rotate3d(0, 0, 1, 90deg);\r\n        transform: rotate3d(0, 0, 1, 90deg);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes rotateOutUpRight {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: rotate3d(0, 0, 1, 90deg);\r\n        transform: rotate3d(0, 0, 1, 90deg);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.animate__rotateOutUpRight {\r\n    -webkit-animation-name: rotateOutUpRight;\r\n    animation-name: rotateOutUpRight;\r\n    -webkit-transform-origin: right bottom;\r\n    transform-origin: right bottom;\r\n}\r\n\r\n/* Specials */\r\n@-webkit-keyframes hinge {\r\n    0% {\r\n        -webkit-animation-timing-function: ease-in-out;\r\n        animation-timing-function: ease-in-out;\r\n    }\r\n\r\n    20%,\r\n    60% {\r\n        -webkit-transform: rotate3d(0, 0, 1, 80deg);\r\n        transform: rotate3d(0, 0, 1, 80deg);\r\n        -webkit-animation-timing-function: ease-in-out;\r\n        animation-timing-function: ease-in-out;\r\n    }\r\n\r\n    40%,\r\n    80% {\r\n        -webkit-transform: rotate3d(0, 0, 1, 60deg);\r\n        transform: rotate3d(0, 0, 1, 60deg);\r\n        -webkit-animation-timing-function: ease-in-out;\r\n        animation-timing-function: ease-in-out;\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 700px, 0);\r\n        transform: translate3d(0, 700px, 0);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes hinge {\r\n    0% {\r\n        -webkit-animation-timing-function: ease-in-out;\r\n        animation-timing-function: ease-in-out;\r\n    }\r\n\r\n    20%,\r\n    60% {\r\n        -webkit-transform: rotate3d(0, 0, 1, 80deg);\r\n        transform: rotate3d(0, 0, 1, 80deg);\r\n        -webkit-animation-timing-function: ease-in-out;\r\n        animation-timing-function: ease-in-out;\r\n    }\r\n\r\n    40%,\r\n    80% {\r\n        -webkit-transform: rotate3d(0, 0, 1, 60deg);\r\n        transform: rotate3d(0, 0, 1, 60deg);\r\n        -webkit-animation-timing-function: ease-in-out;\r\n        animation-timing-function: ease-in-out;\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 700px, 0);\r\n        transform: translate3d(0, 700px, 0);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.animate__hinge {\r\n    -webkit-animation-duration: calc(1s * 2);\r\n    animation-duration: calc(1s * 2);\r\n    -webkit-animation-duration: calc(var(--animate-duration) * 2);\r\n    animation-duration: calc(var(--animate-duration) * 2);\r\n    -webkit-animation-name: hinge;\r\n    animation-name: hinge;\r\n    -webkit-transform-origin: top left;\r\n    transform-origin: top left;\r\n}\r\n\r\n@-webkit-keyframes jackInTheBox {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: scale(0.1) rotate(30deg);\r\n        transform: scale(0.1) rotate(30deg);\r\n        -webkit-transform-origin: center bottom;\r\n        transform-origin: center bottom;\r\n    }\r\n\r\n    50% {\r\n        -webkit-transform: rotate(-10deg);\r\n        transform: rotate(-10deg);\r\n    }\r\n\r\n    70% {\r\n        -webkit-transform: rotate(3deg);\r\n        transform: rotate(3deg);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n@keyframes jackInTheBox {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: scale(0.1) rotate(30deg);\r\n        transform: scale(0.1) rotate(30deg);\r\n        -webkit-transform-origin: center bottom;\r\n        transform-origin: center bottom;\r\n    }\r\n\r\n    50% {\r\n        -webkit-transform: rotate(-10deg);\r\n        transform: rotate(-10deg);\r\n    }\r\n\r\n    70% {\r\n        -webkit-transform: rotate(3deg);\r\n        transform: rotate(3deg);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n.animate__jackInTheBox {\r\n    -webkit-animation-name: jackInTheBox;\r\n    animation-name: jackInTheBox;\r\n}\r\n\r\n/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */\r\n@-webkit-keyframes rollIn {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);\r\n        transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes rollIn {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);\r\n        transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__rollIn {\r\n    -webkit-animation-name: rollIn;\r\n    animation-name: rollIn;\r\n}\r\n\r\n/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */\r\n@-webkit-keyframes rollOut {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);\r\n        transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);\r\n    }\r\n}\r\n\r\n@keyframes rollOut {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);\r\n        transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);\r\n    }\r\n}\r\n\r\n.animate__rollOut {\r\n    -webkit-animation-name: rollOut;\r\n    animation-name: rollOut;\r\n}\r\n\r\n/* Zooming entrances */\r\n@-webkit-keyframes zoomIn {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.3, 0.3, 0.3);\r\n        transform: scale3d(0.3, 0.3, 0.3);\r\n    }\r\n\r\n    50% {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes zoomIn {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.3, 0.3, 0.3);\r\n        transform: scale3d(0.3, 0.3, 0.3);\r\n    }\r\n\r\n    50% {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.animate__zoomIn {\r\n    -webkit-animation-name: zoomIn;\r\n    animation-name: zoomIn;\r\n}\r\n\r\n@-webkit-keyframes zoomInDown {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);\r\n        transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n    }\r\n\r\n    60% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\r\n        transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n        animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n    }\r\n}\r\n\r\n@keyframes zoomInDown {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);\r\n        transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n    }\r\n\r\n    60% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\r\n        transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n        animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n    }\r\n}\r\n\r\n.animate__zoomInDown {\r\n    -webkit-animation-name: zoomInDown;\r\n    animation-name: zoomInDown;\r\n}\r\n\r\n@-webkit-keyframes zoomInLeft {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);\r\n        transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n    }\r\n\r\n    60% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);\r\n        transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n        animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n    }\r\n}\r\n\r\n@keyframes zoomInLeft {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);\r\n        transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n    }\r\n\r\n    60% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);\r\n        transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n        animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n    }\r\n}\r\n\r\n.animate__zoomInLeft {\r\n    -webkit-animation-name: zoomInLeft;\r\n    animation-name: zoomInLeft;\r\n}\r\n\r\n@-webkit-keyframes zoomInRight {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);\r\n        transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n    }\r\n\r\n    60% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);\r\n        transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n        animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n    }\r\n}\r\n\r\n@keyframes zoomInRight {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);\r\n        transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n    }\r\n\r\n    60% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);\r\n        transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n        animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n    }\r\n}\r\n\r\n.animate__zoomInRight {\r\n    -webkit-animation-name: zoomInRight;\r\n    animation-name: zoomInRight;\r\n}\r\n\r\n@-webkit-keyframes zoomInUp {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);\r\n        transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n    }\r\n\r\n    60% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\r\n        transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n        animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n    }\r\n}\r\n\r\n@keyframes zoomInUp {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);\r\n        transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n    }\r\n\r\n    60% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\r\n        transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n        animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n    }\r\n}\r\n\r\n.animate__zoomInUp {\r\n    -webkit-animation-name: zoomInUp;\r\n    animation-name: zoomInUp;\r\n}\r\n\r\n/* Zooming exits */\r\n@-webkit-keyframes zoomOut {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    50% {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.3, 0.3, 0.3);\r\n        transform: scale3d(0.3, 0.3, 0.3);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes zoomOut {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    50% {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.3, 0.3, 0.3);\r\n        transform: scale3d(0.3, 0.3, 0.3);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.animate__zoomOut {\r\n    -webkit-animation-name: zoomOut;\r\n    animation-name: zoomOut;\r\n}\r\n\r\n@-webkit-keyframes zoomOutDown {\r\n    40% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\r\n        transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);\r\n        transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n        animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n    }\r\n}\r\n\r\n@keyframes zoomOutDown {\r\n    40% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\r\n        transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);\r\n        transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n        animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n    }\r\n}\r\n\r\n.animate__zoomOutDown {\r\n    -webkit-animation-name: zoomOutDown;\r\n    animation-name: zoomOutDown;\r\n    -webkit-transform-origin: center bottom;\r\n    transform-origin: center bottom;\r\n}\r\n\r\n@-webkit-keyframes zoomOutLeft {\r\n    40% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);\r\n        transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: scale(0.1) translate3d(-2000px, 0, 0);\r\n        transform: scale(0.1) translate3d(-2000px, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes zoomOutLeft {\r\n    40% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);\r\n        transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: scale(0.1) translate3d(-2000px, 0, 0);\r\n        transform: scale(0.1) translate3d(-2000px, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__zoomOutLeft {\r\n    -webkit-animation-name: zoomOutLeft;\r\n    animation-name: zoomOutLeft;\r\n    -webkit-transform-origin: left center;\r\n    transform-origin: left center;\r\n}\r\n\r\n@-webkit-keyframes zoomOutRight {\r\n    40% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);\r\n        transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: scale(0.1) translate3d(2000px, 0, 0);\r\n        transform: scale(0.1) translate3d(2000px, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes zoomOutRight {\r\n    40% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);\r\n        transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: scale(0.1) translate3d(2000px, 0, 0);\r\n        transform: scale(0.1) translate3d(2000px, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__zoomOutRight {\r\n    -webkit-animation-name: zoomOutRight;\r\n    animation-name: zoomOutRight;\r\n    -webkit-transform-origin: right center;\r\n    transform-origin: right center;\r\n}\r\n\r\n@-webkit-keyframes zoomOutUp {\r\n    40% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\r\n        transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);\r\n        transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n        animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n    }\r\n}\r\n\r\n@keyframes zoomOutUp {\r\n    40% {\r\n        opacity: 1;\r\n        -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\r\n        transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);\r\n        transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);\r\n        -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n        animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\r\n    }\r\n}\r\n\r\n.animate__zoomOutUp {\r\n    -webkit-animation-name: zoomOutUp;\r\n    animation-name: zoomOutUp;\r\n    -webkit-transform-origin: center bottom;\r\n    transform-origin: center bottom;\r\n}\r\n\r\n/* Sliding entrances */\r\n@-webkit-keyframes slideInDown {\r\n    from {\r\n        -webkit-transform: translate3d(0, -100%, 0);\r\n        transform: translate3d(0, -100%, 0);\r\n        visibility: visible;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes slideInDown {\r\n    from {\r\n        -webkit-transform: translate3d(0, -100%, 0);\r\n        transform: translate3d(0, -100%, 0);\r\n        visibility: visible;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__slideInDown {\r\n    -webkit-animation-name: slideInDown;\r\n    animation-name: slideInDown;\r\n}\r\n\r\n@-webkit-keyframes slideInLeft {\r\n    from {\r\n        -webkit-transform: translate3d(-100%, 0, 0);\r\n        transform: translate3d(-100%, 0, 0);\r\n        visibility: visible;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes slideInLeft {\r\n    from {\r\n        -webkit-transform: translate3d(-100%, 0, 0);\r\n        transform: translate3d(-100%, 0, 0);\r\n        visibility: visible;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__slideInLeft {\r\n    -webkit-animation-name: slideInLeft;\r\n    animation-name: slideInLeft;\r\n}\r\n\r\n@-webkit-keyframes slideInRight {\r\n    from {\r\n        -webkit-transform: translate3d(100%, 0, 0);\r\n        transform: translate3d(100%, 0, 0);\r\n        visibility: visible;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes slideInRight {\r\n    from {\r\n        -webkit-transform: translate3d(100%, 0, 0);\r\n        transform: translate3d(100%, 0, 0);\r\n        visibility: visible;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__slideInRight {\r\n    -webkit-animation-name: slideInRight;\r\n    animation-name: slideInRight;\r\n}\r\n\r\n@-webkit-keyframes slideInUp {\r\n    from {\r\n        -webkit-transform: translate3d(0, 100%, 0);\r\n        transform: translate3d(0, 100%, 0);\r\n        visibility: visible;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes slideInUp {\r\n    from {\r\n        -webkit-transform: translate3d(0, 100%, 0);\r\n        transform: translate3d(0, 100%, 0);\r\n        visibility: visible;\r\n    }\r\n\r\n    to {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__slideInUp {\r\n    -webkit-animation-name: slideInUp;\r\n    animation-name: slideInUp;\r\n}\r\n\r\n/* Sliding exits */\r\n@-webkit-keyframes slideOutDown {\r\n    from {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    to {\r\n        visibility: hidden;\r\n        -webkit-transform: translate3d(0, 100%, 0);\r\n        transform: translate3d(0, 100%, 0);\r\n    }\r\n}\r\n\r\n@keyframes slideOutDown {\r\n    from {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    to {\r\n        visibility: hidden;\r\n        -webkit-transform: translate3d(0, 100%, 0);\r\n        transform: translate3d(0, 100%, 0);\r\n    }\r\n}\r\n\r\n.animate__slideOutDown {\r\n    -webkit-animation-name: slideOutDown;\r\n    animation-name: slideOutDown;\r\n}\r\n\r\n@-webkit-keyframes slideOutLeft {\r\n    from {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    to {\r\n        visibility: hidden;\r\n        -webkit-transform: translate3d(-100%, 0, 0);\r\n        transform: translate3d(-100%, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes slideOutLeft {\r\n    from {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    to {\r\n        visibility: hidden;\r\n        -webkit-transform: translate3d(-100%, 0, 0);\r\n        transform: translate3d(-100%, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__slideOutLeft {\r\n    -webkit-animation-name: slideOutLeft;\r\n    animation-name: slideOutLeft;\r\n}\r\n\r\n@-webkit-keyframes slideOutRight {\r\n    from {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    to {\r\n        visibility: hidden;\r\n        -webkit-transform: translate3d(100%, 0, 0);\r\n        transform: translate3d(100%, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes slideOutRight {\r\n    from {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    to {\r\n        visibility: hidden;\r\n        -webkit-transform: translate3d(100%, 0, 0);\r\n        transform: translate3d(100%, 0, 0);\r\n    }\r\n}\r\n\r\n.animate__slideOutRight {\r\n    -webkit-animation-name: slideOutRight;\r\n    animation-name: slideOutRight;\r\n}\r\n\r\n@-webkit-keyframes slideOutUp {\r\n    from {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    to {\r\n        visibility: hidden;\r\n        -webkit-transform: translate3d(0, -100%, 0);\r\n        transform: translate3d(0, -100%, 0);\r\n    }\r\n}\r\n\r\n@keyframes slideOutUp {\r\n    from {\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n\r\n    to {\r\n        visibility: hidden;\r\n        -webkit-transform: translate3d(0, -100%, 0);\r\n        transform: translate3d(0, -100%, 0);\r\n    }\r\n}\r\n\r\n.animate__slideOutUp {\r\n    -webkit-animation-name: slideOutUp;\r\n    animation-name: slideOutUp;\r\n}",".rc-pagination {\r\n    margin: 0;\r\n    padding: 0;\r\n    font-size: 14px\r\n}\r\n\r\n.rc-pagination ol,\r\n.rc-pagination ul {\r\n    margin: 0;\r\n    padding: 0;\r\n    list-style: none\r\n}\r\n\r\n.rc-pagination:after {\r\n    display: block;\r\n    clear: both;\r\n    height: 0;\r\n    overflow: hidden;\r\n    visibility: hidden;\r\n    content: \" \"\r\n}\r\n\r\n.rc-pagination-total-text {\r\n    display: inline-block;\r\n    height: 28px;\r\n    margin-right: 8px;\r\n    line-height: 26px;\r\n    vertical-align: middle\r\n}\r\n\r\n.rc-pagination-item {\r\n    display: inline-block;\r\n    min-width: 28px;\r\n    height: 28px;\r\n    margin-right: 8px;\r\n \r\n    line-height: 26px;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    list-style: none;\r\n    background-color: #fff;\r\n    border: 1px solid #d9d9d9;\r\n    border-radius: 2px;\r\n    outline: 0;\r\n    cursor: pointer;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none\r\n}\r\n\r\n.rc-pagination-item a {\r\n    display: block;\r\n    padding: 0 6px;\r\n    color: rgba(0, 0, 0, .85);\r\n    transition: none\r\n}\r\n\r\n.rc-pagination-item a:hover {\r\n    text-decoration: none\r\n}\r\n\r\n.rc-pagination-item:focus,\r\n.rc-pagination-item:hover {\r\n    border-color: #1890ff;\r\n    transition: all .3s\r\n}\r\n\r\n.rc-pagination-item:focus a,\r\n.rc-pagination-item:hover a {\r\n    color: #1890ff\r\n}\r\n\r\n.rc-pagination-item-active {\r\n    font-weight: 500;\r\n    background: #fff;\r\n    border-color: #1890ff\r\n}\r\n\r\n.rc-pagination-item-active a {\r\n    color: #1890ff\r\n}\r\n\r\n.rc-pagination-item-active:focus,\r\n.rc-pagination-item-active:hover {\r\n    border-color: #40a9ff\r\n}\r\n\r\n.rc-pagination-item-active:focus a,\r\n.rc-pagination-item-active:hover a {\r\n    color: #40a9ff\r\n}\r\n\r\n.rc-pagination-jump-next,\r\n.rc-pagination-jump-prev {\r\n    outline: 0\r\n}\r\n\r\n.rc-pagination-jump-next button,\r\n.rc-pagination-jump-prev button {\r\n    background: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    color: #666\r\n}\r\n\r\n.rc-pagination-jump-next button:after,\r\n.rc-pagination-jump-prev button:after {\r\n    display: block;\r\n    content: \"•••\"\r\n}\r\n\r\n.rc-pagination-jump-next,\r\n.rc-pagination-jump-prev,\r\n.rc-pagination-prev {\r\n    margin-right: 8px\r\n}\r\n\r\n.rc-pagination-jump-next,\r\n.rc-pagination-jump-prev,\r\n.rc-pagination-next,\r\n.rc-pagination-prev {\r\n    display: inline-block;\r\n    min-width: 28px;\r\n    height: 28px;\r\n    color: rgba(0, 0, 0, .85);\r\n   \r\n    line-height: 28px;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    list-style: none;\r\n    border-radius: 2px;\r\n    cursor: pointer;\r\n    transition: all .3s\r\n}\r\n\r\n.rc-pagination-next,\r\n.rc-pagination-prev {\r\n    outline: 0\r\n}\r\n\r\n.rc-pagination-next button,\r\n.rc-pagination-prev button {\r\n    color: rgba(0, 0, 0, .85);\r\n    cursor: pointer;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none\r\n}\r\n\r\n.rc-pagination-next:hover button,\r\n.rc-pagination-prev:hover button {\r\n    border-color: #40a9ff\r\n}\r\n\r\n.rc-pagination-next .rc-pagination-item-link,\r\n.rc-pagination-prev .rc-pagination-item-link {\r\n    display: block;\r\n    width: 100%;\r\n    height: 100%;\r\n    font-size: 12px;\r\n    text-align: center;\r\n    background-color: #fff;\r\n    border: 1px solid #d9d9d9;\r\n    border-radius: 2px;\r\n    outline: none;\r\n    transition: all .3s\r\n}\r\n\r\n.rc-pagination-next:focus .rc-pagination-item-link,\r\n.rc-pagination-next:hover .rc-pagination-item-link,\r\n.rc-pagination-prev:focus .rc-pagination-item-link,\r\n.rc-pagination-prev:hover .rc-pagination-item-link {\r\n    color: #1890ff;\r\n    border-color: #1890ff\r\n}\r\n\r\n.rc-pagination-prev button:after {\r\n    content: \"‹\";\r\n    display: block\r\n}\r\n\r\n.rc-pagination-next button:after {\r\n    content: \"›\";\r\n    display: block\r\n}\r\n\r\n.rc-pagination-disabled,\r\n.rc-pagination-disabled:focus,\r\n.rc-pagination-disabled:hover {\r\n    cursor: not-allowed\r\n}\r\n\r\n.rc-pagination-disabled .rc-pagination-item-link,\r\n.rc-pagination-disabled:focus .rc-pagination-item-link,\r\n.rc-pagination-disabled:hover .rc-pagination-item-link {\r\n    color: rgba(0, 0, 0, .25);\r\n    border-color: #d9d9d9;\r\n    cursor: not-allowed\r\n}\r\n\r\n.rc-pagination-slash {\r\n    margin: 0 10px 0 5px\r\n}\r\n\r\n.rc-pagination-options {\r\n    display: inline-block;\r\n    margin-left: 16px;\r\n    vertical-align: middle\r\n}\r\n\r\n@media (-ms-high-contrast:none) {\r\n\r\n    .rc-pagination-options,\r\n    .rc-pagination-options ::-ms-backdrop {\r\n        vertical-align: top\r\n    }\r\n}\r\n\r\n.rc-pagination-options-size-changer.rc-select {\r\n    display: inline-block;\r\n    width: auto;\r\n    margin-right: 8px\r\n}\r\n\r\n.rc-pagination-options-quick-jumper {\r\n    display: inline-block;\r\n    height: 28px;\r\n    line-height: 28px;\r\n    vertical-align: top\r\n}\r\n\r\n.rc-pagination-options-quick-jumper input {\r\n    width: 50px;\r\n    margin: 0 8px\r\n}\r\n\r\n.rc-pagination-simple .rc-pagination-next,\r\n.rc-pagination-simple .rc-pagination-prev {\r\n    height: 24px;\r\n    line-height: 24px;\r\n    vertical-align: top\r\n}\r\n\r\n.rc-pagination-simple .rc-pagination-next .rc-pagination-item-link,\r\n.rc-pagination-simple .rc-pagination-prev .rc-pagination-item-link {\r\n    height: 24px;\r\n    background-color: transparent;\r\n    border: 0\r\n}\r\n\r\n.rc-pagination-simple .rc-pagination-next .rc-pagination-item-link:after,\r\n.rc-pagination-simple .rc-pagination-prev .rc-pagination-item-link:after {\r\n    height: 24px;\r\n    line-height: 24px\r\n}\r\n\r\n.rc-pagination-simple .rc-pagination-simple-pager {\r\n    display: inline-block;\r\n    height: 24px;\r\n    margin-right: 8px\r\n}\r\n\r\n.rc-pagination-simple .rc-pagination-simple-pager input {\r\n    box-sizing: border-box;\r\n    height: 100%;\r\n    margin-right: 8px;\r\n    padding: 0 6px;\r\n    text-align: center;\r\n    background-color: #fff;\r\n    border: 1px solid #d9d9d9;\r\n    border-radius: 2px;\r\n    outline: none;\r\n    transition: border-color .3s\r\n}\r\n\r\n.rc-pagination-simple .rc-pagination-simple-pager input:hover {\r\n    border-color: #1890ff\r\n}\r\n\r\n.rc-pagination.rc-pagination-disabled {\r\n    cursor: not-allowed\r\n}\r\n\r\n.rc-pagination.rc-pagination-disabled .rc-pagination-item {\r\n    background: #f5f5f5;\r\n    border-color: #d9d9d9;\r\n    cursor: not-allowed\r\n}\r\n\r\n.rc-pagination.rc-pagination-disabled .rc-pagination-item a {\r\n    color: rgba(0, 0, 0, .25);\r\n    background: transparent;\r\n    border: none;\r\n    cursor: not-allowed\r\n}\r\n\r\n.rc-pagination.rc-pagination-disabled .rc-pagination-item-active {\r\n    background: #dbdbdb;\r\n    border-color: transparent\r\n}\r\n\r\n.rc-pagination.rc-pagination-disabled .rc-pagination-item-active a {\r\n    color: #fff\r\n}\r\n\r\n.rc-pagination.rc-pagination-disabled .rc-pagination-item-link {\r\n    color: rgba(0, 0, 0, .25);\r\n    background: #f5f5f5;\r\n    border-color: #d9d9d9;\r\n    cursor: not-allowed\r\n}\r\n\r\n.rc-pagination.rc-pagination-disabled .rc-pagination-item-link-icon {\r\n    opacity: 0\r\n}\r\n\r\n.rc-pagination.rc-pagination-disabled .rc-pagination-item-ellipsis {\r\n    opacity: 1\r\n}\r\n\r\n@media only screen and (max-width:992px) {\r\n\r\n    .rc-pagination-item-after-jump-prev,\r\n    .rc-pagination-item-before-jump-next {\r\n        display: none\r\n    }\r\n}\r\n\r\n@media only screen and (max-width:576px) {\r\n    .rc-pagination-options {\r\n        display: none\r\n    }\r\n}\r\n\r\n* {\r\n    box-sizing: border-box\r\n}\r\n\r\n.rc-select {\r\n    display: inline-block;\r\n    font-size: 12px;\r\n    width: 100px;\r\n    position: relative\r\n}\r\n\r\n.rc-select-disabled,\r\n.rc-select-disabled input {\r\n    cursor: not-allowed\r\n}\r\n\r\n.rc-select-disabled .rc-select-selector {\r\n    opacity: .3\r\n}\r\n\r\n.rc-select-show-arrow.rc-select-loading .rc-select-arrow-icon:after {\r\n    box-sizing: border-box;\r\n    width: 12px;\r\n    height: 12px;\r\n    border-radius: 100%;\r\n    border-color: transparent #999;\r\n    border-style: solid;\r\n    border-width: 2px;\r\n    transform: none;\r\n    margin-top: 4px;\r\n    animation: rcSelectLoadingIcon .5s infinite\r\n}\r\n\r\n.rc-select .rc-select-selection-placeholder {\r\n    opacity: .4;\r\n    pointer-events: none\r\n}\r\n\r\n.rc-select .rc-select-selection-search-input {\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none\r\n}\r\n\r\n.rc-select .rc-select-selection-search-input::-webkit-search-cancel-button {\r\n    display: none;\r\n    -webkit-appearance: none;\r\n    appearance: none\r\n}\r\n\r\n.rc-select-single .rc-select-selector {\r\n    display: flex;\r\n    position: relative\r\n}\r\n\r\n.rc-select-single .rc-select-selector .rc-select-selection-search {\r\n    width: 100%\r\n}\r\n\r\n.rc-select-single .rc-select-selector .rc-select-selection-search-input {\r\n    width: 100%\r\n}\r\n\r\n.rc-select-single .rc-select-selector .rc-select-selection-item,\r\n.rc-select-single .rc-select-selector .rc-select-selection-placeholder {\r\n    position: absolute;\r\n    top: 1px;\r\n    left: 3px;\r\n    pointer-events: none\r\n}\r\n\r\n.rc-select-single:not(.rc-select-customize-input) .rc-select-selector {\r\n    padding: 1px;\r\n    border: 1px solid #000\r\n}\r\n\r\n.rc-select-single:not(.rc-select-customize-input) .rc-select-selector .rc-select-selection-search-input {\r\n    border: none;\r\n    outline: none;\r\n    background: rgba(255, 0, 0, .2);\r\n    width: 100%\r\n}\r\n\r\n.rc-select-multiple .rc-select-selector {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    padding: 1px;\r\n    border: 1px solid #000\r\n}\r\n\r\n.rc-select-multiple .rc-select-selector .rc-select-selection-item {\r\n    flex: none;\r\n    background: #bbb;\r\n    border-radius: 4px;\r\n    margin-right: 2px;\r\n    padding: 0 8px\r\n}\r\n\r\n.rc-select-multiple .rc-select-selector .rc-select-selection-item-disabled {\r\n    cursor: not-allowed;\r\n    opacity: .5\r\n}\r\n\r\n.rc-select-multiple .rc-select-selector .rc-select-selection-overflow {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    width: 100%\r\n}\r\n\r\n.rc-select-multiple .rc-select-selector .rc-select-selection-overflow-item {\r\n    flex: none;\r\n    max-width: 100%\r\n}\r\n\r\n.rc-select-multiple .rc-select-selector .rc-select-selection-search {\r\n    position: relative;\r\n    max-width: 100%\r\n}\r\n\r\n.rc-select-multiple .rc-select-selector .rc-select-selection-search-input,\r\n.rc-select-multiple .rc-select-selector .rc-select-selection-search-mirror {\r\n    padding: 1px;\r\n    font-family: system-ui\r\n}\r\n\r\n.rc-select-multiple .rc-select-selector .rc-select-selection-search-mirror {\r\n    position: absolute;\r\n    z-index: 999;\r\n    white-space: nowrap;\r\n    position: none;\r\n    left: 0;\r\n    top: 0;\r\n    visibility: hidden\r\n}\r\n\r\n.rc-select-multiple .rc-select-selector .rc-select-selection-search-input {\r\n    border: none;\r\n    outline: none;\r\n    background: rgba(255, 0, 0, .2);\r\n    width: 100%\r\n}\r\n\r\n.rc-select-allow-clear.rc-select-multiple .rc-select-selector {\r\n    padding-right: 20px\r\n}\r\n\r\n.rc-select-allow-clear .rc-select-clear {\r\n    position: absolute;\r\n    right: 20px;\r\n    top: 0\r\n}\r\n\r\n.rc-select-show-arrow.rc-select-multiple .rc-select-selector {\r\n    padding-right: 20px\r\n}\r\n\r\n.rc-select-show-arrow .rc-select-arrow {\r\n    pointer-events: none;\r\n    position: absolute;\r\n    right: 5px;\r\n    top: 0\r\n}\r\n\r\n.rc-select-show-arrow .rc-select-arrow-icon:after {\r\n    content: \"\";\r\n    width: 0;\r\n    height: 0;\r\n    display: inline-block;\r\n    border: 5px solid transparent;\r\n    border-top-color: #999;\r\n    transform: translateY(5px)\r\n}\r\n\r\n.rc-select-focused .rc-select-selector {\r\n    border-color: #00f !important\r\n}\r\n\r\n.rc-select-dropdown {\r\n    border: 1px solid green;\r\n    min-height: 100px;\r\n    position: absolute;\r\n    background: #fff\r\n}\r\n\r\n.rc-select-dropdown-hidden {\r\n    display: none\r\n}\r\n\r\n.rc-select-item {\r\n    font-size: 16px;\r\n    line-height: 1.5;\r\n    padding: 4px 16px\r\n}\r\n\r\n.rc-select-item-group {\r\n    color: #999;\r\n    font-weight: 700;\r\n    font-size: 80%\r\n}\r\n\r\n.rc-select-item-option {\r\n    position: relative\r\n}\r\n\r\n.rc-select-item-option-grouped {\r\n    padding-left: 24px\r\n}\r\n\r\n.rc-select-item-option .rc-select-item-option-state {\r\n    position: absolute;\r\n    right: 0;\r\n    top: 4px;\r\n    pointer-events: none\r\n}\r\n\r\n.rc-select-item-option-active {\r\n    background: #ddd\r\n}\r\n\r\n.rc-select-item-option-disabled {\r\n    color: #999\r\n}\r\n\r\n.rc-select-item-empty {\r\n    text-align: center;\r\n    color: #999\r\n}\r\n\r\n.rc-select-selection__choice-zoom {\r\n    transition: all .3s\r\n}\r\n\r\n.rc-select-selection__choice-zoom-appear {\r\n    opacity: 0;\r\n    transform: scale(.5)\r\n}\r\n\r\n.rc-select-selection__choice-zoom-appear.rc-select-selection__choice-zoom-appear-active {\r\n    opacity: 1;\r\n    transform: scale(1)\r\n}\r\n\r\n.rc-select-selection__choice-zoom-leave {\r\n    opacity: 1;\r\n    transform: scale(1)\r\n}\r\n\r\n.rc-select-selection__choice-zoom-leave.rc-select-selection__choice-zoom-leave-active {\r\n    opacity: 0;\r\n    transform: scale(.5)\r\n}\r\n\r\n.rc-select-dropdown-slide-up-appear,\r\n.rc-select-dropdown-slide-up-enter {\r\n    animation-duration: .3s;\r\n    animation-fill-mode: both;\r\n    transform-origin: 0 0;\r\n    opacity: 0;\r\n    animation-timing-function: cubic-bezier(.08, .82, .17, 1);\r\n    animation-play-state: paused\r\n}\r\n\r\n.rc-select-dropdown-slide-up-leave {\r\n    animation-duration: .3s;\r\n    animation-fill-mode: both;\r\n    transform-origin: 0 0;\r\n    opacity: 1;\r\n    animation-timing-function: cubic-bezier(.6, .04, .98, .34);\r\n    animation-play-state: paused\r\n}\r\n\r\n.rc-select-dropdown-slide-up-appear.rc-select-dropdown-slide-up-appear-active.rc-select-dropdown-placement-bottomLeft,\r\n.rc-select-dropdown-slide-up-appear.rc-select-dropdown-slide-up-appear-active.rc-select-dropdown-placement-bottomRight,\r\n.rc-select-dropdown-slide-up-enter.rc-select-dropdown-slide-up-enter-active.rc-select-dropdown-placement-bottomLeft,\r\n.rc-select-dropdown-slide-up-enter.rc-select-dropdown-slide-up-enter-active.rc-select-dropdown-placement-bottomRight {\r\n    animation-name: rcSelectDropdownSlideUpIn;\r\n    animation-play-state: running\r\n}\r\n\r\n.rc-select-dropdown-slide-up-leave.rc-select-dropdown-slide-up-leave-active.rc-select-dropdown-placement-bottomLeft,\r\n.rc-select-dropdown-slide-up-leave.rc-select-dropdown-slide-up-leave-active.rc-select-dropdown-placement-bottomRight {\r\n    animation-name: rcSelectDropdownSlideUpOut;\r\n    animation-play-state: running\r\n}\r\n\r\n.rc-select-dropdown-slide-up-appear.rc-select-dropdown-slide-up-appear-active.rc-select-dropdown-placement-topLeft,\r\n.rc-select-dropdown-slide-up-enter.rc-select-dropdown-slide-up-enter-active.rc-select-dropdown-placement-topLeft {\r\n    animation-name: rcSelectDropdownSlideDownIn;\r\n    animation-play-state: running\r\n}\r\n\r\n.rc-select-dropdown-slide-up-leave.rc-select-dropdown-slide-up-leave-active.rc-select-dropdown-placement-topLeft {\r\n    animation-name: rcSelectDropdownSlideDownOut;\r\n    animation-play-state: running\r\n}\r\n\r\n@keyframes rcSelectDropdownSlideUpIn {\r\n    0% {\r\n        opacity: 0;\r\n        transform-origin: 0 0;\r\n        transform: scaleY(0)\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform-origin: 0 0;\r\n        transform: scaleY(1)\r\n    }\r\n}\r\n\r\n@keyframes rcSelectDropdownSlideUpOut {\r\n    0% {\r\n        opacity: 1;\r\n        transform-origin: 0 0;\r\n        transform: scaleY(1)\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        transform-origin: 0 0;\r\n        transform: scaleY(0)\r\n    }\r\n}\r\n\r\n@keyframes rcSelectLoadingIcon {\r\n    0% {\r\n        transform: rotate(0)\r\n    }\r\n\r\n    to {\r\n        transform: rotate(1turn)\r\n    }\r\n}\r\n\r\n.__dumi-default-previewer {\r\n    background-color: #fff;\r\n    border: 1px solid #ebedf1;\r\n    border-radius: 1px\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-previewer {\r\n    background-color: #141414;\r\n    border-color: #6b6c6d\r\n}\r\n\r\n.__dumi-default-previewer[data-debug] {\r\n    margin-top: 32px;\r\n    border-color: #ffcb00\r\n}\r\n\r\n.__dumi-default-previewer[data-debug]:before {\r\n    content: \"DEV ONLY\";\r\n    float: left;\r\n    margin-left: -1px;\r\n    margin-top: -18px;\r\n    padding: 3px 6px;\r\n    font-size: 12px;\r\n    line-height: 1;\r\n    background-color: #ffcb00;\r\n    color: #735600;\r\n    text-shadow: .5px .5px 0 hsla(0, 0%, 100%, .5);\r\n    border-top-left-radius: 1px;\r\n    border-top-right-radius: 1px\r\n}\r\n\r\n.__dumi-default-previewer[data-iframe] .__dumi-default-previewer-browser-nav {\r\n    padding: 2px 6px;\r\n    background-color: #ebedf1\r\n}\r\n\r\n.__dumi-default-previewer[data-iframe] .__dumi-default-previewer-browser-nav:before {\r\n    content: \"\";\r\n    display: inline-block;\r\n    width: 12px;\r\n    height: 12px;\r\n    border-radius: 50%;\r\n    background-color: #fd6458;\r\n    box-shadow: 20px 0 0 #ffbf2b, 40px 0 0 #24cc3d\r\n}\r\n\r\n.__dumi-default-previewer[data-iframe] .__dumi-default-previewer-demo>iframe {\r\n    border: 0;\r\n    width: 100%;\r\n    height: 300px\r\n}\r\n\r\n.__dumi-default-previewer+.__dumi-default-previewer {\r\n    margin-top: 32px\r\n}\r\n\r\n.__dumi-default-previewer-demo {\r\n    padding: 40px 24px\r\n}\r\n\r\n.__dumi-default-previewer-target {\r\n    border-color: rgba(69, 105, 212, .5);\r\n    box-shadow: 0 0 0 5px rgba(69, 105, 212, .05)\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-previewer-target {\r\n    box-shadow: 0 0 0 5px rgba(69, 105, 212, .3)\r\n}\r\n\r\n.__dumi-default-previewer-desc>div:last-child {\r\n    padding: 1.2em 1em 1em;\r\n    color: #454d64;\r\n    border-top: 1px solid #ebedf1\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-previewer-desc>div:last-child {\r\n    border-color: #6b6c6d\r\n}\r\n\r\n.__dumi-default-previewer-desc .markdown>p:first-child {\r\n    margin-top: 0\r\n}\r\n\r\n.__dumi-default-previewer-desc .markdown>p:last-child {\r\n    margin-bottom: 0\r\n}\r\n\r\n.__dumi-default-previewer-desc[data-title] {\r\n    position: relative\r\n}\r\n\r\n.__dumi-default-previewer-desc[data-title]>a:first-child {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 1em;\r\n    margin-left: -4px;\r\n    padding: 0 4px;\r\n    color: #454d64;\r\n    font-size: inherit;\r\n    font-weight: 500;\r\n    background: linear-gradient(0deg, #fff, #fff 50%, hsla(0, 0%, 100%, 0)) 100%;\r\n    transform: translateY(-50%);\r\n    pointer-events: auto;\r\n    cursor: pointer\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-previewer-desc[data-title]>a:first-child {\r\n    color: hsla(0, 0%, 100%, .85);\r\n    background: linear-gradient(0deg, #141414, #141414 50%, hsla(0, 0%, 100%, 0)) 100%\r\n}\r\n\r\n.__dumi-default-previewer-desc[data-title]:empty {\r\n    padding-top: 0\r\n}\r\n\r\n.__dumi-default-previewer-desc[data-title]:empty+.__dumi-default-previewer-actions {\r\n    height: 46px;\r\n    border-top-style: solid\r\n}\r\n\r\n.__dumi-default-previewer-actions {\r\n    display: flex;\r\n    height: 40px;\r\n    padding: 0 1em;\r\n    align-items: center;\r\n    border-top: 1px dashed #ebedf1\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-previewer-actions {\r\n    border-color: #6b6c6d\r\n}\r\n\r\n.__dumi-default-previewer-actions>a:not(:last-child),\r\n.__dumi-default-previewer-actions>button:not(:last-child) {\r\n    margin-right: 8px\r\n}\r\n\r\n.__dumi-default-previewer-actions>a {\r\n    display: flex\r\n}\r\n\r\n.__dumi-default-previewer-actions button {\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 16px;\r\n    height: 16px;\r\n    padding: 0;\r\n    border: 0;\r\n    box-sizing: border-box;\r\n    cursor: pointer;\r\n    opacity: .6;\r\n    outline: none;\r\n    transition: opacity .2s, background .2s\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-previewer-actions button {\r\n    opacity: 1\r\n}\r\n\r\n.__dumi-default-previewer-actions button:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: -8px;\r\n    left: -8px;\r\n    right: -8px;\r\n    bottom: -8px\r\n}\r\n\r\n.__dumi-default-previewer-actions button:hover {\r\n    opacity: .8\r\n}\r\n\r\n.__dumi-default-previewer-actions button:active {\r\n    opacity: .9\r\n}\r\n\r\n.__dumi-default-previewer-actions button:disabled {\r\n    opacity: .2;\r\n    cursor: not-allowed\r\n}\r\n\r\n.__dumi-default-previewer-actions button[role=codesandbox] {\r\n    background-position: -18px 0\r\n}\r\n\r\n.__dumi-default-previewer-actions button[role=codepen] {\r\n    background-position: -36px 0\r\n}\r\n\r\n.__dumi-default-previewer-actions button[role=source] {\r\n    background-position: -72px 0\r\n}\r\n\r\n.__dumi-default-previewer-actions button[role=change-jsx] {\r\n    background-position: -90px 0\r\n}\r\n\r\n.__dumi-default-previewer-actions button[role=change-tsx] {\r\n    background-position: -108px 0\r\n}\r\n\r\n.__dumi-default-previewer-actions button[role=open-demo] {\r\n    background-position: -126px 0\r\n}\r\n\r\n.__dumi-default-previewer-actions button[role=motions] {\r\n    background-position: -162px 0\r\n}\r\n\r\n.__dumi-default-previewer-actions button[role=sketch-component] {\r\n    background-position: -182px 0\r\n}\r\n\r\n.__dumi-default-previewer-actions button[role=sketch-group] {\r\n    background-position: -200px 0\r\n}\r\n\r\n.__dumi-default-previewer-actions button[role=copy][data-status=ready] {\r\n    background-position: -54px 0\r\n}\r\n\r\n.__dumi-default-previewer-actions button[role=copy][data-status=copied] {\r\n    pointer-events: none;\r\n    background-position: -54px -16px\r\n}\r\n\r\n.__dumi-default-previewer-actions button[role=refresh] {\r\n    background-position-x: -144px\r\n}\r\n\r\n.__dumi-default-previewer-actions>span {\r\n    flex: 1 1;\r\n    display: inline-block\r\n}\r\n\r\n.__dumi-default-previewer-source {\r\n    border-top: 1px dashed #ebedf1\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-previewer-source {\r\n    border-color: #6b6c6d\r\n}\r\n\r\n.__dumi-default-previewer-source-tab {\r\n    border-top: 1px dashed #ebedf1\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-previewer-source-tab {\r\n    border-color: #6b6c6d\r\n}\r\n\r\n.__dumi-default-previewer-source-tab .__dumi-default-tabs-tab-btn {\r\n    position: relative;\r\n    padding-left: 32px\r\n}\r\n\r\n.__dumi-default-previewer-source-tab .__dumi-default-tabs-tab-btn:after,\r\n.__dumi-default-previewer-source-tab .__dumi-default-tabs-tab-btn:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    margin-right: 4px;\r\n    display: inline-block;\r\n    box-sizing: border-box\r\n}\r\n\r\n.__dumi-default-previewer-source-tab .__dumi-default-tabs-tab-btn:before {\r\n    left: 16px;\r\n    top: 50%;\r\n    margin-top: -6px;\r\n    width: 10px;\r\n    height: 12px;\r\n    border: 1px solid #717484\r\n}\r\n\r\n.__dumi-default-previewer-source-tab .__dumi-default-tabs-tab-btn:after {\r\n    top: 50%;\r\n    left: 23px;\r\n    margin-top: -7px;\r\n    width: 4px;\r\n    height: 4px;\r\n    background: #fff;\r\n    border-bottom: 1px solid #717484;\r\n    transform: rotate(45deg)\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-previewer-source-tab .__dumi-default-tabs-tab-btn:after {\r\n    background: #141414\r\n}\r\n\r\n.__dumi-default-tabs {\r\n    overflow: hidden\r\n}\r\n\r\n.__dumi-default-tabs.__dumi-default-tabs-top {\r\n    flex-direction: column\r\n}\r\n\r\n.__dumi-default-tabs.__dumi-default-tabs-top .__dumi-default-tabs-ink-bar {\r\n    bottom: 0\r\n}\r\n\r\n.__dumi-default-tabs-nav {\r\n    display: flex\r\n}\r\n\r\n.__dumi-default-tabs-nav-wrap {\r\n    display: flex;\r\n    white-space: nowrap;\r\n    overflow: hidden\r\n}\r\n\r\n.__dumi-default-tabs-nav-wrap.__dumi-default-tabs-nav-wrap-ping-left {\r\n    box-shadow: inset 5px 0 5px -5px rgba(0, 0, 0, .1)\r\n}\r\n\r\n.__dumi-default-tabs-nav-wrap.__dumi-default-tabs-nav-wrap-ping-right~*>.__dumi-default-tabs-nav-more {\r\n    box-shadow: 0 0 5px rgba(0, 0, 0, .1)\r\n}\r\n\r\n.__dumi-default-tabs-nav-list {\r\n    position: relative;\r\n    display: flex;\r\n    transition: transform .2s\r\n}\r\n\r\n.__dumi-default-tabs-nav-more {\r\n    height: 100%;\r\n    cursor: pointer;\r\n    background: none;\r\n    border: 0;\r\n    transition: box-shadow .2s\r\n}\r\n\r\n.__dumi-default-tabs-tab {\r\n    display: flex\r\n}\r\n\r\n.__dumi-default-tabs-tab-btn {\r\n    padding: 0 16px;\r\n    font-size: 14px;\r\n    line-height: 36px;\r\n    border: 0;\r\n    outline: none;\r\n    background: transparent;\r\n    box-sizing: border-box;\r\n    cursor: pointer\r\n}\r\n\r\n.__dumi-default-tabs-tab-btn:hover {\r\n    color: #4569d4\r\n}\r\n\r\n.__dumi-default-tabs-ink-bar {\r\n    position: absolute;\r\n    height: 2px;\r\n    background: #4569d4;\r\n    transition: left .2s, width .2s;\r\n    pointer-events: none\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-tabs-ink-bar {\r\n    background: #7395f7\r\n}\r\n\r\n.__dumi-default-tabs-dropdown {\r\n    position: absolute;\r\n    background: #fff;\r\n    border: 1px solid #ebedf1;\r\n    max-height: 200px;\r\n    overflow: auto\r\n}\r\n\r\n.__dumi-default-tabs-dropdown>ul {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0\r\n}\r\n\r\n.__dumi-default-tabs-dropdown>ul>li {\r\n    padding: 4px 12px;\r\n    font-size: 14px;\r\n    cursor: pointer\r\n}\r\n\r\n.__dumi-default-tabs-dropdown>ul>li:hover {\r\n    color: #4569d4\r\n}\r\n\r\n.__dumi-default-tabs-dropdown>ul>li:not(:last-child) {\r\n    border-bottom: 1px dashed #ebedf1\r\n}\r\n\r\n.__dumi-default-tabs-dropdown-hidden {\r\n    display: none\r\n}\r\n\r\ncode[class*=language-],\r\npre[class*=language-] {\r\n    color: #000;\r\n    background: none;\r\n    text-shadow: 0 1px #fff;\r\n    font-family: Consolas, Monaco, \"Andale Mono\", \"Ubuntu Mono\", monospace;\r\n    font-size: 1em;\r\n    text-align: left;\r\n    white-space: pre;\r\n    word-spacing: normal;\r\n    word-break: normal;\r\n    word-wrap: normal;\r\n    line-height: 1.5;\r\n    -moz-tab-size: 4;\r\n    tab-size: 4;\r\n    -webkit-hyphens: none;\r\n    -ms-hyphens: none;\r\n    hyphens: none\r\n}\r\n\r\ncode[class*=language-]::selection,\r\ncode[class*=language-] ::selection,\r\npre[class*=language-]::selection,\r\npre[class*=language-] ::selection {\r\n    text-shadow: none;\r\n    background: #b3d4fc\r\n}\r\n\r\n@media print {\r\n\r\n    code[class*=language-],\r\n    pre[class*=language-] {\r\n        text-shadow: none\r\n    }\r\n}\r\n\r\npre[class*=language-] {\r\n    padding: 1em;\r\n    margin: .5em 0;\r\n    overflow: auto\r\n}\r\n\r\n:not(pre)>code[class*=language-],\r\npre[class*=language-] {\r\n    background: #f5f2f0\r\n}\r\n\r\n:not(pre)>code[class*=language-] {\r\n    padding: .1em;\r\n    border-radius: .3em;\r\n    white-space: normal\r\n}\r\n\r\n.token.cdata,\r\n.token.comment,\r\n.token.doctype,\r\n.token.prolog {\r\n    color: #708090\r\n}\r\n\r\n.token.punctuation {\r\n    color: #999\r\n}\r\n\r\n.token.namespace {\r\n    opacity: .7\r\n}\r\n\r\n.token.boolean,\r\n.token.constant,\r\n.token.deleted,\r\n.token.number,\r\n.token.property,\r\n.token.symbol,\r\n.token.tag {\r\n    color: #905\r\n}\r\n\r\n.token.attr-name,\r\n.token.builtin,\r\n.token.char,\r\n.token.inserted,\r\n.token.selector,\r\n.token.string {\r\n    color: #690\r\n}\r\n\r\n.language-css .token.string,\r\n.style .token.string,\r\n.token.entity,\r\n.token.operator,\r\n.token.url {\r\n    color: #9a6e3a;\r\n    background: hsla(0, 0%, 100%, .5)\r\n}\r\n\r\n.token.atrule,\r\n.token.attr-value,\r\n.token.keyword {\r\n    color: #07a\r\n}\r\n\r\n.token.class-name,\r\n.token.function {\r\n    color: #dd4a68\r\n}\r\n\r\n.token.important,\r\n.token.regex,\r\n.token.variable {\r\n    color: #e90\r\n}\r\n\r\n.token.bold,\r\n.token.important {\r\n    font-weight: 700\r\n}\r\n\r\n.token.italic {\r\n    font-style: italic\r\n}\r\n\r\n.token.entity {\r\n    cursor: help\r\n}\r\n\r\n.__dumi-default-code-block {\r\n    position: relative;\r\n    font-size: 14px;\r\n    background-color: #f9fafb\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-code-block {\r\n    color: hsla(0, 0%, 100%, .85);\r\n    background: #262626\r\n}\r\n\r\n.__dumi-default-code-block+.__dumi-default-code-block,\r\n.__dumi-default-code-block+table {\r\n    margin-top: 16px\r\n}\r\n\r\n.__dumi-default-code-block>pre[class*=language-] {\r\n    margin: 0;\r\n    background: transparent\r\n}\r\n\r\n.__dumi-default-code-block>pre[class*=language-] .token-line:not(:last-child) .plain:empty {\r\n    display: inline-block;\r\n    min-height: 1em\r\n}\r\n\r\n.__dumi-default-code-block-copy-btn {\r\n    position: absolute;\r\n    top: 1.1em;\r\n    right: 1em;\r\n    display: inline-block;\r\n    width: 16px;\r\n    height: 16px;\r\n    padding: 0;\r\n    border: 0;\r\n    outline: none;\r\n    cursor: pointer;\r\n    opacity: .6;\r\n    transition: opacity .2s, background .2s\r\n}\r\n\r\n.__dumi-default-code-block-copy-btn:hover {\r\n    opacity: .8\r\n}\r\n\r\n.__dumi-default-code-block-copy-btn:active {\r\n    opacity: .9\r\n}\r\n\r\n.__dumi-default-code-block-copy-btn[data-status=ready] {\r\n    background-position: -54px 0\r\n}\r\n\r\n.__dumi-default-code-block-copy-btn[data-status=copied] {\r\n    opacity: 1;\r\n    pointer-events: none;\r\n    background-position: -54px -16px\r\n}\r\n\r\n.__dumi-default-code-block:not(:hover) .__dumi-default-code-block-copy-btn {\r\n    visibility: hidden;\r\n    opacity: 0\r\n}\r\n\r\ncode[class*=language-]::selection,\r\ncode[class*=language-] ::selection,\r\npre[class*=language-]::selection,\r\npre[class*=language-] ::selection {\r\n    color: inherit\r\n}\r\n\r\n[data-prefers-color=dark] code[class*=language-],\r\n[data-prefers-color=dark] pre[class*=language-] {\r\n    color: hsla(0, 0%, 100%, .85);\r\n    text-shadow: 0 1px #000\r\n}\r\n\r\n[data-prefers-color=dark] code[class*=language-]::selection,\r\n[data-prefers-color=dark] code[class*=language-] ::selection,\r\n[data-prefers-color=dark] pre[class*=language-]::selection,\r\n[data-prefers-color=dark] pre[class*=language-] ::selection {\r\n    background-color: #364a63\r\n}\r\n\r\n[data-prefers-color=dark] .language-css .token.string,\r\n[data-prefers-color=dark] .style .token.string,\r\n[data-prefers-color=dark] .token.entity,\r\n[data-prefers-color=dark] .token.operator,\r\n[data-prefers-color=dark] .token.url {\r\n    background: transparent\r\n}\r\n\r\n[data-prefers-color=dark] .token.constant,\r\n[data-prefers-color=dark] .token.deleted,\r\n[data-prefers-color=dark] .token.property,\r\n[data-prefers-color=dark] .token.symbol,\r\n[data-prefers-color=dark] .token.tag {\r\n    color: #f92672\r\n}\r\n\r\n[data-prefers-color=dark] .token.attr-name,\r\n[data-prefers-color=dark] .token.builtin,\r\n[data-prefers-color=dark] .token.char,\r\n[data-prefers-color=dark] .token.inserted,\r\n[data-prefers-color=dark] .token.selector,\r\n[data-prefers-color=dark] .token.string {\r\n    color: #a6e22e\r\n}\r\n\r\n[data-prefers-color=dark] .token.atrule,\r\n[data-prefers-color=dark] .token.attr-value,\r\n[data-prefers-color=dark] .token.keyword {\r\n    color: #e6db74\r\n}\r\n\r\n[data-prefers-color=dark] .token.punctuation {\r\n    color: hsla(0, 0%, 100%, .85)\r\n}\r\n\r\n[data-prefers-color=dark] .token.keyword {\r\n    color: #66d9ef\r\n}\r\n\r\n[data-prefers-color=dark] .token.boolean,\r\n[data-prefers-color=dark] .token.number {\r\n    color: #ae81ff\r\n}\r\n\r\n.markdown {\r\n    color: #454d64;\r\n    font-size: 15px;\r\n    line-height: 1.60625\r\n}\r\n\r\n[data-prefers-color=dark] .markdown {\r\n    color: hsla(0, 0%, 100%, .65)\r\n}\r\n\r\n.markdown:not(:first-child):empty {\r\n    min-height: 32px\r\n}\r\n\r\n.markdown h1,\r\n.markdown h2,\r\n.markdown h3,\r\n.markdown h4,\r\n.markdown h5,\r\n.markdown h6 {\r\n    margin: 42px 0 18px;\r\n    color: #454d64;\r\n    font-weight: 500;\r\n    line-height: 1.40625\r\n}\r\n\r\n[data-prefers-color=dark] .markdown h1,\r\n[data-prefers-color=dark] .markdown h2,\r\n[data-prefers-color=dark] .markdown h3,\r\n[data-prefers-color=dark] .markdown h4,\r\n[data-prefers-color=dark] .markdown h5,\r\n[data-prefers-color=dark] .markdown h6 {\r\n    color: hsla(0, 0%, 100%, .85)\r\n}\r\n\r\n.markdown h1:hover>a[aria-hidden],\r\n.markdown h2:hover>a[aria-hidden],\r\n.markdown h3:hover>a[aria-hidden],\r\n.markdown h4:hover>a[aria-hidden],\r\n.markdown h5:hover>a[aria-hidden],\r\n.markdown h6:hover>a[aria-hidden] {\r\n    float: left;\r\n    margin-top: .06em;\r\n    margin-left: -20px;\r\n    width: 20px;\r\n    padding-right: 4px;\r\n    line-height: 1;\r\n    box-sizing: border-box\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n\r\n    .markdown h1:hover>a[aria-hidden],\r\n    .markdown h2:hover>a[aria-hidden],\r\n    .markdown h3:hover>a[aria-hidden],\r\n    .markdown h4:hover>a[aria-hidden],\r\n    .markdown h5:hover>a[aria-hidden],\r\n    .markdown h6:hover>a[aria-hidden] {\r\n        width: 14px;\r\n        margin-left: -14px\r\n    }\r\n}\r\n\r\n.markdown h1:hover>a[aria-hidden]:after,\r\n.markdown h2:hover>a[aria-hidden]:after,\r\n.markdown h3:hover>a[aria-hidden]:after,\r\n.markdown h4:hover>a[aria-hidden]:after,\r\n.markdown h5:hover>a[aria-hidden]:after,\r\n.markdown h6:hover>a[aria-hidden]:after {\r\n    content: \"#\";\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    font-size: 20px\r\n}\r\n\r\n.markdown h1:hover>a[aria-hidden] span,\r\n.markdown h2:hover>a[aria-hidden] span,\r\n.markdown h3:hover>a[aria-hidden] span,\r\n.markdown h4:hover>a[aria-hidden] span,\r\n.markdown h5:hover>a[aria-hidden] span,\r\n.markdown h6:hover>a[aria-hidden] span {\r\n    display: none\r\n}\r\n\r\n.markdown h1+h1,\r\n.markdown h1+h2,\r\n.markdown h1+h3,\r\n.markdown h1+h4,\r\n.markdown h1+h5,\r\n.markdown h1+h6,\r\n.markdown h2+h1,\r\n.markdown h2+h2,\r\n.markdown h2+h3,\r\n.markdown h2+h4,\r\n.markdown h2+h5,\r\n.markdown h2+h6,\r\n.markdown h3+h1,\r\n.markdown h3+h2,\r\n.markdown h3+h3,\r\n.markdown h3+h4,\r\n.markdown h3+h5,\r\n.markdown h3+h6,\r\n.markdown h4+h1,\r\n.markdown h4+h2,\r\n.markdown h4+h3,\r\n.markdown h4+h4,\r\n.markdown h4+h5,\r\n.markdown h4+h6,\r\n.markdown h5+h1,\r\n.markdown h5+h2,\r\n.markdown h5+h3,\r\n.markdown h5+h4,\r\n.markdown h5+h5,\r\n.markdown h5+h6,\r\n.markdown h6+h1,\r\n.markdown h6+h2,\r\n.markdown h6+h3,\r\n.markdown h6+h4,\r\n.markdown h6+h5,\r\n.markdown h6+h6 {\r\n    margin-top: 16px\r\n}\r\n\r\n.markdown h1 {\r\n    margin-top: 48px;\r\n    margin-bottom: 32px;\r\n    font-size: 32px\r\n}\r\n\r\n.markdown h2 {\r\n    font-size: 24px\r\n}\r\n\r\n.markdown h3 {\r\n    font-size: 20px\r\n}\r\n\r\n.markdown h4 {\r\n    font-size: 18px\r\n}\r\n\r\n.markdown h5 {\r\n    font-size: 16px\r\n}\r\n\r\n.markdown h6 {\r\n    font-size: 14px\r\n}\r\n\r\n.markdown p {\r\n    margin: 16px 0\r\n}\r\n\r\n.markdown :not(pre) code {\r\n    padding: 2px 5px;\r\n    color: #d56161;\r\n    background: #f6f7f9\r\n}\r\n\r\n[data-prefers-color=dark] .markdown :not(pre) code {\r\n    color: #ff7875;\r\n    background: hsla(0, 0%, 100%, .08)\r\n}\r\n\r\n.markdown code {\r\n    font-family: Consolas, Monaco, \"Andale Mono\", \"Ubuntu Mono\", monospace\r\n}\r\n\r\n.markdown pre {\r\n    font-size: 14px;\r\n    background: #f6f7f9\r\n}\r\n\r\n.markdown pre:not([class^=language-]) {\r\n    padding: 1em\r\n}\r\n\r\n.markdown hr {\r\n    margin: 16px 0;\r\n    border: 0;\r\n    border-top: 1px solid #ebedf1\r\n}\r\n\r\n.markdown blockquote {\r\n    margin: 16px 0;\r\n    padding: 0 24px;\r\n    color: rgba(69, 77, 100, .7);\r\n    border-left: 4px solid #ebedf1;\r\n    overflow: hidden\r\n}\r\n\r\n[data-prefers-color=dark] .markdown blockquote {\r\n    color: hsla(0, 0%, 100%, .55);\r\n    border-color: #6b6c6d\r\n}\r\n\r\n.markdown ol,\r\n.markdown ul {\r\n    margin: 8px 0 8px 32px;\r\n    padding: 0\r\n}\r\n\r\n.markdown ol li,\r\n.markdown ul li {\r\n    margin-bottom: 4px\r\n}\r\n\r\n.markdown table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    border: 1px solid #ebedf1\r\n}\r\n\r\n[data-prefers-color=dark] .markdown table {\r\n    border: 1px solid #3b434b\r\n}\r\n\r\n.markdown table td,\r\n.markdown table th {\r\n    padding: 10px 24px;\r\n    border: 1px solid #ebedf1\r\n}\r\n\r\n[data-prefers-color=dark] .markdown table td,\r\n[data-prefers-color=dark] .markdown table th {\r\n    border: 1px solid #3b434b\r\n}\r\n\r\n.markdown table th {\r\n    font-weight: 600;\r\n    background: #f9fafb\r\n}\r\n\r\n[data-prefers-color=dark] .markdown table th {\r\n    background: hsla(0, 0%, 100%, .08)\r\n}\r\n\r\n.markdown table td:first-child {\r\n    font-weight: 500\r\n}\r\n\r\n.markdown table a svg {\r\n    display: none\r\n}\r\n\r\n.markdown a {\r\n    color: #4569d4;\r\n    text-decoration: none;\r\n    transition: opacity .2s;\r\n    outline: none\r\n}\r\n\r\n[data-prefers-color=dark] .markdown a {\r\n    color: #7395f7\r\n}\r\n\r\n.markdown a:hover {\r\n    opacity: .7;\r\n    text-decoration: underline\r\n}\r\n\r\n.markdown a:active {\r\n    opacity: .9\r\n}\r\n\r\n.markdown img {\r\n    max-width: 100%\r\n}\r\n\r\n.__dumi-default-external-link-icon {\r\n    vertical-align: -.155em;\r\n    margin-left: 2px\r\n}\r\n\r\n[data-prefers-color=dark] h1,\r\n[data-prefers-color=dark] h2,\r\n[data-prefers-color=dark] h3,\r\n[data-prefers-color=dark] h4 {\r\n    color: hsla(0, 0%, 100%, .85)\r\n}\r\n\r\n.__dumi-default-icon {\r\n    background: url(\"data:image/png;base64,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\") no-repeat 0 0/230px auto\r\n}\r\n\r\n\r\n\r\n[data-prefers-color=dark] body {\r\n    color: hsla(0, 0%, 100%, .85);\r\n    background-color: #141414\r\n}\r\n\r\n.__dumi-default-layout {\r\n    box-sizing: border-box;\r\n    min-height: 100vh;\r\n    padding: 16px 194px 50px 318px\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n    .__dumi-default-layout {\r\n        padding-top: 66px !important;\r\n        padding-left: 16px !important;\r\n        padding-right: 16px !important\r\n    }\r\n}\r\n\r\n.__dumi-default-layout[data-gapless=true] {\r\n    padding-top: 64px !important;\r\n    padding-right: 0 !important;\r\n    padding-left: 0 !important;\r\n    padding-bottom: 0\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n    .__dumi-default-layout[data-gapless=true] {\r\n        padding-top: 50px !important\r\n    }\r\n}\r\n\r\n.__dumi-default-layout[data-show-sidemenu=false] {\r\n    padding-left: 58px\r\n}\r\n\r\n.__dumi-default-layout[data-show-slugs=false] {\r\n    padding-right: 58px\r\n}\r\n\r\n.__dumi-default-layout[data-site-mode=true] {\r\n    padding-top: 114px\r\n}\r\n\r\n.__dumi-default-layout[data-site-mode=true][data-show-sidemenu=true] {\r\n    padding-left: 350px\r\n}\r\n\r\n.__dumi-default-layout[data-site-mode=true][data-show-slugs=true] {\r\n    padding-right: 208px\r\n}\r\n\r\n.__dumi-default-layout[data-site-mode=true] .__dumi-default-layout-content>.markdown:first-child>:first-child {\r\n    margin-top: 0\r\n}\r\n\r\n.__dumi-default-layout[data-site-mode=true] .__dumi-default-layout-toc {\r\n    top: 114px;\r\n    max-height: calc(90vh - 144px)\r\n}\r\n\r\n.__dumi-default-layout-hero {\r\n    margin: -50px -58px 0;\r\n    padding: 100px 0;\r\n    text-align: center;\r\n    background-color: #f5f6f8\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-layout-hero {\r\n    background-color: hsla(0, 0%, 100%, .08)\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n    .__dumi-default-layout-hero {\r\n        margin: -16px -16px 0;\r\n        padding: 48px 0\r\n    }\r\n}\r\n\r\n.__dumi-default-layout-hero img {\r\n    max-width: 100%;\r\n    max-height: 200px;\r\n    margin-bottom: 1rem\r\n}\r\n\r\n.__dumi-default-layout-hero h1 {\r\n    margin: 0 0 16px;\r\n    font-size: 48px;\r\n    font-weight: 600;\r\n    line-height: 56px;\r\n    color: #080e29\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-layout-hero h1 {\r\n    color: hsla(0, 0%, 100%, .85)\r\n}\r\n\r\n.__dumi-default-layout-hero h1+div {\r\n    margin: 16px 0 32px;\r\n    opacity: .78\r\n}\r\n\r\n.__dumi-default-layout-hero h1+div .markdown {\r\n    font-size: 16px\r\n}\r\n\r\n.__dumi-default-layout-hero button {\r\n    margin-right: 16px;\r\n    padding: 0 32px;\r\n    height: 44px;\r\n    color: #4569d4;\r\n    font-size: 16px;\r\n    background: transparent;\r\n    border: 1px solid #4569d4;\r\n    border-radius: 22px;\r\n    box-sizing: border-box;\r\n    cursor: pointer;\r\n    outline: none;\r\n    transition: all .3s\r\n}\r\n\r\n.__dumi-default-layout-hero button:hover {\r\n    opacity: .8\r\n}\r\n\r\n.__dumi-default-layout-hero button:active {\r\n    opacity: .9\r\n}\r\n\r\n.__dumi-default-layout-hero a:last-child button {\r\n    margin-right: 0;\r\n    color: #fff;\r\n    background: #4569d4\r\n}\r\n\r\n.__dumi-default-layout-features {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    grid-column-gap: 96px;\r\n    grid-row-gap: 56px;\r\n    padding: 72px 0\r\n}\r\n\r\n.__dumi-default-layout-features>dl {\r\n    flex: 1 1;\r\n    margin: 0;\r\n    text-align: center;\r\n    background: no-repeat top/auto 48px\r\n}\r\n\r\n.__dumi-default-layout-features>dl[style*=background-image] {\r\n    padding-top: 64px\r\n}\r\n\r\n.__dumi-default-layout-features>dl dt {\r\n    margin-bottom: 12px;\r\n    font-size: 20px;\r\n    line-height: 1;\r\n    color: #454d64\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-layout-features>dl dt {\r\n    color: hsla(0, 0%, 100%, .85)\r\n}\r\n\r\n.__dumi-default-layout-features>dl a {\r\n    transition-duration: none\r\n}\r\n\r\n.__dumi-default-layout-features>dl a dt {\r\n    color: #4569d4;\r\n    transition: opacity .2s\r\n}\r\n\r\n.__dumi-default-layout-features>dl a dt:hover {\r\n    opacity: .7;\r\n    text-decoration: underline\r\n}\r\n\r\n.__dumi-default-layout-features>dl a dt:active {\r\n    opacity: .9\r\n}\r\n\r\n.__dumi-default-layout-features>dl dd {\r\n    margin: 0\r\n}\r\n\r\n.__dumi-default-layout-features>dl dd .markdown {\r\n    color: #717484;\r\n    font-size: 14px;\r\n    line-height: 22px\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-layout-features>dl dd .markdown {\r\n    color: hsla(0, 0%, 100%, .65)\r\n}\r\n\r\n.__dumi-default-layout-features>dl dd .markdown>p:first-child {\r\n    margin-top: 0\r\n}\r\n\r\n.__dumi-default-layout-features>dl dd .markdown>p:last-child {\r\n    margin-bottom: 0\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n    .__dumi-default-layout-features {\r\n        display: block;\r\n        padding: 40px 0\r\n    }\r\n\r\n    .__dumi-default-layout-features>dl {\r\n        text-align: left;\r\n        background-position: 0 0\r\n    }\r\n\r\n    .__dumi-default-layout-features>dl[style*=background-image] {\r\n        padding: 0 0 0 60px\r\n    }\r\n\r\n    .__dumi-default-layout-features>dl+dl {\r\n        margin-top: 32px\r\n    }\r\n}\r\n\r\n.__dumi-default-layout-features,\r\n.__dumi-default-layout-features+.__dumi-default-layout-content,\r\n.__dumi-default-layout-hero+.__dumi-default-layout-content {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    max-width: 960px\r\n}\r\n\r\n.__dumi-default-layout-hero+.__dumi-default-layout-content {\r\n    margin-top: 60px\r\n}\r\n\r\n.__dumi-default-layout-toc {\r\n    list-style: none;\r\n    position: fixed;\r\n    z-index: 10;\r\n    top: 50px;\r\n    right: 0;\r\n    width: 136px;\r\n    max-height: calc(90vh - 80px);\r\n    margin: 0;\r\n    padding: 0 24px 0 0;\r\n    background-color: #fff;\r\n    box-sizing: content-box;\r\n    overflow: auto\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-layout-toc {\r\n    background-color: #141414\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n    .__dumi-default-layout-toc {\r\n        display: none\r\n    }\r\n}\r\n\r\n.__dumi-default-layout-toc li {\r\n    position: relative;\r\n    margin: 0;\r\n    padding: 4px 0 4px 6px;\r\n    text-indent: 12px;\r\n    font-size: 13px;\r\n    line-height: 1.40625;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden\r\n}\r\n\r\n.__dumi-default-layout-toc li a {\r\n    color: #454d64;\r\n    text-decoration: none\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-layout-toc li a {\r\n    color: hsla(0, 0%, 100%, .85)\r\n}\r\n\r\n.__dumi-default-layout-toc li a:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    display: inline-block;\r\n    width: 2px;\r\n    background: #ebedf1\r\n}\r\n\r\n.__dumi-default-layout-toc li a:hover {\r\n    color: #5a7ad9\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-layout-toc li a:hover {\r\n    color: #8ba7f8\r\n}\r\n\r\n.__dumi-default-layout-toc li a:active {\r\n    color: #5173d7\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-layout-toc li a:active {\r\n    color: #81a0f8\r\n}\r\n\r\n.__dumi-default-layout-toc li a.active {\r\n    color: #4569d4\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-layout-toc li a.active {\r\n    color: #7395f7\r\n}\r\n\r\n.__dumi-default-layout-toc li a.active:before {\r\n    background: #4569d4\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-layout-toc li a.active:before {\r\n    background: #7395f7\r\n}\r\n\r\n.__dumi-default-layout-footer-meta {\r\n    margin-top: 40px;\r\n    padding-top: 24px;\r\n    display: flex;\r\n    color: #717484;\r\n    font-size: 14px;\r\n    justify-content: space-between;\r\n    border-top: 1px solid #ebedf1\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-layout-footer-meta {\r\n    color: hsla(0, 0%, 100%, .65);\r\n    border-color: #6b6c6d\r\n}\r\n\r\n@media only screen and (max-width:960px) {\r\n    .__dumi-default-layout-footer-meta {\r\n        display: block\r\n    }\r\n}\r\n\r\n.__dumi-default-layout-footer-meta>a {\r\n    margin-bottom: 4px;\r\n    display: block;\r\n    color: #4569d4;\r\n    transition: opacity .2s;\r\n    text-decoration: none\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-layout-footer-meta>a {\r\n    color: #7395f7\r\n}\r\n\r\n.__dumi-default-layout-footer-meta>a:hover {\r\n    opacity: .7;\r\n    text-decoration: underline\r\n}\r\n\r\n.__dumi-default-layout-footer-meta>a:active {\r\n    opacity: .9\r\n}\r\n\r\n.__dumi-default-layout-footer-meta>span:last-child:before {\r\n    content: attr(data-updated-text);\r\n    color: #4569d4\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-layout-footer-meta>span:last-child:before {\r\n    color: #7395f7\r\n}\r\n\r\n.__dumi-default-layout-footer {\r\n    margin: 72px 0 -32px;\r\n    padding-top: 24px;\r\n    border-top: 1px solid #ebedf1;\r\n    text-align: center\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-layout-footer {\r\n    border-color: #6b6c6d\r\n}\r\n\r\n.__dumi-default-layout-footer .markdown {\r\n    color: #b0b1ba\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-layout-footer .markdown {\r\n    color: hsla(0, 0%, 100%, .45)\r\n}\r\n\r\n.__dumi-default-navbar {\r\n    position: fixed;\r\n    z-index: 101;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    display: none;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0 58px;\r\n    height: 64px;\r\n    white-space: nowrap;\r\n    background: #fff;\r\n    box-shadow: 0 8px 24px -2px rgba(0, 0, 0, .05)\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-navbar {\r\n    background: #141414;\r\n    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .65)\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n    .__dumi-default-navbar {\r\n        display: flex;\r\n        justify-content: center;\r\n        height: 50px\r\n    }\r\n}\r\n\r\n.__dumi-default-navbar-toggle {\r\n    position: absolute;\r\n    top: 14px;\r\n    left: 16px;\r\n    display: none;\r\n    width: 22px;\r\n    height: 22px;\r\n    border: 0;\r\n    outline: none;\r\n    background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAAA4CAYAAAB5YT9uAAAAAXNSR0IArs4c6QAAASVJREFUeAHt3DuOwjAUBVAHscWZjaSkAIqU2QjskV80QwpsF3ArdGiw3hW3OGnQM2Iof6/dfr7+n71/LjAdx+HRsvm8SkNPAHBPJ5ABDiD2KgD3dAIZ4ABirwJwTyeQAQ4g9ioA93QC2fbZsSm/z7MDAQIECBAgQIAAAQIECBAgQIAAAQKvAsvV8mO8O8yn19jkXYHpMC7byXVdeS0/75b5XFvAwr1tE0kARxjbJYDbNpEEcISxXQK4bRNJAEcY2yWA2zaRZP0ePJRzpFEJAQIECBAgQIAAAQIECBAgQIAAgW8VWK/tj7Nb5eBTnvbjsp1c15WX4ncRQeB7lb8zyHrW29xo1F1iU8AxynoR4LpLbAo4RlkvAlx3iU0BxyjrRYDrLrHpDVSAEEPXScHTAAAAAElFTkSuQmCC\") no-repeat 50%/contain\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n    .__dumi-default-navbar-toggle {\r\n        display: block\r\n    }\r\n}\r\n\r\n.__dumi-default-navbar-logo {\r\n    display: inline-block;\r\n    height: 40px;\r\n    color: #080e29;\r\n    font-weight: 500;\r\n    text-decoration: none;\r\n    font-size: 24px;\r\n    line-height: 40px\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-navbar-logo {\r\n    color: hsla(0, 0%, 100%, .85)\r\n}\r\n\r\n.__dumi-default-navbar-logo:not([data-plaintext]) {\r\n    padding-left: 56px;\r\n    background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIQAAACCCAMAAACww5CIAAACf1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD///8YkP8AAAACCxMamv/6+voaGhoXi/YYjv8aoP8cq/8dr/8bo/8cqP8bpv8Ykv8drv8BAwUcrP8Zlf8Xjf/s7OzLy8scp/8anP8ZmP/d3d0BBArg4ODT09O7u7sEGCsKCgoanf8YlP/8/Pz09PTIyMgMTIV1dXUGKEVEREQ0NDQODg4GBgYdsv8dsf8Zl//m5uYVgOXj4+MWgtfW1tYTc87BwcERbLWzs7Ovr6+np6cQX6OgoKCTk5MMSXlwcHBra2tiYmIVFRUetf/39/fp6ekWhOkXi+QVfNvY2NjPz88TdcUSb7u6urq3t7cPYK0NUJGQkJCLi4ttbW0JO2cINFtVVVVRUVEHMFEHLEs6OjoEHDEiIiIcHBwXj/vx8fEWh+4Sb8gRbL+rq6upqakOVZiWlpaJiYmGhoYMSIF9fX15eXkKPnQLRHJMTExHR0c9PT0FHzkqKiomJiYEFyUBBw8bovfu7u4Wht4UedsUeMrFxcW9vb0RZrOkpKSampoPXZqAgIALQmtlZWUJOGJZWVkIMFcFIUExMTEwMDAtLS0DEh8Zl/v4+PgXj/QWhvEWhvAYku8YjuwUfNcUfNAVfc0RaLkSaKsRZ6kPWqENUYlbW1sCEBhkSPCkAAAAOHRSTlMA87y4BeKrltbFnUDo0MCup6D67t7ayZKGemtmWS8rEwLNso1wVEpFGaR+UDUlHwmBYls5i1oN/DMym4YAAAfTSURBVHjaxNndS1NxHMfxX5s6t1Kz1KzsuazMnqjgyxv03ovtQrYxUBEfLkREVBQf0AsFBRUUQvEiSVFQ0YsuiiIiqKC/oH+o31lzjtPZg55zttfVNnbx5ffw+X53pmx5UFl2+XLZ4zpVOPWlJFTntYyiBwF/VbX39Sv9upYU9/QHjbXe6qqayrrnylXXi0kov3GVuFiMuNqbHhIu3FcuuohZZ+jDh7mdXkwqlGtKMGmOSFzrGiYe5ZL4+vdsd/SHFyYxtIQlIdiD4ftCa39osTlxRtzwHO1tUOLm0XYk6T3asMRtdKHdUs6qv+L1l/vKgak2SYjqN+1yYg2G5NgR4Pd5/F7fk9sO3YhSkoYkaW40KCk2Rj9KUoikqmtOn8YpydE6J7xFyq5yUhxIjvZJcUfZ5EOb6oxGQmPdtEQlR4Mxupc6IoOdzWiVypabaF1BiesIS876OiSufRXtvO0DcSi2dAN+ZcclYFZsCaOps3nYUOKprDTiSWzqAioCnpIX9ep03pxkw7jYtMWx0pdn7Jb2i1jixN3cM6OGFCti0zgpyopOsw6xiZHoyHIPLIhNHdD7bWR+c7znFD3+PNp+vxhmRkNi28BoWAzBPbQHKhdlQLe4ogsoVTl4ijYjrmiKATdUdvfjh9Ely8DVHFvWe3HJMBBQ2QWAd+KSeeBxjtuxKC7ZzG07Ht0DusQlfwDfs2wZ4b2EYVBcESHO81BlcIWESXHFV7Qss5aXY1FxRSj7L7QAhv3tsaVBMVn8Ou1MFUtjW3sYKjL0jO6QWJiA7iZxysBbtDplpRT4KZbQWkUbHRMnGFUUKwuNaH1iaRJ+Tf8bDbqcWJH2HuCV+l9DpkuxtdsuGlpYHNAJ1FqNMjnE9QocOXJCPwJ309zPT9la8e5yUJwwC/jTBNWQ5EkIqEyzHROSJzvWSeFDW5M8OUArsdgMq2EmanOyGB4WSyMYAhZp2TwkJouw2mZvmusUSwtraA//m7DXZ8SsBxiQM5tGSxNuv3+ZU/NmIpfN9qDXxp1sO4LDNrE202J6cHE1TVq2f1uNiA39K9/7JJ0JwGe6nvOSZ4OA1/R0bFbyrBWoMUX2nOTZAOA3pcSXjFW7UOJnU17VAYeZv98pTvsB1KsTRVXAtqQVA/rFWSNo11SKiuRYZeknEBRn7WJ4rZKuX8pcROvBj6g4rLUZQ8NJYBo2Jb/ax2KkhKYf6I1I3oWngKqUhfgkBTCL1pics1elICaS/5Y9jk+XBdEBeJKhHZGCCLZAWTIkBqQgNlr+NbGi2wHgS1tTAbQNAxW3i1R58WWgd725ANZ7gXPFNaqagrvwt1t7aW0qiOIAPlErPqJCq6JWrW8r1ar1xf0n4NxnnpCELEKyCNmkJZSQRSCbQltooS4sVApiC10U2kWhFRUEEdGF4vuNH8g7c9NQ2pjepPcB/r5ADjlnzp2ZM+QMXHeYb+1WfO5hi5QfveYe33XJ4+d8a3MNQHbI75KhMt9z9wF4FRNcIi3wO94bAHJiQHCHNgmgh3QD8D1MCK6I+KeNCUgbgFFRcEX8Qwhov014o/juUlEoxeqrgpsA7oWp4AZprnpv1ANgShFcoU4a+36jMgOuVGYmnuJ1Wb0hKWqCC8QCgI4dqyfRbNCFoqDBX7Xz6C0AS660K3UKQCdhuqAbdqFT+B8mAXQTbhtbpM7ng4Yn1oytOwFMu5AP9QGAa4Qz8lFwvFWIH6G7Qjijc8/LDueDyvd4z151EYBvwOF+lRFTAK6TGi+ACWdLk0ozANqvkpojAFJKRnCSlFt3m8pLc9bJTylVn64ty9rJfEl1cpVKbH3uJ2v1QleUqOCI2h9xeeP0aVqLCA4JSLk6s7hu6CbkqOAIGpyB7iRZ5xLvFWlHEkITyjK/41/v9h0AC3lngpCz0PXWf0yDUcmBhFDt0T/flx8CkNL8VLAZjUhvAHSQek5AtyALdqP5e9BdbPCkZsbuFRKVvlRHs/W1AfC902yNgoriWwCeqw1fSL+J2VkWNBF8vckr6mPQ3ZcjtkVBA/3z4Ju6Bs5ANzck2BQFpUMTxlVZQ4ege95vUxRUHoPOe5s01OWBbryf2hEFDX4Fc4Vs4gaYZ3ZEQeXBJPgMcFPnwYzJVmeE6jGsGCNAE/rAlPIBamkMQv9YCLpzxJRjYMr5BLXyg5EvgTlKTOoEkw2LUct6dTz4ojqCNO04mMm4ZE150mhMuQ+jHppwAUxqUM5QK9qkPLIE5jhpygkvmHJYiW45FaL8IwmdZy9pUtc2MK9HtvgloZngJyMVp3tJ846ASb7Q1NYrg1JN+ukDs4e05LwHTO5bUKG0tRBEeXAKzJ3rpEXdB8C9fBIWKW0hhOBIBdy2K6R11zvALY6EFYE21yHF4OdKEkz7ObIlXXvAhV4OquoApaYbpCo9qayA29lLturibhimSgOSFjG1ILRwYnwShn09xArnT8PwdnHML6n+hl+2gD8Wjj+rLMOwq49Y5dZpVKUWS++VcCwdCdT5/Uhck5SH45VpVO3qJFbq2Y5Vvly2VBgQY5KqKWI6HY+n06KiqVJMSQyP/37wB6v29xGrnThyEDWh5dyr+fJscbQw/OjRcGG0OFvO3n+QSqKm7exlYgsvNgolkyFs1HGV2OQgTGsjNjnVBtO8Owj3nwbhgWnttgWxy2PaoWaC+AuAXqWYKHupMgAAAABJRU5ErkJggg==\") no-repeat 0/contain\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n    .__dumi-default-navbar-logo {\r\n        height: 28px;\r\n        line-height: 28px\r\n    }\r\n\r\n    .__dumi-default-navbar-logo:not([data-plaintext]) {\r\n        padding-left: 36px\r\n    }\r\n}\r\n\r\n.__dumi-default-navbar-tool {\r\n    display: inline-block\r\n}\r\n\r\n.__dumi-default-navbar nav>span {\r\n    position: relative;\r\n    margin-left: 40px;\r\n    display: inline-block;\r\n    color: #454d64;\r\n    height: 64px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    line-height: 64px;\r\n    text-decoration: none;\r\n    letter-spacing: 0\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-navbar nav>span {\r\n    color: hsla(0, 0%, 100%, .85)\r\n}\r\n\r\n.__dumi-default-navbar nav>span>a {\r\n    color: #4d5164;\r\n    text-decoration: none\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-navbar nav>span>a {\r\n    color: hsla(0, 0%, 100%, .85)\r\n}\r\n\r\n.__dumi-default-navbar nav>span>a.active,\r\n.__dumi-default-navbar nav>span>a:hover {\r\n    color: #4569d4\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-navbar nav>span>a.active,\r\n[data-prefers-color=dark] .__dumi-default-navbar nav>span>a:hover {\r\n    color: #7395f7\r\n}\r\n\r\n.__dumi-default-navbar nav>span>a:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    right: -18px;\r\n    left: -18px\r\n}\r\n\r\n.__dumi-default-navbar nav>span>a.active:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: -2px;\r\n    right: -2px;\r\n    height: 2px;\r\n    background-color: #4569d4;\r\n    border-radius: 1px\r\n}\r\n\r\n.__dumi-default-navbar nav>span+:not(a) {\r\n    margin-left: 40px\r\n}\r\n\r\n.__dumi-default-navbar nav>span>ul {\r\n    list-style: none;\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 50%;\r\n    margin: 0;\r\n    min-width: 100px;\r\n    padding: 8px 18px;\r\n    line-height: 2;\r\n    background-color: #fff;\r\n    box-shadow: 0 8px 24px -2px rgba(0, 0, 0, .08);\r\n    transform: translate(-50%);\r\n    transform-origin: top;\r\n    border-radius: 1px;\r\n    transition: all .2s\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-navbar nav>span>ul {\r\n    background-color: #141414\r\n}\r\n\r\n.__dumi-default-navbar nav>span>ul a {\r\n    position: relative;\r\n    display: block;\r\n    color: #454d64;\r\n    text-decoration: none\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-navbar nav>span>ul a {\r\n    color: hsla(0, 0%, 100%, .85)\r\n}\r\n\r\n.__dumi-default-navbar nav>span>ul a.active,\r\n.__dumi-default-navbar nav>span>ul a:hover {\r\n    color: #4569d4\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-navbar nav>span>ul a.active,\r\n[data-prefers-color=dark] .__dumi-default-navbar nav>span>ul a:hover {\r\n    color: #7395f7\r\n}\r\n\r\n.__dumi-default-navbar nav>span:not(:hover)>ul {\r\n    visibility: hidden;\r\n    pointer-events: none;\r\n    transform: translate(-50%) scaleY(.9);\r\n    opacity: 0\r\n}\r\n\r\n.__dumi-default-navbar nav .__dumi-default-search+.__dumi-default-locale-select {\r\n    margin-left: 40px\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n\r\n    .__dumi-default-navbar nav>a,\r\n    .__dumi-default-navbar nav>div,\r\n    .__dumi-default-navbar nav>span {\r\n        display: none\r\n    }\r\n}\r\n\r\n.__dumi-default-navbar[data-mode=site] {\r\n    display: flex\r\n}\r\n\r\n.__dumi-default-locale-select {\r\n    position: relative;\r\n    display: inline-block;\r\n    border: 1px solid #dadadf;\r\n    border-radius: 14px;\r\n    transition: background .2s\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-locale-select {\r\n    border: 1px solid #464646\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n    .__dumi-default-locale-select {\r\n        margin-top: 6px\r\n    }\r\n}\r\n\r\n.__dumi-default-locale-select:hover {\r\n    background-color: #fafafa\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-locale-select:hover {\r\n    background-color: hsla(0, 0%, 100%, .1)\r\n}\r\n\r\n.__dumi-default-locale-select:not([data-locale-count=\"1\"]):not([data-locale-count=\"2\"]):after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 10px;\r\n    margin-top: -3px;\r\n    width: 0;\r\n    height: 0;\r\n    border: 4px solid transparent;\r\n    border-top: 6px solid #7b7f8d;\r\n    pointer-events: none\r\n}\r\n\r\n.__dumi-default-locale-select a,\r\n.__dumi-default-locale-select select,\r\n.__dumi-default-locale-select span {\r\n    padding: 0 24px 0 16px;\r\n    height: 28px;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    line-height: 28px;\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none;\r\n    border: 0;\r\n    font-size: 16px;\r\n    color: #7b7f8d;\r\n    background: transparent;\r\n    outline: none;\r\n    cursor: pointer\r\n}\r\n\r\n.__dumi-default-locale-select a,\r\n.__dumi-default-locale-select span {\r\n    padding-right: 16px\r\n}\r\n\r\n.__dumi-default-search {\r\n    margin-left: 20px;\r\n    position: relative;\r\n    display: inline-block\r\n}\r\n\r\n.__dumi-default-search-input {\r\n    width: 200px;\r\n    height: 32px;\r\n    padding: 0 38px 0 14px;\r\n    color: #454d64;\r\n    font-size: 14px;\r\n    border: 0;\r\n    outline: none;\r\n    transition: all .2s;\r\n    border-radius: 16px;\r\n    background: url(\"data:image/png;base64,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\") #f5f6f7 no-repeat right 14px center/16px;\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-search-input {\r\n    color: hsla(0, 0%, 100%, .65);\r\n    background: url(\"data:image/png;base64,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\") hsla(0, 0%, 100%, .12156862745098039) no-repeat right 14px center/16px\r\n}\r\n\r\n.__dumi-default-search-input:focus {\r\n    box-shadow: inset 0 0 0 1px rgba(69, 105, 212, .2)\r\n}\r\n\r\n.__dumi-default-search-input:not(:focus)+ul:not(:hover) {\r\n    visibility: hidden\r\n}\r\n\r\n.__dumi-default-search>ul {\r\n    list-style: none;\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    z-index: 10;\r\n    margin: 8px 0 0;\r\n    min-width: 280px;\r\n    max-width: 400px;\r\n    max-height: 230px;\r\n    padding: 6px 0;\r\n    background-color: #fff;\r\n    border: 1px solid #ebedf1;\r\n    border-radius: 1px;\r\n    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, .05);\r\n    box-sizing: border-box;\r\n    overflow-y: auto\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-search>ul {\r\n    border: none;\r\n    background-color: #141414;\r\n    box-shadow: 0 3px 6px -4px rgba(0, 0, 0, .48), 0 6px 16px 0 rgba(0, 0, 0, .32), 0 9px 28px 8px rgba(0, 0, 0, .2)\r\n}\r\n\r\n.__dumi-default-search>ul:empty {\r\n    display: none\r\n}\r\n\r\n.__dumi-default-search>ul li {\r\n    font-size: 15px\r\n}\r\n\r\n.__dumi-default-search>ul li a {\r\n    display: block;\r\n    padding: 6px 20px;\r\n    color: #717484;\r\n    text-decoration: none;\r\n    line-height: 1.5715;\r\n    transition: background-color .3s;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-search>ul li a {\r\n    color: hsla(0, 0%, 100%, .65)\r\n}\r\n\r\n.__dumi-default-search>ul li a:hover {\r\n    color: #4569d4;\r\n    background-color: #f9fafb\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-search>ul li a:hover {\r\n    color: #7395f7;\r\n    background-color: hsla(0, 0%, 100%, .08)\r\n}\r\n\r\n.__dumi-default-search>ul li span:first-child:not(.__dumi-default-search-highlight) {\r\n    position: relative;\r\n    display: inline-block;\r\n    max-width: 50%;\r\n    padding-right: 26px;\r\n    vertical-align: bottom;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    opacity: .8\r\n}\r\n\r\n.__dumi-default-search>ul li span:first-child:not(.__dumi-default-search-highlight):after {\r\n    content: \">\";\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 6px;\r\n    opacity: .6;\r\n    transform: translateY(-54%)\r\n}\r\n\r\n.__dumi-default-search-empty {\r\n    margin: 6px 0;\r\n    opacity: .6;\r\n    fill: #454d64\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-search-empty {\r\n    fill: hsla(0, 0%, 100%, .85)\r\n}\r\n\r\n.__dumi-default-search-highlight {\r\n    padding: 2px 0;\r\n    color: #736b2d;\r\n    vertical-align: bottom;\r\n    background: #fff9cb\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-search-highlight {\r\n    color: #454d64\r\n}\r\n\r\n@media only screen and (max-width:1024px) {\r\n    .__dumi-default-search {\r\n        margin-right: -14px\r\n    }\r\n\r\n    .__dumi-default-search>input:not(:focus) {\r\n        color: transparent;\r\n        width: 32px;\r\n        padding-right: 0;\r\n        box-shadow: none;\r\n        cursor: pointer;\r\n        background-position: right 8px center\r\n    }\r\n\r\n    .__dumi-default-search>input:not(:focus)+ul {\r\n        transition: visibility .1s;\r\n        visibility: hidden\r\n    }\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n    .__dumi-default-search {\r\n        position: absolute;\r\n        top: 9px;\r\n        right: 24px;\r\n        display: block !important\r\n    }\r\n\r\n    .__dumi-default-search>ul {\r\n        right: 0;\r\n        left: auto\r\n    }\r\n}\r\n\r\n.__dumi-default-dark {\r\n    position: fixed;\r\n    right: 20px;\r\n    top: 16px\r\n}\r\n\r\n[data-mode=doc] .__dumi-default-dark {\r\n    position: relative;\r\n    top: 0;\r\n    right: 0;\r\n    display: inline-block\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n    .__dumi-default-dark {\r\n        position: relative;\r\n        top: 6px;\r\n        right: auto;\r\n        display: flex;\r\n        justify-content: center\r\n    }\r\n\r\n    .__dumi-default-navbar .__dumi-default-dark {\r\n        display: none\r\n    }\r\n}\r\n\r\n.__dumi-default-dark-auto,\r\n.__dumi-default-dark-moon,\r\n.__dumi-default-dark-sun {\r\n    position: relative;\r\n    border-radius: 50%;\r\n    outline: none;\r\n    cursor: pointer;\r\n    width: 30px;\r\n    height: 30px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center\r\n}\r\n\r\n.__dumi-default-dark-auto svg,\r\n.__dumi-default-dark-moon svg,\r\n.__dumi-default-dark-sun svg {\r\n    transition: all .3s linear\r\n}\r\n\r\n.__dumi-default-dark-auto svg:hover,\r\n.__dumi-default-dark-moon svg:hover,\r\n.__dumi-default-dark-sun svg:hover {\r\n    transform: scale(1.2)\r\n}\r\n\r\n.__dumi-default-dark-auto,\r\n.__dumi-default-dark-moon,\r\n.__dumi-default-dark-sun {\r\n    border: 1px solid #dadadf;\r\n    background-color: #f9fafb\r\n}\r\n\r\n.__dumi-default-dark-auto svg,\r\n.__dumi-default-dark-moon svg,\r\n.__dumi-default-dark-sun svg {\r\n    fill: #454d64\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-dark-auto svg,\r\n[data-prefers-color=dark] .__dumi-default-dark-moon svg,\r\n[data-prefers-color=dark] .__dumi-default-dark-sun svg {\r\n    fill: hsla(0, 0%, 100%, .85)\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-dark-auto,\r\n[data-prefers-color=dark] .__dumi-default-dark-moon,\r\n[data-prefers-color=dark] .__dumi-default-dark-sun {\r\n    border-color: #464646;\r\n    background-color: #141414\r\n}\r\n\r\n[data-mode=doc] .__dumi-default-dark-switch {\r\n    display: flex\r\n}\r\n\r\n[data-mode=doc] .__dumi-default-dark-switch button+button {\r\n    margin-left: 4px\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n    .__dumi-default-dark-switch {\r\n        display: flex\r\n    }\r\n\r\n    .__dumi-default-dark-switch button+button {\r\n        margin-left: 10px\r\n    }\r\n}\r\n\r\n.__dumi-default-menu .__dumi-default-dark-switch-active {\r\n    border-color: #4569d4\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-menu .__dumi-default-dark-switch-active {\r\n    border-color: #7395f7\r\n}\r\n\r\n[data-mode=doc][data-mobile-show=true] .__dumi-default-dark-switch {\r\n    margin-bottom: 10px\r\n}\r\n\r\n.__dumi-default-dark-switch button {\r\n    z-index: 102\r\n}\r\n\r\n.__dumi-default-dark-switch-list {\r\n    animation: dropDown .2s linear 0s 1\r\n}\r\n\r\n.__dumi-default-dark-switch-list button {\r\n    z-index: 101;\r\n    margin-top: 4px\r\n}\r\n\r\n[data-mode=doc] .__dumi-default-dark-switch-list {\r\n    position: absolute\r\n}\r\n\r\n@keyframes dropDown {\r\n    0% {\r\n        margin-top: -100%\r\n    }\r\n\r\n    to {\r\n        margin-top: 0\r\n    }\r\n}\r\n\r\n.__dumi-default-menu {\r\n    position: fixed;\r\n    z-index: 100;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    width: 260px;\r\n    background-color: #f2f5fa;\r\n    box-sizing: border-box;\r\n    transition: left .3s\r\n}\r\n\r\n.__dumi-default-menu[data-hidden] {\r\n    display: none\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n    .__dumi-default-menu {\r\n        left: -240px;\r\n        top: 50px;\r\n        display: block !important;\r\n        width: 240px;\r\n        background-color: #fff\r\n    }\r\n\r\n    .__dumi-default-menu[data-mobile-show] {\r\n        left: 0\r\n    }\r\n\r\n    [data-prefers-color=dark] .__dumi-default-menu {\r\n        background-color: #141414\r\n    }\r\n}\r\n\r\n.__dumi-default-menu:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    display: block;\r\n    width: 20px;\r\n    background: linear-gradient(90deg, transparent, rgba(0, 0, 0, .03));\r\n    pointer-events: none\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n    .__dumi-default-menu:after {\r\n        width: 1px;\r\n        background: #ebedf1\r\n    }\r\n}\r\n\r\n.__dumi-default-menu-header {\r\n    position: relative;\r\n    padding-top: 40px;\r\n    text-align: center;\r\n    border-bottom: 1px solid #ebedf1\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-menu-header {\r\n    border-color: #6b6c6d\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n    .__dumi-default-menu-header {\r\n        display: none\r\n    }\r\n}\r\n\r\n.__dumi-default-menu-header .__dumi-default-menu-logo {\r\n    display: inline-block;\r\n    width: 66px;\r\n    height: 65px;\r\n    background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIQAAACCCAMAAACww5CIAAACf1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD///8YkP8AAAACCxMamv/6+voaGhoXi/YYjv8aoP8cq/8dr/8bo/8cqP8bpv8Ykv8drv8BAwUcrP8Zlf8Xjf/s7OzLy8scp/8anP8ZmP/d3d0BBArg4ODT09O7u7sEGCsKCgoanf8YlP/8/Pz09PTIyMgMTIV1dXUGKEVEREQ0NDQODg4GBgYdsv8dsf8Zl//m5uYVgOXj4+MWgtfW1tYTc87BwcERbLWzs7Ovr6+np6cQX6OgoKCTk5MMSXlwcHBra2tiYmIVFRUetf/39/fp6ekWhOkXi+QVfNvY2NjPz88TdcUSb7u6urq3t7cPYK0NUJGQkJCLi4ttbW0JO2cINFtVVVVRUVEHMFEHLEs6OjoEHDEiIiIcHBwXj/vx8fEWh+4Sb8gRbL+rq6upqakOVZiWlpaJiYmGhoYMSIF9fX15eXkKPnQLRHJMTExHR0c9PT0FHzkqKiomJiYEFyUBBw8bovfu7u4Wht4UedsUeMrFxcW9vb0RZrOkpKSampoPXZqAgIALQmtlZWUJOGJZWVkIMFcFIUExMTEwMDAtLS0DEh8Zl/v4+PgXj/QWhvEWhvAYku8YjuwUfNcUfNAVfc0RaLkSaKsRZ6kPWqENUYlbW1sCEBhkSPCkAAAAOHRSTlMA87y4BeKrltbFnUDo0MCup6D67t7ayZKGemtmWS8rEwLNso1wVEpFGaR+UDUlHwmBYls5i1oN/DMym4YAAAfTSURBVHjaxNndS1NxHMfxX5s6t1Kz1KzsuazMnqjgyxv03ovtQrYxUBEfLkREVBQf0AsFBRUUQvEiSVFQ0YsuiiIiqKC/oH+o31lzjtPZg55zttfVNnbx5ffw+X53pmx5UFl2+XLZ4zpVOPWlJFTntYyiBwF/VbX39Sv9upYU9/QHjbXe6qqayrrnylXXi0kov3GVuFiMuNqbHhIu3FcuuohZZ+jDh7mdXkwqlGtKMGmOSFzrGiYe5ZL4+vdsd/SHFyYxtIQlIdiD4ftCa39osTlxRtzwHO1tUOLm0XYk6T3asMRtdKHdUs6qv+L1l/vKgak2SYjqN+1yYg2G5NgR4Pd5/F7fk9sO3YhSkoYkaW40KCk2Rj9KUoikqmtOn8YpydE6J7xFyq5yUhxIjvZJcUfZ5EOb6oxGQmPdtEQlR4Mxupc6IoOdzWiVypabaF1BiesIS876OiSufRXtvO0DcSi2dAN+ZcclYFZsCaOps3nYUOKprDTiSWzqAioCnpIX9ep03pxkw7jYtMWx0pdn7Jb2i1jixN3cM6OGFCti0zgpyopOsw6xiZHoyHIPLIhNHdD7bWR+c7znFD3+PNp+vxhmRkNi28BoWAzBPbQHKhdlQLe4ogsoVTl4ijYjrmiKATdUdvfjh9Ely8DVHFvWe3HJMBBQ2QWAd+KSeeBxjtuxKC7ZzG07Ht0DusQlfwDfs2wZ4b2EYVBcESHO81BlcIWESXHFV7Qss5aXY1FxRSj7L7QAhv3tsaVBMVn8Ou1MFUtjW3sYKjL0jO6QWJiA7iZxysBbtDplpRT4KZbQWkUbHRMnGFUUKwuNaH1iaRJ+Tf8bDbqcWJH2HuCV+l9DpkuxtdsuGlpYHNAJ1FqNMjnE9QocOXJCPwJ309zPT9la8e5yUJwwC/jTBNWQ5EkIqEyzHROSJzvWSeFDW5M8OUArsdgMq2EmanOyGB4WSyMYAhZp2TwkJouw2mZvmusUSwtraA//m7DXZ8SsBxiQM5tGSxNuv3+ZU/NmIpfN9qDXxp1sO4LDNrE202J6cHE1TVq2f1uNiA39K9/7JJ0JwGe6nvOSZ4OA1/R0bFbyrBWoMUX2nOTZAOA3pcSXjFW7UOJnU17VAYeZv98pTvsB1KsTRVXAtqQVA/rFWSNo11SKiuRYZeknEBRn7WJ4rZKuX8pcROvBj6g4rLUZQ8NJYBo2Jb/ax2KkhKYf6I1I3oWngKqUhfgkBTCL1pics1elICaS/5Y9jk+XBdEBeJKhHZGCCLZAWTIkBqQgNlr+NbGi2wHgS1tTAbQNAxW3i1R58WWgd725ANZ7gXPFNaqagrvwt1t7aW0qiOIAPlErPqJCq6JWrW8r1ar1xf0n4NxnnpCELEKyCNmkJZSQRSCbQltooS4sVApiC10U2kWhFRUEEdGF4vuNH8g7c9NQ2pjepPcB/r5ADjlnzp2ZM+QMXHeYb+1WfO5hi5QfveYe33XJ4+d8a3MNQHbI75KhMt9z9wF4FRNcIi3wO94bAHJiQHCHNgmgh3QD8D1MCK6I+KeNCUgbgFFRcEX8Qwhov014o/juUlEoxeqrgpsA7oWp4AZprnpv1ANgShFcoU4a+36jMgOuVGYmnuJ1Wb0hKWqCC8QCgI4dqyfRbNCFoqDBX7Xz6C0AS660K3UKQCdhuqAbdqFT+B8mAXQTbhtbpM7ng4Yn1oytOwFMu5AP9QGAa4Qz8lFwvFWIH6G7Qjijc8/LDueDyvd4z151EYBvwOF+lRFTAK6TGi+ACWdLk0ozANqvkpojAFJKRnCSlFt3m8pLc9bJTylVn64ty9rJfEl1cpVKbH3uJ2v1QleUqOCI2h9xeeP0aVqLCA4JSLk6s7hu6CbkqOAIGpyB7iRZ5xLvFWlHEkITyjK/41/v9h0AC3lngpCz0PXWf0yDUcmBhFDt0T/flx8CkNL8VLAZjUhvAHSQek5AtyALdqP5e9BdbPCkZsbuFRKVvlRHs/W1AfC902yNgoriWwCeqw1fSL+J2VkWNBF8vckr6mPQ3ZcjtkVBA/3z4Ju6Bs5ANzck2BQFpUMTxlVZQ4ege95vUxRUHoPOe5s01OWBbryf2hEFDX4Fc4Vs4gaYZ3ZEQeXBJPgMcFPnwYzJVmeE6jGsGCNAE/rAlPIBamkMQv9YCLpzxJRjYMr5BLXyg5EvgTlKTOoEkw2LUct6dTz4ojqCNO04mMm4ZE150mhMuQ+jHppwAUxqUM5QK9qkPLIE5jhpygkvmHJYiW45FaL8IwmdZy9pUtc2MK9HtvgloZngJyMVp3tJ846ASb7Q1NYrg1JN+ukDs4e05LwHTO5bUKG0tRBEeXAKzJ3rpEXdB8C9fBIWKW0hhOBIBdy2K6R11zvALY6EFYE21yHF4OdKEkz7ObIlXXvAhV4OquoApaYbpCo9qayA29lLturibhimSgOSFjG1ILRwYnwShn09xArnT8PwdnHML6n+hl+2gD8Wjj+rLMOwq49Y5dZpVKUWS++VcCwdCdT5/Uhck5SH45VpVO3qJFbq2Y5Vvly2VBgQY5KqKWI6HY+n06KiqVJMSQyP/37wB6v29xGrnThyEDWh5dyr+fJscbQw/OjRcGG0OFvO3n+QSqKm7exlYgsvNgolkyFs1HGV2OQgTGsjNjnVBtO8Owj3nwbhgWnttgWxy2PaoWaC+AuAXqWYKHupMgAAAABJRU5ErkJggg==\") no-repeat 0/contain\r\n}\r\n\r\n.__dumi-default-menu-header h1 {\r\n    margin: 10px 0 0;\r\n    color: #454d64;\r\n    font-weight: 500;\r\n    line-height: 1.40625\r\n}\r\n\r\n.__dumi-default-menu-header p {\r\n    margin: 0 0 5px;\r\n    color: #8c8e9c\r\n}\r\n\r\n.__dumi-default-menu-header p>object[data^=\"https://img.shields.io\"] {\r\n    max-height: 20px\r\n}\r\n\r\n.__dumi-default-menu-header p+p {\r\n    margin-bottom: 10px\r\n}\r\n\r\n.__dumi-default-menu-doc-locale {\r\n    padding: 16px 0;\r\n    text-align: center;\r\n    border-bottom: 1px solid #ebedf1;\r\n    display: flex;\r\n    justify-content: space-evenly\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-menu-doc-locale {\r\n    border-color: #6b6c6d\r\n}\r\n\r\n[data-mode=doc][data-mobile-show=true] .__dumi-default-menu-doc-locale {\r\n    display: grid\r\n}\r\n\r\n.__dumi-default-menu-doc-locale:empty {\r\n    display: none\r\n}\r\n\r\n.__dumi-default-menu-inner {\r\n    width: 100%;\r\n    height: 100%;\r\n    overflow: auto;\r\n    -ms-scroll-chaining: none;\r\n    overscroll-behavior: contain\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-menu-inner {\r\n    background-color: #262626\r\n}\r\n\r\n.__dumi-default-menu-inner ul {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    font-size: 16px\r\n}\r\n\r\n.__dumi-default-menu-inner ul li {\r\n    color: #454d64\r\n}\r\n\r\n.__dumi-default-menu-inner ul li>span,\r\n.__dumi-default-menu-inner ul li a {\r\n    position: relative;\r\n    display: block;\r\n    padding-right: 24px;\r\n    color: #454d64;\r\n    line-height: 2.4;\r\n    text-decoration: none;\r\n    outline: none;\r\n    transition: color .3s, background .3s\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-menu-inner ul li>span,\r\n[data-prefers-color=dark] .__dumi-default-menu-inner ul li a {\r\n    color: hsla(0, 0%, 100%, .85)\r\n}\r\n\r\n.__dumi-default-menu-inner ul li>span span,\r\n.__dumi-default-menu-inner ul li a span {\r\n    display: block;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis\r\n}\r\n\r\n.__dumi-default-menu-inner ul li>span.active,\r\n.__dumi-default-menu-inner ul li>span:hover,\r\n.__dumi-default-menu-inner ul li a.active,\r\n.__dumi-default-menu-inner ul li a:hover {\r\n    color: #4569d4\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-menu-inner ul li>span.active,\r\n[data-prefers-color=dark] .__dumi-default-menu-inner ul li>span:hover,\r\n[data-prefers-color=dark] .__dumi-default-menu-inner ul li a.active,\r\n[data-prefers-color=dark] .__dumi-default-menu-inner ul li a:hover {\r\n    color: #7395f7\r\n}\r\n\r\n.__dumi-default-menu-inner ul li>span:before,\r\n.__dumi-default-menu-inner ul li a:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 50%;\r\n    left: -10px;\r\n    margin-top: -2.5px;\r\n    display: inline-block;\r\n    width: 5px;\r\n    height: 5px;\r\n    background-color: #4569d4;\r\n    border-radius: 50%;\r\n    opacity: 0;\r\n    transition: transform .2s, opacity .2s;\r\n    transform: scale(0) translateX(-10px)\r\n}\r\n\r\n.__dumi-default-menu-inner ul li.active a:before,\r\n.__dumi-default-menu-inner ul li a.active:before {\r\n    opacity: 1;\r\n    transform: scale(1) translateX(0)\r\n}\r\n\r\n.__dumi-default-menu-inner ul li ul {\r\n    font-size: .9em;\r\n    padding-left: 1em\r\n}\r\n\r\n.__dumi-default-menu-inner>ul>li>a {\r\n    line-height: 2.875\r\n}\r\n\r\n.__dumi-default-menu-inner>ul>li>a:not([href]) {\r\n    padding-top: 24px;\r\n    line-height: 1;\r\n    font-weight: 500;\r\n    color: #454d64 !important;\r\n    background: transparent !important;\r\n    cursor: default\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-menu-inner>ul>li>a:not([href]) {\r\n    color: hsla(0, 0%, 100%, .85) !important\r\n}\r\n\r\n.__dumi-default-menu-inner>ul>li:first-child>a:not([href]) {\r\n    padding-top: 0\r\n}\r\n\r\n.__dumi-default-menu-inner>ul ul a {\r\n    color: #717484\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-menu-inner>ul ul a {\r\n    color: hsla(0, 0%, 100%, .65)\r\n}\r\n\r\n.__dumi-default-menu-inner>ul ul a.active {\r\n    color: #4569d4\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-menu-inner>ul ul a.active {\r\n    color: #7395f7\r\n}\r\n\r\n.__dumi-default-menu-inner .__dumi-default-menu-mobile-area {\r\n    display: none;\r\n    padding-bottom: 16px;\r\n    margin-bottom: 16px;\r\n    text-align: center;\r\n    border-bottom: 1px solid #ebedf1\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-menu-inner .__dumi-default-menu-mobile-area {\r\n    border-color: #6b6c6d\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n    .__dumi-default-menu-inner .__dumi-default-menu-mobile-area {\r\n        display: block\r\n    }\r\n}\r\n\r\n.__dumi-default-menu-inner .__dumi-default-menu-nav-list {\r\n    padding: 16px 0 0\r\n}\r\n\r\n.__dumi-default-menu-inner .__dumi-default-menu-nav-list>li,\r\n.__dumi-default-menu-inner .__dumi-default-menu-nav-list>li>a {\r\n    padding-right: 0;\r\n    line-height: 2.4\r\n}\r\n\r\n.__dumi-default-menu-inner .__dumi-default-menu-nav-list>li>a ul,\r\n.__dumi-default-menu-inner .__dumi-default-menu-nav-list>li ul {\r\n    padding-left: 0\r\n}\r\n\r\n.__dumi-default-menu-inner .__dumi-default-menu-nav-list>li>a ul a,\r\n.__dumi-default-menu-inner .__dumi-default-menu-nav-list>li ul a {\r\n    padding-right: 0;\r\n    font-size: 90%\r\n}\r\n\r\n.__dumi-default-menu-inner .__dumi-default-menu-list {\r\n    padding: 8px 0;\r\n    margin-bottom: 40px\r\n}\r\n\r\n.__dumi-default-menu-inner .__dumi-default-menu-list>li>a {\r\n    padding-left: 28px\r\n}\r\n\r\n.__dumi-default-menu-inner .__dumi-default-menu-list>li>a.active {\r\n    background: linear-gradient(270deg, #e8ecf4, rgba(232, 236, 244, 0))\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-menu-inner .__dumi-default-menu-list>li>a.active {\r\n    background: linear-gradient(270deg, #3d3d3e, hsla(0, 0%, 100%, .06))\r\n}\r\n\r\n.__dumi-default-menu-inner .__dumi-default-menu-list>li>a~ul {\r\n    margin-top: 8px;\r\n    margin-left: 28px\r\n}\r\n\r\n@media only screen and (max-width:767px) {\r\n    .__dumi-default-menu-inner .__dumi-default-menu-list>li>a {\r\n        padding-left: 16px\r\n    }\r\n\r\n    .__dumi-default-menu-inner .__dumi-default-menu-list>li>a~ul {\r\n        margin-left: 16px\r\n    }\r\n}\r\n\r\n.__dumi-default-menu[data-mode=site]:after {\r\n    width: 1px;\r\n    background: #ebedf1\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-menu[data-mode=site]:after {\r\n    background: #6b6c6d\r\n}\r\n\r\n.__dumi-default-menu[data-mode=site] .__dumi-default-menu-list {\r\n    padding: 0\r\n}\r\n\r\n.__dumi-default-menu[data-mode=site] .__dumi-default-menu-list>li>a {\r\n    position: relative\r\n}\r\n\r\n.__dumi-default-menu[data-mode=site] .__dumi-default-menu-list>li>a:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    right: 0;\r\n    display: block;\r\n    width: 3px;\r\n    background-color: #4569d4;\r\n    visibility: hidden;\r\n    opacity: 0;\r\n    transition: all .3s;\r\n    border-radius: 1px\r\n}\r\n\r\n.__dumi-default-menu[data-mode=site] .__dumi-default-menu-list>li>a.active {\r\n    z-index: 1;\r\n    background: linear-gradient(270deg, #f8faff, rgba(248, 250, 255, 0))\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-menu[data-mode=site] .__dumi-default-menu-list>li>a.active {\r\n    background: linear-gradient(270deg, #3d3d3e, hsla(0, 0%, 100%, .06))\r\n}\r\n\r\n.__dumi-default-menu[data-mode=site] .__dumi-default-menu-list>li>a.active:after {\r\n    opacity: 1;\r\n    visibility: visible\r\n}\r\n\r\n@media only screen and (min-width:768px) {\r\n    .__dumi-default-menu[data-mode=site] {\r\n        top: 64px;\r\n        width: 300px;\r\n        padding-top: 50px;\r\n        background: transparent\r\n    }\r\n\r\n    [data-prefers-color=dark] .__dumi-default-menu[data-mode=site] {\r\n        background: hsla(0, 0%, 100%, .08)\r\n    }\r\n\r\n    .__dumi-default-menu[data-mode=site] .__dumi-default-menu-header,\r\n    .__dumi-default-menu[data-mode=site] .__dumi-default-menu-nav {\r\n        display: none\r\n    }\r\n\r\n    .__dumi-default-menu[data-mode=site] .__dumi-default-menu-list>li>a {\r\n        padding-left: 58px\r\n    }\r\n\r\n    .__dumi-default-menu[data-mode=site] .__dumi-default-menu-list>li>a~ul {\r\n        margin-left: 58px\r\n    }\r\n}\r\n\r\nul[role=slug-list]:empty {\r\n    margin: 0 !important;\r\n    padding: 0 !important\r\n}\r\n\r\nul[role=slug-list] li>a.active {\r\n    color: #3d62d2\r\n}\r\n\r\nul[role=slug-list] li[data-depth=\"3\"] {\r\n    padding-left: 12px\r\n}\r\n\r\n.__dumi-default-table {\r\n    margin: 16px 0 32px;\r\n    transform: translate(0)\r\n}\r\n\r\n.__dumi-default-table-content {\r\n    overflow: auto\r\n}\r\n\r\n.__dumi-default-table-content:after,\r\n.__dumi-default-table-content:before {\r\n    content: \"\";\r\n    display: block;\r\n    position: fixed;\r\n    z-index: 1;\r\n    top: 0;\r\n    bottom: 0;\r\n    width: 6px;\r\n    pointer-events: none\r\n}\r\n\r\n.__dumi-default-table-content[data-left-folded]:before {\r\n    left: 0;\r\n    background-image: linear-gradient(90deg, rgba(0, 0, 0, .1), transparent)\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-table-content[data-left-folded]:before {\r\n    background-image: linear-gradient(90deg, rgba(0, 0, 0, .5), transparent)\r\n}\r\n\r\n.__dumi-default-table-content[data-right-folded]:after {\r\n    right: 0;\r\n    background-image: linear-gradient(270deg, rgba(0, 0, 0, .1), transparent)\r\n}\r\n\r\n[data-prefers-color=dark] .__dumi-default-table-content[data-right-folded]:after {\r\n    background-image: linear-gradient(270deg, rgba(0, 0, 0, .5), transparent)\r\n}\r\n\r\n.__dumi-default-table-content>table>thead>tr>th,\r\n.__dumi-default-table-content>table>tr>th {\r\n    white-space: nowrap\r\n}","// @import '~styles/index';\r\n\r\n$mobile-width: 768px;\r\n$tablet-width: 1024px;\r\n$desktop-width: 1280px;\r\n\r\n$mobile: \"(max-width: 767px)\";\r\n$tablet: \"(min-width: 768px) and (max-width: 1023px)\";\r\n$desktop: \"(min-width: 1024px)\";\r\n\r\n$black-color: #000000;\r\n$white-color: #ffffff;\r\n\r\n$primary-grey-dark: #313443;\r\n$primary-grey-medium: #41465a;\r\n$primary-grey-light: #f3f3f6;\r\n$primary-grey-semi-light: #e7e8ee;\r\n\r\n$primary-red-color: #d72638;\r\n\r\n@mixin mobile {\r\n    @media (max-width: #{$mobile-width - 1px}) {\r\n        @content;\r\n    }\r\n}\r\n\r\n@mixin tablet {\r\n    @media (min-width: #{$mobile-width}) and (max-width: #{$tablet-width - 1px}) {\r\n        @content;\r\n    }\r\n}\r\n\r\n@mixin mobile-tablet {\r\n    @media (max-width: #{$tablet-width - 1px}) {\r\n        @content;\r\n    }\r\n}\r\n\r\n@mixin desktop {\r\n    @media (min-width: #{$tablet-width}) {\r\n        @content;\r\n    }\r\n}\r\n\r\n\r\n\r\n.node-wrapper {\r\n    white-space: pre;\r\n\r\n    &.default-color {\r\n        &:hover {\r\n            background-color: rgba($primary-red-color, 0.3) !important;\r\n        }\r\n    }\r\n\r\n    &.white-color {\r\n        &:hover {\r\n            background-color: rgba($white-color, 0.5) !important;\r\n        }\r\n    }\r\n\r\n    &.gray-color {\r\n        &:hover {\r\n            background-color: rgba($primary-grey-medium, 0.5) !important;\r\n        }\r\n    }\r\n}\r\n\r\n.selected-node {\r\n    &.default-color-selected {\r\n        background-color: rgba($primary-red-color, 0.5);\r\n    }\r\n\r\n    &.white-color-selected {\r\n        background-color: rgba($white-color, 0.5);\r\n    }\r\n\r\n    &.gray-color-selected {\r\n        background-color: rgba($primary-grey-medium, 0.5);\r\n    }\r\n}\r\n\r\n\r\n.tree-node {\r\n    display: flex;\r\n    align-items: center;\r\n    min-height: 40px;\r\n    max-height: 40px;\r\n\r\n    .tree-icon {\r\n        margin-right: 8px;\r\n        border-radius: 50%;\r\n        cursor: pointer;\r\n        background-repeat: no-repeat;\r\n\r\n        &.open-icon {\r\n            // background-image: url('../../icons/plus.svg');\r\n            width: 12px;\r\n            height: 12px;\r\n            background-size: contain;\r\n        }\r\n\r\n        &.close-icon {\r\n            // background-image: url('../../icons/minus.svg');\r\n            width: 12px;\r\n            height: 12px;\r\n            background-size: contain;\r\n        }\r\n\r\n        &.empty-icon {\r\n            // background-image: url('../../icons/empty.svg');\r\n            width: 12px;\r\n            height: 12px;\r\n            background-size: contain;\r\n        }\r\n    }\r\n\r\n    .node-content-wrapper {\r\n        cursor: pointer;\r\n        min-height: 40px;\r\n        max-height: 40px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        background-color: $white-color;\r\n        width: 100%;\r\n        padding: 6px;\r\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\r\n        transition: all 0.2s ease;\r\n\r\n        &:hover {\r\n            background-color: rgba($primary-red-color, 0.1);\r\n        }\r\n\r\n        &.node-selected {\r\n            border-left: 4px solid $primary-red-color;\r\n        }\r\n\r\n        .titles {\r\n            display: flex;\r\n            flex-direction: column;\r\n            align-items: stretch;\r\n\r\n            .node-title {\r\n                font-weight: 600;\r\n            }\r\n\r\n            .node-subtitle {\r\n                margin-top: 4px;\r\n                font-size: 10px;\r\n            }\r\n        }\r\n\r\n        .children-length {\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n            min-width: 24px;\r\n            height: 16px;\r\n            background-color: $primary-red-color;\r\n            color: $white-color;\r\n            padding: 4px;\r\n            font-size: 12px;\r\n            border-radius: 16px;\r\n            margin-left: 12px;\r\n            font-weight: 600;\r\n        }\r\n    }\r\n}\r\n\r\n.tree-wrapper {\r\n    width: 50%;\r\n    padding: 0 0 0 16px;\r\n\r\n    &.simple {\r\n        overflow: auto;\r\n    }\r\n\r\n    @include mobile {\r\n        width: 100%;\r\n        padding: 0 0 0 0;\r\n        margin-top: 16px;\r\n    }\r\n}\r\n\r\n.lib-icon {\r\n    margin-top: 100px;\r\n\r\n    .tree-icon {\r\n        // background-image: url('../../icons/tree.svg');\r\n        background-repeat: no-repeat;\r\n        width: 100px;\r\n        height: 100px;\r\n    }\r\n}\r\n\r\n.code-wrapper {\r\n    display: flex;\r\n    width: 50%;\r\n    background-color: #fff;\r\n    min-height: 480px;\r\n\r\n    @include mobile {\r\n        width: 100%;\r\n    }\r\n\r\n    .line-numbers {\r\n        font-size: 10px;\r\n        line-height: 12px;\r\n        padding-top: 18px;\r\n        color: rgba(#607D8B, 0.5);\r\n        text-align: right;\r\n        margin-left: 8px;\r\n    }\r\n\r\n    .rendered {\r\n        width: 100%;\r\n        line-height: 12px;\r\n\r\n        .code-view {\r\n            white-space: pre-wrap;\r\n            font-size: 10px;\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n\r\n.hljs {\r\n    display: block;\r\n    overflow-x: auto;\r\n    padding: 0.5em;\r\n    color: #607D8B;\r\n}\r\n\r\n.hljs-comment,\r\n.hljs-quote {\r\n    color: #5c6370;\r\n    font-style: italic;\r\n}\r\n\r\n.hljs-doctag,\r\n.hljs-keyword,\r\n.hljs-formula {\r\n    color: rgb(209, 98, 98);\r\n}\r\n\r\n.hljs-section,\r\n.hljs-name,\r\n.hljs-selector-tag,\r\n.hljs-deletion,\r\n.hljs-subst {\r\n    color: #e03f4d;\r\n}\r\n\r\n.hljs-literal {\r\n    color: #56b6c2;\r\n}\r\n\r\n.hljs-string,\r\n.hljs-regexp,\r\n.hljs-addition,\r\n.hljs-attribute,\r\n.hljs-meta-string {\r\n    color: #5c9e2d;\r\n}\r\n\r\n.hljs-built_in,\r\n.hljs-class .hljs-title {\r\n    color: #e6c07b;\r\n}\r\n\r\n.hljs-attr,\r\n.hljs-variable,\r\n.hljs-template-variable,\r\n.hljs-type,\r\n.hljs-selector-class,\r\n.hljs-selector-attr,\r\n.hljs-selector-pseudo,\r\n.hljs-number {\r\n    color: #d19a66;\r\n}\r\n\r\n.hljs-symbol,\r\n.hljs-bullet,\r\n.hljs-link,\r\n.hljs-meta,\r\n.hljs-selector-id,\r\n.hljs-title {\r\n    color: #4c86b6;\r\n}\r\n\r\n.hljs-emphasis {\r\n    font-style: italic;\r\n}\r\n\r\n.hljs-strong {\r\n    font-weight: bold;\r\n}\r\n\r\n.hljs-link {\r\n    text-decoration: underline;\r\n}","%navigation-chevron {\r\n    border-color: $datepicker__muted-color;\r\n    border-style: solid;\r\n    border-width: 3px 3px 0 0;\r\n    content: \"\";\r\n    display: block;\r\n    height: 9px;\r\n    position: absolute;\r\n    top: 6px;\r\n    width: 9px;\r\n  \r\n    &--disabled,\r\n    &--disabled:hover {\r\n      border-color: $datepicker__navigation-disabled-color;\r\n      cursor: default;\r\n    }\r\n  }\r\n  \r\n  %triangle-arrow {\r\n    margin-left: -$datepicker__triangle-size * 0.5;\r\n    position: absolute;\r\n    width: 0;\r\n  \r\n    &::before,\r\n    &::after {\r\n      box-sizing: content-box;\r\n      position: absolute;\r\n      border: $datepicker__triangle-size solid transparent;\r\n      height: 0;\r\n      width: 1px;\r\n      content: \"\";\r\n      z-index: -1;\r\n      border-width: $datepicker__triangle-size;\r\n      left: -$datepicker__triangle-size;\r\n    }\r\n  \r\n    &::before {\r\n      border-bottom-color: $datepicker__border-color;\r\n    }\r\n  }\r\n  \r\n  %triangle-arrow-up {\r\n    @extend %triangle-arrow;\r\n  \r\n    top: 0;\r\n    margin-top: -$datepicker__triangle-size;\r\n  \r\n    &::before,\r\n    &::after {\r\n      border-top: none;\r\n      border-bottom-color: $datepicker__background-color;\r\n    }\r\n  \r\n    &::after {\r\n      top: 0;\r\n    }\r\n  \r\n    &::before {\r\n      top: -1px;\r\n      border-bottom-color: $datepicker__border-color;\r\n    }\r\n  }\r\n  \r\n  %triangle-arrow-down {\r\n    @extend %triangle-arrow;\r\n  \r\n    bottom: 0;\r\n    margin-bottom: -$datepicker__triangle-size;\r\n  \r\n    &::before,\r\n    &::after {\r\n      border-bottom: none;\r\n      border-top-color: #fff;\r\n    }\r\n  \r\n    &::after {\r\n      bottom: 0;\r\n    }\r\n  \r\n    &::before {\r\n      bottom: -1px;\r\n      border-top-color: $datepicker__border-color;\r\n    }\r\n  }\r\n  \r\n\r\n","@import \"variables.scss\";\r\n@import \"mixins.scss\";\r\n\r\n.react-datepicker-wrapper {\r\n  display: inline-block;\r\n  padding: 0;\r\n  border: 0;\r\n  width: 100%;\r\n}\r\n\r\n.react-datepicker {\r\n  font-family: $datepicker__font-family;\r\n  font-size: $datepicker__font-size;\r\n  background-color: #fff;\r\n  color: $datepicker__text-color;\r\n  border: 1px solid $datepicker__border-color;\r\n  border-radius: $datepicker__border-radius;\r\n  display: inline-block;\r\n  position: relative;\r\n}\r\n\r\n.react-datepicker--time-only {\r\n  .react-datepicker__triangle {\r\n    left: 35px;\r\n  }\r\n\r\n  .react-datepicker__time-container {\r\n    border-left: 0;\r\n  }\r\n\r\n  .react-datepicker__time,\r\n  .react-datepicker__time-box {\r\n    border-bottom-left-radius: 0.3rem;\r\n    border-bottom-right-radius: 0.3rem;\r\n  }\r\n}\r\n\r\n.react-datepicker__triangle {\r\n  position: absolute;\r\n  left: 50px;\r\n}\r\n\r\n.react-datepicker-popper {\r\n  z-index: 1;\r\n\r\n  &[data-placement^=\"bottom\"] {\r\n    padding-top: $datepicker__triangle-size + 2px;\r\n\r\n    .react-datepicker__triangle {\r\n      @extend %triangle-arrow-up;\r\n    }\r\n  }\r\n\r\n  &[data-placement=\"bottom-end\"],\r\n  &[data-placement=\"top-end\"] {\r\n    .react-datepicker__triangle {\r\n      left: auto;\r\n      right: 50px;\r\n    }\r\n  }\r\n\r\n  &[data-placement^=\"top\"] {\r\n    padding-bottom: $datepicker__triangle-size + 2px;\r\n\r\n    .react-datepicker__triangle {\r\n      @extend %triangle-arrow-down;\r\n    }\r\n  }\r\n\r\n  &[data-placement^=\"right\"] {\r\n    padding-left: $datepicker__triangle-size;\r\n\r\n    .react-datepicker__triangle {\r\n      left: auto;\r\n      right: 42px;\r\n    }\r\n  }\r\n\r\n  &[data-placement^=\"left\"] {\r\n    padding-right: $datepicker__triangle-size;\r\n\r\n    .react-datepicker__triangle {\r\n      left: 42px;\r\n      right: auto;\r\n    }\r\n  }\r\n}\r\n\r\n.react-datepicker__header {\r\n  text-align: center;\r\n  background-color: $datepicker__background-color;\r\n  border-bottom: 1px solid $datepicker__border-color;\r\n  border-top-left-radius: $datepicker__border-radius;\r\n  padding: 8px 0;\r\n  position: relative;\r\n\r\n  &--time {\r\n    padding-bottom: 8px;\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n\r\n    &:not(&--only) {\r\n      border-top-left-radius: 0;\r\n    }\r\n  }\r\n\r\n  &:not(&--has-time-select) {\r\n    border-top-right-radius: $datepicker__border-radius;\r\n  }\r\n}\r\n\r\n.react-datepicker__year-dropdown-container--select,\r\n.react-datepicker__month-dropdown-container--select,\r\n.react-datepicker__month-year-dropdown-container--select,\r\n.react-datepicker__year-dropdown-container--scroll,\r\n.react-datepicker__month-dropdown-container--scroll,\r\n.react-datepicker__month-year-dropdown-container--scroll {\r\n  display: inline-block;\r\n  margin: 0 2px;\r\n}\r\n\r\n.react-datepicker__current-month,\r\n.react-datepicker-time__header,\r\n.react-datepicker-year-header {\r\n  margin-top: 0;\r\n  color: $datepicker__header-color;\r\n  font-weight: bold;\r\n  font-size: $datepicker__font-size * 1.18;\r\n}\r\n\r\n.react-datepicker-time__header {\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n}\r\n\r\n.react-datepicker__navigation {\r\n  align-items: center;\r\n  background: none;\r\n  display: flex;\r\n  justify-content: center;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  position: absolute;\r\n  top: 2px;\r\n  padding: 0;\r\n  border: none;\r\n  z-index: 1;\r\n  height: $datepicker__navigation-button-size;\r\n  width: $datepicker__navigation-button-size;\r\n  text-indent: -999em;\r\n  overflow: hidden;\r\n\r\n  &--previous {\r\n    left: 2px;\r\n  }\r\n\r\n  &--next {\r\n    right: 2px;\r\n\r\n    &--with-time:not(&--with-today-button) {\r\n      right: 85px;\r\n    }\r\n  }\r\n\r\n  &--years {\r\n    position: relative;\r\n    top: 0;\r\n    display: block;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n\r\n    &-previous {\r\n      top: 4px;\r\n    }\r\n\r\n    &-upcoming {\r\n      top: -4px;\r\n    }\r\n  }\r\n\r\n  &:hover {\r\n    *::before {\r\n      border-color: darken($datepicker__muted-color, 15%);\r\n    }\r\n  }\r\n}\r\n\r\n.react-datepicker__navigation-icon {\r\n  position: relative;\r\n  top: -1px;\r\n  font-size: 20px;\r\n  width: 0;\r\n\r\n  &::before {\r\n    @extend %navigation-chevron;\r\n  }\r\n\r\n  &--next {\r\n    left: -2px;\r\n\r\n    &::before {\r\n      transform: rotate(45deg);\r\n      left: -7px;\r\n    }\r\n  }\r\n\r\n  &--previous {\r\n    right: -2px;\r\n\r\n    &::before {\r\n      transform: rotate(225deg);\r\n      right: -7px;\r\n    }\r\n  }\r\n}\r\n\r\n.react-datepicker__month-container {\r\n  float: left;\r\n}\r\n\r\n.react-datepicker__year {\r\n  margin: $datepicker__margin;\r\n  text-align: center;\r\n\r\n  &-wrapper {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    max-width: 180px;\r\n  }\r\n\r\n  .react-datepicker__year-text {\r\n    display: inline-block;\r\n    width: 4rem;\r\n    margin: 2px;\r\n  }\r\n}\r\n\r\n.react-datepicker__month {\r\n  margin: $datepicker__margin;\r\n  text-align: center;\r\n\r\n  .react-datepicker__month-text,\r\n  .react-datepicker__quarter-text {\r\n    display: inline-block;\r\n    width: 4rem;\r\n    margin: 2px;\r\n  }\r\n}\r\n\r\n.react-datepicker__input-time-container {\r\n  clear: both;\r\n  width: 100%;\r\n  float: left;\r\n  margin: 5px 0 10px 15px;\r\n  text-align: left;\r\n\r\n  .react-datepicker-time__caption {\r\n    display: inline-block;\r\n  }\r\n\r\n  .react-datepicker-time__input-container {\r\n    display: inline-block;\r\n\r\n    .react-datepicker-time__input {\r\n      display: inline-block;\r\n      margin-left: 10px;\r\n\r\n      input {\r\n        width: auto;\r\n      }\r\n\r\n      input[type=\"time\"]::-webkit-inner-spin-button,\r\n      input[type=\"time\"]::-webkit-outer-spin-button {\r\n        -webkit-appearance: none;\r\n        margin: 0;\r\n      }\r\n\r\n      input[type=\"time\"] {\r\n        -moz-appearance: textfield;\r\n      }\r\n    }\r\n\r\n    .react-datepicker-time__delimiter {\r\n      margin-left: 5px;\r\n      display: inline-block;\r\n    }\r\n  }\r\n}\r\n\r\n.react-datepicker__time-container {\r\n  float: right;\r\n  border-left: 1px solid $datepicker__border-color;\r\n  width: 85px;\r\n\r\n  &--with-today-button {\r\n    display: inline;\r\n    border: 1px solid #aeaeae;\r\n    border-radius: 0.3rem;\r\n    position: absolute;\r\n    right: -72px;\r\n    top: 0;\r\n  }\r\n\r\n  .react-datepicker__time {\r\n    position: relative;\r\n    background: white;\r\n    border-bottom-right-radius: 0.3rem;\r\n\r\n    .react-datepicker__time-box {\r\n      width: 85px;\r\n      overflow-x: hidden;\r\n      margin: 0 auto;\r\n      text-align: center;\r\n      border-bottom-right-radius: 0.3rem;\r\n\r\n      ul.react-datepicker__time-list {\r\n        list-style: none;\r\n        margin: 0;\r\n        height: calc(195px + (#{$datepicker__item-size} / 2));\r\n        overflow-y: scroll;\r\n        padding-right: 0;\r\n        padding-left: 0;\r\n        width: 100%;\r\n        box-sizing: content-box;\r\n\r\n        li.react-datepicker__time-list-item {\r\n          height: 30px;\r\n          padding: 5px 10px;\r\n          white-space: nowrap;\r\n\r\n          &:hover {\r\n            cursor: pointer;\r\n            background-color: $datepicker__background-color;\r\n          }\r\n\r\n          &--selected {\r\n            background-color: $datepicker__selected-color;\r\n            color: white;\r\n            font-weight: bold;\r\n\r\n            &:hover {\r\n              background-color: $datepicker__selected-color;\r\n            }\r\n          }\r\n\r\n          &--disabled {\r\n            color: $datepicker__muted-color;\r\n\r\n            &:hover {\r\n              cursor: default;\r\n              background-color: transparent;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.react-datepicker__week-number {\r\n  color: $datepicker__muted-color;\r\n  display: inline-block;\r\n  width: $datepicker__item-size;\r\n  line-height: $datepicker__item-size;\r\n  text-align: center;\r\n  margin: $datepicker__day-margin;\r\n\r\n  &.react-datepicker__week-number--clickable {\r\n    cursor: pointer;\r\n\r\n    &:hover {\r\n      border-radius: $datepicker__border-radius;\r\n      background-color: $datepicker__background-color;\r\n    }\r\n  }\r\n}\r\n\r\n.react-datepicker__day-names,\r\n.react-datepicker__week {\r\n  white-space: nowrap;\r\n}\r\n\r\n.react-datepicker__day-names {\r\n  margin-bottom: -8px;\r\n}\r\n\r\n.react-datepicker__day-name,\r\n.react-datepicker__day,\r\n.react-datepicker__time-name {\r\n  color: $datepicker__text-color;\r\n  display: inline-block;\r\n  width: $datepicker__item-size;\r\n  line-height: $datepicker__item-size;\r\n  text-align: center;\r\n  margin: $datepicker__day-margin;\r\n}\r\n\r\n.react-datepicker__month,\r\n.react-datepicker__quarter {\r\n  &--selected,\r\n  &--in-selecting-range,\r\n  &--in-range {\r\n    border-radius: $datepicker__border-radius;\r\n    background-color: $datepicker__selected-color;\r\n    color: #fff;\r\n\r\n    &:hover {\r\n      background-color: darken($datepicker__selected-color, 5%);\r\n    }\r\n  }\r\n\r\n  &--disabled {\r\n    color: $datepicker__muted-color;\r\n    pointer-events: none;\r\n\r\n    &:hover {\r\n      cursor: default;\r\n      background-color: transparent;\r\n    }\r\n  }\r\n}\r\n\r\n.react-datepicker__day,\r\n.react-datepicker__month-text,\r\n.react-datepicker__quarter-text,\r\n.react-datepicker__year-text {\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    border-radius: $datepicker__border-radius;\r\n    background-color: $datepicker__background-color;\r\n  }\r\n\r\n  &--today {\r\n    font-weight: bold;\r\n  }\r\n\r\n  &--highlighted {\r\n    border-radius: $datepicker__border-radius;\r\n    background-color: $datepicker__highlighted-color;\r\n    color: #fff;\r\n\r\n    &:hover {\r\n      background-color: darken($datepicker__highlighted-color, 5%);\r\n    }\r\n\r\n    &-custom-1 {\r\n      color: magenta;\r\n    }\r\n\r\n    &-custom-2 {\r\n      color: green;\r\n    }\r\n  }\r\n\r\n  &--selected,\r\n  &--in-selecting-range,\r\n  &--in-range {\r\n    border-radius: $datepicker__border-radius;\r\n    background-color: $datepicker__selected-color;\r\n    color: #fff;\r\n\r\n    &:hover {\r\n      background-color: darken($datepicker__selected-color, 5%);\r\n    }\r\n  }\r\n\r\n  &--keyboard-selected {\r\n    border-radius: $datepicker__border-radius;\r\n    background-color: lighten($datepicker__selected-color, 10%);\r\n    color: #fff;\r\n\r\n    &:hover {\r\n      background-color: darken($datepicker__selected-color, 5%);\r\n    }\r\n  }\r\n\r\n  &--in-selecting-range:not(&--in-range) {\r\n    background-color: rgba($datepicker__selected-color, 0.5);\r\n  }\r\n\r\n  &--in-range:not(&--in-selecting-range) {\r\n    .react-datepicker__month--selecting-range & {\r\n      background-color: $datepicker__background-color;\r\n      color: $datepicker__text-color;\r\n    }\r\n  }\r\n\r\n  &--disabled {\r\n    cursor: default;\r\n    color: $datepicker__muted-color;\r\n\r\n    &:hover {\r\n      background-color: transparent;\r\n    }\r\n  }\r\n}\r\n\r\n.react-datepicker__month-text,\r\n.react-datepicker__quarter-text {\r\n  &.react-datepicker__month--selected,\r\n  &.react-datepicker__month--in-range,\r\n  &.react-datepicker__quarter--selected,\r\n  &.react-datepicker__quarter--in-range {\r\n    &:hover {\r\n      background-color: $datepicker__selected-color;\r\n    }\r\n  }\r\n\r\n  &:hover {\r\n    background-color: $datepicker__background-color;\r\n  }\r\n}\r\n\r\n.react-datepicker__input-container {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 100%;\r\n}\r\n\r\n.react-datepicker__year-read-view,\r\n.react-datepicker__month-read-view,\r\n.react-datepicker__month-year-read-view {\r\n  border: 1px solid transparent;\r\n  border-radius: $datepicker__border-radius;\r\n  position: relative;\r\n\r\n  &:hover {\r\n    cursor: pointer;\r\n\r\n    .react-datepicker__year-read-view--down-arrow,\r\n    .react-datepicker__month-read-view--down-arrow {\r\n      border-top-color: darken($datepicker__muted-color, 10%);\r\n    }\r\n  }\r\n\r\n  &--down-arrow {\r\n    @extend %navigation-chevron;\r\n\r\n    transform: rotate(135deg);\r\n    right: -16px;\r\n    top: 0;\r\n  }\r\n}\r\n\r\n.react-datepicker__year-dropdown,\r\n.react-datepicker__month-dropdown,\r\n.react-datepicker__month-year-dropdown {\r\n  background-color: $datepicker__background-color;\r\n  position: absolute;\r\n  width: 50%;\r\n  left: 25%;\r\n  top: 30px;\r\n  z-index: 1;\r\n  text-align: center;\r\n  border-radius: $datepicker__border-radius;\r\n  border: 1px solid $datepicker__border-color;\r\n\r\n  &:hover {\r\n    cursor: pointer;\r\n  }\r\n\r\n  &--scrollable {\r\n    height: 150px;\r\n    overflow-y: scroll;\r\n  }\r\n}\r\n\r\n.react-datepicker__year-option,\r\n.react-datepicker__month-option,\r\n.react-datepicker__month-year-option {\r\n  line-height: 20px;\r\n  width: 100%;\r\n  display: block;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n\r\n  &:first-of-type {\r\n    border-top-left-radius: $datepicker__border-radius;\r\n    border-top-right-radius: $datepicker__border-radius;\r\n  }\r\n\r\n  &:last-of-type {\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    border-bottom-left-radius: $datepicker__border-radius;\r\n    border-bottom-right-radius: $datepicker__border-radius;\r\n  }\r\n\r\n  &:hover {\r\n    background-color: $datepicker__muted-color;\r\n\r\n    .react-datepicker__navigation--years-upcoming {\r\n      border-bottom-color: darken($datepicker__muted-color, 10%);\r\n    }\r\n\r\n    .react-datepicker__navigation--years-previous {\r\n      border-top-color: darken($datepicker__muted-color, 10%);\r\n    }\r\n  }\r\n\r\n  &--selected {\r\n    position: absolute;\r\n    left: 15px;\r\n  }\r\n}\r\n\r\n.react-datepicker__close-icon {\r\n  cursor: pointer;\r\n  background-color: transparent;\r\n  border: 0;\r\n  outline: 0;\r\n  padding: 0 6px 0 0;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  height: 100%;\r\n  display: table-cell;\r\n  vertical-align: middle;\r\n\r\n  &::after {\r\n    cursor: pointer;\r\n    background-color: $datepicker__selected-color;\r\n    color: #fff;\r\n    border-radius: 50%;\r\n    height: 16px;\r\n    width: 16px;\r\n    padding: 2px;\r\n    font-size: 12px;\r\n    line-height: 1;\r\n    text-align: center;\r\n    display: table-cell;\r\n    vertical-align: middle;\r\n    content: \"\\00d7\";\r\n  }\r\n}\r\n\r\n.react-datepicker__today-button {\r\n  background: $datepicker__background-color;\r\n  border-top: 1px solid $datepicker__border-color;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  font-weight: bold;\r\n  padding: 5px 0;\r\n  clear: left;\r\n}\r\n\r\n.react-datepicker__portal {\r\n  position: fixed;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background-color: rgba(0, 0, 0, 0.8);\r\n  left: 0;\r\n  top: 0;\r\n  justify-content: center;\r\n  align-items: center;\r\n  display: flex;\r\n  z-index: 2147483647;\r\n\r\n  .react-datepicker__day-name,\r\n  .react-datepicker__day,\r\n  .react-datepicker__time-name {\r\n    width: 3rem;\r\n    line-height: 3rem;\r\n  }\r\n\r\n  @media (max-width: 400px), (max-height: 550px) {\r\n    .react-datepicker__day-name,\r\n    .react-datepicker__day,\r\n    .react-datepicker__time-name {\r\n      width: 2rem;\r\n      line-height: 2rem;\r\n    }\r\n  }\r\n\r\n  .react-datepicker__current-month,\r\n  .react-datepicker-time__header {\r\n    font-size: $datepicker__font-size * 1.8;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
